// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgb%2853.35, 67.1, 73.7%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.75%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23FFFFFF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23FFFFFF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28127.5, 127.5, 127.5%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23FFFFFF%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23249d79%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e00000%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e00000%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%280, 0, 0, 0.75%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.75%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23FFFFFF%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23FFFFFF%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./images/pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./images/cover.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./images/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./images/pattern-dark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./images/cover-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./images/logo-dark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./images/cover-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./images/cover-2-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./images/cover-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./images/cover-3-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./images/cover-4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./images/cover-4-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./images/cover-5.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./images/cover-5-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./images/cover-6.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("./images/cover-6-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("./images/cover-7.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("./images/cover-7-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("./images/cover-8.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("./images/cover-8-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("./images/cover-9.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("./images/cover-9-dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23000000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23000000%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23000000%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * HUD REACT v3.1.0 (https://seantheme.com/hud-react/)
 * Copyright 2024 SeanTheme
 */
/*
   01. Color system 
   02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)
   03. Variable prefix setting
   04. Body setting
   05. Spacer setting
   06. Font & headings settings
   07. Grid settings
   08. Container padding
   09. Component border settings
   10. Component border-radius settings
   11. Component box-shadow settings 
   12. Component color settings 
   13. Component caret settings 
   14. Component transition settings 
   15. Component ratio settings 
   16. Container padding settings
   17. App - Header settings
   18. App - Sidebar settings
   19. App - Content settings
   20. App - Pos system settings
   21. Link settings
   22. Alerts settings
   23. Breadcrumbs settings
   24. Progress bars settings
   25. Buttons + Forms settings
   26. Buttons settings
   27. Button close settings
   28. Forms settings
   29. Form placeholders settings
   30. Form check settings
   31. Form switch settings
   32. Form input group settings
   33. Form select settings
   34. Form range settings
   35. Form file settings
   36. Form Floating settings
   37. Form validation settings
   38. Cards settings
   39. Tooltips settings
   40. Popovers
   41. Modals settings
   42. Offcanvas
   43. Toasts settings
   44. Accordion settings
   45. Tables settings
   46. Dropdown settings
   47. List group settings
   48. Nav settings
   49. Navbar settings
   50. Pagination settings
   51. Z-index settings
   52. Badges settings
   53. Position settings
   54. Image thumbnails settings
   55. Figures settings
   56. Carousel settings
   57. Spinners settings
   58. Code settings
*/
/*
   Dark color mode variables

   01. Color system 
   02. Body setting
   03. Font & headings settings
   04. Border settings
   05. Component settings
   06. App - Header settings
   07. App - Sidebar settings
   08. App - Theme panel settings
   09. Form switch settings
   10. Form select settings
   11. Form check settings
   12. Accordion settings
   13. Modal settings
*/
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0271ff;
  --bs-indigo: #5c25ff;
  --bs-purple: #b90dff;
  --bs-pink: #e61079;
  --bs-red: #e00000;
  --bs-orange: #ff9f0c;
  --bs-yellow: #f9e80d;
  --bs-green: #148922;
  --bs-teal: #249d79;
  --bs-cyan: #009be3;
  --bs-black: #000000;
  --bs-white: #FFFFFF;
  --bs-gray: rgb(82.45, 103.7, 113.9);
  --bs-gray-dark: rgb(53.35, 67.1, 73.7);
  --bs-gray-100: rgb(191.8, 201.8, 206.6);
  --bs-gray-200: rgb(168.1, 181.85, 188.45);
  --bs-gray-300: rgb(144.4, 161.9, 170.3);
  --bs-gray-400: rgb(120.7, 141.95, 152.15);
  --bs-gray-500: #617a86;
  --bs-gray-600: rgb(82.45, 103.7, 113.9);
  --bs-gray-700: rgb(67.9, 85.4, 93.8);
  --bs-gray-800: rgb(53.35, 67.1, 73.7);
  --bs-gray-900: rgb(38.8, 48.8, 53.6);
  --bs-default: rgb(120.7, 141.95, 152.15);
  --bs-theme: #249d79;
  --bs-theme-color: #FFFFFF;
  --bs-primary: #0271ff;
  --bs-secondary: rgb(120.7, 141.95, 152.15);
  --bs-warning: #ff9f0c;
  --bs-danger: #e00000;
  --bs-success: #249d79;
  --bs-inverse: #000000;
  --bs-info: #009be3;
  --bs-dark: rgb(53.35, 67.1, 73.7);
  --bs-black: #000000;
  --bs-white: #FFFFFF;
  --bs-purple: #b90dff;
  --bs-indigo: #5c25ff;
  --bs-red: #e00000;
  --bs-pink: #e61079;
  --bs-green: #148922;
  --bs-yellow: #f9e80d;
  --bs-teal: #249d79;
  --bs-muted: #617a86;
  --bs-light: rgb(191.8, 201.8, 206.6);
  --bs-lime: #50b00a;
  --bs-gray-500: #617a86;
  --bs-default-rgb: 121, 142, 152;
  --bs-theme-rgb: 36, 157, 121;
  --bs-theme-color-rgb: 255, 255, 255;
  --bs-primary-rgb: 2, 113, 255;
  --bs-secondary-rgb: 121, 142, 152;
  --bs-warning-rgb: 255, 159, 12;
  --bs-danger-rgb: 224, 0, 0;
  --bs-success-rgb: 36, 157, 121;
  --bs-inverse-rgb: 0, 0, 0;
  --bs-info-rgb: 0, 155, 227;
  --bs-dark-rgb: 53, 67, 74;
  --bs-black-rgb: 0, 0, 0;
  --bs-white-rgb: 255, 255, 255;
  --bs-purple-rgb: 185, 13, 255;
  --bs-indigo-rgb: 92, 37, 255;
  --bs-red-rgb: 224, 0, 0;
  --bs-pink-rgb: 230, 16, 121;
  --bs-green-rgb: 20, 137, 34;
  --bs-yellow-rgb: 249, 232, 13;
  --bs-teal-rgb: 36, 157, 121;
  --bs-muted-rgb: 97, 122, 134;
  --bs-light-rgb: 192, 202, 207;
  --bs-lime-rgb: 80, 176, 10;
  --bs-gray-100-rgb: 192, 202, 207;
  --bs-gray-200-rgb: 168, 182, 188;
  --bs-gray-300-rgb: 144, 162, 170;
  --bs-gray-400-rgb: 121, 142, 152;
  --bs-gray-500-rgb: 97, 122, 134;
  --bs-gray-600-rgb: 82, 104, 114;
  --bs-gray-700-rgb: 68, 85, 94;
  --bs-gray-800-rgb: 53, 67, 74;
  --bs-gray-900-rgb: 39, 49, 54;
  --bs-primary-text-emphasis: rgb(0.8, 45.2, 102);
  --bs-secondary-text-emphasis: rgb(48.28, 56.78, 60.86);
  --bs-success-text-emphasis: rgb(14.4, 62.8, 48.4);
  --bs-info-text-emphasis: rgb(0, 62, 90.8);
  --bs-warning-text-emphasis: rgb(102, 63.6, 4.8);
  --bs-danger-text-emphasis: rgb(89.6, 0, 0);
  --bs-light-text-emphasis: rgb(67.9, 85.4, 93.8);
  --bs-dark-text-emphasis: rgb(67.9, 85.4, 93.8);
  --bs-primary-bg-subtle: rgb(204.4, 226.6, 255);
  --bs-secondary-bg-subtle: rgb(191.8, 201.8, 206.6);
  --bs-success-bg-subtle: rgb(208, 231.4, 210.8);
  --bs-info-bg-subtle: rgb(204, 235, 249.4);
  --bs-warning-bg-subtle: rgb(253.8, 250.4, 206.6);
  --bs-danger-bg-subtle: rgb(248.8, 204, 204);
  --bs-light-bg-subtle: rgb(223.4, 228.4, 230.8);
  --bs-dark-bg-subtle: rgb(120.7, 141.95, 152.15);
  --bs-primary-border-subtle: rgb(153.8, 198.2, 255);
  --bs-secondary-border-subtle: rgb(168.1, 181.85, 188.45);
  --bs-success-border-subtle: rgb(161, 207.8, 166.6);
  --bs-info-border-subtle: rgb(153, 215, 243.8);
  --bs-warning-border-subtle: rgb(252.6, 245.8, 158.2);
  --bs-danger-border-subtle: rgb(242.6, 153, 153);
  --bs-light-border-subtle: rgb(168.1, 181.85, 188.45);
  --bs-dark-border-subtle: #617a86;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Chakra Petch", sans-serif;
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: rgba(0, 0, 0, 0.75);
  --bs-body-color-rgb: 0, 0, 0;
  --bs-body-bg: #FFFFFF;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(0, 0, 0, 0.75);
  --bs-secondary-color-rgb: 0, 0, 0;
  --bs-secondary-bg: rgb(191.8, 201.8, 206.6);
  --bs-secondary-bg-rgb: 192, 202, 207;
  --bs-tertiary-color: rgba(0, 0, 0, 0.5);
  --bs-tertiary-color-rgb: 0, 0, 0;
  --bs-tertiary-bg: rgba(0, 0, 0, 0.1);
  --bs-tertiary-bg-rgb: 0, 0, 0;
  --bs-heading-color: #000000;
  --bs-link-color: #249d79;
  --bs-link-color-rgb: 36, 157, 121;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgba(36, 157, 121, 0.5);
  --bs-link-hover-color-rgb: 36, 157, 121;
  --bs-code-color: #e61079;
  --bs-highlight-color: rgba(0, 0, 0, 0.75);
  --bs-highlight-bg: rgb(253.8, 250.4, 206.6);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: rgba(0, 0, 0, 0.2);
  --bs-border-color-translucent: rgba(0, 0, 0, 0.1);
  --bs-border-radius: 4px;
  --bs-border-radius-sm: 2px;
  --bs-border-radius-lg: 8px;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(var(--bs-inverse-rgb), 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(2, 113, 255, 0.25);
  --bs-form-valid-color: #249d79;
  --bs-form-valid-border-color: #249d79;
  --bs-form-invalid-color: #e00000;
  --bs-form-invalid-border-color: #e00000;
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-100: rgb(191.8, 201.8, 206.6);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-200: rgb(168.1, 181.85, 188.45);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-300: rgb(144.4, 161.9, 170.3);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-400: rgb(120.7, 141.95, 152.15);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-600: rgb(82.45, 103.7, 113.9);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-700: rgb(67.9, 85.4, 93.8);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-800: rgb(53.35, 67.1, 73.7);
}
}
@supports (color: rgb(0 0 0 / 0)){
:root,
[data-bs-theme=light] {
  --bs-gray-900: rgb(38.8, 48.8, 53.6);
}
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: rgba(255, 255, 255, 0.75);
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg: #1d2835;
  --bs-body-bg-rgb: 29, 40, 53;
  --bs-emphasis-color: rgb(191.8, 201.8, 206.6);
  --bs-emphasis-color-rgb: 192, 202, 207;
  --bs-secondary-color: rgba(255, 255, 255, 0.75);
  --bs-secondary-color-rgb: 255, 255, 255;
  --bs-secondary-bg: rgb(53.35, 67.1, 73.7);
  --bs-secondary-bg-rgb: 53, 67, 74;
  --bs-tertiary-color: rgba(255, 255, 255, 0.5);
  --bs-tertiary-color-rgb: 255, 255, 255;
  --bs-tertiary-bg: rgba(0, 0, 0, 0.1);
  --bs-tertiary-bg-rgb: 0, 0, 0;
  --bs-primary-text-emphasis: rgb(103.2, 169.8, 255);
  --bs-secondary-text-emphasis: rgb(174.42, 187.17, 193.29);
  --bs-success-text-emphasis: rgb(123.6, 196.2, 174.6);
  --bs-info-text-emphasis: rgb(102, 195, 238.2);
  --bs-warning-text-emphasis: rgb(255, 197.4, 109.2);
  --bs-danger-text-emphasis: rgb(236.4, 102, 102);
  --bs-light-text-emphasis: rgb(191.8, 201.8, 206.6);
  --bs-dark-text-emphasis: rgb(144.4, 161.9, 170.3);
  --bs-primary-bg-subtle: rgb(0.4, 22.6, 51);
  --bs-secondary-bg-subtle: rgb(38.8, 48.8, 53.6);
  --bs-success-bg-subtle: rgb(4, 27.4, 6.8);
  --bs-info-bg-subtle: rgb(0, 31, 45.4);
  --bs-warning-bg-subtle: rgb(49.8, 46.4, 2.6);
  --bs-danger-bg-subtle: rgb(44.8, 0, 0);
  --bs-light-bg-subtle: rgb(53.35, 67.1, 73.7);
  --bs-dark-bg-subtle: rgb(26.675, 33.55, 36.85);
  --bs-primary-border-subtle: rgb(1.2, 67.8, 153);
  --bs-secondary-border-subtle: rgb(67.9, 85.4, 93.8);
  --bs-success-border-subtle: rgb(12, 82.2, 20.4);
  --bs-info-border-subtle: rgb(0, 62, 90.8);
  --bs-warning-border-subtle: rgb(99.6, 92.8, 5.2);
  --bs-danger-border-subtle: rgb(134.4, 0, 0);
  --bs-light-border-subtle: rgb(67.9, 85.4, 93.8);
  --bs-dark-border-subtle: rgb(53.35, 67.1, 73.7);
  --bs-heading-color: #fff;
  --bs-link-color: rgb(103.2, 169.8, 255);
  --bs-link-hover-color: rgb(153.8, 198.2, 255);
  --bs-link-color-rgb: 103, 170, 255;
  --bs-link-hover-color-rgb: 154, 198, 255;
  --bs-code-color: rgb(240, 111.6, 174.6);
  --bs-highlight-color: rgba(255, 255, 255, 0.75);
  --bs-highlight-bg: rgb(99.6, 92.8, 5.2);
  --bs-border-color: rgba(255, 255, 255, 0.25);
  --bs-border-color-translucent: rgba(255, 255, 255, 0.25);
  --bs-form-valid-color: rgb(114, 184.2, 122.4);
  --bs-form-valid-border-color: rgb(114, 184.2, 122.4);
  --bs-form-invalid-color: rgb(236.4, 102, 102);
  --bs-form-invalid-border-color: rgb(236.4, 102, 102);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.34375rem + 1.125vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.1875rem;
  }
}

h2, .h2 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.75rem;
  }
}

h3, .h3 {
  font-size: calc(1.278125rem + 0.3375vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.53125rem;
  }
}

h4, .h4 {
  font-size: calc(1.25625rem + 0.075vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.3125rem;
  }
}

h5, .h5 {
  font-size: 1.09375rem;
}

h6, .h6 {
  font-size: 0.875rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 2px;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: rgb(120.7, 141.95, 152.15);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.09375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: rgb(82.45, 103.7, 113.9);
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 20px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1660px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1660px;
  --bs-breakpoint-xxxl: 1900px;
}

.row {
  --bs-gutter-x: 20px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1660px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1900px) {
  .col-xxxl {
    flex: 1 0;
  }
  .row-cols-xxxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxxl-0 {
    margin-left: 0;
  }
  .offset-xxxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxxl-3 {
    margin-left: 25%;
  }
  .offset-xxxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxxl-6 {
    margin-left: 50%;
  }
  .offset-xxxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxxl-9 {
    margin-left: 75%;
  }
  .offset-xxxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxxl-0,
  .gx-xxxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxxl-0,
  .gy-xxxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxxl-1,
  .gx-xxxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxxl-1,
  .gy-xxxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxxl-2,
  .gx-xxxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxxl-2,
  .gy-xxxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxxl-3,
  .gx-xxxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxxl-3,
  .gy-xxxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxxl-4,
  .gx-xxxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxxl-4,
  .gy-xxxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxxl-5,
  .gx-xxxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxxl-5,
  .gy-xxxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(var(--bs-inverse-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(204.4, 226.6, 255);
  --bs-table-border-color: rgb(183.96, 203.94, 229.5);
  --bs-table-striped-bg: rgb(183.96, 203.94, 229.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(183.96, 203.94, 229.5);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(189.07, 209.605, 235.875);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(228.14, 232.39, 234.43);
  --bs-table-border-color: rgb(205.326, 209.151, 210.987);
  --bs-table-striped-bg: rgb(205.326, 209.151, 210.987);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(205.326, 209.151, 210.987);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(211.0295, 214.96075, 216.84775);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(211.2, 235.4, 228.2);
  --bs-table-border-color: rgb(190.08, 211.86, 205.38);
  --bs-table-striped-bg: rgb(190.08, 211.86, 205.38);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(190.08, 211.86, 205.38);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(195.36, 217.745, 211.085);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(204, 235, 249.4);
  --bs-table-border-color: rgb(183.6, 211.5, 224.46);
  --bs-table-striped-bg: rgb(183.6, 211.5, 224.46);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(183.6, 211.5, 224.46);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(188.7, 217.375, 230.695);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(255, 235.8, 206.4);
  --bs-table-border-color: rgb(229.5, 212.22, 185.76);
  --bs-table-striped-bg: rgb(229.5, 212.22, 185.76);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(229.5, 212.22, 185.76);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(235.875, 218.115, 190.92);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(248.8, 204, 204);
  --bs-table-border-color: rgb(223.92, 183.6, 183.6);
  --bs-table-striped-bg: rgb(223.92, 183.6, 183.6);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(223.92, 183.6, 183.6);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(230.14, 188.7, 188.7);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-bg: rgb(191.8, 201.8, 206.6);
  --bs-table-border-color: rgb(172.62, 181.62, 185.94);
  --bs-table-striped-bg: rgb(172.62, 181.62, 185.94);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgb(172.62, 181.62, 185.94);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgb(177.415, 186.665, 191.105);
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #FFFFFF;
  --bs-table-bg: rgb(53.35, 67.1, 73.7);
  --bs-table-border-color: rgb(73.515, 85.89, 91.83);
  --bs-table-striped-bg: rgb(73.515, 85.89, 91.83);
  --bs-table-striped-color: #FFFFFF;
  --bs-table-active-bg: rgb(73.515, 85.89, 91.83);
  --bs-table-active-color: #FFFFFF;
  --bs-table-hover-bg: rgb(68.47375, 81.1925, 87.2975);
  --bs-table-hover-color: #FFFFFF;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1659.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1899.98px) {
  .table-responsive-xxxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.8125rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: rgb(120.7, 141.95, 152.15);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: transparent;
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: transparent;
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: rgba(var(--bs-body-color-rgb), 0.5);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-form-control-disabled-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-border-color);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
  border-radius: 2px;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 8px;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 4px;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 4px;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: transparent;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-form-control-disabled-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.8125rem;
  border-radius: 2px;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1rem;
  border-radius: 8px;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.3em;
  padding-left: 1.8em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.8em;
}

.form-check-reverse {
  padding-right: 1.8em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.8em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: transparent;
  flex-shrink: 0;
  width: 1.3em;
  height: 1.3em;
  margin-top: 0.1em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-check-input:checked {
  background-color: #249d79;
  border-color: #249d79;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #249d79;
  border-color: #249d79;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.8em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2.3em;
  margin-left: -2.8em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2.3em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.8em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.8em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px transparent, 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px transparent, 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--bs-theme);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgba(var(--bs-theme-rgb), 0.75);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--bs-theme);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgba(var(--bs-theme-rgb), 0.75);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.875em;
  content: "";
  background-color: transparent;
  border-radius: 4px;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: rgb(82.45, 103.7, 113.9);
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-form-control-disabled-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 4px;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 8px;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
  border-radius: 2px;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-success-text);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-success);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-success);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-success);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-success-text);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-success-text);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-danger-text);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-danger);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-danger);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-danger);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-danger-text);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-danger-text);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 4px;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-default {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(102.595, 120.6575, 129.3275);
  --bs-btn-hover-border-color: rgb(96.56, 113.56, 121.72);
  --bs-btn-focus-shadow-rgb: 141, 159, 168;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(96.56, 113.56, 121.72);
  --bs-btn-active-border-color: rgb(90.525, 106.4625, 114.1125);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
}

.btn-theme {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(30.6, 133.45, 102.85);
  --bs-btn-hover-border-color: rgb(28.8, 125.6, 96.8);
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(28.8, 125.6, 96.8);
  --bs-btn-active-border-color: rgb(27, 117.75, 90.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #249d79;
  --bs-btn-disabled-border-color: #249d79;
}

.btn-theme-color {
  --bs-btn-color: #000000;
  --bs-btn-bg: #FFFFFF;
  --bs-btn-border-color: #FFFFFF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #FFFFFF;
  --bs-btn-disabled-border-color: #FFFFFF;
}

.btn-primary {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #0271ff;
  --bs-btn-border-color: #0271ff;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(1.7, 96.05, 216.75);
  --bs-btn-hover-border-color: rgb(1.6, 90.4, 204);
  --bs-btn-focus-shadow-rgb: 40, 134, 255;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(1.6, 90.4, 204);
  --bs-btn-active-border-color: rgb(1.5, 84.75, 191.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #0271ff;
  --bs-btn-disabled-border-color: #0271ff;
}

.btn-secondary {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(102.595, 120.6575, 129.3275);
  --bs-btn-hover-border-color: rgb(96.56, 113.56, 121.72);
  --bs-btn-focus-shadow-rgb: 141, 159, 168;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(96.56, 113.56, 121.72);
  --bs-btn-active-border-color: rgb(90.525, 106.4625, 114.1125);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
}

.btn-warning {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ff9f0c;
  --bs-btn-border-color: #ff9f0c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(255, 173.4, 48.45);
  --bs-btn-hover-border-color: rgb(255, 168.6, 36.3);
  --bs-btn-focus-shadow-rgb: 217, 135, 10;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(255, 178.2, 60.6);
  --bs-btn-active-border-color: rgb(255, 168.6, 36.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ff9f0c;
  --bs-btn-disabled-border-color: #ff9f0c;
}

.btn-danger {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(190.4, 0, 0);
  --bs-btn-hover-border-color: rgb(179.2, 0, 0);
  --bs-btn-focus-shadow-rgb: 229, 38, 38;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(179.2, 0, 0);
  --bs-btn-active-border-color: #a80000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #e00000;
  --bs-btn-disabled-border-color: #e00000;
}

.btn-success {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(30.6, 133.45, 102.85);
  --bs-btn-hover-border-color: rgb(28.8, 125.6, 96.8);
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(28.8, 125.6, 96.8);
  --bs-btn-active-border-color: rgb(27, 117.75, 90.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #249d79;
  --bs-btn-disabled-border-color: #249d79;
}

.btn-inverse {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: black;
  --bs-btn-hover-border-color: black;
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: black;
  --bs-btn-active-border-color: black;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #000000;
  --bs-btn-disabled-border-color: #000000;
}

.btn-info {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #009be3;
  --bs-btn-border-color: #009be3;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(0, 131.75, 192.95);
  --bs-btn-hover-border-color: rgb(0, 124, 181.6);
  --bs-btn-focus-shadow-rgb: 38, 170, 231;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(0, 124, 181.6);
  --bs-btn-active-border-color: rgb(0, 116.25, 170.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #009be3;
  --bs-btn-disabled-border-color: #009be3;
}

.btn-dark {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(83.5975, 95.285, 100.895);
  --bs-btn-hover-border-color: rgb(73.515, 85.89, 91.83);
  --bs-btn-focus-shadow-rgb: 84, 95, 101;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(93.68, 104.68, 109.96);
  --bs-btn-active-border-color: rgb(73.515, 85.89, 91.83);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-disabled-border-color: rgb(53.35, 67.1, 73.7);
}

.btn-black {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: black;
  --bs-btn-hover-border-color: black;
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: black;
  --bs-btn-active-border-color: black;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #000000;
  --bs-btn-disabled-border-color: #000000;
}

.btn-white {
  --bs-btn-color: #000000;
  --bs-btn-bg: #FFFFFF;
  --bs-btn-border-color: #FFFFFF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #FFFFFF;
  --bs-btn-disabled-border-color: #FFFFFF;
}

.btn-purple {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #b90dff;
  --bs-btn-border-color: #b90dff;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(157.25, 11.05, 216.75);
  --bs-btn-hover-border-color: rgb(148, 10.4, 204);
  --bs-btn-focus-shadow-rgb: 196, 49, 255;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(148, 10.4, 204);
  --bs-btn-active-border-color: rgb(138.75, 9.75, 191.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #b90dff;
  --bs-btn-disabled-border-color: #b90dff;
}

.btn-indigo {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #5c25ff;
  --bs-btn-border-color: #5c25ff;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(78.2, 31.45, 216.75);
  --bs-btn-hover-border-color: rgb(73.6, 29.6, 204);
  --bs-btn-focus-shadow-rgb: 116, 70, 255;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(73.6, 29.6, 204);
  --bs-btn-active-border-color: rgb(69, 27.75, 191.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #5c25ff;
  --bs-btn-disabled-border-color: #5c25ff;
}

.btn-red {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(190.4, 0, 0);
  --bs-btn-hover-border-color: rgb(179.2, 0, 0);
  --bs-btn-focus-shadow-rgb: 229, 38, 38;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(179.2, 0, 0);
  --bs-btn-active-border-color: #a80000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #e00000;
  --bs-btn-disabled-border-color: #e00000;
}

.btn-pink {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #e61079;
  --bs-btn-border-color: #e61079;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(195.5, 13.6, 102.85);
  --bs-btn-hover-border-color: rgb(184, 12.8, 96.8);
  --bs-btn-focus-shadow-rgb: 234, 52, 141;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(184, 12.8, 96.8);
  --bs-btn-active-border-color: rgb(172.5, 12, 90.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #e61079;
  --bs-btn-disabled-border-color: #e61079;
}

.btn-green {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #148922;
  --bs-btn-border-color: #148922;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(17, 116.45, 28.9);
  --bs-btn-hover-border-color: rgb(16, 109.6, 27.2);
  --bs-btn-focus-shadow-rgb: 55, 155, 67;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(16, 109.6, 27.2);
  --bs-btn-active-border-color: rgb(15, 102.75, 25.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #148922;
  --bs-btn-disabled-border-color: #148922;
}

.btn-yellow {
  --bs-btn-color: #000000;
  --bs-btn-bg: #f9e80d;
  --bs-btn-border-color: #f9e80d;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(249.9, 235.45, 49.3);
  --bs-btn-hover-border-color: rgb(249.6, 234.3, 37.2);
  --bs-btn-focus-shadow-rgb: 212, 197, 11;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(250.2, 236.6, 61.4);
  --bs-btn-active-border-color: rgb(249.6, 234.3, 37.2);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #f9e80d;
  --bs-btn-disabled-border-color: #f9e80d;
}

.btn-teal {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(30.6, 133.45, 102.85);
  --bs-btn-hover-border-color: rgb(28.8, 125.6, 96.8);
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(28.8, 125.6, 96.8);
  --bs-btn-active-border-color: rgb(27, 117.75, 90.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #249d79;
  --bs-btn-disabled-border-color: #249d79;
}

.btn-muted {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(82.45, 103.7, 113.9);
  --bs-btn-hover-border-color: rgb(77.6, 97.6, 107.2);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(77.6, 97.6, 107.2);
  --bs-btn-active-border-color: rgb(72.75, 91.5, 100.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #617a86;
  --bs-btn-disabled-border-color: #617a86;
}

.btn-light {
  --bs-btn-color: #000000;
  --bs-btn-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(163.03, 171.53, 175.61);
  --bs-btn-hover-border-color: rgb(153.44, 161.44, 165.28);
  --bs-btn-focus-shadow-rgb: 163, 172, 176;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(153.44, 161.44, 165.28);
  --bs-btn-active-border-color: rgb(143.85, 151.35, 154.95);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-disabled-border-color: rgb(191.8, 201.8, 206.6);
}

.btn-lime {
  --bs-btn-color: #000000;
  --bs-btn-bg: #50b00a;
  --bs-btn-border-color: #50b00a;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(106.25, 187.85, 46.75);
  --bs-btn-hover-border-color: rgb(97.5, 183.9, 34.5);
  --bs-btn-focus-shadow-rgb: 68, 150, 9;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(115, 191.8, 59);
  --bs-btn-active-border-color: rgb(97.5, 183.9, 34.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #50b00a;
  --bs-btn-disabled-border-color: #50b00a;
}

.btn-gray-100 {
  --bs-btn-color: #000000;
  --bs-btn-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(201.28, 209.78, 213.86);
  --bs-btn-hover-border-color: rgb(198.12, 207.12, 211.44);
  --bs-btn-focus-shadow-rgb: 163, 172, 176;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(204.44, 212.44, 216.28);
  --bs-btn-active-border-color: rgb(198.12, 207.12, 211.44);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-disabled-border-color: rgb(191.8, 201.8, 206.6);
}

.btn-gray-200 {
  --bs-btn-color: #000000;
  --bs-btn-bg: rgb(168.1, 181.85, 188.45);
  --bs-btn-border-color: rgb(168.1, 181.85, 188.45);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(181.135, 192.8225, 198.4325);
  --bs-btn-hover-border-color: rgb(176.79, 189.165, 195.105);
  --bs-btn-focus-shadow-rgb: 143, 155, 160;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(185.48, 196.48, 201.76);
  --bs-btn-active-border-color: rgb(176.79, 189.165, 195.105);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: rgb(168.1, 181.85, 188.45);
  --bs-btn-disabled-border-color: rgb(168.1, 181.85, 188.45);
}

.btn-gray-300 {
  --bs-btn-color: #000000;
  --bs-btn-bg: rgb(144.4, 161.9, 170.3);
  --bs-btn-border-color: rgb(144.4, 161.9, 170.3);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(160.99, 175.865, 183.005);
  --bs-btn-hover-border-color: rgb(155.46, 171.21, 178.77);
  --bs-btn-focus-shadow-rgb: 123, 138, 145;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(166.52, 180.52, 187.24);
  --bs-btn-active-border-color: rgb(155.46, 171.21, 178.77);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: rgb(144.4, 161.9, 170.3);
  --bs-btn-disabled-border-color: rgb(144.4, 161.9, 170.3);
}

.btn-gray-400 {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(102.595, 120.6575, 129.3275);
  --bs-btn-hover-border-color: rgb(96.56, 113.56, 121.72);
  --bs-btn-focus-shadow-rgb: 141, 159, 168;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(96.56, 113.56, 121.72);
  --bs-btn-active-border-color: rgb(90.525, 106.4625, 114.1125);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
}

.btn-gray-500 {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(82.45, 103.7, 113.9);
  --bs-btn-hover-border-color: rgb(77.6, 97.6, 107.2);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(77.6, 97.6, 107.2);
  --bs-btn-active-border-color: rgb(72.75, 91.5, 100.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: #617a86;
  --bs-btn-disabled-border-color: #617a86;
}

.btn-gray-600 {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(82.45, 103.7, 113.9);
  --bs-btn-border-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(70.0825, 88.145, 96.815);
  --bs-btn-hover-border-color: rgb(65.96, 82.96, 91.12);
  --bs-btn-focus-shadow-rgb: 108, 126, 135;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(65.96, 82.96, 91.12);
  --bs-btn-active-border-color: rgb(61.8375, 77.775, 85.425);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(82.45, 103.7, 113.9);
  --bs-btn-disabled-border-color: rgb(82.45, 103.7, 113.9);
}

.btn-gray-700 {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(67.9, 85.4, 93.8);
  --bs-btn-border-color: rgb(67.9, 85.4, 93.8);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(57.715, 72.59, 79.73);
  --bs-btn-hover-border-color: rgb(54.32, 68.32, 75.04);
  --bs-btn-focus-shadow-rgb: 96, 111, 118;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(54.32, 68.32, 75.04);
  --bs-btn-active-border-color: rgb(50.925, 64.05, 70.35);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(67.9, 85.4, 93.8);
  --bs-btn-disabled-border-color: rgb(67.9, 85.4, 93.8);
}

.btn-gray-800 {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(45.3475, 57.035, 62.645);
  --bs-btn-hover-border-color: rgb(42.68, 53.68, 58.96);
  --bs-btn-focus-shadow-rgb: 84, 95, 101;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(42.68, 53.68, 58.96);
  --bs-btn-active-border-color: rgb(40.0125, 50.325, 55.275);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-disabled-border-color: rgb(53.35, 67.1, 73.7);
}

.btn-gray-900 {
  --bs-btn-color: #FFFFFF;
  --bs-btn-bg: rgb(38.8, 48.8, 53.6);
  --bs-btn-border-color: rgb(38.8, 48.8, 53.6);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(32.98, 41.48, 45.56);
  --bs-btn-hover-border-color: rgb(31.04, 39.04, 42.88);
  --bs-btn-focus-shadow-rgb: 71, 80, 84;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(31.04, 39.04, 42.88);
  --bs-btn-active-border-color: rgb(29.1, 36.6, 40.2);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: rgb(38.8, 48.8, 53.6);
  --bs-btn-disabled-border-color: rgb(38.8, 48.8, 53.6);
}

.btn-outline-default {
  --bs-btn-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
  --bs-gradient: none;
}

.btn-outline-theme {
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}

.btn-outline-theme-color {
  --bs-btn-color: #FFFFFF;
  --bs-btn-border-color: #FFFFFF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #FFFFFF;
  --bs-btn-hover-border-color: #FFFFFF;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #FFFFFF;
  --bs-btn-active-border-color: #FFFFFF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFFFFF;
  --bs-gradient: none;
}

.btn-outline-primary {
  --bs-btn-color: #0271ff;
  --bs-btn-border-color: #0271ff;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #0271ff;
  --bs-btn-hover-border-color: #0271ff;
  --bs-btn-focus-shadow-rgb: 2, 113, 255;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #0271ff;
  --bs-btn-active-border-color: #0271ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0271ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0271ff;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ff9f0c;
  --bs-btn-border-color: #ff9f0c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ff9f0c;
  --bs-btn-hover-border-color: #ff9f0c;
  --bs-btn-focus-shadow-rgb: 255, 159, 12;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ff9f0c;
  --bs-btn-active-border-color: #ff9f0c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff9f0c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff9f0c;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #e00000;
  --bs-btn-hover-border-color: #e00000;
  --bs-btn-focus-shadow-rgb: 224, 0, 0;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #e00000;
  --bs-btn-active-border-color: #e00000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e00000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e00000;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}

.btn-outline-inverse {
  --bs-btn-color: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #000000;
  --bs-btn-hover-border-color: #000000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #000000;
  --bs-btn-active-border-color: #000000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000000;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #009be3;
  --bs-btn-border-color: #009be3;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #009be3;
  --bs-btn-hover-border-color: #009be3;
  --bs-btn-focus-shadow-rgb: 0, 155, 227;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #009be3;
  --bs-btn-active-border-color: #009be3;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #009be3;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #009be3;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-hover-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-focus-shadow-rgb: 53, 67, 74;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-active-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(53.35, 67.1, 73.7);
  --bs-gradient: none;
}

.btn-outline-black {
  --bs-btn-color: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #000000;
  --bs-btn-hover-border-color: #000000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #000000;
  --bs-btn-active-border-color: #000000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000000;
  --bs-gradient: none;
}

.btn-outline-white {
  --bs-btn-color: #FFFFFF;
  --bs-btn-border-color: #FFFFFF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #FFFFFF;
  --bs-btn-hover-border-color: #FFFFFF;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #FFFFFF;
  --bs-btn-active-border-color: #FFFFFF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFFFFF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFFFFF;
  --bs-gradient: none;
}

.btn-outline-purple {
  --bs-btn-color: #b90dff;
  --bs-btn-border-color: #b90dff;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #b90dff;
  --bs-btn-hover-border-color: #b90dff;
  --bs-btn-focus-shadow-rgb: 185, 13, 255;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #b90dff;
  --bs-btn-active-border-color: #b90dff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #b90dff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #b90dff;
  --bs-gradient: none;
}

.btn-outline-indigo {
  --bs-btn-color: #5c25ff;
  --bs-btn-border-color: #5c25ff;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #5c25ff;
  --bs-btn-hover-border-color: #5c25ff;
  --bs-btn-focus-shadow-rgb: 92, 37, 255;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #5c25ff;
  --bs-btn-active-border-color: #5c25ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #5c25ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #5c25ff;
  --bs-gradient: none;
}

.btn-outline-red {
  --bs-btn-color: #e00000;
  --bs-btn-border-color: #e00000;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #e00000;
  --bs-btn-hover-border-color: #e00000;
  --bs-btn-focus-shadow-rgb: 224, 0, 0;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #e00000;
  --bs-btn-active-border-color: #e00000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e00000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e00000;
  --bs-gradient: none;
}

.btn-outline-pink {
  --bs-btn-color: #e61079;
  --bs-btn-border-color: #e61079;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #e61079;
  --bs-btn-hover-border-color: #e61079;
  --bs-btn-focus-shadow-rgb: 230, 16, 121;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #e61079;
  --bs-btn-active-border-color: #e61079;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e61079;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e61079;
  --bs-gradient: none;
}

.btn-outline-green {
  --bs-btn-color: #148922;
  --bs-btn-border-color: #148922;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #148922;
  --bs-btn-hover-border-color: #148922;
  --bs-btn-focus-shadow-rgb: 20, 137, 34;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #148922;
  --bs-btn-active-border-color: #148922;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #148922;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #148922;
  --bs-gradient: none;
}

.btn-outline-yellow {
  --bs-btn-color: #f9e80d;
  --bs-btn-border-color: #f9e80d;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f9e80d;
  --bs-btn-hover-border-color: #f9e80d;
  --bs-btn-focus-shadow-rgb: 249, 232, 13;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f9e80d;
  --bs-btn-active-border-color: #f9e80d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f9e80d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f9e80d;
  --bs-gradient: none;
}

.btn-outline-teal {
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}

.btn-outline-muted {
  --bs-btn-color: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #617a86;
  --bs-btn-hover-border-color: #617a86;
  --bs-btn-focus-shadow-rgb: 97, 122, 134;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #617a86;
  --bs-btn-active-border-color: #617a86;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #617a86;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #617a86;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-hover-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-focus-shadow-rgb: 192, 202, 207;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-active-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(191.8, 201.8, 206.6);
  --bs-gradient: none;
}

.btn-outline-lime {
  --bs-btn-color: #50b00a;
  --bs-btn-border-color: #50b00a;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #50b00a;
  --bs-btn-hover-border-color: #50b00a;
  --bs-btn-focus-shadow-rgb: 80, 176, 10;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #50b00a;
  --bs-btn-active-border-color: #50b00a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50b00a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50b00a;
  --bs-gradient: none;
}

.btn-outline-gray-100 {
  --bs-btn-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-hover-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-focus-shadow-rgb: 192, 202, 207;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(191.8, 201.8, 206.6);
  --bs-btn-active-border-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(191.8, 201.8, 206.6);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(191.8, 201.8, 206.6);
  --bs-gradient: none;
}

.btn-outline-gray-200 {
  --bs-btn-color: rgb(168.1, 181.85, 188.45);
  --bs-btn-border-color: rgb(168.1, 181.85, 188.45);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(168.1, 181.85, 188.45);
  --bs-btn-hover-border-color: rgb(168.1, 181.85, 188.45);
  --bs-btn-focus-shadow-rgb: 168, 182, 188;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(168.1, 181.85, 188.45);
  --bs-btn-active-border-color: rgb(168.1, 181.85, 188.45);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(168.1, 181.85, 188.45);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(168.1, 181.85, 188.45);
  --bs-gradient: none;
}

.btn-outline-gray-300 {
  --bs-btn-color: rgb(144.4, 161.9, 170.3);
  --bs-btn-border-color: rgb(144.4, 161.9, 170.3);
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: rgb(144.4, 161.9, 170.3);
  --bs-btn-hover-border-color: rgb(144.4, 161.9, 170.3);
  --bs-btn-focus-shadow-rgb: 144, 162, 170;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: rgb(144.4, 161.9, 170.3);
  --bs-btn-active-border-color: rgb(144.4, 161.9, 170.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(144.4, 161.9, 170.3);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(144.4, 161.9, 170.3);
  --bs-gradient: none;
}

.btn-outline-gray-400 {
  --bs-btn-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
  --bs-gradient: none;
}

.btn-outline-gray-500 {
  --bs-btn-color: #617a86;
  --bs-btn-border-color: #617a86;
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: #617a86;
  --bs-btn-hover-border-color: #617a86;
  --bs-btn-focus-shadow-rgb: 97, 122, 134;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #617a86;
  --bs-btn-active-border-color: #617a86;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #617a86;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #617a86;
  --bs-gradient: none;
}

.btn-outline-gray-600 {
  --bs-btn-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-border-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(82.45, 103.7, 113.9);
  --bs-btn-hover-border-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-focus-shadow-rgb: 82, 104, 114;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(82.45, 103.7, 113.9);
  --bs-btn-active-border-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(82.45, 103.7, 113.9);
  --bs-gradient: none;
}

.btn-outline-gray-700 {
  --bs-btn-color: rgb(67.9, 85.4, 93.8);
  --bs-btn-border-color: rgb(67.9, 85.4, 93.8);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(67.9, 85.4, 93.8);
  --bs-btn-hover-border-color: rgb(67.9, 85.4, 93.8);
  --bs-btn-focus-shadow-rgb: 68, 85, 94;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(67.9, 85.4, 93.8);
  --bs-btn-active-border-color: rgb(67.9, 85.4, 93.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(67.9, 85.4, 93.8);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(67.9, 85.4, 93.8);
  --bs-gradient: none;
}

.btn-outline-gray-800 {
  --bs-btn-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-hover-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-focus-shadow-rgb: 53, 67, 74;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(53.35, 67.1, 73.7);
  --bs-btn-active-border-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(53.35, 67.1, 73.7);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(53.35, 67.1, 73.7);
  --bs-gradient: none;
}

.btn-outline-gray-900 {
  --bs-btn-color: rgb(38.8, 48.8, 53.6);
  --bs-btn-border-color: rgb(38.8, 48.8, 53.6);
  --bs-btn-hover-color: #FFFFFF;
  --bs-btn-hover-bg: rgb(38.8, 48.8, 53.6);
  --bs-btn-hover-border-color: rgb(38.8, 48.8, 53.6);
  --bs-btn-focus-shadow-rgb: 39, 49, 54;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(38.8, 48.8, 53.6);
  --bs-btn-active-border-color: rgb(38.8, 48.8, 53.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(38.8, 48.8, 53.6);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(38.8, 48.8, 53.6);
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: rgb(82.45, 103.7, 113.9);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 69, 172, 141;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1rem;
  --bs-btn-border-radius: 8px;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-border-radius: 2px;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.875rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: rgba(var(--bs-body-bg-rgb), 0.98);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0;
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(0 - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: rgba(var(--bs-body-color-rgb), 0.15);
  --bs-dropdown-link-active-color: #FFFFFF;
  --bs-dropdown-link-active-bg: #249d79;
  --bs-dropdown-link-disabled-color: #617a86;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.375rem;
  --bs-dropdown-header-color: rgba(var(--bs-body-color-rgb), 0.5);
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1660px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1900px) {
  .dropdown-menu-xxxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.8125rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: rgb(144.4, 161.9, 170.3);
  --bs-dropdown-bg: rgb(53.35, 67.1, 73.7);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: rgb(144.4, 161.9, 170.3);
  --bs-dropdown-link-hover-color: #FFFFFF;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #FFFFFF;
  --bs-dropdown-link-active-bg: #249d79;
  --bs-dropdown-link-disabled-color: #617a86;
  --bs-dropdown-header-color: #617a86;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 4px;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(2, 113, 255, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-inverse);
  --bs-nav-tabs-link-active-bg: transparent;
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) transparent;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 4px;
  --bs-nav-pills-link-active-color: #FFFFFF;
  --bs-nav-pills-link-active-bg: #249d79;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 600;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-inverse-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-inverse-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-inverse-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-inverse-rgb), 1);
  --bs-navbar-brand-padding-y: 0.40625rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1rem;
  --bs-navbar-brand-color: rgba(var(--bs-inverse-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-inverse-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-inverse-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 4px;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1660px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1900px) {
  .navbar-expand-xxxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #FFFFFF;
  --bs-navbar-brand-color: #FFFFFF;
  --bs-navbar-brand-hover-color: #FFFFFF;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: transparent;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-inverse);
  --bs-accordion-active-bg: rgba(var(--bs-theme-rgb), 0.15);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-font-size: 85%;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-color: var(--bs-inverse);
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-inverse);
  --bs-pagination-hover-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  --bs-pagination-active-color: var(--bs-theme-color);
  --bs-pagination-active-bg: var(--bs-theme);
  --bs-pagination-active-border-color: var(--bs-theme);
  --bs-pagination-disabled-color: rgba(var(--bs-inverse-rgb), 0.35);
  --bs-pagination-disabled-bg: rgba(var(--bs-inverse-rgb), 0.1);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-border-radius: 8px;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.8125rem;
  --bs-pagination-border-radius: 2px;
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #FFFFFF;
  --bs-badge-border-radius: 4px;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 4px;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-default {
  --bs-alert-color: var(--bs-default-text-emphasis);
  --bs-alert-bg: var(--bs-default-bg-subtle);
  --bs-alert-border-color: var(--bs-default-border-subtle);
  --bs-alert-link-color: var(--bs-default-text-emphasis);
}

.alert-theme {
  --bs-alert-color: var(--bs-theme-text-emphasis);
  --bs-alert-bg: var(--bs-theme-bg-subtle);
  --bs-alert-border-color: var(--bs-theme-border-subtle);
  --bs-alert-link-color: var(--bs-theme-text-emphasis);
}

.alert-theme-color {
  --bs-alert-color: var(--bs-theme-color-text-emphasis);
  --bs-alert-bg: var(--bs-theme-color-bg-subtle);
  --bs-alert-border-color: var(--bs-theme-color-border-subtle);
  --bs-alert-link-color: var(--bs-theme-color-text-emphasis);
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-inverse {
  --bs-alert-color: var(--bs-inverse-text-emphasis);
  --bs-alert-bg: var(--bs-inverse-bg-subtle);
  --bs-alert-border-color: var(--bs-inverse-border-subtle);
  --bs-alert-link-color: var(--bs-inverse-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-black {
  --bs-alert-color: var(--bs-black-text-emphasis);
  --bs-alert-bg: var(--bs-black-bg-subtle);
  --bs-alert-border-color: var(--bs-black-border-subtle);
  --bs-alert-link-color: var(--bs-black-text-emphasis);
}

.alert-white {
  --bs-alert-color: var(--bs-white-text-emphasis);
  --bs-alert-bg: var(--bs-white-bg-subtle);
  --bs-alert-border-color: var(--bs-white-border-subtle);
  --bs-alert-link-color: var(--bs-white-text-emphasis);
}

.alert-purple {
  --bs-alert-color: var(--bs-purple-text-emphasis);
  --bs-alert-bg: var(--bs-purple-bg-subtle);
  --bs-alert-border-color: var(--bs-purple-border-subtle);
  --bs-alert-link-color: var(--bs-purple-text-emphasis);
}

.alert-indigo {
  --bs-alert-color: var(--bs-indigo-text-emphasis);
  --bs-alert-bg: var(--bs-indigo-bg-subtle);
  --bs-alert-border-color: var(--bs-indigo-border-subtle);
  --bs-alert-link-color: var(--bs-indigo-text-emphasis);
}

.alert-red {
  --bs-alert-color: var(--bs-red-text-emphasis);
  --bs-alert-bg: var(--bs-red-bg-subtle);
  --bs-alert-border-color: var(--bs-red-border-subtle);
  --bs-alert-link-color: var(--bs-red-text-emphasis);
}

.alert-pink {
  --bs-alert-color: var(--bs-pink-text-emphasis);
  --bs-alert-bg: var(--bs-pink-bg-subtle);
  --bs-alert-border-color: var(--bs-pink-border-subtle);
  --bs-alert-link-color: var(--bs-pink-text-emphasis);
}

.alert-green {
  --bs-alert-color: var(--bs-green-text-emphasis);
  --bs-alert-bg: var(--bs-green-bg-subtle);
  --bs-alert-border-color: var(--bs-green-border-subtle);
  --bs-alert-link-color: var(--bs-green-text-emphasis);
}

.alert-yellow {
  --bs-alert-color: var(--bs-yellow-text-emphasis);
  --bs-alert-bg: var(--bs-yellow-bg-subtle);
  --bs-alert-border-color: var(--bs-yellow-border-subtle);
  --bs-alert-link-color: var(--bs-yellow-text-emphasis);
}

.alert-teal {
  --bs-alert-color: var(--bs-teal-text-emphasis);
  --bs-alert-bg: var(--bs-teal-bg-subtle);
  --bs-alert-border-color: var(--bs-teal-border-subtle);
  --bs-alert-link-color: var(--bs-teal-text-emphasis);
}

.alert-muted {
  --bs-alert-color: var(--bs-muted-text-emphasis);
  --bs-alert-bg: var(--bs-muted-bg-subtle);
  --bs-alert-border-color: var(--bs-muted-border-subtle);
  --bs-alert-link-color: var(--bs-muted-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-lime {
  --bs-alert-color: var(--bs-lime-text-emphasis);
  --bs-alert-bg: var(--bs-lime-bg-subtle);
  --bs-alert-border-color: var(--bs-lime-border-subtle);
  --bs-alert-link-color: var(--bs-lime-text-emphasis);
}

.alert-gray-100 {
  --bs-alert-color: var(--bs-gray-100-text-emphasis);
  --bs-alert-bg: var(--bs-gray-100-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-100-border-subtle);
  --bs-alert-link-color: var(--bs-gray-100-text-emphasis);
}

.alert-gray-200 {
  --bs-alert-color: var(--bs-gray-200-text-emphasis);
  --bs-alert-bg: var(--bs-gray-200-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-200-border-subtle);
  --bs-alert-link-color: var(--bs-gray-200-text-emphasis);
}

.alert-gray-300 {
  --bs-alert-color: var(--bs-gray-300-text-emphasis);
  --bs-alert-bg: var(--bs-gray-300-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-300-border-subtle);
  --bs-alert-link-color: var(--bs-gray-300-text-emphasis);
}

.alert-gray-400 {
  --bs-alert-color: var(--bs-gray-400-text-emphasis);
  --bs-alert-bg: var(--bs-gray-400-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-400-border-subtle);
  --bs-alert-link-color: var(--bs-gray-400-text-emphasis);
}

.alert-gray-500 {
  --bs-alert-color: var(--bs-gray-500-text-emphasis);
  --bs-alert-bg: var(--bs-gray-500-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-500-border-subtle);
  --bs-alert-link-color: var(--bs-gray-500-text-emphasis);
}

.alert-gray-600 {
  --bs-alert-color: var(--bs-gray-600-text-emphasis);
  --bs-alert-bg: var(--bs-gray-600-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-600-border-subtle);
  --bs-alert-link-color: var(--bs-gray-600-text-emphasis);
}

.alert-gray-700 {
  --bs-alert-color: var(--bs-gray-700-text-emphasis);
  --bs-alert-bg: var(--bs-gray-700-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-700-border-subtle);
  --bs-alert-link-color: var(--bs-gray-700-text-emphasis);
}

.alert-gray-800 {
  --bs-alert-color: var(--bs-gray-800-text-emphasis);
  --bs-alert-bg: var(--bs-gray-800-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-800-border-subtle);
  --bs-alert-link-color: var(--bs-gray-800-text-emphasis);
}

.alert-gray-900 {
  --bs-alert-color: var(--bs-gray-900-text-emphasis);
  --bs-alert-bg: var(--bs-gray-900-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-900-border-subtle);
  --bs-alert-link-color: var(--bs-gray-900-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.65625rem;
  --bs-progress-bg: rgba(var(--bs-inverse-rgb), 0.15);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #FFFFFF;
  --bs-progress-bar-bg: #0271ff;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: transparent;
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-inverse);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: transparent;
  --bs-list-group-active-color: #FFFFFF;
  --bs-list-group-active-bg: #249d79;
  --bs-list-group-active-border-color: #249d79;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1660px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1900px) {
  .list-group-horizontal-xxxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-default {
  --bs-list-group-color: var(--bs-default-text-emphasis);
  --bs-list-group-bg: var(--bs-default-bg-subtle);
  --bs-list-group-border-color: var(--bs-default-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-default-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-default-border-subtle);
  --bs-list-group-active-color: var(--bs-default-bg-subtle);
  --bs-list-group-active-bg: var(--bs-default-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-default-text-emphasis);
}

.list-group-item-theme {
  --bs-list-group-color: var(--bs-theme-text-emphasis);
  --bs-list-group-bg: var(--bs-theme-bg-subtle);
  --bs-list-group-border-color: var(--bs-theme-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-theme-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-theme-border-subtle);
  --bs-list-group-active-color: var(--bs-theme-bg-subtle);
  --bs-list-group-active-bg: var(--bs-theme-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-theme-text-emphasis);
}

.list-group-item-theme-color {
  --bs-list-group-color: var(--bs-theme-color-text-emphasis);
  --bs-list-group-bg: var(--bs-theme-color-bg-subtle);
  --bs-list-group-border-color: var(--bs-theme-color-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-theme-color-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-theme-color-border-subtle);
  --bs-list-group-active-color: var(--bs-theme-color-bg-subtle);
  --bs-list-group-active-bg: var(--bs-theme-color-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-theme-color-text-emphasis);
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-inverse {
  --bs-list-group-color: var(--bs-inverse-text-emphasis);
  --bs-list-group-bg: var(--bs-inverse-bg-subtle);
  --bs-list-group-border-color: var(--bs-inverse-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-inverse-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-inverse-border-subtle);
  --bs-list-group-active-color: var(--bs-inverse-bg-subtle);
  --bs-list-group-active-bg: var(--bs-inverse-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-inverse-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-black {
  --bs-list-group-color: var(--bs-black-text-emphasis);
  --bs-list-group-bg: var(--bs-black-bg-subtle);
  --bs-list-group-border-color: var(--bs-black-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-black-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-black-border-subtle);
  --bs-list-group-active-color: var(--bs-black-bg-subtle);
  --bs-list-group-active-bg: var(--bs-black-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-black-text-emphasis);
}

.list-group-item-white {
  --bs-list-group-color: var(--bs-white-text-emphasis);
  --bs-list-group-bg: var(--bs-white-bg-subtle);
  --bs-list-group-border-color: var(--bs-white-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-white-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-white-border-subtle);
  --bs-list-group-active-color: var(--bs-white-bg-subtle);
  --bs-list-group-active-bg: var(--bs-white-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-white-text-emphasis);
}

.list-group-item-purple {
  --bs-list-group-color: var(--bs-purple-text-emphasis);
  --bs-list-group-bg: var(--bs-purple-bg-subtle);
  --bs-list-group-border-color: var(--bs-purple-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-purple-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-purple-border-subtle);
  --bs-list-group-active-color: var(--bs-purple-bg-subtle);
  --bs-list-group-active-bg: var(--bs-purple-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-purple-text-emphasis);
}

.list-group-item-indigo {
  --bs-list-group-color: var(--bs-indigo-text-emphasis);
  --bs-list-group-bg: var(--bs-indigo-bg-subtle);
  --bs-list-group-border-color: var(--bs-indigo-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-indigo-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-indigo-border-subtle);
  --bs-list-group-active-color: var(--bs-indigo-bg-subtle);
  --bs-list-group-active-bg: var(--bs-indigo-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-indigo-text-emphasis);
}

.list-group-item-red {
  --bs-list-group-color: var(--bs-red-text-emphasis);
  --bs-list-group-bg: var(--bs-red-bg-subtle);
  --bs-list-group-border-color: var(--bs-red-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-red-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-red-border-subtle);
  --bs-list-group-active-color: var(--bs-red-bg-subtle);
  --bs-list-group-active-bg: var(--bs-red-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-red-text-emphasis);
}

.list-group-item-pink {
  --bs-list-group-color: var(--bs-pink-text-emphasis);
  --bs-list-group-bg: var(--bs-pink-bg-subtle);
  --bs-list-group-border-color: var(--bs-pink-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-pink-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-pink-border-subtle);
  --bs-list-group-active-color: var(--bs-pink-bg-subtle);
  --bs-list-group-active-bg: var(--bs-pink-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-pink-text-emphasis);
}

.list-group-item-green {
  --bs-list-group-color: var(--bs-green-text-emphasis);
  --bs-list-group-bg: var(--bs-green-bg-subtle);
  --bs-list-group-border-color: var(--bs-green-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-green-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-green-border-subtle);
  --bs-list-group-active-color: var(--bs-green-bg-subtle);
  --bs-list-group-active-bg: var(--bs-green-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-green-text-emphasis);
}

.list-group-item-yellow {
  --bs-list-group-color: var(--bs-yellow-text-emphasis);
  --bs-list-group-bg: var(--bs-yellow-bg-subtle);
  --bs-list-group-border-color: var(--bs-yellow-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-yellow-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-yellow-border-subtle);
  --bs-list-group-active-color: var(--bs-yellow-bg-subtle);
  --bs-list-group-active-bg: var(--bs-yellow-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-yellow-text-emphasis);
}

.list-group-item-teal {
  --bs-list-group-color: var(--bs-teal-text-emphasis);
  --bs-list-group-bg: var(--bs-teal-bg-subtle);
  --bs-list-group-border-color: var(--bs-teal-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-teal-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-teal-border-subtle);
  --bs-list-group-active-color: var(--bs-teal-bg-subtle);
  --bs-list-group-active-bg: var(--bs-teal-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-teal-text-emphasis);
}

.list-group-item-muted {
  --bs-list-group-color: var(--bs-muted-text-emphasis);
  --bs-list-group-bg: var(--bs-muted-bg-subtle);
  --bs-list-group-border-color: var(--bs-muted-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-muted-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-muted-border-subtle);
  --bs-list-group-active-color: var(--bs-muted-bg-subtle);
  --bs-list-group-active-bg: var(--bs-muted-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-muted-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-lime {
  --bs-list-group-color: var(--bs-lime-text-emphasis);
  --bs-list-group-bg: var(--bs-lime-bg-subtle);
  --bs-list-group-border-color: var(--bs-lime-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-lime-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-lime-border-subtle);
  --bs-list-group-active-color: var(--bs-lime-bg-subtle);
  --bs-list-group-active-bg: var(--bs-lime-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-lime-text-emphasis);
}

.list-group-item-gray-100 {
  --bs-list-group-color: var(--bs-gray-100-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-100-text-emphasis);
}

.list-group-item-gray-200 {
  --bs-list-group-color: var(--bs-gray-200-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-200-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-200-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-200-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-200-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-200-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-200-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-200-text-emphasis);
}

.list-group-item-gray-300 {
  --bs-list-group-color: var(--bs-gray-300-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-300-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-300-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-300-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-300-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-300-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-300-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-300-text-emphasis);
}

.list-group-item-gray-400 {
  --bs-list-group-color: var(--bs-gray-400-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-400-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-400-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-400-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-400-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-400-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-400-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-400-text-emphasis);
}

.list-group-item-gray-500 {
  --bs-list-group-color: var(--bs-gray-500-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-500-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-500-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-500-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-500-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-500-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-500-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-500-text-emphasis);
}

.list-group-item-gray-600 {
  --bs-list-group-color: var(--bs-gray-600-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-600-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-600-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-600-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-600-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-600-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-600-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-600-text-emphasis);
}

.list-group-item-gray-700 {
  --bs-list-group-color: var(--bs-gray-700-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-700-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-700-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-700-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-700-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-700-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-700-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-700-text-emphasis);
}

.list-group-item-gray-800 {
  --bs-list-group-color: var(--bs-gray-800-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-800-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-800-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-800-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-800-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-800-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-800-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-800-text-emphasis);
}

.list-group-item-gray-900 {
  --bs-list-group-color: var(--bs-gray-900-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-900-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-900-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-900-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-900-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-900-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-900-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-900-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 4px;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 20px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-app-header-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: 0;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);
  --bs-modal-inner-border-radius: 0;
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #e6e6e6;
  --bs-backdrop-opacity: 0.95;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1659.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1899.98px) {
  .modal-fullscreen-xxxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxxl-down .modal-header,
  .modal-fullscreen-xxxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1130;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.8125rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-inverse);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Chakra Petch", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.8125rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.875rem;
  --bs-popover-header-color: #000000;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Chakra Petch", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #FFFFFF;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #FFFFFF;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #FFFFFF;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #FFFFFF;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
.carousel-dark .carousel-caption {
  color: #000000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxxl, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(var(--bs-inverse-rgb), 0.035);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1659.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1659.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1659.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1660px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1899.98px) {
  .offcanvas-xxxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1899.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxxl {
    transition: none;
  }
}
@media (max-width: 1899.98px) {
  .offcanvas-xxxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxxl.showing, .offcanvas-xxxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxxl.showing, .offcanvas-xxxl.hiding, .offcanvas-xxxl.show {
    visibility: visible;
  }
}
@media (min-width: 1900px) {
  .offcanvas-xxxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #e6e6e6;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.95;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-default {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-default-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-theme {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-theme-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-theme-color {
  color: #000000 !important;
  background-color: RGBA(var(--bs-theme-color-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-inverse {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-inverse-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-black {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-black-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-white {
  color: #000000 !important;
  background-color: RGBA(var(--bs-white-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-purple {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-purple-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-indigo {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-indigo-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-red {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-red-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-pink {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-pink-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-green {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-green-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-yellow {
  color: #000000 !important;
  background-color: RGBA(var(--bs-yellow-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-teal {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-teal-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-muted {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-muted-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-lime {
  color: #000000 !important;
  background-color: RGBA(var(--bs-lime-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-100 {
  color: #000000 !important;
  background-color: RGBA(var(--bs-gray-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-200 {
  color: #000000 !important;
  background-color: RGBA(var(--bs-gray-200-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-300 {
  color: #000000 !important;
  background-color: RGBA(var(--bs-gray-300-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-400 {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-gray-400-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-500 {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-gray-500-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-600 {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-gray-600-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-700 {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-gray-700-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-800 {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-gray-800-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-900 {
  color: #FFFFFF !important;
  background-color: RGBA(var(--bs-gray-900-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-default {
  color: RGBA(var(--bs-default-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-default-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-default:hover, .link-default:focus {
  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;
}

.link-theme {
  color: RGBA(var(--bs-theme-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-theme-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-theme:hover, .link-theme:focus {
  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-theme-color {
  color: RGBA(var(--bs-theme-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-theme-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-theme-color:hover, .link-theme-color:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(2, 90, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(2, 90, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 178, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 178, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(179, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(179, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-inverse {
  color: RGBA(var(--bs-inverse-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-inverse-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-inverse:hover, .link-inverse:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(0, 124, 182, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 124, 182, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(43, 54, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(43, 54, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-black {
  color: RGBA(var(--bs-black-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-black-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-black:hover, .link-black:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-white {
  color: RGBA(var(--bs-white-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-white-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-white:hover, .link-white:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-purple {
  color: RGBA(var(--bs-purple-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-purple-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-purple:hover, .link-purple:focus {
  color: RGBA(148, 10, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(148, 10, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-indigo {
  color: RGBA(var(--bs-indigo-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-indigo-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-indigo:hover, .link-indigo:focus {
  color: RGBA(74, 30, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(74, 30, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-red {
  color: RGBA(var(--bs-red-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-red-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-red:hover, .link-red:focus {
  color: RGBA(179, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(179, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-pink {
  color: RGBA(var(--bs-pink-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-pink-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-pink:hover, .link-pink:focus {
  color: RGBA(184, 13, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(184, 13, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-green {
  color: RGBA(var(--bs-green-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-green-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-green:hover, .link-green:focus {
  color: RGBA(16, 110, 27, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(16, 110, 27, var(--bs-link-underline-opacity, 1)) !important;
}

.link-yellow {
  color: RGBA(var(--bs-yellow-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-yellow-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-yellow:hover, .link-yellow:focus {
  color: RGBA(250, 237, 61, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(250, 237, 61, var(--bs-link-underline-opacity, 1)) !important;
}

.link-teal {
  color: RGBA(var(--bs-teal-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-teal-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-teal:hover, .link-teal:focus {
  color: RGBA(29, 126, 97, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 126, 97, var(--bs-link-underline-opacity, 1)) !important;
}

.link-muted {
  color: RGBA(var(--bs-muted-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-muted-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-muted:hover, .link-muted:focus {
  color: RGBA(78, 98, 107, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(78, 98, 107, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(204, 212, 216, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 212, 216, var(--bs-link-underline-opacity, 1)) !important;
}

.link-lime {
  color: RGBA(var(--bs-lime-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-lime-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-lime:hover, .link-lime:focus {
  color: RGBA(115, 192, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(115, 192, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-100 {
  color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-100:hover, .link-gray-100:focus {
  color: RGBA(204, 212, 216, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 212, 216, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-200 {
  color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-200:hover, .link-gray-200:focus {
  color: RGBA(185, 196, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(185, 196, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-300 {
  color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-300:hover, .link-gray-300:focus {
  color: RGBA(167, 181, 187, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(167, 181, 187, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-400 {
  color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-400:hover, .link-gray-400:focus {
  color: RGBA(97, 114, 122, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 114, 122, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-500 {
  color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-500:hover, .link-gray-500:focus {
  color: RGBA(78, 98, 107, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(78, 98, 107, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-600 {
  color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-600:hover, .link-gray-600:focus {
  color: RGBA(66, 83, 91, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(66, 83, 91, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-700 {
  color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-700:hover, .link-gray-700:focus {
  color: RGBA(54, 68, 75, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(54, 68, 75, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-800 {
  color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-800:hover, .link-gray-800:focus {
  color: RGBA(43, 54, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(43, 54, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-900 {
  color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-900:hover, .link-gray-900:focus {
  color: RGBA(31, 39, 43, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(31, 39, 43, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1660px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1900px) {
  .sticky-xxxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-default {
  --bs-focus-ring-color: rgba(var(--bs-default-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-theme {
  --bs-focus-ring-color: rgba(var(--bs-theme-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-theme-color {
  --bs-focus-ring-color: rgba(var(--bs-theme-color-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-inverse {
  --bs-focus-ring-color: rgba(var(--bs-inverse-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-black {
  --bs-focus-ring-color: rgba(var(--bs-black-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-white {
  --bs-focus-ring-color: rgba(var(--bs-white-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-purple {
  --bs-focus-ring-color: rgba(var(--bs-purple-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-indigo {
  --bs-focus-ring-color: rgba(var(--bs-indigo-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-red {
  --bs-focus-ring-color: rgba(var(--bs-red-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-pink {
  --bs-focus-ring-color: rgba(var(--bs-pink-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-green {
  --bs-focus-ring-color: rgba(var(--bs-green-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-yellow {
  --bs-focus-ring-color: rgba(var(--bs-yellow-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-teal {
  --bs-focus-ring-color: rgba(var(--bs-teal-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-muted {
  --bs-focus-ring-color: rgba(var(--bs-muted-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-lime {
  --bs-focus-ring-color: rgba(var(--bs-lime-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-100 {
  --bs-focus-ring-color: rgba(var(--bs-gray-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-200 {
  --bs-focus-ring-color: rgba(var(--bs-gray-200-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-300 {
  --bs-focus-ring-color: rgba(var(--bs-gray-300-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-400 {
  --bs-focus-ring-color: rgba(var(--bs-gray-400-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-500 {
  --bs-focus-ring-color: rgba(var(--bs-gray-500-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-600 {
  --bs-focus-ring-color: rgba(var(--bs-gray-600-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-700 {
  --bs-focus-ring-color: rgba(var(--bs-gray-700-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-800 {
  --bs-focus-ring-color: rgba(var(--bs-gray-800-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-900 {
  --bs-focus-ring-color: rgba(var(--bs-gray-900-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-default {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-default-rgb), var(--bs-border-opacity)) !important;
}

.border-theme {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-theme-rgb), var(--bs-border-opacity)) !important;
}

.border-theme-color {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-theme-color-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-inverse {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-inverse-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-purple {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-purple-rgb), var(--bs-border-opacity)) !important;
}

.border-indigo {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-indigo-rgb), var(--bs-border-opacity)) !important;
}

.border-red {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-red-rgb), var(--bs-border-opacity)) !important;
}

.border-pink {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-pink-rgb), var(--bs-border-opacity)) !important;
}

.border-green {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-green-rgb), var(--bs-border-opacity)) !important;
}

.border-yellow {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-yellow-rgb), var(--bs-border-opacity)) !important;
}

.border-teal {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-teal-rgb), var(--bs-border-opacity)) !important;
}

.border-muted {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-muted-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-lime {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-lime-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-100-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-200 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-200-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-300 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-300-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-400 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-400-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-500 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-500-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-600 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-600-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-700 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-700-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-800 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-800-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-900 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-900-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.34375rem + 1.125vw) !important;
}

.fs-2 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-3 {
  font-size: calc(1.278125rem + 0.3375vw) !important;
}

.fs-4 {
  font-size: calc(1.25625rem + 0.075vw) !important;
}

.fs-5 {
  font-size: 1.09375rem !important;
}

.fs-6 {
  font-size: 0.875rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 500 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-default {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-default-rgb), var(--bs-text-opacity)) !important;
}

.text-theme {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-theme-rgb), var(--bs-text-opacity)) !important;
}

.text-theme-color {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-theme-color-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-inverse {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-inverse-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-purple {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-purple-rgb), var(--bs-text-opacity)) !important;
}

.text-indigo {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-indigo-rgb), var(--bs-text-opacity)) !important;
}

.text-red {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-red-rgb), var(--bs-text-opacity)) !important;
}

.text-pink {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-pink-rgb), var(--bs-text-opacity)) !important;
}

.text-green {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-green-rgb), var(--bs-text-opacity)) !important;
}

.text-yellow {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-yellow-rgb), var(--bs-text-opacity)) !important;
}

.text-teal {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-teal-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-lime {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-lime-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-100-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-200 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-200-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-300 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-300-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-400 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-400-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-500 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-500-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-600 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-600-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-700 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-700-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-800 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-800-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-900 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-900-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-default {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-default-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-theme {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-theme-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-theme-color {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-theme-color-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-inverse {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-inverse-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-black {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-black-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-white {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-white-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-purple {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-purple-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-indigo {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-indigo-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-red {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-red-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-pink {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-pink-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-green {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-green-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-yellow {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-yellow-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-teal {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-teal-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-muted {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-muted-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-lime {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-lime-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-200 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-300 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-400 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-500 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-600 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-700 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-800 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-900 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-default {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-default-rgb), var(--bs-bg-opacity)) !important;
}

.bg-theme {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-theme-rgb), var(--bs-bg-opacity)) !important;
}

.bg-theme-color {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-theme-color-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-inverse {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-inverse-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-purple {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-purple-rgb), var(--bs-bg-opacity)) !important;
}

.bg-indigo {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-indigo-rgb), var(--bs-bg-opacity)) !important;
}

.bg-red {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-red-rgb), var(--bs-bg-opacity)) !important;
}

.bg-pink {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-pink-rgb), var(--bs-bg-opacity)) !important;
}

.bg-green {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-green-rgb), var(--bs-bg-opacity)) !important;
}

.bg-yellow {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-yellow-rgb), var(--bs-bg-opacity)) !important;
}

.bg-teal {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-teal-rgb), var(--bs-bg-opacity)) !important;
}

.bg-muted {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-muted-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-lime {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-lime-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-200-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-300-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-400-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-500 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-500-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-600-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-700-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-800-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-900-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1660px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1900px) {
  .float-xxxl-start {
    float: left !important;
  }
  .float-xxxl-end {
    float: right !important;
  }
  .float-xxxl-none {
    float: none !important;
  }
  .object-fit-xxxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxxl-none {
    object-fit: none !important;
  }
  .d-xxxl-inline {
    display: inline !important;
  }
  .d-xxxl-inline-block {
    display: inline-block !important;
  }
  .d-xxxl-block {
    display: block !important;
  }
  .d-xxxl-grid {
    display: grid !important;
  }
  .d-xxxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxxl-table {
    display: table !important;
  }
  .d-xxxl-table-row {
    display: table-row !important;
  }
  .d-xxxl-table-cell {
    display: table-cell !important;
  }
  .d-xxxl-flex {
    display: flex !important;
  }
  .d-xxxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxxl-none {
    display: none !important;
  }
  .flex-xxxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxxl-row {
    flex-direction: row !important;
  }
  .flex-xxxl-column {
    flex-direction: column !important;
  }
  .flex-xxxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxxl-center {
    justify-content: center !important;
  }
  .justify-content-xxxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxxl-center {
    align-items: center !important;
  }
  .align-items-xxxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxxl-center {
    align-content: center !important;
  }
  .align-content-xxxl-between {
    align-content: space-between !important;
  }
  .align-content-xxxl-around {
    align-content: space-around !important;
  }
  .align-content-xxxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxxl-auto {
    align-self: auto !important;
  }
  .align-self-xxxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxxl-center {
    align-self: center !important;
  }
  .align-self-xxxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxxl-stretch {
    align-self: stretch !important;
  }
  .order-xxxl-first {
    order: -1 !important;
  }
  .order-xxxl-0 {
    order: 0 !important;
  }
  .order-xxxl-1 {
    order: 1 !important;
  }
  .order-xxxl-2 {
    order: 2 !important;
  }
  .order-xxxl-3 {
    order: 3 !important;
  }
  .order-xxxl-4 {
    order: 4 !important;
  }
  .order-xxxl-5 {
    order: 5 !important;
  }
  .order-xxxl-last {
    order: 6 !important;
  }
  .m-xxxl-0 {
    margin: 0 !important;
  }
  .m-xxxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxxl-3 {
    margin: 1rem !important;
  }
  .m-xxxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxxl-5 {
    margin: 3rem !important;
  }
  .m-xxxl-auto {
    margin: auto !important;
  }
  .mx-xxxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxxl-auto {
    margin-top: auto !important;
  }
  .me-xxxl-0 {
    margin-right: 0 !important;
  }
  .me-xxxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxxl-auto {
    margin-right: auto !important;
  }
  .mb-xxxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxxl-auto {
    margin-left: auto !important;
  }
  .m-xxxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxxl-n3 {
    margin: -1rem !important;
  }
  .m-xxxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxxl-0 {
    padding: 0 !important;
  }
  .p-xxxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxxl-3 {
    padding: 1rem !important;
  }
  .p-xxxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxxl-5 {
    padding: 3rem !important;
  }
  .px-xxxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxxl-0 {
    gap: 0 !important;
  }
  .gap-xxxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxxl-3 {
    gap: 1rem !important;
  }
  .gap-xxxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxxl-start {
    text-align: left !important;
  }
  .text-xxxl-end {
    text-align: right !important;
  }
  .text-xxxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.1875rem !important;
  }
  .fs-2 {
    font-size: 1.75rem !important;
  }
  .fs-3 {
    font-size: 1.53125rem !important;
  }
  .fs-4 {
    font-size: 1.3125rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
:root,
[data-bs-theme=light] {
  --bs-body-bg-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.99) 100%);
  --bs-body-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --bs-body-bg-image-size: 4.6875rem;
  --bs-body-bg-cover: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --bs-body-font-weight: 400;
  --bs-body-letter-spacing: 0.046875rem;
  --bs-component-bg: #FFFFFF;
  --bs-component-bg-rgb: 255, 255, 255;
  --bs-component-color: rgba(0, 0, 0, 0.75);
  --bs-component-color-rgb: 0, 0, 0;
  --bs-app-header-bg: #FFFFFF;
  --bs-app-header-brand-img: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --bs-app-header-link-color: #000000;
  --bs-app-header-link-color-rgb: 0, 0, 0;
  --bs-app-header-link-hover-color: #000000;
  --bs-app-header-scroll-box-shadow: ;
  --bs-app-sidebar-menu-header-color: rgba(var(--bs-inverse-rgb), 0.3);
  --bs-app-sidebar-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-sidebar-menu-link-hover-color: #000000;
  --bs-app-sidebar-menu-link-active-color: #000000;
  --bs-app-sidebar-mobile-bg: rgba(255, 255, 255, 0.98);
  --bs-app-top-nav-bg: #FFFFFF;
  --bs-app-top-nav-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-top-nav-menu-link-hover-color: #000000;
  --bs-app-top-nav-menu-link-active-color: #000000;
  --bs-app-top-nav-menu-submenu-bg: #FFFFFF;
  --bs-app-theme-panel-bg: rgba(255, 255, 255, 0.95);
  --bs-theme-bg-subtle: rgb(211.2, 235.4, 228.2);
}

[data-bs-theme=dark] {
  --bs-body-bg-gradient: linear-gradient(180deg, rgba(50, 70, 80, 0.9) 0%, rgb(13, 16, 27) 100%);
  --bs-body-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --bs-body-bg-image-size: 4.6875rem;
  --bs-body-bg-cover: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  --bs-body-font-weight: 300;
  --bs-body-letter-spacing: 0.046875rem;
  --bs-component-bg: #28292b;
  --bs-component-bg-rgb: 40, 41, 43;
  --bs-component-color: rgba(255, 255, 255, 0.75);
  --bs-component-color-rgb: 255, 255, 255;
  --bs-app-header-bg: rgba(29, 40, 53, 0.95);
  --bs-app-header-brand-img: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  --bs-app-header-link-color: #FFFFFF;
  --bs-app-header-link-color-rgb: 255, 255, 255;
  --bs-app-header-link-hover-color: rgba(255, 255, 255, 0.5);
  --bs-app-header-scroll-box-shadow: ;
  --bs-app-sidebar-menu-header-color: rgba(var(--bs-inverse-rgb), 0.3);
  --bs-app-sidebar-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-sidebar-menu-link-hover-color: #FFFFFF;
  --bs-app-sidebar-menu-link-active-color: #FFFFFF;
  --bs-app-sidebar-mobile-bg: rgba(44, 56, 70, 0.98);
  --bs-app-top-nav-bg: rgba(29, 40, 53, 0.95);
  --bs-app-top-nav-menu-link-color: rgba(var(--bs-inverse-rgb), 0.5);
  --bs-app-top-nav-menu-link-hover-color: #FFFFFF;
  --bs-app-top-nav-menu-link-active-color: #FFFFFF;
  --bs-app-top-nav-menu-submenu-bg: rgba(29, 40, 53, 0.95);
  --bs-app-theme-panel-bg: rgba(67.9, 85.4, 93.8, 0.95);
  --bs-theme-bg-subtle: rgb(7.2, 31.4, 24.2);
}

html {
  height: 100%;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-body-bg-gradient);
}
html:before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: -5;
  background: var(--bs-body-bg-gradient);
}
html:after {
  content: "";
  position: fixed;
  top: 0;
  height: 100%;
  left: 0;
  right: 0;
  z-index: -10;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-body-bg-gradient);
  background-image: var(--bs-body-bg-cover);
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: initial;
  height: 100%;
  transition: background 0.2s linear;
  background-size: cover;
}

body {
  background: none;
  font-weight: var(--bs-body-font-weight);
  letter-spacing: var(--bs-body-letter-spacing);
  position: relative;
  min-height: 100vh;
  z-index: 9999;
}
body:before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-attachment: initial;
  background-color: transparent;
  background-image: var(--bs-body-bg-image);
  background-size: var(--bs-body-bg-image-size);
  background-repeat: repeat;
  background-attachment: initial;
  z-index: -5;
}
body:not(.app-init) * {
  transition: none !important;
  animation: none !important;
}

/* Helper Margin */
.m-1px {
  margin: 1px !important;
}

.m-2px {
  margin: 2px !important;
}

.m-3px {
  margin: 3px !important;
}

.m-4px {
  margin: 4px !important;
}

.m-5px {
  margin: 5px !important;
}

.m-6px {
  margin: 6px !important;
}

.m-7px {
  margin: 7px !important;
}

.m-8px {
  margin: 8px !important;
}

.m-9px {
  margin: 9px !important;
}

.m-10px {
  margin: 10px !important;
}

.m-5px {
  margin: 5px !important;
}

.m-10px {
  margin: 10px !important;
}

.m-15px {
  margin: 15px !important;
}

.m-20px {
  margin: 20px !important;
}

.m-25px {
  margin: 25px !important;
}

.m-30px {
  margin: 30px !important;
}

.m-35px {
  margin: 35px !important;
}

.m-40px {
  margin: 40px !important;
}

.m-45px {
  margin: 45px !important;
}

.m-50px {
  margin: 50px !important;
}

.mt-1px {
  margin-top: 1px !important;
}

.mt-2px {
  margin-top: 2px !important;
}

.mt-3px {
  margin-top: 3px !important;
}

.mt-4px {
  margin-top: 4px !important;
}

.mt-5px {
  margin-top: 5px !important;
}

.mt-6px {
  margin-top: 6px !important;
}

.mt-7px {
  margin-top: 7px !important;
}

.mt-8px {
  margin-top: 8px !important;
}

.mt-9px {
  margin-top: 9px !important;
}

.mt-10px {
  margin-top: 10px !important;
}

.mt-5px {
  margin-top: 5px !important;
}

.mt-10px {
  margin-top: 10px !important;
}

.mt-15px {
  margin-top: 15px !important;
}

.mt-20px {
  margin-top: 20px !important;
}

.mt-25px {
  margin-top: 25px !important;
}

.mt-30px {
  margin-top: 30px !important;
}

.mt-35px {
  margin-top: 35px !important;
}

.mt-40px {
  margin-top: 40px !important;
}

.mt-45px {
  margin-top: 45px !important;
}

.mt-50px {
  margin-top: 50px !important;
}

.me-1px {
  margin-right: 1px !important;
}

.me-2px {
  margin-right: 2px !important;
}

.me-3px {
  margin-right: 3px !important;
}

.me-4px {
  margin-right: 4px !important;
}

.me-5px {
  margin-right: 5px !important;
}

.me-6px {
  margin-right: 6px !important;
}

.me-7px {
  margin-right: 7px !important;
}

.me-8px {
  margin-right: 8px !important;
}

.me-9px {
  margin-right: 9px !important;
}

.me-10px {
  margin-right: 10px !important;
}

.me-5px {
  margin-right: 5px !important;
}

.me-10px {
  margin-right: 10px !important;
}

.me-15px {
  margin-right: 15px !important;
}

.me-20px {
  margin-right: 20px !important;
}

.me-25px {
  margin-right: 25px !important;
}

.me-30px {
  margin-right: 30px !important;
}

.me-35px {
  margin-right: 35px !important;
}

.me-40px {
  margin-right: 40px !important;
}

.me-45px {
  margin-right: 45px !important;
}

.me-50px {
  margin-right: 50px !important;
}

.mb-1px {
  margin-bottom: 1px !important;
}

.mb-2px {
  margin-bottom: 2px !important;
}

.mb-3px {
  margin-bottom: 3px !important;
}

.mb-4px {
  margin-bottom: 4px !important;
}

.mb-5px {
  margin-bottom: 5px !important;
}

.mb-6px {
  margin-bottom: 6px !important;
}

.mb-7px {
  margin-bottom: 7px !important;
}

.mb-8px {
  margin-bottom: 8px !important;
}

.mb-9px {
  margin-bottom: 9px !important;
}

.mb-10px {
  margin-bottom: 10px !important;
}

.mb-5px {
  margin-bottom: 5px !important;
}

.mb-10px {
  margin-bottom: 10px !important;
}

.mb-15px {
  margin-bottom: 15px !important;
}

.mb-20px {
  margin-bottom: 20px !important;
}

.mb-25px {
  margin-bottom: 25px !important;
}

.mb-30px {
  margin-bottom: 30px !important;
}

.mb-35px {
  margin-bottom: 35px !important;
}

.mb-40px {
  margin-bottom: 40px !important;
}

.mb-45px {
  margin-bottom: 45px !important;
}

.mb-50px {
  margin-bottom: 50px !important;
}

.ms-1px {
  margin-left: 1px !important;
}

.ms-2px {
  margin-left: 2px !important;
}

.ms-3px {
  margin-left: 3px !important;
}

.ms-4px {
  margin-left: 4px !important;
}

.ms-5px {
  margin-left: 5px !important;
}

.ms-6px {
  margin-left: 6px !important;
}

.ms-7px {
  margin-left: 7px !important;
}

.ms-8px {
  margin-left: 8px !important;
}

.ms-9px {
  margin-left: 9px !important;
}

.ms-10px {
  margin-left: 10px !important;
}

.ms-5px {
  margin-left: 5px !important;
}

.ms-10px {
  margin-left: 10px !important;
}

.ms-15px {
  margin-left: 15px !important;
}

.ms-20px {
  margin-left: 20px !important;
}

.ms-25px {
  margin-left: 25px !important;
}

.ms-30px {
  margin-left: 30px !important;
}

.ms-35px {
  margin-left: 35px !important;
}

.ms-40px {
  margin-left: 40px !important;
}

.ms-45px {
  margin-left: 45px !important;
}

.ms-50px {
  margin-left: 50px !important;
}

.mx-1px {
  margin-left: 1px !important;
  margin-right: 1px !important;
}

.mx-2px {
  margin-left: 2px !important;
  margin-right: 2px !important;
}

.mx-3px {
  margin-left: 3px !important;
  margin-right: 3px !important;
}

.mx-4px {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.mx-5px {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.mx-6px {
  margin-left: 6px !important;
  margin-right: 6px !important;
}

.mx-7px {
  margin-left: 7px !important;
  margin-right: 7px !important;
}

.mx-8px {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.mx-9px {
  margin-left: 9px !important;
  margin-right: 9px !important;
}

.mx-10px {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.mx-5px {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.mx-10px {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.mx-15px {
  margin-left: 15px !important;
  margin-right: 15px !important;
}

.mx-20px {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.mx-25px {
  margin-left: 25px !important;
  margin-right: 25px !important;
}

.mx-30px {
  margin-left: 30px !important;
  margin-right: 30px !important;
}

.mx-35px {
  margin-left: 35px !important;
  margin-right: 35px !important;
}

.mx-40px {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.mx-45px {
  margin-left: 45px !important;
  margin-right: 45px !important;
}

.mx-50px {
  margin-left: 50px !important;
  margin-right: 50px !important;
}

.my-1px {
  margin-top: 1px !important;
  margin-bottom: 1px !important;
}

.my-2px {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.my-3px {
  margin-top: 3px !important;
  margin-bottom: 3px !important;
}

.my-4px {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.my-5px {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.my-6px {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
}

.my-7px {
  margin-top: 7px !important;
  margin-bottom: 7px !important;
}

.my-8px {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.my-9px {
  margin-top: 9px !important;
  margin-bottom: 9px !important;
}

.my-10px {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.my-5px {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.my-10px {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.my-15px {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}

.my-20px {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.my-25px {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}

.my-30px {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}

.my-35px {
  margin-top: 35px !important;
  margin-bottom: 35px !important;
}

.my-40px {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.my-45px {
  margin-top: 45px !important;
  margin-bottom: 45px !important;
}

.my-50px {
  margin-top: 50px !important;
  margin-bottom: 50px !important;
}

/* Helper Padding */
.p-1px {
  padding: 1px !important;
}

.p-2px {
  padding: 2px !important;
}

.p-3px {
  padding: 3px !important;
}

.p-4px {
  padding: 4px !important;
}

.p-5px {
  padding: 5px !important;
}

.p-6px {
  padding: 6px !important;
}

.p-7px {
  padding: 7px !important;
}

.p-8px {
  padding: 8px !important;
}

.p-9px {
  padding: 9px !important;
}

.p-10px {
  padding: 10px !important;
}

.p-5px {
  padding: 5px !important;
}

.p-10px {
  padding: 10px !important;
}

.p-15px {
  padding: 15px !important;
}

.p-20px {
  padding: 20px !important;
}

.p-25px {
  padding: 25px !important;
}

.p-30px {
  padding: 30px !important;
}

.p-35px {
  padding: 35px !important;
}

.p-40px {
  padding: 40px !important;
}

.p-45px {
  padding: 45px !important;
}

.p-50px {
  padding: 50px !important;
}

.pt-1px {
  padding-top: 1px !important;
}

.pt-2px {
  padding-top: 2px !important;
}

.pt-3px {
  padding-top: 3px !important;
}

.pt-4px {
  padding-top: 4px !important;
}

.pt-5px {
  padding-top: 5px !important;
}

.pt-6px {
  padding-top: 6px !important;
}

.pt-7px {
  padding-top: 7px !important;
}

.pt-8px {
  padding-top: 8px !important;
}

.pt-9px {
  padding-top: 9px !important;
}

.pt-10px {
  padding-top: 10px !important;
}

.pt-5px {
  padding-top: 5px !important;
}

.pt-10px {
  padding-top: 10px !important;
}

.pt-15px {
  padding-top: 15px !important;
}

.pt-20px {
  padding-top: 20px !important;
}

.pt-25px {
  padding-top: 25px !important;
}

.pt-30px {
  padding-top: 30px !important;
}

.pt-35px {
  padding-top: 35px !important;
}

.pt-40px {
  padding-top: 40px !important;
}

.pt-45px {
  padding-top: 45px !important;
}

.pt-50px {
  padding-top: 50px !important;
}

.pe-1px {
  padding-right: 1px !important;
}

.pe-2px {
  padding-right: 2px !important;
}

.pe-3px {
  padding-right: 3px !important;
}

.pe-4px {
  padding-right: 4px !important;
}

.pe-5px {
  padding-right: 5px !important;
}

.pe-6px {
  padding-right: 6px !important;
}

.pe-7px {
  padding-right: 7px !important;
}

.pe-8px {
  padding-right: 8px !important;
}

.pe-9px {
  padding-right: 9px !important;
}

.pe-10px {
  padding-right: 10px !important;
}

.pe-5px {
  padding-right: 5px !important;
}

.pe-10px {
  padding-right: 10px !important;
}

.pe-15px {
  padding-right: 15px !important;
}

.pe-20px {
  padding-right: 20px !important;
}

.pe-25px {
  padding-right: 25px !important;
}

.pe-30px {
  padding-right: 30px !important;
}

.pe-35px {
  padding-right: 35px !important;
}

.pe-40px {
  padding-right: 40px !important;
}

.pe-45px {
  padding-right: 45px !important;
}

.pe-50px {
  padding-right: 50px !important;
}

.pb-1px {
  padding-bottom: 1px !important;
}

.pb-2px {
  padding-bottom: 2px !important;
}

.pb-3px {
  padding-bottom: 3px !important;
}

.pb-4px {
  padding-bottom: 4px !important;
}

.pb-5px {
  padding-bottom: 5px !important;
}

.pb-6px {
  padding-bottom: 6px !important;
}

.pb-7px {
  padding-bottom: 7px !important;
}

.pb-8px {
  padding-bottom: 8px !important;
}

.pb-9px {
  padding-bottom: 9px !important;
}

.pb-10px {
  padding-bottom: 10px !important;
}

.pb-5px {
  padding-bottom: 5px !important;
}

.pb-10px {
  padding-bottom: 10px !important;
}

.pb-15px {
  padding-bottom: 15px !important;
}

.pb-20px {
  padding-bottom: 20px !important;
}

.pb-25px {
  padding-bottom: 25px !important;
}

.pb-30px {
  padding-bottom: 30px !important;
}

.pb-35px {
  padding-bottom: 35px !important;
}

.pb-40px {
  padding-bottom: 40px !important;
}

.pb-45px {
  padding-bottom: 45px !important;
}

.pb-50px {
  padding-bottom: 50px !important;
}

.ps-1px {
  padding-left: 1px !important;
}

.ps-2px {
  padding-left: 2px !important;
}

.ps-3px {
  padding-left: 3px !important;
}

.ps-4px {
  padding-left: 4px !important;
}

.ps-5px {
  padding-left: 5px !important;
}

.ps-6px {
  padding-left: 6px !important;
}

.ps-7px {
  padding-left: 7px !important;
}

.ps-8px {
  padding-left: 8px !important;
}

.ps-9px {
  padding-left: 9px !important;
}

.ps-10px {
  padding-left: 10px !important;
}

.ps-5px {
  padding-left: 5px !important;
}

.ps-10px {
  padding-left: 10px !important;
}

.ps-15px {
  padding-left: 15px !important;
}

.ps-20px {
  padding-left: 20px !important;
}

.ps-25px {
  padding-left: 25px !important;
}

.ps-30px {
  padding-left: 30px !important;
}

.ps-35px {
  padding-left: 35px !important;
}

.ps-40px {
  padding-left: 40px !important;
}

.ps-45px {
  padding-left: 45px !important;
}

.ps-50px {
  padding-left: 50px !important;
}

.px-1px {
  padding-left: 1px !important;
  padding-right: 1px !important;
}

.px-2px {
  padding-left: 2px !important;
  padding-right: 2px !important;
}

.px-3px {
  padding-left: 3px !important;
  padding-right: 3px !important;
}

.px-4px {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.px-5px {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.px-6px {
  padding-left: 6px !important;
  padding-right: 6px !important;
}

.px-7px {
  padding-left: 7px !important;
  padding-right: 7px !important;
}

.px-8px {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.px-9px {
  padding-left: 9px !important;
  padding-right: 9px !important;
}

.px-10px {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.px-5px {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.px-10px {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.px-15px {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.px-20px {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.px-25px {
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.px-30px {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.px-35px {
  padding-left: 35px !important;
  padding-right: 35px !important;
}

.px-40px {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.px-45px {
  padding-left: 45px !important;
  padding-right: 45px !important;
}

.px-50px {
  padding-left: 50px !important;
  padding-right: 50px !important;
}

.py-1px {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

.py-2px {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.py-3px {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.py-4px {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.py-5px {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.py-6px {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}

.py-7px {
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}

.py-8px {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.py-9px {
  padding-top: 9px !important;
  padding-bottom: 9px !important;
}

.py-10px {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.py-5px {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.py-10px {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.py-15px {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.py-20px {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.py-25px {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
}

.py-30px {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}

.py-35px {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}

.py-40px {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.py-45px {
  padding-top: 45px !important;
  padding-bottom: 45px !important;
}

.py-50px {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

/* Helper Font */
.fs-0px {
  font-size: 0px !important;
}

.fs-1px {
  font-size: 1px !important;
}

.fs-2px {
  font-size: 2px !important;
}

.fs-3px {
  font-size: 3px !important;
}

.fs-4px {
  font-size: 4px !important;
}

.fs-5px {
  font-size: 5px !important;
}

.fs-6px {
  font-size: 6px !important;
}

.fs-7px {
  font-size: 7px !important;
}

.fs-8px {
  font-size: 8px !important;
}

.fs-9px {
  font-size: 9px !important;
}

.fs-10px {
  font-size: 10px !important;
}

.fs-11px {
  font-size: 11px !important;
}

.fs-12px {
  font-size: 12px !important;
}

.fs-13px {
  font-size: 13px !important;
}

.fs-14px {
  font-size: 14px !important;
}

.fs-15px {
  font-size: 15px !important;
}

.fs-16px {
  font-size: 16px !important;
}

.fs-17px {
  font-size: 17px !important;
}

.fs-18px {
  font-size: 18px !important;
}

.fs-19px {
  font-size: 19px !important;
}

.fs-20px {
  font-size: 20px !important;
}

.fs-21px {
  font-size: 21px !important;
}

.fs-22px {
  font-size: 22px !important;
}

.fs-23px {
  font-size: 23px !important;
}

.fs-24px {
  font-size: 24px !important;
}

.fs-25px {
  font-size: 25px !important;
}

.fs-26px {
  font-size: 26px !important;
}

.fs-27px {
  font-size: 27px !important;
}

.fs-28px {
  font-size: 28px !important;
}

.fs-29px {
  font-size: 29px !important;
}

.fs-30px {
  font-size: 30px !important;
}

.fs-31px {
  font-size: 31px !important;
}

.fs-32px {
  font-size: 32px !important;
}

.fs-33px {
  font-size: 33px !important;
}

.fs-34px {
  font-size: 34px !important;
}

.fs-35px {
  font-size: 35px !important;
}

.fs-36px {
  font-size: 36px !important;
}

.fs-37px {
  font-size: 37px !important;
}

.fs-38px {
  font-size: 38px !important;
}

.fs-39px {
  font-size: 39px !important;
}

.fs-40px {
  font-size: 40px !important;
}

.fs-41px {
  font-size: 41px !important;
}

.fs-42px {
  font-size: 42px !important;
}

.fs-43px {
  font-size: 43px !important;
}

.fs-44px {
  font-size: 44px !important;
}

.fs-45px {
  font-size: 45px !important;
}

.fs-46px {
  font-size: 46px !important;
}

.fs-47px {
  font-size: 47px !important;
}

.fs-48px {
  font-size: 48px !important;
}

.fs-49px {
  font-size: 49px !important;
}

.fs-50px {
  font-size: 50px !important;
}

.fs-51px {
  font-size: 51px !important;
}

.fs-52px {
  font-size: 52px !important;
}

.fs-53px {
  font-size: 53px !important;
}

.fs-54px {
  font-size: 54px !important;
}

.fs-55px {
  font-size: 55px !important;
}

.fs-56px {
  font-size: 56px !important;
}

.fs-57px {
  font-size: 57px !important;
}

.fs-58px {
  font-size: 58px !important;
}

.fs-59px {
  font-size: 59px !important;
}

.fs-60px {
  font-size: 60px !important;
}

.fs-61px {
  font-size: 61px !important;
}

.fs-62px {
  font-size: 62px !important;
}

.fs-63px {
  font-size: 63px !important;
}

.fs-64px {
  font-size: 64px !important;
}

.fs-65px {
  font-size: 65px !important;
}

.fs-66px {
  font-size: 66px !important;
}

.fs-67px {
  font-size: 67px !important;
}

.fs-68px {
  font-size: 68px !important;
}

.fs-69px {
  font-size: 69px !important;
}

.fs-70px {
  font-size: 70px !important;
}

.fs-71px {
  font-size: 71px !important;
}

.fs-72px {
  font-size: 72px !important;
}

.fs-73px {
  font-size: 73px !important;
}

.fs-74px {
  font-size: 74px !important;
}

.fs-75px {
  font-size: 75px !important;
}

.fs-76px {
  font-size: 76px !important;
}

.fs-77px {
  font-size: 77px !important;
}

.fs-78px {
  font-size: 78px !important;
}

.fs-79px {
  font-size: 79px !important;
}

.fs-80px {
  font-size: 80px !important;
}

.fw-100 {
  font-weight: 100 !important;
}

.fw-200 {
  font-weight: 200 !important;
}

.fw-300 {
  font-weight: 300 !important;
}

.fw-400 {
  font-weight: 400 !important;
}

.fw-500 {
  font-weight: 500 !important;
}

.fw-600 {
  font-weight: 600 !important;
}

.fw-700 {
  font-weight: 700 !important;
}

.fw-800 {
  font-weight: 800 !important;
}

/* Helper Position Direction */
.top-0 {
  top: 0 !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.start-0 {
  left: 0 !important;
}

.end-0 {
  right: 0 !important;
}

.top-auto {
  top: auto !important;
}

.bottom-auto {
  bottom: auto !important;
}

.start-auto {
  left: auto !important;
}

.end-auto {
  right: auto !important;
}

/* Helper Text */
.text-underline {
  text-decoration: underline !important;
}

.text-gradient {
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.line-height-1 {
  line-height: 1 !important;
}

/* Helper Size */
.w-5px {
  width: 5px !important;
}

.w-1px {
  width: 1px !important;
}

.w-10px {
  width: 10px !important;
}

.w-2px {
  width: 2px !important;
}

.w-15px {
  width: 15px !important;
}

.w-3px {
  width: 3px !important;
}

.w-20px {
  width: 20px !important;
}

.w-4px {
  width: 4px !important;
}

.w-25px {
  width: 25px !important;
}

.w-5px {
  width: 5px !important;
}

.w-30px {
  width: 30px !important;
}

.w-6px {
  width: 6px !important;
}

.w-35px {
  width: 35px !important;
}

.w-7px {
  width: 7px !important;
}

.w-40px {
  width: 40px !important;
}

.w-8px {
  width: 8px !important;
}

.w-45px {
  width: 45px !important;
}

.w-9px {
  width: 9px !important;
}

.w-50px {
  width: 50px !important;
}

.w-10px {
  width: 10px !important;
}

.w-55px {
  width: 55px !important;
}

.w-11px {
  width: 11px !important;
}

.w-60px {
  width: 60px !important;
}

.w-12px {
  width: 12px !important;
}

.w-65px {
  width: 65px !important;
}

.w-13px {
  width: 13px !important;
}

.w-70px {
  width: 70px !important;
}

.w-14px {
  width: 14px !important;
}

.w-75px {
  width: 75px !important;
}

.w-15px {
  width: 15px !important;
}

.w-80px {
  width: 80px !important;
}

.w-16px {
  width: 16px !important;
}

.w-85px {
  width: 85px !important;
}

.w-17px {
  width: 17px !important;
}

.w-90px {
  width: 90px !important;
}

.w-18px {
  width: 18px !important;
}

.w-95px {
  width: 95px !important;
}

.w-19px {
  width: 19px !important;
}

.w-100px {
  width: 100px !important;
}

.w-20px {
  width: 20px !important;
}

.w-105px {
  width: 105px !important;
}

.w-21px {
  width: 21px !important;
}

.w-110px {
  width: 110px !important;
}

.w-22px {
  width: 22px !important;
}

.w-115px {
  width: 115px !important;
}

.w-23px {
  width: 23px !important;
}

.w-120px {
  width: 120px !important;
}

.w-24px {
  width: 24px !important;
}

.w-125px {
  width: 125px !important;
}

.w-25px {
  width: 25px !important;
}

.w-130px {
  width: 130px !important;
}

.w-26px {
  width: 26px !important;
}

.w-135px {
  width: 135px !important;
}

.w-27px {
  width: 27px !important;
}

.w-140px {
  width: 140px !important;
}

.w-28px {
  width: 28px !important;
}

.w-145px {
  width: 145px !important;
}

.w-29px {
  width: 29px !important;
}

.w-150px {
  width: 150px !important;
}

.w-30px {
  width: 30px !important;
}

.w-155px {
  width: 155px !important;
}

.w-31px {
  width: 31px !important;
}

.w-160px {
  width: 160px !important;
}

.w-32px {
  width: 32px !important;
}

.w-165px {
  width: 165px !important;
}

.w-33px {
  width: 33px !important;
}

.w-170px {
  width: 170px !important;
}

.w-34px {
  width: 34px !important;
}

.w-175px {
  width: 175px !important;
}

.w-35px {
  width: 35px !important;
}

.w-180px {
  width: 180px !important;
}

.w-36px {
  width: 36px !important;
}

.w-185px {
  width: 185px !important;
}

.w-37px {
  width: 37px !important;
}

.w-190px {
  width: 190px !important;
}

.w-38px {
  width: 38px !important;
}

.w-195px {
  width: 195px !important;
}

.w-39px {
  width: 39px !important;
}

.w-200px {
  width: 200px !important;
}

.w-40px {
  width: 40px !important;
}

.w-250px {
  width: 250px !important;
}

.w-300px {
  width: 300px !important;
}

.w-350px {
  width: 350px !important;
}

.w-400px {
  width: 400px !important;
}

.w-450px {
  width: 450px !important;
}

.w-500px {
  width: 500px !important;
}

.w-550px {
  width: 550px !important;
}

.w-600px {
  width: 600px !important;
}

.h-5px {
  height: 5px !important;
}

.h-1px {
  height: 1px !important;
}

.h-10px {
  height: 10px !important;
}

.h-2px {
  height: 2px !important;
}

.h-15px {
  height: 15px !important;
}

.h-3px {
  height: 3px !important;
}

.h-20px {
  height: 20px !important;
}

.h-4px {
  height: 4px !important;
}

.h-25px {
  height: 25px !important;
}

.h-5px {
  height: 5px !important;
}

.h-30px {
  height: 30px !important;
}

.h-6px {
  height: 6px !important;
}

.h-35px {
  height: 35px !important;
}

.h-7px {
  height: 7px !important;
}

.h-40px {
  height: 40px !important;
}

.h-8px {
  height: 8px !important;
}

.h-45px {
  height: 45px !important;
}

.h-9px {
  height: 9px !important;
}

.h-50px {
  height: 50px !important;
}

.h-10px {
  height: 10px !important;
}

.h-55px {
  height: 55px !important;
}

.h-11px {
  height: 11px !important;
}

.h-60px {
  height: 60px !important;
}

.h-12px {
  height: 12px !important;
}

.h-65px {
  height: 65px !important;
}

.h-13px {
  height: 13px !important;
}

.h-70px {
  height: 70px !important;
}

.h-14px {
  height: 14px !important;
}

.h-75px {
  height: 75px !important;
}

.h-15px {
  height: 15px !important;
}

.h-80px {
  height: 80px !important;
}

.h-16px {
  height: 16px !important;
}

.h-85px {
  height: 85px !important;
}

.h-17px {
  height: 17px !important;
}

.h-90px {
  height: 90px !important;
}

.h-18px {
  height: 18px !important;
}

.h-95px {
  height: 95px !important;
}

.h-19px {
  height: 19px !important;
}

.h-100px {
  height: 100px !important;
}

.h-20px {
  height: 20px !important;
}

.h-105px {
  height: 105px !important;
}

.h-21px {
  height: 21px !important;
}

.h-110px {
  height: 110px !important;
}

.h-22px {
  height: 22px !important;
}

.h-115px {
  height: 115px !important;
}

.h-23px {
  height: 23px !important;
}

.h-120px {
  height: 120px !important;
}

.h-24px {
  height: 24px !important;
}

.h-125px {
  height: 125px !important;
}

.h-25px {
  height: 25px !important;
}

.h-130px {
  height: 130px !important;
}

.h-26px {
  height: 26px !important;
}

.h-135px {
  height: 135px !important;
}

.h-27px {
  height: 27px !important;
}

.h-140px {
  height: 140px !important;
}

.h-28px {
  height: 28px !important;
}

.h-145px {
  height: 145px !important;
}

.h-29px {
  height: 29px !important;
}

.h-150px {
  height: 150px !important;
}

.h-30px {
  height: 30px !important;
}

.h-155px {
  height: 155px !important;
}

.h-31px {
  height: 31px !important;
}

.h-160px {
  height: 160px !important;
}

.h-32px {
  height: 32px !important;
}

.h-165px {
  height: 165px !important;
}

.h-33px {
  height: 33px !important;
}

.h-170px {
  height: 170px !important;
}

.h-34px {
  height: 34px !important;
}

.h-175px {
  height: 175px !important;
}

.h-35px {
  height: 35px !important;
}

.h-180px {
  height: 180px !important;
}

.h-36px {
  height: 36px !important;
}

.h-185px {
  height: 185px !important;
}

.h-37px {
  height: 37px !important;
}

.h-190px {
  height: 190px !important;
}

.h-38px {
  height: 38px !important;
}

.h-195px {
  height: 195px !important;
}

.h-39px {
  height: 39px !important;
}

.h-200px {
  height: 200px !important;
}

.h-40px {
  height: 40px !important;
}

.h-250px {
  height: 250px !important;
}

.h-300px {
  height: 300px !important;
}

.h-350px {
  height: 350px !important;
}

.h-400px {
  height: 400px !important;
}

.h-450px {
  height: 450px !important;
}

.h-500px {
  height: 500px !important;
}

.h-550px {
  height: 550px !important;
}

.h-600px {
  height: 600px !important;
}

/* Helper Color */
.bg-gradient-default {
  background-color: rgb(120.7, 141.95, 152.15) !important;
  background-image: linear-gradient(to bottom, rgb(149.5817204301, 166.261827957, 174.2682795699), rgb(107.273655914, 129.4376344086, 140.076344086)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-default {
  --bs-theme: rgb(120.7, 141.95, 152.15) !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-default-100 {
  --bs-text-opacity: 1;
  color: rgba(228.14, 232.39, 234.43, var(--bs-text-opacity)) !important;
}

.bg-default-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228.14, 232.39, 234.43, var(--bs-bg-opacity)) !important;
}

.text-default-600 {
  --bs-text-opacity: 1;
  color: rgba(96.56, 113.56, 121.72, var(--bs-text-opacity)) !important;
}

.bg-default-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(96.56, 113.56, 121.72, var(--bs-bg-opacity)) !important;
}

.text-default-200 {
  --bs-text-opacity: 1;
  color: rgba(201.28, 209.78, 213.86, var(--bs-text-opacity)) !important;
}

.bg-default-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201.28, 209.78, 213.86, var(--bs-bg-opacity)) !important;
}

.text-default-700 {
  --bs-text-opacity: 1;
  color: rgba(72.42, 85.17, 91.29, var(--bs-text-opacity)) !important;
}

.bg-default-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(72.42, 85.17, 91.29, var(--bs-bg-opacity)) !important;
}

.text-default-300 {
  --bs-text-opacity: 1;
  color: rgba(174.42, 187.17, 193.29, var(--bs-text-opacity)) !important;
}

.bg-default-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.42, 187.17, 193.29, var(--bs-bg-opacity)) !important;
}

.text-default-800 {
  --bs-text-opacity: 1;
  color: rgba(48.28, 56.78, 60.86, var(--bs-text-opacity)) !important;
}

.bg-default-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48.28, 56.78, 60.86, var(--bs-bg-opacity)) !important;
}

.text-default-400 {
  --bs-text-opacity: 1;
  color: rgba(147.56, 164.56, 172.72, var(--bs-text-opacity)) !important;
}

.bg-default-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(147.56, 164.56, 172.72, var(--bs-bg-opacity)) !important;
}

.text-default-900 {
  --bs-text-opacity: 1;
  color: rgba(24.14, 28.39, 30.43, var(--bs-text-opacity)) !important;
}

.bg-default-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24.14, 28.39, 30.43, var(--bs-bg-opacity)) !important;
}

.bg-gradient-theme {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, rgb(45.5129533679, 198.4870466321, 152.9740932642), rgb(31.2435233161, 136.2564766839, 105.0129533679)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

.border-theme {
  border-color: var(--bs-theme) !important;
}

:root .theme-theme {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-theme-100 {
  --bs-text-opacity: 1;
  color: rgba(211.2, 235.4, 228.2, var(--bs-text-opacity)) !important;
}

.bg-theme-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211.2, 235.4, 228.2, var(--bs-bg-opacity)) !important;
}

.text-theme-600 {
  --bs-text-opacity: 1;
  color: rgba(28.8, 125.6, 96.8, var(--bs-text-opacity)) !important;
}

.bg-theme-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.8, 125.6, 96.8, var(--bs-bg-opacity)) !important;
}

.text-theme-200 {
  --bs-text-opacity: 1;
  color: rgba(167.4, 215.8, 201.4, var(--bs-text-opacity)) !important;
}

.bg-theme-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167.4, 215.8, 201.4, var(--bs-bg-opacity)) !important;
}

.text-theme-700 {
  --bs-text-opacity: 1;
  color: rgba(21.6, 94.2, 72.6, var(--bs-text-opacity)) !important;
}

.bg-theme-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.6, 94.2, 72.6, var(--bs-bg-opacity)) !important;
}

.text-theme-300 {
  --bs-text-opacity: 1;
  color: rgba(123.6, 196.2, 174.6, var(--bs-text-opacity)) !important;
}

.bg-theme-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(123.6, 196.2, 174.6, var(--bs-bg-opacity)) !important;
}

.text-theme-800 {
  --bs-text-opacity: 1;
  color: rgba(14.4, 62.8, 48.4, var(--bs-text-opacity)) !important;
}

.bg-theme-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14.4, 62.8, 48.4, var(--bs-bg-opacity)) !important;
}

.text-theme-400 {
  --bs-text-opacity: 1;
  color: rgba(79.8, 176.6, 147.8, var(--bs-text-opacity)) !important;
}

.bg-theme-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(79.8, 176.6, 147.8, var(--bs-bg-opacity)) !important;
}

.text-theme-900 {
  --bs-text-opacity: 1;
  color: rgba(7.2, 31.4, 24.2, var(--bs-text-opacity)) !important;
}

.bg-theme-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7.2, 31.4, 24.2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-theme-color {
  background-color: #FFFFFF !important;
  background-image: linear-gradient(to bottom, white, rgb(242.25, 242.25, 242.25)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-theme-color {
  --bs-theme: #FFFFFF !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-theme-color-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-theme-color-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-theme-color-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-theme-color-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-theme-color-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-theme-color-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-theme-color-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-theme-color-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-theme-color-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-theme-color-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-primary {
  background-color: #0271ff !important;
  background-image: linear-gradient(to bottom, rgb(53, 141.6245059289, 255), rgb(0, 101.5671936759, 231.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-primary {
  --bs-theme: #0271ff !important;
  --bs-theme-rgb: 2, 113, 255 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-primary-100 {
  --bs-text-opacity: 1;
  color: rgba(204.4, 226.6, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.4, 226.6, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-600 {
  --bs-text-opacity: 1;
  color: rgba(1.6, 90.4, 204, var(--bs-text-opacity)) !important;
}

.bg-primary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(1.6, 90.4, 204, var(--bs-bg-opacity)) !important;
}

.text-primary-200 {
  --bs-text-opacity: 1;
  color: rgba(153.8, 198.2, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153.8, 198.2, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-700 {
  --bs-text-opacity: 1;
  color: rgba(1.2, 67.8, 153, var(--bs-text-opacity)) !important;
}

.bg-primary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(1.2, 67.8, 153, var(--bs-bg-opacity)) !important;
}

.text-primary-300 {
  --bs-text-opacity: 1;
  color: rgba(103.2, 169.8, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(103.2, 169.8, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-800 {
  --bs-text-opacity: 1;
  color: rgba(0.8, 45.2, 102, var(--bs-text-opacity)) !important;
}

.bg-primary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0.8, 45.2, 102, var(--bs-bg-opacity)) !important;
}

.text-primary-400 {
  --bs-text-opacity: 1;
  color: rgba(52.6, 141.4, 255, var(--bs-text-opacity)) !important;
}

.bg-primary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(52.6, 141.4, 255, var(--bs-bg-opacity)) !important;
}

.text-primary-900 {
  --bs-text-opacity: 1;
  color: rgba(0.4, 22.6, 51, var(--bs-text-opacity)) !important;
}

.bg-primary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0.4, 22.6, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-secondary {
  background-color: rgb(120.7, 141.95, 152.15) !important;
  background-image: linear-gradient(to bottom, rgb(149.5817204301, 166.261827957, 174.2682795699), rgb(107.273655914, 129.4376344086, 140.076344086)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-secondary {
  --bs-theme: rgb(120.7, 141.95, 152.15) !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-secondary-100 {
  --bs-text-opacity: 1;
  color: rgba(228.14, 232.39, 234.43, var(--bs-text-opacity)) !important;
}

.bg-secondary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228.14, 232.39, 234.43, var(--bs-bg-opacity)) !important;
}

.text-secondary-600 {
  --bs-text-opacity: 1;
  color: rgba(96.56, 113.56, 121.72, var(--bs-text-opacity)) !important;
}

.bg-secondary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(96.56, 113.56, 121.72, var(--bs-bg-opacity)) !important;
}

.text-secondary-200 {
  --bs-text-opacity: 1;
  color: rgba(201.28, 209.78, 213.86, var(--bs-text-opacity)) !important;
}

.bg-secondary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201.28, 209.78, 213.86, var(--bs-bg-opacity)) !important;
}

.text-secondary-700 {
  --bs-text-opacity: 1;
  color: rgba(72.42, 85.17, 91.29, var(--bs-text-opacity)) !important;
}

.bg-secondary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(72.42, 85.17, 91.29, var(--bs-bg-opacity)) !important;
}

.text-secondary-300 {
  --bs-text-opacity: 1;
  color: rgba(174.42, 187.17, 193.29, var(--bs-text-opacity)) !important;
}

.bg-secondary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.42, 187.17, 193.29, var(--bs-bg-opacity)) !important;
}

.text-secondary-800 {
  --bs-text-opacity: 1;
  color: rgba(48.28, 56.78, 60.86, var(--bs-text-opacity)) !important;
}

.bg-secondary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48.28, 56.78, 60.86, var(--bs-bg-opacity)) !important;
}

.text-secondary-400 {
  --bs-text-opacity: 1;
  color: rgba(147.56, 164.56, 172.72, var(--bs-text-opacity)) !important;
}

.bg-secondary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(147.56, 164.56, 172.72, var(--bs-bg-opacity)) !important;
}

.text-secondary-900 {
  --bs-text-opacity: 1;
  color: rgba(24.14, 28.39, 30.43, var(--bs-text-opacity)) !important;
}

.bg-secondary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24.14, 28.39, 30.43, var(--bs-bg-opacity)) !important;
}

.bg-gradient-warning {
  background-color: #ff9f0c !important;
  background-image: linear-gradient(to bottom, rgb(255, 179.1481481481, 63), rgb(241.5, 146.0925925926, 0)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-warning {
  --bs-theme: #ff9f0c !important;
  --bs-theme-rgb: 255, 159, 12 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-warning-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 235.8, 206.4, var(--bs-text-opacity)) !important;
}

.bg-warning-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 235.8, 206.4, var(--bs-bg-opacity)) !important;
}

.text-warning-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 127.2, 9.6, var(--bs-text-opacity)) !important;
}

.bg-warning-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 127.2, 9.6, var(--bs-bg-opacity)) !important;
}

.text-warning-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 216.6, 157.8, var(--bs-text-opacity)) !important;
}

.bg-warning-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 216.6, 157.8, var(--bs-bg-opacity)) !important;
}

.text-warning-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 95.4, 7.2, var(--bs-text-opacity)) !important;
}

.bg-warning-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 95.4, 7.2, var(--bs-bg-opacity)) !important;
}

.text-warning-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 197.4, 109.2, var(--bs-text-opacity)) !important;
}

.bg-warning-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 197.4, 109.2, var(--bs-bg-opacity)) !important;
}

.text-warning-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 63.6, 4.8, var(--bs-text-opacity)) !important;
}

.bg-warning-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 63.6, 4.8, var(--bs-bg-opacity)) !important;
}

.text-warning-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 178.2, 60.6, var(--bs-text-opacity)) !important;
}

.bg-warning-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 178.2, 60.6, var(--bs-bg-opacity)) !important;
}

.text-warning-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 31.8, 2.4, var(--bs-text-opacity)) !important;
}

.bg-warning-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 31.8, 2.4, var(--bs-bg-opacity)) !important;
}

.bg-gradient-danger {
  background-color: #e00000 !important;
  background-image: linear-gradient(to bottom, #ff1414, rgb(198.5, 0, 0)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-danger {
  --bs-theme: #e00000 !important;
  --bs-theme-rgb: 224, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-danger-100 {
  --bs-text-opacity: 1;
  color: rgba(248.8, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-danger-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(248.8, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-danger-600 {
  --bs-text-opacity: 1;
  color: rgba(179.2, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(179.2, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-danger-200 {
  --bs-text-opacity: 1;
  color: rgba(242.6, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-danger-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.6, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-danger-700 {
  --bs-text-opacity: 1;
  color: rgba(134.4, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.4, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-danger-300 {
  --bs-text-opacity: 1;
  color: rgba(236.4, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-danger-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(236.4, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-danger-800 {
  --bs-text-opacity: 1;
  color: rgba(89.6, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(89.6, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-danger-400 {
  --bs-text-opacity: 1;
  color: rgba(230.2, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-danger-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(230.2, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-danger-900 {
  --bs-text-opacity: 1;
  color: rgba(44.8, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-danger-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(44.8, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-success {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, rgb(45.5129533679, 198.4870466321, 152.9740932642), rgb(31.2435233161, 136.2564766839, 105.0129533679)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-success {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-success-100 {
  --bs-text-opacity: 1;
  color: rgba(211.2, 235.4, 228.2, var(--bs-text-opacity)) !important;
}

.bg-success-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211.2, 235.4, 228.2, var(--bs-bg-opacity)) !important;
}

.text-success-600 {
  --bs-text-opacity: 1;
  color: rgba(28.8, 125.6, 96.8, var(--bs-text-opacity)) !important;
}

.bg-success-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.8, 125.6, 96.8, var(--bs-bg-opacity)) !important;
}

.text-success-200 {
  --bs-text-opacity: 1;
  color: rgba(167.4, 215.8, 201.4, var(--bs-text-opacity)) !important;
}

.bg-success-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167.4, 215.8, 201.4, var(--bs-bg-opacity)) !important;
}

.text-success-700 {
  --bs-text-opacity: 1;
  color: rgba(21.6, 94.2, 72.6, var(--bs-text-opacity)) !important;
}

.bg-success-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.6, 94.2, 72.6, var(--bs-bg-opacity)) !important;
}

.text-success-300 {
  --bs-text-opacity: 1;
  color: rgba(123.6, 196.2, 174.6, var(--bs-text-opacity)) !important;
}

.bg-success-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(123.6, 196.2, 174.6, var(--bs-bg-opacity)) !important;
}

.text-success-800 {
  --bs-text-opacity: 1;
  color: rgba(14.4, 62.8, 48.4, var(--bs-text-opacity)) !important;
}

.bg-success-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14.4, 62.8, 48.4, var(--bs-bg-opacity)) !important;
}

.text-success-400 {
  --bs-text-opacity: 1;
  color: rgba(79.8, 176.6, 147.8, var(--bs-text-opacity)) !important;
}

.bg-success-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(79.8, 176.6, 147.8, var(--bs-bg-opacity)) !important;
}

.text-success-900 {
  --bs-text-opacity: 1;
  color: rgba(7.2, 31.4, 24.2, var(--bs-text-opacity)) !important;
}

.bg-success-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7.2, 31.4, 24.2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-inverse {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, rgb(25.5, 25.5, 25.5), black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-inverse {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-inverse-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-inverse-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-inverse-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-inverse-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-inverse-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-inverse-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-inverse-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-inverse-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-inverse-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-inverse-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-inverse-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-inverse-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-inverse-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-info {
  background-color: #009be3 !important;
  background-image: linear-gradient(to bottom, rgb(23, 181.4140969163, 255), rgb(0, 137.5881057269, 201.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-info {
  --bs-theme: #009be3 !important;
  --bs-theme-rgb: 0, 155, 227 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-info-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 235, 249.4, var(--bs-text-opacity)) !important;
}

.bg-info-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 235, 249.4, var(--bs-bg-opacity)) !important;
}

.text-info-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 124, 181.6, var(--bs-text-opacity)) !important;
}

.bg-info-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 124, 181.6, var(--bs-bg-opacity)) !important;
}

.text-info-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 215, 243.8, var(--bs-text-opacity)) !important;
}

.bg-info-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 215, 243.8, var(--bs-bg-opacity)) !important;
}

.text-info-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 93, 136.2, var(--bs-text-opacity)) !important;
}

.bg-info-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 93, 136.2, var(--bs-bg-opacity)) !important;
}

.text-info-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 195, 238.2, var(--bs-text-opacity)) !important;
}

.bg-info-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 195, 238.2, var(--bs-bg-opacity)) !important;
}

.text-info-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 62, 90.8, var(--bs-text-opacity)) !important;
}

.bg-info-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 62, 90.8, var(--bs-bg-opacity)) !important;
}

.text-info-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 175, 232.6, var(--bs-text-opacity)) !important;
}

.bg-info-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 175, 232.6, var(--bs-bg-opacity)) !important;
}

.text-info-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 31, 45.4, var(--bs-text-opacity)) !important;
}

.bg-info-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 31, 45.4, var(--bs-bg-opacity)) !important;
}

.bg-gradient-dark {
  background-color: rgb(53.35, 67.1, 73.7) !important;
  background-image: linear-gradient(to bottom, rgb(74.7655844156, 94.0350649351, 103.2844155844), rgb(42.6422077922, 53.6324675325, 58.9077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-dark {
  --bs-theme: rgb(53.35, 67.1, 73.7) !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-dark-100 {
  --bs-text-opacity: 1;
  color: rgba(214.67, 217.42, 218.74, var(--bs-text-opacity)) !important;
}

.bg-dark-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(214.67, 217.42, 218.74, var(--bs-bg-opacity)) !important;
}

.text-dark-600 {
  --bs-text-opacity: 1;
  color: rgba(42.68, 53.68, 58.96, var(--bs-text-opacity)) !important;
}

.bg-dark-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42.68, 53.68, 58.96, var(--bs-bg-opacity)) !important;
}

.text-dark-200 {
  --bs-text-opacity: 1;
  color: rgba(174.34, 179.84, 182.48, var(--bs-text-opacity)) !important;
}

.bg-dark-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.34, 179.84, 182.48, var(--bs-bg-opacity)) !important;
}

.text-dark-700 {
  --bs-text-opacity: 1;
  color: rgba(32.01, 40.26, 44.22, var(--bs-text-opacity)) !important;
}

.bg-dark-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.01, 40.26, 44.22, var(--bs-bg-opacity)) !important;
}

.text-dark-300 {
  --bs-text-opacity: 1;
  color: rgba(134.01, 142.26, 146.22, var(--bs-text-opacity)) !important;
}

.bg-dark-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.01, 142.26, 146.22, var(--bs-bg-opacity)) !important;
}

.text-dark-800 {
  --bs-text-opacity: 1;
  color: rgba(21.34, 26.84, 29.48, var(--bs-text-opacity)) !important;
}

.bg-dark-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.34, 26.84, 29.48, var(--bs-bg-opacity)) !important;
}

.text-dark-400 {
  --bs-text-opacity: 1;
  color: rgba(93.68, 104.68, 109.96, var(--bs-text-opacity)) !important;
}

.bg-dark-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93.68, 104.68, 109.96, var(--bs-bg-opacity)) !important;
}

.text-dark-900 {
  --bs-text-opacity: 1;
  color: rgba(10.67, 13.42, 14.74, var(--bs-text-opacity)) !important;
}

.bg-dark-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(10.67, 13.42, 14.74, var(--bs-bg-opacity)) !important;
}

.bg-gradient-black {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, rgb(25.5, 25.5, 25.5), black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-black {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-black-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-black-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-black-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-black-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-black-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-black-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-black-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-black-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-black-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-white {
  background-color: #FFFFFF !important;
  background-image: linear-gradient(to bottom, white, rgb(242.25, 242.25, 242.25)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-white {
  --bs-theme: #FFFFFF !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-white-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-white-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-white-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-white-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-white-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-white-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-white-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-white-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-purple {
  background-color: #b90dff !important;
  background-image: linear-gradient(to bottom, rgb(199.7520661157, 64, 255), rgb(172.3553719008, 0, 242.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-purple {
  --bs-theme: #b90dff !important;
  --bs-theme-rgb: 185, 13, 255 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(241, 206.6, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(241, 206.6, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-600 {
  --bs-text-opacity: 1;
  color: rgba(148, 10.4, 204, var(--bs-text-opacity)) !important;
}

.bg-purple-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 10.4, 204, var(--bs-bg-opacity)) !important;
}

.text-purple-200 {
  --bs-text-opacity: 1;
  color: rgba(227, 158.2, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(227, 158.2, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-700 {
  --bs-text-opacity: 1;
  color: rgba(111, 7.8, 153, var(--bs-text-opacity)) !important;
}

.bg-purple-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(111, 7.8, 153, var(--bs-bg-opacity)) !important;
}

.text-purple-300 {
  --bs-text-opacity: 1;
  color: rgba(213, 109.8, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(213, 109.8, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-800 {
  --bs-text-opacity: 1;
  color: rgba(74, 5.2, 102, var(--bs-text-opacity)) !important;
}

.bg-purple-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(74, 5.2, 102, var(--bs-bg-opacity)) !important;
}

.text-purple-400 {
  --bs-text-opacity: 1;
  color: rgba(199, 61.4, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 61.4, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-900 {
  --bs-text-opacity: 1;
  color: rgba(37, 2.6, 51, var(--bs-text-opacity)) !important;
}

.bg-purple-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 2.6, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-indigo {
  background-color: #5c25ff !important;
  background-image: linear-gradient(to bottom, rgb(130.1330275229, 88, 255), rgb(72.9334862385, 11.5, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-indigo {
  --bs-theme: #5c25ff !important;
  --bs-theme-rgb: 92, 37, 255 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-indigo-100 {
  --bs-text-opacity: 1;
  color: rgba(222.4, 211.4, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(222.4, 211.4, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-600 {
  --bs-text-opacity: 1;
  color: rgba(73.6, 29.6, 204, var(--bs-text-opacity)) !important;
}

.bg-indigo-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(73.6, 29.6, 204, var(--bs-bg-opacity)) !important;
}

.text-indigo-200 {
  --bs-text-opacity: 1;
  color: rgba(189.8, 167.8, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(189.8, 167.8, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-700 {
  --bs-text-opacity: 1;
  color: rgba(55.2, 22.2, 153, var(--bs-text-opacity)) !important;
}

.bg-indigo-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(55.2, 22.2, 153, var(--bs-bg-opacity)) !important;
}

.text-indigo-300 {
  --bs-text-opacity: 1;
  color: rgba(157.2, 124.2, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(157.2, 124.2, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-800 {
  --bs-text-opacity: 1;
  color: rgba(36.8, 14.8, 102, var(--bs-text-opacity)) !important;
}

.bg-indigo-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(36.8, 14.8, 102, var(--bs-bg-opacity)) !important;
}

.text-indigo-400 {
  --bs-text-opacity: 1;
  color: rgba(124.6, 80.6, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(124.6, 80.6, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-900 {
  --bs-text-opacity: 1;
  color: rgba(18.4, 7.4, 51, var(--bs-text-opacity)) !important;
}

.bg-indigo-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(18.4, 7.4, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-red {
  background-color: #e00000 !important;
  background-image: linear-gradient(to bottom, #ff1414, rgb(198.5, 0, 0)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-red {
  --bs-theme: #e00000 !important;
  --bs-theme-rgb: 224, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-red-100 {
  --bs-text-opacity: 1;
  color: rgba(248.8, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-red-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(248.8, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-red-600 {
  --bs-text-opacity: 1;
  color: rgba(179.2, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(179.2, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-200 {
  --bs-text-opacity: 1;
  color: rgba(242.6, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-red-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.6, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-red-700 {
  --bs-text-opacity: 1;
  color: rgba(134.4, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.4, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-300 {
  --bs-text-opacity: 1;
  color: rgba(236.4, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-red-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(236.4, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-red-800 {
  --bs-text-opacity: 1;
  color: rgba(89.6, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(89.6, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-400 {
  --bs-text-opacity: 1;
  color: rgba(230.2, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-red-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(230.2, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-red-900 {
  --bs-text-opacity: 1;
  color: rgba(44.8, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(44.8, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-pink {
  background-color: #e61079 !important;
  background-image: linear-gradient(to bottom, rgb(241.1463414634, 55.8536585366, 146.7682926829), rgb(206.1585365854, 14.3414634146, 108.4573170732)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-pink {
  --bs-theme: #e61079 !important;
  --bs-theme-rgb: 230, 16, 121 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-pink-100 {
  --bs-text-opacity: 1;
  color: rgba(250, 207.2, 228.2, var(--bs-text-opacity)) !important;
}

.bg-pink-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 207.2, 228.2, var(--bs-bg-opacity)) !important;
}

.text-pink-600 {
  --bs-text-opacity: 1;
  color: rgba(184, 12.8, 96.8, var(--bs-text-opacity)) !important;
}

.bg-pink-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(184, 12.8, 96.8, var(--bs-bg-opacity)) !important;
}

.text-pink-200 {
  --bs-text-opacity: 1;
  color: rgba(245, 159.4, 201.4, var(--bs-text-opacity)) !important;
}

.bg-pink-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(245, 159.4, 201.4, var(--bs-bg-opacity)) !important;
}

.text-pink-700 {
  --bs-text-opacity: 1;
  color: rgba(138, 9.6, 72.6, var(--bs-text-opacity)) !important;
}

.bg-pink-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 9.6, 72.6, var(--bs-bg-opacity)) !important;
}

.text-pink-300 {
  --bs-text-opacity: 1;
  color: rgba(240, 111.6, 174.6, var(--bs-text-opacity)) !important;
}

.bg-pink-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(240, 111.6, 174.6, var(--bs-bg-opacity)) !important;
}

.text-pink-800 {
  --bs-text-opacity: 1;
  color: rgba(92, 6.4, 48.4, var(--bs-text-opacity)) !important;
}

.bg-pink-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(92, 6.4, 48.4, var(--bs-bg-opacity)) !important;
}

.text-pink-400 {
  --bs-text-opacity: 1;
  color: rgba(235, 63.8, 147.8, var(--bs-text-opacity)) !important;
}

.bg-pink-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(235, 63.8, 147.8, var(--bs-bg-opacity)) !important;
}

.text-pink-900 {
  --bs-text-opacity: 1;
  color: rgba(46, 3.2, 24.2, var(--bs-text-opacity)) !important;
}

.bg-pink-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(46, 3.2, 24.2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-green {
  background-color: #148922 !important;
  background-image: linear-gradient(to bottom, rgb(26.4968152866, 181.5031847134, 45.0445859873), rgb(16.7515923567, 114.7484076433, 28.4777070064)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-green {
  --bs-theme: #148922 !important;
  --bs-theme-rgb: 20, 137, 34 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-green-100 {
  --bs-text-opacity: 1;
  color: rgba(208, 231.4, 210.8, var(--bs-text-opacity)) !important;
}

.bg-green-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(208, 231.4, 210.8, var(--bs-bg-opacity)) !important;
}

.text-green-600 {
  --bs-text-opacity: 1;
  color: rgba(16, 109.6, 27.2, var(--bs-text-opacity)) !important;
}

.bg-green-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 109.6, 27.2, var(--bs-bg-opacity)) !important;
}

.text-green-200 {
  --bs-text-opacity: 1;
  color: rgba(161, 207.8, 166.6, var(--bs-text-opacity)) !important;
}

.bg-green-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(161, 207.8, 166.6, var(--bs-bg-opacity)) !important;
}

.text-green-700 {
  --bs-text-opacity: 1;
  color: rgba(12, 82.2, 20.4, var(--bs-text-opacity)) !important;
}

.bg-green-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 82.2, 20.4, var(--bs-bg-opacity)) !important;
}

.text-green-300 {
  --bs-text-opacity: 1;
  color: rgba(114, 184.2, 122.4, var(--bs-text-opacity)) !important;
}

.bg-green-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(114, 184.2, 122.4, var(--bs-bg-opacity)) !important;
}

.text-green-800 {
  --bs-text-opacity: 1;
  color: rgba(8, 54.8, 13.6, var(--bs-text-opacity)) !important;
}

.bg-green-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(8, 54.8, 13.6, var(--bs-bg-opacity)) !important;
}

.text-green-400 {
  --bs-text-opacity: 1;
  color: rgba(67, 160.6, 78.2, var(--bs-text-opacity)) !important;
}

.bg-green-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 160.6, 78.2, var(--bs-bg-opacity)) !important;
}

.text-green-900 {
  --bs-text-opacity: 1;
  color: rgba(4, 27.4, 6.8, var(--bs-text-opacity)) !important;
}

.bg-green-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(4, 27.4, 6.8, var(--bs-bg-opacity)) !important;
}

.bg-gradient-yellow {
  background-color: #f9e80d !important;
  background-image: linear-gradient(to bottom, rgb(250.2338709677, 236.7298387097, 62.7661290323), rgb(230.7782258065, 214.5665322581, 5.7217741935)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-yellow {
  --bs-theme: #f9e80d !important;
  --bs-theme-rgb: 249, 232, 13 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-yellow-100 {
  --bs-text-opacity: 1;
  color: rgba(253.8, 250.4, 206.6, var(--bs-text-opacity)) !important;
}

.bg-yellow-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(253.8, 250.4, 206.6, var(--bs-bg-opacity)) !important;
}

.text-yellow-600 {
  --bs-text-opacity: 1;
  color: rgba(199.2, 185.6, 10.4, var(--bs-text-opacity)) !important;
}

.bg-yellow-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(199.2, 185.6, 10.4, var(--bs-bg-opacity)) !important;
}

.text-yellow-200 {
  --bs-text-opacity: 1;
  color: rgba(252.6, 245.8, 158.2, var(--bs-text-opacity)) !important;
}

.bg-yellow-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(252.6, 245.8, 158.2, var(--bs-bg-opacity)) !important;
}

.text-yellow-700 {
  --bs-text-opacity: 1;
  color: rgba(149.4, 139.2, 7.8, var(--bs-text-opacity)) !important;
}

.bg-yellow-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(149.4, 139.2, 7.8, var(--bs-bg-opacity)) !important;
}

.text-yellow-300 {
  --bs-text-opacity: 1;
  color: rgba(251.4, 241.2, 109.8, var(--bs-text-opacity)) !important;
}

.bg-yellow-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(251.4, 241.2, 109.8, var(--bs-bg-opacity)) !important;
}

.text-yellow-800 {
  --bs-text-opacity: 1;
  color: rgba(99.6, 92.8, 5.2, var(--bs-text-opacity)) !important;
}

.bg-yellow-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(99.6, 92.8, 5.2, var(--bs-bg-opacity)) !important;
}

.text-yellow-400 {
  --bs-text-opacity: 1;
  color: rgba(250.2, 236.6, 61.4, var(--bs-text-opacity)) !important;
}

.bg-yellow-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(250.2, 236.6, 61.4, var(--bs-bg-opacity)) !important;
}

.text-yellow-900 {
  --bs-text-opacity: 1;
  color: rgba(49.8, 46.4, 2.6, var(--bs-text-opacity)) !important;
}

.bg-yellow-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(49.8, 46.4, 2.6, var(--bs-bg-opacity)) !important;
}

.bg-gradient-teal {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, rgb(45.5129533679, 198.4870466321, 152.9740932642), rgb(31.2435233161, 136.2564766839, 105.0129533679)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-teal {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-teal-100 {
  --bs-text-opacity: 1;
  color: rgba(211.2, 235.4, 228.2, var(--bs-text-opacity)) !important;
}

.bg-teal-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211.2, 235.4, 228.2, var(--bs-bg-opacity)) !important;
}

.text-teal-600 {
  --bs-text-opacity: 1;
  color: rgba(28.8, 125.6, 96.8, var(--bs-text-opacity)) !important;
}

.bg-teal-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.8, 125.6, 96.8, var(--bs-bg-opacity)) !important;
}

.text-teal-200 {
  --bs-text-opacity: 1;
  color: rgba(167.4, 215.8, 201.4, var(--bs-text-opacity)) !important;
}

.bg-teal-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167.4, 215.8, 201.4, var(--bs-bg-opacity)) !important;
}

.text-teal-700 {
  --bs-text-opacity: 1;
  color: rgba(21.6, 94.2, 72.6, var(--bs-text-opacity)) !important;
}

.bg-teal-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.6, 94.2, 72.6, var(--bs-bg-opacity)) !important;
}

.text-teal-300 {
  --bs-text-opacity: 1;
  color: rgba(123.6, 196.2, 174.6, var(--bs-text-opacity)) !important;
}

.bg-teal-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(123.6, 196.2, 174.6, var(--bs-bg-opacity)) !important;
}

.text-teal-800 {
  --bs-text-opacity: 1;
  color: rgba(14.4, 62.8, 48.4, var(--bs-text-opacity)) !important;
}

.bg-teal-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14.4, 62.8, 48.4, var(--bs-bg-opacity)) !important;
}

.text-teal-400 {
  --bs-text-opacity: 1;
  color: rgba(79.8, 176.6, 147.8, var(--bs-text-opacity)) !important;
}

.bg-teal-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(79.8, 176.6, 147.8, var(--bs-bg-opacity)) !important;
}

.text-teal-900 {
  --bs-text-opacity: 1;
  color: rgba(7.2, 31.4, 24.2, var(--bs-text-opacity)) !important;
}

.bg-teal-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7.2, 31.4, 24.2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-muted {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, rgb(122.7402597403, 147.4155844156, 159.2597402597), rgb(86.2922077922, 108.5324675325, 119.2077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-muted {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-muted-100 {
  --bs-text-opacity: 1;
  color: rgba(223.4, 228.4, 230.8, var(--bs-text-opacity)) !important;
}

.bg-muted-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223.4, 228.4, 230.8, var(--bs-bg-opacity)) !important;
}

.text-muted-600 {
  --bs-text-opacity: 1;
  color: rgba(77.6, 97.6, 107.2, var(--bs-text-opacity)) !important;
}

.bg-muted-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(77.6, 97.6, 107.2, var(--bs-bg-opacity)) !important;
}

.text-muted-200 {
  --bs-text-opacity: 1;
  color: rgba(191.8, 201.8, 206.6, var(--bs-text-opacity)) !important;
}

.bg-muted-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(191.8, 201.8, 206.6, var(--bs-bg-opacity)) !important;
}

.text-muted-700 {
  --bs-text-opacity: 1;
  color: rgba(58.2, 73.2, 80.4, var(--bs-text-opacity)) !important;
}

.bg-muted-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58.2, 73.2, 80.4, var(--bs-bg-opacity)) !important;
}

.text-muted-300 {
  --bs-text-opacity: 1;
  color: rgba(160.2, 175.2, 182.4, var(--bs-text-opacity)) !important;
}

.bg-muted-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160.2, 175.2, 182.4, var(--bs-bg-opacity)) !important;
}

.text-muted-800 {
  --bs-text-opacity: 1;
  color: rgba(38.8, 48.8, 53.6, var(--bs-text-opacity)) !important;
}

.bg-muted-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.8, 48.8, 53.6, var(--bs-bg-opacity)) !important;
}

.text-muted-400 {
  --bs-text-opacity: 1;
  color: rgba(128.6, 148.6, 158.2, var(--bs-text-opacity)) !important;
}

.bg-muted-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(128.6, 148.6, 158.2, var(--bs-bg-opacity)) !important;
}

.text-muted-900 {
  --bs-text-opacity: 1;
  color: rgba(19.4, 24.4, 26.8, var(--bs-text-opacity)) !important;
}

.bg-muted-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19.4, 24.4, 26.8, var(--bs-bg-opacity)) !important;
}

.bg-gradient-light {
  background-color: rgb(191.8, 201.8, 206.6) !important;
  background-image: linear-gradient(to bottom, rgb(220.6817204301, 226.111827957, 228.7182795699), rgb(177.3591397849, 189.6440860215, 195.5408602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-light {
  --bs-theme: rgb(191.8, 201.8, 206.6) !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-light-100 {
  --bs-text-opacity: 1;
  color: rgba(242.36, 244.36, 245.32, var(--bs-text-opacity)) !important;
}

.bg-light-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.36, 244.36, 245.32, var(--bs-bg-opacity)) !important;
}

.text-light-600 {
  --bs-text-opacity: 1;
  color: rgba(153.44, 161.44, 165.28, var(--bs-text-opacity)) !important;
}

.bg-light-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(153.44, 161.44, 165.28, var(--bs-bg-opacity)) !important;
}

.text-light-200 {
  --bs-text-opacity: 1;
  color: rgba(229.72, 233.72, 235.64, var(--bs-text-opacity)) !important;
}

.bg-light-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(229.72, 233.72, 235.64, var(--bs-bg-opacity)) !important;
}

.text-light-700 {
  --bs-text-opacity: 1;
  color: rgba(115.08, 121.08, 123.96, var(--bs-text-opacity)) !important;
}

.bg-light-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115.08, 121.08, 123.96, var(--bs-bg-opacity)) !important;
}

.text-light-300 {
  --bs-text-opacity: 1;
  color: rgba(217.08, 223.08, 225.96, var(--bs-text-opacity)) !important;
}

.bg-light-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217.08, 223.08, 225.96, var(--bs-bg-opacity)) !important;
}

.text-light-800 {
  --bs-text-opacity: 1;
  color: rgba(76.72, 80.72, 82.64, var(--bs-text-opacity)) !important;
}

.bg-light-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(76.72, 80.72, 82.64, var(--bs-bg-opacity)) !important;
}

.text-light-400 {
  --bs-text-opacity: 1;
  color: rgba(204.44, 212.44, 216.28, var(--bs-text-opacity)) !important;
}

.bg-light-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.44, 212.44, 216.28, var(--bs-bg-opacity)) !important;
}

.text-light-900 {
  --bs-text-opacity: 1;
  color: rgba(38.36, 40.36, 41.32, var(--bs-text-opacity)) !important;
}

.bg-light-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.36, 40.36, 41.32, var(--bs-bg-opacity)) !important;
}

.bg-gradient-lime {
  background-color: #50b00a !important;
  background-image: linear-gradient(to bottom, rgb(101.935483871, 224.2580645161, 12.7419354839), rgb(69.0322580645, 151.8709677419, 8.6290322581)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-lime {
  --bs-theme: #50b00a !important;
  --bs-theme-rgb: 80, 176, 10 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-lime-100 {
  --bs-text-opacity: 1;
  color: rgba(220, 239.2, 206, var(--bs-text-opacity)) !important;
}

.bg-lime-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 239.2, 206, var(--bs-bg-opacity)) !important;
}

.text-lime-600 {
  --bs-text-opacity: 1;
  color: rgba(64, 140.8, 8, var(--bs-text-opacity)) !important;
}

.bg-lime-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(64, 140.8, 8, var(--bs-bg-opacity)) !important;
}

.text-lime-200 {
  --bs-text-opacity: 1;
  color: rgba(185, 223.4, 157, var(--bs-text-opacity)) !important;
}

.bg-lime-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(185, 223.4, 157, var(--bs-bg-opacity)) !important;
}

.text-lime-700 {
  --bs-text-opacity: 1;
  color: rgba(48, 105.6, 6, var(--bs-text-opacity)) !important;
}

.bg-lime-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 105.6, 6, var(--bs-bg-opacity)) !important;
}

.text-lime-300 {
  --bs-text-opacity: 1;
  color: rgba(150, 207.6, 108, var(--bs-text-opacity)) !important;
}

.bg-lime-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(150, 207.6, 108, var(--bs-bg-opacity)) !important;
}

.text-lime-800 {
  --bs-text-opacity: 1;
  color: rgba(32, 70.4, 4, var(--bs-text-opacity)) !important;
}

.bg-lime-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(32, 70.4, 4, var(--bs-bg-opacity)) !important;
}

.text-lime-400 {
  --bs-text-opacity: 1;
  color: rgba(115, 191.8, 59, var(--bs-text-opacity)) !important;
}

.bg-lime-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(115, 191.8, 59, var(--bs-bg-opacity)) !important;
}

.text-lime-900 {
  --bs-text-opacity: 1;
  color: rgba(16, 35.2, 2, var(--bs-text-opacity)) !important;
}

.bg-lime-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 35.2, 2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-100 {
  background-color: rgb(191.8, 201.8, 206.6) !important;
  background-image: linear-gradient(to bottom, rgb(220.6817204301, 226.111827957, 228.7182795699), rgb(177.3591397849, 189.6440860215, 195.5408602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-100 {
  --bs-theme: rgb(191.8, 201.8, 206.6) !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-gray-100-100 {
  --bs-text-opacity: 1;
  color: rgba(242.36, 244.36, 245.32, var(--bs-text-opacity)) !important;
}

.bg-gray-100-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.36, 244.36, 245.32, var(--bs-bg-opacity)) !important;
}

.text-gray-100-600 {
  --bs-text-opacity: 1;
  color: rgba(153.44, 161.44, 165.28, var(--bs-text-opacity)) !important;
}

.bg-gray-100-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(153.44, 161.44, 165.28, var(--bs-bg-opacity)) !important;
}

.text-gray-100-200 {
  --bs-text-opacity: 1;
  color: rgba(229.72, 233.72, 235.64, var(--bs-text-opacity)) !important;
}

.bg-gray-100-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(229.72, 233.72, 235.64, var(--bs-bg-opacity)) !important;
}

.text-gray-100-700 {
  --bs-text-opacity: 1;
  color: rgba(115.08, 121.08, 123.96, var(--bs-text-opacity)) !important;
}

.bg-gray-100-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115.08, 121.08, 123.96, var(--bs-bg-opacity)) !important;
}

.text-gray-100-300 {
  --bs-text-opacity: 1;
  color: rgba(217.08, 223.08, 225.96, var(--bs-text-opacity)) !important;
}

.bg-gray-100-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217.08, 223.08, 225.96, var(--bs-bg-opacity)) !important;
}

.text-gray-100-800 {
  --bs-text-opacity: 1;
  color: rgba(76.72, 80.72, 82.64, var(--bs-text-opacity)) !important;
}

.bg-gray-100-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(76.72, 80.72, 82.64, var(--bs-bg-opacity)) !important;
}

.text-gray-100-400 {
  --bs-text-opacity: 1;
  color: rgba(204.44, 212.44, 216.28, var(--bs-text-opacity)) !important;
}

.bg-gray-100-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.44, 212.44, 216.28, var(--bs-bg-opacity)) !important;
}

.text-gray-100-900 {
  --bs-text-opacity: 1;
  color: rgba(38.36, 40.36, 41.32, var(--bs-text-opacity)) !important;
}

.bg-gray-100-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.36, 40.36, 41.32, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-200 {
  background-color: rgb(168.1, 181.85, 188.45) !important;
  background-image: linear-gradient(to bottom, rgb(196.9817204301, 206.161827957, 210.5682795699), rgb(153.6591397849, 169.6940860215, 177.3908602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-200 {
  --bs-theme: rgb(168.1, 181.85, 188.45) !important;
  --bs-theme-rgb: 168, 182, 188 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-gray-200-100 {
  --bs-text-opacity: 1;
  color: rgba(237.62, 240.37, 241.69, var(--bs-text-opacity)) !important;
}

.bg-gray-200-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(237.62, 240.37, 241.69, var(--bs-bg-opacity)) !important;
}

.text-gray-200-600 {
  --bs-text-opacity: 1;
  color: rgba(134.48, 145.48, 150.76, var(--bs-text-opacity)) !important;
}

.bg-gray-200-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.48, 145.48, 150.76, var(--bs-bg-opacity)) !important;
}

.text-gray-200-200 {
  --bs-text-opacity: 1;
  color: rgba(220.24, 225.74, 228.38, var(--bs-text-opacity)) !important;
}

.bg-gray-200-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(220.24, 225.74, 228.38, var(--bs-bg-opacity)) !important;
}

.text-gray-200-700 {
  --bs-text-opacity: 1;
  color: rgba(100.86, 109.11, 113.07, var(--bs-text-opacity)) !important;
}

.bg-gray-200-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(100.86, 109.11, 113.07, var(--bs-bg-opacity)) !important;
}

.text-gray-200-300 {
  --bs-text-opacity: 1;
  color: rgba(202.86, 211.11, 215.07, var(--bs-text-opacity)) !important;
}

.bg-gray-200-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(202.86, 211.11, 215.07, var(--bs-bg-opacity)) !important;
}

.text-gray-200-800 {
  --bs-text-opacity: 1;
  color: rgba(67.24, 72.74, 75.38, var(--bs-text-opacity)) !important;
}

.bg-gray-200-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(67.24, 72.74, 75.38, var(--bs-bg-opacity)) !important;
}

.text-gray-200-400 {
  --bs-text-opacity: 1;
  color: rgba(185.48, 196.48, 201.76, var(--bs-text-opacity)) !important;
}

.bg-gray-200-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(185.48, 196.48, 201.76, var(--bs-bg-opacity)) !important;
}

.text-gray-200-900 {
  --bs-text-opacity: 1;
  color: rgba(33.62, 36.37, 37.69, var(--bs-text-opacity)) !important;
}

.bg-gray-200-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(33.62, 36.37, 37.69, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-300 {
  background-color: rgb(144.4, 161.9, 170.3) !important;
  background-image: linear-gradient(to bottom, rgb(173.2817204301, 186.211827957, 192.4182795699), rgb(129.9591397849, 149.7440860215, 159.2408602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-300 {
  --bs-theme: rgb(144.4, 161.9, 170.3) !important;
  --bs-theme-rgb: 144, 162, 170 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-gray-300-100 {
  --bs-text-opacity: 1;
  color: rgba(232.88, 236.38, 238.06, var(--bs-text-opacity)) !important;
}

.bg-gray-300-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(232.88, 236.38, 238.06, var(--bs-bg-opacity)) !important;
}

.text-gray-300-600 {
  --bs-text-opacity: 1;
  color: rgba(115.52, 129.52, 136.24, var(--bs-text-opacity)) !important;
}

.bg-gray-300-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(115.52, 129.52, 136.24, var(--bs-bg-opacity)) !important;
}

.text-gray-300-200 {
  --bs-text-opacity: 1;
  color: rgba(210.76, 217.76, 221.12, var(--bs-text-opacity)) !important;
}

.bg-gray-300-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(210.76, 217.76, 221.12, var(--bs-bg-opacity)) !important;
}

.text-gray-300-700 {
  --bs-text-opacity: 1;
  color: rgba(86.64, 97.14, 102.18, var(--bs-text-opacity)) !important;
}

.bg-gray-300-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(86.64, 97.14, 102.18, var(--bs-bg-opacity)) !important;
}

.text-gray-300-300 {
  --bs-text-opacity: 1;
  color: rgba(188.64, 199.14, 204.18, var(--bs-text-opacity)) !important;
}

.bg-gray-300-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(188.64, 199.14, 204.18, var(--bs-bg-opacity)) !important;
}

.text-gray-300-800 {
  --bs-text-opacity: 1;
  color: rgba(57.76, 64.76, 68.12, var(--bs-text-opacity)) !important;
}

.bg-gray-300-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(57.76, 64.76, 68.12, var(--bs-bg-opacity)) !important;
}

.text-gray-300-400 {
  --bs-text-opacity: 1;
  color: rgba(166.52, 180.52, 187.24, var(--bs-text-opacity)) !important;
}

.bg-gray-300-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(166.52, 180.52, 187.24, var(--bs-bg-opacity)) !important;
}

.text-gray-300-900 {
  --bs-text-opacity: 1;
  color: rgba(28.88, 32.38, 34.06, var(--bs-text-opacity)) !important;
}

.bg-gray-300-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.88, 32.38, 34.06, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-400 {
  background-color: rgb(120.7, 141.95, 152.15) !important;
  background-image: linear-gradient(to bottom, rgb(149.5817204301, 166.261827957, 174.2682795699), rgb(107.273655914, 129.4376344086, 140.076344086)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-400 {
  --bs-theme: rgb(120.7, 141.95, 152.15) !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-400-100 {
  --bs-text-opacity: 1;
  color: rgba(228.14, 232.39, 234.43, var(--bs-text-opacity)) !important;
}

.bg-gray-400-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228.14, 232.39, 234.43, var(--bs-bg-opacity)) !important;
}

.text-gray-400-600 {
  --bs-text-opacity: 1;
  color: rgba(96.56, 113.56, 121.72, var(--bs-text-opacity)) !important;
}

.bg-gray-400-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(96.56, 113.56, 121.72, var(--bs-bg-opacity)) !important;
}

.text-gray-400-200 {
  --bs-text-opacity: 1;
  color: rgba(201.28, 209.78, 213.86, var(--bs-text-opacity)) !important;
}

.bg-gray-400-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201.28, 209.78, 213.86, var(--bs-bg-opacity)) !important;
}

.text-gray-400-700 {
  --bs-text-opacity: 1;
  color: rgba(72.42, 85.17, 91.29, var(--bs-text-opacity)) !important;
}

.bg-gray-400-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(72.42, 85.17, 91.29, var(--bs-bg-opacity)) !important;
}

.text-gray-400-300 {
  --bs-text-opacity: 1;
  color: rgba(174.42, 187.17, 193.29, var(--bs-text-opacity)) !important;
}

.bg-gray-400-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.42, 187.17, 193.29, var(--bs-bg-opacity)) !important;
}

.text-gray-400-800 {
  --bs-text-opacity: 1;
  color: rgba(48.28, 56.78, 60.86, var(--bs-text-opacity)) !important;
}

.bg-gray-400-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48.28, 56.78, 60.86, var(--bs-bg-opacity)) !important;
}

.text-gray-400-400 {
  --bs-text-opacity: 1;
  color: rgba(147.56, 164.56, 172.72, var(--bs-text-opacity)) !important;
}

.bg-gray-400-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(147.56, 164.56, 172.72, var(--bs-bg-opacity)) !important;
}

.text-gray-400-900 {
  --bs-text-opacity: 1;
  color: rgba(24.14, 28.39, 30.43, var(--bs-text-opacity)) !important;
}

.bg-gray-400-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24.14, 28.39, 30.43, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-500 {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, rgb(122.7402597403, 147.4155844156, 159.2597402597), rgb(86.2922077922, 108.5324675325, 119.2077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-500 {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-500-100 {
  --bs-text-opacity: 1;
  color: rgba(223.4, 228.4, 230.8, var(--bs-text-opacity)) !important;
}

.bg-gray-500-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223.4, 228.4, 230.8, var(--bs-bg-opacity)) !important;
}

.text-gray-500-600 {
  --bs-text-opacity: 1;
  color: rgba(77.6, 97.6, 107.2, var(--bs-text-opacity)) !important;
}

.bg-gray-500-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(77.6, 97.6, 107.2, var(--bs-bg-opacity)) !important;
}

.text-gray-500-200 {
  --bs-text-opacity: 1;
  color: rgba(191.8, 201.8, 206.6, var(--bs-text-opacity)) !important;
}

.bg-gray-500-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(191.8, 201.8, 206.6, var(--bs-bg-opacity)) !important;
}

.text-gray-500-700 {
  --bs-text-opacity: 1;
  color: rgba(58.2, 73.2, 80.4, var(--bs-text-opacity)) !important;
}

.bg-gray-500-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58.2, 73.2, 80.4, var(--bs-bg-opacity)) !important;
}

.text-gray-500-300 {
  --bs-text-opacity: 1;
  color: rgba(160.2, 175.2, 182.4, var(--bs-text-opacity)) !important;
}

.bg-gray-500-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160.2, 175.2, 182.4, var(--bs-bg-opacity)) !important;
}

.text-gray-500-800 {
  --bs-text-opacity: 1;
  color: rgba(38.8, 48.8, 53.6, var(--bs-text-opacity)) !important;
}

.bg-gray-500-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.8, 48.8, 53.6, var(--bs-bg-opacity)) !important;
}

.text-gray-500-400 {
  --bs-text-opacity: 1;
  color: rgba(128.6, 148.6, 158.2, var(--bs-text-opacity)) !important;
}

.bg-gray-500-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(128.6, 148.6, 158.2, var(--bs-bg-opacity)) !important;
}

.text-gray-500-900 {
  --bs-text-opacity: 1;
  color: rgba(19.4, 24.4, 26.8, var(--bs-text-opacity)) !important;
}

.bg-gray-500-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19.4, 24.4, 26.8, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-600 {
  background-color: rgb(82.45, 103.7, 113.9) !important;
  background-image: linear-gradient(to bottom, rgb(103.8655844156, 130.6350649351, 143.4844155844), rgb(71.7422077922, 90.2324675325, 99.1077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-600 {
  --bs-theme: rgb(82.45, 103.7, 113.9) !important;
  --bs-theme-rgb: 82, 104, 114 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-600-100 {
  --bs-text-opacity: 1;
  color: rgba(220.49, 224.74, 226.78, var(--bs-text-opacity)) !important;
}

.bg-gray-600-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220.49, 224.74, 226.78, var(--bs-bg-opacity)) !important;
}

.text-gray-600-600 {
  --bs-text-opacity: 1;
  color: rgba(65.96, 82.96, 91.12, var(--bs-text-opacity)) !important;
}

.bg-gray-600-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(65.96, 82.96, 91.12, var(--bs-bg-opacity)) !important;
}

.text-gray-600-200 {
  --bs-text-opacity: 1;
  color: rgba(185.98, 194.48, 198.56, var(--bs-text-opacity)) !important;
}

.bg-gray-600-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(185.98, 194.48, 198.56, var(--bs-bg-opacity)) !important;
}

.text-gray-600-700 {
  --bs-text-opacity: 1;
  color: rgba(49.47, 62.22, 68.34, var(--bs-text-opacity)) !important;
}

.bg-gray-600-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(49.47, 62.22, 68.34, var(--bs-bg-opacity)) !important;
}

.text-gray-600-300 {
  --bs-text-opacity: 1;
  color: rgba(151.47, 164.22, 170.34, var(--bs-text-opacity)) !important;
}

.bg-gray-600-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(151.47, 164.22, 170.34, var(--bs-bg-opacity)) !important;
}

.text-gray-600-800 {
  --bs-text-opacity: 1;
  color: rgba(32.98, 41.48, 45.56, var(--bs-text-opacity)) !important;
}

.bg-gray-600-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.98, 41.48, 45.56, var(--bs-bg-opacity)) !important;
}

.text-gray-600-400 {
  --bs-text-opacity: 1;
  color: rgba(116.96, 133.96, 142.12, var(--bs-text-opacity)) !important;
}

.bg-gray-600-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(116.96, 133.96, 142.12, var(--bs-bg-opacity)) !important;
}

.text-gray-600-900 {
  --bs-text-opacity: 1;
  color: rgba(16.49, 20.74, 22.78, var(--bs-text-opacity)) !important;
}

.bg-gray-600-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16.49, 20.74, 22.78, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-700 {
  background-color: rgb(67.9, 85.4, 93.8) !important;
  background-image: linear-gradient(to bottom, rgb(89.3155844156, 112.3350649351, 123.3844155844), rgb(57.1922077922, 71.9324675325, 79.0077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-700 {
  --bs-theme: rgb(67.9, 85.4, 93.8) !important;
  --bs-theme-rgb: 68, 85, 94 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-700-100 {
  --bs-text-opacity: 1;
  color: rgba(217.58, 221.08, 222.76, var(--bs-text-opacity)) !important;
}

.bg-gray-700-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(217.58, 221.08, 222.76, var(--bs-bg-opacity)) !important;
}

.text-gray-700-600 {
  --bs-text-opacity: 1;
  color: rgba(54.32, 68.32, 75.04, var(--bs-text-opacity)) !important;
}

.bg-gray-700-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(54.32, 68.32, 75.04, var(--bs-bg-opacity)) !important;
}

.text-gray-700-200 {
  --bs-text-opacity: 1;
  color: rgba(180.16, 187.16, 190.52, var(--bs-text-opacity)) !important;
}

.bg-gray-700-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(180.16, 187.16, 190.52, var(--bs-bg-opacity)) !important;
}

.text-gray-700-700 {
  --bs-text-opacity: 1;
  color: rgba(40.74, 51.24, 56.28, var(--bs-text-opacity)) !important;
}

.bg-gray-700-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(40.74, 51.24, 56.28, var(--bs-bg-opacity)) !important;
}

.text-gray-700-300 {
  --bs-text-opacity: 1;
  color: rgba(142.74, 153.24, 158.28, var(--bs-text-opacity)) !important;
}

.bg-gray-700-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(142.74, 153.24, 158.28, var(--bs-bg-opacity)) !important;
}

.text-gray-700-800 {
  --bs-text-opacity: 1;
  color: rgba(27.16, 34.16, 37.52, var(--bs-text-opacity)) !important;
}

.bg-gray-700-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(27.16, 34.16, 37.52, var(--bs-bg-opacity)) !important;
}

.text-gray-700-400 {
  --bs-text-opacity: 1;
  color: rgba(105.32, 119.32, 126.04, var(--bs-text-opacity)) !important;
}

.bg-gray-700-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(105.32, 119.32, 126.04, var(--bs-bg-opacity)) !important;
}

.text-gray-700-900 {
  --bs-text-opacity: 1;
  color: rgba(13.58, 17.08, 18.76, var(--bs-text-opacity)) !important;
}

.bg-gray-700-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(13.58, 17.08, 18.76, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-800 {
  background-color: rgb(53.35, 67.1, 73.7) !important;
  background-image: linear-gradient(to bottom, rgb(74.7655844156, 94.0350649351, 103.2844155844), rgb(42.6422077922, 53.6324675325, 58.9077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-800 {
  --bs-theme: rgb(53.35, 67.1, 73.7) !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-800-100 {
  --bs-text-opacity: 1;
  color: rgba(214.67, 217.42, 218.74, var(--bs-text-opacity)) !important;
}

.bg-gray-800-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(214.67, 217.42, 218.74, var(--bs-bg-opacity)) !important;
}

.text-gray-800-600 {
  --bs-text-opacity: 1;
  color: rgba(42.68, 53.68, 58.96, var(--bs-text-opacity)) !important;
}

.bg-gray-800-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42.68, 53.68, 58.96, var(--bs-bg-opacity)) !important;
}

.text-gray-800-200 {
  --bs-text-opacity: 1;
  color: rgba(174.34, 179.84, 182.48, var(--bs-text-opacity)) !important;
}

.bg-gray-800-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.34, 179.84, 182.48, var(--bs-bg-opacity)) !important;
}

.text-gray-800-700 {
  --bs-text-opacity: 1;
  color: rgba(32.01, 40.26, 44.22, var(--bs-text-opacity)) !important;
}

.bg-gray-800-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.01, 40.26, 44.22, var(--bs-bg-opacity)) !important;
}

.text-gray-800-300 {
  --bs-text-opacity: 1;
  color: rgba(134.01, 142.26, 146.22, var(--bs-text-opacity)) !important;
}

.bg-gray-800-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.01, 142.26, 146.22, var(--bs-bg-opacity)) !important;
}

.text-gray-800-800 {
  --bs-text-opacity: 1;
  color: rgba(21.34, 26.84, 29.48, var(--bs-text-opacity)) !important;
}

.bg-gray-800-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.34, 26.84, 29.48, var(--bs-bg-opacity)) !important;
}

.text-gray-800-400 {
  --bs-text-opacity: 1;
  color: rgba(93.68, 104.68, 109.96, var(--bs-text-opacity)) !important;
}

.bg-gray-800-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93.68, 104.68, 109.96, var(--bs-bg-opacity)) !important;
}

.text-gray-800-900 {
  --bs-text-opacity: 1;
  color: rgba(10.67, 13.42, 14.74, var(--bs-text-opacity)) !important;
}

.bg-gray-800-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(10.67, 13.42, 14.74, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-900 {
  background-color: rgb(38.8, 48.8, 53.6) !important;
  background-image: linear-gradient(to bottom, rgb(60.2155844156, 75.7350649351, 83.1844155844), rgb(28.0922077922, 35.3324675325, 38.8077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-900 {
  --bs-theme: rgb(38.8, 48.8, 53.6) !important;
  --bs-theme-rgb: 39, 49, 54 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-900-100 {
  --bs-text-opacity: 1;
  color: rgba(211.76, 213.76, 214.72, var(--bs-text-opacity)) !important;
}

.bg-gray-900-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211.76, 213.76, 214.72, var(--bs-bg-opacity)) !important;
}

.text-gray-900-600 {
  --bs-text-opacity: 1;
  color: rgba(31.04, 39.04, 42.88, var(--bs-text-opacity)) !important;
}

.bg-gray-900-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(31.04, 39.04, 42.88, var(--bs-bg-opacity)) !important;
}

.text-gray-900-200 {
  --bs-text-opacity: 1;
  color: rgba(168.52, 172.52, 174.44, var(--bs-text-opacity)) !important;
}

.bg-gray-900-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(168.52, 172.52, 174.44, var(--bs-bg-opacity)) !important;
}

.text-gray-900-700 {
  --bs-text-opacity: 1;
  color: rgba(23.28, 29.28, 32.16, var(--bs-text-opacity)) !important;
}

.bg-gray-900-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(23.28, 29.28, 32.16, var(--bs-bg-opacity)) !important;
}

.text-gray-900-300 {
  --bs-text-opacity: 1;
  color: rgba(125.28, 131.28, 134.16, var(--bs-text-opacity)) !important;
}

.bg-gray-900-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(125.28, 131.28, 134.16, var(--bs-bg-opacity)) !important;
}

.text-gray-900-800 {
  --bs-text-opacity: 1;
  color: rgba(15.52, 19.52, 21.44, var(--bs-text-opacity)) !important;
}

.bg-gray-900-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(15.52, 19.52, 21.44, var(--bs-bg-opacity)) !important;
}

.text-gray-900-400 {
  --bs-text-opacity: 1;
  color: rgba(82.04, 90.04, 93.88, var(--bs-text-opacity)) !important;
}

.bg-gray-900-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(82.04, 90.04, 93.88, var(--bs-bg-opacity)) !important;
}

.text-gray-900-900 {
  --bs-text-opacity: 1;
  color: rgba(7.76, 9.76, 10.72, var(--bs-text-opacity)) !important;
}

.bg-gray-900-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7.76, 9.76, 10.72, var(--bs-bg-opacity)) !important;
}

.bg-gradient-blue {
  background-color: #0271ff !important;
  background-image: linear-gradient(to bottom, rgb(53, 141.6245059289, 255), rgb(0, 101.5671936759, 231.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-blue {
  --bs-theme: #0271ff !important;
  --bs-theme-rgb: 2, 113, 255 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-blue-100 {
  --bs-text-opacity: 1;
  color: rgba(204.4, 226.6, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.4, 226.6, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-600 {
  --bs-text-opacity: 1;
  color: rgba(1.6, 90.4, 204, var(--bs-text-opacity)) !important;
}

.bg-blue-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(1.6, 90.4, 204, var(--bs-bg-opacity)) !important;
}

.text-blue-200 {
  --bs-text-opacity: 1;
  color: rgba(153.8, 198.2, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153.8, 198.2, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-700 {
  --bs-text-opacity: 1;
  color: rgba(1.2, 67.8, 153, var(--bs-text-opacity)) !important;
}

.bg-blue-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(1.2, 67.8, 153, var(--bs-bg-opacity)) !important;
}

.text-blue-300 {
  --bs-text-opacity: 1;
  color: rgba(103.2, 169.8, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(103.2, 169.8, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-800 {
  --bs-text-opacity: 1;
  color: rgba(0.8, 45.2, 102, var(--bs-text-opacity)) !important;
}

.bg-blue-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0.8, 45.2, 102, var(--bs-bg-opacity)) !important;
}

.text-blue-400 {
  --bs-text-opacity: 1;
  color: rgba(52.6, 141.4, 255, var(--bs-text-opacity)) !important;
}

.bg-blue-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(52.6, 141.4, 255, var(--bs-bg-opacity)) !important;
}

.text-blue-900 {
  --bs-text-opacity: 1;
  color: rgba(0.4, 22.6, 51, var(--bs-text-opacity)) !important;
}

.bg-blue-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0.4, 22.6, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-indigo {
  background-color: #5c25ff !important;
  background-image: linear-gradient(to bottom, rgb(130.1330275229, 88, 255), rgb(72.9334862385, 11.5, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-indigo {
  --bs-theme: #5c25ff !important;
  --bs-theme-rgb: 92, 37, 255 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-indigo-100 {
  --bs-text-opacity: 1;
  color: rgba(222.4, 211.4, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(222.4, 211.4, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-600 {
  --bs-text-opacity: 1;
  color: rgba(73.6, 29.6, 204, var(--bs-text-opacity)) !important;
}

.bg-indigo-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(73.6, 29.6, 204, var(--bs-bg-opacity)) !important;
}

.text-indigo-200 {
  --bs-text-opacity: 1;
  color: rgba(189.8, 167.8, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(189.8, 167.8, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-700 {
  --bs-text-opacity: 1;
  color: rgba(55.2, 22.2, 153, var(--bs-text-opacity)) !important;
}

.bg-indigo-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(55.2, 22.2, 153, var(--bs-bg-opacity)) !important;
}

.text-indigo-300 {
  --bs-text-opacity: 1;
  color: rgba(157.2, 124.2, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(157.2, 124.2, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-800 {
  --bs-text-opacity: 1;
  color: rgba(36.8, 14.8, 102, var(--bs-text-opacity)) !important;
}

.bg-indigo-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(36.8, 14.8, 102, var(--bs-bg-opacity)) !important;
}

.text-indigo-400 {
  --bs-text-opacity: 1;
  color: rgba(124.6, 80.6, 255, var(--bs-text-opacity)) !important;
}

.bg-indigo-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(124.6, 80.6, 255, var(--bs-bg-opacity)) !important;
}

.text-indigo-900 {
  --bs-text-opacity: 1;
  color: rgba(18.4, 7.4, 51, var(--bs-text-opacity)) !important;
}

.bg-indigo-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(18.4, 7.4, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-purple {
  background-color: #b90dff !important;
  background-image: linear-gradient(to bottom, rgb(199.7520661157, 64, 255), rgb(172.3553719008, 0, 242.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-purple {
  --bs-theme: #b90dff !important;
  --bs-theme-rgb: 185, 13, 255 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(241, 206.6, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(241, 206.6, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-600 {
  --bs-text-opacity: 1;
  color: rgba(148, 10.4, 204, var(--bs-text-opacity)) !important;
}

.bg-purple-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(148, 10.4, 204, var(--bs-bg-opacity)) !important;
}

.text-purple-200 {
  --bs-text-opacity: 1;
  color: rgba(227, 158.2, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(227, 158.2, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-700 {
  --bs-text-opacity: 1;
  color: rgba(111, 7.8, 153, var(--bs-text-opacity)) !important;
}

.bg-purple-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(111, 7.8, 153, var(--bs-bg-opacity)) !important;
}

.text-purple-300 {
  --bs-text-opacity: 1;
  color: rgba(213, 109.8, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(213, 109.8, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-800 {
  --bs-text-opacity: 1;
  color: rgba(74, 5.2, 102, var(--bs-text-opacity)) !important;
}

.bg-purple-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(74, 5.2, 102, var(--bs-bg-opacity)) !important;
}

.text-purple-400 {
  --bs-text-opacity: 1;
  color: rgba(199, 61.4, 255, var(--bs-text-opacity)) !important;
}

.bg-purple-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(199, 61.4, 255, var(--bs-bg-opacity)) !important;
}

.text-purple-900 {
  --bs-text-opacity: 1;
  color: rgba(37, 2.6, 51, var(--bs-text-opacity)) !important;
}

.bg-purple-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(37, 2.6, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-pink {
  background-color: #e61079 !important;
  background-image: linear-gradient(to bottom, rgb(241.1463414634, 55.8536585366, 146.7682926829), rgb(206.1585365854, 14.3414634146, 108.4573170732)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-pink {
  --bs-theme: #e61079 !important;
  --bs-theme-rgb: 230, 16, 121 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-pink-100 {
  --bs-text-opacity: 1;
  color: rgba(250, 207.2, 228.2, var(--bs-text-opacity)) !important;
}

.bg-pink-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 207.2, 228.2, var(--bs-bg-opacity)) !important;
}

.text-pink-600 {
  --bs-text-opacity: 1;
  color: rgba(184, 12.8, 96.8, var(--bs-text-opacity)) !important;
}

.bg-pink-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(184, 12.8, 96.8, var(--bs-bg-opacity)) !important;
}

.text-pink-200 {
  --bs-text-opacity: 1;
  color: rgba(245, 159.4, 201.4, var(--bs-text-opacity)) !important;
}

.bg-pink-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(245, 159.4, 201.4, var(--bs-bg-opacity)) !important;
}

.text-pink-700 {
  --bs-text-opacity: 1;
  color: rgba(138, 9.6, 72.6, var(--bs-text-opacity)) !important;
}

.bg-pink-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 9.6, 72.6, var(--bs-bg-opacity)) !important;
}

.text-pink-300 {
  --bs-text-opacity: 1;
  color: rgba(240, 111.6, 174.6, var(--bs-text-opacity)) !important;
}

.bg-pink-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(240, 111.6, 174.6, var(--bs-bg-opacity)) !important;
}

.text-pink-800 {
  --bs-text-opacity: 1;
  color: rgba(92, 6.4, 48.4, var(--bs-text-opacity)) !important;
}

.bg-pink-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(92, 6.4, 48.4, var(--bs-bg-opacity)) !important;
}

.text-pink-400 {
  --bs-text-opacity: 1;
  color: rgba(235, 63.8, 147.8, var(--bs-text-opacity)) !important;
}

.bg-pink-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(235, 63.8, 147.8, var(--bs-bg-opacity)) !important;
}

.text-pink-900 {
  --bs-text-opacity: 1;
  color: rgba(46, 3.2, 24.2, var(--bs-text-opacity)) !important;
}

.bg-pink-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(46, 3.2, 24.2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-red {
  background-color: #e00000 !important;
  background-image: linear-gradient(to bottom, #ff1414, rgb(198.5, 0, 0)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-red {
  --bs-theme: #e00000 !important;
  --bs-theme-rgb: 224, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-red-100 {
  --bs-text-opacity: 1;
  color: rgba(248.8, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-red-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(248.8, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-red-600 {
  --bs-text-opacity: 1;
  color: rgba(179.2, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(179.2, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-200 {
  --bs-text-opacity: 1;
  color: rgba(242.6, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-red-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.6, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-red-700 {
  --bs-text-opacity: 1;
  color: rgba(134.4, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.4, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-300 {
  --bs-text-opacity: 1;
  color: rgba(236.4, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-red-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(236.4, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-red-800 {
  --bs-text-opacity: 1;
  color: rgba(89.6, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(89.6, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-red-400 {
  --bs-text-opacity: 1;
  color: rgba(230.2, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-red-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(230.2, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-red-900 {
  --bs-text-opacity: 1;
  color: rgba(44.8, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-red-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(44.8, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-orange {
  background-color: #ff9f0c !important;
  background-image: linear-gradient(to bottom, rgb(255, 179.1481481481, 63), rgb(241.5, 146.0925925926, 0)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-orange {
  --bs-theme: #ff9f0c !important;
  --bs-theme-rgb: 255, 159, 12 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-orange-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 235.8, 206.4, var(--bs-text-opacity)) !important;
}

.bg-orange-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 235.8, 206.4, var(--bs-bg-opacity)) !important;
}

.text-orange-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 127.2, 9.6, var(--bs-text-opacity)) !important;
}

.bg-orange-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 127.2, 9.6, var(--bs-bg-opacity)) !important;
}

.text-orange-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 216.6, 157.8, var(--bs-text-opacity)) !important;
}

.bg-orange-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 216.6, 157.8, var(--bs-bg-opacity)) !important;
}

.text-orange-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 95.4, 7.2, var(--bs-text-opacity)) !important;
}

.bg-orange-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 95.4, 7.2, var(--bs-bg-opacity)) !important;
}

.text-orange-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 197.4, 109.2, var(--bs-text-opacity)) !important;
}

.bg-orange-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 197.4, 109.2, var(--bs-bg-opacity)) !important;
}

.text-orange-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 63.6, 4.8, var(--bs-text-opacity)) !important;
}

.bg-orange-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 63.6, 4.8, var(--bs-bg-opacity)) !important;
}

.text-orange-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 178.2, 60.6, var(--bs-text-opacity)) !important;
}

.bg-orange-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 178.2, 60.6, var(--bs-bg-opacity)) !important;
}

.text-orange-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 31.8, 2.4, var(--bs-text-opacity)) !important;
}

.bg-orange-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 31.8, 2.4, var(--bs-bg-opacity)) !important;
}

.bg-gradient-yellow {
  background-color: #f9e80d !important;
  background-image: linear-gradient(to bottom, rgb(250.2338709677, 236.7298387097, 62.7661290323), rgb(230.7782258065, 214.5665322581, 5.7217741935)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-yellow {
  --bs-theme: #f9e80d !important;
  --bs-theme-rgb: 249, 232, 13 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-yellow-100 {
  --bs-text-opacity: 1;
  color: rgba(253.8, 250.4, 206.6, var(--bs-text-opacity)) !important;
}

.bg-yellow-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(253.8, 250.4, 206.6, var(--bs-bg-opacity)) !important;
}

.text-yellow-600 {
  --bs-text-opacity: 1;
  color: rgba(199.2, 185.6, 10.4, var(--bs-text-opacity)) !important;
}

.bg-yellow-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(199.2, 185.6, 10.4, var(--bs-bg-opacity)) !important;
}

.text-yellow-200 {
  --bs-text-opacity: 1;
  color: rgba(252.6, 245.8, 158.2, var(--bs-text-opacity)) !important;
}

.bg-yellow-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(252.6, 245.8, 158.2, var(--bs-bg-opacity)) !important;
}

.text-yellow-700 {
  --bs-text-opacity: 1;
  color: rgba(149.4, 139.2, 7.8, var(--bs-text-opacity)) !important;
}

.bg-yellow-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(149.4, 139.2, 7.8, var(--bs-bg-opacity)) !important;
}

.text-yellow-300 {
  --bs-text-opacity: 1;
  color: rgba(251.4, 241.2, 109.8, var(--bs-text-opacity)) !important;
}

.bg-yellow-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(251.4, 241.2, 109.8, var(--bs-bg-opacity)) !important;
}

.text-yellow-800 {
  --bs-text-opacity: 1;
  color: rgba(99.6, 92.8, 5.2, var(--bs-text-opacity)) !important;
}

.bg-yellow-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(99.6, 92.8, 5.2, var(--bs-bg-opacity)) !important;
}

.text-yellow-400 {
  --bs-text-opacity: 1;
  color: rgba(250.2, 236.6, 61.4, var(--bs-text-opacity)) !important;
}

.bg-yellow-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(250.2, 236.6, 61.4, var(--bs-bg-opacity)) !important;
}

.text-yellow-900 {
  --bs-text-opacity: 1;
  color: rgba(49.8, 46.4, 2.6, var(--bs-text-opacity)) !important;
}

.bg-yellow-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(49.8, 46.4, 2.6, var(--bs-bg-opacity)) !important;
}

.bg-gradient-green {
  background-color: #148922 !important;
  background-image: linear-gradient(to bottom, rgb(26.4968152866, 181.5031847134, 45.0445859873), rgb(16.7515923567, 114.7484076433, 28.4777070064)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-green {
  --bs-theme: #148922 !important;
  --bs-theme-rgb: 20, 137, 34 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-green-100 {
  --bs-text-opacity: 1;
  color: rgba(208, 231.4, 210.8, var(--bs-text-opacity)) !important;
}

.bg-green-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(208, 231.4, 210.8, var(--bs-bg-opacity)) !important;
}

.text-green-600 {
  --bs-text-opacity: 1;
  color: rgba(16, 109.6, 27.2, var(--bs-text-opacity)) !important;
}

.bg-green-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(16, 109.6, 27.2, var(--bs-bg-opacity)) !important;
}

.text-green-200 {
  --bs-text-opacity: 1;
  color: rgba(161, 207.8, 166.6, var(--bs-text-opacity)) !important;
}

.bg-green-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(161, 207.8, 166.6, var(--bs-bg-opacity)) !important;
}

.text-green-700 {
  --bs-text-opacity: 1;
  color: rgba(12, 82.2, 20.4, var(--bs-text-opacity)) !important;
}

.bg-green-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 82.2, 20.4, var(--bs-bg-opacity)) !important;
}

.text-green-300 {
  --bs-text-opacity: 1;
  color: rgba(114, 184.2, 122.4, var(--bs-text-opacity)) !important;
}

.bg-green-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(114, 184.2, 122.4, var(--bs-bg-opacity)) !important;
}

.text-green-800 {
  --bs-text-opacity: 1;
  color: rgba(8, 54.8, 13.6, var(--bs-text-opacity)) !important;
}

.bg-green-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(8, 54.8, 13.6, var(--bs-bg-opacity)) !important;
}

.text-green-400 {
  --bs-text-opacity: 1;
  color: rgba(67, 160.6, 78.2, var(--bs-text-opacity)) !important;
}

.bg-green-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(67, 160.6, 78.2, var(--bs-bg-opacity)) !important;
}

.text-green-900 {
  --bs-text-opacity: 1;
  color: rgba(4, 27.4, 6.8, var(--bs-text-opacity)) !important;
}

.bg-green-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(4, 27.4, 6.8, var(--bs-bg-opacity)) !important;
}

.bg-gradient-teal {
  background-color: #249d79 !important;
  background-image: linear-gradient(to bottom, rgb(45.5129533679, 198.4870466321, 152.9740932642), rgb(31.2435233161, 136.2564766839, 105.0129533679)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-teal {
  --bs-theme: #249d79 !important;
  --bs-theme-rgb: 36, 157, 121 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-teal-100 {
  --bs-text-opacity: 1;
  color: rgba(211.2, 235.4, 228.2, var(--bs-text-opacity)) !important;
}

.bg-teal-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211.2, 235.4, 228.2, var(--bs-bg-opacity)) !important;
}

.text-teal-600 {
  --bs-text-opacity: 1;
  color: rgba(28.8, 125.6, 96.8, var(--bs-text-opacity)) !important;
}

.bg-teal-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.8, 125.6, 96.8, var(--bs-bg-opacity)) !important;
}

.text-teal-200 {
  --bs-text-opacity: 1;
  color: rgba(167.4, 215.8, 201.4, var(--bs-text-opacity)) !important;
}

.bg-teal-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(167.4, 215.8, 201.4, var(--bs-bg-opacity)) !important;
}

.text-teal-700 {
  --bs-text-opacity: 1;
  color: rgba(21.6, 94.2, 72.6, var(--bs-text-opacity)) !important;
}

.bg-teal-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.6, 94.2, 72.6, var(--bs-bg-opacity)) !important;
}

.text-teal-300 {
  --bs-text-opacity: 1;
  color: rgba(123.6, 196.2, 174.6, var(--bs-text-opacity)) !important;
}

.bg-teal-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(123.6, 196.2, 174.6, var(--bs-bg-opacity)) !important;
}

.text-teal-800 {
  --bs-text-opacity: 1;
  color: rgba(14.4, 62.8, 48.4, var(--bs-text-opacity)) !important;
}

.bg-teal-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(14.4, 62.8, 48.4, var(--bs-bg-opacity)) !important;
}

.text-teal-400 {
  --bs-text-opacity: 1;
  color: rgba(79.8, 176.6, 147.8, var(--bs-text-opacity)) !important;
}

.bg-teal-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(79.8, 176.6, 147.8, var(--bs-bg-opacity)) !important;
}

.text-teal-900 {
  --bs-text-opacity: 1;
  color: rgba(7.2, 31.4, 24.2, var(--bs-text-opacity)) !important;
}

.bg-teal-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7.2, 31.4, 24.2, var(--bs-bg-opacity)) !important;
}

.bg-gradient-cyan {
  background-color: #009be3 !important;
  background-image: linear-gradient(to bottom, rgb(23, 181.4140969163, 255), rgb(0, 137.5881057269, 201.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-cyan {
  --bs-theme: #009be3 !important;
  --bs-theme-rgb: 0, 155, 227 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-cyan-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 235, 249.4, var(--bs-text-opacity)) !important;
}

.bg-cyan-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 235, 249.4, var(--bs-bg-opacity)) !important;
}

.text-cyan-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 124, 181.6, var(--bs-text-opacity)) !important;
}

.bg-cyan-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 124, 181.6, var(--bs-bg-opacity)) !important;
}

.text-cyan-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 215, 243.8, var(--bs-text-opacity)) !important;
}

.bg-cyan-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 215, 243.8, var(--bs-bg-opacity)) !important;
}

.text-cyan-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 93, 136.2, var(--bs-text-opacity)) !important;
}

.bg-cyan-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 93, 136.2, var(--bs-bg-opacity)) !important;
}

.text-cyan-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 195, 238.2, var(--bs-text-opacity)) !important;
}

.bg-cyan-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 195, 238.2, var(--bs-bg-opacity)) !important;
}

.text-cyan-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 62, 90.8, var(--bs-text-opacity)) !important;
}

.bg-cyan-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 62, 90.8, var(--bs-bg-opacity)) !important;
}

.text-cyan-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 175, 232.6, var(--bs-text-opacity)) !important;
}

.bg-cyan-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 175, 232.6, var(--bs-bg-opacity)) !important;
}

.text-cyan-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 31, 45.4, var(--bs-text-opacity)) !important;
}

.bg-cyan-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 31, 45.4, var(--bs-bg-opacity)) !important;
}

.bg-gradient-black {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, rgb(25.5, 25.5, 25.5), black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-black {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-black-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-black-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-black-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-black-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-black-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-black-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-black-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.text-black-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-black-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.text-black-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}

.bg-black-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}

.bg-gradient-white {
  background-color: #FFFFFF !important;
  background-image: linear-gradient(to bottom, white, rgb(242.25, 242.25, 242.25)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-white {
  --bs-theme: #FFFFFF !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}

.text-white-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}

.bg-white-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}

.text-white-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}

.bg-white-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}

.text-white-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}

.bg-white-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}

.text-white-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}

.bg-white-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}

.text-white-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}

.bg-white-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray {
  background-color: rgb(82.45, 103.7, 113.9) !important;
  background-image: linear-gradient(to bottom, rgb(103.8655844156, 130.6350649351, 143.4844155844), rgb(71.7422077922, 90.2324675325, 99.1077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray {
  --bs-theme: rgb(82.45, 103.7, 113.9) !important;
  --bs-theme-rgb: 82, 104, 114 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-100 {
  --bs-text-opacity: 1;
  color: rgba(220.49, 224.74, 226.78, var(--bs-text-opacity)) !important;
}

.bg-gray-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220.49, 224.74, 226.78, var(--bs-bg-opacity)) !important;
}

.text-gray-600 {
  --bs-text-opacity: 1;
  color: rgba(65.96, 82.96, 91.12, var(--bs-text-opacity)) !important;
}

.bg-gray-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(65.96, 82.96, 91.12, var(--bs-bg-opacity)) !important;
}

.text-gray-200 {
  --bs-text-opacity: 1;
  color: rgba(185.98, 194.48, 198.56, var(--bs-text-opacity)) !important;
}

.bg-gray-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(185.98, 194.48, 198.56, var(--bs-bg-opacity)) !important;
}

.text-gray-700 {
  --bs-text-opacity: 1;
  color: rgba(49.47, 62.22, 68.34, var(--bs-text-opacity)) !important;
}

.bg-gray-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(49.47, 62.22, 68.34, var(--bs-bg-opacity)) !important;
}

.text-gray-300 {
  --bs-text-opacity: 1;
  color: rgba(151.47, 164.22, 170.34, var(--bs-text-opacity)) !important;
}

.bg-gray-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(151.47, 164.22, 170.34, var(--bs-bg-opacity)) !important;
}

.text-gray-800 {
  --bs-text-opacity: 1;
  color: rgba(32.98, 41.48, 45.56, var(--bs-text-opacity)) !important;
}

.bg-gray-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.98, 41.48, 45.56, var(--bs-bg-opacity)) !important;
}

.text-gray-400 {
  --bs-text-opacity: 1;
  color: rgba(116.96, 133.96, 142.12, var(--bs-text-opacity)) !important;
}

.bg-gray-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(116.96, 133.96, 142.12, var(--bs-bg-opacity)) !important;
}

.text-gray-900 {
  --bs-text-opacity: 1;
  color: rgba(16.49, 20.74, 22.78, var(--bs-text-opacity)) !important;
}

.bg-gray-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16.49, 20.74, 22.78, var(--bs-bg-opacity)) !important;
}

.bg-gradient-gray-dark {
  background-color: rgb(53.35, 67.1, 73.7) !important;
  background-image: linear-gradient(to bottom, rgb(74.7655844156, 94.0350649351, 103.2844155844), rgb(42.6422077922, 53.6324675325, 58.9077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}

:root .theme-gray-dark {
  --bs-theme: rgb(53.35, 67.1, 73.7) !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}

.text-gray-dark-100 {
  --bs-text-opacity: 1;
  color: rgba(214.67, 217.42, 218.74, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(214.67, 217.42, 218.74, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-600 {
  --bs-text-opacity: 1;
  color: rgba(42.68, 53.68, 58.96, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42.68, 53.68, 58.96, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-200 {
  --bs-text-opacity: 1;
  color: rgba(174.34, 179.84, 182.48, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.34, 179.84, 182.48, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-700 {
  --bs-text-opacity: 1;
  color: rgba(32.01, 40.26, 44.22, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.01, 40.26, 44.22, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-300 {
  --bs-text-opacity: 1;
  color: rgba(134.01, 142.26, 146.22, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.01, 142.26, 146.22, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-800 {
  --bs-text-opacity: 1;
  color: rgba(21.34, 26.84, 29.48, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.34, 26.84, 29.48, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-400 {
  --bs-text-opacity: 1;
  color: rgba(93.68, 104.68, 109.96, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93.68, 104.68, 109.96, var(--bs-bg-opacity)) !important;
}

.text-gray-dark-900 {
  --bs-text-opacity: 1;
  color: rgba(10.67, 13.42, 14.74, var(--bs-text-opacity)) !important;
}

.bg-gray-dark-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(10.67, 13.42, 14.74, var(--bs-bg-opacity)) !important;
}

[data-bs-theme=dark] {
  --bs-default: rgb(168.1, 181.85, 188.45);
  --bs-default-rgb: 168, 182, 188;
  --bs-theme: #3cd2a5;
  --bs-theme-rgb: 60, 210, 165;
  --bs-primary: #4e9cff;
  --bs-primary-rgb: 78, 156, 255;
  --bs-secondary: rgb(120.7, 141.95, 152.15);
  --bs-secondary-rgb: 121, 142, 152;
  --bs-warning: #ff9f0c;
  --bs-warning-rgb: 255, 159, 12;
  --bs-danger: #ff6060;
  --bs-danger-rgb: 255, 96, 96;
  --bs-success: #3cd2a5;
  --bs-success-rgb: 60, 210, 165;
  --bs-inverse: #FFFFFF;
  --bs-inverse-rgb: 255, 255, 255;
  --bs-info: #30beff;
  --bs-info-rgb: 48, 190, 255;
  --bs-dark: rgb(53.35, 67.1, 73.7);
  --bs-dark-rgb: 53, 67, 74;
  --bs-black: #000000;
  --bs-black-rgb: 0, 0, 0;
  --bs-white: #FFFFFF;
  --bs-white-rgb: 255, 255, 255;
  --bs-purple: #de8cff;
  --bs-purple-rgb: 222, 140, 255;
  --bs-indigo: #bba4ff;
  --bs-indigo-rgb: 187, 164, 255;
  --bs-red: #ff6060;
  --bs-red-rgb: 255, 96, 96;
  --bs-pink: #f34fa0;
  --bs-pink-rgb: 243, 79, 160;
  --bs-green: #1ecc33;
  --bs-green-rgb: 30, 204, 51;
  --bs-yellow: #f9e80d;
  --bs-yellow-rgb: 249, 232, 13;
  --bs-teal: #3cd2a5;
  --bs-teal-rgb: 60, 210, 165;
  --bs-muted: #617a86;
  --bs-muted-rgb: 97, 122, 134;
  --bs-light: rgb(191.8, 201.8, 206.6);
  --bs-light-rgb: 192, 202, 207;
  --bs-lime: #81f32d;
  --bs-lime-rgb: 129, 243, 45;
  --bs-gray-100: rgb(191.8, 201.8, 206.6);
  --bs-gray-100-rgb: 192, 202, 207;
  --bs-gray-200: rgb(168.1, 181.85, 188.45);
  --bs-gray-200-rgb: 168, 182, 188;
  --bs-gray-300: rgb(144.4, 161.9, 170.3);
  --bs-gray-300-rgb: 144, 162, 170;
  --bs-gray-400: rgb(120.7, 141.95, 152.15);
  --bs-gray-400-rgb: 121, 142, 152;
  --bs-gray-500: #617a86;
  --bs-gray-500-rgb: 97, 122, 134;
  --bs-gray-600: rgb(82.45, 103.7, 113.9);
  --bs-gray-600-rgb: 82, 104, 114;
  --bs-gray-700: rgb(67.9, 85.4, 93.8);
  --bs-gray-700-rgb: 68, 85, 94;
  --bs-gray-800: rgb(53.35, 67.1, 73.7);
  --bs-gray-800-rgb: 53, 67, 74;
  --bs-gray-900: rgb(38.8, 48.8, 53.6);
  --bs-gray-900-rgb: 39, 49, 54;
}
[data-bs-theme=dark] .bg-gradient-default {
  background-color: rgb(168.1, 181.85, 188.45) !important;
  background-image: linear-gradient(to bottom, rgb(196.9817204301, 206.161827957, 210.5682795699), rgb(153.6591397849, 169.6940860215, 177.3908602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-default {
  --bs-theme: rgb(168.1, 181.85, 188.45) !important;
  --bs-theme-rgb: 168, 182, 188 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-default-100 {
  --bs-text-opacity: 1;
  color: rgba(237.62, 240.37, 241.69, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(237.62, 240.37, 241.69, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-600 {
  --bs-text-opacity: 1;
  color: rgba(134.48, 145.48, 150.76, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.48, 145.48, 150.76, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-200 {
  --bs-text-opacity: 1;
  color: rgba(220.24, 225.74, 228.38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(220.24, 225.74, 228.38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-700 {
  --bs-text-opacity: 1;
  color: rgba(100.86, 109.11, 113.07, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(100.86, 109.11, 113.07, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-300 {
  --bs-text-opacity: 1;
  color: rgba(202.86, 211.11, 215.07, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(202.86, 211.11, 215.07, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-800 {
  --bs-text-opacity: 1;
  color: rgba(67.24, 72.74, 75.38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(67.24, 72.74, 75.38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-400 {
  --bs-text-opacity: 1;
  color: rgba(185.48, 196.48, 201.76, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(185.48, 196.48, 201.76, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-default-900 {
  --bs-text-opacity: 1;
  color: rgba(33.62, 36.37, 37.69, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-default-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(33.62, 36.37, 37.69, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-theme {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, rgb(101.4375, 219.5625, 184.125), rgb(45.84375, 198.65625, 152.8125)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .border-theme {
  border-color: var(--bs-theme) !important;
}
[data-bs-theme=dark] .theme-theme {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-theme-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-theme-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-theme-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-primary {
  background-color: #4e9cff !important;
  background-image: linear-gradient(to bottom, rgb(129, 184.5254237288, 255), rgb(52.5, 141.7372881356, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-primary {
  --bs-theme: #4e9cff !important;
  --bs-theme-rgb: 78, 156, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-primary-100 {
  --bs-text-opacity: 1;
  color: rgba(219.6, 235.2, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(219.6, 235.2, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-600 {
  --bs-text-opacity: 1;
  color: rgba(62.4, 124.8, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(62.4, 124.8, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-200 {
  --bs-text-opacity: 1;
  color: rgba(184.2, 215.4, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(184.2, 215.4, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-700 {
  --bs-text-opacity: 1;
  color: rgba(46.8, 93.6, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(46.8, 93.6, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-300 {
  --bs-text-opacity: 1;
  color: rgba(148.8, 195.6, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(148.8, 195.6, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-800 {
  --bs-text-opacity: 1;
  color: rgba(31.2, 62.4, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(31.2, 62.4, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-400 {
  --bs-text-opacity: 1;
  color: rgba(113.4, 175.8, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(113.4, 175.8, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-primary-900 {
  --bs-text-opacity: 1;
  color: rgba(15.6, 31.2, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-primary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(15.6, 31.2, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-secondary {
  background-color: rgb(120.7, 141.95, 152.15) !important;
  background-image: linear-gradient(to bottom, rgb(149.5817204301, 166.261827957, 174.2682795699), rgb(107.273655914, 129.4376344086, 140.076344086)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-secondary {
  --bs-theme: rgb(120.7, 141.95, 152.15) !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-secondary-100 {
  --bs-text-opacity: 1;
  color: rgba(228.14, 232.39, 234.43, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228.14, 232.39, 234.43, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-600 {
  --bs-text-opacity: 1;
  color: rgba(96.56, 113.56, 121.72, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(96.56, 113.56, 121.72, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-200 {
  --bs-text-opacity: 1;
  color: rgba(201.28, 209.78, 213.86, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201.28, 209.78, 213.86, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-700 {
  --bs-text-opacity: 1;
  color: rgba(72.42, 85.17, 91.29, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(72.42, 85.17, 91.29, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-300 {
  --bs-text-opacity: 1;
  color: rgba(174.42, 187.17, 193.29, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.42, 187.17, 193.29, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-800 {
  --bs-text-opacity: 1;
  color: rgba(48.28, 56.78, 60.86, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48.28, 56.78, 60.86, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-400 {
  --bs-text-opacity: 1;
  color: rgba(147.56, 164.56, 172.72, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(147.56, 164.56, 172.72, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-secondary-900 {
  --bs-text-opacity: 1;
  color: rgba(24.14, 28.39, 30.43, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-secondary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24.14, 28.39, 30.43, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-warning {
  background-color: #ff9f0c !important;
  background-image: linear-gradient(to bottom, rgb(255, 179.1481481481, 63), rgb(241.5, 146.0925925926, 0)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-warning {
  --bs-theme: #ff9f0c !important;
  --bs-theme-rgb: 255, 159, 12 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-warning-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 235.8, 206.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 235.8, 206.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 127.2, 9.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 127.2, 9.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 216.6, 157.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 216.6, 157.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 95.4, 7.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 95.4, 7.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 197.4, 109.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 197.4, 109.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 63.6, 4.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 63.6, 4.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 178.2, 60.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 178.2, 60.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-warning-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 31.8, 2.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-warning-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 31.8, 2.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-danger {
  background-color: #ff6060 !important;
  background-image: linear-gradient(to bottom, #ff9393, rgb(255, 70.5, 70.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-danger {
  --bs-theme: #ff6060 !important;
  --bs-theme-rgb: 255, 96, 96 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-danger-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 223.2, 223.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 223.2, 223.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 76.8, 76.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 76.8, 76.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 191.4, 191.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 191.4, 191.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 57.6, 57.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 57.6, 57.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 159.6, 159.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 159.6, 159.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 38.4, 38.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 38.4, 38.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 127.8, 127.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 127.8, 127.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-danger-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 19.2, 19.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-danger-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 19.2, 19.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-success {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, rgb(101.4375, 219.5625, 184.125), rgb(45.84375, 198.65625, 152.8125)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-success {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-success-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-success-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-success-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-inverse {
  background-color: #FFFFFF !important;
  background-image: linear-gradient(to bottom, white, rgb(242.25, 242.25, 242.25)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-inverse {
  --bs-theme: #FFFFFF !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-inverse-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-inverse-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-inverse-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-info {
  background-color: #30beff !important;
  background-image: linear-gradient(to bottom, rgb(99, 206.0144927536, 255), rgb(22.5, 181.9927536232, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-info {
  --bs-theme: #30beff !important;
  --bs-theme-rgb: 48, 190, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-info-100 {
  --bs-text-opacity: 1;
  color: rgba(213.6, 242, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(213.6, 242, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-600 {
  --bs-text-opacity: 1;
  color: rgba(38.4, 152, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.4, 152, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-200 {
  --bs-text-opacity: 1;
  color: rgba(172.2, 229, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(172.2, 229, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-700 {
  --bs-text-opacity: 1;
  color: rgba(28.8, 114, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.8, 114, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-300 {
  --bs-text-opacity: 1;
  color: rgba(130.8, 216, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(130.8, 216, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-800 {
  --bs-text-opacity: 1;
  color: rgba(19.2, 76, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(19.2, 76, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-400 {
  --bs-text-opacity: 1;
  color: rgba(89.4, 203, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(89.4, 203, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-info-900 {
  --bs-text-opacity: 1;
  color: rgba(9.6, 38, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-info-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(9.6, 38, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-dark {
  background-color: rgb(53.35, 67.1, 73.7) !important;
  background-image: linear-gradient(to bottom, rgb(74.7655844156, 94.0350649351, 103.2844155844), rgb(42.6422077922, 53.6324675325, 58.9077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-dark {
  --bs-theme: rgb(53.35, 67.1, 73.7) !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-dark-100 {
  --bs-text-opacity: 1;
  color: rgba(214.67, 217.42, 218.74, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(214.67, 217.42, 218.74, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-600 {
  --bs-text-opacity: 1;
  color: rgba(42.68, 53.68, 58.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42.68, 53.68, 58.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-200 {
  --bs-text-opacity: 1;
  color: rgba(174.34, 179.84, 182.48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.34, 179.84, 182.48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-700 {
  --bs-text-opacity: 1;
  color: rgba(32.01, 40.26, 44.22, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.01, 40.26, 44.22, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-300 {
  --bs-text-opacity: 1;
  color: rgba(134.01, 142.26, 146.22, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.01, 142.26, 146.22, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-800 {
  --bs-text-opacity: 1;
  color: rgba(21.34, 26.84, 29.48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.34, 26.84, 29.48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-400 {
  --bs-text-opacity: 1;
  color: rgba(93.68, 104.68, 109.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93.68, 104.68, 109.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-dark-900 {
  --bs-text-opacity: 1;
  color: rgba(10.67, 13.42, 14.74, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-dark-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(10.67, 13.42, 14.74, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-black {
  background-color: #000000 !important;
  background-image: linear-gradient(to bottom, rgb(25.5, 25.5, 25.5), black) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-black {
  --bs-theme: #000000 !important;
  --bs-theme-rgb: 0, 0, 0 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-black-100 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-600 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-200 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-700 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-300 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-800 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-400 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-black-900 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-black-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-white {
  background-color: #FFFFFF !important;
  background-image: linear-gradient(to bottom, white, rgb(242.25, 242.25, 242.25)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-white {
  --bs-theme: #FFFFFF !important;
  --bs-theme-rgb: 255, 255, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-white-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 204, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 204, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 153, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 153, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 102, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 102, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-white-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 51, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-white-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 51, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-purple {
  background-color: #de8cff !important;
  background-image: linear-gradient(to bottom, rgb(236.6347826087, 191, 255), rgb(214.6826086957, 114.5, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-purple {
  --bs-theme: #de8cff !important;
  --bs-theme-rgb: 222, 140, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(248.4, 232, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(248.4, 232, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-600 {
  --bs-text-opacity: 1;
  color: rgba(177.6, 112, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(177.6, 112, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-200 {
  --bs-text-opacity: 1;
  color: rgba(241.8, 209, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(241.8, 209, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-700 {
  --bs-text-opacity: 1;
  color: rgba(133.2, 84, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(133.2, 84, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-300 {
  --bs-text-opacity: 1;
  color: rgba(235.2, 186, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(235.2, 186, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-800 {
  --bs-text-opacity: 1;
  color: rgba(88.8, 56, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(88.8, 56, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-400 {
  --bs-text-opacity: 1;
  color: rgba(228.6, 163, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(228.6, 163, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-purple-900 {
  --bs-text-opacity: 1;
  color: rgba(44.4, 28, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-purple-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(44.4, 28, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-indigo {
  background-color: #bba4ff !important;
  background-image: linear-gradient(to bottom, rgb(225.1098901099, 215, 255), rgb(167.9450549451, 138.5, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-indigo {
  --bs-theme: #bba4ff !important;
  --bs-theme-rgb: 187, 164, 255 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-indigo-100 {
  --bs-text-opacity: 1;
  color: rgba(241.4, 236.8, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(241.4, 236.8, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-600 {
  --bs-text-opacity: 1;
  color: rgba(149.6, 131.2, 204, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(149.6, 131.2, 204, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-200 {
  --bs-text-opacity: 1;
  color: rgba(227.8, 218.6, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(227.8, 218.6, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-700 {
  --bs-text-opacity: 1;
  color: rgba(112.2, 98.4, 153, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(112.2, 98.4, 153, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-300 {
  --bs-text-opacity: 1;
  color: rgba(214.2, 200.4, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(214.2, 200.4, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-800 {
  --bs-text-opacity: 1;
  color: rgba(74.8, 65.6, 102, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(74.8, 65.6, 102, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-400 {
  --bs-text-opacity: 1;
  color: rgba(200.6, 182.2, 255, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(200.6, 182.2, 255, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-indigo-900 {
  --bs-text-opacity: 1;
  color: rgba(37.4, 32.8, 51, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-indigo-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(37.4, 32.8, 51, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-red {
  background-color: #ff6060 !important;
  background-image: linear-gradient(to bottom, #ff9393, rgb(255, 70.5, 70.5)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-red {
  --bs-theme: #ff6060 !important;
  --bs-theme-rgb: 255, 96, 96 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-red-100 {
  --bs-text-opacity: 1;
  color: rgba(255, 223.2, 223.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 223.2, 223.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-600 {
  --bs-text-opacity: 1;
  color: rgba(204, 76.8, 76.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(204, 76.8, 76.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-200 {
  --bs-text-opacity: 1;
  color: rgba(255, 191.4, 191.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 191.4, 191.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-700 {
  --bs-text-opacity: 1;
  color: rgba(153, 57.6, 57.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(153, 57.6, 57.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-300 {
  --bs-text-opacity: 1;
  color: rgba(255, 159.6, 159.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 159.6, 159.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-800 {
  --bs-text-opacity: 1;
  color: rgba(102, 38.4, 38.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(102, 38.4, 38.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-400 {
  --bs-text-opacity: 1;
  color: rgba(255, 127.8, 127.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 127.8, 127.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-red-900 {
  --bs-text-opacity: 1;
  color: rgba(51, 19.2, 19.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-red-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(51, 19.2, 19.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-pink {
  background-color: #f34fa0 !important;
  background-image: linear-gradient(to bottom, rgb(246.2553191489, 126.7446808511, 185.7712765957), rgb(241.3723404255, 55.1276595745, 147.1143617021)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-pink {
  --bs-theme: #f34fa0 !important;
  --bs-theme-rgb: 243, 79, 160 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-pink-100 {
  --bs-text-opacity: 1;
  color: rgba(252.6, 219.8, 236, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(252.6, 219.8, 236, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-600 {
  --bs-text-opacity: 1;
  color: rgba(194.4, 63.2, 128, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(194.4, 63.2, 128, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-200 {
  --bs-text-opacity: 1;
  color: rgba(250.2, 184.6, 217, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(250.2, 184.6, 217, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-700 {
  --bs-text-opacity: 1;
  color: rgba(145.8, 47.4, 96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(145.8, 47.4, 96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-300 {
  --bs-text-opacity: 1;
  color: rgba(247.8, 149.4, 198, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(247.8, 149.4, 198, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-800 {
  --bs-text-opacity: 1;
  color: rgba(97.2, 31.6, 64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(97.2, 31.6, 64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-400 {
  --bs-text-opacity: 1;
  color: rgba(245.4, 114.2, 179, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(245.4, 114.2, 179, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-pink-900 {
  --bs-text-opacity: 1;
  color: rgba(48.6, 15.8, 32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-pink-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(48.6, 15.8, 32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-green {
  background-color: #1ecc33 !important;
  background-image: linear-gradient(to bottom, rgb(58.8461538462, 226.1538461538, 79.0384615385), rgb(26.7307692308, 181.7692307692, 45.4423076923)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-green {
  --bs-theme: #1ecc33 !important;
  --bs-theme-rgb: 30, 204, 51 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-green-100 {
  --bs-text-opacity: 1;
  color: rgba(210, 244.8, 214.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(210, 244.8, 214.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-600 {
  --bs-text-opacity: 1;
  color: rgba(24, 163.2, 40.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 163.2, 40.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-200 {
  --bs-text-opacity: 1;
  color: rgba(165, 234.6, 173.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(165, 234.6, 173.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-700 {
  --bs-text-opacity: 1;
  color: rgba(18, 122.4, 30.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(18, 122.4, 30.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-300 {
  --bs-text-opacity: 1;
  color: rgba(120, 224.4, 132.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(120, 224.4, 132.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-800 {
  --bs-text-opacity: 1;
  color: rgba(12, 81.6, 20.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 81.6, 20.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-400 {
  --bs-text-opacity: 1;
  color: rgba(75, 214.2, 91.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(75, 214.2, 91.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-green-900 {
  --bs-text-opacity: 1;
  color: rgba(6, 40.8, 10.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-green-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(6, 40.8, 10.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-yellow {
  background-color: #f9e80d !important;
  background-image: linear-gradient(to bottom, rgb(250.2338709677, 236.7298387097, 62.7661290323), rgb(230.7782258065, 214.5665322581, 5.7217741935)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-yellow {
  --bs-theme: #f9e80d !important;
  --bs-theme-rgb: 249, 232, 13 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-yellow-100 {
  --bs-text-opacity: 1;
  color: rgba(253.8, 250.4, 206.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(253.8, 250.4, 206.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-600 {
  --bs-text-opacity: 1;
  color: rgba(199.2, 185.6, 10.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(199.2, 185.6, 10.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-200 {
  --bs-text-opacity: 1;
  color: rgba(252.6, 245.8, 158.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(252.6, 245.8, 158.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-700 {
  --bs-text-opacity: 1;
  color: rgba(149.4, 139.2, 7.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(149.4, 139.2, 7.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-300 {
  --bs-text-opacity: 1;
  color: rgba(251.4, 241.2, 109.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(251.4, 241.2, 109.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-800 {
  --bs-text-opacity: 1;
  color: rgba(99.6, 92.8, 5.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(99.6, 92.8, 5.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-400 {
  --bs-text-opacity: 1;
  color: rgba(250.2, 236.6, 61.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(250.2, 236.6, 61.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-yellow-900 {
  --bs-text-opacity: 1;
  color: rgba(49.8, 46.4, 2.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-yellow-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(49.8, 46.4, 2.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-teal {
  background-color: #3cd2a5 !important;
  background-image: linear-gradient(to bottom, rgb(101.4375, 219.5625, 184.125), rgb(45.84375, 198.65625, 152.8125)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-teal {
  --bs-theme: #3cd2a5 !important;
  --bs-theme-rgb: 60, 210, 165 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-teal-100 {
  --bs-text-opacity: 1;
  color: rgba(216, 246, 237, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(216, 246, 237, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-600 {
  --bs-text-opacity: 1;
  color: rgba(48, 168, 132, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(48, 168, 132, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-200 {
  --bs-text-opacity: 1;
  color: rgba(177, 237, 219, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(177, 237, 219, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-700 {
  --bs-text-opacity: 1;
  color: rgba(36, 126, 99, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(36, 126, 99, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-300 {
  --bs-text-opacity: 1;
  color: rgba(138, 228, 201, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(138, 228, 201, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-800 {
  --bs-text-opacity: 1;
  color: rgba(24, 84, 66, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(24, 84, 66, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-400 {
  --bs-text-opacity: 1;
  color: rgba(99, 219, 183, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(99, 219, 183, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-teal-900 {
  --bs-text-opacity: 1;
  color: rgba(12, 42, 33, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-teal-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(12, 42, 33, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-muted {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, rgb(122.7402597403, 147.4155844156, 159.2597402597), rgb(86.2922077922, 108.5324675325, 119.2077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-muted {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-muted-100 {
  --bs-text-opacity: 1;
  color: rgba(223.4, 228.4, 230.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223.4, 228.4, 230.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-600 {
  --bs-text-opacity: 1;
  color: rgba(77.6, 97.6, 107.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(77.6, 97.6, 107.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-200 {
  --bs-text-opacity: 1;
  color: rgba(191.8, 201.8, 206.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(191.8, 201.8, 206.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-700 {
  --bs-text-opacity: 1;
  color: rgba(58.2, 73.2, 80.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58.2, 73.2, 80.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-300 {
  --bs-text-opacity: 1;
  color: rgba(160.2, 175.2, 182.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160.2, 175.2, 182.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-800 {
  --bs-text-opacity: 1;
  color: rgba(38.8, 48.8, 53.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.8, 48.8, 53.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-400 {
  --bs-text-opacity: 1;
  color: rgba(128.6, 148.6, 158.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(128.6, 148.6, 158.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-muted-900 {
  --bs-text-opacity: 1;
  color: rgba(19.4, 24.4, 26.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-muted-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19.4, 24.4, 26.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-light {
  background-color: rgb(191.8, 201.8, 206.6) !important;
  background-image: linear-gradient(to bottom, rgb(220.6817204301, 226.111827957, 228.7182795699), rgb(177.3591397849, 189.6440860215, 195.5408602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-light {
  --bs-theme: rgb(191.8, 201.8, 206.6) !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-light-100 {
  --bs-text-opacity: 1;
  color: rgba(242.36, 244.36, 245.32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.36, 244.36, 245.32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-600 {
  --bs-text-opacity: 1;
  color: rgba(153.44, 161.44, 165.28, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(153.44, 161.44, 165.28, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-200 {
  --bs-text-opacity: 1;
  color: rgba(229.72, 233.72, 235.64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(229.72, 233.72, 235.64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-700 {
  --bs-text-opacity: 1;
  color: rgba(115.08, 121.08, 123.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115.08, 121.08, 123.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-300 {
  --bs-text-opacity: 1;
  color: rgba(217.08, 223.08, 225.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217.08, 223.08, 225.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-800 {
  --bs-text-opacity: 1;
  color: rgba(76.72, 80.72, 82.64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(76.72, 80.72, 82.64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-400 {
  --bs-text-opacity: 1;
  color: rgba(204.44, 212.44, 216.28, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.44, 212.44, 216.28, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-light-900 {
  --bs-text-opacity: 1;
  color: rgba(38.36, 40.36, 41.32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-light-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.36, 40.36, 41.32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-lime {
  background-color: #81f32d !important;
  background-image: linear-gradient(to bottom, rgb(157.9459459459, 245.7567567568, 93.2432432432), rgb(114.527027027, 241.6216216216, 20.8783783784)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-lime {
  --bs-theme: #81f32d !important;
  --bs-theme-rgb: 129, 243, 45 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-lime-100 {
  --bs-text-opacity: 1;
  color: rgba(229.8, 252.6, 213, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(229.8, 252.6, 213, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-600 {
  --bs-text-opacity: 1;
  color: rgba(103.2, 194.4, 36, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(103.2, 194.4, 36, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-200 {
  --bs-text-opacity: 1;
  color: rgba(204.6, 250.2, 171, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.6, 250.2, 171, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-700 {
  --bs-text-opacity: 1;
  color: rgba(77.4, 145.8, 27, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(77.4, 145.8, 27, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-300 {
  --bs-text-opacity: 1;
  color: rgba(179.4, 247.8, 129, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(179.4, 247.8, 129, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-800 {
  --bs-text-opacity: 1;
  color: rgba(51.6, 97.2, 18, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(51.6, 97.2, 18, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-400 {
  --bs-text-opacity: 1;
  color: rgba(154.2, 245.4, 87, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(154.2, 245.4, 87, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-lime-900 {
  --bs-text-opacity: 1;
  color: rgba(25.8, 48.6, 9, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-lime-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(25.8, 48.6, 9, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-100 {
  background-color: rgb(191.8, 201.8, 206.6) !important;
  background-image: linear-gradient(to bottom, rgb(220.6817204301, 226.111827957, 228.7182795699), rgb(177.3591397849, 189.6440860215, 195.5408602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-100 {
  --bs-theme: rgb(191.8, 201.8, 206.6) !important;
  --bs-theme-rgb: 192, 202, 207 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-gray-100-100 {
  --bs-text-opacity: 1;
  color: rgba(242.36, 244.36, 245.32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(242.36, 244.36, 245.32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-600 {
  --bs-text-opacity: 1;
  color: rgba(153.44, 161.44, 165.28, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(153.44, 161.44, 165.28, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-200 {
  --bs-text-opacity: 1;
  color: rgba(229.72, 233.72, 235.64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(229.72, 233.72, 235.64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-700 {
  --bs-text-opacity: 1;
  color: rgba(115.08, 121.08, 123.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(115.08, 121.08, 123.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-300 {
  --bs-text-opacity: 1;
  color: rgba(217.08, 223.08, 225.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(217.08, 223.08, 225.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-800 {
  --bs-text-opacity: 1;
  color: rgba(76.72, 80.72, 82.64, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(76.72, 80.72, 82.64, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-400 {
  --bs-text-opacity: 1;
  color: rgba(204.44, 212.44, 216.28, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(204.44, 212.44, 216.28, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-100-900 {
  --bs-text-opacity: 1;
  color: rgba(38.36, 40.36, 41.32, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-100-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.36, 40.36, 41.32, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-200 {
  background-color: rgb(168.1, 181.85, 188.45) !important;
  background-image: linear-gradient(to bottom, rgb(196.9817204301, 206.161827957, 210.5682795699), rgb(153.6591397849, 169.6940860215, 177.3908602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-200 {
  --bs-theme: rgb(168.1, 181.85, 188.45) !important;
  --bs-theme-rgb: 168, 182, 188 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-gray-200-100 {
  --bs-text-opacity: 1;
  color: rgba(237.62, 240.37, 241.69, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(237.62, 240.37, 241.69, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-600 {
  --bs-text-opacity: 1;
  color: rgba(134.48, 145.48, 150.76, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.48, 145.48, 150.76, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-200 {
  --bs-text-opacity: 1;
  color: rgba(220.24, 225.74, 228.38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(220.24, 225.74, 228.38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-700 {
  --bs-text-opacity: 1;
  color: rgba(100.86, 109.11, 113.07, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(100.86, 109.11, 113.07, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-300 {
  --bs-text-opacity: 1;
  color: rgba(202.86, 211.11, 215.07, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(202.86, 211.11, 215.07, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-800 {
  --bs-text-opacity: 1;
  color: rgba(67.24, 72.74, 75.38, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(67.24, 72.74, 75.38, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-400 {
  --bs-text-opacity: 1;
  color: rgba(185.48, 196.48, 201.76, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(185.48, 196.48, 201.76, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-200-900 {
  --bs-text-opacity: 1;
  color: rgba(33.62, 36.37, 37.69, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-200-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(33.62, 36.37, 37.69, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-300 {
  background-color: rgb(144.4, 161.9, 170.3) !important;
  background-image: linear-gradient(to bottom, rgb(173.2817204301, 186.211827957, 192.4182795699), rgb(129.9591397849, 149.7440860215, 159.2408602151)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-300 {
  --bs-theme: rgb(144.4, 161.9, 170.3) !important;
  --bs-theme-rgb: 144, 162, 170 !important;
  --bs-theme-color: #000000 !important;
  --bs-theme-color-rgb: 0, 0, 0 !important;
}
[data-bs-theme=dark] .text-gray-300-100 {
  --bs-text-opacity: 1;
  color: rgba(232.88, 236.38, 238.06, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(232.88, 236.38, 238.06, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-600 {
  --bs-text-opacity: 1;
  color: rgba(115.52, 129.52, 136.24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(115.52, 129.52, 136.24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-200 {
  --bs-text-opacity: 1;
  color: rgba(210.76, 217.76, 221.12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(210.76, 217.76, 221.12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-700 {
  --bs-text-opacity: 1;
  color: rgba(86.64, 97.14, 102.18, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(86.64, 97.14, 102.18, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-300 {
  --bs-text-opacity: 1;
  color: rgba(188.64, 199.14, 204.18, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(188.64, 199.14, 204.18, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-800 {
  --bs-text-opacity: 1;
  color: rgba(57.76, 64.76, 68.12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(57.76, 64.76, 68.12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-400 {
  --bs-text-opacity: 1;
  color: rgba(166.52, 180.52, 187.24, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(166.52, 180.52, 187.24, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-300-900 {
  --bs-text-opacity: 1;
  color: rgba(28.88, 32.38, 34.06, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-300-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(28.88, 32.38, 34.06, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-400 {
  background-color: rgb(120.7, 141.95, 152.15) !important;
  background-image: linear-gradient(to bottom, rgb(149.5817204301, 166.261827957, 174.2682795699), rgb(107.273655914, 129.4376344086, 140.076344086)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-400 {
  --bs-theme: rgb(120.7, 141.95, 152.15) !important;
  --bs-theme-rgb: 121, 142, 152 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-400-100 {
  --bs-text-opacity: 1;
  color: rgba(228.14, 232.39, 234.43, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(228.14, 232.39, 234.43, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-600 {
  --bs-text-opacity: 1;
  color: rgba(96.56, 113.56, 121.72, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(96.56, 113.56, 121.72, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-200 {
  --bs-text-opacity: 1;
  color: rgba(201.28, 209.78, 213.86, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(201.28, 209.78, 213.86, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-700 {
  --bs-text-opacity: 1;
  color: rgba(72.42, 85.17, 91.29, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(72.42, 85.17, 91.29, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-300 {
  --bs-text-opacity: 1;
  color: rgba(174.42, 187.17, 193.29, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.42, 187.17, 193.29, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-800 {
  --bs-text-opacity: 1;
  color: rgba(48.28, 56.78, 60.86, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(48.28, 56.78, 60.86, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-400 {
  --bs-text-opacity: 1;
  color: rgba(147.56, 164.56, 172.72, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(147.56, 164.56, 172.72, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-400-900 {
  --bs-text-opacity: 1;
  color: rgba(24.14, 28.39, 30.43, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-400-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(24.14, 28.39, 30.43, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-500 {
  background-color: #617a86 !important;
  background-image: linear-gradient(to bottom, rgb(122.7402597403, 147.4155844156, 159.2597402597), rgb(86.2922077922, 108.5324675325, 119.2077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-500 {
  --bs-theme: #617a86 !important;
  --bs-theme-rgb: 97, 122, 134 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-500-100 {
  --bs-text-opacity: 1;
  color: rgba(223.4, 228.4, 230.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(223.4, 228.4, 230.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-600 {
  --bs-text-opacity: 1;
  color: rgba(77.6, 97.6, 107.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(77.6, 97.6, 107.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-200 {
  --bs-text-opacity: 1;
  color: rgba(191.8, 201.8, 206.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(191.8, 201.8, 206.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-700 {
  --bs-text-opacity: 1;
  color: rgba(58.2, 73.2, 80.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(58.2, 73.2, 80.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-300 {
  --bs-text-opacity: 1;
  color: rgba(160.2, 175.2, 182.4, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(160.2, 175.2, 182.4, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-800 {
  --bs-text-opacity: 1;
  color: rgba(38.8, 48.8, 53.6, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(38.8, 48.8, 53.6, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-400 {
  --bs-text-opacity: 1;
  color: rgba(128.6, 148.6, 158.2, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(128.6, 148.6, 158.2, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-500-900 {
  --bs-text-opacity: 1;
  color: rgba(19.4, 24.4, 26.8, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-500-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(19.4, 24.4, 26.8, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-600 {
  background-color: rgb(82.45, 103.7, 113.9) !important;
  background-image: linear-gradient(to bottom, rgb(103.8655844156, 130.6350649351, 143.4844155844), rgb(71.7422077922, 90.2324675325, 99.1077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-600 {
  --bs-theme: rgb(82.45, 103.7, 113.9) !important;
  --bs-theme-rgb: 82, 104, 114 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-600-100 {
  --bs-text-opacity: 1;
  color: rgba(220.49, 224.74, 226.78, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(220.49, 224.74, 226.78, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-600 {
  --bs-text-opacity: 1;
  color: rgba(65.96, 82.96, 91.12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(65.96, 82.96, 91.12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-200 {
  --bs-text-opacity: 1;
  color: rgba(185.98, 194.48, 198.56, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(185.98, 194.48, 198.56, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-700 {
  --bs-text-opacity: 1;
  color: rgba(49.47, 62.22, 68.34, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(49.47, 62.22, 68.34, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-300 {
  --bs-text-opacity: 1;
  color: rgba(151.47, 164.22, 170.34, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(151.47, 164.22, 170.34, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-800 {
  --bs-text-opacity: 1;
  color: rgba(32.98, 41.48, 45.56, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.98, 41.48, 45.56, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-400 {
  --bs-text-opacity: 1;
  color: rgba(116.96, 133.96, 142.12, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(116.96, 133.96, 142.12, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-600-900 {
  --bs-text-opacity: 1;
  color: rgba(16.49, 20.74, 22.78, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-600-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(16.49, 20.74, 22.78, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-700 {
  background-color: rgb(67.9, 85.4, 93.8) !important;
  background-image: linear-gradient(to bottom, rgb(89.3155844156, 112.3350649351, 123.3844155844), rgb(57.1922077922, 71.9324675325, 79.0077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-700 {
  --bs-theme: rgb(67.9, 85.4, 93.8) !important;
  --bs-theme-rgb: 68, 85, 94 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-700-100 {
  --bs-text-opacity: 1;
  color: rgba(217.58, 221.08, 222.76, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(217.58, 221.08, 222.76, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-600 {
  --bs-text-opacity: 1;
  color: rgba(54.32, 68.32, 75.04, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(54.32, 68.32, 75.04, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-200 {
  --bs-text-opacity: 1;
  color: rgba(180.16, 187.16, 190.52, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(180.16, 187.16, 190.52, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-700 {
  --bs-text-opacity: 1;
  color: rgba(40.74, 51.24, 56.28, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(40.74, 51.24, 56.28, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-300 {
  --bs-text-opacity: 1;
  color: rgba(142.74, 153.24, 158.28, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(142.74, 153.24, 158.28, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-800 {
  --bs-text-opacity: 1;
  color: rgba(27.16, 34.16, 37.52, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(27.16, 34.16, 37.52, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-400 {
  --bs-text-opacity: 1;
  color: rgba(105.32, 119.32, 126.04, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(105.32, 119.32, 126.04, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-700-900 {
  --bs-text-opacity: 1;
  color: rgba(13.58, 17.08, 18.76, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-700-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(13.58, 17.08, 18.76, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-800 {
  background-color: rgb(53.35, 67.1, 73.7) !important;
  background-image: linear-gradient(to bottom, rgb(74.7655844156, 94.0350649351, 103.2844155844), rgb(42.6422077922, 53.6324675325, 58.9077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-800 {
  --bs-theme: rgb(53.35, 67.1, 73.7) !important;
  --bs-theme-rgb: 53, 67, 74 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-800-100 {
  --bs-text-opacity: 1;
  color: rgba(214.67, 217.42, 218.74, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(214.67, 217.42, 218.74, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-600 {
  --bs-text-opacity: 1;
  color: rgba(42.68, 53.68, 58.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(42.68, 53.68, 58.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-200 {
  --bs-text-opacity: 1;
  color: rgba(174.34, 179.84, 182.48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(174.34, 179.84, 182.48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-700 {
  --bs-text-opacity: 1;
  color: rgba(32.01, 40.26, 44.22, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(32.01, 40.26, 44.22, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-300 {
  --bs-text-opacity: 1;
  color: rgba(134.01, 142.26, 146.22, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(134.01, 142.26, 146.22, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-800 {
  --bs-text-opacity: 1;
  color: rgba(21.34, 26.84, 29.48, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(21.34, 26.84, 29.48, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-400 {
  --bs-text-opacity: 1;
  color: rgba(93.68, 104.68, 109.96, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(93.68, 104.68, 109.96, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-800-900 {
  --bs-text-opacity: 1;
  color: rgba(10.67, 13.42, 14.74, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-800-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(10.67, 13.42, 14.74, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .bg-gradient-gray-900 {
  background-color: rgb(38.8, 48.8, 53.6) !important;
  background-image: linear-gradient(to bottom, rgb(60.2155844156, 75.7350649351, 83.1844155844), rgb(28.0922077922, 35.3324675325, 38.8077922078)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="lighten(\$value, 10%)", endColorstr="darken(\$value, 5%)",GradientType=0 ) !important;
}
[data-bs-theme=dark] .theme-gray-900 {
  --bs-theme: rgb(38.8, 48.8, 53.6) !important;
  --bs-theme-rgb: 39, 49, 54 !important;
  --bs-theme-color: #FFFFFF !important;
  --bs-theme-color-rgb: 255, 255, 255 !important;
}
[data-bs-theme=dark] .text-gray-900-100 {
  --bs-text-opacity: 1;
  color: rgba(211.76, 213.76, 214.72, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(211.76, 213.76, 214.72, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-600 {
  --bs-text-opacity: 1;
  color: rgba(31.04, 39.04, 42.88, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(31.04, 39.04, 42.88, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-200 {
  --bs-text-opacity: 1;
  color: rgba(168.52, 172.52, 174.44, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(168.52, 172.52, 174.44, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-700 {
  --bs-text-opacity: 1;
  color: rgba(23.28, 29.28, 32.16, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(23.28, 29.28, 32.16, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-300 {
  --bs-text-opacity: 1;
  color: rgba(125.28, 131.28, 134.16, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(125.28, 131.28, 134.16, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-800 {
  --bs-text-opacity: 1;
  color: rgba(15.52, 19.52, 21.44, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(15.52, 19.52, 21.44, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-400 {
  --bs-text-opacity: 1;
  color: rgba(82.04, 90.04, 93.88, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(82.04, 90.04, 93.88, var(--bs-bg-opacity)) !important;
}
[data-bs-theme=dark] .text-gray-900-900 {
  --bs-text-opacity: 1;
  color: rgba(7.76, 9.76, 10.72, var(--bs-text-opacity)) !important;
}
[data-bs-theme=dark] .bg-gray-900-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(7.76, 9.76, 10.72, var(--bs-bg-opacity)) !important;
}

.bg-none {
  background: none !important;
}

.bg-position-center {
  background-position: center !important;
}

.bg-size-cover {
  background-size: cover !important;
}

.bg-repeat-no-repeat {
  background-repeat: no-repeat !important;
}

.bg-gradient-orange-red {
  background: rgb(255, 179.1481481481, 63);
}

.bg-gradient-orange-red {
  background: linear-gradient(to top, rgb(255, 179.1481481481, 63), #ff1414) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-red-orange {
  background: #ff1414;
}

.bg-gradient-red-orange {
  background: linear-gradient(to top, #ff1414, rgb(255, 179.1481481481, 63)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-red-pink {
  background: #ff1414;
}

.bg-gradient-red-pink {
  background: linear-gradient(to top, #ff1414, rgb(241.1463414634, 55.8536585366, 146.7682926829)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-yellow-orange {
  background: rgb(250.2338709677, 236.7298387097, 62.7661290323);
}

.bg-gradient-yellow-orange {
  background: linear-gradient(to top, rgb(250.2338709677, 236.7298387097, 62.7661290323), rgb(255, 179.1481481481, 63)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-yellow-red {
  background: rgb(250.2338709677, 236.7298387097, 62.7661290323);
}

.bg-gradient-yellow-red {
  background: linear-gradient(to top, rgb(250.2338709677, 236.7298387097, 62.7661290323), #ff1414) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-yellow-green {
  background: rgb(250.2338709677, 236.7298387097, 62.7661290323);
}

.bg-gradient-yellow-green {
  background: linear-gradient(to top, rgb(250.2338709677, 236.7298387097, 62.7661290323), rgb(26.4968152866, 181.5031847134, 45.0445859873)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-blue-indigo {
  background: #0271ff;
}

.bg-gradient-blue-indigo {
  background: linear-gradient(to top, #0271ff, #5c25ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-blue-cyan {
  background: #0271ff;
}

.bg-gradient-blue-cyan {
  background: linear-gradient(to top, #0271ff, #009be3) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-cyan-blue {
  background: #009be3;
}

.bg-gradient-cyan-blue {
  background: linear-gradient(to top, #009be3, #0271ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-cyan-indigo {
  background: #009be3;
}

.bg-gradient-cyan-indigo {
  background: linear-gradient(to top, #009be3, #5c25ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-indigo-blue {
  background: #5c25ff;
}

.bg-gradient-indigo-blue {
  background: linear-gradient(to top, #5c25ff, #0271ff) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-orange {
  background: rgb(244.4029850746, 113, 95.1970149254);
}

.bg-gradient-custom-orange {
  background: linear-gradient(to left, rgb(244.4029850746, 113, 95.1970149254), rgb(246.6231343284, 142.75, 128.6768656716)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-pink {
  background: rgb(239.2731707317, 28.9268292683, 132.1341463415);
}

.bg-gradient-custom-pink {
  background: linear-gradient(to left, rgb(239.2731707317, 28.9268292683, 132.1341463415), rgb(241.5951219512, 62.3048780488, 150.2743902439)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-teal {
  background: rgb(29.52, 128.74, 99.22);
}

.bg-gradient-custom-teal {
  background: linear-gradient(to left, rgb(29.52, 128.74, 99.22), #249d79) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-indigo {
  background: rgb(138.8472914875, 102.6361994841, 246.1638005159);
}

.bg-gradient-custom-indigo {
  background: linear-gradient(to left, rgb(138.8472914875, 102.6361994841, 246.1638005159), rgb(179.2701633706, 155.6610705073, 249.2389294927)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-custom-blue {
  background: #0271ff;
}

.bg-gradient-custom-blue {
  background: linear-gradient(to left, #0271ff, rgb(53, 141.6245059289, 255)) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$from", endColorstr="\$to",GradientType=0 ) !important;
}

.bg-gradient-indigo-teal {
  background-image: linear-gradient(to left, #5c25ff, #0271ff, #249d79) !important;
}

[data-bs-theme=dark] .invert-dark {
  filter: invert(1);
}

/* Helper Opacity */
.opacity-0 {
  opacity: 0 !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.text-opacity-0 {
  --bs-text-opacity: 0;
}

.text-opacity-5 {
  --bs-text-opacity: 0.05;
}

.bg-opacity-0 {
  --bs-bg-opacity: 0;
}

.bg-opacity-5 {
  --bs-bg-opacity: 0.05;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.text-opacity-10 {
  --bs-text-opacity: 0.1;
}

.text-opacity-15 {
  --bs-text-opacity: 0.15;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-15 {
  --bs-bg-opacity: 0.15;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-30 {
  opacity: 0.3 !important;
}

.text-opacity-20 {
  --bs-text-opacity: 0.2;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.bg-opacity-20 {
  --bs-bg-opacity: 0.2;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-45 {
  opacity: 0.45 !important;
}

.text-opacity-30 {
  --bs-text-opacity: 0.3;
}

.text-opacity-35 {
  --bs-text-opacity: 0.35;
}

.bg-opacity-30 {
  --bs-bg-opacity: 0.3;
}

.bg-opacity-35 {
  --bs-bg-opacity: 0.35;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-60 {
  opacity: 0.6 !important;
}

.text-opacity-40 {
  --bs-text-opacity: 0.4;
}

.text-opacity-45 {
  --bs-text-opacity: 0.45;
}

.bg-opacity-40 {
  --bs-bg-opacity: 0.4;
}

.bg-opacity-45 {
  --bs-bg-opacity: 0.45;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-55 {
  --bs-text-opacity: 0.55;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-55 {
  --bs-bg-opacity: 0.55;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-90 {
  opacity: 0.9 !important;
}

.text-opacity-60 {
  --bs-text-opacity: 0.6;
}

.text-opacity-65 {
  --bs-text-opacity: 0.65;
}

.bg-opacity-60 {
  --bs-bg-opacity: 0.6;
}

.bg-opacity-65 {
  --bs-bg-opacity: 0.65;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-105 {
  opacity: 1.05 !important;
}

.text-opacity-70 {
  --bs-text-opacity: 0.7;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.bg-opacity-70 {
  --bs-bg-opacity: 0.7;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-120 {
  opacity: 1.2 !important;
}

.text-opacity-80 {
  --bs-text-opacity: 0.8;
}

.text-opacity-85 {
  --bs-text-opacity: 0.85;
}

.bg-opacity-80 {
  --bs-bg-opacity: 0.8;
}

.bg-opacity-85 {
  --bs-bg-opacity: 0.85;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-135 {
  opacity: 1.35 !important;
}

.text-opacity-90 {
  --bs-text-opacity: 0.9;
}

.text-opacity-95 {
  --bs-text-opacity: 0.95;
}

.bg-opacity-90 {
  --bs-bg-opacity: 0.9;
}

.bg-opacity-95 {
  --bs-bg-opacity: 0.95;
}

.opacity-10 {
  opacity: 1 !important;
}

.opacity-150 {
  opacity: 1.5 !important;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-opacity-105 {
  --bs-text-opacity: 1.05;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-opacity-105 {
  --bs-bg-opacity: 1.05;
}

/* Helper Sticky Top */
@media (min-width: 1200px) {
  .desktop-sticky-top {
    position: sticky;
    top: 4.5rem;
  }
}

/* Helper Outline */
.outline-none {
  outline: none !important;
}

.bg-cover-2:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-2:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.bg-cover-3:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-3:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

.bg-cover-4:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-4:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

.bg-cover-5:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-5:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

.bg-cover-6:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-6:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

.bg-cover-7:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-7:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.bg-cover-8:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-8:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

.bg-cover-9:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.bg-cover-none:after {
  background-color: var(--bs-body-bg);
}

[data-bs-theme=dark].bg-cover-9:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

/* Helper Flex */
.flex-1 {
  flex: 1 1 !important;
}

/* Helper Theme */
.list-group-item.active,
.page-item.active .page-link,
.form-check-input:checked,
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}

.btn-theme {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
  position: relative;
}
.btn-theme:before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn-theme:before {
    transition: none;
  }
}
.btn-theme.disabled, .btn-theme:disabled {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-theme:hover, .btn-theme:focus, .btn-theme:active, .btn-theme.active {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-theme:hover:before, .btn-theme:focus:before, .btn-theme:active:before, .btn-theme.active:before {
  background: rgba(255, 255, 255, 0.2);
}
.btn-outline-theme {
  color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-outline-theme:hover, .btn-outline-theme.active {
  background-color: var(--bs-theme);
  border-color: var(--bs-theme);
}
.btn-outline-theme.disabled, .btn-outline-theme:disabled {
  color: var(--bs-theme);
}
.nav-link {
  color: var(--bs-theme);
}
.nav-link:hover {
  color: rgba(var(--bs-theme-rgb), 0.5);
}

.app-content {
  padding: 2rem 2rem;
  flex: 1 1;
  margin-left: 16.875rem;
}
@media (max-width: 767.98px) {
  .app-content {
    padding: 1rem 1rem;
    margin-left: 0;
  }
}
.app-content .app-content-inner-padding {
  padding: 2rem 2rem;
}
@media (max-width: 767.98px) {
  .app-content .app-content-inner-padding {
    padding: 1rem 1rem;
  }
}
.app-content .app-content-inner-padding-x {
  padding-left: 2rem;
  padding-right: 2rem;
}
@media (max-width: 767.98px) {
  .app-content .app-content-inner-padding-x {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.app-content .app-content-inner-padding-y {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
@media (max-width: 767.98px) {
  .app-content .app-content-inner-padding-y {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}

.app-footer {
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1.25rem 0;
  border-top: 1px solid var(--bs-border-color);
  font-weight: 600;
  color: rgba(var(--bs-body-color-rgb), 0.5);
  margin-left: 18.875rem;
  margin-right: 2rem;
}
@media (max-width: 767.98px) {
  .app-footer {
    padding: 1rem 0;
    margin: 0 1rem;
  }
}

.app-header {
  height: 3.25rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1020;
  background: var(--bs-app-header-bg);
  display: flex;
  transition: all 0.15s ease-in-out;
}
.app-header .menu-toggler {
  border: none;
  background: none;
  height: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.app-header .menu-toggler .bar {
  width: 1.625rem;
  display: block;
  height: 1px;
  background: rgba(var(--bs-app-header-link-color-rgb), 0.4);
  transition: all 0.2s linear;
}
.app-header .menu-toggler .bar + .bar {
  margin-top: 0.25rem;
}
.app-header .menu-toggler:hover .bar {
  background: rgba(var(--bs-app-header-link-color-rgb), 0.75);
}
.app-header .mobile-toggler {
  height: 100%;
  display: none;
  margin-right: auto;
}
@media (max-width: 767.98px) {
  .app-header .mobile-toggler {
    display: flex;
    align-items: center;
  }
}
.app-header .desktop-toggler {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: auto;
}
@media (max-width: 767.98px) {
  .app-header .desktop-toggler {
    display: none;
  }
}
.app-header .brand {
  height: 100%;
  width: 18.875rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .app-header .brand {
    display: none;
  }
}
.app-header .brand .brand-logo {
  text-decoration: none;
  color: var(--bs-app-header-link-color);
  font-size: 0.91875rem;
  letter-spacing: 2px;
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .app-header .brand .brand-logo {
    display: none;
  }
}
.app-header .brand .brand-logo img {
  max-width: 100%;
  max-height: 100%;
  margin-right: 1rem;
}
.app-header .brand .brand-logo .brand-img {
  width: 1.625rem;
  height: 1.625rem;
  background: var(--bs-app-header-brand-img);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}
.app-header .brand .brand-logo .brand-img .brand-img-text {
  display: block;
  letter-spacing: initial;
  font-weight: 600;
  font-size: 1.05rem;
}
.app-header .menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1;
}
.app-header .menu .menu-item {
  height: 100%;
  display: flex;
  align-items: center;
}
.app-header .menu .menu-item .menu-link {
  text-decoration: none;
  color: var(--bs-app-header-link-color);
  position: relative;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
}
.app-header .menu .menu-item .menu-link .menu-img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.75rem;
}
.app-header .menu .menu-item .menu-link .menu-img img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 30px;
}
.app-header .menu .menu-item .menu-link .menu-icon {
  font-size: 1.25rem;
}
.app-header .menu .menu-item .menu-link .menu-badge {
  position: absolute;
  background: transparent;
  width: 6px;
  height: 6px;
  top: 0.5rem;
  border-radius: 6px;
  right: 1rem;
}
.app-header .menu-search {
  position: absolute;
  top: -3.25rem;
  left: 0;
  right: 0;
  height: 3.25rem;
  background: var(--bs-app-header-bg);
  transition: all 0.2s ease-in-out;
}
.app-header .menu-search .menu-search-container {
  max-width: 60.4375rem;
  margin: 0 auto;
  height: 3.25rem;
  display: flex;
}
.app-header .menu-search .menu-search-container .menu-search-icon {
  padding: 0 1rem;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
}
.app-header .menu-search .menu-search-container .menu-search-icon .bi:before {
  display: block;
}
.app-header .menu-search .menu-search-container .menu-search-icon a {
  color: rgba(var(--bs-app-header-link-color-rgb), 0.5);
  text-decoration: none;
  display: block;
  transition: all 0.2s linear;
}
.app-header .menu-search .menu-search-container .menu-search-icon a:hover {
  color: var(--bs-app-header-link-color);
}
.app-header .menu-search .menu-search-container .menu-search-input {
  flex: 1 1;
}
.app-header .menu-search .menu-search-container .menu-search-input .form-control {
  border: none;
  padding-left: 0;
  height: 100%;
  box-shadow: none;
}
.app-header-menu-search-toggled .app-header .menu-search {
  top: 0;
}
@media (max-width: 991.98px) {
  .app-header.navbar .navbar-collapse {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    background: var(--bs-app-header-bg);
    padding: 0 1rem;
  }
}

.app-sidebar-mobile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1020;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  margin: 0;
  outline: none;
  display: none;
  background: rgba(0, 0, 0, 0.25);
}

@keyframes appSidebarSubMenuSlideInRight {
  to {
    transform: translate3d(0, 0, 0);
  }
}
.app-sidebar {
  width: 16.875rem;
  bottom: 0;
  position: fixed;
  top: 3.25rem;
  z-index: 1010;
  left: 0;
}
@media (max-width: 767.98px) {
  .app-sidebar {
    top: 0;
    z-index: 1030;
    background: var(--bs-app-sidebar-mobile-bg);
    left: -16.875rem;
  }
}
.app-sidebar .slimScrollDiv {
  width: 100% !important;
}
.app-sidebar .slimScrollDiv .slimScrollBar, .app-sidebar .slimScrollDiv .slimScrollRail {
  display: none !important;
}
.app-sidebar .app-sidebar-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.app-sidebar .app-sidebar-content .menu {
  position: relative;
}
.app-sidebar .app-sidebar-content .menu .menu-header {
  padding: 1rem 1rem 0.5rem;
  font-size: 0.65625rem;
  font-weight: 600;
  color: var(--bs-app-sidebar-menu-header-color);
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link {
  text-decoration: none;
  position: relative;
  padding: 0.3rem 1rem;
  color: var(--bs-app-sidebar-menu-link-color);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.2s ease-in-out;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-icon {
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.05rem;
  margin: -0.25rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-caret {
  margin: -0.3125rem 0;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link .menu-text {
  flex: 1 1;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-link:hover, .app-sidebar .app-sidebar-content .menu .menu-item .menu-link:focus {
  color: var(--bs-app-sidebar-menu-link-hover-color);
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu {
  background: none;
  display: none;
  padding: 0 0 1rem;
}
.app-sidebar .app-sidebar-content .menu .menu-item .menu-submenu .menu-item {
  position: relative;
  padding-left: 2.625rem;
}
.app-sidebar .app-sidebar-content .menu .menu-item.active:not(.has-sub) > .menu-link {
  color: var(--bs-app-sidebar-menu-link-active-color);
}
.app-sidebar .app-sidebar-content .menu .menu-item.active > .menu-link .menu-icon {
  color: var(--bs-theme);
}
.app-sidebar .app-sidebar-content .menu .menu-item.active.has-sub > .menu-submenu {
  display: block;
}
.app-sidebar .app-sidebar-content .menu .menu-item.expand > .menu-submenu {
  display: block;
}
.app-sidebar .app-sidebar-content .menu .menu-item.expand > .menu-submenu > .menu-item {
  animation: appSidebarSubMenuSlideInRight 0.3s both cubic-bezier(0.7, 0, 0.3, 1);
  transform: translate3d(-100%, 0, 0);
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(2), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(2) {
  animation-delay: 45ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(3), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(3) {
  animation-delay: 60ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(4), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(4) {
  animation-delay: 75ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(5), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(5) {
  animation-delay: 90ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(6), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(6) {
  animation-delay: 105ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(7), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(7) {
  animation-delay: 120ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(8), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(8) {
  animation-delay: 135ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(9), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(9) {
  animation-delay: 150ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(10), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(10) {
  animation-delay: 165ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(11), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(11) {
  animation-delay: 180ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(12), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(12) {
  animation-delay: 195ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(13), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(13) {
  animation-delay: 210ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(14), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(14) {
  animation-delay: 225ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(15), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(15) {
  animation-delay: 240ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(16), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(16) {
  animation-delay: 255ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(17), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(17) {
  animation-delay: 270ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(18), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(18) {
  animation-delay: 285ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(19), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(19) {
  animation-delay: 300ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(20), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(20) {
  animation-delay: 315ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(21), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(21) {
  animation-delay: 330ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(22), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(22) {
  animation-delay: 345ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(23), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(23) {
  animation-delay: 360ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(24), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(24) {
  animation-delay: 375ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(25), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(25) {
  animation-delay: 390ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(26), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(26) {
  animation-delay: 405ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(27), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(27) {
  animation-delay: 420ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(28), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(28) {
  animation-delay: 435ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(29), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(29) {
  animation-delay: 450ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(30), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(30) {
  animation-delay: 465ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(31), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(31) {
  animation-delay: 480ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(32), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(32) {
  animation-delay: 495ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(33), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(33) {
  animation-delay: 510ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(34), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(34) {
  animation-delay: 525ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(35), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(35) {
  animation-delay: 540ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(36), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(36) {
  animation-delay: 555ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(37), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(37) {
  animation-delay: 570ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(38), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(38) {
  animation-delay: 585ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(39), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(39) {
  animation-delay: 600ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(40), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(40) {
  animation-delay: 615ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(41), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(41) {
  animation-delay: 630ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(42), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(42) {
  animation-delay: 645ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(43), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(43) {
  animation-delay: 660ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(44), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(44) {
  animation-delay: 675ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(45), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(45) {
  animation-delay: 690ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(46), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(46) {
  animation-delay: 705ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(47), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(47) {
  animation-delay: 720ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(48), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(48) {
  animation-delay: 735ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(49), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(49) {
  animation-delay: 750ms;
}
.app-sidebar .app-sidebar-content .menu .collapse.expand > .menu-item:nth-child(50), .app-sidebar .app-sidebar-content .menu .menu-item > .menu-submenu > .menu-item:nth-child(50) {
  animation-delay: 765ms;
}
.app-sidebar .app-sidebar-mobile-backdrop {
  display: none;
}
.app-sidebar.uppercase-mode {
  text-transform: uppercase;
}
.app-sidebar.uppercase-mode .app-sidebar-content .menu .menu-item .menu-link {
  font-size: 0.83125rem;
}

.app-theme-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1030;
  width: 0;
  display: flex;
  align-items: center;
  right: -12rem;
  transition: right 0.2s ease-in-out;
}
.app-theme-panel .app-theme-panel-container {
  width: 12rem;
  position: absolute;
  right: 0;
}
.app-theme-panel .app-theme-panel-content {
  width: 12rem;
  background: var(--bs-app-theme-panel-bg);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  padding: 0.5rem;
  z-index: 10;
}
.app-theme-panel .app-theme-panel-content .app-theme-list {
  margin: -0.25rem;
  display: flex;
  flex-wrap: wrap;
}
.app-theme-panel .app-theme-panel-content .app-theme-list .app-theme-list-item {
  padding: 0.25rem;
  width: 25%;
}
.app-theme-panel .app-theme-panel-content .app-theme-list .app-theme-list-item .app-theme-list-link {
  height: 2rem;
  display: block;
  text-decoration: none;
  position: relative;
  transition: all 0.2s linear;
}
.app-theme-panel .app-theme-panel-content .app-theme-list .app-theme-list-item .app-theme-list-link:hover {
  opacity: 0.6;
}
.app-theme-panel .app-theme-panel-content .app-theme-list .app-theme-list-item.active .app-theme-list-link {
  opacity: 1;
}
.app-theme-panel .app-theme-panel-content .app-theme-list .app-theme-list-item.active .app-theme-list-link:before {
  content: "\\f00c";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link {
  color: #FFFFFF;
  text-decoration: none;
  text-align: center;
  position: relative;
  display: block;
  transition: all 0.2s linear;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link .img {
  position: relative;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link .img:before {
  content: "\\f00c";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link .text {
  font-size: 0.65625rem;
  font-weight: 500;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link:hover {
  opacity: 0.6;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active {
  opacity: 1;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active .img:before {
  color: #FFFFFF;
}
.app-theme-panel .app-theme-panel-content .app-theme-mode-link.active .img:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
.app-theme-panel .app-theme-panel-content .app-theme-cover {
  margin: -0.25rem;
  display: flex;
  flex-wrap: wrap;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item {
  padding: 0.25rem;
  width: 33.33%;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link {
  display: block;
  text-decoration: none;
  position: relative;
  padding-top: 46%;
  background-size: cover;
  background-position: center;
  transition: all 0.2s linear;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link:hover {
  opacity: 0.6;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item .app-theme-cover-link:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.25;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item.active .app-theme-cover-link {
  opacity: 1;
}
.app-theme-panel .app-theme-panel-content .app-theme-cover .app-theme-cover-item.active .app-theme-cover-link:after {
  content: "\\f00c";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.app-theme-panel .app-theme-toggle-btn {
  position: absolute;
  top: 50%;
  margin-top: -1rem;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.09375rem;
  color: var(--bs-app-theme-panel-color);
  background: var(--bs-app-theme-panel-bg);
  text-align: center;
  left: 0;
  margin-left: -2rem;
}
.app-theme-panel.active {
  right: 0;
}

@keyframes topMenuControlSlideInLeft {
  from {
    left: -3.125rem;
  }
  to {
    left: 0;
  }
}
@keyframes topMenuControlSlideInRight {
  from {
    right: -3.125rem;
  }
  to {
    right: 0;
  }
}
.app-top-nav {
  background: var(--bs-app-top-nav-bg);
  left: 0;
  right: 0;
  z-index: 1010;
}
@media (min-width: 768px) {
  .app-top-nav {
    top: 3.25rem;
    position: fixed;
    height: 2.875rem;
  }
}
@media (max-width: 767.98px) {
  .app-top-nav {
    display: none;
  }
}
@media (min-width: 768px) {
  .app-top-nav .menu {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
}
@media (max-width: 767.98px) {
  .app-top-nav .menu {
    display: block;
    margin: 0 !important;
  }
}
.app-top-nav .menu .menu-item {
  position: relative;
}
.app-top-nav .menu .menu-item .menu-link {
  text-decoration: none;
  position: relative;
  padding: 0.75rem 1rem;
  color: var(--bs-app-top-nav-menu-link-color);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
}
@media (max-width: 767.98px) {
  .app-top-nav .menu .menu-item .menu-link {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
.app-top-nav .menu .menu-item .menu-link .menu-icon {
  width: 1.875rem;
  height: 1.875rem;
  font-size: 1.05rem;
  margin: -0.25rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}
.app-top-nav .menu .menu-item .menu-link .menu-caret {
  margin: -0.3125rem 0;
  margin-left: 0.75rem;
}
.app-top-nav .menu .menu-item .menu-link .menu-text {
  flex: 1 1;
}
.app-top-nav .menu .menu-item .menu-link:hover, .app-top-nav .menu .menu-item .menu-link:focus {
  color: var(--bs-app-top-nav-menu-link-hover-color);
}
.app-top-nav .menu .menu-item .menu-submenu {
  background: var(--bs-app-top-nav-menu-submenu-bg);
  display: none;
  padding: 0.5rem 0;
  min-width: 12.5rem;
}
@media (min-width: 768px) {
  .app-top-nav .menu .menu-item .menu-submenu {
    position: absolute;
    max-height: calc(100vh - 6.125rem);
    left: 0;
  }
}
@media (max-width: 767.98px) {
  .app-top-nav .menu .menu-item .menu-submenu {
    padding-top: 0;
    padding-bottom: 1rem;
    padding-left: 2.625rem;
  }
}
.app-top-nav .menu .menu-item .menu-submenu .menu-item {
  position: relative;
}
.app-top-nav .menu .menu-item .menu-submenu .menu-item .menu-link {
  padding: 0.25rem 1rem;
}
.app-top-nav .menu .menu-item.active > .menu-link {
  color: var(--bs-app-top-nav-menu-link-active-color);
}
.app-top-nav .menu .menu-item.active > .menu-link .menu-icon {
  color: var(--bs-theme);
}
.app-top-nav .menu .menu-item.menu-control {
  position: absolute;
  top: 0;
  margin: 0;
  z-index: 10;
}
@media (max-width: 767.98px) {
  .app-top-nav .menu .menu-item.menu-control {
    display: none !important;
  }
}
.app-top-nav .menu .menu-item.menu-control > .menu-link {
  padding: 0;
  text-align: center;
  width: 2.875rem;
  height: 2.875rem;
  background: var(--bs-app-top-nav-bg);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--bs-app-top-nav-menu-link-color);
}
.app-top-nav .menu .menu-item.menu-control > .menu-link i {
  float: none;
  margin: 0;
  font-size: 1.125rem;
  display: block;
  line-height: 2.5rem;
  width: auto;
}
.app-top-nav .menu .menu-item.menu-control > .menu-link:hover, .app-top-nav .menu .menu-item.menu-control > .menu-link:focus {
  color: var(--bs-app-top-nav-menu-link-hover-color);
}
.app-top-nav .menu .menu-item.menu-control.menu-control-start {
  left: -3.25rem;
}
.app-top-nav .menu .menu-item.menu-control.menu-control-start > .menu-link {
  box-shadow: 12px 0 10px -10px rgba(0, 0, 0, 0.5);
}
.app-top-nav .menu .menu-item.menu-control.menu-control-start.show {
  left: 0;
  animation: topMenuControlSlideInLeft 0.2s;
}
.app-top-nav .menu .menu-item.menu-control.menu-control-end {
  right: -3.25rem;
}
.app-top-nav .menu .menu-item.menu-control.menu-control-end > .menu-link {
  box-shadow: -12px 0 10px -10px rgba(0, 0, 0, 0.5);
}
.app-top-nav .menu .menu-item.menu-control.menu-control-end.show {
  right: 0;
  animation: topMenuControlSlideInRight 0.2s;
}
@media (min-width: 768px) {
  .app-top-nav .menu > .menu-item.has-sub:hover > .menu-submenu {
    display: block;
  }
}

.app {
  padding-top: 3.25rem;
}

@media (min-width: 992px) {
  .app-boxed-layout {
    min-height: 100vh;
  }
  .app-boxed-layout, .app-boxed-layout .app-header {
    max-width: 80rem;
    margin-left: auto;
    margin-right: auto;
  }
  .app-boxed-layout .app-top-nav {
    max-width: 80rem;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
  .app-boxed-layout .app-top-nav .menu .menu-item .menu-submenu {
    position: fixed;
    left: auto;
    right: auto;
    top: auto;
  }
  .app-boxed-layout .app-sidebar {
    left: auto;
  }
}

.app-content-full-height .app-content {
  height: calc(100vh - 3.25rem);
}
.app-content-full-height.app-without-header .app-content {
  height: 100vh;
}

.app-content-full-width .app-content {
  margin: 0;
}
.app-content-full-width .app-footer {
  margin-left: 2rem;
}
@media (max-width: 767.98px) {
  .app-content-full-width .app-footer {
    margin-left: 1rem;
  }
}

.app-footer-fixed {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-full-height {
  min-height: 100vh;
}

@keyframes appSidebarCollapse {
  from {
    margin-left: 0;
    opacity: 1;
  }
  to {
    margin-left: -16.875rem;
    opacity: 0;
  }
}
@keyframes appContentCollapse {
  from {
    margin-left: 16.875rem;
  }
  to {
    margin-left: 0;
  }
}
@keyframes appFooterCollapse {
  from {
    margin-left: 16.875rem;
  }
  to {
    margin-left: 2rem;
  }
}
@media (min-width: 768px) {
  .app-sidebar-collapsed .app-sidebar {
    opacity: 0;
    margin-left: -16.875rem;
  }
  .app-init .app-sidebar-collapsed .app-sidebar {
    animation: appSidebarCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);
  }
  .app-sidebar-collapsed .app-content {
    animation: appContentCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);
    margin-left: 0;
  }
  .app-sidebar-collapsed .app-footer {
    animation: appFooterCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);
    margin-left: 2rem;
  }
}

@keyframes appSidebarMobileSlideInLeft {
  from {
    left: -16.875rem;
  }
  to {
    left: 0;
  }
}
@keyframes appSidebarMobileBackdrop {
  from {
    background: transparent;
  }
  to {
    background: rgba(0, 0, 0, 0.25);
  }
}
@media (max-width: 767.98px) {
  .app-sidebar-mobile-toggled .app-sidebar {
    animation: appSidebarMobileSlideInLeft 0.1s ease;
    left: 0;
  }
  .app-sidebar-mobile-toggled .app-sidebar-mobile-backdrop:not(.app-sidebar-end) {
    display: block;
    background: rgba(0, 0, 0, 0.25);
    animation: appSidebarMobileBackdrop 0.1s ease;
  }
}

@keyframes appSidebarExpand {
  from {
    margin-left: -16.875rem;
  }
  to {
    margin-left: 0;
  }
}
@keyframes appContentExpand {
  from {
    margin-left: 0;
  }
  to {
    margin-left: 16.875rem;
  }
}
@keyframes appFooterExpand {
  from {
    margin-left: 2rem;
  }
  to {
    margin-left: 18.875rem;
  }
}
@media (min-width: 768px) {
  .app-sidebar-toggled .app-sidebar {
    animation: appSidebarExpand 0.15s both cubic-bezier(0.7, 0, 0.3, 1);
    margin-left: 0;
  }
  .app-sidebar-toggled .app-content {
    animation: appContentExpand 0.15s both cubic-bezier(0.7, 0, 0.3, 1);
    margin-left: 16.875rem;
  }
  .app-sidebar-toggled .app-footer {
    animation: appFooterExpand 0.15s both cubic-bezier(0.7, 0, 0.3, 1);
    margin-left: 18.875rem;
  }
}

@media (min-width: 768px) {
  .app-with-top-nav {
    padding-top: 6.125rem;
  }
  .app-with-top-nav .app-sidebar {
    top: 6.125rem;
  }
}
@media (min-width: 768px) {
  .app-with-top-nav.app-without-header {
    padding-top: 2.875rem;
  }
  .app-with-top-nav.app-without-header .app-sidebar {
    top: 2.875rem;
  }
}

.app-without-header {
  padding-top: 0;
}

.app-without-sidebar .app-content {
  margin: 0;
}

.breadcrumb {
  font-weight: bold;
}
.breadcrumb .breadcrumb-item a {
  text-decoration: none;
}
.breadcrumb .breadcrumb-item a:hover {
  text-decoration: underline;
}
.btn-scroll-top {
  position: fixed;
  bottom: 1.875rem;
  width: 2.5rem;
  height: 2.5rem;
  background: rgba(53.35, 67.1, 73.7, 0.75);
  color: #FFFFFF;
  text-align: center;
  text-decoration: none;
  z-index: 1020;
  border-radius: 36px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 1.875rem;
}
@media (max-width: 767.98px) {
  .btn-scroll-top {
    bottom: 1.25rem;
    z-index: 1020;
    right: 1.25rem;
  }
}
.btn-scroll-top:hover {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  text-decoration: none;
}

.card-expand .app-content {
  z-index: 1120;
  position: relative;
  height: calc(100vh - 3.25rem);
  overflow: hidden;
}

.card {
  --bs-border-color-rgb: var(--bs-body-color-rgb);
  position: relative;
  border: none;
}
.card.border-theme {
  --bs-border-color-rgb: var(--bs-theme-rgb);
}
.card.card-expand {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1120;
  border-radius: 0;
  margin: 0 !important;
  padding: 0.3125rem;
  background: var(--bs-app-header-bg);
}
.card.card-expand .card-header, .card.card-expand .card-body {
  border-radius: 0;
}
.card.card-expand .card-body {
  flex: 1 0;
  overflow: scroll;
}
.card.card-expand:not(.border-0):before {
  top: 5px;
  bottom: 5px;
  left: 20px;
  right: 20px;
}
.card.card-expand:not(.border-0):after {
  top: 20px;
  bottom: 20px;
  left: 5px;
  right: 5px;
}
.card.card-expand .card-arrow {
  margin: 5px;
}
.card .card-header .card-header-tabs .nav-item .nav-link.active {
  border-bottom-color: transparent;
}
.card .card-body .nav-tabs .nav-item .nav-link.active {
  background: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}
.card:before, .card:after {
  content: "";
  position: absolute;
}
.card:not(.border-0):before {
  left: 15px;
  right: 15px;
  top: 0;
  bottom: 0;
  border-top: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
  border-bottom: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
}
.card:not(.border-0):after {
  top: 15px;
  bottom: 15px;
  left: 0;
  right: 0;
  border-left: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
  border-right: 1px solid rgba(var(--bs-border-color-rgb), 0.3);
}
.card > *:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) {
  position: relative;
  z-index: 10;
}
.card .card-arrow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.card .card-arrow-top-left, .card .card-arrow-top-right, .card .card-arrow-bottom-left, .card .card-arrow-bottom-right {
  width: 10px;
  height: 10px;
  position: absolute;
}
.card .card-arrow-top-left:before, .card .card-arrow-top-right:before, .card .card-arrow-bottom-left:before, .card .card-arrow-bottom-right:before {
  content: "";
  position: absolute;
  width: 2px;
  height: 8px;
  background: rgba(var(--bs-border-color-rgb), 0.75);
}
.card .card-arrow-top-left:after, .card .card-arrow-top-right:after, .card .card-arrow-bottom-left:after, .card .card-arrow-bottom-right:after {
  content: "";
  position: absolute;
  width: 10px;
  height: 2px;
  background: rgba(var(--bs-border-color-rgb), 0.75);
}
.card .card-arrow-top-left, .card .card-arrow-top-right {
  top: 0;
}
.card .card-arrow-top-left:before, .card .card-arrow-top-right:before {
  top: 2px;
}
.card .card-arrow-top-left:after, .card .card-arrow-top-right:after {
  top: 0;
}
.card .card-arrow-bottom-left, .card .card-arrow-bottom-right {
  bottom: 0;
}
.card .card-arrow-bottom-left:before, .card .card-arrow-bottom-right:before {
  bottom: 2px;
}
.card .card-arrow-bottom-left:after, .card .card-arrow-bottom-right:after {
  bottom: 0;
}
.card .card-arrow-top-left, .card .card-arrow-bottom-left {
  left: 0;
}
.card .card-arrow-top-left:before, .card .card-arrow-top-left:after, .card .card-arrow-bottom-left:before, .card .card-arrow-bottom-left:after {
  left: 0;
}
.card .card-arrow-top-right, .card .card-arrow-bottom-right {
  right: 0;
}
.card .card-arrow-top-right:before, .card .card-arrow-top-right:after, .card .card-arrow-bottom-right:before, .card .card-arrow-bottom-right:after {
  right: 0;
}

@media (max-width: 991.98px) {
  .card-columns {
    column-count: 2;
  }
}
@media (max-width: 575.98px) {
  .card-columns {
    column-count: 1;
  }
}

.caret:before {
  content: "\\f22c";
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: 400 !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dropup.caret, .dropup .caret {
  content: "";
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid\\9 ;
}

.carousel-indicators [data-bs-target] {
  overflow: hidden;
}

@keyframes appDropdownShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.dropdown-menu.show {
  animation: appDropdownShow 0.25s both cubic-bezier(0.7, 0, 0.3, 1);
}

@media (max-width: 575.98px) {
  .dropdown.dropdown-mobile-full {
    position: initial;
  }
  .dropdown.dropdown-mobile-full .dropdown-menu {
    left: 0.25rem !important;
    right: 0.25rem !important;
    width: auto !important;
  }
}

[data-bs-theme=dark] .form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

[data-bs-theme=dark] .form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.form-select:not([multiple]) option {
  color: #000000;
}

[data-bs-theme=dark] .form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
[data-bs-theme=dark] .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
[data-bs-theme=dark] .form-switch .form-check-input:checked {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

hr.hr-bg, hr.hr-transparent, hr.hr-inverse, hr.hr-inverse-transparent {
  border: none;
  height: 1px;
}
hr.hr-transparent {
  background-color: rgba(0, 0, 0, 0.3);
}
hr.hr-inverse {
  background-color: rgb(25.5, 25.5, 25.5);
}
hr.hr-inverse-transparent {
  background-color: rgba(255, 255, 255, 0.3);
}

a {
  color: var(--bs-theme);
}
a:hover {
  color: rgba(var(--bs-theme-rgb), 0.75);
}

.modal .modal-content > * {
  position: relative;
}
.modal .modal-dialog.modal-full {
  max-width: 100%;
  width: 100%;
}
.modal .modal-dialog.modal-full .modal-content {
  border-radius: 0;
}
.modal.modal-cover .modal-dialog {
  min-height: 100%;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.modal.modal-cover .modal-content, .modal.modal-cover .modal-header, .modal.modal-cover .modal-footer {
  background: none;
  border: none;
}

[data-bs-theme=dark] .modal-backdrop {
  --bs-backdrop-bg: #1d2835;
}

.nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  padding: 1rem 0;
  color: var(--bs-inverse);
}
.nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link:hover, .nav.nav-tabs.nav-tabs-v2 > .nav-item > .nav-link.active {
  color: var(--bs-inverse);
  border-bottom-color: var(--bs-theme);
}
.nav.nav-tabs.nav-tabs-v2 > .nav-item.show > .nav-link {
  color: var(--bs-inverse);
  border-bottom-color: var(--bs-theme);
}

@media (max-width: 767.98px) {
  .nav-wizards-container {
    overflow: scroll;
  }
  .nav-wizards-container .nav.nav-wizards-1, .nav-wizards-container .nav.nav-wizards-2, .nav-wizards-container .nav.nav-wizards-3 {
    min-width: 37.5rem;
  }
}

.nav.nav-wizards-1 .nav-item {
  padding: 0;
}
.nav.nav-wizards-1 .nav-item .nav-link {
  position: relative;
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
.nav.nav-wizards-1 .nav-item .nav-link .nav-no {
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 auto;
  font-weight: 600;
  background: none;
  border: 2px solid var(--bs-border-color);
  position: relative;
  z-index: 10;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s linear;
}
.nav.nav-wizards-1 .nav-item .nav-link .nav-text {
  text-align: center;
  margin-top: 0.3125rem;
  font-weight: 600;
  font-size: 0.8125rem;
}
.nav.nav-wizards-1 .nav-item .nav-link.active, .nav.nav-wizards-1 .nav-item .nav-link.completed {
  color: var(--bs-theme);
}
.nav.nav-wizards-1 .nav-item .nav-link.active .nav-no, .nav.nav-wizards-1 .nav-item .nav-link.completed .nav-no {
  border-color: var(--bs-theme);
  color: var(--bs-theme);
}
.nav.nav-wizards-1 .nav-item .nav-link.active:before, .nav.nav-wizards-1 .nav-item .nav-link.active:after, .nav.nav-wizards-1 .nav-item .nav-link.completed:before, .nav.nav-wizards-1 .nav-item .nav-link.completed:after {
  background: var(--bs-theme);
}
.nav.nav-wizards-1 .nav-item .nav-link.active .nav-no {
  box-shadow: 0 0 0 5px rgba(var(--bs-theme-rgb), 0.2);
}
.nav.nav-wizards-1 .nav-item .nav-link.disabled {
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
.nav.nav-wizards-1 .nav-item .nav-link:before {
  content: "";
  position: absolute;
  top: 1.625rem;
  height: 0.125rem;
  background: rgba(var(--bs-inverse-rgb), 0.3);
  transition: all 0.2s linear;
}
.nav.nav-wizards-1 .nav-item .nav-link:before {
  left: calc(-50% + 20px);
  right: calc(50% + 20px);
}
.nav.nav-wizards-1 .nav-item:first-child .nav-link:before {
  display: none;
}
.nav.nav-wizards-1 .nav-item:last-child .nav-link:after {
  display: none;
}
.nav.nav-wizards-2 .nav-item {
  padding: 0 1rem;
}
.nav.nav-wizards-2 .nav-item .nav-link {
  position: relative;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  background: rgba(var(--bs-inverse-rgb), 0.15);
  border-radius: 60px;
}
.nav.nav-wizards-2 .nav-item .nav-link .nav-text {
  text-align: center;
  font-weight: 600;
  font-size: 0.8125rem;
}
.nav.nav-wizards-2 .nav-item .nav-link:before {
  content: "";
  position: absolute;
  left: -2rem;
  right: 100%;
  height: 0.125rem;
  top: 50%;
  margin-top: -0.0625rem;
  background-color: rgba(var(--bs-inverse-rgb), 0.3);
  transition: all 0.2s linear;
}
.nav.nav-wizards-2 .nav-item .nav-link.disabled {
  color: rgba(var(--bs-inverse-rgb), 0.35);
}
.nav.nav-wizards-2 .nav-item .nav-link.active, .nav.nav-wizards-2 .nav-item .nav-link.completed {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
}
.nav.nav-wizards-2 .nav-item .nav-link.active:before, .nav.nav-wizards-2 .nav-item .nav-link.completed:before {
  background: var(--bs-theme);
}
.nav.nav-wizards-2 .nav-item .nav-link.active {
  box-shadow: 0 0 0 4px rgba(var(--bs-theme-rgb), 0.2);
}
.nav.nav-wizards-2 .nav-item:first-child .nav-link:before {
  display: none;
}
.nav.nav-wizards-3 .nav-item {
  padding: 0;
}
.nav.nav-wizards-3 .nav-item .nav-link {
  position: relative;
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
.nav.nav-wizards-3 .nav-item .nav-link .nav-dot {
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
  font-weight: 600;
  background: none;
  border: 3px solid var(--bs-border-color);
  position: relative;
  z-index: 10;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s linear;
}
.nav.nav-wizards-3 .nav-item .nav-link .nav-title {
  margin-top: 0.625rem;
  font-weight: 600;
  text-align: center;
}
.nav.nav-wizards-3 .nav-item .nav-link .nav-text {
  text-align: center;
  font-size: 0.8125rem;
}
.nav.nav-wizards-3 .nav-item .nav-link.active, .nav.nav-wizards-3 .nav-item .nav-link.completed {
  color: var(--bs-theme);
}
.nav.nav-wizards-3 .nav-item .nav-link.active .nav-dot, .nav.nav-wizards-3 .nav-item .nav-link.completed .nav-dot {
  border-color: var(--bs-theme);
  color: var(--bs-theme);
}
.nav.nav-wizards-3 .nav-item .nav-link.active:before, .nav.nav-wizards-3 .nav-item .nav-link.completed:before {
  background: var(--bs-theme);
}
.nav.nav-wizards-3 .nav-item .nav-link.active .nav-dot {
  box-shadow: 0 0 0 5px rgba(var(--bs-theme-rgb), 0.2);
}
.nav.nav-wizards-3 .nav-item .nav-link.disabled {
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
.nav.nav-wizards-3 .nav-item .nav-link:before {
  content: "";
  position: absolute;
  left: calc(-50% + 8px);
  top: 0.875rem;
  right: calc(50% + 8px);
  height: 0.1875rem;
  background: rgba(var(--bs-inverse-rgb), 0.3);
}
.nav.nav-wizards-3 .nav-item:first-child .nav-link:before {
  display: none;
}

.navbar.navbar-sticky {
  top: 5.25rem;
  position: sticky;
  padding: 0;
  border-left: 1px solid var(--bs-border-color);
  margin-left: 1rem;
}
.navbar.navbar-sticky .nav {
  width: 100%;
  flex-direction: column;
}
.navbar.navbar-sticky .nav .nav-link {
  color: rgba(var(--bs-inverse-rgb), 0.6);
  padding: 0.25rem 1.5rem;
}
.navbar.navbar-sticky .nav .nav-link:hover {
  color: rgba(var(--bs-inverse-rgb), 1);
}
.navbar.navbar-sticky .nav .nav-link.active {
  color: var(--bs-theme);
  font-weight: 500;
}

.page-header {
  color: var(--bs-heading-color);
  padding: 0;
  border: none;
  margin-bottom: 1rem;
  font-weight: 600;
  font-size: 1.75rem;
}
.page-header small, .page-header .small {
  font-size: 1rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: 300;
}

.pagination .page-item .page-link {
  border-radius: 0.25rem;
}
.pagination .page-item + .page-item {
  margin-left: 0.3125rem;
}

pre {
  display: block;
  padding: 1rem;
  font-size: 0.875rem;
  color: rgb(67.9, 85.4, 93.8);
  word-break: break-all;
  word-wrap: break-word;
  background-color: #FFFFFF;
  border: 1px solid rgb(168.1, 181.85, 188.45);
  border-radius: 4px;
}

.row.row-grid > [class*=col-] + [class*=col-] {
  border-left: 1px solid rgba(var(--bs-inverse-rgb), 0.15);
}
.row.row-grid + .row-grid {
  border-top: 1px solid rgba(var(--bs-inverse-rgb), 0.15);
}

.table.table-card thead > tr td:first-child, .table.table-card thead > tr th:first-child, .table.table-card tbody > tr td:first-child, .table.table-card tbody > tr th:first-child {
  padding-left: 1rem;
}
.table.table-card thead > tr td:last-child, .table.table-card thead > tr th:last-child, .table.table-card tbody > tr td:last-child, .table.table-card tbody > tr th:last-child {
  padding-right: 1rem;
}
.table.table-xs {
  font-size: 0.75rem;
}
.table.table-xs thead th, .table.table-xs tbody th, .table.table-xs tfoot th {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
}
.table.table-xs thead td, .table.table-xs tbody td, .table.table-xs tfoot td {
  padding: 0.3125rem 0.5rem;
}

.toasts-container {
  position: fixed;
  top: 3.25rem;
  padding-top: 1rem;
  width: 21.875rem;
  right: 0;
  padding-right: 1rem;
}
@media (max-width: 767.98px) {
  .toasts-container {
    width: 18.75rem;
  }
}
.toasts-container .toast {
  width: 100%;
}

.apexcharts-canvas .apexcharts-tooltip {
  font-size: 0.8125rem;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.apexcharts-canvas .apexcharts-tooltip * {
  font-family: inherit !important;
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {
  border: none;
  background: rgba(var(--bs-body-bg-rgb), 0.9);
  color: var(--bs-inverse);
}
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title, .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {
  background: rgba(var(--bs-inverse-rgb), 0.15);
  border-color: transparent;
  color: var(--bs-inverse);
  text-transform: uppercase;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-family: inherit !important;
  font-weight: 600;
  padding: 0.35rem 0.75rem;
  margin: 0;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group {
  padding: 0.35rem 0.75rem;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group .apexcharts-tooltip-marker {
  width: 0.625rem;
  height: 0.625rem;
  margin-right: 0.25rem;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group .apexcharts-tooltip-text .apexcharts-tooltip-y-group {
  padding: 0;
}
.apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-series-group + .apexcharts-tooltip-series-group {
  padding-top: 0;
}
.apexcharts-canvas .apexcharts-xaxistooltip * {
  font-family: inherit !important;
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark {
  color: #FFFFFF;
  background: rgb(53.35, 67.1, 73.7);
  border-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-bottom:before, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-bottom:after, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-top:before, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-top:before {
  border-top-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light.apexcharts-xaxistooltip-top:after, .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-dark.apexcharts-xaxistooltip-top:after {
  border-top-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-yaxistooltip * {
  font-family: inherit !important;
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark {
  color: #FFFFFF;
  background: rgb(53.35, 67.1, 73.7);
  border-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-right:before, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-right:before {
  border-right-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-right:after, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-right:after {
  border-right-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-left:before, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-left:before {
  border-left-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-light.apexcharts-yaxistooltip-left:after, .apexcharts-canvas .apexcharts-yaxistooltip.apexcharts-theme-dark.apexcharts-yaxistooltip-left:after {
  border-left-color: rgb(53.35, 67.1, 73.7);
}
.apexcharts-canvas .apexcharts-legend-marker {
  width: 0.625rem !important;
  height: 0.625rem !important;
  margin-right: 0.3125rem;
}
.apexcharts-canvas .apexcharts-menu {
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border: none;
  padding: 0;
  border-radius: 0;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}
.apexcharts-canvas .apexcharts-menu .apexcharts-menu-item {
  color: var(--bs-body-color);
}
.apexcharts-canvas .apexcharts-menu .apexcharts-menu-item:hover {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  color: var(--bs-body-color);
}
.apexcharts-canvas.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-reset-icon:hover svg, .apexcharts-canvas.apexcharts-theme-light .apexcharts-menu-icon:hover svg {
  fill: #FFFFFF;
}

body .daterangepicker {
  z-index: 1030;
  border-color: var(--bs-border-color-translucent);
  font-family: inherit;
  font-size: inherit;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border-radius: 0;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  width: auto;
}
body .daterangepicker:before, body .daterangepicker:after {
  display: none;
}
body .daterangepicker:after {
  border-width: 0.4375rem;
  top: -0.4375rem;
  left: 0.625rem;
}
body .daterangepicker.opensright:after {
  right: 0.625rem;
  left: auto;
}
body .daterangepicker select.monthselect, body .daterangepicker select.yearselect {
  font-size: 0.7875rem;
}
body .daterangepicker .drp-calendar {
  max-width: inherit;
  padding: 0.75rem;
}
body .daterangepicker .drp-calendar .calendar-table {
  background: none;
  border: none;
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table thead .week, body .daterangepicker .drp-calendar .calendar-table table tbody .week {
  font-size: 0.74375rem;
  color: rgb(191.8, 201.8, 206.6);
  font-weight: 600;
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th {
  min-width: auto;
  width: auto;
  height: auto;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  color: var(--bs-inverse);
  font-weight: 600;
  font-size: inherit;
  border: none;
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next span {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:hover, body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:focus, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:hover, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:focus {
  background: none;
  color: var(--bs-theme);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:hover span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.prev:focus span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:hover span, body .daterangepicker .drp-calendar .calendar-table table thead tr th.next:focus span {
  border-color: var(--bs-theme);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .yearselect, body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .monthselect {
  border-color: var(--bs-border-color);
  background: transparent;
  border-radius: 4px;
  color: var(--bs-inverse);
  transition: all 0.2s linear;
}
body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .yearselect:focus, body .daterangepicker .drp-calendar .calendar-table table thead tr th.month .monthselect:focus {
  outline: none;
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  box-shadow: 0 0 0 0.125rem rgba(var(--bs-inverse-rgb), 0.5);
}
body .daterangepicker .drp-calendar .calendar-table table thead tr:last-child th {
  font-size: 0.74375rem;
  padding-bottom: 0.5rem;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td {
  min-width: auto;
  width: auto;
  height: auto;
  line-height: 1.3;
  padding: 0.625rem 0.375rem;
  font-weight: 400;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  border-color: var(--bs-border-color-translucent);
  font-size: 0.7875rem;
  border-radius: 0 !important;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available:hover, body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available:focus {
  background: var(--bs-theme);
  border-color: var(--bs-theme);
  color: var(--bs-theme-color);
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.in-range {
  background: rgba(var(--bs-theme-rgb), 0.25);
  border-color: rgba(var(--bs-theme-rgb), 0.5);
  color: var(--bs-inverse);
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.active {
  background: var(--bs-theme);
  border-color: var(--bs-theme);
  color: var(--bs-theme-color);
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.start-date {
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.available.end-date {
  border-radius: 0;
}
body .daterangepicker .drp-calendar .calendar-table table tbody tr td.off {
  background: none;
  color: rgba(var(--bs-inverse-rgb), 0.25);
}
body .daterangepicker .drp-calendar.left {
  padding: 0.75rem !important;
}
body .daterangepicker .drp-calendar.left .calendar-table {
  padding: 0 !important;
}
body .daterangepicker .drp-calendar.right {
  padding: 0.75rem !important;
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 575.98px) {
  body .daterangepicker .drp-calendar.right {
    border-top: 1px solid var(--bs-border-color);
    border-left: none;
  }
}
body .daterangepicker .drp-buttons {
  padding: 0.75rem 0.75rem;
  border-color: var(--bs-border-color);
  background: rgba(var(--bs-inverse-rgb), 0.05);
  border: none;
}
body .daterangepicker .drp-buttons .btn.btn-primary {
  background: none;
  border: 1px solid var(--bs-btn-border-color);
  color: var(--bs-btn-color);
  --bs-btn-color: #249d79;
  --bs-btn-border-color: #249d79;
  --bs-btn-hover-color: #249d79;
  --bs-btn-hover-bg: #249d79;
  --bs-btn-hover-border-color: #249d79;
  --bs-btn-focus-shadow-rgb: 36, 157, 121;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: #249d79;
  --bs-btn-active-border-color: #249d79;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #249d79;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #249d79;
  --bs-gradient: none;
}
body .daterangepicker .drp-buttons .btn.btn-primary:hover, body .daterangepicker .drp-buttons .btn.btn-primary:active {
  background: var(--bs-btn-hover-bg);
}
body .daterangepicker .drp-buttons .btn.btn-default {
  background: none;
  border: 1px solid var(--bs-btn-border-color);
  color: var(--bs-btn-color);
  --bs-btn-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
  --bs-gradient: none;
}
body .daterangepicker .drp-buttons .btn.btn-default:hover, body .daterangepicker .drp-buttons .btn.btn-default:active {
  color: #000000;
  background: var(--bs-btn-hover-bg);
}
body .daterangepicker .ranges {
  display: none;
}
body .daterangepicker.show-ranges .ranges {
  position: relative;
  display: block;
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .ranges {
    float: none;
    margin: 0;
    padding: 0.625rem;
    border-bottom: 1px solid var(--bs-border-color);
    overflow: scroll;
    max-width: 35rem;
  }
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .ranges ul {
    width: auto;
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    padding-right: 0.625rem;
  }
}
body .daterangepicker.show-ranges .ranges ul li {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 0.8125rem;
  font-weight: 400;
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .ranges ul li {
    border-radius: 4px;
    margin-right: 0.625rem !important;
  }
}
body .daterangepicker.show-ranges .ranges ul li:hover, body .daterangepicker.show-ranges .ranges ul li:focus {
  background: rgba(var(--bs-inverse-rgb), 0.15);
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
body .daterangepicker.show-ranges .ranges ul li.active {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  margin-right: -0.0625rem;
}
body .daterangepicker.show-ranges .drp-calendar.left {
  border-left: 1px solid rgba(var(--bs-inverse-rgb), 0.15) !important;
}
@media (max-width: 767.98px) {
  body .daterangepicker.show-ranges .drp-calendar.left {
    border-left: none !important;
  }
}

body .dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:before {
  content: "\\f64d" !important;
  background: none;
  border: 1px solid var(--bs-border-color) !important;
  color: var(--bs-inverse);
  font-size: 0.65rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 0;
  box-shadow: none;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: 400 !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  float: left;
  margin-right: 0.5rem !important;
}
body .dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:hover:before, body .dt-bootstrap5 .dataTable.dtr-inline tr td.dtr-control:focus:before {
  border-color: var(--bs-theme) !important;
}
body .dt-bootstrap5 .dataTable.dtr-inline tr.dt-hasChild > td.dtr-control:before, body .dt-bootstrap5 .dataTable.dtr-inline tr.dt-hasChild > th.dtr-control:before {
  content: "\\f068";
  background: var(--bs-theme);
  color: var(--bs-theme-color);
}
body .dt-bootstrap5 .dataTable thead > tr > th.sorting:hover, body .dt-bootstrap5 .dataTable thead > tr > th.sorting:focus, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc:hover, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc:focus, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-desc:hover, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-desc:focus, body .dt-bootstrap5 .dataTable thead > tr > td.sorting:hover, body .dt-bootstrap5 .dataTable thead > tr > td.sorting:focus, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc:hover, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc:focus, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-desc:hover, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-desc:focus {
  outline: 2px solid var(--bs-border-color);
  outline-offset: -2px;
}
body .dt-bootstrap5 .dataTable thead > tr > th.sorting .dt-column-order, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc .dt-column-order, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-desc .dt-column-order, body .dt-bootstrap5 .dataTable thead > tr > td.sorting .dt-column-order, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc .dt-column-order, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-desc .dt-column-order {
  right: 0.375rem;
}
body .dt-bootstrap5 .dataTable thead > tr > th.sorting .dt-column-order:before, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc .dt-column-order:before, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-desc .dt-column-order:before, body .dt-bootstrap5 .dataTable thead > tr > td.sorting .dt-column-order:before, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc .dt-column-order:before, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-desc .dt-column-order:before {
  display: none;
}
body .dt-bootstrap5 .dataTable thead > tr > th.sorting .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-desc .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > td.sorting .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-desc .dt-column-order:after {
  opacity: 1;
  color: rgba(var(--bs-body-color-rgb), 0.5);
  top: 0;
  bottom: 0;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc.dt-orderable-desc .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc.dt-orderable-desc .dt-column-order:after {
  content: "\\f0dc";
}
body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc.dt-orderable-desc.dt-ordering-asc .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc.dt-orderable-desc.dt-ordering-asc .dt-column-order:after {
  content: "\\f0dd";
  color: var(--bs-theme);
}
body .dt-bootstrap5 .dataTable thead > tr > th.dt-orderable-asc.dt-orderable-desc.dt-ordering-desc .dt-column-order:after, body .dt-bootstrap5 .dataTable thead > tr > td.dt-orderable-asc.dt-orderable-desc.dt-ordering-desc .dt-column-order:after {
  content: "\\f0de";
  color: var(--bs-theme);
}
body .dt-bootstrap5 .dataTable.table-bordered th:last-child, body .dt-bootstrap5 .dataTable.table-bordered td:last-child {
  border-color: var(--bs-table-border-color);
}
body .dt-bootstrap5 .dt-paging .pagination {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-border-radius: 2px;
  justify-content: flex-end;
  font-size: 0.8125rem;
}
body .dt-bootstrap5 .dt-scroll .dt-scroll-head .table-bordered {
  border-top: 1px solid var(--bs-table-border-color);
  border-bottom: 1px solid var(--bs-table-border-color);
}
body .dt-bootstrap5 .dt-scroll .dt-scroll-body .table-bordered tbody tr {
  border-bottom: none;
}
body .dt-bootstrap5 .dt-scroll .dt-scroll-body .table-bordered tbody tr:not(:last-child) td {
  border-bottom: 1px solid var(--bs-table-border-color);
}
body .dt-bootstrap5 .dt-scroll .dt-scroll-foot .table-bordered {
  border-bottom: 1px solid var(--bs-table-border-color);
}
body .dt-bootstrap5 .dt-scroll .dtfc-scrolling-left tr > .dtfc-fixed-left::after {
  border-left: 1px solid var(--bs-table-border-color);
  box-shadow: none;
}
body .dt-bootstrap5 .dt-info {
  padding-top: 0 !important;
}
body .dt-bootstrap5 .btn.btn-secondary[class*=btn-outline-]:not(:hover):not(:focus) {
  background: none;
}

.fc-event-list .fc-event-item .fc-event-link {
  padding: 0.35rem 0.7rem;
  color: var(--bs-inverse);
  position: relative;
  border: 1px solid var(--bs-border-color);
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.fc-event-list .fc-event-item .fc-event-link:hover {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.fc-event-list .fc-event-item .fc-event-link:after {
  content: "\\f0b2";
  color: rgba(var(--bs-inverse-rgb), 0.5);
  line-height: 1;
  margin-left: auto;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.fc-event-list .fc-event-item + .fc-event-item {
  margin-top: 0.5rem;
}

.fc-event-link.fc-dragging, .fc-event-link.fc-event-dragging {
  padding: 0.35rem 0.7rem;
  background: rgba(var(--bs-inverse-rgb), 0.15);
  border: 1px solid var(--bs-border-color);
  color: var(--bs-inverse);
  display: block;
  display: flex;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
}

.fc .fc-toolbar, .fc .fc-header-toolbar {
  margin-bottom: 0 !important;
  flex-wrap: wrap;
  align-items: center;
}
.fc .fc-toolbar .fc-left, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1), .fc .fc-header-toolbar .fc-left, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 575.98px) {
  .fc .fc-toolbar .fc-left .btn-group, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group, .fc .fc-header-toolbar .fc-left .btn-group, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn-group {
    width: 100%;
  }
}
.fc .fc-toolbar .fc-left .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn, .fc .fc-header-toolbar .fc-left .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn {
  min-width: 6.25rem;
  background: none;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  color: var(--bs-btn-color);
  --bs-btn-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
  --bs-gradient: none;
}
@media (max-width: 991.98px) {
  .fc .fc-toolbar .fc-left .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn, .fc .fc-header-toolbar .fc-left .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn {
    min-width: 5.625rem;
  }
}
.fc .fc-toolbar .fc-left .btn:hover, .fc .fc-toolbar .fc-left .btn:active, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn:hover, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(1) .btn:active, .fc .fc-header-toolbar .fc-left .btn:hover, .fc .fc-header-toolbar .fc-left .btn:active, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn:hover, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) .btn:active {
  color: #000000;
  background: var(--bs-btn-hover-bg);
}
.fc .fc-toolbar .fc-center, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(2), .fc .fc-header-toolbar .fc-center, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {
  flex: 1 1;
  padding: 1rem;
}
.fc .fc-toolbar .fc-right, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3), .fc .fc-header-toolbar .fc-right, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) {
  padding: 1rem;
}
.fc .fc-toolbar .fc-right .btn, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn, .fc .fc-header-toolbar .fc-right .btn, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  background: none;
  --bs-btn-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-hover-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-focus-shadow-rgb: 121, 142, 152;
  --bs-btn-active-color: #FFFFFF;
  --bs-btn-active-bg: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-border-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(120.7, 141.95, 152.15);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(120.7, 141.95, 152.15);
  --bs-gradient: none;
}
.fc .fc-toolbar .fc-right .btn:hover, .fc .fc-toolbar .fc-right .btn:active, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn:hover, .fc .fc-toolbar .fc-toolbar-chunk:nth-child(3) .btn:active, .fc .fc-header-toolbar .fc-right .btn:hover, .fc .fc-header-toolbar .fc-right .btn:active, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn:hover, .fc .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .btn:active {
  color: #000000;
}
.fc .fc-view .fc-event, .fc .fc-view .fc-event-dot {
  background-color: rgba(var(--bs-inverse-rgb), 0.15);
  border-color: transparent;
}
.fc .fc-view .fc-event.fc-daygrid-dot-event, .fc .fc-view .fc-event-dot.fc-daygrid-dot-event {
  background-color: rgba(var(--bs-inverse-rgb), 0.15);
  border-color: transparent;
}
.fc .fc-view.fc-dayGrid-view .fc-week-number, .fc .fc-view.fc-dayGrid-view .fc-day-number, .fc .fc-view.fc-dayGrid-view .fc-daygrid-day-number, .fc .fc-view.fc-dayGridMonth-view .fc-week-number, .fc .fc-view.fc-dayGridMonth-view .fc-day-number, .fc .fc-view.fc-dayGridMonth-view .fc-daygrid-day-number {
  padding: 0.125rem 0.25rem;
}
.fc .fc-view.fc-dayGrid-view .fc-day-grid-event, .fc .fc-view.fc-dayGrid-view .fc-daygrid-day-events, .fc .fc-view.fc-dayGridMonth-view .fc-day-grid-event, .fc .fc-view.fc-dayGridMonth-view .fc-daygrid-day-events {
  margin-top: 0.125rem;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table {
  border: none;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table tbody tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-slats table thead tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table tbody tr:first-child td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-bg table thead tr:first-child td {
  border-top: none;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table {
  border: none !important;
}
.fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table td, .fc .fc-view.fc-timeGrid-view .fc-time-grid .fc-content-skeleton table th {
  border: none !important;
}
.fc .fc-view a {
  text-decoration: none;
}
.fc .fc-view .fc-daygrid-event, .fc .fc-view .fc-timegrid-event-harness-inset .fc-timegrid-event, .fc .fc-view .fc-timegrid-event.fc-event-mirror, .fc .fc-view .fc-timegrid-more-link {
  box-shadow: none;
  border-radius: 0;
}
.fc td, .fc th {
  border-width: 1px;
  border-color: var(--bs-border-color);
}
.fc .fc-view-harness {
  height: auto !important;
}
.fc .fc-scroller-liquid-absolute {
  position: relative !important;
  overflow: initial !important;
}
.fc a:not([href]) {
  color: inherit;
}

.hljs {
  display: block;
  overflow-x: auto;
  color: var(--bs-gray-500);
  font-size: 0.7875rem;
}

.hljs-code,
.hljs-emphasis {
  font-style: italic;
}

.hljs-tag,
.hljs-name {
  color: var(--bs-gray-300);
}

.hljs-string,
.hljs-bullet {
  color: var(--bs-indigo);
}

.hljs-attr {
  color: var(--bs-teal);
}

.hljs a {
  color: inherit;
}
.hljs a:focus, .hljs a:hover {
  color: inherit;
  text-decoration: underline;
}

.hljs-container {
  padding: 1rem 1rem;
  border-top: 1px solid var(--bs-border-color);
  position: relative;
  z-index: 1;
}
.hljs-container pre {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  border-radius: 0;
}

.jvm-container .jvm-zoomin, .jvm-container .jvm-zoomout, .jvm-container .jvm-goback {
  width: 1.125rem;
  height: 1.125rem;
  padding: 0 0 0.125rem;
  box-sizing: border-box;
  font-size: 1rem;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color);
  left: 1rem;
  box-shadow: none;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  left: 1rem;
}
.jvm-container .jvm-zoomin:hover, .jvm-container .jvm-zoomout:hover, .jvm-container .jvm-goback:hover {
  color: var(--bs-theme-color);
  background: var(--bs-theme);
}
.jvm-container .jvm-zoomin {
  top: 1rem;
}
.jvm-container .jvm-zoomout {
  top: 2.5625rem;
}
.jvm-container.jvectormap-without-padding .jvm-zoomin {
  top: 0;
}
.jvm-container.jvectormap-without-padding .jvm-zoomout {
  top: 1.5625rem;
}
.jvm-container.jvectormap-without-padding .jvm-zoomin, .jvm-container.jvectormap-without-padding .jvm-zoomout {
  left: 0;
}
.jvm-container .jvm-legend {
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  border-radius: 0;
}
.jvm-container .jvm-legend-title {
  font-size: 0.6875rem;
  padding: 0.3rem 0.5rem;
  background: rgba(var(--bs-inverse-rgb), 0.15);
}
.jvm-container .jvm-legend-cnt-v .jvm-legend {
  padding: 0;
  margin: 1rem 1rem 0 0;
}
.jvm-container .jvm-legend-cnt-v .jvm-legend .jvm-legend-inner {
  padding: 0.5rem;
}
.jvm-container .jvm-legend-cnt-v .jvm-legend .jvm-legend-tick {
  display: flex;
  align-items: center;
}
.jvm-container .jvm-legend-cnt-v .jvm-legend .jvm-legend-tick-sample {
  width: 1rem;
  height: 1rem;
}
.jvm-container .jvm-legend-cnt-v .jvm-legend .jvm-legend-tick-text {
  padding-left: 0.5rem;
}

.jvm-tooltip {
  background: rgba(var(--bs-inverse-rgb), 0.9) !important;
  color: var(--bs-body-bg) !important;
  font-weight: 600 !important;
  padding: 0.25rem 0.5rem !important;
  border: none !important;
  font-family: inherit !important;
  font-size: 0.7875rem !important;
  z-index: 1000;
  border-radius: 4px !important;
}

.ps {
  position: relative;
}
.ps .ps__rail-x, .ps .ps__rail-y {
  z-index: 10;
}
.ps .ps__rail-x.ps--clicking, .ps .ps__rail-x:hover, .ps .ps__rail-x:focus, .ps .ps__rail-y.ps--clicking, .ps .ps__rail-y:hover, .ps .ps__rail-y:focus {
  background: none;
}
.ps .ps__thumb-y {
  border-radius: 0;
  background: none;
}
.ps .ps__thumb-y:before {
  content: "";
  background: #aaa;
  position: absolute;
  top: 0.0625rem;
  bottom: 0.0625rem;
  right: 0;
  left: 0;
}

.app-sidebar .ps__rail-x,
.app-sidebar .ps__rail-y {
  display: none;
}

.rdt .rdtPicker {
  width: auto;
  min-width: auto;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0;
  padding: 0.5rem 0.5rem;
}
.rdt .rdtPicker table thead tr th.rdtPrev, .rdt .rdtPicker table thead tr th.rdtNext, .rdt .rdtPicker table thead tr th.rdtSwitch {
  line-height: 1.625rem;
  padding: 0.25rem;
  height: auto;
  min-height: 30px;
  border: none;
  border-radius: 4px;
}
.rdt .rdtPicker table thead tr th.rdtPrev:hover, .rdt .rdtPicker table thead tr th.rdtPrev:focus, .rdt .rdtPicker table thead tr th.rdtNext:hover, .rdt .rdtPicker table thead tr th.rdtNext:focus, .rdt .rdtPicker table thead tr th.rdtSwitch:hover, .rdt .rdtPicker table thead tr th.rdtSwitch:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
.rdt .rdtPicker table thead tr th.rdtPrev:hover span:before, .rdt .rdtPicker table thead tr th.rdtPrev:focus span:before, .rdt .rdtPicker table thead tr th.rdtNext:hover span:before, .rdt .rdtPicker table thead tr th.rdtNext:focus span:before, .rdt .rdtPicker table thead tr th.rdtSwitch:hover span:before, .rdt .rdtPicker table thead tr th.rdtSwitch:focus span:before {
  color: var(--bs-body-color);
}
.rdt .rdtPicker table thead tr th.rdtPrev, .rdt .rdtPicker table thead tr th.rdtNext {
  color: transparent;
  width: 14.28%;
  position: relative;
}
.rdt .rdtPicker table thead tr th.rdtPrev span, .rdt .rdtPicker table thead tr th.rdtNext span {
  color: transparent;
  position: relative;
  display: block;
  border-radius: 4px;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.rdt .rdtPicker table thead tr th.rdtPrev span:before, .rdt .rdtPicker table thead tr th.rdtNext span:before {
  color: rgba(var(--bs-body-color-rgb), 0.5);
  position: absolute;
  font-size: 14px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker table thead tr th.rdtPrev span i, .rdt .rdtPicker table thead tr th.rdtNext span i {
  display: none;
}
.rdt .rdtPicker table thead tr th.rdtPrev span:before {
  content: "\\f104";
}
.rdt .rdtPicker table thead tr th.rdtNext span:before {
  content: "\\f105";
}
.rdt .rdtPicker table thead tr th.rdtSwitch {
  width: auto;
}
.rdt .rdtPicker table thead tr th.dow {
  padding: 5px 0;
}
.rdt .rdtPicker table tfoot {
  border: none;
}
.rdt .rdtPicker table tfoot tr td.rdtTimeToggle {
  border: none;
  font-weight: 600;
  color: rgba(var(--bs-body-color-rgb), 0.5);
  text-shadow: none;
  border-radius: 4px;
}
.rdt .rdtPicker table tfoot tr td.rdtTimeToggle:hover, .rdt .rdtPicker table tfoot tr td.rdtTimeToggle:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  text-shadow: none;
}
.rdt .rdtPicker .rdtTime {
  min-width: 180px;
}
.rdt .rdtPicker .rdtTime .rdtCounters {
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker .rdtTime .rdtCounters > div {
  float: none;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter {
  height: 110px;
  width: 60px;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn {
  height: 35%;
  color: transparent;
  position: relative;
  border-radius: 4px;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:before {
  content: "\\f106";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: rgba(var(--bs-body-color-rgb), 0.5);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:hover, .rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtBtn:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtCount {
  height: 30%;
  font-weight: 600;
  color: rgba(var(--bs-body-color-rgb), 0.75);
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt .rdtPicker .rdtTime .rdtCounters .rdtCounter .rdtCount + .rdtBtn:before {
  content: "\\f107";
}
.rdt .rdtPicker .rdtDays {
  min-width: 17.5rem;
}
.rdt .rdtPicker .rdtDays .rdtDay {
  font-weight: 400;
  color: rgba(var(--bs-body-color-rgb), 0.75);
  padding: 0.25rem 0.25rem;
  line-height: 1.625rem;
  border-radius: 4px;
}
.rdt .rdtPicker .rdtDays .rdtDay:hover, .rdt .rdtPicker .rdtDays .rdtDay:focus, .rdt .rdtPicker .rdtDays .rdtDay.rdtSelected, .rdt .rdtPicker .rdtDays .rdtDay.rdtHighlighted, .rdt .rdtPicker .rdtDays .rdtDay.rdtRange {
  background: rgba(var(--bs-body-color-rgb), 0.15) !important;
  text-shadow: none;
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtToday {
  background: var(--bs-theme) !important;
  color: var(--bs-theme-color) !important;
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtToday:before {
  border-bottom-color: var(--bs-body-color);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtActive {
  background: var(--bs-theme) !important;
  color: var(--bs-theme-color) !important;
  text-shadow: none !important;
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtOld {
  color: rgba(var(--bs-body-color-rgb), 0.25);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtNew {
  color: rgba(var(--bs-body-color-rgb), 0.5);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled {
  color: rgba(var(--bs-body-color-rgb), 0.25);
}
.rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled:hover, .rdt .rdtPicker .rdtDays .rdtDay.rdtDisabled:focus {
  background: none !important;
}
.rdt .rdtPicker .rdtMonths, .rdt .rdtPicker .rdtYears {
  min-width: 17.5rem;
}
.rdt .rdtPicker .rdtMonths .rdtMonth, .rdt .rdtPicker .rdtMonths .rdtYear, .rdt .rdtPicker .rdtYears .rdtMonth, .rdt .rdtPicker .rdtYears .rdtYear {
  font-weight: 600;
  color: rgba(var(--bs-body-color-rgb), 0.5);
  text-shadow: none;
  border-radius: 4px;
}
.rdt .rdtPicker .rdtMonths .rdtMonth:hover, .rdt .rdtPicker .rdtMonths .rdtMonth:focus, .rdt .rdtPicker .rdtMonths .rdtYear:hover, .rdt .rdtPicker .rdtMonths .rdtYear:focus, .rdt .rdtPicker .rdtYears .rdtMonth:hover, .rdt .rdtPicker .rdtYears .rdtMonth:focus, .rdt .rdtPicker .rdtYears .rdtYear:hover, .rdt .rdtPicker .rdtYears .rdtYear:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
.rdt .rdtPicker .rdtMonths .rdtMonth.rdtFocused, .rdt .rdtPicker .rdtMonths .rdtYear.rdtFocused, .rdt .rdtPicker .rdtYears .rdtMonth.rdtFocused, .rdt .rdtPicker .rdtYears .rdtYear.rdtFocused {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  color: var(--bs-body-color);
}
.rdt .rdtPicker .rdtMonths .rdtMonth.rdtActive, .rdt .rdtPicker .rdtMonths .rdtYear.rdtActive, .rdt .rdtPicker .rdtYears .rdtMonth.rdtActive, .rdt .rdtPicker .rdtYears .rdtYear.rdtActive {
  background: #249d79 !important;
  color: var(--bs-body-color);
}

.react-datepicker {
  border: none;
  display: block;
  font-family: inherit;
  background: none;
}
.react-datepicker .react-datepicker__navigation {
  color: transparent;
  padding: 0.3125rem;
  line-height: 1.25rem;
  border: none;
  width: 1.875rem;
  height: 1.875rem;
  top: 0.3125rem;
  text-indent: 0;
  border-radius: 8px;
}
.react-datepicker .react-datepicker__navigation:hover, .react-datepicker .react-datepicker__navigation:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  outline: none;
}
.react-datepicker .react-datepicker__navigation:hover:after, .react-datepicker .react-datepicker__navigation:focus:after {
  color: var(--bs-body-color);
}
.react-datepicker .react-datepicker__navigation:after {
  color: rgba(var(--bs-body-color-rgb), 0.5);
  position: absolute;
  font-size: 0.875rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.react-datepicker .react-datepicker__navigation .react-datepicker__navigation-icon {
  display: none;
}
.react-datepicker .react-datepicker__navigation.react-datepicker__navigation--previous:after {
  content: "\\f104";
}
.react-datepicker .react-datepicker__navigation.react-datepicker__navigation--next:after {
  content: "\\f105";
}
.react-datepicker .react-datepicker__month-container {
  float: none;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header {
  background: none;
  border: none;
  padding: 0;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__current-month {
  font-size: 0.875rem;
  color: var(--bs-body-color);
  font-weight: 600;
  padding: 0.35rem;
  line-height: 1.625rem;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names {
  display: flex;
  margin-bottom: -0.1875rem;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__header .react-datepicker__day-names .react-datepicker__day-name {
  font-weight: 600;
  color: rgba(var(--bs-body-color-rgb), 0.75);
  font-size: 0.875rem;
  padding: 0.35rem;
  line-height: 1.625rem;
  margin: 0;
  flex: 1 1;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month {
  margin: 0;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week {
  display: flex;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day {
  padding: 0.35rem 0.5rem;
  margin: 0.15rem;
  width: 1.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgba(var(--bs-body-color-rgb), 0.5);
  flex: 1 1;
  border-radius: 4px;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:hover, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day:focus, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--today, .react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--keyboard-selected {
  background: rgba(var(--bs-body-color-rgb), 0.15);
  color: var(--bs-body-color);
  outline: none;
}
.react-datepicker .react-datepicker__month-container .react-datepicker__month .react-datepicker__week .react-datepicker__day.react-datepicker__day--selected {
  background: var(--bs-theme) !important;
  color: var(--bs-theme-color) !important;
}

body .react-datepicker__triangle {
  display: none;
}
body .react-datepicker-popper {
  padding: 0.5rem;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  z-index: 10;
  border-radius: 0;
  border: 1px solid var(--bs-border-color-translucent);
}
body .react-datepicker-wrapper {
  display: block;
}

body .ql-toolbar, body .ql-container {
  border-color: var(--bs-border-color) !important;
}
body .ql-toolbar .ql-picker, body .ql-container .ql-picker {
  color: var(--bs-body-color);
}
body .ql-toolbar button, body .ql-toolbar .ql-picker-label, body .ql-toolbar .ql-picker-item, body .ql-container button, body .ql-container .ql-picker-label, body .ql-container .ql-picker-item {
  border: none !important;
}
body .ql-toolbar button:hover, body .ql-toolbar button:focus, body .ql-toolbar .ql-picker-label:hover, body .ql-toolbar .ql-picker-label:focus, body .ql-toolbar .ql-picker-item:hover, body .ql-toolbar .ql-picker-item:focus, body .ql-container button:hover, body .ql-container button:focus, body .ql-container .ql-picker-label:hover, body .ql-container .ql-picker-label:focus, body .ql-container .ql-picker-item:hover, body .ql-container .ql-picker-item:focus {
  background: rgba(var(--bs-body-color-rgb), 0.25) !important;
  color: var(--bs-body-color) !important;
  border-radius: 4px;
}
body .ql-toolbar button:hover .ql-fill, body .ql-toolbar button:focus .ql-fill, body .ql-toolbar .ql-picker-label:hover .ql-fill, body .ql-toolbar .ql-picker-label:focus .ql-fill, body .ql-toolbar .ql-picker-item:hover .ql-fill, body .ql-toolbar .ql-picker-item:focus .ql-fill, body .ql-container button:hover .ql-fill, body .ql-container button:focus .ql-fill, body .ql-container .ql-picker-label:hover .ql-fill, body .ql-container .ql-picker-label:focus .ql-fill, body .ql-container .ql-picker-item:hover .ql-fill, body .ql-container .ql-picker-item:focus .ql-fill {
  fill: var(--bs-body-color) !important;
}
body .ql-toolbar button.ql-active, body .ql-toolbar .ql-picker-label.ql-active, body .ql-toolbar .ql-picker-item.ql-active, body .ql-container button.ql-active, body .ql-container .ql-picker-label.ql-active, body .ql-container .ql-picker-item.ql-active {
  background: rgba(var(--bs-theme-rgb), 0.25) !important;
  border-radius: 4px;
  color: var(--bs-theme) !important;
  border: none !important;
}
body .ql-toolbar button.ql-active .ql-stroke, body .ql-toolbar .ql-picker-label.ql-active .ql-stroke, body .ql-toolbar .ql-picker-item.ql-active .ql-stroke, body .ql-container button.ql-active .ql-stroke, body .ql-container .ql-picker-label.ql-active .ql-stroke, body .ql-container .ql-picker-item.ql-active .ql-stroke {
  stroke: var(--bs-theme) !important;
}
body .ql-toolbar button.ql-active .ql-fill, body .ql-toolbar .ql-picker-label.ql-active .ql-fill, body .ql-toolbar .ql-picker-item.ql-active .ql-fill, body .ql-container button.ql-active .ql-fill, body .ql-container .ql-picker-label.ql-active .ql-fill, body .ql-container .ql-picker-item.ql-active .ql-fill {
  fill: var(--bs-theme) !important;
}
body .ql-toolbar .ql-picker-options, body .ql-container .ql-picker-options {
  border-radius: 0 !important;
  border: 1px solid var(--bs-border-color-translucent) !important;
  margin-top: 0.5rem !important;
  overflow: hidden;
  box-shadow: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);
  padding: 0;
  background: rgba(var(--bs-body-bg-rgb), 0.98);
}
body .ql-toolbar .ql-picker-options .ql-picker-item, body .ql-container .ql-picker-options .ql-picker-item {
  border-radius: 0 !important;
  padding: 0.5rem 1rem;
}
body .ql-toolbar .ql-picker-options .ql-picker-item:hover, body .ql-toolbar .ql-picker-options .ql-picker-item:focus, body .ql-container .ql-picker-options .ql-picker-item:hover, body .ql-container .ql-picker-options .ql-picker-item:focus {
  background: rgba(var(--bs-body-color-rgb), 0.15) !important;
  color: var(--bs-body-color);
}
body .ql-toolbar .ql-picker-options .ql-picker-item.ql-selected, body .ql-container .ql-picker-options .ql-picker-item.ql-selected {
  background: rgba(var(--bs-theme-rgb), 0.25) !important;
  color: var(--bs-theme) !important;
}
body .ql-toolbar .ql-stroke, body .ql-container .ql-stroke {
  fill: transparent !important;
  stroke: var(--bs-body-color) !important;
}
body .ql-toolbar {
  border-radius: 4px 4px 0 0 !important;
}
body .ql-container {
  border-radius: 0 0 4px 4px !important;
}

.border-0 .ql-toolbar {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

.border-0 .ql-container {
  border: none !important;
}

body .react-select__control {
  border: 1px solid var(--bs-border-color);
  background: none;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
  min-height: 2.1875rem;
}
body .react-select__control:hover {
  border-color: var(--bs-border-color);
}
body .react-select__control.react-select__control--is-focused {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
}
body .react-select__control .react-select__value-container {
  padding: 0;
}
body .react-select__control .react-select__value-container .react-select__placeholder {
  margin: 0;
  color: rgba(var(--bs-body-color-rgb), 0.5);
}
body .react-select__control .react-select__value-container .react-select__single-value {
  color: var(--bs-body-color);
}
body .react-select__control .react-select__value-container .react-select__input-container {
  margin: 0;
  padding: 0;
}
body .react-select__control .react-select__value-container .react-select__input-container .react-select__input {
  color: var(--bs-body-color);
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi {
  margin-bottom: -0.3125rem;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__placeholder, body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__input-container {
  margin-top: -0.3125rem;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value {
  margin: 0 0.25rem 0.25rem 0;
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  border-radius: 4px;
  font-weight: 500;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__label {
  color: var(--bs-theme-color);
  font-size: 0.75rem;
  padding: 0.125rem;
  padding-left: 0.375rem;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__remove {
  border-radius: 0;
  padding: 0 3px;
}
body .react-select__control .react-select__value-container.react-select__value-container--is-multi .react-select__multi-value .react-select__multi-value__remove:hover {
  background: none;
  color: rgba(var(--bs-theme-color-rgb), 0.5);
}
body .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  color: rgba(var(--bs-body-color-rgb), 0.5);
}
body .react-select__control .react-select__indicators .react-select__indicator:hover {
  color: var(--bs-body-color);
}
body .react-select__control .react-select__indicators .react-select__indicator-separator {
  background: none;
  margin: 0;
}
body .react-select__menu {
  background: rgba(var(--bs-body-bg-rgb), 0.98);
  border-radius: 0;
  border: 1px solid var(--bs-border-color-translucent);
  overflow: hidden;
}
body .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-focused {
  background: rgba(var(--bs-body-color-rgb), 0.15);
}
body .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-selected {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
}
body .react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-disabled {
  opacity: 0.25;
}

body .sketch-picker, body .chrome-picker {
  background: none !important;
}
body .sketch-picker input, body .chrome-picker input {
  width: 100% !important;
  border: 1px solid var(--bs-border-color) !important;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: none !important;
  text-align: center;
  background: none !important;
  color: var(--bs-body-color) !important;
}
body .sketch-picker input:focus, body .chrome-picker input:focus {
  border-color: rgba(var(--bs-inverse-rgb), 0.5) !important;
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25) !important;
  outline: none !important;
}
body .sketch-picker .flexbox-fix:last-child, body .chrome-picker .flexbox-fix:last-child {
  border-color: var(--bs-border-color) !important;
}
body .sketch-picker label, body .chrome-picker label {
  color: var(--bs-body-color) !important;
}
body .dropdown-menu .sketch-picker, body .dropdown-menu .chrome-picker {
  border: 1px solid var(--bs-dropdown-border-color);
  border-radius: 0 !important;
}
body .dropdown-menu .sketch-picker input:not(:focus), body .dropdown-menu .sketch-picker .flexbox-fix:last-child, body .dropdown-menu .chrome-picker input:not(:focus), body .dropdown-menu .chrome-picker .flexbox-fix:last-child {
  border-color: var(--bs-dropdown-border-color) !important;
}

body .rti--container {
  background: transparent;
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  line-height: 1;
  gap: 0.25rem;
}
body .rti--container:focus-within {
  border-color: rgba(var(--bs-inverse-rgb), 0.5);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-inverse-rgb), 0.25);
}
body .rti--container .rti--tag {
  font-size: 0.75rem;
  color: var(--bs-theme-color);
  line-height: 0.9375rem;
  min-height: 1.25rem;
  font-weight: 500;
  border-radius: 1.25rem;
  padding: 0.3125rem 0.75rem;
  background: var(--bs-theme);
}
body .rti--container .rti--tag button {
  margin-top: 0.0625rem;
  margin-bottom: -0.0625rem;
  color: var(--bs-theme-color);
  margin-right: -0.3125rem;
  margin-left: 0.3125rem;
}
body .rti--container .rti--tag button:hover {
  color: var(--bs-theme-color);
  opacity: 0.5;
}
body .rti--container .rti--input {
  background: none;
  color: var(--bs-inverse);
}
body .rti--container .rti--input::placeholder {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: 400;
}

.calendar {
  min-height: calc(100vh - 3.25rem);
  display: flex;
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 767.98px) {
  .calendar {
    border: none;
  }
}
.calendar .calendar-body {
  flex: 1 1;
  height: calc(100vh - 3.25rem);
}
.calendar .calendar-body + .calendar-sidebar {
  border-left: 1px solid var(--bs-border-color);
}
.calendar .calendar-body .fc .fc-head-container th {
  border-bottom-width: 0;
}
.calendar .calendar-body .fc table {
  border: none !important;
}
.calendar .calendar-body .fc table thead tr, .calendar .calendar-body .fc table tbody tr {
  border-width: 0;
}
.calendar .calendar-body .fc table thead tr th:first-child, .calendar .calendar-body .fc table thead tr td:first-child, .calendar .calendar-body .fc table tbody tr th:first-child, .calendar .calendar-body .fc table tbody tr td:first-child {
  border-left-width: 0 !important;
}
.calendar .calendar-body .fc table thead tr th:last-child, .calendar .calendar-body .fc table thead tr td:last-child, .calendar .calendar-body .fc table tbody tr th:last-child, .calendar .calendar-body .fc table tbody tr td:last-child {
  border-right-width: 0 !important;
}
.calendar .calendar-body .fc table .fc-head-container {
  border: none;
}
.calendar .calendar-sidebar {
  width: 13.75rem;
  padding: 1rem;
}
@media (min-width: 992px) {
  .calendar .calendar-sidebar {
    height: calc(100vh - 3.25rem);
  }
}
@media (max-width: 991.98px) {
  .calendar .calendar-sidebar {
    display: none;
  }
}
.calendar .calendar-sidebar + .calendar-body {
  border-left: 1px solid var(--bs-border-color);
}
.calendar .calendar-sidebar .calendar-sidebar-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  display: flex;
  align-items: flex-end;
}

.coming-soon {
  min-height: 100vh;
  display: flex;
  align-items: center;
}
.coming-soon .coming-soon-img img {
  max-width: 100%;
}
.coming-soon .coming-soon-timer {
  padding: 2rem;
  min-height: 50vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.coming-soon .coming-soon-content {
  min-height: 50vh;
  position: relative;
  text-align: center;
  margin: 0 auto;
  padding: 2rem;
  background: linear-gradient(to bottom, rgba(var(--bs-inverse-rgb), 0.15) 0%, transparent 100%);
  flex: 1 1;
}
.coming-soon .coming-soon-content > * {
  max-width: 32.5rem;
  margin-left: auto;
  margin-right: auto;
}
.coming-soon .is-countdown {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
}
.coming-soon .is-countdown:before, .coming-soon .is-countdown:after {
  content: "";
  display: table;
  clear: both;
}
.coming-soon .is-countdown .countdown-row {
  display: block;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coming-soon .is-countdown .countdown-row .countdown-section {
  width: 7.5rem;
  padding: 1rem;
  background: rgba(var(--bs-inverse-rgb), 0.15);
  margin: 0.75rem;
  color: var(--bs-inverse);
  border-radius: 12px;
}
@media (max-width: 575.98px) {
  .coming-soon .is-countdown .countdown-row .countdown-section {
    width: 5rem;
    padding: 0.5rem 0;
    margin: 0.25rem;
  }
}
.coming-soon .is-countdown .countdown-amount {
  font-size: 3rem;
  font-weight: 600;
  line-height: 1.25;
}
@media (max-width: 575.98px) {
  .coming-soon .is-countdown .countdown-amount {
    font-size: 1.75rem;
  }
}
.coming-soon .is-countdown .countdown-period {
  font-size: 1.00625rem;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  line-height: 1.5;
}
@media (max-width: 575.98px) {
  .coming-soon .is-countdown .countdown-period {
    font-size: 0.7875rem;
  }
}

.data-management .dataTables_wrapper .dataTable {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  color: var(--bs-body-color);
}
.data-management .dataTables_wrapper .dataTables_filter {
  text-align: left;
  margin-bottom: 1rem;
  font-size: 0.75rem;
}
.data-management .dataTables_wrapper .dataTables_filter label {
  display: flex;
  align-items: center;
}
.data-management .dataTables_wrapper .dataTables_filter input {
  border-radius: 4px;
  font-size: 0.8125rem;
  min-width: 12.5rem;
}
@media (max-width: 991.98px) {
  .data-management .dataTables_wrapper .dataTables_filter input {
    min-width: inherit;
    flex: 1 1;
    width: 100%;
  }
}

.error-page {
  min-height: 100vh;
  padding: 4rem 0;
  display: flex;
  align-items: center;
}
.error-page .error-page-content {
  margin: 0 auto;
  position: relative;
  padding: 0 1rem;
  text-align: center;
}
.error-page .error-page-content .error-code {
  color: var(--bs-inverse);
  left: 0;
  right: 0;
  font-size: 7.375rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.25;
  letter-spacing: 5px;
  text-shadow: 10px 10px rgba(var(--bs-inverse-rgb), 0.15);
}
@media (max-width: 575.98px) {
  .error-page .error-page-content .error-code {
    font-size: 6.375rem;
  }
}
.error-page .error-page-content .error-page-icon i {
  font-size: 8rem;
  color: rgb(144.4, 161.9, 170.3);
}
.error-page .error-page-content h1, .error-page .error-page-content .h1 {
  font-size: 3rem;
  font-weight: 600;
}
@media (max-width: 575.98px) {
  .error-page .error-page-content h1, .error-page .error-page-content .h1 {
    font-size: 3.25rem;
  }
}
.error-page .error-page-content h3, .error-page .error-page-content .h3 {
  font-size: 1.125rem;
  font-weight: 400;
}
@media (max-width: 575.98px) {
  .error-page .error-page-content h3, .error-page .error-page-content .h3 {
    font-size: 1rem;
  }
}
.error-page .error-page-content .link-divider {
  width: 0.25rem;
  height: 0.25rem;
  display: inline-block;
  background: rgba(var(--bs-inverse-rgb), 0.3);
  position: relative;
  top: -0.125rem;
  margin: 0 1rem;
  border-radius: 4px;
}

.file-tree {
  position: relative;
}
.file-tree .file-node {
  position: relative;
  padding-left: 0.9375rem;
}
.file-tree .file-node .file-link {
  text-decoration: none;
  padding: 0.25rem 0.25rem;
  color: var(--bs-body-text);
  position: relative;
  border-radius: 4px;
  display: flex;
  font-size: 0.8125rem;
}
.file-tree .file-node .file-link > *:hover, .file-tree .file-node .file-link > *:focus {
  opacity: 0.75;
}
.file-tree .file-node .file-link .file-info {
  display: flex;
  flex: 1 1;
}
.file-tree .file-node .file-link .file-icon {
  font-size: 1rem;
  width: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.35rem;
}
.file-tree .file-node .file-link .file-text {
  flex: 1 1;
}
.file-tree .file-node.has-sub > .file-link .file-arrow:before {
  content: "+";
  position: absolute;
  top: 50%;
  margin-top: -0.65625rem;
  width: 0.75rem;
  display: flex;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  left: -0.75rem;
}
.file-tree .file-node.has-sub.expand > .file-tree {
  display: block;
}
.file-tree .file-node.has-sub.expand > .file-link .file-arrow:before {
  content: "\\f068";
}
.file-tree .file-node.selected > .file-link {
  font-weight: 600;
}
.file-tree .file-node.selected > .file-link > .file-info {
  opacity: 1;
}
.file-tree .file-tree {
  display: none;
}

.file-manager {
  --bs-file-manager-sidebar-width: 15.625rem;
  --bs-file-manager-mobile-sidebar-margin: -15.625rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
.file-manager .file-manager-toolbar {
  background: rgba(var(--bs-body-bg-rgb), 0.5);
  padding: 0.25rem;
  border-bottom: 1px solid var(--bs-border-color);
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 991.98px) {
  .file-manager .file-manager-toolbar {
    overflow: scroll;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
}
.file-manager .file-manager-container {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  position: relative;
}
.file-manager .file-manager-container .file-manager-sidebar {
  display: flex;
  flex-direction: column;
  width: var(--bs-file-manager-sidebar-width);
  min-width: var(--bs-file-manager-sidebar-width);
}
@media (max-width: 991.98px) {
  .file-manager .file-manager-container .file-manager-sidebar {
    position: absolute;
    top: 0;
    bottom: 0;
    background: rgba(var(--bs-body-bg-rgb), 0.95);
    z-index: 10;
    transition: all 0.2s ease-in-out;
    left: var(--bs-file-manager-mobile-sidebar-margin);
    margin-left: 0.0625rem;
    border-right: 1px solid var(--bs-border-color-translucent);
  }
}
.file-manager .file-manager-container .file-manager-sidebar .file-manager-sidebar-mobile-toggler {
  position: absolute;
  top: 1rem;
  width: 2rem;
  left: 100%;
  margin-left: 0.0625rem;
}
.file-manager .file-manager-container .file-manager-sidebar .file-manager-sidebar-mobile-toggler .btn {
  background: rgba(var(--bs-body-bg-rgb), 0.95);
  color: var(--bs-component-color);
  border-radius: 0;
  padding: 0.5rem 0.65rem;
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-inverse-rgb), 0.075);
  transition: all 0.2s ease-in-out;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid var(--bs-border-color-translucent);
  border-left: none;
}
@media (min-width: 992px) {
  .file-manager .file-manager-container .file-manager-sidebar .file-manager-sidebar-mobile-toggler {
    display: none;
  }
}
.file-manager .file-manager-container .file-manager-sidebar .file-manager-sidebar-content {
  flex: 1 1;
  overflow: hidden;
}
.file-manager .file-manager-container .file-manager-sidebar .file-manager-sidebar-footer {
  padding: 0.5rem 1rem;
  border-top: 1px solid var(--bs-border-color);
}
.file-manager .file-manager-container .file-manager-content {
  flex: 1 1;
}
@media (min-width: 992px) {
  .file-manager .file-manager-container .file-manager-content {
    border-left: 1px solid var(--bs-border-color);
  }
}
@media (max-width: 767.98px) {
  .file-manager .file-manager-container .file-manager-content {
    overflow: scroll;
    flex-wrap: nowrap;
  }
}
.file-manager.file-manager-sidebar-mobile-toggled .file-manager-sidebar {
  left: 0;
}
@media (max-width: 991.98px) {
  .file-manager.file-manager-sidebar-mobile-toggled .file-manager-sidebar {
    box-shadow: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);
  }
}
@media (max-width: 991.98px) {
  .file-manager.file-manager-sidebar-mobile-toggled .file-manager-sidebar .file-manager-sidebar-mobile-toggler .btn {
    box-shadow: none;
  }
}

.gallery-menu-container {
  min-width: 12.5rem;
}
@media (min-width: 768px) {
  .gallery-menu-container {
    min-height: calc(100vh - 3.25rem);
    border-right: 1px solid var(--bs-border-color);
  }
}

.gallery-menu {
  padding: 1rem;
  padding: 0;
}
@media (max-width: 767.98px) {
  .gallery-menu {
    overflow: scroll;
    border-bottom: 1px solid var(--bs-border-color);
    position: sticky;
    top: 3.25rem;
    display: flex;
    flex-wrap: nowrap;
  }
}
.gallery-menu .gallery-menu-header {
  padding: 1rem 1rem 0.25rem;
  font-weight: 600;
  font-size: 90%;
}
@media (max-width: 767.98px) {
  .gallery-menu .gallery-menu-header {
    display: none;
  }
}
.gallery-menu .gallery-menu-item .gallery-menu-link {
  padding: 0.35rem 1.25rem;
  display: block;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  text-decoration: none;
}
@media (max-width: 767.98px) {
  .gallery-menu .gallery-menu-item .gallery-menu-link {
    white-space: nowrap;
    padding: 0.9375rem 1.25rem 0.625rem;
  }
}
.gallery-menu .gallery-menu-item .gallery-menu-link .fa {
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
@media (max-width: 767.98px) {
  .gallery-menu .gallery-menu-item .gallery-menu-link .fa {
    display: block;
    margin: 0 0 0.1875rem !important;
    width: auto !important;
    font-size: 1.125rem;
  }
}
.gallery-menu .gallery-menu-item .gallery-menu-link:hover {
  color: rgba(var(--bs-inverse-rgb), 0.75);
}
.gallery-menu .gallery-menu-item .gallery-menu-link.active {
  color: var(--bs-theme);
  font-weight: 600;
}
.gallery-menu .gallery-menu-item .gallery-menu-link.active .fa {
  color: inherit;
}

.gallery-content-container {
  width: 100%;
}
@media (min-width: 768px) {
  .gallery-content-container {
    min-height: calc(100vh - 3.25rem);
  }
}

.gallery {
  padding: 1rem;
}
.gallery + .gallery {
  border-top: 1px solid var(--bs-border-color);
}
.gallery .gallery-title {
  font-size: 1.09375rem;
  color: var(--bs-inverse);
  font-weight: 600;
  margin-bottom: 1rem;
}
.gallery .gallery-title a {
  color: var(--bs-inverse);
  text-decoration: none;
}
.gallery .gallery-title a i {
  font-size: 0.875rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  margin-left: 0.3125rem;
}
.gallery .gallery-title small, .gallery .gallery-title .small {
  display: block;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 0.7875rem;
}
.gallery .gallery-image-list {
  list-style-type: none;
  margin: -0.15rem;
  padding: 0;
}
.gallery .gallery-image-list:before, .gallery .gallery-image-list:after {
  content: "";
  display: table;
  clear: both;
}
.gallery .gallery-image-list > li {
  position: relative;
  padding-top: 12.5%;
  width: 16.6667%;
  float: left;
}
@media (max-width: 991.98px) {
  .gallery .gallery-image-list > li {
    width: 25%;
    padding-top: 18.75%;
  }
}
@media (max-width: 767.98px) {
  .gallery .gallery-image-list > li {
    width: 33.33%;
    padding-top: 33.33%;
  }
}
@media (max-width: 575.98px) {
  .gallery .gallery-image-list > li {
    width: 50%;
    padding-top: 50%;
  }
}
.gallery .gallery-image-list > li:hover {
  z-index: 10;
}
.gallery .gallery-image-list > li a {
  position: absolute;
  left: 0.15rem;
  right: 0.15rem;
  bottom: 0.15rem;
  top: 0.15rem;
  overflow: hidden;
  background: rgba(var(--bs-inverse-rgb), 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}
@media (min-width: 992px) {
  .gallery .gallery-image-list > li a:hover {
    left: -15%;
    right: -15%;
    top: -15%;
    bottom: -15%;
  }
}
.gallery .gallery-image-list > li img, .gallery .gallery-image-list > li .img {
  max-width: 100%;
}
.gallery .gallery-image-list > li .img-portrait {
  height: 100%;
  width: auto;
  max-height: 100%;
  max-width: inherit;
}
@media (max-width: 767.98px) {
  .gallery .gallery-image-list > li .img-portrait-xs {
    height: 100%;
    width: auto;
    max-height: 100%;
    max-width: inherit;
  }
}

.login {
  min-height: 100vh;
  padding: 3rem 1rem;
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .login {
    padding: 1rem;
  }
}
.login .login-content {
  max-width: 22.5rem;
  margin: 0 auto;
  position: relative;
  flex: 1 1;
}

.mailbox {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.mailbox .mailbox-toolbar {
  padding: 0.75rem;
  display: flex;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-toolbar {
    overflow: scroll;
    white-space: nowrap;
    padding: 0.5rem;
    flex-wrap: nowrap;
  }
}
.mailbox .mailbox-toolbar .mailbox-toolbar-text {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  padding: 0.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-toolbar .mailbox-toolbar-text {
    padding: 0;
  }
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link {
  padding: 0.5rem 1rem;
}
.mailbox .mailbox-toolbar .mailbox-toolbar-item {
  padding: 0.5rem;
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link {
  color: rgba(var(--bs-inverse-rgb), 0.75);
  text-decoration: none;
  border-radius: 4px;
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link:hover {
  background: rgba(var(--bs-inverse-rgb), 0.25);
}
.mailbox .mailbox-toolbar .mailbox-toolbar-link.active {
  background: var(--bs-theme);
  color: #FFFFFF;
  font-weight: 600;
}
.mailbox .mailbox-body {
  border-top: 1px solid var(--bs-border-color);
  overflow: hidden;
  display: flex;
  flex: 1 1;
}
.mailbox .mailbox-body .mailbox-sidebar {
  max-width: 22.5rem;
  height: 100%;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-body .mailbox-sidebar {
    max-width: 100%;
    height: auto;
  }
}
.mailbox .mailbox-body .mailbox-sidebar + .mailbox-content {
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-body .mailbox-sidebar + .mailbox-content {
    border-left: none;
  }
}
.mailbox .mailbox-body .mailbox-content {
  height: 100%;
  flex: 1 1;
}
.mailbox .mailbox-empty-message {
  min-height: 100%;
  width: 100%;
  padding: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-icon i {
  font-size: 6.125rem;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-img {
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-img img {
  width: 100%;
  height: 100%;
  max-width: 30rem;
  max-height: 30rem;
  opacity: 0.5;
}
.mailbox .mailbox-empty-message .mailbox-empty-message-title {
  font-size: 1.3125rem;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
.mailbox .mailbox-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.mailbox .mailbox-list .mailbox-list-item {
  padding: 1rem;
  display: flex;
}
.mailbox .mailbox-list .mailbox-list-item + .mailbox-list-item {
  border-top: 1px solid var(--bs-border-color);
}
.mailbox .mailbox-list .mailbox-list-item:hover {
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-list .mailbox-list-item.unread .mailbox-message .mailbox-title {
  font-weight: 600;
  color: var(--bs-inverse);
}
.mailbox .mailbox-list .mailbox-list-item.active {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-list .mailbox-list-item.has-attachment .mailbox-checkbox:after {
  content: "\\f0c1";
  position: absolute;
  top: 1.5625rem;
  text-align: center;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  width: 1.125rem;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  left: 0;
}
.mailbox .mailbox-list .mailbox-checkbox {
  position: relative;
}
.mailbox .mailbox-list .mailbox-checkbox + .mailbox-message {
  padding-left: 0.5rem;
}
.mailbox .mailbox-list .mailbox-message {
  flex: 1 1;
}
.mailbox .mailbox-list .mailbox-message .mailbox-list-item-link {
  display: block;
  color: var(--bs-inverse);
  text-decoration: none;
  position: relative;
}
.mailbox .mailbox-list .mailbox-message .mailbox-sender {
  position: relative;
  display: flex;
  align-items: center;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-list .mailbox-message .mailbox-sender {
    display: block;
  }
}
.mailbox .mailbox-list .mailbox-message .mailbox-sender .mailbox-sender-name {
  font-weight: 600;
  color: var(--bs-theme);
  flex: 1 1;
  margin-right: auto;
}
.mailbox .mailbox-list .mailbox-message .mailbox-sender .mailbox-time {
  font-size: 0.75rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: 400;
  padding-left: 0.5rem;
}
.mailbox .mailbox-list .mailbox-message .mailbox-title {
  color: rgba(var(--bs-inverse-rgb), 0.75);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 18.125rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-list .mailbox-message .mailbox-title {
    max-width: initial;
    white-space: initial;
  }
}
.mailbox .mailbox-list .mailbox-message .mailbox-desc {
  position: relative;
  font-size: 0.8125rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  max-height: 2.625rem;
  overflow: hidden;
}
.mailbox .mailbox-detail {
  padding: 1.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-detail {
    padding: 1rem;
  }
}
.mailbox .mailbox-detail .mailbox-detail-header {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 0 0 1.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-detail .mailbox-detail-header {
    padding-bottom: 1rem;
  }
}
.mailbox .mailbox-detail .mailbox-detail-content {
  padding: 1.5rem 0;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-detail .mailbox-detail-content {
    padding: 1rem 0;
  }
}
.mailbox .mailbox-detail .mailbox-detail-body {
  font-size: 0.875rem;
}
.mailbox .mailbox-detail .mailbox-detail-attachment {
  display: flex;
  flex-wrap: wrap;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment {
  background: rgba(var(--bs-inverse-rgb), 0.15);
  width: 7.5rem;
  overflow: hidden;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  margin-right: 0.5rem;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment a {
  display: block;
  text-decoration: none;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file {
  height: 3.75rem;
  overflow: hidden;
  text-align: center;
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file i {
  display: block;
  line-height: 3.75rem;
  font-size: 2rem;
  color: var(--bs-inverse);
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-file img {
  max-width: 100%;
}
.mailbox .mailbox-detail .mailbox-detail-attachment .mailbox-attachment .document-name {
  color: var(--bs-inverse);
  padding: 0.125rem 0.625rem;
  font-size: 0.8125rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mailbox .mailbox-form .mailbox-form-header {
  padding: 1rem 1.5rem;
}
@media (max-width: 991.98px) {
  .mailbox .mailbox-form .mailbox-form-header {
    padding: 0.75rem 1rem;
  }
}
.mailbox .mailbox-form .mailbox-form-header .form-control {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}
.mailbox .mailbox-form .note-editor {
  border: none;
  border-radius: 0;
}
.mailbox .mailbox-form .note-editor .note-toolbar {
  border-top: 1px solid var(--bs-border-color);
  border-bottom: 1px solid var(--bs-border-color);
}
.mailbox .mailbox-form .note-editor .note-editing-area {
  background: rgba(var(--bs-inverse-rgb), 0.1);
}

.messenger {
  height: 100%;
  display: flex;
}
.messenger .messenger-sidebar {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
@media (min-width: 992px) {
  .messenger .messenger-sidebar {
    max-width: 22.5rem;
    border-right: 1px solid var(--bs-border-color);
  }
}
.messenger .messenger-sidebar .messenger-sidebar-header {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 1rem;
}
.messenger .messenger-sidebar .messenger-sidebar-body {
  flex: 1 1;
  overflow: hidden;
}
.messenger .messenger-sidebar .messenger-item {
  border-bottom: 1px solid var(--bs-border-color);
}
.messenger .messenger-sidebar .messenger-item .messenger-link {
  display: flex;
  padding: 0.85rem 1rem;
  text-decoration: none;
  color: var(--bs-inverse);
}
.messenger .messenger-sidebar .messenger-item .messenger-link.active {
  background-color: rgba(var(--bs-inverse-rgb), 0.15);
}
.messenger .messenger-sidebar .messenger-item .messenger-link:hover, .messenger .messenger-sidebar .messenger-item .messenger-link:focus {
  background-color: rgba(var(--bs-inverse-rgb), 0.1);
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media img {
  max-width: 100%;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-media + .messenger-info {
  padding-left: 0.85rem;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-info {
  flex: 1 1;
  white-space: nowrap;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-time-badge {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-time {
  font-size: 0.690625rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  margin-bottom: 0.25rem;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-text, .messenger .messenger-sidebar .messenger-item .messenger-link .messenger-name {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 13.75rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 0.8125rem;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-name {
  font-weight: 600;
  color: var(--bs-inverse);
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-badge {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
  display: inline-flex;
  border-radius: 1.875rem;
  padding: 0 0.1875rem;
  min-width: 1.125rem;
  min-height: 1.125rem;
  align-items: center;
  justify-content: center;
  font-size: 0.56875rem;
  font-weight: 600;
  margin-left: auto;
}
.messenger .messenger-sidebar .messenger-item .messenger-link .messenger-badge.empty {
  display: none;
}
.messenger .messenger-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
@media (max-width: 991.98px) {
  .messenger .messenger-content {
    display: none;
  }
}
.messenger .messenger-content .messenger-content-header {
  display: flex;
  border-bottom: 1px solid var(--bs-border-color);
  padding: 0.75rem 1rem;
  align-items: center;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler {
  display: none;
}
@media (max-width: 991.98px) {
  .messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler {
    display: block;
  }
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-mobile-toggler a {
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-size: 1.125rem;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-media .media {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-media + .messenger-content-header-info {
  margin-left: 1rem;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-info {
  font-size: 0.875rem;
  color: var(--bs-inverse);
  font-weight: 600;
  font-size: 0.9375rem;
  flex: 1 1;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-info small, .messenger .messenger-content .messenger-content-header .messenger-content-header-info .small {
  display: block;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  font-weight: normal;
  font-size: 0.6875rem;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-btn {
  display: flex;
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn {
  font-size: 1rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
}
.messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn:hover, .messenger .messenger-content .messenger-content-header .messenger-content-header-btn .btn:focus {
  color: var(--bs-inverse);
}
.messenger .messenger-content .messenger-content-body {
  flex: 1 1;
  overflow: hidden;
}
.messenger .messenger-content .messenger-content-body .widget-chat {
  padding: 1rem;
}
.messenger .messenger-content .messenger-content-footer {
  border-top: 1px solid var(--bs-border-color);
  padding: 1rem;
}
@media (max-width: 991.98px) {
  .messenger.messenger-content-toggled .messenger-sidebar {
    display: none;
  }
  .messenger.messenger-content-toggled .messenger-content {
    display: flex;
  }
}

.pos {
  background: var(--app-pos-bg);
  height: 100%;
}
.pos .pos-container {
  height: 100%;
  padding: 0;
}
@media (min-width: 992px) {
  .pos .pos-container {
    display: flex;
  }
  .pos .pos-container > div + div {
    border-left: 1px solid var(--bs-border-color);
  }
}
.pos .pos-menu {
  display: flex;
}
@media (min-width: 992px) {
  .pos .pos-menu {
    width: 140px;
    flex-direction: column;
  }
}
@media (max-width: 991.98px) {
  .pos .pos-menu {
    overflow: scroll;
    align-items: center;
    border-bottom: 1px solid var(--bs-border-color);
  }
}
.pos .pos-menu .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
@media (max-width: 991.98px) {
  .pos .pos-menu .logo {
    width: 140px;
    height: 5.9375rem;
    flex: 0 0 140px;
  }
}
.pos .pos-menu .logo a {
  display: block;
  text-decoration: none;
  color: inherit;
}
.pos .pos-menu .logo .logo-img {
  text-align: center;
  height: 2.875rem;
}
.pos .pos-menu .logo .logo-text {
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: 0.25rem;
}
.pos .pos-menu .logo img {
  max-width: 100%;
  max-height: 100%;
}
.pos .pos-menu .nav-container {
  flex: 1 1;
}
@media (min-width: 992px) {
  .pos .pos-menu .nav-container {
    overflow: hidden;
    padding: 0;
  }
}
.pos .pos-menu .nav.nav-tabs {
  margin: 0;
  padding: 0;
  display: block;
  border: 0;
}
@media (max-width: 991.98px) {
  .pos .pos-menu .nav.nav-tabs {
    display: flex;
    flex-wrap: nowrap;
  }
}
@media (max-width: 991.98px) {
  .pos .pos-menu .nav.nav-tabs .nav-item {
    min-width: 5.625rem;
  }
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link {
  position: relative;
  padding: 1rem;
  white-space: nowrap;
  text-align: center;
  color: rgba(var(--bs-inverse), 0.25);
  border: none;
  font-size: 0.65625rem;
  text-transform: uppercase;
  font-weight: 600;
  border-radius: 0;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card {
  margin: -0.75rem -0.25rem;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card .card-body {
  padding: 0.5rem 0.7rem;
  margin: 0.5rem;
  flex: 1 1;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card:before, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card:after, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link .card .card-arrow {
  visibility: hidden;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link .fa {
  display: block;
  margin: 0.225rem auto 0.35rem auto !important;
  font-size: 1.25rem;
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link:hover {
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active {
  color: var(--bs-inverse);
}
.pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card:before, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card:after, .pos .pos-menu .nav.nav-tabs .nav-item .nav-link.active .card .card-arrow {
  visibility: visible;
}
.pos .pos-content {
  flex: 1 1;
}
@media (min-width: 992px) {
  .pos .pos-content {
    overflow: scroll;
  }
}
@media (max-width: 991.98px) {
  .pos .pos-content {
    height: calc(100% - 96px);
  }
}
.pos .pos-content .pos-content-container {
  padding: 0 2rem;
}
.pos .pos-sidebar {
  width: 360px;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 360px;
}
@media (max-width: 991.98px) {
  .pos .pos-sidebar {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    z-index: 1021;
    background: var(--bs-body-bg);
    background: var(--bs-body-bg-gradient);
    display: none;
  }
}
.pos .pos-sidebar .pos-sidebar-header {
  padding: 1rem 1.5rem;
  position: relative;
  display: flex;
  align-items: center;
}
.pos .pos-sidebar .pos-sidebar-header .back-btn {
  border: none;
  display: none;
  margin-right: 1rem;
}
@media (max-width: 991.98px) {
  .pos .pos-sidebar .pos-sidebar-header .back-btn {
    display: block;
  }
}
.pos .pos-sidebar .pos-sidebar-header .back-btn .btn {
  color: var(--bs-inverse);
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 1.09375rem;
}
.pos .pos-sidebar .pos-sidebar-header .icon img {
  height: 1.875rem;
}
.pos .pos-sidebar .pos-sidebar-header .icon + .title {
  padding-left: 0.625rem;
}
.pos .pos-sidebar .pos-sidebar-header .title {
  font-weight: 600;
  flex: 1 1;
}
.pos .pos-sidebar .pos-sidebar-header .order {
  display: block;
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs {
  padding: 0 1.5rem;
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item .nav-link {
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item .nav-link.active {
  color: var(--bs-inverse);
}
.pos .pos-sidebar .pos-sidebar-nav .nav.nav-tabs .nav-item + .nav-item {
  margin-left: 0.5rem;
}
.pos .pos-sidebar .pos-sidebar-body {
  padding: 0;
  margin: 0;
  overflow: scroll;
  flex: 1 1;
}
.pos .pos-sidebar .pos-sidebar-footer {
  border-top: 1px solid var(--bs-border-color);
  padding: 1rem 1.5rem;
}
.pos .pos-sidebar .pos-order {
  padding: 1.5rem;
  position: relative;
  display: flex;
}
.pos .pos-sidebar .pos-order .pos-order-product {
  display: flex;
  flex: 1 1;
}
.pos .pos-sidebar .pos-order .pos-order-product .img {
  width: 4.5rem;
  height: 4.5rem;
  background-position: center;
  background-size: cover;
}
.pos .pos-sidebar .pos-order .pos-order-product > * + * {
  margin-left: 1rem;
}
.pos .pos-sidebar .pos-order > * + * {
  margin-left: 1rem;
}
.pos .pos-sidebar .pos-order .pos-order-confirmation {
  position: absolute;
  top: 0;
  left: 0.0625rem;
  right: 0.0625rem;
  bottom: 0;
  z-index: 10;
  background: rgba(235, 235, 235, 0.88);
  padding: 1rem;
  margin: 0;
}
.pos .pos-sidebar .pos-order .pos-order-confirmation > * {
  position: relative;
}
.pos .pos-sidebar .pos-order .pos-order-confirmation .btn {
  min-width: 3.75rem;
}
.pos .pos-sidebar .pos-order + .pos-order {
  border-top: 1px solid var(--bs-border-color);
}
.pos .pos-header {
  padding: 0.66rem 1.75rem;
  height: 3.25rem;
  display: flex;
  align-items: center;
}
.pos .pos-header .logo, .pos .pos-header .time, .pos .pos-header .nav {
  width: 33.33%;
}
@media (max-width: 767.98px) {
  .pos .pos-header .logo, .pos .pos-header .time, .pos .pos-header .nav {
    width: 50%;
  }
}
.pos .pos-header .logo {
  display: flex;
}
.pos .pos-header .logo > div, .pos .pos-header .logo > a {
  text-align: center;
  color: var(--bs-inverse);
  text-decoration: none;
  display: flex;
  align-items: center;
}
.pos .pos-header .logo > div .logo-img img, .pos .pos-header .logo > a .logo-img img {
  height: 2rem;
}
.pos .pos-header .logo > div .logo-text, .pos .pos-header .logo > a .logo-text {
  font-weight: 600;
  font-size: 1rem;
  letter-spacing: 0.0625rem;
  margin-left: 1rem;
}
.pos .pos-header .time {
  font-weight: 600;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767.98px) {
  .pos .pos-header .time {
    display: none;
  }
}
.pos .pos-header .nav {
  align-items: center;
  justify-content: flex-end;
}
.pos .pos-header .nav .nav-item .nav-link {
  padding: 0.333rem 1rem;
  color: var(--bs-inverse);
}
@media (max-width: 767.98px) {
  .pos .pos-header .nav .nav-item .nav-link {
    padding: 0.333rem 0.66rem;
  }
}
.pos .pos-header .nav .nav-item .nav-link .nav-icon {
  height: 1.25rem;
  font-size: 1.25rem;
}
.pos .pos-header .nav .nav-item .nav-link:hover {
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-product {
  text-decoration: none;
  color: var(--bs-inverse);
  position: relative;
  transition: all 0.2s linear;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pos .pos-product .img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 11.25rem;
  transition: all 0.2s linear;
}
.pos .pos-product .info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(var(--bs-inverse), 0.1);
  padding: 1rem;
}
.pos .pos-product .info .title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--app-component-color);
  margin: 0 0 0.125rem;
}
.pos .pos-product .info .desc {
  color: rgba(var(--bs-inverse), 0.5);
  margin: 0 0 1rem;
  line-height: 1.4;
  flex: 1 1;
}
.pos .pos-product .info .price {
  margin: 0;
  font-weight: 600;
  color: var(--app-component-color);
  font-size: 1rem;
}
.pos .pos-product.not-available {
  cursor: not-allowed;
}
.pos .pos-product.not-available .not-available-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 11.25rem;
  background: rgba(235, 235, 235, 0.88);
  color: var(--bs-inverse);
  font-size: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pos .pos-table-booking {
  display: block;
  margin-bottom: 1.25rem;
  text-decoration: none;
  color: var(--bs-inverse);
}
.pos .pos-table-booking:hover .pos-table-booking-container {
  background: rgba(var(--bs-inverse), 0.2);
}
.pos .pos-table-booking .pos-table-booking-container {
  padding: 0;
  background: rgba(var(--bs-inverse), 0.1);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-header {
  padding: 1rem;
  border-bottom: 1px solid var(--bs-border-color);
  color: rgba(var(--bs-inverse), 0.5);
  font-weight: 600;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-header .no {
  font-size: 2.5rem;
  color: var(--bs-inverse);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking {
  font-size: 0.8125rem;
  padding: 0.333rem 1rem;
  display: flex;
  align-items: center;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .time {
  width: 4.6875rem;
  font-weight: 600;
  font-size: 0.74375rem;
  color: rgba(var(--bs-inverse), 0.5);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .info {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 1;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status {
  font-size: 0.375rem;
  color: #617a86;
  display: flex;
  align-items: center;
  padding-left: 1rem;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status.upcoming {
  color: #ff9f0c;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking .status.in-progress {
  color: #249d79;
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking.highlight {
  color: var(--bs-theme);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking.highlight .time {
  color: rgba(var(--bs-theme-rgb), 0.75);
}
.pos .pos-table-booking .pos-table-booking-container .pos-table-booking-body .booking + .booking {
  border-top: 1px solid var(--bs-border-color);
}
.pos .pos-task {
  border-bottom: 1px solid var(--bs-border-color);
}
@media (min-width: 768px) {
  .pos .pos-task {
    display: flex;
  }
}
.pos .pos-task .pos-task-info {
  width: 30%;
  padding: 1.5rem;
  text-align: right;
}
@media (max-width: 767.98px) {
  .pos .pos-task .pos-task-info {
    width: auto;
    position: relative;
    text-align: left;
  }
}
.pos .pos-task .pos-task-body {
  padding: 1.5rem;
  flex: 1 1;
  border-left: 1px solid var(--bs-border-color);
}
@media (max-width: 767.98px) {
  .pos .pos-task .pos-task-body {
    border-left: none;
    padding-top: 0;
  }
}
.pos .pos-task .pos-task-body .pos-task-completed {
  font-size: 1rem;
  line-height: 2.25rem;
}
@media (max-width: 767.98px) {
  .pos .pos-task .pos-task-body .pos-task-completed {
    border-top: 1px solid var(--bs-border-color);
    margin-top: -0.625rem;
    padding-top: 0.625rem;
  }
}
.pos .pos-task .pos-task-body .pos-task-product {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img {
  padding-top: 75%;
  position: relative;
  margin-bottom: 1rem;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img .cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-img .caption {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(53.35, 67.1, 73.7, 0.75);
  color: var(--bs-white);
  font-size: 1.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-info {
  display: flex;
  flex: 1 1;
  margin-bottom: 1rem;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-action .btn {
  display: block;
}
.pos .pos-task .pos-task-body .pos-task-product .pos-task-product-action .btn + .btn {
  margin-top: 0.75rem;
}
.pos .pos-task .pos-task-body .pos-task-product.completed .pos-task-product-info {
  opacity: 0.33;
}
.pos .pos-checkout-table {
  padding: 0.0625rem;
  margin: 0;
  height: 100%;
}
.pos .pos-checkout-table .pos-checkout-table-container {
  color: var(--bs-inverse);
  display: block;
  padding: 0;
  height: 100%;
  text-decoration: none;
  position: relative;
  transition: all 0.1s linear;
  margin: 0.25rem;
}
.pos .pos-checkout-table .pos-checkout-table-container:before {
  transition: all 0.1s linear;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-header {
  padding: 1rem;
  text-align: center;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-header .status {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  font-size: 0.5rem;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row {
  border-top: 1px solid var(--bs-border-color);
  margin: 0;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row > div {
  padding: 0.25rem 0.5rem;
  text-align: center;
}
.pos .pos-checkout-table .pos-checkout-table-container .pos-checkout-table-info > .row > div + div {
  border-left: 1px solid var(--bs-border-color);
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) {
  position: relative;
  z-index: 10;
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container {
  position: relative;
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container:before {
  content: "";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(45, 51, 58, 0.75);
}
.pos .pos-checkout-table.in-use:hover:not(.disabled) .table-container:after {
  content: "\\f00c";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: var(--app-component-color);
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container .table-info-row, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container .table-info-row {
  color: var(--app-component-color);
}
.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container:before, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container:before {
  content: "";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--bs-theme-rgb), 0.5);
}
.pos .pos-checkout-table.selected:not(.disabled) .pos-checkout-table-container:after, .pos .pos-checkout-table.selected:not(.disabled):hover .pos-checkout-table-container:after {
  content: "\\f00c";
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: var(--bs-inverse);
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;
  font-weight: 900;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.pos .pos-checkout-table.disabled .pos-checkout-table-container {
  cursor: not-allowed;
  background: var(--app-component-bg);
  color: var(--app-component-color);
}
.pos .pos-checkout-table.disabled .pos-checkout-table-container .status {
  color: #e00000;
}
.pos .pos-checkout-table.available .pos-checkout-table-container .status {
  color: #249d79;
}
.pos .pos-checkout-table.available .pos-checkout-table-container .pos-checkout-table-info {
  color: transparent;
}
.pos .pos-checkout-table.available .pos-checkout-table-container .pos-checkout-table-info i {
  color: transparent !important;
}
.pos .pos-checkout-table.in-use .pos-checkout-table-container {
  background: rgba(var(--bs-inverse), 0.15);
  position: relative;
}
.pos .pos-checkout-table.in-use .pos-checkout-table-container .status {
  color: #ff9f0c;
}
.pos.pos-vertical > .pos-container {
  flex-direction: column;
}
.pos.pos-vertical > .pos-container .pos-header + .pos-content {
  height: calc(100% - 52px);
}
.pos.pos-vertical > .pos-container > div + div {
  border: 0;
  border-top: 1px solid var(--bs-border-color);
}
@media (max-width: 991.98px) {
  .pos.pos-mobile-sidebar-toggled {
    z-index: 20;
  }
  .pos.pos-mobile-sidebar-toggled .pos-content, .pos.pos-mobile-sidebar-toggled .pos-menu {
    opacity: 0.25;
  }
  .pos.pos-mobile-sidebar-toggled .pos-sidebar {
    display: flex;
  }
  .pos.pos-mobile-sidebar-toggled.pos-vertical > .pos-container > .pos-content {
    opacity: 1;
  }
}

.modal.modal-pos .close {
  position: absolute;
  top: 1.5625rem;
  z-index: 10;
  right: 1.5625rem;
}
@media (min-width: 992px) {
  .modal.modal-pos .modal-pos-product {
    display: flex;
  }
  .modal.modal-pos .modal-pos-product .modal-pos-product-img, .modal.modal-pos .modal-pos-product .modal-pos-product-info {
    width: 50%;
    max-width: 50%;
    flex: 0 0 50%;
  }
}
.modal.modal-pos .modal-pos-product .modal-pos-product-img {
  padding: 1rem;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-img .img {
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 15.625rem;
}
@media (min-width: 992px) {
  .modal.modal-pos .modal-pos-product .modal-pos-product-img .img {
    min-height: 18.75rem;
  }
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info {
  padding: 1.5rem;
  border-left: 1px solid var(--bs-border-color);
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list {
  margin: -0.333rem;
  padding: 0.333rem 0;
  display: flex;
  flex-wrap: wrap;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option {
  width: 33.33%;
  max-width: 33.33%;
  padding: 0.333rem;
  flex: 0 0 33.33%;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-input {
  display: none;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-input:checked + .option-label {
  color: var(--bs-theme);
  border: 1px solid var(--bs-theme);
  background: rgba(var(--bs-theme-rgb), 0.1);
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label {
  border: 1px solid rgba(var(--bs-inverse-rgb), 0.25);
  padding: 0.625rem;
  height: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label .option-text {
  display: block;
  line-height: 1.2;
  opacity: 0.75;
  font-size: 0.8125rem;
  text-align: center;
}
.modal.modal-pos .modal-pos-product .modal-pos-product-info .option-list .option .option-label .option-price {
  font-weight: 600;
  margin-top: 0.25rem;
  line-height: 1.2;
}

.pos-mobile-sidebar-toggler {
  position: fixed;
  bottom: 3rem;
  right: 1rem;
  z-index: 1020;
  background: var(--bs-white);
  padding: 0.5rem;
  width: 3.75rem;
  height: 3.75rem;
  text-decoration: none;
  color: var(--bs-black);
  display: none;
  border-radius: 50px;
  box-shadow: 0 1rem 3rem rgba(var(--bs-inverse-rgb), 0.175);
  align-items: center;
  z-index: 10;
}
.pos-mobile-sidebar-toggler:before {
  content: "";
  position: absolute;
  top: -0.25rem;
  left: -0.25rem;
  right: -0.25rem;
  bottom: -0.25rem;
  border: 2px solid var(--bs-white);
  border-radius: 50px;
}
@media (max-width: 991.98px) {
  .pos-mobile-sidebar-toggler {
    display: flex;
  }
}
.pos-mobile-sidebar-toggler:hover {
  color: rgb(82.45, 103.7, 113.9);
}
.pos-mobile-sidebar-toggler i {
  font-size: 2rem;
  display: block;
  margin: 0 auto;
}
.pos-mobile-sidebar-toggler .badge {
  position: absolute;
  right: -0.3rem;
  top: -0.3rem;
  background-color: var(--bs-theme);
  color: var(--bs-theme-color);
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

[data-bs-theme=dark] .pos .pos-product.not-available .not-available-text,
[data-bs-theme=dark] .pos .pos-sidebar .pos-order .pos-order-confirmation {
  background: rgba(59, 70, 82, 0.88);
}

.profile .profile-img {
  height: 12.5rem;
  overflow: hidden;
  margin-bottom: 1rem;
  z-index: 10;
}
.profile .profile-img img {
  max-width: 100%;
  width: 100%;
}
.profile .profile-tab {
  position: relative;
  padding: 0 1.5rem;
  flex: 1 1;
}
@media (max-width: 991.98px) {
  .profile .profile-tab {
    overflow: scroll;
    padding: 0 1rem;
    display: flex;
    flex-wrap: nowrap;
  }
}
.profile .profile-tab .nav-item .nav-link {
  text-align: center;
}
.profile .profile-tab .nav-item .nav-link .nav-value {
  font-size: 1.3125rem;
  font-weight: 600;
  margin-bottom: -0.35rem;
}
@media (max-width: 767.98px) {
  .profile .profile-tab .nav-item .nav-link .nav-value {
    font-size: 1.00625rem;
  }
}
.profile .profile-tab .nav-item + .nav-item {
  margin-left: 1.5rem;
}
.profile .profile-container {
  display: flex;
}
@media (max-width: 991.98px) {
  .profile .profile-container {
    display: block;
  }
}
.profile .profile-container .profile-sidebar {
  width: 15.625rem;
  padding: 1.5rem;
  border-right: 1px solid var(--bs-border-color);
}
@media (max-width: 991.98px) {
  .profile .profile-container .profile-sidebar {
    display: none;
  }
}
.profile .profile-container .profile-content {
  flex: 1 1;
}
.profile .profile-container .profile-content .profile-content-container {
  padding: 1.5rem;
}
@media (max-width: 991.98px) {
  .profile .profile-container .profile-content .profile-content-container {
    padding: 1rem;
  }
}
.profile .profile-img-list {
  list-style-type: none;
  margin: -0.25rem;
  padding: 0;
}
.profile .profile-img-list:before, .profile .profile-img-list:after {
  content: "";
  display: table;
  clear: both;
}
.profile .profile-img-list .profile-img-list-item {
  width: 25%;
  padding: 0.25rem;
  float: left;
}
.profile .profile-img-list .profile-img-list-item.main {
  width: 50%;
}
.profile .profile-img-list .profile-img-list-item .profile-img-list-link {
  display: block;
  padding-top: 75%;
  overflow: hidden;
  position: relative;
}
.profile .profile-img-list .profile-img-list-item .profile-img-list-link img, .profile .profile-img-list .profile-img-list-item .profile-img-list-link .profile-img-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.profile .profile-img-list .profile-img-list-item .profile-img-list-link img:before, .profile .profile-img-list .profile-img-list-item .profile-img-list-link .profile-img-content:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid rgba(var(--bs-inverse-rgb), 0.15);
}
.profile .profile-img-list .profile-img-list-item.with-number .profile-img-number {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  color: #FFFFFF;
  font-size: 1.53125rem;
  font-weight: 600;
  line-height: 1.625rem;
  margin-top: -0.765625rem;
  text-align: center;
}

.register {
  min-height: 100vh;
  padding: 3rem 1rem;
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .register {
    padding: 1rem;
  }
}
.register .register-content {
  flex: 1 1;
  max-width: 22.5rem;
  margin: 0 auto;
  position: relative;
}

.search-result .search-input {
  position: relative;
  max-width: 45rem;
  margin-bottom: 0.9375rem;
}
.search-result .search-close {
  position: absolute;
  top: 50%;
  margin-top: -0.75rem;
  width: 1.625rem;
  height: 1.625rem;
  text-align: center;
  font-size: 1.25rem;
  padding: 0 0 0.125rem;
  color: var(--bs-inverse);
  background: rgba(var(--bs-inverse-rgb), 0.25);
  text-decoration: none;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0.75rem;
}
.search-result .search-close:hover, .search-result .search-close:focus {
  text-decoration: none;
  background: rgba(var(--bs-inverse-rgb), 0.5);
  color: var(--bs-inverse);
}
.search-result .search-tab {
  list-style-type: none;
  margin: 0 -2rem;
  padding: 0 2rem;
  border-bottom: 1px solid var(--bs-border-color);
  white-space: nowrap;
  display: flex;
}
@media (max-width: 767.98px) {
  .search-result .search-tab {
    margin: 0 -0.9375rem;
    padding: 0 0.9375rem;
    overflow: scroll;
  }
}
.search-result .search-tab .search-tab-item .search-tab-link {
  display: block;
  padding: 0.625rem;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  text-decoration: none;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  margin-bottom: -1px;
}
.search-result .search-tab .search-tab-item .search-tab-link:hover, .search-result .search-tab .search-tab-item .search-tab-link:focus {
  border-bottom-color: rgb(144.4, 161.9, 170.3);
}
.search-result .search-tab .search-tab-item .search-tab-link.active {
  font-weight: 600;
  color: var(--bs-theme);
  border-bottom-color: var(--bs-theme);
}
.search-result .search-tab .search-tab-item + .search-tab-item {
  margin-left: 1rem;
}
.search-result .search-result-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.search-result .search-result-list .search-result-item {
  padding: 2rem 0;
  display: flex;
}
.search-result .search-result-list .search-result-item:before, .search-result .search-result-list .search-result-item:after {
  content: "";
  display: table;
  clear: both;
}
.search-result .search-result-list .search-result-item:last-child {
  border-bottom: 1px solid var(--bs-border-color);
}
.search-result .search-result-list .search-result-item + .search-result-item {
  border-top: 1px solid var(--bs-border-color);
}
.search-result .search-result-list .search-result-item .search-result-media {
  width: 10rem;
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767.98px) {
  .search-result .search-result-list .search-result-item .search-result-media {
    width: 5rem;
    height: 3.75rem;
  }
}
.search-result .search-result-list .search-result-item .search-result-media img {
  max-width: 100%;
  max-height: 100%;
}
.search-result .search-result-list .search-result-item .search-result-media + .search-result-content {
  padding-left: 1.875rem;
}
.search-result .search-result-list .search-result-item .search-result-content {
  flex: 1 1;
}
.search-result .search-result-list .search-result-item .search-result-content h3, .search-result .search-result-list .search-result-item .search-result-content .h3 {
  margin: 0 0 0.3125rem;
  font-size: 1.25rem;
}
.search-result .search-result-list .search-result-item .search-result-content h3 a, .search-result .search-result-list .search-result-item .search-result-content .h3 a {
  color: var(--bs-inverse);
  text-decoration: none;
}
.search-result .search-result-list .search-result-item .search-result-content h3 a:hover, .search-result .search-result-list .search-result-item .search-result-content .h3 a:hover {
  text-decoration: underline;
}

.widget-chat {
  margin: 0;
  padding: 0;
}
.widget-chat .widget-chat-item {
  display: flex;
  align-items: flex-end;
}
.widget-chat .widget-chat-item + .widget-chat-item {
  margin-top: 1rem;
}
.widget-chat .widget-chat-item > div + div {
  padding-left: 0.75rem;
}
.widget-chat .widget-chat-date {
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.5);
  padding: 0.75rem;
  text-align: center;
}
.widget-chat .widget-chat-content {
  flex: 1 1;
}
.widget-chat .widget-chat-name, .widget-chat .widget-chat-status {
  font-size: 0.6875rem;
  font-weight: 600;
  color: rgba(var(--bs-inverse-rgb), 0.75);
  margin: 0.25rem 0;
  line-height: 1.5;
}
.widget-chat .widget-chat-media {
  width: 1.75rem;
}
.widget-chat .widget-chat-media img {
  max-width: 100%;
  display: block;
  border-radius: 28px;
}
.widget-chat .widget-chat-message {
  background: #FFFFFF;
  color: #000000;
  padding: 0.5rem 1rem;
  display: inline-block;
  position: relative;
  border-radius: 8px;
}
.widget-chat .widget-chat-message + .widget-chat-message {
  margin-top: 0.3rem;
}
.widget-chat .widget-chat-message.last:before {
  content: "";
  border: 0.3125rem solid transparent;
  border-bottom-color: #FFFFFF;
  position: absolute;
  bottom: 0.375rem;
  left: -0.25rem;
  border-right-color: #FFFFFF;
}
.widget-chat .reply .widget-chat-content {
  text-align: right;
}
.widget-chat .reply .widget-chat-message {
  background: var(--bs-theme);
  color: var(--bs-theme-color);
}
.widget-chat .reply .widget-chat-message.last:before {
  border-color: transparent;
  border-bottom-color: var(--bs-theme);
  border-left-color: var(--bs-theme);
  left: auto;
  right: -0.25rem;
}

.widget-img-list {
  margin: -0.0625rem;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.widget-img-list .widget-img-list-item {
  padding: 0.0625rem;
  width: 20%;
}
.widget-img-list .widget-img-list-item a {
  display: block;
  text-decoration: none;
  padding-top: 100%;
  position: relative;
  overflow: hidden;
}
.widget-img-list .widget-img-list-item a img, .widget-img-list .widget-img-list-item a .img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
}
.widget-img-list .widget-img-list-item a .img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.widget-reminder .widget-reminder-item {
  position: relative;
  display: flex;
}
.widget-reminder .widget-reminder-header + .widget-reminder-item, .widget-reminder .widget-reminder-item + .widget-reminder-header, .widget-reminder .widget-reminder-item + .widget-reminder-item {
  border-top: 1px solid var(--bs-border-color);
}
.widget-reminder .widget-reminder-time, .widget-reminder .widget-reminder-content {
  padding: 1rem;
}
.widget-reminder .widget-reminder-content {
  flex: 1 1;
}
.widget-reminder .widget-reminder-time {
  width: 5rem;
  font-size: 0.8125rem;
  text-align: right;
}
.widget-reminder .widget-reminder-divider {
  width: 0.1875rem;
  background: var(--bs-border-color);
}
.widget-reminder + .card-header, .widget-reminder + .card-footer, .widget-reminder + .card-body {
  border-top: 1px solid var(--bs-border-color);
}

.widget-user-list {
  display: flex;
  align-items: center;
}
.widget-user-list .widget-user-list-item .widget-user-list-link {
  border: 2px solid var(--bs-body-bg);
  overflow: hidden;
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
}
.widget-user-list .widget-user-list-item .widget-user-list-link img {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.widget-user-list .widget-user-list-item + .widget-user-list-item {
  margin-left: -1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/scss/styles.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/_variables-dark.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/scss/_root.scss","webpack://./src/scss/_reboot.scss","webpack://./src/scss/_helper.scss","webpack://./src/scss/mixins/_helper-spacing.scss","webpack://./src/scss/mixins/_helper-font-size.scss","webpack://./src/scss/mixins/_helper-font-weight.scss","webpack://./src/scss/mixins/_helper-size.scss","webpack://./src/scss/mixins/_helper-color.scss","webpack://./src/scss/mixins/_helper-color-dark.scss","webpack://./src/scss/mixins/_background-gradient.scss","webpack://./src/scss/mixins/_helper-opacity.scss","webpack://./src/scss/app/_app-content.scss","webpack://./src/scss/app/_app-footer.scss","webpack://./src/scss/app/_app-header.scss","webpack://./src/scss/app/_app-sidebar-mobile-backdrop.scss","webpack://./src/scss/app/_app-sidebar.scss","webpack://./src/scss/app/_app-theme-panel.scss","webpack://./src/scss/mixins/_fontawesome.scss","webpack://./src/scss/app/_app-top-nav.scss","webpack://./src/scss/app/_app.scss","webpack://./src/scss/layout/_app-boxed-layout.scss","webpack://./src/scss/layout/_app-content-full-height.scss","webpack://./src/scss/layout/_app-content-full-width.scss","webpack://./src/scss/layout/_app-footer-fixed.scss","webpack://./src/scss/layout/_app-full-height.scss","webpack://./src/scss/layout/_app-sidebar-collapsed.scss","webpack://./src/scss/layout/_app-sidebar-mobile-toggled.scss","webpack://./src/scss/layout/_app-sidebar-toggled.scss","webpack://./src/scss/layout/_app-with-top-nav.scss","webpack://./src/scss/layout/_app-without-header.scss","webpack://./src/scss/layout/_app-without-sidebar.scss","webpack://./src/scss/ui/_breadcrumb.scss","webpack://./src/scss/ui/_btn-scroll-top.scss","webpack://./src/scss/ui/_card.scss","webpack://./src/scss/ui/_card-columns.scss","webpack://./src/scss/ui/_caret.scss","webpack://./src/scss/ui/_carousel.scss","webpack://./src/scss/ui/_dropdown.scss","webpack://./src/scss/ui/_form-check.scss","webpack://./src/scss/ui/_form-radio.scss","webpack://./src/scss/ui/_form-select.scss","webpack://./src/scss/ui/_form-switch.scss","webpack://./src/scss/ui/_hr.scss","webpack://./src/scss/ui/_link.scss","webpack://./src/scss/ui/_modal.scss","webpack://./src/scss/ui/_nav-tabs.scss","webpack://./src/scss/ui/_nav-wizards.scss","webpack://./src/scss/ui/_navbar-sticky.scss","webpack://./src/scss/ui/_page-header.scss","webpack://./src/scss/ui/_pagination.scss","webpack://./src/scss/ui/_pre.scss","webpack://./src/scss/ui/_row.scss","webpack://./src/scss/ui/_table.scss","webpack://./src/scss/ui/_toasts.scss","webpack://./src/scss/plugins/_apexcharts.scss","webpack://./src/scss/plugins/_bootstrap-daterangepicker.scss","webpack://./src/scss/plugins/_datatables.scss","webpack://./src/scss/mixins/_bootstrap-icons.scss","webpack://./src/scss/plugins/_fullcalendar.scss","webpack://./src/scss/plugins/_hljs.scss","webpack://./src/scss/plugins/_jsvectormap.scss","webpack://./src/scss/plugins/_perfect-scrollbar.scss","webpack://./src/scss/plugins/_react-datetime.scss","webpack://./src/scss/plugins/_react-datepicker.scss","webpack://./src/scss/plugins/_react-quill.scss","webpack://./src/scss/plugins/_react-select.scss","webpack://./src/scss/plugins/_react-sketch-picker.scss","webpack://./src/scss/plugins/_react-tag-input-component.scss","webpack://./src/scss/pages/_calendar.scss","webpack://./src/scss/pages/_coming-soon.scss","webpack://./src/scss/mixins/_clearfix.scss","webpack://./src/scss/pages/_data-management.scss","webpack://./src/scss/pages/_error.scss","webpack://./src/scss/pages/_file-manager.scss","webpack://./src/scss/pages/_gallery.scss","webpack://./src/scss/pages/_login.scss","webpack://./src/scss/pages/_mailbox.scss","webpack://./src/scss/pages/_messenger.scss","webpack://./src/scss/pages/_pos.scss","webpack://./src/scss/pages/_profile.scss","webpack://./src/scss/pages/_register.scss","webpack://./src/scss/pages/_search-result.scss","webpack://./src/scss/widget/_widget-chat.scss","webpack://./src/scss/widget/_widget-img-list.scss","webpack://./src/scss/widget/_widget-reminder.scss","webpack://./src/scss/widget/_widget-user-list.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;EAAA;ACAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;ACAA;;;;;;;;;;;;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mCAAA;EAAA,sCAAA;EAIA,uCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,sBAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,qCAAA;EAAA,oCAAA;EAIA,wCAAA;EAAA,mBAAA;EAAA,yBAAA;EAAA,qBAAA;EAAA,0CAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,iCAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oCAAA;EAAA,kBAAA;EAAA,sBAAA;EAIA,+BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,6BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,uBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAIA,+CAAA;EAAA,sDAAA;EAAA,iDAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,0CAAA;EAAA,+CAAA;EAAA,8CAAA;EAIA,8CAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,yCAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,+CAAA;EAIA,kDAAA;EAAA,wDAAA;EAAA,kDAAA;EAAA,6CAAA;EAAA,oDAAA;EAAA,+CAAA;EAAA,oDAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,iDAAA;EC2OI,6BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,oCAAA;EACA,4BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,gCAAA;EAEA,yCAAA;EACA,iCAAA;EACA,2CAAA;EACA,oCAAA;EAEA,uCAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8CAAA;EACA,uCAAA;EAMA,wBAAA;EACA,yCAAA;EACA,2CAAA;EAGA,sBAAA;EACA,wBAAA;EACA,qCAAA;EACA,iDAAA;EAEA,uBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,iEAAA;EACA,yEAAA;EACA,kEAAA;EACA,yEAAA;EAIA,8BAAA;EACA,6BAAA;EACA,8CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AJ+HF;AI9PA;AAAA;;EAiBI,uCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,yCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,uCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,yCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,uCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,oCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,qCAAA;AJ6OJ;AAAA;AI9PA;AAAA;;EAiBI,oCAAA;AJ6OJ;AAAA;;AM/OI;EFsHA,kBAAA;EAGA,0CAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,6CAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,yCAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,oCAAA;EACA,6BAAA;EAGE,kDAAA;EAAA,yDAAA;EAAA,oDAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAIA,0CAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,qCAAA;EAAA,4CAAA;EAAA,sCAAA;EAAA,4CAAA;EAAA,8CAAA;EAIA,+CAAA;EAAA,mDAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,gDAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,+CAAA;EAGF,wBAAA;EAEA,uCAAA;EACA,6CAAA;EACA,kCAAA;EACA,wCAAA;EAEA,uCAAA;EACA,+CAAA;EACA,uCAAA;EAEA,4CAAA;EACA,wDAAA;EAEA,6CAAA;EACA,oDAAA;EACA,6CAAA;EACA,oDAAA;AJ+HJ;;AOvSA;;;EAGE,sBAAA;AP0SF;;AO3RI;EANJ;IAOM,uBAAA;EP+RJ;AACF;;AOlRA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;APqRF;;AO5QA;EACE,cAAA;EACA,cNmS8C;EMlS9C,SAAA;EACA,wCAAA;EACA,aNmS8C;ADpBhD;;AOrQA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBN8P8C;EM7P9C,gBCwjB4B;EDvjB5B,8BAAA;APsQF;;AOnQA;EFuMQ,qCAAA;ALgER;AK5NI;EE3CJ;IF8MQ,oBAAA;EL6DN;AACF;;AOvQA;EFkMQ,+BAAA;ALyER;AKrOI;EEtCJ;IFyMQ,kBAAA;ELsEN;AACF;;AO3QA;EF6LQ,uCAAA;ALkFR;AK9OI;EEjCJ;IFoMQ,qBAAA;EL+EN;AACF;;AO/QA;EFwLQ,qCAAA;AL2FR;AKvPI;EE5BJ;IF+LQ,oBAAA;ELwFN;AACF;;AOnRA;EF+KM,qBALI;AL6GV;;AOlRA;EF0KM,mBALI;ALiHV;;AO3QA;EACE,aAAA;EACA,mBNiP8C;AD6BhD;;AOpQA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;APuQF;;AOjQA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;APoQF;;AO9PA;;EAEE,kBAAA;APiQF;;AO9PA;;;EAGE,aAAA;EACA,mBAAA;APiQF;;AO9PA;;;;EAIE,gBAAA;APiQF;;AO9PA;EACE,gBNmK8C;AD8FhD;;AO5PA;EACE,qBAAA;EACA,cAAA;AP+PF;;AOzPA;EACE,gBAAA;AP4PF;;AOpPA;;EAEE,mBCsa4B;AR/K9B;;AO/OA;EF6EM,kBALI;AL2KV;;AO5OA;EACE,iBNuJ8C;EMtJ9C,gCAAA;EACA,wCAAA;AP+OF;;AOtOA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;APyOF;;AOtOA;EAAM,eAAA;AP0ON;;AOzOA;EAAM,WAAA;AP6ON;;AOxOA;EACE,gEAAA;EACA,0BN6T8C;ADlFhD;AOzOE;EACE,mDAAA;AP2OJ;;AOhOE;EAEE,cAAA;EACA,qBAAA;APkOJ;;AO3NA;;;;EAIE,qCCgV4B;EHlUxB,cALI;ALsNV;;AOvNA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AL8NV;AOtNE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;APwNJ;;AOpNA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;APuNF;AOpNE;EACE,cAAA;APsNJ;;AOlNA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBNqjC6C;EMpjC7C,sCNqjC6C;EQ11C3C,kBAAA;AT2fJ;AOnNE;EACE,UAAA;EF7BE,cALI;ALwPV;;AO3MA;EACE,gBAAA;AP8MF;;AOxMA;;EAEE,sBAAA;AP2MF;;AOnMA;EACE,oBAAA;EACA,yBAAA;APsMF;;AOnMA;EACE,mBNgvB8C;EM/uB9C,sBN+uB8C;EM9uB9C,iCN3Ra;EM4Rb,gBAAA;APsMF;;AO/LA;EAEE,mBAAA;EACA,gCAAA;APiMF;;AO9LA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;APiMF;;AOzLA;EACE,qBAAA;AP4LF;;AOtLA;EAEE,gBAAA;APwLF;;AOhLA;EACE,UAAA;APmLF;;AO9KA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;APiLF;;AO7KA;;EAEE,oBAAA;APgLF;;AO3KA;EACE,eAAA;AP8KF;;AO3KA;EAGE,iBAAA;AP4KF;AOzKE;EACE,UAAA;AP2KJ;;AOpKA;EACE,wBAAA;APuKF;;AO/JA;;;;EAIE,0BAAA;APkKF;AO/JI;;;;EACE,eAAA;APoKN;;AO7JA;EACE,UAAA;EACA,kBAAA;APgKF;;AO3JA;EACE,gBAAA;AP8JF;;AOpJA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;APuJF;;AO/IA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBNxI8C;EIzExC,iCAAA;EEoNN,oBAAA;APiJF;AKjgBI;EEyWJ;IFtMQ,iBAAA;ELkWN;AACF;AOpJE;EACE,WAAA;APsJJ;;AO/IA;;;;;;;EAOE,UAAA;APkJF;;AO/IA;EACE,YAAA;APkJF;;AOzIA;EACE,6BAAA;EACA,oBAAA;AP4IF;;AOpIA;;;;;;;CAAA;AAWA;EACE,wBAAA;APoIF;;AO/HA;EACE,UAAA;APkIF;;AO3HA;EACE,aAAA;EACA,0BAAA;AP8HF;;AOzHA;EACE,qBAAA;AP4HF;;AOvHA;EACE,SAAA;AP0HF;;AOnHA;EACE,kBAAA;EACA,eAAA;APsHF;;AO9GA;EACE,wBAAA;APiHF;;AOzGA;EACE,wBAAA;AP4GF;;AUjrBA;ELmQM,qBALI;EK5PR,gBTgU8C;ADoXhD;;AU/qBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARwE9B;AKjlBI;EKpGF;ILuQM,eAAA;ELkbN;AACF;;AU1rBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARmF9B;AK5lBI;EKpGF;ILuQM,iBAAA;EL6bN;AACF;;AUrsBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AR8F9B;AKvmBI;EKpGF;ILuQM,eAAA;ELwcN;AACF;;AUhtBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARyG9B;AKlnBI;EKpGF;ILuQM,iBAAA;ELmdN;AACF;;AU3tBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ARoH9B;AK7nBI;EKpGF;ILuQM,eAAA;EL8dN;AACF;;AUtuBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AR+H9B;AKxoBI;EKpGF;ILuQM,iBAAA;ELyeN;AACF;;AUztBA;ECvDE,eAAA;EACA,gBAAA;AXoxBF;;AUztBA;EC5DE,eAAA;EACA,gBAAA;AXyxBF;;AU3tBA;EACE,qBAAA;AV8tBF;AU5tBE;EACE,oBTyS4C;ADqbhD;;AUptBA;EL8MM,kBALI;EKvMR,yBAAA;AVutBF;;AUntBA;EACE,mBTyO8C;EIlC1C,qBALI;ALqhBV;AUptBE;EACE,gBAAA;AVstBJ;;AUltBA;EACE,iBAAA;EACA,mBT+N8C;EIlC1C,kBALI;EKtLR,+BT7Ba;ADkvBf;AUntBE;EACE,aAAA;AVqtBJ;;AYrzBA;ECIE,eAAA;EAGA,YAAA;AbmzBF;;AYpzBA;EACE,gBX4xC8C;EW3xC9C,mCX4xC8C;EW3xC9C,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;Ab4zBF;;AY9yBA;EAEE,qBAAA;AZgzBF;;AY7yBA;EACE,qBAAA;EACA,cAAA;AZgzBF;;AY7yBA;EPyPM,kBALI;EOlPR,gCX8wC8C;AD9dhD;;Acl1BE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Af+1BF;;AgBzyBI;EF5CE;IACE,gBbiXe;EDwerB;AACF;AgB/yBI;EF5CE;IACE,gBbiXe;ED6erB;AACF;AgBpzBI;EF5CE;IACE,gBbiXe;EDkfrB;AACF;AgBzzBI;EF5CE;IACE,iBbiXe;EDufrB;AACF;AgB9zBI;EF5CE;IACE,iBbiXe;ED4frB;AACF;AiB93BA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;AjBq4BJ;;AiBh4BE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AlBy4BF;AiBv4BI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AlBm4BF;;AkBp1BM;EACE,SAAA;AlBu1BR;;AkBp1BM;EApCJ,cAAA;EACA,WAAA;AlB43BF;;AkB92BE;EACE,cAAA;EACA,WAAA;AlBi3BJ;;AkBn3BE;EACE,cAAA;EACA,UAAA;AlBs3BJ;;AkBx3BE;EACE,cAAA;EACA,mBAAA;AlB23BJ;;AkB73BE;EACE,cAAA;EACA,UAAA;AlBg4BJ;;AkBl4BE;EACE,cAAA;EACA,UAAA;AlBq4BJ;;AkBv4BE;EACE,cAAA;EACA,mBAAA;AlB04BJ;;AkB32BM;EAhDJ,cAAA;EACA,WAAA;AlB+5BF;;AkB12BU;EAhEN,cAAA;EACA,kBAAA;AlB86BJ;;AkB/2BU;EAhEN,cAAA;EACA,mBAAA;AlBm7BJ;;AkBp3BU;EAhEN,cAAA;EACA,UAAA;AlBw7BJ;;AkBz3BU;EAhEN,cAAA;EACA,mBAAA;AlB67BJ;;AkB93BU;EAhEN,cAAA;EACA,mBAAA;AlBk8BJ;;AkBn4BU;EAhEN,cAAA;EACA,UAAA;AlBu8BJ;;AkBx4BU;EAhEN,cAAA;EACA,mBAAA;AlB48BJ;;AkB74BU;EAhEN,cAAA;EACA,mBAAA;AlBi9BJ;;AkBl5BU;EAhEN,cAAA;EACA,UAAA;AlBs9BJ;;AkBv5BU;EAhEN,cAAA;EACA,mBAAA;AlB29BJ;;AkB55BU;EAhEN,cAAA;EACA,mBAAA;AlBg+BJ;;AkBj6BU;EAhEN,cAAA;EACA,WAAA;AlBq+BJ;;AkB95BY;EAxDV,wBAAA;AlB09BF;;AkBl6BY;EAxDV,yBAAA;AlB89BF;;AkBt6BY;EAxDV,gBAAA;AlBk+BF;;AkB16BY;EAxDV,yBAAA;AlBs+BF;;AkB96BY;EAxDV,yBAAA;AlB0+BF;;AkBl7BY;EAxDV,gBAAA;AlB8+BF;;AkBt7BY;EAxDV,yBAAA;AlBk/BF;;AkB17BY;EAxDV,yBAAA;AlBs/BF;;AkB97BY;EAxDV,gBAAA;AlB0/BF;;AkBl8BY;EAxDV,yBAAA;AlB8/BF;;AkBt8BY;EAxDV,yBAAA;AlBkgCF;;AkB/7BQ;;EAEE,gBAAA;AlBk8BV;;AkB/7BQ;;EAEE,gBAAA;AlBk8BV;;AkBz8BQ;;EAEE,sBAAA;AlB48BV;;AkBz8BQ;;EAEE,sBAAA;AlB48BV;;AkBn9BQ;;EAEE,qBAAA;AlBs9BV;;AkBn9BQ;;EAEE,qBAAA;AlBs9BV;;AkB79BQ;;EAEE,mBAAA;AlBg+BV;;AkB79BQ;;EAEE,mBAAA;AlBg+BV;;AkBv+BQ;;EAEE,qBAAA;AlB0+BV;;AkBv+BQ;;EAEE,qBAAA;AlB0+BV;;AkBj/BQ;;EAEE,mBAAA;AlBo/BV;;AkBj/BQ;;EAEE,mBAAA;AlBo/BV;;AgB9iCI;EEUE;IACE,SAAA;ElBwiCN;EkBriCI;IApCJ,cAAA;IACA,WAAA;ElB4kCA;EkB9jCA;IACE,cAAA;IACA,WAAA;ElBgkCF;EkBlkCA;IACE,cAAA;IACA,UAAA;ElBokCF;EkBtkCA;IACE,cAAA;IACA,mBAAA;ElBwkCF;EkB1kCA;IACE,cAAA;IACA,UAAA;ElB4kCF;EkB9kCA;IACE,cAAA;IACA,UAAA;ElBglCF;EkBllCA;IACE,cAAA;IACA,mBAAA;ElBolCF;EkBrjCI;IAhDJ,cAAA;IACA,WAAA;ElBwmCA;EkBnjCQ;IAhEN,cAAA;IACA,kBAAA;ElBsnCF;EkBvjCQ;IAhEN,cAAA;IACA,mBAAA;ElB0nCF;EkB3jCQ;IAhEN,cAAA;IACA,UAAA;ElB8nCF;EkB/jCQ;IAhEN,cAAA;IACA,mBAAA;ElBkoCF;EkBnkCQ;IAhEN,cAAA;IACA,mBAAA;ElBsoCF;EkBvkCQ;IAhEN,cAAA;IACA,UAAA;ElB0oCF;EkB3kCQ;IAhEN,cAAA;IACA,mBAAA;ElB8oCF;EkB/kCQ;IAhEN,cAAA;IACA,mBAAA;ElBkpCF;EkBnlCQ;IAhEN,cAAA;IACA,UAAA;ElBspCF;EkBvlCQ;IAhEN,cAAA;IACA,mBAAA;ElB0pCF;EkB3lCQ;IAhEN,cAAA;IACA,mBAAA;ElB8pCF;EkB/lCQ;IAhEN,cAAA;IACA,WAAA;ElBkqCF;EkB3lCU;IAxDV,cAAA;ElBspCA;EkB9lCU;IAxDV,wBAAA;ElBypCA;EkBjmCU;IAxDV,yBAAA;ElB4pCA;EkBpmCU;IAxDV,gBAAA;ElB+pCA;EkBvmCU;IAxDV,yBAAA;ElBkqCA;EkB1mCU;IAxDV,yBAAA;ElBqqCA;EkB7mCU;IAxDV,gBAAA;ElBwqCA;EkBhnCU;IAxDV,yBAAA;ElB2qCA;EkBnnCU;IAxDV,yBAAA;ElB8qCA;EkBtnCU;IAxDV,gBAAA;ElBirCA;EkBznCU;IAxDV,yBAAA;ElBorCA;EkB5nCU;IAxDV,yBAAA;ElBurCA;EkBpnCM;;IAEE,gBAAA;ElBsnCR;EkBnnCM;;IAEE,gBAAA;ElBqnCR;EkB5nCM;;IAEE,sBAAA;ElB8nCR;EkB3nCM;;IAEE,sBAAA;ElB6nCR;EkBpoCM;;IAEE,qBAAA;ElBsoCR;EkBnoCM;;IAEE,qBAAA;ElBqoCR;EkB5oCM;;IAEE,mBAAA;ElB8oCR;EkB3oCM;;IAEE,mBAAA;ElB6oCR;EkBppCM;;IAEE,qBAAA;ElBspCR;EkBnpCM;;IAEE,qBAAA;ElBqpCR;EkB5pCM;;IAEE,mBAAA;ElB8pCR;EkB3pCM;;IAEE,mBAAA;ElB6pCR;AACF;AgBxtCI;EEUE;IACE,SAAA;ElBitCN;EkB9sCI;IApCJ,cAAA;IACA,WAAA;ElBqvCA;EkBvuCA;IACE,cAAA;IACA,WAAA;ElByuCF;EkB3uCA;IACE,cAAA;IACA,UAAA;ElB6uCF;EkB/uCA;IACE,cAAA;IACA,mBAAA;ElBivCF;EkBnvCA;IACE,cAAA;IACA,UAAA;ElBqvCF;EkBvvCA;IACE,cAAA;IACA,UAAA;ElByvCF;EkB3vCA;IACE,cAAA;IACA,mBAAA;ElB6vCF;EkB9tCI;IAhDJ,cAAA;IACA,WAAA;ElBixCA;EkB5tCQ;IAhEN,cAAA;IACA,kBAAA;ElB+xCF;EkBhuCQ;IAhEN,cAAA;IACA,mBAAA;ElBmyCF;EkBpuCQ;IAhEN,cAAA;IACA,UAAA;ElBuyCF;EkBxuCQ;IAhEN,cAAA;IACA,mBAAA;ElB2yCF;EkB5uCQ;IAhEN,cAAA;IACA,mBAAA;ElB+yCF;EkBhvCQ;IAhEN,cAAA;IACA,UAAA;ElBmzCF;EkBpvCQ;IAhEN,cAAA;IACA,mBAAA;ElBuzCF;EkBxvCQ;IAhEN,cAAA;IACA,mBAAA;ElB2zCF;EkB5vCQ;IAhEN,cAAA;IACA,UAAA;ElB+zCF;EkBhwCQ;IAhEN,cAAA;IACA,mBAAA;ElBm0CF;EkBpwCQ;IAhEN,cAAA;IACA,mBAAA;ElBu0CF;EkBxwCQ;IAhEN,cAAA;IACA,WAAA;ElB20CF;EkBpwCU;IAxDV,cAAA;ElB+zCA;EkBvwCU;IAxDV,wBAAA;ElBk0CA;EkB1wCU;IAxDV,yBAAA;ElBq0CA;EkB7wCU;IAxDV,gBAAA;ElBw0CA;EkBhxCU;IAxDV,yBAAA;ElB20CA;EkBnxCU;IAxDV,yBAAA;ElB80CA;EkBtxCU;IAxDV,gBAAA;ElBi1CA;EkBzxCU;IAxDV,yBAAA;ElBo1CA;EkB5xCU;IAxDV,yBAAA;ElBu1CA;EkB/xCU;IAxDV,gBAAA;ElB01CA;EkBlyCU;IAxDV,yBAAA;ElB61CA;EkBryCU;IAxDV,yBAAA;ElBg2CA;EkB7xCM;;IAEE,gBAAA;ElB+xCR;EkB5xCM;;IAEE,gBAAA;ElB8xCR;EkBryCM;;IAEE,sBAAA;ElBuyCR;EkBpyCM;;IAEE,sBAAA;ElBsyCR;EkB7yCM;;IAEE,qBAAA;ElB+yCR;EkB5yCM;;IAEE,qBAAA;ElB8yCR;EkBrzCM;;IAEE,mBAAA;ElBuzCR;EkBpzCM;;IAEE,mBAAA;ElBszCR;EkB7zCM;;IAEE,qBAAA;ElB+zCR;EkB5zCM;;IAEE,qBAAA;ElB8zCR;EkBr0CM;;IAEE,mBAAA;ElBu0CR;EkBp0CM;;IAEE,mBAAA;ElBs0CR;AACF;AgBj4CI;EEUE;IACE,SAAA;ElB03CN;EkBv3CI;IApCJ,cAAA;IACA,WAAA;ElB85CA;EkBh5CA;IACE,cAAA;IACA,WAAA;ElBk5CF;EkBp5CA;IACE,cAAA;IACA,UAAA;ElBs5CF;EkBx5CA;IACE,cAAA;IACA,mBAAA;ElB05CF;EkB55CA;IACE,cAAA;IACA,UAAA;ElB85CF;EkBh6CA;IACE,cAAA;IACA,UAAA;ElBk6CF;EkBp6CA;IACE,cAAA;IACA,mBAAA;ElBs6CF;EkBv4CI;IAhDJ,cAAA;IACA,WAAA;ElB07CA;EkBr4CQ;IAhEN,cAAA;IACA,kBAAA;ElBw8CF;EkBz4CQ;IAhEN,cAAA;IACA,mBAAA;ElB48CF;EkB74CQ;IAhEN,cAAA;IACA,UAAA;ElBg9CF;EkBj5CQ;IAhEN,cAAA;IACA,mBAAA;ElBo9CF;EkBr5CQ;IAhEN,cAAA;IACA,mBAAA;ElBw9CF;EkBz5CQ;IAhEN,cAAA;IACA,UAAA;ElB49CF;EkB75CQ;IAhEN,cAAA;IACA,mBAAA;ElBg+CF;EkBj6CQ;IAhEN,cAAA;IACA,mBAAA;ElBo+CF;EkBr6CQ;IAhEN,cAAA;IACA,UAAA;ElBw+CF;EkBz6CQ;IAhEN,cAAA;IACA,mBAAA;ElB4+CF;EkB76CQ;IAhEN,cAAA;IACA,mBAAA;ElBg/CF;EkBj7CQ;IAhEN,cAAA;IACA,WAAA;ElBo/CF;EkB76CU;IAxDV,cAAA;ElBw+CA;EkBh7CU;IAxDV,wBAAA;ElB2+CA;EkBn7CU;IAxDV,yBAAA;ElB8+CA;EkBt7CU;IAxDV,gBAAA;ElBi/CA;EkBz7CU;IAxDV,yBAAA;ElBo/CA;EkB57CU;IAxDV,yBAAA;ElBu/CA;EkB/7CU;IAxDV,gBAAA;ElB0/CA;EkBl8CU;IAxDV,yBAAA;ElB6/CA;EkBr8CU;IAxDV,yBAAA;ElBggDA;EkBx8CU;IAxDV,gBAAA;ElBmgDA;EkB38CU;IAxDV,yBAAA;ElBsgDA;EkB98CU;IAxDV,yBAAA;ElBygDA;EkBt8CM;;IAEE,gBAAA;ElBw8CR;EkBr8CM;;IAEE,gBAAA;ElBu8CR;EkB98CM;;IAEE,sBAAA;ElBg9CR;EkB78CM;;IAEE,sBAAA;ElB+8CR;EkBt9CM;;IAEE,qBAAA;ElBw9CR;EkBr9CM;;IAEE,qBAAA;ElBu9CR;EkB99CM;;IAEE,mBAAA;ElBg+CR;EkB79CM;;IAEE,mBAAA;ElB+9CR;EkBt+CM;;IAEE,qBAAA;ElBw+CR;EkBr+CM;;IAEE,qBAAA;ElBu+CR;EkB9+CM;;IAEE,mBAAA;ElBg/CR;EkB7+CM;;IAEE,mBAAA;ElB++CR;AACF;AgB1iDI;EEUE;IACE,SAAA;ElBmiDN;EkBhiDI;IApCJ,cAAA;IACA,WAAA;ElBukDA;EkBzjDA;IACE,cAAA;IACA,WAAA;ElB2jDF;EkB7jDA;IACE,cAAA;IACA,UAAA;ElB+jDF;EkBjkDA;IACE,cAAA;IACA,mBAAA;ElBmkDF;EkBrkDA;IACE,cAAA;IACA,UAAA;ElBukDF;EkBzkDA;IACE,cAAA;IACA,UAAA;ElB2kDF;EkB7kDA;IACE,cAAA;IACA,mBAAA;ElB+kDF;EkBhjDI;IAhDJ,cAAA;IACA,WAAA;ElBmmDA;EkB9iDQ;IAhEN,cAAA;IACA,kBAAA;ElBinDF;EkBljDQ;IAhEN,cAAA;IACA,mBAAA;ElBqnDF;EkBtjDQ;IAhEN,cAAA;IACA,UAAA;ElBynDF;EkB1jDQ;IAhEN,cAAA;IACA,mBAAA;ElB6nDF;EkB9jDQ;IAhEN,cAAA;IACA,mBAAA;ElBioDF;EkBlkDQ;IAhEN,cAAA;IACA,UAAA;ElBqoDF;EkBtkDQ;IAhEN,cAAA;IACA,mBAAA;ElByoDF;EkB1kDQ;IAhEN,cAAA;IACA,mBAAA;ElB6oDF;EkB9kDQ;IAhEN,cAAA;IACA,UAAA;ElBipDF;EkBllDQ;IAhEN,cAAA;IACA,mBAAA;ElBqpDF;EkBtlDQ;IAhEN,cAAA;IACA,mBAAA;ElBypDF;EkB1lDQ;IAhEN,cAAA;IACA,WAAA;ElB6pDF;EkBtlDU;IAxDV,cAAA;ElBipDA;EkBzlDU;IAxDV,wBAAA;ElBopDA;EkB5lDU;IAxDV,yBAAA;ElBupDA;EkB/lDU;IAxDV,gBAAA;ElB0pDA;EkBlmDU;IAxDV,yBAAA;ElB6pDA;EkBrmDU;IAxDV,yBAAA;ElBgqDA;EkBxmDU;IAxDV,gBAAA;ElBmqDA;EkB3mDU;IAxDV,yBAAA;ElBsqDA;EkB9mDU;IAxDV,yBAAA;ElByqDA;EkBjnDU;IAxDV,gBAAA;ElB4qDA;EkBpnDU;IAxDV,yBAAA;ElB+qDA;EkBvnDU;IAxDV,yBAAA;ElBkrDA;EkB/mDM;;IAEE,gBAAA;ElBinDR;EkB9mDM;;IAEE,gBAAA;ElBgnDR;EkBvnDM;;IAEE,sBAAA;ElBynDR;EkBtnDM;;IAEE,sBAAA;ElBwnDR;EkB/nDM;;IAEE,qBAAA;ElBioDR;EkB9nDM;;IAEE,qBAAA;ElBgoDR;EkBvoDM;;IAEE,mBAAA;ElByoDR;EkBtoDM;;IAEE,mBAAA;ElBwoDR;EkB/oDM;;IAEE,qBAAA;ElBipDR;EkB9oDM;;IAEE,qBAAA;ElBgpDR;EkBvpDM;;IAEE,mBAAA;ElBypDR;EkBtpDM;;IAEE,mBAAA;ElBwpDR;AACF;AgBntDI;EEUE;IACE,SAAA;ElB4sDN;EkBzsDI;IApCJ,cAAA;IACA,WAAA;ElBgvDA;EkBluDA;IACE,cAAA;IACA,WAAA;ElBouDF;EkBtuDA;IACE,cAAA;IACA,UAAA;ElBwuDF;EkB1uDA;IACE,cAAA;IACA,mBAAA;ElB4uDF;EkB9uDA;IACE,cAAA;IACA,UAAA;ElBgvDF;EkBlvDA;IACE,cAAA;IACA,UAAA;ElBovDF;EkBtvDA;IACE,cAAA;IACA,mBAAA;ElBwvDF;EkBztDI;IAhDJ,cAAA;IACA,WAAA;ElB4wDA;EkBvtDQ;IAhEN,cAAA;IACA,kBAAA;ElB0xDF;EkB3tDQ;IAhEN,cAAA;IACA,mBAAA;ElB8xDF;EkB/tDQ;IAhEN,cAAA;IACA,UAAA;ElBkyDF;EkBnuDQ;IAhEN,cAAA;IACA,mBAAA;ElBsyDF;EkBvuDQ;IAhEN,cAAA;IACA,mBAAA;ElB0yDF;EkB3uDQ;IAhEN,cAAA;IACA,UAAA;ElB8yDF;EkB/uDQ;IAhEN,cAAA;IACA,mBAAA;ElBkzDF;EkBnvDQ;IAhEN,cAAA;IACA,mBAAA;ElBszDF;EkBvvDQ;IAhEN,cAAA;IACA,UAAA;ElB0zDF;EkB3vDQ;IAhEN,cAAA;IACA,mBAAA;ElB8zDF;EkB/vDQ;IAhEN,cAAA;IACA,mBAAA;ElBk0DF;EkBnwDQ;IAhEN,cAAA;IACA,WAAA;ElBs0DF;EkB/vDU;IAxDV,cAAA;ElB0zDA;EkBlwDU;IAxDV,wBAAA;ElB6zDA;EkBrwDU;IAxDV,yBAAA;ElBg0DA;EkBxwDU;IAxDV,gBAAA;ElBm0DA;EkB3wDU;IAxDV,yBAAA;ElBs0DA;EkB9wDU;IAxDV,yBAAA;ElBy0DA;EkBjxDU;IAxDV,gBAAA;ElB40DA;EkBpxDU;IAxDV,yBAAA;ElB+0DA;EkBvxDU;IAxDV,yBAAA;ElBk1DA;EkB1xDU;IAxDV,gBAAA;ElBq1DA;EkB7xDU;IAxDV,yBAAA;ElBw1DA;EkBhyDU;IAxDV,yBAAA;ElB21DA;EkBxxDM;;IAEE,gBAAA;ElB0xDR;EkBvxDM;;IAEE,gBAAA;ElByxDR;EkBhyDM;;IAEE,sBAAA;ElBkyDR;EkB/xDM;;IAEE,sBAAA;ElBiyDR;EkBxyDM;;IAEE,qBAAA;ElB0yDR;EkBvyDM;;IAEE,qBAAA;ElByyDR;EkBhzDM;;IAEE,mBAAA;ElBkzDR;EkB/yDM;;IAEE,mBAAA;ElBizDR;EkBxzDM;;IAEE,qBAAA;ElB0zDR;EkBvzDM;;IAEE,qBAAA;ElByzDR;EkBh0DM;;IAEE,mBAAA;ElBk0DR;EkB/zDM;;IAEE,mBAAA;ElBi0DR;AACF;AgB53DI;EEUE;IACE,SAAA;ElBq3DN;EkBl3DI;IApCJ,cAAA;IACA,WAAA;ElBy5DA;EkB34DA;IACE,cAAA;IACA,WAAA;ElB64DF;EkB/4DA;IACE,cAAA;IACA,UAAA;ElBi5DF;EkBn5DA;IACE,cAAA;IACA,mBAAA;ElBq5DF;EkBv5DA;IACE,cAAA;IACA,UAAA;ElBy5DF;EkB35DA;IACE,cAAA;IACA,UAAA;ElB65DF;EkB/5DA;IACE,cAAA;IACA,mBAAA;ElBi6DF;EkBl4DI;IAhDJ,cAAA;IACA,WAAA;ElBq7DA;EkBh4DQ;IAhEN,cAAA;IACA,kBAAA;ElBm8DF;EkBp4DQ;IAhEN,cAAA;IACA,mBAAA;ElBu8DF;EkBx4DQ;IAhEN,cAAA;IACA,UAAA;ElB28DF;EkB54DQ;IAhEN,cAAA;IACA,mBAAA;ElB+8DF;EkBh5DQ;IAhEN,cAAA;IACA,mBAAA;ElBm9DF;EkBp5DQ;IAhEN,cAAA;IACA,UAAA;ElBu9DF;EkBx5DQ;IAhEN,cAAA;IACA,mBAAA;ElB29DF;EkB55DQ;IAhEN,cAAA;IACA,mBAAA;ElB+9DF;EkBh6DQ;IAhEN,cAAA;IACA,UAAA;ElBm+DF;EkBp6DQ;IAhEN,cAAA;IACA,mBAAA;ElBu+DF;EkBx6DQ;IAhEN,cAAA;IACA,mBAAA;ElB2+DF;EkB56DQ;IAhEN,cAAA;IACA,WAAA;ElB++DF;EkBx6DU;IAxDV,cAAA;ElBm+DA;EkB36DU;IAxDV,wBAAA;ElBs+DA;EkB96DU;IAxDV,yBAAA;ElBy+DA;EkBj7DU;IAxDV,gBAAA;ElB4+DA;EkBp7DU;IAxDV,yBAAA;ElB++DA;EkBv7DU;IAxDV,yBAAA;ElBk/DA;EkB17DU;IAxDV,gBAAA;ElBq/DA;EkB77DU;IAxDV,yBAAA;ElBw/DA;EkBh8DU;IAxDV,yBAAA;ElB2/DA;EkBn8DU;IAxDV,gBAAA;ElB8/DA;EkBt8DU;IAxDV,yBAAA;ElBigEA;EkBz8DU;IAxDV,yBAAA;ElBogEA;EkBj8DM;;IAEE,gBAAA;ElBm8DR;EkBh8DM;;IAEE,gBAAA;ElBk8DR;EkBz8DM;;IAEE,sBAAA;ElB28DR;EkBx8DM;;IAEE,sBAAA;ElB08DR;EkBj9DM;;IAEE,qBAAA;ElBm9DR;EkBh9DM;;IAEE,qBAAA;ElBk9DR;EkBz9DM;;IAEE,mBAAA;ElB29DR;EkBx9DM;;IAEE,mBAAA;ElB09DR;EkBj+DM;;IAEE,qBAAA;ElBm+DR;EkBh+DM;;IAEE,qBAAA;ElBk+DR;EkBz+DM;;IAEE,mBAAA;ElB2+DR;EkBx+DM;;IAEE,mBAAA;ElB0+DR;AACF;AmBhmEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,uDAAA;EACA,6CAAA;EACA,sDAAA;EACA,4CAAA;EACA,uDAAA;EAEA,WAAA;EACA,mBlB0S8C;EkBzS9C,mBlB0jC8C;EkBzjC9C,0CAAA;AnB+lEF;AmBxlEE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2ClB4jC4C;EkB3jC5C,2GAAA;AnBylEJ;AmBtlEE;EACE,uBAAA;AnBwlEJ;AmBrlEE;EACE,sBAAA;AnBulEJ;;AmBnlEA;EACE,+DAAA;AnBslEF;;AmB/kEA;EACE,iBAAA;AnBklEF;;AmBxkEE;EACE,wBAAA;AnB2kEJ;;AmB5jEE;EACE,sCAAA;AnB+jEJ;AmB5jEI;EACE,sCAAA;AnB8jEN;;AmBvjEE;EACE,sBAAA;AnB0jEJ;AmBvjEE;EACE,mBAAA;AnByjEJ;;AmB/iEE;EACE,oDAAA;EACA,8CAAA;AnBkjEJ;;AmB5iEE;EACE,oDAAA;EACA,8CAAA;AnB+iEJ;;AmBviEA;EACE,oDAAA;EACA,8CAAA;AnB0iEF;;AmBliEE;EACE,mDAAA;EACA,6CAAA;AnBqiEJ;;AoBjrEE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB6qEJ;;AoB/rEE;EAOE,yBAAA;EACA,0CAAA;EACA,uDAAA;EACA,qDAAA;EACA,iCAAA;EACA,oDAAA;EACA,gCAAA;EACA,wDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB2rEJ;;AoB7sEE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBysEJ;;AoB3tEE;EAOE,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,gDAAA;EACA,iCAAA;EACA,+CAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApButEJ;;AoBzuEE;EAOE,yBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBquEJ;;AoBvvEE;EAOE,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,gDAAA;EACA,iCAAA;EACA,+CAAA;EACA,gCAAA;EACA,8CAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBmvEJ;;AoBrwEE;EAOE,yBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,mDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBiwEJ;;AoBnxEE;EAOE,yBAAA;EACA,qCAAA;EACA,kDAAA;EACA,gDAAA;EACA,iCAAA;EACA,+CAAA;EACA,gCAAA;EACA,oDAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB+wEJ;;AmB9nEI;EACE,gBAAA;EACA,iCAAA;AnBioEN;;AgB5tEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBuoEJ;AACF;AgBnuEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB6oEJ;AACF;AgBzuEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBmpEJ;AACF;AgB/uEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBypEJ;AACF;AgBrvEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB+pEJ;AACF;AgB3vEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBqqEJ;AACF;AqBz0EA;EACE,qBpBorB8C;ADupDhD;;AqBl0EA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBpBqU8C;AD8/DhD;;AqB/zEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,eALI;ALokEV;;AqB/zEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,oBALI;AL0kEV;;AsBh2EA;EACE,mBrB+qB8C;EIrZ1C,kBALI;EiBjRR,iCrB4Da;ADqyEf;;AuBt2EA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,mBALI;EkBhRR,gBtB4U8C;EsB3U9C,gBtB+U8C;EsB9U9C,2BtBksB8C;EsBjsB9C,gBAAA;EACA,6BtB4rB8C;EsB3rB9C,4BAAA;EACA,2DAAA;EdGE,kBAAA;EeHE,wEDMJ;AvBo2EF;AwBt2EM;EDhBN;ICiBQ,gBAAA;ExBy2EN;AACF;AuBv2EE;EACE,gBAAA;AvBy2EJ;AuBv2EI;EACE,eAAA;AvBy2EN;AuBp2EE;EACE,2BtB4qB4C;EsB3qB5C,6BtBuqB4C;EsBtqB5C,8CtBkrB4C;EsBjrB5C,UAAA;EAKE,2DtBqkB0C;AD6xDhD;AuB91EE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvBk1EJ;AuB70EE;EACE,cAAA;EACA,UAAA;AvB+0EJ;AuB30EE;EACE,0CtB+oB4C;EsB7oB5C,UAAA;AvB40EJ;AuBp0EE;EAEE,oDtBqnB4C;EsBlnB5C,UAAA;AvBm0EJ;AuB/zEE;EACE,yBAAA;EACA,0BAAA;EACA,0BtBsgB4C;EsBrgB5C,2BtB4mB4C;EwB1sB9C,uCxBu2B8C;EsBvwB5C,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CtB8gB4C;EsB7gB5C,gBAAA;ECzFE,qID0FF;AvBi0EJ;AwBv5EM;ED0EJ;ICzEM,gBAAA;ExB05EN;AACF;AuBn0EE;EACE,wCtB8vB4C;ADukDhD;;AuB5zEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBtB8N8C;EsB7N9C,2BtB8lB8C;EsB7lB9C,6BAAA;EACA,yBAAA;EACA,sCAAA;AvB+zEF;AuB7zEE;EACE,UAAA;AvB+zEJ;AuB5zEE;EAEE,gBAAA;EACA,eAAA;AvB6zEJ;;AuBlzEA;EACE,mEtB4kB8C;EsB3kB9C,uBAAA;ElByII,oBALI;EIvQN,kBAAA;AT07EJ;AuBnzEE;EACE,uBAAA;EACA,wBAAA;EACA,yBtBod4C;ADi2DhD;;AuBjzEA;EACE,iEtBgkB8C;EsB/jB9C,oBAAA;ElB4HI,eALI;EIvQN,kBAAA;ATs8EJ;AuBlzEE;EACE,oBAAA;EACA,qBAAA;EACA,uBtB0c4C;AD02DhD;;AuB5yEE;EACE,oEtB6iB4C;ADkwDhD;AuB5yEE;EACE,mEtB0iB4C;ADowDhD;AuB3yEE;EACE,iEtBuiB4C;ADswDhD;;AuBxyEA;EACE,WtBmiB8C;EsBliB9C,gEtB8hB8C;EsB7hB9C,iBtBma8C;ADw4DhD;AuBzyEE;EACE,eAAA;AvB2yEJ;AuBxyEE;EACE,oBAAA;EdvLA,kBAAA;ATk+EJ;AuBvyEE;EACE,oBAAA;Ed5LA,kBAAA;ATs+EJ;AuBtyEE;EAAoB,+DtB8gB0B;AD2xDhD;AuBxyEE;EAAoB,6DtB8gB0B;AD6xDhD;;A0B1/EA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,mBALI;EqB7QR,gBzByU8C;EyBxU9C,gBzB4U8C;EyB3U9C,2BzB+rB8C;EyB9rB9C,gBAAA;EACA,6BzByrB8C;EyBxrB9C,mFAAA;EACA,4BAAA;EACA,yCzBoyB8C;EyBnyB9C,0BzBoyB8C;EyBnyB9C,2DAAA;EjBHE,kBAAA;EeHE,wEESJ;A1B0/EF;AwB//EM;EEfN;IFgBQ,gBAAA;ExBkgFN;AACF;A0B7/EE;EACE,8CzB0rB4C;EyBzrB5C,UAAA;EAKE,2DzBmyB0C;ADwtDhD;A0Bv/EE;EAEE,sBzB+jB4C;EyB9jB5C,sBAAA;A1Bw/EJ;A0Br/EE;EAEE,oDzB8pB4C;ADw1DhD;A0Bj/EE;EACE,kBAAA;EACA,uCAAA;A1Bm/EJ;;A0B/+EA;EACE,oBzBsjB8C;EyBrjB9C,uBzBqjB8C;EyBpjB9C,oBzBqjB8C;EIlV1C,oBALI;EIvQN,kBAAA;AT6hFJ;;A0B/+EA;EACE,mBzBijB8C;EyBhjB9C,sBzBgjB8C;EyB/iB9C,kBzBgjB8C;EIrV1C,eALI;EIvQN,kBAAA;ATqiFJ;;A0B7+EI;EACE,gEAAA;A1Bg/EN;;A2BxjFA;EACE,cAAA;EACA,iB1B4uB8C;E0B3uB9C,mB1B4uB8C;E0B3uB9C,uB1B4uB8C;AD+0DhD;A2BzjFE;EACE,WAAA;EACA,mBAAA;A3B2jFJ;;A2BvjFA;EACE,oB1BkuB8C;E0BjuB9C,eAAA;EACA,iBAAA;A3B0jFF;A2BxjFE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A3B0jFJ;;A2BtjFA;EACE,+BAAA;EAEA,cAAA;EACA,Y1BitB8C;E0BhtB9C,a1BgtB8C;E0B/sB9C,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2D1BgtB8C;E0B/sB9C,iCAAA;UAAA,yBAAA;A3BwjFF;A2BrjFE;ElB3BE,qBAAA;ATmlFJ;A2BpjFE;EAEE,kB1BwsB4C;AD62DhD;A2BljFE;EACE,uB1BgsB4C;ADo3DhD;A2BjjFE;EACE,8C1B0pB4C;E0BzpB5C,UAAA;EACA,2D1BijB4C;ADkgEhD;A2BhjFE;EACE,yB1BgBW;E0BfX,qB1BeW;ADmiFf;A2BhjFI;EAII,iEAAA;A3B+iFR;A2B3iFI;EAII,iEAAA;A3B0iFR;A2BriFE;EACE,yB1BLW;E0BMX,qB1BNW;E0BWT,iEAAA;A3BmiFN;A2B/hFE;EACE,oBAAA;EACA,YAAA;EACA,Y1BoqB4C;AD63DhD;A2B1hFI;EACE,eAAA;EACA,Y1B2pB0C;ADi4DhD;;A2B9gFA;EACE,mB1BupB8C;AD03DhD;A2B/gFE;EACE,4DAAA;EAEA,Y1BipB4C;E0BhpB5C,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,oBAAA;EeHE,iDGsHF;A3BghFJ;AwBloFM;EG0GJ;IHzGM,gBAAA;ExBqoFN;AACF;A2BnhFI;EACE,4DAAA;A3BqhFN;A2BlhFI;EACE,iC1B8oB0C;E0BzoBxC,4DAAA;A3BghFR;A2B3gFE;EACE,oB1B2nB4C;E0B1nB5C,eAAA;A3B6gFJ;A2B3gFI;EACE,oBAAA;EACA,cAAA;A3B6gFN;;A2BxgFA;EACE,qBAAA;EACA,kB1BumB8C;ADo6DhD;;A2BxgFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3B2gFF;A2BvgFI;EACE,oBAAA;EACA,YAAA;EACA,a1B4d0C;AD6iEhD;;A2BlgFI;EACE,4DAAA;A3BqgFN;;A4BxrFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5B2rFF;A4BzrFE;EACE,UAAA;A5B2rFJ;A4BvrFI;EAA0B,kF3B80BkB;AD42DhD;A4BzrFI;EAA0B,kF3B60BkB;AD+2DhD;A4BzrFE;EACE,SAAA;A5B2rFJ;A4BxrFE;EACE,W3B+zB4C;E2B9zB5C,Y3B8zB4C;E2B7zB5C,oBAAA;EACA,gBAAA;EH1BF,iCxBw1B8C;E2B5zB5C,S3B6zB4C;EQ10B5C,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A5ByrFJ;AwBxsFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ExB2sFN;AACF;A4B5rFI;EHjCF,iDxB81B8C;ADk4DhD;A4B1rFE;EACE,W3ByyB4C;E2BxyB5C,c3ByyB4C;E2BxyB5C,kBAAA;EACA,e3BwyB4C;E2BvyB5C,kD3BwyB4C;E2BvyB5C,yBAAA;EnB7BA,mBAAA;AT0tFJ;A4BxrFE;EACE,W3BoyB4C;E2BnyB5C,Y3BmyB4C;E2BlyB5C,gBAAA;EHpDF,iCxBw1B8C;E2BlyB5C,S3BmyB4C;EQ10B5C,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A5ByrFJ;AwBluFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ExBquFN;AACF;A4B5rFI;EH3DF,iDxB81B8C;AD45DhD;A4B1rFE;EACE,W3B+wB4C;E2B9wB5C,c3B+wB4C;E2B9wB5C,kBAAA;EACA,e3B8wB4C;E2B7wB5C,kD3B8wB4C;E2B7wB5C,yBAAA;EnBvDA,mBAAA;ATovFJ;A4BxrFE;EACE,oBAAA;A5B0rFJ;A4BxrFI;EACE,2C3BgxB0C;AD06DhD;A4BvrFI;EACE,2C3B4wB0C;AD66DhD;;A6BhxFA;EACE,kBAAA;A7BmxFF;A6BjxFE;;;EAGE,uD5B42B4C;E4B32B5C,2D5B22B4C;E4B12B5C,iB5B22B4C;ADw6DhD;A6BhxFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A7BkxFJ;AwBvxFM;EKTJ;ILUM,gBAAA;ExB0xFN;AACF;A6BpxFE;;EAEE,qBAAA;A7BsxFJ;A6BpxFI;;EACE,kBAAA;A7BuxFN;A6BpxFI;;;EAEE,qB5Bg1B0C;E4B/0B1C,wB5Bg1B0C;ADu8DhD;A6BpxFI;;EACE,qB5B20B0C;E4B10B1C,wB5B20B0C;AD48DhD;A6BnxFE;EACE,qB5Bq0B4C;E4Bp0B5C,wB5Bq0B4C;ADg9DhD;A6B9wFI;;;;EACE,2CAAA;EACA,8D5B+zB0C;ADo9DhD;A6BjxFM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,e5BuzBwC;E4BtzBxC,WAAA;EACA,6B5BuoBwC;EQvrB5C,kBAAA;ATu0FJ;A6BhxFI;EACE,2CAAA;EACA,8D5B8yB0C;ADo+DhD;A6B7wFI;EACE,sCAAA;A7B+wFN;A6B3wFE;;EAEE,+B5BjBW;AD8xFf;A6B3wFI;;EACE,oD5BinB0C;AD6pEhD;;A8Br2FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9Bw2FF;A8Bt2FE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9Bw2FJ;A8Bp2FE;;;EAGE,UAAA;A9Bs2FJ;A8Bh2FE;EACE,kBAAA;EACA,UAAA;A9Bk2FJ;A8Bh2FI;EACE,UAAA;A9Bk2FN;;A8Bv1FA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,mBALI;EyBvOR,gB7BmS8C;E6BlS9C,gB7BsS8C;E6BrS9C,2B7BypB8C;E6BxpB9C,kBAAA;EACA,mBAAA;EACA,uC7B6uB8C;E6B5uB9C,2DAAA;ErBtCE,kBAAA;ATi4FJ;;A8Bj1FA;;;;EAIE,oBAAA;EzBwNI,eALI;EIvQN,kBAAA;AT04FJ;;A8Bj1FA;;;;EAIE,uBAAA;EzB+MI,oBALI;EIvQN,kBAAA;ATm5FJ;;A8Bj1FA;;EAEE,mBAAA;A9Bo1FF;;A8Bv0FI;;;;ErBjEA,0BAAA;EACA,6BAAA;AT+4FJ;A8Bt0FI;;;;ErB1EA,0BAAA;EACA,6BAAA;ATs5FJ;A8Bh0FE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AT64FJ;A8Bh0FE;;ErB9EE,yBAAA;EACA,4BAAA;ATk5FJ;;A+B16FE;EACE,aAAA;EACA,WAAA;EACA,mB9BupB4C;EIrZ1C,kBALI;E0B1PN,6B9B22BqB;ADikEzB;;A+Bz6FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,W9B81BqB;E8B71BrB,mC9B61BqB;EQx3BrB,sCAAA;ATu8FJ;;A+Bv6FI;;;;EAEE,cAAA;A/B46FN;;A+B39FI;EAqDE,+B9Bg1BmB;E8B70BjB,oC9B+pBwC;E8B9pBxC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/Bw6FR;A+Br6FM;EACE,+B9Bq0BiB;E8Bh0Bf,2D9Bg0Be;ADmmEzB;;A+Bx+FI;EA+EI,oC9BwoBwC;E8BvoBxC,kFAAA;A/B65FR;;A+B7+FI;EAuFE,+B9B8yBmB;AD4mEzB;A+Bv5FQ;EAEE,iEAAA;EACA,uB9BytBsC;E8BxtBtC,+DAAA;EACA,2EAAA;A/Bw5FV;A+Bp5FM;EACE,+B9BiyBiB;E8B5xBf,2D9B4xBe;ADsnEzB;;A+B3/FI;EAkHI,yCAAA;A/B64FR;;A+B//FI;EAyHE,+B9B4wBmB;AD8nEzB;A+Bx4FM;EACE,wC9BywBiB;ADioEzB;A+Bv4FM;EACE,2D9BqwBiB;ADooEzB;A+Bt4FM;EACE,6B9BiwBiB;ADuoEzB;;A+Bn4FI;EACE,kBAAA;A/Bs4FN;;A+BhhGI;;;;;EAoJM,UAAA;A/Bo4FV;;A+BpgGE;EACE,aAAA;EACA,WAAA;EACA,mB9BupB4C;EIrZ1C,kBALI;E0B1PN,4B9B22BqB;AD2pEzB;;A+BngGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,W9B81BqB;E8B71BrB,kC9B61BqB;EQx3BrB,sCAAA;ATiiGJ;;A+BjgGI;;;;EAEE,cAAA;A/BsgGN;;A+BrjGI;EAqDE,8B9Bg1BmB;E8B70BjB,oC9B+pBwC;E8B9pBxC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/BkgGR;A+B//FM;EACE,8B9Bq0BiB;E8Bh0Bf,0D9Bg0Be;AD6rEzB;;A+BlkGI;EA+EI,oC9BwoBwC;E8BvoBxC,kFAAA;A/Bu/FR;;A+BvkGI;EAuFE,8B9B8yBmB;ADssEzB;A+Bj/FQ;EAEE,kEAAA;EACA,uB9BytBsC;E8BxtBtC,+DAAA;EACA,2EAAA;A/Bk/FV;A+B9+FM;EACE,8B9BiyBiB;E8B5xBf,0D9B4xBe;ADgtEzB;;A+BrlGI;EAkHI,yCAAA;A/Bu+FR;;A+BzlGI;EAyHE,8B9B4wBmB;ADwtEzB;A+Bl+FM;EACE,uC9BywBiB;AD2tEzB;A+Bj+FM;EACE,0D9BqwBiB;AD8tEzB;A+Bh+FM;EACE,4B9BiwBiB;ADiuEzB;;A+B79FI;EACE,kBAAA;A/Bg+FN;;A+B1mGI;;;;;EAsJM,UAAA;A/B49FV;;AgCpnGA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,4BALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,2BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;AhCknGF;AwBtoGM;EQhBN;IRiBQ,gBAAA;ExByoGN;AACF;AgCrnGE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AhCsnGJ;AgCnnGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhConGJ;AgCjnGE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AhC+mGN;AgC3mGE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AhCymGN;AgCrmGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AhCimGJ;AgC9lGI;EAKI,0CAAA;AhC4lGR;AgCvlGE;EAKI,0CAAA;AhCqlGN;AgCjlGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AhCglGJ;;AgCpkGE;EC/GA,uBAAA;EACA,uCAAA;EACA,iDAAA;EACA,6BAAA;EACA,mDAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gCAAA;EACA,gDAAA;EACA,0DAAA;AjCurGF;;AgCrlGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,4CAAA;EACA,mDAAA;EACA,uCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCwsGF;;AgCtmGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCytGF;;AgCvnGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0CAAA;EACA,gDAAA;EACA,uCAAA;EACA,8BAAA;EACA,uCAAA;EACA,qDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC0uGF;;AgCxoGE;EC/GA,uBAAA;EACA,uCAAA;EACA,iDAAA;EACA,6BAAA;EACA,mDAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gCAAA;EACA,gDAAA;EACA,0DAAA;AjC2vGF;;AgCzpGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EACA,kDAAA;EACA,uCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC4wGF;;AgC1qGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,6CAAA;EACA,sCAAA;EACA,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC6xGF;;AgC3rGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,4CAAA;EACA,mDAAA;EACA,uCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC8yGF;;AgC5sGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC+zGF;;AgC7tGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EACA,+CAAA;EACA,uCAAA;EACA,8BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCg1GF;;AgC9uGE;EC/GA,uBAAA;EACA,mCAAA;EACA,6CAAA;EACA,6BAAA;EACA,gDAAA;EACA,sDAAA;EACA,sCAAA;EACA,8BAAA;EACA,8CAAA;EACA,uDAAA;EACA,4DAAA;EACA,gCAAA;EACA,4CAAA;EACA,sDAAA;AjCi2GF;;AgC/vGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,qCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCk3GF;;AgChxGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCm4GF;;AgCjyGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6CAAA;EACA,gDAAA;EACA,uCAAA;EACA,8BAAA;EACA,uCAAA;EACA,uDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCo5GF;;AgClzGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCq6GF;;AgCn0GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,6CAAA;EACA,sCAAA;EACA,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCs7GF;;AgCp1GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,8BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCu8GF;;AgCr2GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EACA,iDAAA;EACA,sCAAA;EACA,8BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCw9GF;;AgCt3GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EACA,oDAAA;EACA,uCAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCy+GF;;AgCv4GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,4CAAA;EACA,mDAAA;EACA,uCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC0/GF;;AgCx5GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EACA,mDAAA;EACA,wCAAA;EACA,8BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC2gHF;;AgCz6GE;EC/GA,uBAAA;EACA,qCAAA;EACA,+CAAA;EACA,6BAAA;EACA,8CAAA;EACA,wDAAA;EACA,wCAAA;EACA,8BAAA;EACA,+CAAA;EACA,yDAAA;EACA,4DAAA;EACA,gCAAA;EACA,8CAAA;EACA,wDAAA;AjC4hHF;;AgC17GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6CAAA;EACA,mDAAA;EACA,qCAAA;EACA,8BAAA;EACA,uCAAA;EACA,oDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC6iHF;;AgC38GE;EC/GA,uBAAA;EACA,qCAAA;EACA,+CAAA;EACA,6BAAA;EACA,8CAAA;EACA,wDAAA;EACA,wCAAA;EACA,8BAAA;EACA,+CAAA;EACA,yDAAA;EACA,4DAAA;EACA,gCAAA;EACA,8CAAA;EACA,wDAAA;AjC8jHF;;AgC59GE;EC/GA,uBAAA;EACA,uCAAA;EACA,iDAAA;EACA,6BAAA;EACA,mDAAA;EACA,0DAAA;EACA,wCAAA;EACA,8BAAA;EACA,+CAAA;EACA,2DAAA;EACA,4DAAA;EACA,gCAAA;EACA,gDAAA;EACA,0DAAA;AjC+kHF;;AgC7+GE;EC/GA,uBAAA;EACA,qCAAA;EACA,+CAAA;EACA,6BAAA;EACA,gDAAA;EACA,wDAAA;EACA,wCAAA;EACA,8BAAA;EACA,+CAAA;EACA,yDAAA;EACA,4DAAA;EACA,gCAAA;EACA,8CAAA;EACA,wDAAA;AjCgmHF;;AgC9/GE;EC/GA,uBAAA;EACA,uCAAA;EACA,iDAAA;EACA,6BAAA;EACA,mDAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gCAAA;EACA,gDAAA;EACA,0DAAA;AjCinHF;;AgC/gHE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2CAAA;EACA,mDAAA;EACA,wCAAA;EACA,8BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCkoHF;;AgChiHE;EC/GA,uBAAA;EACA,qCAAA;EACA,+CAAA;EACA,6BAAA;EACA,+CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,gCAAA;EACA,8CAAA;EACA,wDAAA;AjCmpHF;;AgCjjHE;EC/GA,uBAAA;EACA,kCAAA;EACA,4CAAA;EACA,6BAAA;EACA,4CAAA;EACA,qDAAA;EACA,uCAAA;EACA,8BAAA;EACA,4CAAA;EACA,uDAAA;EACA,4DAAA;EACA,gCAAA;EACA,2CAAA;EACA,qDAAA;AjCoqHF;;AgClkHE;EC/GA,uBAAA;EACA,mCAAA;EACA,6CAAA;EACA,6BAAA;EACA,+CAAA;EACA,qDAAA;EACA,sCAAA;EACA,8BAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,gCAAA;EACA,4CAAA;EACA,sDAAA;AjCqrHF;;AgCnlHE;EC/GA,uBAAA;EACA,kCAAA;EACA,4CAAA;EACA,6BAAA;EACA,2CAAA;EACA,qDAAA;EACA,qCAAA;EACA,8BAAA;EACA,4CAAA;EACA,mDAAA;EACA,4DAAA;EACA,gCAAA;EACA,2CAAA;EACA,qDAAA;AjCssHF;;AgC1kHE;EChHA,0CAAA;EACA,iDAAA;EACA,6BAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjC8rHF;;AgC3lHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC+sHF;;AgC5mHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCguHF;;AgC7nHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCivHF;;AgC9oHE;EChHA,0CAAA;EACA,iDAAA;EACA,6BAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjCkwHF;;AgC/pHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCmxHF;;AgChrHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCoyHF;;AgCjsHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCqzHF;;AgCltHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCs0HF;;AgCnuHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCu1HF;;AgCpvHE;EChHA,sCAAA;EACA,6CAAA;EACA,6BAAA;EACA,yCAAA;EACA,mDAAA;EACA,qCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,+CAAA;EACA,iCAAA;EACA,sDAAA;EACA,mBAAA;AjCw2HF;;AgCrwHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCy3HF;;AgCtxHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC04HF;;AgCvyHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC25HF;;AgCxzHE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC46HF;;AgCz0HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC67HF;;AgC11HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC88HF;;AgC32HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC+9HF;;AgC53HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCg/HF;;AgC74HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCigIF;;AgC95HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCkhIF;;AgC/6HE;EChHA,wCAAA;EACA,+CAAA;EACA,6BAAA;EACA,2CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,iDAAA;EACA,iCAAA;EACA,wDAAA;EACA,mBAAA;AjCmiIF;;AgCh8HE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCojIF;;AgCj9HE;EChHA,wCAAA;EACA,+CAAA;EACA,6BAAA;EACA,2CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,iDAAA;EACA,iCAAA;EACA,wDAAA;EACA,mBAAA;AjCqkIF;;AgCl+HE;EChHA,0CAAA;EACA,iDAAA;EACA,6BAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjCslIF;;AgCn/HE;EChHA,wCAAA;EACA,+CAAA;EACA,6BAAA;EACA,2CAAA;EACA,qDAAA;EACA,wCAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,iDAAA;EACA,iCAAA;EACA,wDAAA;EACA,mBAAA;AjCumIF;;AgCpgIE;EChHA,0CAAA;EACA,iDAAA;EACA,6BAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjCwnIF;;AgCrhIE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCyoIF;;AgCtiIE;EChHA,wCAAA;EACA,+CAAA;EACA,6BAAA;EACA,2CAAA;EACA,qDAAA;EACA,uCAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,iDAAA;EACA,iCAAA;EACA,wDAAA;EACA,mBAAA;AjC0pIF;;AgCvjIE;EChHA,qCAAA;EACA,4CAAA;EACA,6BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,8CAAA;EACA,iCAAA;EACA,qDAAA;EACA,mBAAA;AjC2qIF;;AgCxkIE;EChHA,sCAAA;EACA,6CAAA;EACA,6BAAA;EACA,yCAAA;EACA,mDAAA;EACA,qCAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,+CAAA;EACA,iCAAA;EACA,sDAAA;EACA,mBAAA;AjC4rIF;;AgCzlIE;EChHA,qCAAA;EACA,4CAAA;EACA,6BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,8CAAA;EACA,iCAAA;EACA,qDAAA;EACA,mBAAA;AjC6sIF;;AgC9lIA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,iDAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0B/B2X8C;ADquHhD;AgCtlIE;EACE,0BAAA;AhCwlIJ;AgCrlIE;EACE,gCAAA;AhCulIJ;;AgC5kIA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,wBALI;E4BvNR,2BAAA;AjCiuIF;;AgC/kIA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,6BALI;E4BvNR,2BAAA;AjCwuIF;;AkC3yIA;EVgBM,gCUfJ;AlC8yIF;AwB3xIM;EUpBN;IVqBQ,gBAAA;ExB8xIN;AACF;AkCjzIE;EACE,UAAA;AlCmzIJ;;AkC7yIE;EACE,aAAA;AlCgzIJ;;AkC5yIA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AlC+yIF;AwB7yIM;EULN;IVMQ,gBAAA;ExBgzIN;AACF;AkClzIE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AlCozIJ;AwBvzIM;EUAJ;IVCM,gBAAA;ExB0zIN;AACF;;AmC/0IA;;;;;;EAME,kBAAA;AnCk1IF;;AmC/0IA;EACE,mBAAA;AnCk1IF;AoC1zII;EACE,qBAAA;EACA,oBnCia0C;EmCha1C,uBnC+Z0C;EmC9Z1C,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApCk2IF;AoCxyII;EACE,cAAA;ApC0yIN;;AmCx1IA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,iCALI;E8BhQR,yCAAA;EACA,mDAAA;EACA,8DAAA;EACA,8BAAA;EACA,kDAAA;EACA,mEAAA;EACA,4DAAA;EACA,sCAAA;EACA,0EAAA;EACA,8CAAA;EACA,oDAAA;EACA,iEAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EACA,sCAAA;EACA,+DAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;ATk4IJ;AmCr1IE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AnCu1IJ;;AmC/zII;EACE,oBAAA;AnCk0IN;AmCh0IM;EACE,WAAA;EACA,OAAA;AnCk0IR;;AmC9zII;EACE,kBAAA;AnCi0IN;AmC/zIM;EACE,QAAA;EACA,UAAA;AnCi0IR;;AgB32II;EmB4BA;IACE,oBAAA;EnCm1IJ;EmCj1II;IACE,WAAA;IACA,OAAA;EnCm1IN;EmC/0IE;IACE,kBAAA;EnCi1IJ;EmC/0II;IACE,QAAA;IACA,UAAA;EnCi1IN;AACF;AgB53II;EmB4BA;IACE,oBAAA;EnCm2IJ;EmCj2II;IACE,WAAA;IACA,OAAA;EnCm2IN;EmC/1IE;IACE,kBAAA;EnCi2IJ;EmC/1II;IACE,QAAA;IACA,UAAA;EnCi2IN;AACF;AgB54II;EmB4BA;IACE,oBAAA;EnCm3IJ;EmCj3II;IACE,WAAA;IACA,OAAA;EnCm3IN;EmC/2IE;IACE,kBAAA;EnCi3IJ;EmC/2II;IACE,QAAA;IACA,UAAA;EnCi3IN;AACF;AgB55II;EmB4BA;IACE,oBAAA;EnCm4IJ;EmCj4II;IACE,WAAA;IACA,OAAA;EnCm4IN;EmC/3IE;IACE,kBAAA;EnCi4IJ;EmC/3II;IACE,QAAA;IACA,UAAA;EnCi4IN;AACF;AgB56II;EmB4BA;IACE,oBAAA;EnCm5IJ;EmCj5II;IACE,WAAA;IACA,OAAA;EnCm5IN;EmC/4IE;IACE,kBAAA;EnCi5IJ;EmC/4II;IACE,QAAA;IACA,UAAA;EnCi5IN;AACF;AgB57II;EmB4BA;IACE,oBAAA;EnCm6IJ;EmCj6II;IACE,WAAA;IACA,OAAA;EnCm6IN;EmC/5IE;IACE,kBAAA;EnCi6IJ;EmC/5II;IACE,QAAA;IACA,UAAA;EnCi6IN;AACF;AmCx5IE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AnC05IJ;AoC9+II;EACE,qBAAA;EACA,oBnCia0C;EmCha1C,uBnC+Z0C;EmC9Z1C,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApC+gJF;AoC59II;EACE,cAAA;ApC89IN;;AmC95IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AnCi6IJ;AoCngJI;EACE,qBAAA;EACA,oBnCia0C;EmCha1C,uBnC+Z0C;EmC9Z1C,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApC6hJF;AoCj/II;EACE,cAAA;ApCm/IN;AmCz6II;EACE,iBAAA;AnC26IN;;AmCr6IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AnCw6IJ;AoC3hJI;EACE,qBAAA;EACA,oBnCia0C;EmCha1C,uBnC+Z0C;EmC9Z1C,WAAA;ApC6hJN;AoClhJM;EACE,aAAA;ApCohJR;AoCjhJM;EACE,qBAAA;EACA,qBnC8YwC;EmC7YxC,uBnC4YwC;EmC3YxC,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApCujJF;AoCjhJI;EACE,cAAA;ApCmhJN;AmCx7II;EACE,iBAAA;AnC07IN;;AmCn7IA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AnCs7IF;;AmCh7IA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBlCoK8C;EkCnK9C,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AT0lJJ;AmCj7IE;EAEE,0CAAA;EV1LF,kDU4LuB;AnCi7IzB;AmC96IE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AnC+6IzB;AmC56IE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AnC66IJ;;AmCv6IA;EACE,cAAA;AnC06IF;;AmCt6IA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,oBALI;E8B5DR,sCAAA;EACA,mBAAA;AnCy6IF;;AmCr6IA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AnCw6IF;;AmCp6IA;EAEE,6CAAA;EACA,wCAAA;EACA,8DAAA;EACA,0BAAA;EACA,kDAAA;EACA,uCAAA;EACA,4DAAA;EACA,sDAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AnCs6IF;;AqC5pJA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArC+pJF;AqC7pJE;;EACE,kBAAA;EACA,cAAA;ArCgqJJ;AqC3pJE;;;;;;;;;;;;EAME,UAAA;ArCmqJJ;;AqC9pJA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArCiqJF;AqC/pJE;EACE,WAAA;ArCiqJJ;;AqC7pJA;E5BhBI,kBAAA;ATirJJ;AqC7pJE;;EAEE,8CAAA;ArC+pJJ;AqC3pJE;;;E5BVE,0BAAA;EACA,6BAAA;AT0qJJ;AqCvpJE;;;E5BNE,yBAAA;EACA,4BAAA;ATkqJJ;;AqC1oJA;EACE,wBAAA;EACA,uBAAA;ArC6oJF;AqC3oJE;EAGE,cAAA;ArC2oJJ;AqCxoJE;EACE,eAAA;ArC0oJJ;;AqCtoJA;EACE,uBAAA;EACA,sBAAA;ArCyoJF;;AqCtoJA;EACE,sBAAA;EACA,qBAAA;ArCyoJF;;AqCrnJA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArCwnJF;AqCtnJE;;EAEE,WAAA;ArCwnJJ;AqCrnJE;;EAEE,6CAAA;ArCunJJ;AqCnnJE;;E5B1FE,6BAAA;EACA,4BAAA;ATitJJ;AqCnnJE;;E5B7GE,yBAAA;EACA,0BAAA;ATouJJ;;AsC5vJA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC2vJF;;AsCxvJA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;AtC2vJF;AwBvwJM;EcGN;IdFQ,gBAAA;ExB0wJN;AACF;AsC9vJE;EAEE,qCAAA;AtC+vJJ;AsC3vJE;EACE,UAAA;EACA,iD9BkhBoB;AR2uIxB;AsCzvJE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtC0vJJ;;AsClvJA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,kDAAA;EACA,yCAAA;EACA,iGAAA;EAGA,oFAAA;AtCkvJF;AsChvJE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;ATgyJJ;AsCjvJI;EAGE,kBAAA;EACA,wDAAA;AtCivJN;AsC7uJE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtC+uJJ;AsC5uJE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AT+yJJ;;AsCpuJA;EAEE,iCAAA;EACA,yCAAA;EACA,sCAAA;AtCsuJF;AsCnuJE;E7B5FE,gDAAA;ATk0JJ;AsCluJE;;EAEE,4CAAA;EbjHF,oDakHuB;AtCouJzB;;AsC3tJA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtC2tJF;AsCztJE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtC2tJJ;AsCztJI;EAEE,iCAAA;AtC0tJN;AsCttJE;;EAEE,gBrCgM4C;EqC/L5C,gDAAA;EACA,iCAAA;AtCwtJJ;;AsC9sJE;;EAEE,cAAA;EACA,kBAAA;AtCitJJ;;AsC5sJE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtC+sJJ;;AsCzsJE;;EACE,WAAA;AtC6sJJ;;AsCnsJE;EACE,aAAA;AtCssJJ;AsCpsJE;EACE,cAAA;AtCssJJ;;AuCn4JA;EAEE,wBAAA;EACA,6BAAA;EACA,oDAAA;EACA,yDAAA;EACA,4DAAA;EACA,wDAAA;EACA,uCAAA;EACA,kCAAA;EACA,iCAAA;EACA,uDAAA;EACA,6DAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,mCAAA;EACA,qEAAA;EACA,mEAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvCm4JF;AuC73JE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvCq4JJ;AuCj3JA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AvCm3JF;AuCj3JE;EAEE,yCAAA;AvCk3JJ;;AuCx2JA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvCu2JF;AuCp2JI;EAEE,oCAAA;AvCq2JN;AuCj2JE;EACE,gBAAA;AvCm2JJ;;AuC11JA;EACE,mBtCmjC8C;EsCljC9C,sBtCkjC8C;EsCjjC9C,6BAAA;AvC61JF;AuC31JE;;;EAGE,oCAAA;AvC61JJ;;AuCh1JA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvCi1JF;;AuC70JA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AvCg1JF;AwBz9JM;EeiIN;IfhIQ,gBAAA;ExB49JN;AACF;AuCn1JE;EACE,qBAAA;AvCq1JJ;AuCl1JE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvCo1JJ;;AuC90JA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvCi1JF;;AuC90JA;EACE,yCAAA;EACA,gBAAA;AvCi1JF;;AgB38JI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCw0JN;EuCt0JM;IACE,mBAAA;EvCw0JR;EuCt0JQ;IACE,kBAAA;EvCw0JV;EuCr0JQ;IACE,kDAAA;IACA,iDAAA;EvCu0JV;EuCn0JM;IACE,iBAAA;EvCq0JR;EuCl0JM;IACE,wBAAA;IACA,gBAAA;EvCo0JR;EuCj0JM;IACE,aAAA;EvCm0JR;EuCh0JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvCg0JR;EuC7zJQ;IACE,aAAA;EvC+zJV;EuC5zJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC8zJV;AACF;AgB3/JI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCu3JN;EuCr3JM;IACE,mBAAA;EvCu3JR;EuCr3JQ;IACE,kBAAA;EvCu3JV;EuCp3JQ;IACE,kDAAA;IACA,iDAAA;EvCs3JV;EuCl3JM;IACE,iBAAA;EvCo3JR;EuCj3JM;IACE,wBAAA;IACA,gBAAA;EvCm3JR;EuCh3JM;IACE,aAAA;EvCk3JR;EuC/2JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvC+2JR;EuC52JQ;IACE,aAAA;EvC82JV;EuC32JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC62JV;AACF;AgB1iKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCs6JN;EuCp6JM;IACE,mBAAA;EvCs6JR;EuCp6JQ;IACE,kBAAA;EvCs6JV;EuCn6JQ;IACE,kDAAA;IACA,iDAAA;EvCq6JV;EuCj6JM;IACE,iBAAA;EvCm6JR;EuCh6JM;IACE,wBAAA;IACA,gBAAA;EvCk6JR;EuC/5JM;IACE,aAAA;EvCi6JR;EuC95JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvC85JR;EuC35JQ;IACE,aAAA;EvC65JV;EuC15JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC45JV;AACF;AgBzlKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCq9JN;EuCn9JM;IACE,mBAAA;EvCq9JR;EuCn9JQ;IACE,kBAAA;EvCq9JV;EuCl9JQ;IACE,kDAAA;IACA,iDAAA;EvCo9JV;EuCh9JM;IACE,iBAAA;EvCk9JR;EuC/8JM;IACE,wBAAA;IACA,gBAAA;EvCi9JR;EuC98JM;IACE,aAAA;EvCg9JR;EuC78JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvC68JR;EuC18JQ;IACE,aAAA;EvC48JV;EuCz8JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC28JV;AACF;AgBxoKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCogKN;EuClgKM;IACE,mBAAA;EvCogKR;EuClgKQ;IACE,kBAAA;EvCogKV;EuCjgKQ;IACE,kDAAA;IACA,iDAAA;EvCmgKV;EuC//JM;IACE,iBAAA;EvCigKR;EuC9/JM;IACE,wBAAA;IACA,gBAAA;EvCggKR;EuC7/JM;IACE,aAAA;EvC+/JR;EuC5/JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvC4/JR;EuCz/JQ;IACE,aAAA;EvC2/JV;EuCx/JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC0/JV;AACF;AgBvrKI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCmjKN;EuCjjKM;IACE,mBAAA;EvCmjKR;EuCjjKQ;IACE,kBAAA;EvCmjKV;EuChjKQ;IACE,kDAAA;IACA,iDAAA;EvCkjKV;EuC9iKM;IACE,iBAAA;EvCgjKR;EuC7iKM;IACE,wBAAA;IACA,gBAAA;EvC+iKR;EuC5iKM;IACE,aAAA;EvC8iKR;EuC3iKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EvC2iKR;EuCxiKQ;IACE,aAAA;EvC0iKV;EuCviKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvCyiKV;AACF;AuChmKI;EAEI,iBAAA;EACA,2BAAA;AvCimKR;AuC/lKQ;EACE,mBAAA;AvCimKV;AuC/lKU;EACE,kBAAA;AvCimKZ;AuC9lKU;EACE,kDAAA;EACA,iDAAA;AvCgmKZ;AuC5lKQ;EACE,iBAAA;AvC8lKV;AuC3lKQ;EACE,wBAAA;EACA,gBAAA;AvC6lKV;AuC1lKQ;EACE,aAAA;AvC4lKV;AuCzlKQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AvCylKV;AuCtlKU;EACE,aAAA;AvCwlKZ;AuCrlKU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvCulKZ;;AuCtkKA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,iCAAA;EACA,gCAAA;EACA,sCAAA;EACA,0DAAA;EACA,qEAAA;AvCwkKF;;AuClkKI;EACE,qEAAA;AvCqkKN;;AwC91KA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;ATg3KJ;AwC31KE;EACE,eAAA;EACA,cAAA;AxC61KJ;AwC11KE;EACE,mBAAA;EACA,sBAAA;AxC41KJ;AwC11KI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;ATm3KJ;AwC11KI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AT02KJ;AwCv1KE;;EAEE,aAAA;AxCy1KJ;;AwCr1KA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxCs1KF;;AwCn1KA;EACE,4CAAA;EACA,iCAAA;AxCs1KF;;AwCn1KA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AxCs1KF;;AwCn1KA;EACE,gBAAA;AxCs1KF;;AwC90KE;EACE,oCAAA;AxCi1KJ;;AwCz0KA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxC40KF;AwC10KE;E/B7FE,wFAAA;AT06KJ;;AwCx0KA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxC20KF;AwCz0KE;E/BxGE,wFAAA;ATo7KJ;;AwCl0KA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AxCq0KF;AwCn0KE;EACE,mCAAA;EACA,sCAAA;AxCq0KJ;;AwCj0KA;EACE,uDAAA;EACA,sDAAA;AxCo0KF;;AwCh0KA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AT88KJ;;AwCh0KA;;;EAGE,WAAA;AxCm0KF;;AwCh0KA;;E/B3II,0DAAA;EACA,2DAAA;ATg9KJ;;AwCj0KA;;E/BlII,8DAAA;EACA,6DAAA;ATw8KJ;;AwC1zKE;EACE,0CAAA;AxC6zKJ;AgBx7KI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;ExC6zKF;EwC1zKE;IAEE,SAAA;IACA,gBAAA;ExC2zKJ;EwCzzKI;IACE,cAAA;IACA,cAAA;ExC2zKN;EwCtzKM;I/B3KJ,0BAAA;IACA,6BAAA;ETo+KF;EwCvzKQ;;IAGE,0BAAA;ExCwzKV;EwCtzKQ;;IAGE,6BAAA;ExCuzKV;EwCnzKM;I/B5KJ,yBAAA;IACA,4BAAA;ETk+KF;EwCpzKQ;;IAGE,yBAAA;ExCqzKV;EwCnzKQ;;IAGE,4BAAA;ExCozKV;AACF;;AyCzhLA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,oFAAA;EACA,sCAAA;EACA,mCAAA;EACA,8CAAA;EACA,yDAAA;AzC2hLF;;AyCvhLA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,mBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AzC0hLF;AwBjjLM;EiBUN;IjBTQ,gBAAA;ExBojLN;AACF;AyC7hLE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzC+hLJ;AyC7hLI;EACE,qDAAA;EACA,iDAAA;AzC+hLN;AyC1hLE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AzC4hLJ;AwB1kLM;EiBqCJ;IjBpCM,gBAAA;ExB6kLN;AACF;AyC9hLE;EACE,UAAA;AzCgiLJ;AyC7hLE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AzC+hLJ;;AyC3hLA;EACE,gBAAA;AzC8hLF;;AyC3hLA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzC8hLF;AyC5hLE;EhC7DE,yDAAA;EACA,0DAAA;AT4lLJ;AyC7hLI;EhChEA,+DAAA;EACA,gEAAA;ATgmLJ;AyC5hLE;EACE,aAAA;AzC8hLJ;AyC1hLE;EhC5DE,6DAAA;EACA,4DAAA;ATylLJ;AyC1hLM;EhChEF,mEAAA;EACA,kEAAA;AT6lLJ;AyCzhLI;EhCrEA,6DAAA;EACA,4DAAA;ATimLJ;;AyCvhLA;EACE,8EAAA;AzC0hLF;;AyCjhLE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;ATmoLJ;AyClhLI;EAAgB,aAAA;AzCqhLpB;AyCphLI;EAAe,gBAAA;AzCuhLnB;AyCnhLM;EhCtHF,gBAAA;AT4oLJ;AyC/gLI;EhC7HA,gBAAA;AT+oLJ;;AyC1gLI;EACE,iEAAA;EACA,wEAAA;AzC6gLN;;A0CvqLA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;ErC2RI,8BALI;EqCpRR,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;ATwqLJ;;A0ClqLE;EACE,iDAAA;A1CqqLJ;A0CnqLI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1CqqLN;A0CjqLE;EACE,6CAAA;A1CmqLJ;;A2CxsLA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,mCALI;EsCrRR,wCAAA;EACA,+BAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,8CAAA;EACA,0DAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,iFAAA;EACA,mDAAA;EACA,0CAAA;EACA,oDAAA;EACA,iEAAA;EACA,6DAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AX6tLF;;A2CtsLA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A3CysLF;AwB1tLM;EmBQN;InBPQ,gBAAA;ExB6tLN;AACF;A2C5sLE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A3C6sLJ;A2C1sLE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,U1C0rC4C;E0CzrC5C,iDAAA;A3C4sLJ;A2CzsLE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A3C0sLJ;A2CvsLE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3CwsLJ;;A2CnsLE;EACE,8C1C8pC4C;ADwiJhD;A2CjsLM;ElC9BF,0DAAA;EACA,6DAAA;ATkuLJ;A2C/rLM;ElClDF,2DAAA;EACA,8DAAA;ATovLJ;;A2ClrLA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,+BALI;EuCnRR,kCAAA;A5CwxLF;;A2CrrLA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,oCALI;EuCnRR,kCAAA;A5C+xLF;;A6CjyLA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,yBAAA;EACA,6BAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ATsyLJ;A6C7xLE;EACE,aAAA;A7C+xLJ;;A6C1xLA;EACE,kBAAA;EACA,SAAA;A7C6xLF;;A8C7zLA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,6BAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;ATi0LJ;;A8CzzLA;EAEE,cAAA;A9C2zLF;;A8CvzLA;EACE,gB7CmT8C;E6ClT9C,iCAAA;A9C0zLF;;A8ClzLA;EACE,mB7CshB8C;AD+xKhD;A8ClzLE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9CozLJ;;A8C5yLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C+yLJ;;A8CnzLE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9CszLJ;;A8C1zLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A9C6zLJ;;A8Cj0LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Co0LJ;;A8Cx0LE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9C20LJ;;A8C/0LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Ck1LJ;;A8Ct1LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9Cy1LJ;;A8C71LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cg2LJ;;A8Cp2LE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cu2LJ;;A8C32LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9C82LJ;;A8Cl3LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Cq3LJ;;A8Cz3LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9C43LJ;;A8Ch4LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Cm4LJ;;A8Cv4LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9C04LJ;;A8C94LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9Ci5LJ;;A8Cr5LE;EACE,6CAAA;EACA,sCAAA;EACA,oDAAA;EACA,kDAAA;A9Cw5LJ;;A8C55LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9C+5LJ;;A8Cn6LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Cs6LJ;;A8C16LE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9C66LJ;;A8Cj7LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Co7LJ;;A8Cx7LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9C27LJ;;A8C/7LE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Ck8LJ;;A8Ct8LE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Cy8LJ;;A8C78LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cg9LJ;;A8Cp9LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cu9LJ;;A8C39LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9C89LJ;;A8Cl+LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cq+LJ;;A8Cz+LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9C4+LJ;;A8Ch/LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9Cm/LJ;;A8Cv/LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9C0/LJ;;A8C9/LE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9CigMJ;;A8CrgME;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A9CwgMJ;;A+CpkME;EACE;IAAK,2B9CmlBuC;EDq/K9C;AACF;A+CpkMA;;EAGE,0BAAA;E1CkRI,mCALI;E0C3QR,mDAAA;EACA,oDAAA;EACA,oDAAA;EACA,gCAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AT4kMJ;;A+C/jMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A/CkkMF;AwBvlMM;EuBYN;IvBXQ,gBAAA;ExB0lMN;AACF;;A+CpkMA;EtBAE,qMAAA;EsBEA,oEAAA;A/CukMF;;A+CpkMA;EACE,iBAAA;A/CukMF;;A+CpkMA;EACE,WAAA;A/CukMF;;A+CnkME;EACE,kDAAA;A/CskMJ;A+CnkMM;EAJJ;IAKM,eAAA;E/CskMN;AACF;;AgDloMA;EAEE,2CAAA;EACA,+BAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,qDAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,wCAAA;EACA,qCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AT4oMJ;;AgD7nMA;EACE,qBAAA;EACA,sBAAA;AhDgoMF;AgD9nME;EAEE,oCAAA;EACA,0BAAA;AhD+nMJ;;AgDtnMA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhDynMF;AgDtnME;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhDunMJ;AgDpnME;EACE,+CAAA;EACA,uDAAA;AhDsnMJ;;AgD9mMA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AhDinMF;AgD/mME;EvCvDE,+BAAA;EACA,gCAAA;ATyqMJ;AgD/mME;EvC7CE,mCAAA;EACA,kCAAA;AT+pMJ;AgD/mME;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhDgnMJ;AgD5mME;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhD8mMJ;AgD1mME;EACE,mBAAA;AhD4mMJ;AgD1mMI;EACE,wDAAA;EACA,mDAAA;AhD4mMN;;AgD/lMI;EACE,mBAAA;AhDkmMN;AgD/lMQ;EvCvDJ,6DAAA;EAZA,0BAAA;ATsqMJ;AgD9lMQ;EvCxEJ,2DAAA;EAYA,4BAAA;AT8pMJ;AgD7lMQ;EACE,aAAA;AhD+lMV;AgD5lMQ;EACE,mDAAA;EACA,oBAAA;AhD8lMV;AgD5lMU;EACE,yDAAA;EACA,oDAAA;AhD8lMZ;;AgBprMI;EgC8DA;IACE,mBAAA;EhD0nMJ;EgDvnMM;IvCvDJ,6DAAA;IAZA,0BAAA;ET8rMF;EgDtnMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETsrMF;EgDrnMM;IACE,aAAA;EhDunMR;EgDpnMM;IACE,mDAAA;IACA,oBAAA;EhDsnMR;EgDpnMQ;IACE,yDAAA;IACA,oDAAA;EhDsnMV;AACF;AgB7sMI;EgC8DA;IACE,mBAAA;EhDkpMJ;EgD/oMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETstMF;EgD9oMM;IvCxEJ,2DAAA;IAYA,4BAAA;ET8sMF;EgD7oMM;IACE,aAAA;EhD+oMR;EgD5oMM;IACE,mDAAA;IACA,oBAAA;EhD8oMR;EgD5oMQ;IACE,yDAAA;IACA,oDAAA;EhD8oMV;AACF;AgBruMI;EgC8DA;IACE,mBAAA;EhD0qMJ;EgDvqMM;IvCvDJ,6DAAA;IAZA,0BAAA;ET8uMF;EgDtqMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETsuMF;EgDrqMM;IACE,aAAA;EhDuqMR;EgDpqMM;IACE,mDAAA;IACA,oBAAA;EhDsqMR;EgDpqMQ;IACE,yDAAA;IACA,oDAAA;EhDsqMV;AACF;AgB7vMI;EgC8DA;IACE,mBAAA;EhDksMJ;EgD/rMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETswMF;EgD9rMM;IvCxEJ,2DAAA;IAYA,4BAAA;ET8vMF;EgD7rMM;IACE,aAAA;EhD+rMR;EgD5rMM;IACE,mDAAA;IACA,oBAAA;EhD8rMR;EgD5rMQ;IACE,yDAAA;IACA,oDAAA;EhD8rMV;AACF;AgBrxMI;EgC8DA;IACE,mBAAA;EhD0tMJ;EgDvtMM;IvCvDJ,6DAAA;IAZA,0BAAA;ET8xMF;EgDttMM;IvCxEJ,2DAAA;IAYA,4BAAA;ETsxMF;EgDrtMM;IACE,aAAA;EhDutMR;EgDptMM;IACE,mDAAA;IACA,oBAAA;EhDstMR;EgDptMQ;IACE,yDAAA;IACA,oDAAA;EhDstMV;AACF;AgB7yMI;EgC8DA;IACE,mBAAA;EhDkvMJ;EgD/uMM;IvCvDJ,6DAAA;IAZA,0BAAA;ETszMF;EgD9uMM;IvCxEJ,2DAAA;IAYA,4BAAA;ET8yMF;EgD7uMM;IACE,aAAA;EhD+uMR;EgD5uMM;IACE,mDAAA;IACA,oBAAA;EhD8uMR;EgD5uMQ;IACE,yDAAA;IACA,oDAAA;EhD8uMV;AACF;AgDjuMA;EvChJI,gBAAA;ATo3MJ;AgDjuME;EACE,mDAAA;AhDmuMJ;AgDjuMI;EACE,sBAAA;AhDmuMN;;AgDttME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDytMJ;;AgDnuME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDsuMJ;;AgDhvME;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;AhDmvMJ;;AgD7vME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDgwMJ;;AgD1wME;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhD6wMJ;;AgDvxME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD0xMJ;;AgDpyME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhDuyMJ;;AgDjzME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDozMJ;;AgD9zME;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDi0MJ;;AgD30ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhD80MJ;;AgDx1ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhD21MJ;;AgDr2ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDw2MJ;;AgDl3ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDq3MJ;;AgD/3ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhDk4MJ;;AgD54ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhD+4MJ;;AgDz5ME;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,4DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,qDAAA;EACA,sDAAA;EACA,gEAAA;AhD45MJ;;AgDt6ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDy6MJ;;AgDn7ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhDs7MJ;;AgDh8ME;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhDm8MJ;;AgD78ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDg9MJ;;AgD19ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhD69MJ;;AgDv+ME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhD0+MJ;;AgDp/ME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDu/MJ;;AgDjgNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDogNJ;;AgD9gNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDihNJ;;AgD3hNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD8hNJ;;AgDxiNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD2iNJ;;AgDrjNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDwjNJ;;AgDlkNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDqkNJ;;AgD/kNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhDklNJ;;AgD5lNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD+lNJ;;AgDzmNE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;AhD4mNJ;;AiDxyNA;EAEE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,4EAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UhDipB8C;EgDhpB9C,WhDgpB8C;EgD/oB9C,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,kBAAA;EwCMF,oCAAA;AjDwyNF;AiDryNE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjDuyNJ;AiDpyNE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjDsyNJ;AiDnyNE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AjDoyNJ;;AiD5xNA;EAHE,wCAAA;AjDmyNF;;AiD1xNI;EATF,wCAAA;AjDuyNF;;AkDx1NA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;ATi2NJ;AkDt1NE;EACE,UAAA;AlDw1NJ;AkDr1NE;EACE,aAAA;AlDu1NJ;;AkDn1NA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlDq1NF;AkDn1NE;EACE,sCAAA;AlDq1NJ;;AkDj1NA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;ATq3NJ;AkDn1NE;EACE,oDAAA;EACA,sCAAA;AlDq1NJ;;AkDj1NA;EACE,kCAAA;EACA,qBAAA;AlDo1NF;;AmDl5NA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2DAAA;EACA,+CAAA;EACA,2BAAA;EACA,4EAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnDg5NF;;AmDz4NA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AnD24NF;AmDx4NE;E3B5CI,mC2B6CF;EACA,8BlDm8B4C;ADu8LhD;AwBp7NM;E2BwCJ;I3BvCM,gBAAA;ExBu7NN;AACF;AmD74NE;EACE,elDi8B4C;AD88LhD;AmD34NE;EACE,sBlD87B4C;AD+8LhD;;AmDz4NA;EACE,+CAAA;AnD44NF;AmD14NE;EACE,gBAAA;EACA,gBAAA;AnD44NJ;AmDz4NE;EACE,gBAAA;AnD24NJ;;AmDv4NA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AnD04NF;;AmDt4NA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AnDs4NF;;AmDl4NA;EAEE,0BAAA;EACA,yBAAA;EACA,2BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AnDw4N9D;AoDp/NE;EAAS,UAAA;ApDu/NX;AoDt/NE;EAAS,mCD2GiF;AnD84N5F;;AmDz4NA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;ATk/NJ;AmD34NE;EACE,kGAAA;EACA,sJAAA;AnD64NJ;;AmDx4NA;EACE,gBAAA;EACA,8CAAA;AnD24NF;;AmDt4NA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AnDu4NF;;AmDn4NA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;ATggOJ;AmDl4NE;EACE,8CAAA;AnDo4NJ;;AgB/+NI;EmCiHF;IACE,0BAAA;IACA,uEAAA;EnDk4NF;EmD93NA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EnDg4NF;EmD73NA;IACE,uBAAA;EnD+3NF;AACF;AgB9/NI;EmCmIF;;IAEE,uBAAA;EnD83NF;AACF;AgBpgOI;EmC0IF;IACE,wBAAA;EnD63NF;AACF;AmDp3NI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnDs3NN;AmDp3NM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;ATgkOJ;AmDn3NM;;E1C7MF,gBAAA;ATokOJ;AmDl3NM;EACE,gBAAA;AnDo3NR;;AgB9gOI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD04NJ;EmDx4NI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ETolOF;EmDv4NI;;I1C7MF,gBAAA;ETwlOF;EmDt4NI;IACE,gBAAA;EnDw4NN;AACF;AgBniOI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD85NJ;EmD55NI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ETwmOF;EmD35NI;;I1C7MF,gBAAA;ET4mOF;EmD15NI;IACE,gBAAA;EnD45NN;AACF;AgBvjOI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDk7NJ;EmDh7NI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ET4nOF;EmD/6NI;;I1C7MF,gBAAA;ETgoOF;EmD96NI;IACE,gBAAA;EnDg7NN;AACF;AgB3kOI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDs8NJ;EmDp8NI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ETgpOF;EmDn8NI;;I1C7MF,gBAAA;ETopOF;EmDl8NI;IACE,gBAAA;EnDo8NN;AACF;AgB/lOI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD09NJ;EmDx9NI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EToqOF;EmDv9NI;;I1C7MF,gBAAA;ETwqOF;EmDt9NI;IACE,gBAAA;EnDw9NN;AACF;AgBnnOI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD8+NJ;EmD5+NI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ETwrOF;EmD3+NI;;I1C7MF,gBAAA;ET4rOF;EmD1+NI;IACE,gBAAA;EnD4+NN;AACF;AqDltOA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,iCALI;EgDjRR,qCAAA;EACA,kCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,uCrD8U8C;EqD5U9C,kBAAA;EACA,gBrDmV8C;EqDlV9C,gBrDqV8C;EqDpV9C,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;ArD0tOF;AqDxtOE;EAAS,kCAAA;ArD2tOX;AqDztOE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArD2tOJ;AqDztOI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArD2tON;;AqDttOA;EACE,iDAAA;ArDytOF;AqDvtOE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ArDytOJ;;AqDrtOA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ArDwtOF;AqDttOE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ArDwtOJ;;AqDptOA,mBAAA;AAEA;EACE,8CAAA;ArDstOF;AqDptOE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ArDstOJ;;AqDltOA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ArDqtOF;AqDntOE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ArDqtOJ;;AqDjtOA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;ATqyOJ;;AuDxzOA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,iCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,yEAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,uCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,uCrD8U8C;EqD5U9C,kBAAA;EACA,gBrDmV8C;EqDlV9C,gBrDqV8C;EqDpV9C,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;ATm1OJ;AuD/zOE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvDi0OJ;AuD/zOI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvDg0ON;;AuD1zOE;EACE,oFAAA;AvD6zOJ;AuD3zOI;EAEE,wFAAA;AvD4zON;AuDzzOI;EACE,SAAA;EACA,gDAAA;AvD2zON;AuDxzOI;EACE,sCAAA;EACA,sCAAA;AvD0zON;;AuDrzOA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AvDuzOJ;AuDrzOI;EAEE,kIAAA;AvDszON;AuDnzOI;EACE,OAAA;EACA,kDAAA;AvDqzON;AuDlzOI;EACE,oCAAA;EACA,wCAAA;AvDozON;;AuD/yOA,mBAAA;AAGE;EACE,iFAAA;AvDgzOJ;AuD9yOI;EAEE,wFAAA;AvD+yON;AuD5yOI;EACE,MAAA;EACA,mDAAA;AvD8yON;AuD3yOI;EACE,mCAAA;EACA,yCAAA;AvD6yON;AuDxyOE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AvD0yOJ;;AuDtyOA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AvDwyOJ;AuDtyOI;EAEE,kIAAA;AvDuyON;AuDpyOI;EACE,QAAA;EACA,iDAAA;AvDsyON;AuDnyOI;EACE,qCAAA;EACA,uCAAA;AvDqyON;;AuDhyOA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AT+6OJ;AuDjxOE;EACE,aAAA;AvDmxOJ;;AuD/wOA;EACE,0EAAA;EACA,mCAAA;AvDkxOF;;AwDv8OA;EACE,kBAAA;AxD08OF;;AwDv8OA;EACE,mBAAA;AxD08OF;;AwDv8OA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxD08OF;AyDh+OE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDk+OJ;;AwD38OA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AxD88OF;AwB79OM;EgCQN;IhCPQ,gBAAA;ExBg+ON;AACF;;AwDh9OA;;;EAGE,cAAA;AxDm9OF;;AwDh9OA;;EAEE,2BAAA;AxDm9OF;;AwDh9OA;;EAEE,4BAAA;AxDm9OF;;AwD18OE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxD68OJ;AwD18OE;;;EAGE,UAAA;EACA,UAAA;AxD48OJ;AwDz8OE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AxD28OJ;AwBpgPM;EgCqDJ;;IhCpDM,gBAAA;ExBwgPN;AACF;;AwDx8OA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UvD6tC8C;EuD5tC9C,UAAA;EACA,cvDlCa;EuDmCb,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YvDwtC8C;EuB9yC1C,8BgCuFJ;AxD08OF;AwB7hPM;EgCkEN;;IhCjEQ,gBAAA;ExBiiPN;AACF;AwD78OE;;;EAEE,cvD5CW;EuD6CX,qBAAA;EACA,UAAA;EACA,YvDgtC4C;ADgwMhD;;AwD78OA;EACE,OAAA;AxDg9OF;;AwD78OA;EACE,QAAA;AxDg9OF;;AwD38OA;;EAEE,qBAAA;EACA,WvD8sC8C;EuD7sC9C,YvD6sC8C;EuD5sC9C,4BAAA;EACA,wBAAA;EACA,0BAAA;AxD88OF;;AwD38OA;EACE,8TAAA;AxD88OF;;AwD58OA;EACE,6TAAA;AxD+8OF;;AwDv8OA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBvDiqC8C;EuDhqC9C,mBAAA;EACA,gBvD+pC8C;AD0yMhD;AwDv8OE;EACE,uBAAA;EACA,cAAA;EACA,WvD8pC4C;EuD7pC5C,WvD8pC4C;EuD7pC5C,UAAA;EACA,iBvD8pC4C;EuD7pC5C,gBvD6pC4C;EuD5pC5C,mBAAA;EACA,eAAA;EACA,yBvD1GW;EuD2GX,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YvDqpC4C;EuBrzC1C,6BgCiKF;AxDw8OJ;AwBrmPM;EgC4IJ;IhC3IM,gBAAA;ExBwmPN;AACF;AwD18OE;EACE,UvDkpC4C;AD0zMhD;;AwDn8OA;EACE,kBAAA;EACA,UAAA;EACA,evD2oC8C;EuD1oC9C,SAAA;EACA,oBvDwoC8C;EuDvoC9C,uBvDuoC8C;EuDtoC9C,cvDrIa;EuDsIb,kBAAA;AxDs8OF;;AwDh8OE;;EAEE,gCvDsoC4C;AD6zMhD;AwDh8OE;EACE,yBvDzHW;AD2jPf;AwD/7OE;EACE,cvD7HW;AD8jPf;;AwD38OE;;;EAEE,gCvDsoC4C;ADy0MhD;AwD58OE;EACE,yBvDzHW;ADukPf;AwD38OE;EACE,cvD7HW;AD0kPf;;A0D/pPA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A1DiqPF;;A0D7pPA;EACE;IAAK,0CAAA;E1DiqPL;AACF;A0D9pPA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A1D6pPF;;A0D1pPA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A1D4pPF;;A0DnpPA;EACE;IACE,mBAAA;E1DspPF;E0DppPA;IACE,UAAA;IACA,eAAA;E1DspPF;AACF;A0DlpPA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A1DipPF;;A0D9oPA;EACE,wBAAA;EACA,yBAAA;A1DipPF;;A0D7oPE;EACE;;IAEE,kCAAA;E1DgpPJ;AACF;A2DhuPA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,gFAAA;EACA,qDAAA;EACA,qCAAA;A3DiuPF;;AgBpqPI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DktPJ;AACF;AwB7uPM;EmCYJ;InCXM,gBAAA;ExBgvPN;AACF;AgB1rPI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DytPN;E2DttPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3DwtPN;E2DrtPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3DutPN;E2DptPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3DstPN;E2DntPI;IAEE,eAAA;E3DotPN;E2DjtPI;IAGE,mBAAA;E3DitPN;AACF;AgB9uPI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DgtPN;E2D9sPM;IACE,aAAA;E3DgtPR;E2D7sPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D8sPR;AACF;;AgBlvPI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DgyPJ;AACF;AwB3zPM;EmCYJ;InCXM,gBAAA;ExB8zPN;AACF;AgBxwPI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DuyPN;E2DpyPI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3DsyPN;E2DnyPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3DqyPN;E2DlyPI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3DoyPN;E2DjyPI;IAEE,eAAA;E3DkyPN;E2D/xPI;IAGE,mBAAA;E3D+xPN;AACF;AgB5zPI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D8xPN;E2D5xPM;IACE,aAAA;E3D8xPR;E2D3xPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D4xPR;AACF;;AgBh0PI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D82PJ;AACF;AwBz4PM;EmCYJ;InCXM,gBAAA;ExB44PN;AACF;AgBt1PI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Dq3PN;E2Dl3PI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Do3PN;E2Dj3PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Dm3PN;E2Dh3PI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Dk3PN;E2D/2PI;IAEE,eAAA;E3Dg3PN;E2D72PI;IAGE,mBAAA;E3D62PN;AACF;AgB14PI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D42PN;E2D12PM;IACE,aAAA;E3D42PR;E2Dz2PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3D02PR;AACF;;AgB94PI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D47PJ;AACF;AwBv9PM;EmCYJ;InCXM,gBAAA;ExB09PN;AACF;AgBp6PI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Dm8PN;E2Dh8PI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Dk8PN;E2D/7PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Di8PN;E2D97PI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Dg8PN;E2D77PI;IAEE,eAAA;E3D87PN;E2D37PI;IAGE,mBAAA;E3D27PN;AACF;AgBx9PI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D07PN;E2Dx7PM;IACE,aAAA;E3D07PR;E2Dv7PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3Dw7PR;AACF;;AgB59PI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3D0gQJ;AACF;AwBriQM;EmCYJ;InCXM,gBAAA;ExBwiQN;AACF;AgBl/PI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DihQN;E2D9gQI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3DghQN;E2D7gQI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D+gQN;E2D5gQI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D8gQN;E2D3gQI;IAEE,eAAA;E3D4gQN;E2DzgQI;IAGE,mBAAA;E3DygQN;AACF;AgBtiQI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DwgQN;E2DtgQM;IACE,aAAA;E3DwgQR;E2DrgQM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DsgQR;AACF;;AgB1iQI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E3DwlQJ;AACF;AwBnnQM;EmCYJ;InCXM,gBAAA;ExBsnQN;AACF;AgBhkQI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3D+lQN;E2D5lQI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D8lQN;E2D3lQI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D6lQN;E2D1lQI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D4lQN;E2DzlQI;IAEE,eAAA;E3D0lQN;E2DvlQI;IAGE,mBAAA;E3DulQN;AACF;AgBpnQI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DslQN;E2DplQM;IACE,aAAA;E3DslQR;E2DnlQM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DolQR;AACF;;A2DpqQE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A3DqqQN;AwB/rQM;EmCYJ;InCXM,gBAAA;ExBksQN;AACF;A2DxqQM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A3D0qQR;A2DvqQM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A3DyqQR;A2DtqQM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A3DwqQR;A2DrqQM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A3DuqQR;A2DpqQM;EAEE,eAAA;A3DqqQR;A2DlqQM;EAGE,mBAAA;A3DkqQR;;A2DvoQA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,anD6vC8C;EmD5vC9C,YAAA;EACA,aAAA;EACA,yBnD2+B8C;ADoxOhD;AoD5vQE;EAAS,UAAA;ApD+vQX;AoD9vQE;EAAS,anDw+BqC;ADyxOhD;;A2DnpQA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A3DspQF;A2DppQE;EACE,4FAAA;EACA,6IAAA;A3DspQJ;;A2DlpQA;EACE,gBAAA;EACA,kDAAA;A3DqpQF;;A2DlpQA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A3DqpQF;;A4DlyQA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,Y3DouB8C;ADikPhD;A4DnyQE;EACE,qBAAA;EACA,WAAA;A5DqyQJ;;A4DhyQA;EACE,iBAAA;A5DmyQF;;A4DhyQA;EACE,iBAAA;A5DmyQF;;A4DhyQA;EACE,iBAAA;A5DmyQF;;A4D9xQE;EACE,mDAAA;A5DiyQJ;;A4D7xQA;EACE;IACE,Y3DusB4C;EDylP9C;AACF;A4D7xQA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A5D+xQF;;A4D5xQA;EACE;IACE,uBAAA;E5D+xQF;AACF;AyD90QE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDg1QJ;;A6Dn1QE;EACE,yBAAA;EACA,iFAAA;A7Ds1QJ;;A6Dx1QE;EACE,yBAAA;EACA,+EAAA;A7D21QJ;;A6D71QE;EACE,yBAAA;EACA,qFAAA;A7Dg2QJ;;A6Dl2QE;EACE,yBAAA;EACA,iFAAA;A7Dq2QJ;;A6Dv2QE;EACE,yBAAA;EACA,mFAAA;A7D02QJ;;A6D52QE;EACE,yBAAA;EACA,iFAAA;A7D+2QJ;;A6Dj3QE;EACE,yBAAA;EACA,gFAAA;A7Do3QJ;;A6Dt3QE;EACE,yBAAA;EACA,iFAAA;A7Dy3QJ;;A6D33QE;EACE,yBAAA;EACA,iFAAA;A7D83QJ;;A6Dh4QE;EACE,yBAAA;EACA,8EAAA;A7Dm4QJ;;A6Dr4QE;EACE,yBAAA;EACA,8EAAA;A7Dw4QJ;;A6D14QE;EACE,yBAAA;EACA,+EAAA;A7D64QJ;;A6D/4QE;EACE,yBAAA;EACA,+EAAA;A7Dk5QJ;;A6Dp5QE;EACE,yBAAA;EACA,gFAAA;A7Du5QJ;;A6Dz5QE;EACE,yBAAA;EACA,gFAAA;A7D45QJ;;A6D95QE;EACE,yBAAA;EACA,6EAAA;A7Di6QJ;;A6Dn6QE;EACE,yBAAA;EACA,8EAAA;A7Ds6QJ;;A6Dx6QE;EACE,yBAAA;EACA,+EAAA;A7D26QJ;;A6D76QE;EACE,yBAAA;EACA,gFAAA;A7Dg7QJ;;A6Dl7QE;EACE,yBAAA;EACA,8EAAA;A7Dq7QJ;;A6Dv7QE;EACE,yBAAA;EACA,+EAAA;A7D07QJ;;A6D57QE;EACE,yBAAA;EACA,+EAAA;A7D+7QJ;;A6Dj8QE;EACE,yBAAA;EACA,8EAAA;A7Do8QJ;;A6Dt8QE;EACE,yBAAA;EACA,kFAAA;A7Dy8QJ;;A6D38QE;EACE,yBAAA;EACA,kFAAA;A7D88QJ;;A6Dh9QE;EACE,yBAAA;EACA,kFAAA;A7Dm9QJ;;A6Dr9QE;EACE,yBAAA;EACA,kFAAA;A7Dw9QJ;;A6D19QE;EACE,yBAAA;EACA,kFAAA;A7D69QJ;;A6D/9QE;EACE,yBAAA;EACA,kFAAA;A7Dk+QJ;;A6Dp+QE;EACE,yBAAA;EACA,kFAAA;A7Du+QJ;;A6Dz+QE;EACE,yBAAA;EACA,kFAAA;A7D4+QJ;;A6D9+QE;EACE,yBAAA;EACA,kFAAA;A7Di/QJ;;A8Dn/QE;EACE,wEAAA;EACA,kGAAA;A9Ds/QJ;A8Dn/QM;EAGE,+DAAA;EACA,yFAAA;A9Dm/QR;;A8D5/QE;EACE,sEAAA;EACA,gGAAA;A9D+/QJ;A8D5/QM;EAGE,8DAAA;EACA,wFAAA;A9D4/QR;;A8DrgRE;EACE,4EAAA;EACA,sGAAA;A9DwgRJ;A8DrgRM;EAGE,gEAAA;EACA,0FAAA;A9DqgRR;;A8D9gRE;EACE,wEAAA;EACA,kGAAA;A9DihRJ;A8D9gRM;EAGE,6DAAA;EACA,uFAAA;A9D8gRR;;A8DvhRE;EACE,0EAAA;EACA,oGAAA;A9D0hRJ;A8DvhRM;EAGE,+DAAA;EACA,yFAAA;A9DuhRR;;A8DhiRE;EACE,wEAAA;EACA,kGAAA;A9DmiRJ;A8DhiRM;EAGE,+DAAA;EACA,yFAAA;A9DgiRR;;A8DziRE;EACE,uEAAA;EACA,iGAAA;A9D4iRJ;A8DziRM;EAGE,4DAAA;EACA,sFAAA;A9DyiRR;;A8DljRE;EACE,wEAAA;EACA,kGAAA;A9DqjRJ;A8DljRM;EAGE,8DAAA;EACA,wFAAA;A9DkjRR;;A8D3jRE;EACE,wEAAA;EACA,kGAAA;A9D8jRJ;A8D3jRM;EAGE,0DAAA;EACA,oFAAA;A9D2jRR;;A8DpkRE;EACE,qEAAA;EACA,+FAAA;A9DukRJ;A8DpkRM;EAGE,8DAAA;EACA,wFAAA;A9DokRR;;A8D7kRE;EACE,qEAAA;EACA,+FAAA;A9DglRJ;A8D7kRM;EAGE,6DAAA;EACA,uFAAA;A9D6kRR;;A8DtlRE;EACE,sEAAA;EACA,gGAAA;A9DylRJ;A8DtlRM;EAGE,0DAAA;EACA,oFAAA;A9DslRR;;A8D/lRE;EACE,sEAAA;EACA,gGAAA;A9DkmRJ;A8D/lRM;EAGE,gEAAA;EACA,0FAAA;A9D+lRR;;A8DxmRE;EACE,uEAAA;EACA,iGAAA;A9D2mRJ;A8DxmRM;EAGE,+DAAA;EACA,yFAAA;A9DwmRR;;A8DjnRE;EACE,uEAAA;EACA,iGAAA;A9DonRJ;A8DjnRM;EAGE,8DAAA;EACA,wFAAA;A9DinRR;;A8D1nRE;EACE,oEAAA;EACA,8FAAA;A9D6nRJ;A8D1nRM;EAGE,4DAAA;EACA,sFAAA;A9D0nRR;;A8DnoRE;EACE,qEAAA;EACA,+FAAA;A9DsoRJ;A8DnoRM;EAGE,8DAAA;EACA,wFAAA;A9DmoRR;;A8D5oRE;EACE,sEAAA;EACA,gGAAA;A9D+oRJ;A8D5oRM;EAGE,8DAAA;EACA,wFAAA;A9D4oRR;;A8DrpRE;EACE,uEAAA;EACA,iGAAA;A9DwpRJ;A8DrpRM;EAGE,+DAAA;EACA,yFAAA;A9DqpRR;;A8D9pRE;EACE,qEAAA;EACA,+FAAA;A9DiqRJ;A8D9pRM;EAGE,8DAAA;EACA,wFAAA;A9D8pRR;;A8DvqRE;EACE,sEAAA;EACA,gGAAA;A9D0qRJ;A8DvqRM;EAGE,8DAAA;EACA,wFAAA;A9DuqRR;;A8DhrRE;EACE,sEAAA;EACA,gGAAA;A9DmrRJ;A8DhrRM;EAGE,gEAAA;EACA,0FAAA;A9DgrRR;;A8DzrRE;EACE,qEAAA;EACA,+FAAA;A9D4rRJ;A8DzrRM;EAGE,+DAAA;EACA,yFAAA;A9DyrRR;;A8DlsRE;EACE,yEAAA;EACA,mGAAA;A9DqsRJ;A8DlsRM;EAGE,gEAAA;EACA,0FAAA;A9DksRR;;A8D3sRE;EACE,yEAAA;EACA,mGAAA;A9D8sRJ;A8D3sRM;EAGE,gEAAA;EACA,0FAAA;A9D2sRR;;A8DptRE;EACE,yEAAA;EACA,mGAAA;A9DutRJ;A8DptRM;EAGE,gEAAA;EACA,0FAAA;A9DotRR;;A8D7tRE;EACE,yEAAA;EACA,mGAAA;A9DguRJ;A8D7tRM;EAGE,+DAAA;EACA,yFAAA;A9D6tRR;;A8DtuRE;EACE,yEAAA;EACA,mGAAA;A9DyuRJ;A8DtuRM;EAGE,8DAAA;EACA,wFAAA;A9DsuRR;;A8D/uRE;EACE,yEAAA;EACA,mGAAA;A9DkvRJ;A8D/uRM;EAGE,6DAAA;EACA,uFAAA;A9D+uRR;;A8DxvRE;EACE,yEAAA;EACA,mGAAA;A9D2vRJ;A8DxvRM;EAGE,6DAAA;EACA,uFAAA;A9DwvRR;;A8DjwRE;EACE,yEAAA;EACA,mGAAA;A9DowRJ;A8DjwRM;EAGE,6DAAA;EACA,uFAAA;A9DiwRR;;A8D1wRE;EACE,yEAAA;EACA,mGAAA;A9D6wRJ;A8D1wRM;EAGE,6DAAA;EACA,uFAAA;A9D0wRR;;A8DnwRA;EACE,+EAAA;EACA,yGAAA;A9DswRF;A8DnwRI;EAEE,kFAAA;EACA,4GAAA;A9DowRN;;A+D9xRA;EACE,UAAA;EAEA,kJAAA;A/DgyRF;;AgEnyRA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;AhEsyRF;AgEpyRE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;AhEsyRJ;AwB/xRM;EwCZJ;IxCaM,gBAAA;ExBkyRN;AACF;;AgEpyRI;EACE,mEAAA;AhEuyRN;;AiE1zRA;EACE,kBAAA;EACA,WAAA;AjE6zRF;AiE3zRE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AjE6zRJ;AiE1zRE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AjE4zRJ;;AiEvzRE;EACE,uBAAA;AjE0zRJ;;AiE3zRE;EACE,sBAAA;AjE8zRJ;;AiE/zRE;EACE,yBAAA;AjEk0RJ;;AiEn0RE;EACE,iCAAA;AjEs0RJ;;AkE31RA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,ajE0vC8C;ADomPhD;;AkE31RA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,ajEkvC8C;AD4mPhD;;AkEt1RI;EACE,gBAAA;EACA,MAAA;EACA,ajEsuC0C;ADmnPhD;;AkEt1RI;EACE,gBAAA;EACA,SAAA;EACA,ajEguC0C;ADynPhD;;AgB1zRI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajEsuC0C;EDgoP9C;EkEn2RE;IACE,gBAAA;IACA,SAAA;IACA,ajEguC0C;EDqoP9C;AACF;AgBv0RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajEsuC0C;ED4oP9C;EkE/2RE;IACE,gBAAA;IACA,SAAA;IACA,ajEguC0C;EDipP9C;AACF;AgBn1RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajEsuC0C;EDwpP9C;EkE33RE;IACE,gBAAA;IACA,SAAA;IACA,ajEguC0C;ED6pP9C;AACF;AgB/1RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajEsuC0C;EDoqP9C;EkEv4RE;IACE,gBAAA;IACA,SAAA;IACA,ajEguC0C;EDyqP9C;AACF;AgB32RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajEsuC0C;EDgrP9C;EkEn5RE;IACE,gBAAA;IACA,SAAA;IACA,ajEguC0C;EDqrP9C;AACF;AgBv3RI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,ajEsuC0C;ED4rP9C;EkE/5RE;IACE,gBAAA;IACA,SAAA;IACA,ajEguC0C;EDisP9C;AACF;AmEj8RA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AnEm8RF;;AmEh8RA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AnEm8RF;;AoE38RA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ArE48RF;AqEz8RE;;EACE,6BAAA;ArE48RJ;;AsE19RE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UrE2iB4C;EqE1iB5C,WAAA;AtE69RJ;;AuEr+RA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AxEy+RF;;AyE/+RA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,axEqW8C;AD6oRhD;;A0Et7RQ;EAOI,mCAAA;A1Em7RZ;;A0E17RQ;EAOI,8BAAA;A1Eu7RZ;;A0E97RQ;EAOI,iCAAA;A1E27RZ;;A0El8RQ;EAOI,iCAAA;A1E+7RZ;;A0Et8RQ;EAOI,sCAAA;A1Em8RZ;;A0E18RQ;EAOI,mCAAA;A1Eu8RZ;;A0E98RQ;EAOI,sBAAA;A1E28RZ;;A0El9RQ;EAOI,uBAAA;A1E+8RZ;;A0Et9RQ;EAOI,sBAAA;A1Em9RZ;;A0E19RQ;EAOI,8BAAA;A1Eu9RZ;;A0E99RQ;EAOI,4BAAA;A1E29RZ;;A0El+RQ;EAOI,2BAAA;A1E+9RZ;;A0Et+RQ;EAOI,iCAAA;A1Em+RZ;;A0E1+RQ;EAOI,2BAAA;A1Eu+RZ;;A0E9+RQ;EAOI,qBAAA;A1E2+RZ;;A0El/RQ;EAOI,wBAAA;A1E++RZ;;A0Et/RQ;EAOI,uBAAA;A1Em/RZ;;A0E1/RQ;EAOI,wBAAA;A1Eu/RZ;;A0E9/RQ;EAOI,qBAAA;A1E2/RZ;;A0ElgSQ;EAOI,yBAAA;A1E+/RZ;;A0EtgSQ;EAOI,2BAAA;A1EmgSZ;;A0E1gSQ;EAOI,4BAAA;A1EugSZ;;A0E9gSQ;EAOI,2BAAA;A1E2gSZ;;A0ElhSQ;EAOI,2BAAA;A1E+gSZ;;A0EthSQ;EAOI,6BAAA;A1EmhSZ;;A0E1hSQ;EAOI,8BAAA;A1EuhSZ;;A0E9hSQ;EAOI,6BAAA;A1E2hSZ;;A0EliSQ;EAOI,2BAAA;A1E+hSZ;;A0EtiSQ;EAOI,6BAAA;A1EmiSZ;;A0E1iSQ;EAOI,8BAAA;A1EuiSZ;;A0E9iSQ;EAOI,6BAAA;A1E2iSZ;;A0EljSQ;EAOI,0BAAA;A1E+iSZ;;A0EtjSQ;EAOI,gCAAA;A1EmjSZ;;A0E1jSQ;EAOI,yBAAA;A1EujSZ;;A0E9jSQ;EAOI,wBAAA;A1E2jSZ;;A0ElkSQ;EAOI,+BAAA;A1E+jSZ;;A0EtkSQ;EAOI,yBAAA;A1EmkSZ;;A0E1kSQ;EAOI,6BAAA;A1EukSZ;;A0E9kSQ;EAOI,8BAAA;A1E2kSZ;;A0EllSQ;EAOI,wBAAA;A1E+kSZ;;A0EtlSQ;EAOI,+BAAA;A1EmlSZ;;A0E1lSQ;EAOI,wBAAA;A1EulSZ;;A0E9lSQ;EAOI,2CAAA;A1E2lSZ;;A0ElmSQ;EAOI,8CAAA;A1E+lSZ;;A0EtmSQ;EAOI,8CAAA;A1EmmSZ;;A0E1mSQ;EAOI,2BAAA;A1EumSZ;;A0ExnSQ;EACE,gFAAA;A1E2nSV;;A0E5nSQ;EACE,8EAAA;A1E+nSV;;A0EhoSQ;EACE,oFAAA;A1EmoSV;;A0EpoSQ;EACE,gFAAA;A1EuoSV;;A0ExoSQ;EACE,kFAAA;A1E2oSV;;A0E5oSQ;EACE,gFAAA;A1E+oSV;;A0EhpSQ;EACE,+EAAA;A1EmpSV;;A0EppSQ;EACE,gFAAA;A1EupSV;;A0ExpSQ;EACE,gFAAA;A1E2pSV;;A0E5pSQ;EACE,6EAAA;A1E+pSV;;A0EhqSQ;EACE,6EAAA;A1EmqSV;;A0EpqSQ;EACE,8EAAA;A1EuqSV;;A0ExqSQ;EACE,8EAAA;A1E2qSV;;A0E5qSQ;EACE,+EAAA;A1E+qSV;;A0EhrSQ;EACE,+EAAA;A1EmrSV;;A0EprSQ;EACE,4EAAA;A1EurSV;;A0ExrSQ;EACE,6EAAA;A1E2rSV;;A0E5rSQ;EACE,8EAAA;A1E+rSV;;A0EhsSQ;EACE,+EAAA;A1EmsSV;;A0EpsSQ;EACE,6EAAA;A1EusSV;;A0ExsSQ;EACE,8EAAA;A1E2sSV;;A0E5sSQ;EACE,8EAAA;A1E+sSV;;A0EhtSQ;EACE,6EAAA;A1EmtSV;;A0EptSQ;EACE,iFAAA;A1EutSV;;A0ExtSQ;EACE,iFAAA;A1E2tSV;;A0E5tSQ;EACE,iFAAA;A1E+tSV;;A0EhuSQ;EACE,iFAAA;A1EmuSV;;A0EpuSQ;EACE,iFAAA;A1EuuSV;;A0ExuSQ;EACE,iFAAA;A1E2uSV;;A0E5uSQ;EACE,iFAAA;A1E+uSV;;A0EhvSQ;EACE,iFAAA;A1EmvSV;;A0EpvSQ;EACE,iFAAA;A1EuvSV;;A0E9uSQ;EAOI,2BAAA;A1E2uSZ;;A0ElvSQ;EAOI,6BAAA;A1E+uSZ;;A0EtvSQ;EAOI,6BAAA;A1EmvSZ;;A0E1vSQ;EAOI,0BAAA;A1EuvSZ;;A0E9vSQ;EAOI,2BAAA;A1E2vSZ;;A0ElwSQ;EAOI,iBAAA;A1E+vSZ;;A0EtwSQ;EAOI,mBAAA;A1EmwSZ;;A0E1wSQ;EAOI,oBAAA;A1EuwSZ;;A0E9wSQ;EAOI,oBAAA;A1E2wSZ;;A0ElxSQ;EAOI,sBAAA;A1E+wSZ;;A0EtxSQ;EAOI,uBAAA;A1EmxSZ;;A0E1xSQ;EAOI,kBAAA;A1EuxSZ;;A0E9xSQ;EAOI,oBAAA;A1E2xSZ;;A0ElySQ;EAOI,qBAAA;A1E+xSZ;;A0EtySQ;EAOI,mBAAA;A1EmySZ;;A0E1ySQ;EAOI,qBAAA;A1EuySZ;;A0E9ySQ;EAOI,sBAAA;A1E2ySZ;;A0ElzSQ;EAOI,2CAAA;A1E+ySZ;;A0EtzSQ;EAOI,sCAAA;A1EmzSZ;;A0E1zSQ;EAOI,sCAAA;A1EuzSZ;;A0E9zSQ;EAOI,uFAAA;A1E2zSZ;;A0El0SQ;EAOI,oBAAA;A1E+zSZ;;A0Et0SQ;EAOI,2FAAA;A1Em0SZ;;A0E10SQ;EAOI,wBAAA;A1Eu0SZ;;A0E90SQ;EAOI,6FAAA;A1E20SZ;;A0El1SQ;EAOI,0BAAA;A1E+0SZ;;A0Et1SQ;EAOI,8FAAA;A1Em1SZ;;A0E11SQ;EAOI,2BAAA;A1Eu1SZ;;A0E91SQ;EAOI,4FAAA;A1E21SZ;;A0El2SQ;EAOI,yBAAA;A1E+1SZ;;A0Et2SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1Eo2SZ;;A0E32SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Ey2SZ;;A0Eh3SQ;EAIQ,sBAAA;EAGJ,kFAAA;A1E82SZ;;A0Er3SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1Em3SZ;;A0E13SQ;EAIQ,sBAAA;EAGJ,gFAAA;A1Ew3SZ;;A0E/3SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E63SZ;;A0Ep4SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1Ek4SZ;;A0Ez4SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1Eu4SZ;;A0E94SQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E44SZ;;A0En5SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Ei5SZ;;A0Ex5SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Es5SZ;;A0E75SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1E25SZ;;A0El6SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Eg6SZ;;A0Ev6SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1Eq6SZ;;A0E56SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1E06SZ;;A0Ej7SQ;EAIQ,sBAAA;EAGJ,0EAAA;A1E+6SZ;;A0Et7SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Eo7SZ;;A0E37SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Ey7SZ;;A0Eh8SQ;EAIQ,sBAAA;EAGJ,6EAAA;A1E87SZ;;A0Er8SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Em8SZ;;A0E18SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1Ew8SZ;;A0E/8SQ;EAIQ,sBAAA;EAGJ,4EAAA;A1E68SZ;;A0Ep9SQ;EAIQ,sBAAA;EAGJ,2EAAA;A1Ek9SZ;;A0Ez9SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Eu9SZ;;A0E99SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E49SZ;;A0En+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Ei+SZ;;A0Ex+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Es+SZ;;A0E7+SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E2+SZ;;A0El/SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Eg/SZ;;A0Ev/SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1Eq/SZ;;A0E5/SQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E0/SZ;;A0EjgTQ;EAIQ,sBAAA;EAGJ,+EAAA;A1E+/SZ;;A0EtgTQ;EAOI,wDAAA;A1EmgTZ;;A0E1gTQ;EAOI,0DAAA;A1EugTZ;;A0E9gTQ;EAOI,wDAAA;A1E2gTZ;;A0ElhTQ;EAOI,qDAAA;A1E+gTZ;;A0EthTQ;EAOI,wDAAA;A1EmhTZ;;A0E1hTQ;EAOI,uDAAA;A1EuhTZ;;A0E9hTQ;EAOI,sDAAA;A1E2hTZ;;A0EliTQ;EAOI,qDAAA;A1E+hTZ;;A0EtiTQ;EAOI,4BAAA;A1EmiTZ;;A0E1iTQ;EAOI,4BAAA;A1EuiTZ;;A0E9iTQ;EAOI,4BAAA;A1E2iTZ;;A0EljTQ;EAOI,4BAAA;A1E+iTZ;;A0EtjTQ;EAOI,4BAAA;A1EmjTZ;;A0EpkTQ;EACE,wBAAA;A1EukTV;;A0ExkTQ;EACE,yBAAA;A1E2kTV;;A0E5kTQ;EACE,wBAAA;A1E+kTV;;A0EhlTQ;EACE,yBAAA;A1EmlTV;;A0EplTQ;EACE,sBAAA;A1EulTV;;A0E9kTQ;EAOI,qBAAA;A1E2kTZ;;A0EllTQ;EAOI,qBAAA;A1E+kTZ;;A0EtlTQ;EAOI,qBAAA;A1EmlTZ;;A0E1lTQ;EAOI,sBAAA;A1EulTZ;;A0E9lTQ;EAOI,sBAAA;A1E2lTZ;;A0ElmTQ;EAOI,0BAAA;A1E+lTZ;;A0EtmTQ;EAOI,uBAAA;A1EmmTZ;;A0E1mTQ;EAOI,2BAAA;A1EumTZ;;A0E9mTQ;EAOI,sBAAA;A1E2mTZ;;A0ElnTQ;EAOI,sBAAA;A1E+mTZ;;A0EtnTQ;EAOI,sBAAA;A1EmnTZ;;A0E1nTQ;EAOI,uBAAA;A1EunTZ;;A0E9nTQ;EAOI,uBAAA;A1E2nTZ;;A0EloTQ;EAOI,2BAAA;A1E+nTZ;;A0EtoTQ;EAOI,wBAAA;A1EmoTZ;;A0E1oTQ;EAOI,4BAAA;A1EuoTZ;;A0E9oTQ;EAOI,yBAAA;A1E2oTZ;;A0ElpTQ;EAOI,8BAAA;A1E+oTZ;;A0EtpTQ;EAOI,iCAAA;A1EmpTZ;;A0E1pTQ;EAOI,sCAAA;A1EupTZ;;A0E9pTQ;EAOI,yCAAA;A1E2pTZ;;A0ElqTQ;EAOI,uBAAA;A1E+pTZ;;A0EtqTQ;EAOI,uBAAA;A1EmqTZ;;A0E1qTQ;EAOI,yBAAA;A1EuqTZ;;A0E9qTQ;EAOI,yBAAA;A1E2qTZ;;A0ElrTQ;EAOI,0BAAA;A1E+qTZ;;A0EtrTQ;EAOI,4BAAA;A1EmrTZ;;A0E1rTQ;EAOI,kCAAA;A1EurTZ;;A0E9rTQ;EAOI,sCAAA;A1E2rTZ;;A0ElsTQ;EAOI,oCAAA;A1E+rTZ;;A0EtsTQ;EAOI,kCAAA;A1EmsTZ;;A0E1sTQ;EAOI,yCAAA;A1EusTZ;;A0E9sTQ;EAOI,wCAAA;A1E2sTZ;;A0EltTQ;EAOI,wCAAA;A1E+sTZ;;A0EttTQ;EAOI,kCAAA;A1EmtTZ;;A0E1tTQ;EAOI,gCAAA;A1EutTZ;;A0E9tTQ;EAOI,8BAAA;A1E2tTZ;;A0EluTQ;EAOI,gCAAA;A1E+tTZ;;A0EtuTQ;EAOI,+BAAA;A1EmuTZ;;A0E1uTQ;EAOI,oCAAA;A1EuuTZ;;A0E9uTQ;EAOI,kCAAA;A1E2uTZ;;A0ElvTQ;EAOI,gCAAA;A1E+uTZ;;A0EtvTQ;EAOI,uCAAA;A1EmvTZ;;A0E1vTQ;EAOI,sCAAA;A1EuvTZ;;A0E9vTQ;EAOI,iCAAA;A1E2vTZ;;A0ElwTQ;EAOI,2BAAA;A1E+vTZ;;A0EtwTQ;EAOI,iCAAA;A1EmwTZ;;A0E1wTQ;EAOI,+BAAA;A1EuwTZ;;A0E9wTQ;EAOI,6BAAA;A1E2wTZ;;A0ElxTQ;EAOI,+BAAA;A1E+wTZ;;A0EtxTQ;EAOI,8BAAA;A1EmxTZ;;A0E1xTQ;EAOI,oBAAA;A1EuxTZ;;A0E9xTQ;EAOI,mBAAA;A1E2xTZ;;A0ElyTQ;EAOI,mBAAA;A1E+xTZ;;A0EtyTQ;EAOI,mBAAA;A1EmyTZ;;A0E1yTQ;EAOI,mBAAA;A1EuyTZ;;A0E9yTQ;EAOI,mBAAA;A1E2yTZ;;A0ElzTQ;EAOI,mBAAA;A1E+yTZ;;A0EtzTQ;EAOI,mBAAA;A1EmzTZ;;A0E1zTQ;EAOI,oBAAA;A1EuzTZ;;A0E9zTQ;EAOI,0BAAA;A1E2zTZ;;A0El0TQ;EAOI,yBAAA;A1E+zTZ;;A0Et0TQ;EAOI,uBAAA;A1Em0TZ;;A0E10TQ;EAOI,yBAAA;A1Eu0TZ;;A0E90TQ;EAOI,uBAAA;A1E20TZ;;A0El1TQ;EAOI,uBAAA;A1E+0TZ;;A0Et1TQ;EAOI,0BAAA;EAAA,yBAAA;A1Eo1TZ;;A0E31TQ;EAOI,gCAAA;EAAA,+BAAA;A1Ey1TZ;;A0Eh2TQ;EAOI,+BAAA;EAAA,8BAAA;A1E81TZ;;A0Er2TQ;EAOI,6BAAA;EAAA,4BAAA;A1Em2TZ;;A0E12TQ;EAOI,+BAAA;EAAA,8BAAA;A1Ew2TZ;;A0E/2TQ;EAOI,6BAAA;EAAA,4BAAA;A1E62TZ;;A0Ep3TQ;EAOI,6BAAA;EAAA,4BAAA;A1Ek3TZ;;A0Ez3TQ;EAOI,wBAAA;EAAA,2BAAA;A1Eu3TZ;;A0E93TQ;EAOI,8BAAA;EAAA,iCAAA;A1E43TZ;;A0En4TQ;EAOI,6BAAA;EAAA,gCAAA;A1Ei4TZ;;A0Ex4TQ;EAOI,2BAAA;EAAA,8BAAA;A1Es4TZ;;A0E74TQ;EAOI,6BAAA;EAAA,gCAAA;A1E24TZ;;A0El5TQ;EAOI,2BAAA;EAAA,8BAAA;A1Eg5TZ;;A0Ev5TQ;EAOI,2BAAA;EAAA,8BAAA;A1Eq5TZ;;A0E55TQ;EAOI,wBAAA;A1Ey5TZ;;A0Eh6TQ;EAOI,8BAAA;A1E65TZ;;A0Ep6TQ;EAOI,6BAAA;A1Ei6TZ;;A0Ex6TQ;EAOI,2BAAA;A1Eq6TZ;;A0E56TQ;EAOI,6BAAA;A1Ey6TZ;;A0Eh7TQ;EAOI,2BAAA;A1E66TZ;;A0Ep7TQ;EAOI,2BAAA;A1Ei7TZ;;A0Ex7TQ;EAOI,0BAAA;A1Eq7TZ;;A0E57TQ;EAOI,gCAAA;A1Ey7TZ;;A0Eh8TQ;EAOI,+BAAA;A1E67TZ;;A0Ep8TQ;EAOI,6BAAA;A1Ei8TZ;;A0Ex8TQ;EAOI,+BAAA;A1Eq8TZ;;A0E58TQ;EAOI,6BAAA;A1Ey8TZ;;A0Eh9TQ;EAOI,6BAAA;A1E68TZ;;A0Ep9TQ;EAOI,2BAAA;A1Ei9TZ;;A0Ex9TQ;EAOI,iCAAA;A1Eq9TZ;;A0E59TQ;EAOI,gCAAA;A1Ey9TZ;;A0Eh+TQ;EAOI,8BAAA;A1E69TZ;;A0Ep+TQ;EAOI,gCAAA;A1Ei+TZ;;A0Ex+TQ;EAOI,8BAAA;A1Eq+TZ;;A0E5+TQ;EAOI,8BAAA;A1Ey+TZ;;A0Eh/TQ;EAOI,yBAAA;A1E6+TZ;;A0Ep/TQ;EAOI,+BAAA;A1Ei/TZ;;A0Ex/TQ;EAOI,8BAAA;A1Eq/TZ;;A0E5/TQ;EAOI,4BAAA;A1Ey/TZ;;A0EhgUQ;EAOI,8BAAA;A1E6/TZ;;A0EpgUQ;EAOI,4BAAA;A1EigUZ;;A0ExgUQ;EAOI,4BAAA;A1EqgUZ;;A0E5gUQ;EAOI,2BAAA;A1EygUZ;;A0EhhUQ;EAOI,0BAAA;A1E6gUZ;;A0EphUQ;EAOI,wBAAA;A1EihUZ;;A0ExhUQ;EAOI,0BAAA;A1EqhUZ;;A0E5hUQ;EAOI,wBAAA;A1EyhUZ;;A0EhiUQ;EAOI,iCAAA;EAAA,gCAAA;A1E8hUZ;;A0EriUQ;EAOI,gCAAA;EAAA,+BAAA;A1EmiUZ;;A0E1iUQ;EAOI,8BAAA;EAAA,6BAAA;A1EwiUZ;;A0E/iUQ;EAOI,gCAAA;EAAA,+BAAA;A1E6iUZ;;A0EpjUQ;EAOI,8BAAA;EAAA,6BAAA;A1EkjUZ;;A0EzjUQ;EAOI,+BAAA;EAAA,kCAAA;A1EujUZ;;A0E9jUQ;EAOI,8BAAA;EAAA,iCAAA;A1E4jUZ;;A0EnkUQ;EAOI,4BAAA;EAAA,+BAAA;A1EikUZ;;A0ExkUQ;EAOI,8BAAA;EAAA,iCAAA;A1EskUZ;;A0E7kUQ;EAOI,4BAAA;EAAA,+BAAA;A1E2kUZ;;A0EllUQ;EAOI,+BAAA;A1E+kUZ;;A0EtlUQ;EAOI,8BAAA;A1EmlUZ;;A0E1lUQ;EAOI,4BAAA;A1EulUZ;;A0E9lUQ;EAOI,8BAAA;A1E2lUZ;;A0ElmUQ;EAOI,4BAAA;A1E+lUZ;;A0EtmUQ;EAOI,iCAAA;A1EmmUZ;;A0E1mUQ;EAOI,gCAAA;A1EumUZ;;A0E9mUQ;EAOI,8BAAA;A1E2mUZ;;A0ElnUQ;EAOI,gCAAA;A1E+mUZ;;A0EtnUQ;EAOI,8BAAA;A1EmnUZ;;A0E1nUQ;EAOI,kCAAA;A1EunUZ;;A0E9nUQ;EAOI,iCAAA;A1E2nUZ;;A0EloUQ;EAOI,+BAAA;A1E+nUZ;;A0EtoUQ;EAOI,iCAAA;A1EmoUZ;;A0E1oUQ;EAOI,+BAAA;A1EuoUZ;;A0E9oUQ;EAOI,gCAAA;A1E2oUZ;;A0ElpUQ;EAOI,+BAAA;A1E+oUZ;;A0EtpUQ;EAOI,6BAAA;A1EmpUZ;;A0E1pUQ;EAOI,+BAAA;A1EupUZ;;A0E9pUQ;EAOI,6BAAA;A1E2pUZ;;A0ElqUQ;EAOI,qBAAA;A1E+pUZ;;A0EtqUQ;EAOI,2BAAA;A1EmqUZ;;A0E1qUQ;EAOI,0BAAA;A1EuqUZ;;A0E9qUQ;EAOI,wBAAA;A1E2qUZ;;A0ElrUQ;EAOI,0BAAA;A1E+qUZ;;A0EtrUQ;EAOI,wBAAA;A1EmrUZ;;A0E1rUQ;EAOI,2BAAA;EAAA,0BAAA;A1EwrUZ;;A0E/rUQ;EAOI,iCAAA;EAAA,gCAAA;A1E6rUZ;;A0EpsUQ;EAOI,gCAAA;EAAA,+BAAA;A1EksUZ;;A0EzsUQ;EAOI,8BAAA;EAAA,6BAAA;A1EusUZ;;A0E9sUQ;EAOI,gCAAA;EAAA,+BAAA;A1E4sUZ;;A0EntUQ;EAOI,8BAAA;EAAA,6BAAA;A1EitUZ;;A0ExtUQ;EAOI,yBAAA;EAAA,4BAAA;A1EstUZ;;A0E7tUQ;EAOI,+BAAA;EAAA,kCAAA;A1E2tUZ;;A0EluUQ;EAOI,8BAAA;EAAA,iCAAA;A1EguUZ;;A0EvuUQ;EAOI,4BAAA;EAAA,+BAAA;A1EquUZ;;A0E5uUQ;EAOI,8BAAA;EAAA,iCAAA;A1E0uUZ;;A0EjvUQ;EAOI,4BAAA;EAAA,+BAAA;A1E+uUZ;;A0EtvUQ;EAOI,yBAAA;A1EmvUZ;;A0E1vUQ;EAOI,+BAAA;A1EuvUZ;;A0E9vUQ;EAOI,8BAAA;A1E2vUZ;;A0ElwUQ;EAOI,4BAAA;A1E+vUZ;;A0EtwUQ;EAOI,8BAAA;A1EmwUZ;;A0E1wUQ;EAOI,4BAAA;A1EuwUZ;;A0E9wUQ;EAOI,2BAAA;A1E2wUZ;;A0ElxUQ;EAOI,iCAAA;A1E+wUZ;;A0EtxUQ;EAOI,gCAAA;A1EmxUZ;;A0E1xUQ;EAOI,8BAAA;A1EuxUZ;;A0E9xUQ;EAOI,gCAAA;A1E2xUZ;;A0ElyUQ;EAOI,8BAAA;A1E+xUZ;;A0EtyUQ;EAOI,4BAAA;A1EmyUZ;;A0E1yUQ;EAOI,kCAAA;A1EuyUZ;;A0E9yUQ;EAOI,iCAAA;A1E2yUZ;;A0ElzUQ;EAOI,+BAAA;A1E+yUZ;;A0EtzUQ;EAOI,iCAAA;A1EmzUZ;;A0E1zUQ;EAOI,+BAAA;A1EuzUZ;;A0E9zUQ;EAOI,0BAAA;A1E2zUZ;;A0El0UQ;EAOI,gCAAA;A1E+zUZ;;A0Et0UQ;EAOI,+BAAA;A1Em0UZ;;A0E10UQ;EAOI,6BAAA;A1Eu0UZ;;A0E90UQ;EAOI,+BAAA;A1E20UZ;;A0El1UQ;EAOI,6BAAA;A1E+0UZ;;A0Et1UQ;EAOI,iBAAA;A1Em1UZ;;A0E11UQ;EAOI,uBAAA;A1Eu1UZ;;A0E91UQ;EAOI,sBAAA;A1E21UZ;;A0El2UQ;EAOI,oBAAA;A1E+1UZ;;A0Et2UQ;EAOI,sBAAA;A1Em2UZ;;A0E12UQ;EAOI,oBAAA;A1Eu2UZ;;A0E92UQ;EAOI,qBAAA;A1E22UZ;;A0El3UQ;EAOI,2BAAA;A1E+2UZ;;A0Et3UQ;EAOI,0BAAA;A1Em3UZ;;A0E13UQ;EAOI,wBAAA;A1Eu3UZ;;A0E93UQ;EAOI,0BAAA;A1E23UZ;;A0El4UQ;EAOI,wBAAA;A1E+3UZ;;A0Et4UQ;EAOI,wBAAA;A1Em4UZ;;A0E14UQ;EAOI,8BAAA;A1Eu4UZ;;A0E94UQ;EAOI,6BAAA;A1E24UZ;;A0El5UQ;EAOI,2BAAA;A1E+4UZ;;A0Et5UQ;EAOI,6BAAA;A1Em5UZ;;A0E15UQ;EAOI,2BAAA;A1Eu5UZ;;A0E95UQ;EAOI,gDAAA;A1E25UZ;;A0El6UQ;EAOI,gDAAA;A1E+5UZ;;A0Et6UQ;EAOI,0CAAA;A1Em6UZ;;A0E16UQ;EAOI,kDAAA;A1Eu6UZ;;A0E96UQ;EAOI,gDAAA;A1E26UZ;;A0El7UQ;EAOI,gCAAA;A1E+6UZ;;A0Et7UQ;EAOI,8BAAA;A1Em7UZ;;A0E17UQ;EAOI,6BAAA;A1Eu7UZ;;A0E97UQ;EAOI,6BAAA;A1E27UZ;;A0El8UQ;EAOI,+BAAA;A1E+7UZ;;A0Et8UQ;EAOI,2BAAA;A1Em8UZ;;A0E18UQ;EAOI,2BAAA;A1Eu8UZ;;A0E98UQ;EAOI,2BAAA;A1E28UZ;;A0El9UQ;EAOI,2BAAA;A1E+8UZ;;A0Et9UQ;EAOI,2BAAA;A1Em9UZ;;A0E19UQ;EAOI,8BAAA;A1Eu9UZ;;A0E99UQ;EAOI,yBAAA;A1E29UZ;;A0El+UQ;EAOI,4BAAA;A1E+9UZ;;A0Et+UQ;EAOI,2BAAA;A1Em+UZ;;A0E1+UQ;EAOI,yBAAA;A1Eu+UZ;;A0E9+UQ;EAOI,2BAAA;A1E2+UZ;;A0El/UQ;EAOI,4BAAA;A1E++UZ;;A0Et/UQ;EAOI,6BAAA;A1Em/UZ;;A0E1/UQ;EAOI,gCAAA;A1Eu/UZ;;A0E9/UQ;EAOI,qCAAA;A1E2/UZ;;A0ElgVQ;EAOI,wCAAA;A1E+/UZ;;A0EtgVQ;EAOI,oCAAA;A1EmgVZ;;A0E1gVQ;EAOI,oCAAA;A1EugVZ;;A0E9gVQ;EAOI,qCAAA;A1E2gVZ;;A0ElhVQ;EAOI,8BAAA;A1E+gVZ;;A0EthVQ;EAOI,8BAAA;A1EmhVZ;;A0ExiVQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A1EyhVZ;;A0EtgVQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A1E+hVZ;;A0EtiVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EoiVZ;;A0E3iVQ;EAIQ,oBAAA;EAGJ,yEAAA;A1EyiVZ;;A0EhjVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E8iVZ;;A0ErjVQ;EAIQ,oBAAA;EAGJ,uEAAA;A1EmjVZ;;A0E1jVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EwjVZ;;A0E/jVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1E6jVZ;;A0EpkVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EkkVZ;;A0EzkVQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EukVZ;;A0E9kVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1E4kVZ;;A0EnlVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EilVZ;;A0ExlVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EslVZ;;A0E7lVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E2lVZ;;A0ElmVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EgmVZ;;A0EvmVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EqmVZ;;A0E5mVQ;EAIQ,oBAAA;EAGJ,iEAAA;A1E0mVZ;;A0EjnVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1E+mVZ;;A0EtnVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EonVZ;;A0E3nVQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EynVZ;;A0EhoVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1E8nVZ;;A0EroVQ;EAIQ,oBAAA;EAGJ,2CAAA;A1EmoVZ;;A0E1oVQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EwoVZ;;A0E/oVQ;EAIQ,oBAAA;EAGJ,kEAAA;A1E6oVZ;;A0EppVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EkpVZ;;A0EzpVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EupVZ;;A0E9pVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1E4pVZ;;A0EnqVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EiqVZ;;A0ExqVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EsqVZ;;A0E7qVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1E2qVZ;;A0ElrVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EgrVZ;;A0EvrVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1EqrVZ;;A0E5rVQ;EAIQ,oBAAA;EAGJ,sEAAA;A1E0rVZ;;A0EjsVQ;EAIQ,oBAAA;EAGJ,wEAAA;A1E+rVZ;;A0EtsVQ;EAIQ,oBAAA;EAGJ,oCAAA;A1EosVZ;;A0E3sVQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EysVZ;;A0EhtVQ;EAIQ,oBAAA;EAGJ,2CAAA;A1E8sVZ;;A0ErtVQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EmtVZ;;A0E1tVQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EwtVZ;;A0E/tVQ;EAIQ,oBAAA;EAGJ,yBAAA;A1E6tVZ;;A0E9uVQ;EACE,uBAAA;A1EivVV;;A0ElvVQ;EACE,sBAAA;A1EqvVV;;A0EtvVQ;EACE,uBAAA;A1EyvVV;;A0E1vVQ;EACE,oBAAA;A1E6vVV;;A0EpvVQ;EAOI,iDAAA;A1EivVZ;;A0ExvVQ;EAOI,mDAAA;A1EqvVZ;;A0E5vVQ;EAOI,iDAAA;A1EyvVZ;;A0EhwVQ;EAOI,8CAAA;A1E6vVZ;;A0EpwVQ;EAOI,iDAAA;A1EiwVZ;;A0ExwVQ;EAOI,gDAAA;A1EqwVZ;;A0E5wVQ;EAOI,+CAAA;A1EywVZ;;A0EhxVQ;EAOI,8CAAA;A1E6wVZ;;A0E9xVQ;EACE,sBAAA;A1EiyVV;;A0E7xVU;EACE,sBAAA;A1EgyVZ;;A0EtyVQ;EACE,uBAAA;A1EyyVV;;A0EryVU;EACE,uBAAA;A1EwyVZ;;A0E9yVQ;EACE,sBAAA;A1EizVV;;A0E7yVU;EACE,sBAAA;A1EgzVZ;;A0EtzVQ;EACE,uBAAA;A1EyzVV;;A0ErzVU;EACE,uBAAA;A1EwzVZ;;A0E9zVQ;EACE,oBAAA;A1Ei0VV;;A0E7zVU;EACE,oBAAA;A1Eg0VZ;;A0E5zVQ;EAOI,yCAAA;A1EyzVZ;;A0EpzVU;EAOI,yCAAA;A1EizVd;;A0Ep0VQ;EAOI,wCAAA;A1Ei0VZ;;A0E5zVU;EAOI,wCAAA;A1EyzVd;;A0E50VQ;EAOI,yCAAA;A1Ey0VZ;;A0Ep0VU;EAOI,yCAAA;A1Ei0Vd;;A0Ep1VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ek1VZ;;A0Ez1VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Eu1VZ;;A0E91VQ;EAIQ,8BAAA;EAGJ,mGAAA;A1E41VZ;;A0En2VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ei2VZ;;A0Ex2VQ;EAIQ,8BAAA;EAGJ,iGAAA;A1Es2VZ;;A0E72VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1E22VZ;;A0El3VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1Eg3VZ;;A0Ev3VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Eq3VZ;;A0E53VQ;EAIQ,8BAAA;EAGJ,+FAAA;A1E03VZ;;A0Ej4VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1E+3VZ;;A0Et4VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Eo4VZ;;A0E34VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Ey4VZ;;A0Eh5VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E84VZ;;A0Er5VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1Em5VZ;;A0E15VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1Ew5VZ;;A0E/5VQ;EAIQ,8BAAA;EAGJ,2FAAA;A1E65VZ;;A0Ep6VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Ek6VZ;;A0Ez6VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Eu6VZ;;A0E96VQ;EAIQ,8BAAA;EAGJ,8FAAA;A1E46VZ;;A0En7VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Ei7VZ;;A0Ex7VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1Es7VZ;;A0E77VQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E27VZ;;A0El8VQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Eg8VZ;;A0Ev8VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Eq8VZ;;A0E58VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E08VZ;;A0Ej9VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E+8VZ;;A0Et9VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Eo9VZ;;A0E39VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Ey9VZ;;A0Eh+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E89VZ;;A0Er+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Em+VZ;;A0E1+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1Ew+VZ;;A0E/+VQ;EAIQ,8BAAA;EAGJ,gGAAA;A1E6+VZ;;A0Ep/VQ;EAIQ,8BAAA;EAGJ,qGAAA;A1Ek/VZ;;A0EngWQ;EACE,8BAAA;A1EsgWV;;A0ElgWU;EACE,8BAAA;A1EqgWZ;;A0E3gWQ;EACE,gCAAA;A1E8gWV;;A0E1gWU;EACE,gCAAA;A1E6gWZ;;A0EnhWQ;EACE,iCAAA;A1EshWV;;A0ElhWU;EACE,iCAAA;A1EqhWZ;;A0E3hWQ;EACE,gCAAA;A1E8hWV;;A0E1hWU;EACE,gCAAA;A1E6hWZ;;A0EniWQ;EACE,iCAAA;A1EsiWV;;A0EliWU;EACE,iCAAA;A1EqiWZ;;A0E3iWQ;EACE,8BAAA;A1E8iWV;;A0E1iWU;EACE,8BAAA;A1E6iWZ;;A0EziWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EuiWZ;;A0E9iWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E4iWZ;;A0EnjWQ;EAIQ,kBAAA;EAGJ,kFAAA;A1EijWZ;;A0ExjWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EsjWZ;;A0E7jWQ;EAIQ,kBAAA;EAGJ,gFAAA;A1E2jWZ;;A0ElkWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EgkWZ;;A0EvkWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EqkWZ;;A0E5kWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E0kWZ;;A0EjlWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E+kWZ;;A0EtlWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EolWZ;;A0E3lWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EylWZ;;A0EhmWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E8lWZ;;A0ErmWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EmmWZ;;A0E1mWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EwmWZ;;A0E/mWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1E6mWZ;;A0EpnWQ;EAIQ,kBAAA;EAGJ,0EAAA;A1EknWZ;;A0EznWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EunWZ;;A0E9nWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E4nWZ;;A0EnoWQ;EAIQ,kBAAA;EAGJ,6EAAA;A1EioWZ;;A0ExoWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EsoWZ;;A0E7oWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E2oWZ;;A0ElpWQ;EAIQ,kBAAA;EAGJ,4EAAA;A1EgpWZ;;A0EvpWQ;EAIQ,kBAAA;EAGJ,2EAAA;A1EqpWZ;;A0E5pWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E0pWZ;;A0EjqWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E+pWZ;;A0EtqWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EoqWZ;;A0E3qWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EyqWZ;;A0EhrWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E8qWZ;;A0ErrWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EmrWZ;;A0E1rWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EwrWZ;;A0E/rWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1E6rWZ;;A0EpsWQ;EAIQ,kBAAA;EAGJ,+EAAA;A1EksWZ;;A0EzsWQ;EAIQ,kBAAA;EAGJ,8EAAA;A1EusWZ;;A0E9sWQ;EAIQ,kBAAA;EAGJ,wCAAA;A1E4sWZ;;A0EntWQ;EAIQ,kBAAA;EAGJ,mFAAA;A1EitWZ;;A0ExtWQ;EAIQ,kBAAA;EAGJ,kFAAA;A1EstWZ;;A0EvuWQ;EACE,oBAAA;A1E0uWV;;A0E3uWQ;EACE,qBAAA;A1E8uWV;;A0E/uWQ;EACE,oBAAA;A1EkvWV;;A0EnvWQ;EACE,qBAAA;A1EsvWV;;A0EvvWQ;EACE,kBAAA;A1E0vWV;;A0EjvWQ;EAOI,wDAAA;A1E8uWZ;;A0ErvWQ;EAOI,0DAAA;A1EkvWZ;;A0EzvWQ;EAOI,wDAAA;A1EsvWZ;;A0E7vWQ;EAOI,qDAAA;A1E0vWZ;;A0EjwWQ;EAOI,wDAAA;A1E8vWZ;;A0ErwWQ;EAOI,uDAAA;A1EkwWZ;;A0EzwWQ;EAOI,sDAAA;A1EswWZ;;A0E7wWQ;EAOI,qDAAA;A1E0wWZ;;A0EjxWQ;EAOI,+CAAA;A1E8wWZ;;A0ErxWQ;EAOI,mCAAA;UAAA,2BAAA;A1EkxWZ;;A0EzxWQ;EAOI,oCAAA;UAAA,4BAAA;A1EsxWZ;;A0E7xWQ;EAOI,oCAAA;UAAA,4BAAA;A1E0xWZ;;A0EjyWQ;EAOI,+BAAA;A1E8xWZ;;A0EryWQ;EAOI,+BAAA;A1EkyWZ;;A0EzyWQ;EAOI,iDAAA;A1EsyWZ;;A0E7yWQ;EAOI,2BAAA;A1E0yWZ;;A0EjzWQ;EAOI,oDAAA;A1E8yWZ;;A0ErzWQ;EAOI,iDAAA;A1EkzWZ;;A0EzzWQ;EAOI,oDAAA;A1EszWZ;;A0E7zWQ;EAOI,oDAAA;A1E0zWZ;;A0Ej0WQ;EAOI,qDAAA;A1E8zWZ;;A0Er0WQ;EAOI,6BAAA;A1Ek0WZ;;A0Ez0WQ;EAOI,sDAAA;A1Es0WZ;;A0E70WQ;EAOI,0DAAA;EAAA,2DAAA;A1E20WZ;;A0El1WQ;EAOI,oCAAA;EAAA,qCAAA;A1Eg1WZ;;A0Ev1WQ;EAOI,6DAAA;EAAA,8DAAA;A1Eq1WZ;;A0E51WQ;EAOI,0DAAA;EAAA,2DAAA;A1E01WZ;;A0Ej2WQ;EAOI,6DAAA;EAAA,8DAAA;A1E+1WZ;;A0Et2WQ;EAOI,6DAAA;EAAA,8DAAA;A1Eo2WZ;;A0E32WQ;EAOI,8DAAA;EAAA,+DAAA;A1Ey2WZ;;A0Eh3WQ;EAOI,sCAAA;EAAA,uCAAA;A1E82WZ;;A0Er3WQ;EAOI,+DAAA;EAAA,gEAAA;A1Em3WZ;;A0E13WQ;EAOI,2DAAA;EAAA,8DAAA;A1Ew3WZ;;A0E/3WQ;EAOI,qCAAA;EAAA,wCAAA;A1E63WZ;;A0Ep4WQ;EAOI,8DAAA;EAAA,iEAAA;A1Ek4WZ;;A0Ez4WQ;EAOI,2DAAA;EAAA,8DAAA;A1Eu4WZ;;A0E94WQ;EAOI,8DAAA;EAAA,iEAAA;A1E44WZ;;A0En5WQ;EAOI,8DAAA;EAAA,iEAAA;A1Ei5WZ;;A0Ex5WQ;EAOI,+DAAA;EAAA,kEAAA;A1Es5WZ;;A0E75WQ;EAOI,uCAAA;EAAA,0CAAA;A1E25WZ;;A0El6WQ;EAOI,gEAAA;EAAA,mEAAA;A1Eg6WZ;;A0Ev6WQ;EAOI,8DAAA;EAAA,6DAAA;A1Eq6WZ;;A0E56WQ;EAOI,wCAAA;EAAA,uCAAA;A1E06WZ;;A0Ej7WQ;EAOI,iEAAA;EAAA,gEAAA;A1E+6WZ;;A0Et7WQ;EAOI,8DAAA;EAAA,6DAAA;A1Eo7WZ;;A0E37WQ;EAOI,iEAAA;EAAA,gEAAA;A1Ey7WZ;;A0Eh8WQ;EAOI,iEAAA;EAAA,gEAAA;A1E87WZ;;A0Er8WQ;EAOI,kEAAA;EAAA,iEAAA;A1Em8WZ;;A0E18WQ;EAOI,0CAAA;EAAA,yCAAA;A1Ew8WZ;;A0E/8WQ;EAOI,mEAAA;EAAA,kEAAA;A1E68WZ;;A0Ep9WQ;EAOI,6DAAA;EAAA,0DAAA;A1Ek9WZ;;A0Ez9WQ;EAOI,uCAAA;EAAA,oCAAA;A1Eu9WZ;;A0E99WQ;EAOI,gEAAA;EAAA,6DAAA;A1E49WZ;;A0En+WQ;EAOI,6DAAA;EAAA,0DAAA;A1Ei+WZ;;A0Ex+WQ;EAOI,gEAAA;EAAA,6DAAA;A1Es+WZ;;A0E7+WQ;EAOI,gEAAA;EAAA,6DAAA;A1E2+WZ;;A0El/WQ;EAOI,iEAAA;EAAA,8DAAA;A1Eg/WZ;;A0Ev/WQ;EAOI,yCAAA;EAAA,sCAAA;A1Eq/WZ;;A0E5/WQ;EAOI,kEAAA;EAAA,+DAAA;A1E0/WZ;;A0EjgXQ;EAOI,8BAAA;A1E8/WZ;;A0ErgXQ;EAOI,6BAAA;A1EkgXZ;;A0EzgXQ;EAOI,sBAAA;A1EsgXZ;;A0E7gXQ;EAOI,qBAAA;A1E0gXZ;;A0EjhXQ;EAOI,qBAAA;A1E8gXZ;;A0ErhXQ;EAOI,qBAAA;A1EkhXZ;;A0EzhXQ;EAOI,qBAAA;A1EshXZ;;AgBhiXI;E0DGI;IAOI,sBAAA;E1E2hXV;E0EliXM;IAOI,uBAAA;E1E8hXV;E0EriXM;IAOI,sBAAA;E1EiiXV;E0ExiXM;IAOI,8BAAA;E1EoiXV;E0E3iXM;IAOI,4BAAA;E1EuiXV;E0E9iXM;IAOI,2BAAA;E1E0iXV;E0EjjXM;IAOI,iCAAA;E1E6iXV;E0EpjXM;IAOI,2BAAA;E1EgjXV;E0EvjXM;IAOI,0BAAA;E1EmjXV;E0E1jXM;IAOI,gCAAA;E1EsjXV;E0E7jXM;IAOI,yBAAA;E1EyjXV;E0EhkXM;IAOI,wBAAA;E1E4jXV;E0EnkXM;IAOI,+BAAA;E1E+jXV;E0EtkXM;IAOI,yBAAA;E1EkkXV;E0EzkXM;IAOI,6BAAA;E1EqkXV;E0E5kXM;IAOI,8BAAA;E1EwkXV;E0E/kXM;IAOI,wBAAA;E1E2kXV;E0EllXM;IAOI,+BAAA;E1E8kXV;E0ErlXM;IAOI,wBAAA;E1EilXV;E0ExlXM;IAOI,yBAAA;E1EolXV;E0E3lXM;IAOI,8BAAA;E1EulXV;E0E9lXM;IAOI,iCAAA;E1E0lXV;E0EjmXM;IAOI,sCAAA;E1E6lXV;E0EpmXM;IAOI,yCAAA;E1EgmXV;E0EvmXM;IAOI,uBAAA;E1EmmXV;E0E1mXM;IAOI,uBAAA;E1EsmXV;E0E7mXM;IAOI,yBAAA;E1EymXV;E0EhnXM;IAOI,yBAAA;E1E4mXV;E0EnnXM;IAOI,0BAAA;E1E+mXV;E0EtnXM;IAOI,4BAAA;E1EknXV;E0EznXM;IAOI,kCAAA;E1EqnXV;E0E5nXM;IAOI,sCAAA;E1EwnXV;E0E/nXM;IAOI,oCAAA;E1E2nXV;E0EloXM;IAOI,kCAAA;E1E8nXV;E0EroXM;IAOI,yCAAA;E1EioXV;E0ExoXM;IAOI,wCAAA;E1EooXV;E0E3oXM;IAOI,wCAAA;E1EuoXV;E0E9oXM;IAOI,kCAAA;E1E0oXV;E0EjpXM;IAOI,gCAAA;E1E6oXV;E0EppXM;IAOI,8BAAA;E1EgpXV;E0EvpXM;IAOI,gCAAA;E1EmpXV;E0E1pXM;IAOI,+BAAA;E1EspXV;E0E7pXM;IAOI,oCAAA;E1EypXV;E0EhqXM;IAOI,kCAAA;E1E4pXV;E0EnqXM;IAOI,gCAAA;E1E+pXV;E0EtqXM;IAOI,uCAAA;E1EkqXV;E0EzqXM;IAOI,sCAAA;E1EqqXV;E0E5qXM;IAOI,iCAAA;E1EwqXV;E0E/qXM;IAOI,2BAAA;E1E2qXV;E0ElrXM;IAOI,iCAAA;E1E8qXV;E0ErrXM;IAOI,+BAAA;E1EirXV;E0ExrXM;IAOI,6BAAA;E1EorXV;E0E3rXM;IAOI,+BAAA;E1EurXV;E0E9rXM;IAOI,8BAAA;E1E0rXV;E0EjsXM;IAOI,oBAAA;E1E6rXV;E0EpsXM;IAOI,mBAAA;E1EgsXV;E0EvsXM;IAOI,mBAAA;E1EmsXV;E0E1sXM;IAOI,mBAAA;E1EssXV;E0E7sXM;IAOI,mBAAA;E1EysXV;E0EhtXM;IAOI,mBAAA;E1E4sXV;E0EntXM;IAOI,mBAAA;E1E+sXV;E0EttXM;IAOI,mBAAA;E1EktXV;E0EztXM;IAOI,oBAAA;E1EqtXV;E0E5tXM;IAOI,0BAAA;E1EwtXV;E0E/tXM;IAOI,yBAAA;E1E2tXV;E0EluXM;IAOI,uBAAA;E1E8tXV;E0EruXM;IAOI,yBAAA;E1EiuXV;E0ExuXM;IAOI,uBAAA;E1EouXV;E0E3uXM;IAOI,uBAAA;E1EuuXV;E0E9uXM;IAOI,0BAAA;IAAA,yBAAA;E1E2uXV;E0ElvXM;IAOI,gCAAA;IAAA,+BAAA;E1E+uXV;E0EtvXM;IAOI,+BAAA;IAAA,8BAAA;E1EmvXV;E0E1vXM;IAOI,6BAAA;IAAA,4BAAA;E1EuvXV;E0E9vXM;IAOI,+BAAA;IAAA,8BAAA;E1E2vXV;E0ElwXM;IAOI,6BAAA;IAAA,4BAAA;E1E+vXV;E0EtwXM;IAOI,6BAAA;IAAA,4BAAA;E1EmwXV;E0E1wXM;IAOI,wBAAA;IAAA,2BAAA;E1EuwXV;E0E9wXM;IAOI,8BAAA;IAAA,iCAAA;E1E2wXV;E0ElxXM;IAOI,6BAAA;IAAA,gCAAA;E1E+wXV;E0EtxXM;IAOI,2BAAA;IAAA,8BAAA;E1EmxXV;E0E1xXM;IAOI,6BAAA;IAAA,gCAAA;E1EuxXV;E0E9xXM;IAOI,2BAAA;IAAA,8BAAA;E1E2xXV;E0ElyXM;IAOI,2BAAA;IAAA,8BAAA;E1E+xXV;E0EtyXM;IAOI,wBAAA;E1EkyXV;E0EzyXM;IAOI,8BAAA;E1EqyXV;E0E5yXM;IAOI,6BAAA;E1EwyXV;E0E/yXM;IAOI,2BAAA;E1E2yXV;E0ElzXM;IAOI,6BAAA;E1E8yXV;E0ErzXM;IAOI,2BAAA;E1EizXV;E0ExzXM;IAOI,2BAAA;E1EozXV;E0E3zXM;IAOI,0BAAA;E1EuzXV;E0E9zXM;IAOI,gCAAA;E1E0zXV;E0Ej0XM;IAOI,+BAAA;E1E6zXV;E0Ep0XM;IAOI,6BAAA;E1Eg0XV;E0Ev0XM;IAOI,+BAAA;E1Em0XV;E0E10XM;IAOI,6BAAA;E1Es0XV;E0E70XM;IAOI,6BAAA;E1Ey0XV;E0Eh1XM;IAOI,2BAAA;E1E40XV;E0En1XM;IAOI,iCAAA;E1E+0XV;E0Et1XM;IAOI,gCAAA;E1Ek1XV;E0Ez1XM;IAOI,8BAAA;E1Eq1XV;E0E51XM;IAOI,gCAAA;E1Ew1XV;E0E/1XM;IAOI,8BAAA;E1E21XV;E0El2XM;IAOI,8BAAA;E1E81XV;E0Er2XM;IAOI,yBAAA;E1Ei2XV;E0Ex2XM;IAOI,+BAAA;E1Eo2XV;E0E32XM;IAOI,8BAAA;E1Eu2XV;E0E92XM;IAOI,4BAAA;E1E02XV;E0Ej3XM;IAOI,8BAAA;E1E62XV;E0Ep3XM;IAOI,4BAAA;E1Eg3XV;E0Ev3XM;IAOI,4BAAA;E1Em3XV;E0E13XM;IAOI,2BAAA;E1Es3XV;E0E73XM;IAOI,0BAAA;E1Ey3XV;E0Eh4XM;IAOI,wBAAA;E1E43XV;E0En4XM;IAOI,0BAAA;E1E+3XV;E0Et4XM;IAOI,wBAAA;E1Ek4XV;E0Ez4XM;IAOI,iCAAA;IAAA,gCAAA;E1Es4XV;E0E74XM;IAOI,gCAAA;IAAA,+BAAA;E1E04XV;E0Ej5XM;IAOI,8BAAA;IAAA,6BAAA;E1E84XV;E0Er5XM;IAOI,gCAAA;IAAA,+BAAA;E1Ek5XV;E0Ez5XM;IAOI,8BAAA;IAAA,6BAAA;E1Es5XV;E0E75XM;IAOI,+BAAA;IAAA,kCAAA;E1E05XV;E0Ej6XM;IAOI,8BAAA;IAAA,iCAAA;E1E85XV;E0Er6XM;IAOI,4BAAA;IAAA,+BAAA;E1Ek6XV;E0Ez6XM;IAOI,8BAAA;IAAA,iCAAA;E1Es6XV;E0E76XM;IAOI,4BAAA;IAAA,+BAAA;E1E06XV;E0Ej7XM;IAOI,+BAAA;E1E66XV;E0Ep7XM;IAOI,8BAAA;E1Eg7XV;E0Ev7XM;IAOI,4BAAA;E1Em7XV;E0E17XM;IAOI,8BAAA;E1Es7XV;E0E77XM;IAOI,4BAAA;E1Ey7XV;E0Eh8XM;IAOI,iCAAA;E1E47XV;E0En8XM;IAOI,gCAAA;E1E+7XV;E0Et8XM;IAOI,8BAAA;E1Ek8XV;E0Ez8XM;IAOI,gCAAA;E1Eq8XV;E0E58XM;IAOI,8BAAA;E1Ew8XV;E0E/8XM;IAOI,kCAAA;E1E28XV;E0El9XM;IAOI,iCAAA;E1E88XV;E0Er9XM;IAOI,+BAAA;E1Ei9XV;E0Ex9XM;IAOI,iCAAA;E1Eo9XV;E0E39XM;IAOI,+BAAA;E1Eu9XV;E0E99XM;IAOI,gCAAA;E1E09XV;E0Ej+XM;IAOI,+BAAA;E1E69XV;E0Ep+XM;IAOI,6BAAA;E1Eg+XV;E0Ev+XM;IAOI,+BAAA;E1Em+XV;E0E1+XM;IAOI,6BAAA;E1Es+XV;E0E7+XM;IAOI,qBAAA;E1Ey+XV;E0Eh/XM;IAOI,2BAAA;E1E4+XV;E0En/XM;IAOI,0BAAA;E1E++XV;E0Et/XM;IAOI,wBAAA;E1Ek/XV;E0Ez/XM;IAOI,0BAAA;E1Eq/XV;E0E5/XM;IAOI,wBAAA;E1Ew/XV;E0E//XM;IAOI,2BAAA;IAAA,0BAAA;E1E4/XV;E0EngYM;IAOI,iCAAA;IAAA,gCAAA;E1EggYV;E0EvgYM;IAOI,gCAAA;IAAA,+BAAA;E1EogYV;E0E3gYM;IAOI,8BAAA;IAAA,6BAAA;E1EwgYV;E0E/gYM;IAOI,gCAAA;IAAA,+BAAA;E1E4gYV;E0EnhYM;IAOI,8BAAA;IAAA,6BAAA;E1EghYV;E0EvhYM;IAOI,yBAAA;IAAA,4BAAA;E1EohYV;E0E3hYM;IAOI,+BAAA;IAAA,kCAAA;E1EwhYV;E0E/hYM;IAOI,8BAAA;IAAA,iCAAA;E1E4hYV;E0EniYM;IAOI,4BAAA;IAAA,+BAAA;E1EgiYV;E0EviYM;IAOI,8BAAA;IAAA,iCAAA;E1EoiYV;E0E3iYM;IAOI,4BAAA;IAAA,+BAAA;E1EwiYV;E0E/iYM;IAOI,yBAAA;E1E2iYV;E0EljYM;IAOI,+BAAA;E1E8iYV;E0ErjYM;IAOI,8BAAA;E1EijYV;E0ExjYM;IAOI,4BAAA;E1EojYV;E0E3jYM;IAOI,8BAAA;E1EujYV;E0E9jYM;IAOI,4BAAA;E1E0jYV;E0EjkYM;IAOI,2BAAA;E1E6jYV;E0EpkYM;IAOI,iCAAA;E1EgkYV;E0EvkYM;IAOI,gCAAA;E1EmkYV;E0E1kYM;IAOI,8BAAA;E1EskYV;E0E7kYM;IAOI,gCAAA;E1EykYV;E0EhlYM;IAOI,8BAAA;E1E4kYV;E0EnlYM;IAOI,4BAAA;E1E+kYV;E0EtlYM;IAOI,kCAAA;E1EklYV;E0EzlYM;IAOI,iCAAA;E1EqlYV;E0E5lYM;IAOI,+BAAA;E1EwlYV;E0E/lYM;IAOI,iCAAA;E1E2lYV;E0ElmYM;IAOI,+BAAA;E1E8lYV;E0ErmYM;IAOI,0BAAA;E1EimYV;E0ExmYM;IAOI,gCAAA;E1EomYV;E0E3mYM;IAOI,+BAAA;E1EumYV;E0E9mYM;IAOI,6BAAA;E1E0mYV;E0EjnYM;IAOI,+BAAA;E1E6mYV;E0EpnYM;IAOI,6BAAA;E1EgnYV;E0EvnYM;IAOI,iBAAA;E1EmnYV;E0E1nYM;IAOI,uBAAA;E1EsnYV;E0E7nYM;IAOI,sBAAA;E1EynYV;E0EhoYM;IAOI,oBAAA;E1E4nYV;E0EnoYM;IAOI,sBAAA;E1E+nYV;E0EtoYM;IAOI,oBAAA;E1EkoYV;E0EzoYM;IAOI,qBAAA;E1EqoYV;E0E5oYM;IAOI,2BAAA;E1EwoYV;E0E/oYM;IAOI,0BAAA;E1E2oYV;E0ElpYM;IAOI,wBAAA;E1E8oYV;E0ErpYM;IAOI,0BAAA;E1EipYV;E0ExpYM;IAOI,wBAAA;E1EopYV;E0E3pYM;IAOI,wBAAA;E1EupYV;E0E9pYM;IAOI,8BAAA;E1E0pYV;E0EjqYM;IAOI,6BAAA;E1E6pYV;E0EpqYM;IAOI,2BAAA;E1EgqYV;E0EvqYM;IAOI,6BAAA;E1EmqYV;E0E1qYM;IAOI,2BAAA;E1EsqYV;E0E7qYM;IAOI,2BAAA;E1EyqYV;E0EhrYM;IAOI,4BAAA;E1E4qYV;E0EnrYM;IAOI,6BAAA;E1E+qYV;AACF;AgB1rYI;E0DGI;IAOI,sBAAA;E1EorYV;E0E3rYM;IAOI,uBAAA;E1EurYV;E0E9rYM;IAOI,sBAAA;E1E0rYV;E0EjsYM;IAOI,8BAAA;E1E6rYV;E0EpsYM;IAOI,4BAAA;E1EgsYV;E0EvsYM;IAOI,2BAAA;E1EmsYV;E0E1sYM;IAOI,iCAAA;E1EssYV;E0E7sYM;IAOI,2BAAA;E1EysYV;E0EhtYM;IAOI,0BAAA;E1E4sYV;E0EntYM;IAOI,gCAAA;E1E+sYV;E0EttYM;IAOI,yBAAA;E1EktYV;E0EztYM;IAOI,wBAAA;E1EqtYV;E0E5tYM;IAOI,+BAAA;E1EwtYV;E0E/tYM;IAOI,yBAAA;E1E2tYV;E0EluYM;IAOI,6BAAA;E1E8tYV;E0EruYM;IAOI,8BAAA;E1EiuYV;E0ExuYM;IAOI,wBAAA;E1EouYV;E0E3uYM;IAOI,+BAAA;E1EuuYV;E0E9uYM;IAOI,wBAAA;E1E0uYV;E0EjvYM;IAOI,yBAAA;E1E6uYV;E0EpvYM;IAOI,8BAAA;E1EgvYV;E0EvvYM;IAOI,iCAAA;E1EmvYV;E0E1vYM;IAOI,sCAAA;E1EsvYV;E0E7vYM;IAOI,yCAAA;E1EyvYV;E0EhwYM;IAOI,uBAAA;E1E4vYV;E0EnwYM;IAOI,uBAAA;E1E+vYV;E0EtwYM;IAOI,yBAAA;E1EkwYV;E0EzwYM;IAOI,yBAAA;E1EqwYV;E0E5wYM;IAOI,0BAAA;E1EwwYV;E0E/wYM;IAOI,4BAAA;E1E2wYV;E0ElxYM;IAOI,kCAAA;E1E8wYV;E0ErxYM;IAOI,sCAAA;E1EixYV;E0ExxYM;IAOI,oCAAA;E1EoxYV;E0E3xYM;IAOI,kCAAA;E1EuxYV;E0E9xYM;IAOI,yCAAA;E1E0xYV;E0EjyYM;IAOI,wCAAA;E1E6xYV;E0EpyYM;IAOI,wCAAA;E1EgyYV;E0EvyYM;IAOI,kCAAA;E1EmyYV;E0E1yYM;IAOI,gCAAA;E1EsyYV;E0E7yYM;IAOI,8BAAA;E1EyyYV;E0EhzYM;IAOI,gCAAA;E1E4yYV;E0EnzYM;IAOI,+BAAA;E1E+yYV;E0EtzYM;IAOI,oCAAA;E1EkzYV;E0EzzYM;IAOI,kCAAA;E1EqzYV;E0E5zYM;IAOI,gCAAA;E1EwzYV;E0E/zYM;IAOI,uCAAA;E1E2zYV;E0El0YM;IAOI,sCAAA;E1E8zYV;E0Er0YM;IAOI,iCAAA;E1Ei0YV;E0Ex0YM;IAOI,2BAAA;E1Eo0YV;E0E30YM;IAOI,iCAAA;E1Eu0YV;E0E90YM;IAOI,+BAAA;E1E00YV;E0Ej1YM;IAOI,6BAAA;E1E60YV;E0Ep1YM;IAOI,+BAAA;E1Eg1YV;E0Ev1YM;IAOI,8BAAA;E1Em1YV;E0E11YM;IAOI,oBAAA;E1Es1YV;E0E71YM;IAOI,mBAAA;E1Ey1YV;E0Eh2YM;IAOI,mBAAA;E1E41YV;E0En2YM;IAOI,mBAAA;E1E+1YV;E0Et2YM;IAOI,mBAAA;E1Ek2YV;E0Ez2YM;IAOI,mBAAA;E1Eq2YV;E0E52YM;IAOI,mBAAA;E1Ew2YV;E0E/2YM;IAOI,mBAAA;E1E22YV;E0El3YM;IAOI,oBAAA;E1E82YV;E0Er3YM;IAOI,0BAAA;E1Ei3YV;E0Ex3YM;IAOI,yBAAA;E1Eo3YV;E0E33YM;IAOI,uBAAA;E1Eu3YV;E0E93YM;IAOI,yBAAA;E1E03YV;E0Ej4YM;IAOI,uBAAA;E1E63YV;E0Ep4YM;IAOI,uBAAA;E1Eg4YV;E0Ev4YM;IAOI,0BAAA;IAAA,yBAAA;E1Eo4YV;E0E34YM;IAOI,gCAAA;IAAA,+BAAA;E1Ew4YV;E0E/4YM;IAOI,+BAAA;IAAA,8BAAA;E1E44YV;E0En5YM;IAOI,6BAAA;IAAA,4BAAA;E1Eg5YV;E0Ev5YM;IAOI,+BAAA;IAAA,8BAAA;E1Eo5YV;E0E35YM;IAOI,6BAAA;IAAA,4BAAA;E1Ew5YV;E0E/5YM;IAOI,6BAAA;IAAA,4BAAA;E1E45YV;E0En6YM;IAOI,wBAAA;IAAA,2BAAA;E1Eg6YV;E0Ev6YM;IAOI,8BAAA;IAAA,iCAAA;E1Eo6YV;E0E36YM;IAOI,6BAAA;IAAA,gCAAA;E1Ew6YV;E0E/6YM;IAOI,2BAAA;IAAA,8BAAA;E1E46YV;E0En7YM;IAOI,6BAAA;IAAA,gCAAA;E1Eg7YV;E0Ev7YM;IAOI,2BAAA;IAAA,8BAAA;E1Eo7YV;E0E37YM;IAOI,2BAAA;IAAA,8BAAA;E1Ew7YV;E0E/7YM;IAOI,wBAAA;E1E27YV;E0El8YM;IAOI,8BAAA;E1E87YV;E0Er8YM;IAOI,6BAAA;E1Ei8YV;E0Ex8YM;IAOI,2BAAA;E1Eo8YV;E0E38YM;IAOI,6BAAA;E1Eu8YV;E0E98YM;IAOI,2BAAA;E1E08YV;E0Ej9YM;IAOI,2BAAA;E1E68YV;E0Ep9YM;IAOI,0BAAA;E1Eg9YV;E0Ev9YM;IAOI,gCAAA;E1Em9YV;E0E19YM;IAOI,+BAAA;E1Es9YV;E0E79YM;IAOI,6BAAA;E1Ey9YV;E0Eh+YM;IAOI,+BAAA;E1E49YV;E0En+YM;IAOI,6BAAA;E1E+9YV;E0Et+YM;IAOI,6BAAA;E1Ek+YV;E0Ez+YM;IAOI,2BAAA;E1Eq+YV;E0E5+YM;IAOI,iCAAA;E1Ew+YV;E0E/+YM;IAOI,gCAAA;E1E2+YV;E0El/YM;IAOI,8BAAA;E1E8+YV;E0Er/YM;IAOI,gCAAA;E1Ei/YV;E0Ex/YM;IAOI,8BAAA;E1Eo/YV;E0E3/YM;IAOI,8BAAA;E1Eu/YV;E0E9/YM;IAOI,yBAAA;E1E0/YV;E0EjgZM;IAOI,+BAAA;E1E6/YV;E0EpgZM;IAOI,8BAAA;E1EggZV;E0EvgZM;IAOI,4BAAA;E1EmgZV;E0E1gZM;IAOI,8BAAA;E1EsgZV;E0E7gZM;IAOI,4BAAA;E1EygZV;E0EhhZM;IAOI,4BAAA;E1E4gZV;E0EnhZM;IAOI,2BAAA;E1E+gZV;E0EthZM;IAOI,0BAAA;E1EkhZV;E0EzhZM;IAOI,wBAAA;E1EqhZV;E0E5hZM;IAOI,0BAAA;E1EwhZV;E0E/hZM;IAOI,wBAAA;E1E2hZV;E0EliZM;IAOI,iCAAA;IAAA,gCAAA;E1E+hZV;E0EtiZM;IAOI,gCAAA;IAAA,+BAAA;E1EmiZV;E0E1iZM;IAOI,8BAAA;IAAA,6BAAA;E1EuiZV;E0E9iZM;IAOI,gCAAA;IAAA,+BAAA;E1E2iZV;E0EljZM;IAOI,8BAAA;IAAA,6BAAA;E1E+iZV;E0EtjZM;IAOI,+BAAA;IAAA,kCAAA;E1EmjZV;E0E1jZM;IAOI,8BAAA;IAAA,iCAAA;E1EujZV;E0E9jZM;IAOI,4BAAA;IAAA,+BAAA;E1E2jZV;E0ElkZM;IAOI,8BAAA;IAAA,iCAAA;E1E+jZV;E0EtkZM;IAOI,4BAAA;IAAA,+BAAA;E1EmkZV;E0E1kZM;IAOI,+BAAA;E1EskZV;E0E7kZM;IAOI,8BAAA;E1EykZV;E0EhlZM;IAOI,4BAAA;E1E4kZV;E0EnlZM;IAOI,8BAAA;E1E+kZV;E0EtlZM;IAOI,4BAAA;E1EklZV;E0EzlZM;IAOI,iCAAA;E1EqlZV;E0E5lZM;IAOI,gCAAA;E1EwlZV;E0E/lZM;IAOI,8BAAA;E1E2lZV;E0ElmZM;IAOI,gCAAA;E1E8lZV;E0ErmZM;IAOI,8BAAA;E1EimZV;E0ExmZM;IAOI,kCAAA;E1EomZV;E0E3mZM;IAOI,iCAAA;E1EumZV;E0E9mZM;IAOI,+BAAA;E1E0mZV;E0EjnZM;IAOI,iCAAA;E1E6mZV;E0EpnZM;IAOI,+BAAA;E1EgnZV;E0EvnZM;IAOI,gCAAA;E1EmnZV;E0E1nZM;IAOI,+BAAA;E1EsnZV;E0E7nZM;IAOI,6BAAA;E1EynZV;E0EhoZM;IAOI,+BAAA;E1E4nZV;E0EnoZM;IAOI,6BAAA;E1E+nZV;E0EtoZM;IAOI,qBAAA;E1EkoZV;E0EzoZM;IAOI,2BAAA;E1EqoZV;E0E5oZM;IAOI,0BAAA;E1EwoZV;E0E/oZM;IAOI,wBAAA;E1E2oZV;E0ElpZM;IAOI,0BAAA;E1E8oZV;E0ErpZM;IAOI,wBAAA;E1EipZV;E0ExpZM;IAOI,2BAAA;IAAA,0BAAA;E1EqpZV;E0E5pZM;IAOI,iCAAA;IAAA,gCAAA;E1EypZV;E0EhqZM;IAOI,gCAAA;IAAA,+BAAA;E1E6pZV;E0EpqZM;IAOI,8BAAA;IAAA,6BAAA;E1EiqZV;E0ExqZM;IAOI,gCAAA;IAAA,+BAAA;E1EqqZV;E0E5qZM;IAOI,8BAAA;IAAA,6BAAA;E1EyqZV;E0EhrZM;IAOI,yBAAA;IAAA,4BAAA;E1E6qZV;E0EprZM;IAOI,+BAAA;IAAA,kCAAA;E1EirZV;E0ExrZM;IAOI,8BAAA;IAAA,iCAAA;E1EqrZV;E0E5rZM;IAOI,4BAAA;IAAA,+BAAA;E1EyrZV;E0EhsZM;IAOI,8BAAA;IAAA,iCAAA;E1E6rZV;E0EpsZM;IAOI,4BAAA;IAAA,+BAAA;E1EisZV;E0ExsZM;IAOI,yBAAA;E1EosZV;E0E3sZM;IAOI,+BAAA;E1EusZV;E0E9sZM;IAOI,8BAAA;E1E0sZV;E0EjtZM;IAOI,4BAAA;E1E6sZV;E0EptZM;IAOI,8BAAA;E1EgtZV;E0EvtZM;IAOI,4BAAA;E1EmtZV;E0E1tZM;IAOI,2BAAA;E1EstZV;E0E7tZM;IAOI,iCAAA;E1EytZV;E0EhuZM;IAOI,gCAAA;E1E4tZV;E0EnuZM;IAOI,8BAAA;E1E+tZV;E0EtuZM;IAOI,gCAAA;E1EkuZV;E0EzuZM;IAOI,8BAAA;E1EquZV;E0E5uZM;IAOI,4BAAA;E1EwuZV;E0E/uZM;IAOI,kCAAA;E1E2uZV;E0ElvZM;IAOI,iCAAA;E1E8uZV;E0ErvZM;IAOI,+BAAA;E1EivZV;E0ExvZM;IAOI,iCAAA;E1EovZV;E0E3vZM;IAOI,+BAAA;E1EuvZV;E0E9vZM;IAOI,0BAAA;E1E0vZV;E0EjwZM;IAOI,gCAAA;E1E6vZV;E0EpwZM;IAOI,+BAAA;E1EgwZV;E0EvwZM;IAOI,6BAAA;E1EmwZV;E0E1wZM;IAOI,+BAAA;E1EswZV;E0E7wZM;IAOI,6BAAA;E1EywZV;E0EhxZM;IAOI,iBAAA;E1E4wZV;E0EnxZM;IAOI,uBAAA;E1E+wZV;E0EtxZM;IAOI,sBAAA;E1EkxZV;E0EzxZM;IAOI,oBAAA;E1EqxZV;E0E5xZM;IAOI,sBAAA;E1EwxZV;E0E/xZM;IAOI,oBAAA;E1E2xZV;E0ElyZM;IAOI,qBAAA;E1E8xZV;E0EryZM;IAOI,2BAAA;E1EiyZV;E0ExyZM;IAOI,0BAAA;E1EoyZV;E0E3yZM;IAOI,wBAAA;E1EuyZV;E0E9yZM;IAOI,0BAAA;E1E0yZV;E0EjzZM;IAOI,wBAAA;E1E6yZV;E0EpzZM;IAOI,wBAAA;E1EgzZV;E0EvzZM;IAOI,8BAAA;E1EmzZV;E0E1zZM;IAOI,6BAAA;E1EszZV;E0E7zZM;IAOI,2BAAA;E1EyzZV;E0Eh0ZM;IAOI,6BAAA;E1E4zZV;E0En0ZM;IAOI,2BAAA;E1E+zZV;E0Et0ZM;IAOI,2BAAA;E1Ek0ZV;E0Ez0ZM;IAOI,4BAAA;E1Eq0ZV;E0E50ZM;IAOI,6BAAA;E1Ew0ZV;AACF;AgBn1ZI;E0DGI;IAOI,sBAAA;E1E60ZV;E0Ep1ZM;IAOI,uBAAA;E1Eg1ZV;E0Ev1ZM;IAOI,sBAAA;E1Em1ZV;E0E11ZM;IAOI,8BAAA;E1Es1ZV;E0E71ZM;IAOI,4BAAA;E1Ey1ZV;E0Eh2ZM;IAOI,2BAAA;E1E41ZV;E0En2ZM;IAOI,iCAAA;E1E+1ZV;E0Et2ZM;IAOI,2BAAA;E1Ek2ZV;E0Ez2ZM;IAOI,0BAAA;E1Eq2ZV;E0E52ZM;IAOI,gCAAA;E1Ew2ZV;E0E/2ZM;IAOI,yBAAA;E1E22ZV;E0El3ZM;IAOI,wBAAA;E1E82ZV;E0Er3ZM;IAOI,+BAAA;E1Ei3ZV;E0Ex3ZM;IAOI,yBAAA;E1Eo3ZV;E0E33ZM;IAOI,6BAAA;E1Eu3ZV;E0E93ZM;IAOI,8BAAA;E1E03ZV;E0Ej4ZM;IAOI,wBAAA;E1E63ZV;E0Ep4ZM;IAOI,+BAAA;E1Eg4ZV;E0Ev4ZM;IAOI,wBAAA;E1Em4ZV;E0E14ZM;IAOI,yBAAA;E1Es4ZV;E0E74ZM;IAOI,8BAAA;E1Ey4ZV;E0Eh5ZM;IAOI,iCAAA;E1E44ZV;E0En5ZM;IAOI,sCAAA;E1E+4ZV;E0Et5ZM;IAOI,yCAAA;E1Ek5ZV;E0Ez5ZM;IAOI,uBAAA;E1Eq5ZV;E0E55ZM;IAOI,uBAAA;E1Ew5ZV;E0E/5ZM;IAOI,yBAAA;E1E25ZV;E0El6ZM;IAOI,yBAAA;E1E85ZV;E0Er6ZM;IAOI,0BAAA;E1Ei6ZV;E0Ex6ZM;IAOI,4BAAA;E1Eo6ZV;E0E36ZM;IAOI,kCAAA;E1Eu6ZV;E0E96ZM;IAOI,sCAAA;E1E06ZV;E0Ej7ZM;IAOI,oCAAA;E1E66ZV;E0Ep7ZM;IAOI,kCAAA;E1Eg7ZV;E0Ev7ZM;IAOI,yCAAA;E1Em7ZV;E0E17ZM;IAOI,wCAAA;E1Es7ZV;E0E77ZM;IAOI,wCAAA;E1Ey7ZV;E0Eh8ZM;IAOI,kCAAA;E1E47ZV;E0En8ZM;IAOI,gCAAA;E1E+7ZV;E0Et8ZM;IAOI,8BAAA;E1Ek8ZV;E0Ez8ZM;IAOI,gCAAA;E1Eq8ZV;E0E58ZM;IAOI,+BAAA;E1Ew8ZV;E0E/8ZM;IAOI,oCAAA;E1E28ZV;E0El9ZM;IAOI,kCAAA;E1E88ZV;E0Er9ZM;IAOI,gCAAA;E1Ei9ZV;E0Ex9ZM;IAOI,uCAAA;E1Eo9ZV;E0E39ZM;IAOI,sCAAA;E1Eu9ZV;E0E99ZM;IAOI,iCAAA;E1E09ZV;E0Ej+ZM;IAOI,2BAAA;E1E69ZV;E0Ep+ZM;IAOI,iCAAA;E1Eg+ZV;E0Ev+ZM;IAOI,+BAAA;E1Em+ZV;E0E1+ZM;IAOI,6BAAA;E1Es+ZV;E0E7+ZM;IAOI,+BAAA;E1Ey+ZV;E0Eh/ZM;IAOI,8BAAA;E1E4+ZV;E0En/ZM;IAOI,oBAAA;E1E++ZV;E0Et/ZM;IAOI,mBAAA;E1Ek/ZV;E0Ez/ZM;IAOI,mBAAA;E1Eq/ZV;E0E5/ZM;IAOI,mBAAA;E1Ew/ZV;E0E//ZM;IAOI,mBAAA;E1E2/ZV;E0ElgaM;IAOI,mBAAA;E1E8/ZV;E0ErgaM;IAOI,mBAAA;E1EigaV;E0ExgaM;IAOI,mBAAA;E1EogaV;E0E3gaM;IAOI,oBAAA;E1EugaV;E0E9gaM;IAOI,0BAAA;E1E0gaV;E0EjhaM;IAOI,yBAAA;E1E6gaV;E0EphaM;IAOI,uBAAA;E1EghaV;E0EvhaM;IAOI,yBAAA;E1EmhaV;E0E1haM;IAOI,uBAAA;E1EshaV;E0E7haM;IAOI,uBAAA;E1EyhaV;E0EhiaM;IAOI,0BAAA;IAAA,yBAAA;E1E6haV;E0EpiaM;IAOI,gCAAA;IAAA,+BAAA;E1EiiaV;E0ExiaM;IAOI,+BAAA;IAAA,8BAAA;E1EqiaV;E0E5iaM;IAOI,6BAAA;IAAA,4BAAA;E1EyiaV;E0EhjaM;IAOI,+BAAA;IAAA,8BAAA;E1E6iaV;E0EpjaM;IAOI,6BAAA;IAAA,4BAAA;E1EijaV;E0ExjaM;IAOI,6BAAA;IAAA,4BAAA;E1EqjaV;E0E5jaM;IAOI,wBAAA;IAAA,2BAAA;E1EyjaV;E0EhkaM;IAOI,8BAAA;IAAA,iCAAA;E1E6jaV;E0EpkaM;IAOI,6BAAA;IAAA,gCAAA;E1EikaV;E0ExkaM;IAOI,2BAAA;IAAA,8BAAA;E1EqkaV;E0E5kaM;IAOI,6BAAA;IAAA,gCAAA;E1EykaV;E0EhlaM;IAOI,2BAAA;IAAA,8BAAA;E1E6kaV;E0EplaM;IAOI,2BAAA;IAAA,8BAAA;E1EilaV;E0ExlaM;IAOI,wBAAA;E1EolaV;E0E3laM;IAOI,8BAAA;E1EulaV;E0E9laM;IAOI,6BAAA;E1E0laV;E0EjmaM;IAOI,2BAAA;E1E6laV;E0EpmaM;IAOI,6BAAA;E1EgmaV;E0EvmaM;IAOI,2BAAA;E1EmmaV;E0E1maM;IAOI,2BAAA;E1EsmaV;E0E7maM;IAOI,0BAAA;E1EymaV;E0EhnaM;IAOI,gCAAA;E1E4maV;E0EnnaM;IAOI,+BAAA;E1E+maV;E0EtnaM;IAOI,6BAAA;E1EknaV;E0EznaM;IAOI,+BAAA;E1EqnaV;E0E5naM;IAOI,6BAAA;E1EwnaV;E0E/naM;IAOI,6BAAA;E1E2naV;E0EloaM;IAOI,2BAAA;E1E8naV;E0EroaM;IAOI,iCAAA;E1EioaV;E0ExoaM;IAOI,gCAAA;E1EooaV;E0E3oaM;IAOI,8BAAA;E1EuoaV;E0E9oaM;IAOI,gCAAA;E1E0oaV;E0EjpaM;IAOI,8BAAA;E1E6oaV;E0EppaM;IAOI,8BAAA;E1EgpaV;E0EvpaM;IAOI,yBAAA;E1EmpaV;E0E1paM;IAOI,+BAAA;E1EspaV;E0E7paM;IAOI,8BAAA;E1EypaV;E0EhqaM;IAOI,4BAAA;E1E4paV;E0EnqaM;IAOI,8BAAA;E1E+paV;E0EtqaM;IAOI,4BAAA;E1EkqaV;E0EzqaM;IAOI,4BAAA;E1EqqaV;E0E5qaM;IAOI,2BAAA;E1EwqaV;E0E/qaM;IAOI,0BAAA;E1E2qaV;E0ElraM;IAOI,wBAAA;E1E8qaV;E0ErraM;IAOI,0BAAA;E1EiraV;E0ExraM;IAOI,wBAAA;E1EoraV;E0E3raM;IAOI,iCAAA;IAAA,gCAAA;E1EwraV;E0E/raM;IAOI,gCAAA;IAAA,+BAAA;E1E4raV;E0EnsaM;IAOI,8BAAA;IAAA,6BAAA;E1EgsaV;E0EvsaM;IAOI,gCAAA;IAAA,+BAAA;E1EosaV;E0E3saM;IAOI,8BAAA;IAAA,6BAAA;E1EwsaV;E0E/saM;IAOI,+BAAA;IAAA,kCAAA;E1E4saV;E0EntaM;IAOI,8BAAA;IAAA,iCAAA;E1EgtaV;E0EvtaM;IAOI,4BAAA;IAAA,+BAAA;E1EotaV;E0E3taM;IAOI,8BAAA;IAAA,iCAAA;E1EwtaV;E0E/taM;IAOI,4BAAA;IAAA,+BAAA;E1E4taV;E0EnuaM;IAOI,+BAAA;E1E+taV;E0EtuaM;IAOI,8BAAA;E1EkuaV;E0EzuaM;IAOI,4BAAA;E1EquaV;E0E5uaM;IAOI,8BAAA;E1EwuaV;E0E/uaM;IAOI,4BAAA;E1E2uaV;E0ElvaM;IAOI,iCAAA;E1E8uaV;E0ErvaM;IAOI,gCAAA;E1EivaV;E0ExvaM;IAOI,8BAAA;E1EovaV;E0E3vaM;IAOI,gCAAA;E1EuvaV;E0E9vaM;IAOI,8BAAA;E1E0vaV;E0EjwaM;IAOI,kCAAA;E1E6vaV;E0EpwaM;IAOI,iCAAA;E1EgwaV;E0EvwaM;IAOI,+BAAA;E1EmwaV;E0E1waM;IAOI,iCAAA;E1EswaV;E0E7waM;IAOI,+BAAA;E1EywaV;E0EhxaM;IAOI,gCAAA;E1E4waV;E0EnxaM;IAOI,+BAAA;E1E+waV;E0EtxaM;IAOI,6BAAA;E1EkxaV;E0EzxaM;IAOI,+BAAA;E1EqxaV;E0E5xaM;IAOI,6BAAA;E1EwxaV;E0E/xaM;IAOI,qBAAA;E1E2xaV;E0ElyaM;IAOI,2BAAA;E1E8xaV;E0EryaM;IAOI,0BAAA;E1EiyaV;E0ExyaM;IAOI,wBAAA;E1EoyaV;E0E3yaM;IAOI,0BAAA;E1EuyaV;E0E9yaM;IAOI,wBAAA;E1E0yaV;E0EjzaM;IAOI,2BAAA;IAAA,0BAAA;E1E8yaV;E0ErzaM;IAOI,iCAAA;IAAA,gCAAA;E1EkzaV;E0EzzaM;IAOI,gCAAA;IAAA,+BAAA;E1EszaV;E0E7zaM;IAOI,8BAAA;IAAA,6BAAA;E1E0zaV;E0Ej0aM;IAOI,gCAAA;IAAA,+BAAA;E1E8zaV;E0Er0aM;IAOI,8BAAA;IAAA,6BAAA;E1Ek0aV;E0Ez0aM;IAOI,yBAAA;IAAA,4BAAA;E1Es0aV;E0E70aM;IAOI,+BAAA;IAAA,kCAAA;E1E00aV;E0Ej1aM;IAOI,8BAAA;IAAA,iCAAA;E1E80aV;E0Er1aM;IAOI,4BAAA;IAAA,+BAAA;E1Ek1aV;E0Ez1aM;IAOI,8BAAA;IAAA,iCAAA;E1Es1aV;E0E71aM;IAOI,4BAAA;IAAA,+BAAA;E1E01aV;E0Ej2aM;IAOI,yBAAA;E1E61aV;E0Ep2aM;IAOI,+BAAA;E1Eg2aV;E0Ev2aM;IAOI,8BAAA;E1Em2aV;E0E12aM;IAOI,4BAAA;E1Es2aV;E0E72aM;IAOI,8BAAA;E1Ey2aV;E0Eh3aM;IAOI,4BAAA;E1E42aV;E0En3aM;IAOI,2BAAA;E1E+2aV;E0Et3aM;IAOI,iCAAA;E1Ek3aV;E0Ez3aM;IAOI,gCAAA;E1Eq3aV;E0E53aM;IAOI,8BAAA;E1Ew3aV;E0E/3aM;IAOI,gCAAA;E1E23aV;E0El4aM;IAOI,8BAAA;E1E83aV;E0Er4aM;IAOI,4BAAA;E1Ei4aV;E0Ex4aM;IAOI,kCAAA;E1Eo4aV;E0E34aM;IAOI,iCAAA;E1Eu4aV;E0E94aM;IAOI,+BAAA;E1E04aV;E0Ej5aM;IAOI,iCAAA;E1E64aV;E0Ep5aM;IAOI,+BAAA;E1Eg5aV;E0Ev5aM;IAOI,0BAAA;E1Em5aV;E0E15aM;IAOI,gCAAA;E1Es5aV;E0E75aM;IAOI,+BAAA;E1Ey5aV;E0Eh6aM;IAOI,6BAAA;E1E45aV;E0En6aM;IAOI,+BAAA;E1E+5aV;E0Et6aM;IAOI,6BAAA;E1Ek6aV;E0Ez6aM;IAOI,iBAAA;E1Eq6aV;E0E56aM;IAOI,uBAAA;E1Ew6aV;E0E/6aM;IAOI,sBAAA;E1E26aV;E0El7aM;IAOI,oBAAA;E1E86aV;E0Er7aM;IAOI,sBAAA;E1Ei7aV;E0Ex7aM;IAOI,oBAAA;E1Eo7aV;E0E37aM;IAOI,qBAAA;E1Eu7aV;E0E97aM;IAOI,2BAAA;E1E07aV;E0Ej8aM;IAOI,0BAAA;E1E67aV;E0Ep8aM;IAOI,wBAAA;E1Eg8aV;E0Ev8aM;IAOI,0BAAA;E1Em8aV;E0E18aM;IAOI,wBAAA;E1Es8aV;E0E78aM;IAOI,wBAAA;E1Ey8aV;E0Eh9aM;IAOI,8BAAA;E1E48aV;E0En9aM;IAOI,6BAAA;E1E+8aV;E0Et9aM;IAOI,2BAAA;E1Ek9aV;E0Ez9aM;IAOI,6BAAA;E1Eq9aV;E0E59aM;IAOI,2BAAA;E1Ew9aV;E0E/9aM;IAOI,2BAAA;E1E29aV;E0El+aM;IAOI,4BAAA;E1E89aV;E0Er+aM;IAOI,6BAAA;E1Ei+aV;AACF;AgB5+aI;E0DGI;IAOI,sBAAA;E1Es+aV;E0E7+aM;IAOI,uBAAA;E1Ey+aV;E0Eh/aM;IAOI,sBAAA;E1E4+aV;E0En/aM;IAOI,8BAAA;E1E++aV;E0Et/aM;IAOI,4BAAA;E1Ek/aV;E0Ez/aM;IAOI,2BAAA;E1Eq/aV;E0E5/aM;IAOI,iCAAA;E1Ew/aV;E0E//aM;IAOI,2BAAA;E1E2/aV;E0ElgbM;IAOI,0BAAA;E1E8/aV;E0ErgbM;IAOI,gCAAA;E1EigbV;E0ExgbM;IAOI,yBAAA;E1EogbV;E0E3gbM;IAOI,wBAAA;E1EugbV;E0E9gbM;IAOI,+BAAA;E1E0gbV;E0EjhbM;IAOI,yBAAA;E1E6gbV;E0EphbM;IAOI,6BAAA;E1EghbV;E0EvhbM;IAOI,8BAAA;E1EmhbV;E0E1hbM;IAOI,wBAAA;E1EshbV;E0E7hbM;IAOI,+BAAA;E1EyhbV;E0EhibM;IAOI,wBAAA;E1E4hbV;E0EnibM;IAOI,yBAAA;E1E+hbV;E0EtibM;IAOI,8BAAA;E1EkibV;E0EzibM;IAOI,iCAAA;E1EqibV;E0E5ibM;IAOI,sCAAA;E1EwibV;E0E/ibM;IAOI,yCAAA;E1E2ibV;E0EljbM;IAOI,uBAAA;E1E8ibV;E0ErjbM;IAOI,uBAAA;E1EijbV;E0ExjbM;IAOI,yBAAA;E1EojbV;E0E3jbM;IAOI,yBAAA;E1EujbV;E0E9jbM;IAOI,0BAAA;E1E0jbV;E0EjkbM;IAOI,4BAAA;E1E6jbV;E0EpkbM;IAOI,kCAAA;E1EgkbV;E0EvkbM;IAOI,sCAAA;E1EmkbV;E0E1kbM;IAOI,oCAAA;E1EskbV;E0E7kbM;IAOI,kCAAA;E1EykbV;E0EhlbM;IAOI,yCAAA;E1E4kbV;E0EnlbM;IAOI,wCAAA;E1E+kbV;E0EtlbM;IAOI,wCAAA;E1EklbV;E0EzlbM;IAOI,kCAAA;E1EqlbV;E0E5lbM;IAOI,gCAAA;E1EwlbV;E0E/lbM;IAOI,8BAAA;E1E2lbV;E0ElmbM;IAOI,gCAAA;E1E8lbV;E0ErmbM;IAOI,+BAAA;E1EimbV;E0ExmbM;IAOI,oCAAA;E1EombV;E0E3mbM;IAOI,kCAAA;E1EumbV;E0E9mbM;IAOI,gCAAA;E1E0mbV;E0EjnbM;IAOI,uCAAA;E1E6mbV;E0EpnbM;IAOI,sCAAA;E1EgnbV;E0EvnbM;IAOI,iCAAA;E1EmnbV;E0E1nbM;IAOI,2BAAA;E1EsnbV;E0E7nbM;IAOI,iCAAA;E1EynbV;E0EhobM;IAOI,+BAAA;E1E4nbV;E0EnobM;IAOI,6BAAA;E1E+nbV;E0EtobM;IAOI,+BAAA;E1EkobV;E0EzobM;IAOI,8BAAA;E1EqobV;E0E5obM;IAOI,oBAAA;E1EwobV;E0E/obM;IAOI,mBAAA;E1E2obV;E0ElpbM;IAOI,mBAAA;E1E8obV;E0ErpbM;IAOI,mBAAA;E1EipbV;E0ExpbM;IAOI,mBAAA;E1EopbV;E0E3pbM;IAOI,mBAAA;E1EupbV;E0E9pbM;IAOI,mBAAA;E1E0pbV;E0EjqbM;IAOI,mBAAA;E1E6pbV;E0EpqbM;IAOI,oBAAA;E1EgqbV;E0EvqbM;IAOI,0BAAA;E1EmqbV;E0E1qbM;IAOI,yBAAA;E1EsqbV;E0E7qbM;IAOI,uBAAA;E1EyqbV;E0EhrbM;IAOI,yBAAA;E1E4qbV;E0EnrbM;IAOI,uBAAA;E1E+qbV;E0EtrbM;IAOI,uBAAA;E1EkrbV;E0EzrbM;IAOI,0BAAA;IAAA,yBAAA;E1EsrbV;E0E7rbM;IAOI,gCAAA;IAAA,+BAAA;E1E0rbV;E0EjsbM;IAOI,+BAAA;IAAA,8BAAA;E1E8rbV;E0ErsbM;IAOI,6BAAA;IAAA,4BAAA;E1EksbV;E0EzsbM;IAOI,+BAAA;IAAA,8BAAA;E1EssbV;E0E7sbM;IAOI,6BAAA;IAAA,4BAAA;E1E0sbV;E0EjtbM;IAOI,6BAAA;IAAA,4BAAA;E1E8sbV;E0ErtbM;IAOI,wBAAA;IAAA,2BAAA;E1EktbV;E0EztbM;IAOI,8BAAA;IAAA,iCAAA;E1EstbV;E0E7tbM;IAOI,6BAAA;IAAA,gCAAA;E1E0tbV;E0EjubM;IAOI,2BAAA;IAAA,8BAAA;E1E8tbV;E0ErubM;IAOI,6BAAA;IAAA,gCAAA;E1EkubV;E0EzubM;IAOI,2BAAA;IAAA,8BAAA;E1EsubV;E0E7ubM;IAOI,2BAAA;IAAA,8BAAA;E1E0ubV;E0EjvbM;IAOI,wBAAA;E1E6ubV;E0EpvbM;IAOI,8BAAA;E1EgvbV;E0EvvbM;IAOI,6BAAA;E1EmvbV;E0E1vbM;IAOI,2BAAA;E1EsvbV;E0E7vbM;IAOI,6BAAA;E1EyvbV;E0EhwbM;IAOI,2BAAA;E1E4vbV;E0EnwbM;IAOI,2BAAA;E1E+vbV;E0EtwbM;IAOI,0BAAA;E1EkwbV;E0EzwbM;IAOI,gCAAA;E1EqwbV;E0E5wbM;IAOI,+BAAA;E1EwwbV;E0E/wbM;IAOI,6BAAA;E1E2wbV;E0ElxbM;IAOI,+BAAA;E1E8wbV;E0ErxbM;IAOI,6BAAA;E1EixbV;E0ExxbM;IAOI,6BAAA;E1EoxbV;E0E3xbM;IAOI,2BAAA;E1EuxbV;E0E9xbM;IAOI,iCAAA;E1E0xbV;E0EjybM;IAOI,gCAAA;E1E6xbV;E0EpybM;IAOI,8BAAA;E1EgybV;E0EvybM;IAOI,gCAAA;E1EmybV;E0E1ybM;IAOI,8BAAA;E1EsybV;E0E7ybM;IAOI,8BAAA;E1EyybV;E0EhzbM;IAOI,yBAAA;E1E4ybV;E0EnzbM;IAOI,+BAAA;E1E+ybV;E0EtzbM;IAOI,8BAAA;E1EkzbV;E0EzzbM;IAOI,4BAAA;E1EqzbV;E0E5zbM;IAOI,8BAAA;E1EwzbV;E0E/zbM;IAOI,4BAAA;E1E2zbV;E0El0bM;IAOI,4BAAA;E1E8zbV;E0Er0bM;IAOI,2BAAA;E1Ei0bV;E0Ex0bM;IAOI,0BAAA;E1Eo0bV;E0E30bM;IAOI,wBAAA;E1Eu0bV;E0E90bM;IAOI,0BAAA;E1E00bV;E0Ej1bM;IAOI,wBAAA;E1E60bV;E0Ep1bM;IAOI,iCAAA;IAAA,gCAAA;E1Ei1bV;E0Ex1bM;IAOI,gCAAA;IAAA,+BAAA;E1Eq1bV;E0E51bM;IAOI,8BAAA;IAAA,6BAAA;E1Ey1bV;E0Eh2bM;IAOI,gCAAA;IAAA,+BAAA;E1E61bV;E0Ep2bM;IAOI,8BAAA;IAAA,6BAAA;E1Ei2bV;E0Ex2bM;IAOI,+BAAA;IAAA,kCAAA;E1Eq2bV;E0E52bM;IAOI,8BAAA;IAAA,iCAAA;E1Ey2bV;E0Eh3bM;IAOI,4BAAA;IAAA,+BAAA;E1E62bV;E0Ep3bM;IAOI,8BAAA;IAAA,iCAAA;E1Ei3bV;E0Ex3bM;IAOI,4BAAA;IAAA,+BAAA;E1Eq3bV;E0E53bM;IAOI,+BAAA;E1Ew3bV;E0E/3bM;IAOI,8BAAA;E1E23bV;E0El4bM;IAOI,4BAAA;E1E83bV;E0Er4bM;IAOI,8BAAA;E1Ei4bV;E0Ex4bM;IAOI,4BAAA;E1Eo4bV;E0E34bM;IAOI,iCAAA;E1Eu4bV;E0E94bM;IAOI,gCAAA;E1E04bV;E0Ej5bM;IAOI,8BAAA;E1E64bV;E0Ep5bM;IAOI,gCAAA;E1Eg5bV;E0Ev5bM;IAOI,8BAAA;E1Em5bV;E0E15bM;IAOI,kCAAA;E1Es5bV;E0E75bM;IAOI,iCAAA;E1Ey5bV;E0Eh6bM;IAOI,+BAAA;E1E45bV;E0En6bM;IAOI,iCAAA;E1E+5bV;E0Et6bM;IAOI,+BAAA;E1Ek6bV;E0Ez6bM;IAOI,gCAAA;E1Eq6bV;E0E56bM;IAOI,+BAAA;E1Ew6bV;E0E/6bM;IAOI,6BAAA;E1E26bV;E0El7bM;IAOI,+BAAA;E1E86bV;E0Er7bM;IAOI,6BAAA;E1Ei7bV;E0Ex7bM;IAOI,qBAAA;E1Eo7bV;E0E37bM;IAOI,2BAAA;E1Eu7bV;E0E97bM;IAOI,0BAAA;E1E07bV;E0Ej8bM;IAOI,wBAAA;E1E67bV;E0Ep8bM;IAOI,0BAAA;E1Eg8bV;E0Ev8bM;IAOI,wBAAA;E1Em8bV;E0E18bM;IAOI,2BAAA;IAAA,0BAAA;E1Eu8bV;E0E98bM;IAOI,iCAAA;IAAA,gCAAA;E1E28bV;E0El9bM;IAOI,gCAAA;IAAA,+BAAA;E1E+8bV;E0Et9bM;IAOI,8BAAA;IAAA,6BAAA;E1Em9bV;E0E19bM;IAOI,gCAAA;IAAA,+BAAA;E1Eu9bV;E0E99bM;IAOI,8BAAA;IAAA,6BAAA;E1E29bV;E0El+bM;IAOI,yBAAA;IAAA,4BAAA;E1E+9bV;E0Et+bM;IAOI,+BAAA;IAAA,kCAAA;E1Em+bV;E0E1+bM;IAOI,8BAAA;IAAA,iCAAA;E1Eu+bV;E0E9+bM;IAOI,4BAAA;IAAA,+BAAA;E1E2+bV;E0El/bM;IAOI,8BAAA;IAAA,iCAAA;E1E++bV;E0Et/bM;IAOI,4BAAA;IAAA,+BAAA;E1Em/bV;E0E1/bM;IAOI,yBAAA;E1Es/bV;E0E7/bM;IAOI,+BAAA;E1Ey/bV;E0EhgcM;IAOI,8BAAA;E1E4/bV;E0EngcM;IAOI,4BAAA;E1E+/bV;E0EtgcM;IAOI,8BAAA;E1EkgcV;E0EzgcM;IAOI,4BAAA;E1EqgcV;E0E5gcM;IAOI,2BAAA;E1EwgcV;E0E/gcM;IAOI,iCAAA;E1E2gcV;E0ElhcM;IAOI,gCAAA;E1E8gcV;E0ErhcM;IAOI,8BAAA;E1EihcV;E0ExhcM;IAOI,gCAAA;E1EohcV;E0E3hcM;IAOI,8BAAA;E1EuhcV;E0E9hcM;IAOI,4BAAA;E1E0hcV;E0EjicM;IAOI,kCAAA;E1E6hcV;E0EpicM;IAOI,iCAAA;E1EgicV;E0EvicM;IAOI,+BAAA;E1EmicV;E0E1icM;IAOI,iCAAA;E1EsicV;E0E7icM;IAOI,+BAAA;E1EyicV;E0EhjcM;IAOI,0BAAA;E1E4icV;E0EnjcM;IAOI,gCAAA;E1E+icV;E0EtjcM;IAOI,+BAAA;E1EkjcV;E0EzjcM;IAOI,6BAAA;E1EqjcV;E0E5jcM;IAOI,+BAAA;E1EwjcV;E0E/jcM;IAOI,6BAAA;E1E2jcV;E0ElkcM;IAOI,iBAAA;E1E8jcV;E0ErkcM;IAOI,uBAAA;E1EikcV;E0ExkcM;IAOI,sBAAA;E1EokcV;E0E3kcM;IAOI,oBAAA;E1EukcV;E0E9kcM;IAOI,sBAAA;E1E0kcV;E0EjlcM;IAOI,oBAAA;E1E6kcV;E0EplcM;IAOI,qBAAA;E1EglcV;E0EvlcM;IAOI,2BAAA;E1EmlcV;E0E1lcM;IAOI,0BAAA;E1EslcV;E0E7lcM;IAOI,wBAAA;E1EylcV;E0EhmcM;IAOI,0BAAA;E1E4lcV;E0EnmcM;IAOI,wBAAA;E1E+lcV;E0EtmcM;IAOI,wBAAA;E1EkmcV;E0EzmcM;IAOI,8BAAA;E1EqmcV;E0E5mcM;IAOI,6BAAA;E1EwmcV;E0E/mcM;IAOI,2BAAA;E1E2mcV;E0ElncM;IAOI,6BAAA;E1E8mcV;E0ErncM;IAOI,2BAAA;E1EincV;E0ExncM;IAOI,2BAAA;E1EoncV;E0E3ncM;IAOI,4BAAA;E1EuncV;E0E9ncM;IAOI,6BAAA;E1E0ncV;AACF;AgBrocI;E0DGI;IAOI,sBAAA;E1E+ncV;E0EtocM;IAOI,uBAAA;E1EkocV;E0EzocM;IAOI,sBAAA;E1EqocV;E0E5ocM;IAOI,8BAAA;E1EwocV;E0E/ocM;IAOI,4BAAA;E1E2ocV;E0ElpcM;IAOI,2BAAA;E1E8ocV;E0ErpcM;IAOI,iCAAA;E1EipcV;E0ExpcM;IAOI,2BAAA;E1EopcV;E0E3pcM;IAOI,0BAAA;E1EupcV;E0E9pcM;IAOI,gCAAA;E1E0pcV;E0EjqcM;IAOI,yBAAA;E1E6pcV;E0EpqcM;IAOI,wBAAA;E1EgqcV;E0EvqcM;IAOI,+BAAA;E1EmqcV;E0E1qcM;IAOI,yBAAA;E1EsqcV;E0E7qcM;IAOI,6BAAA;E1EyqcV;E0EhrcM;IAOI,8BAAA;E1E4qcV;E0EnrcM;IAOI,wBAAA;E1E+qcV;E0EtrcM;IAOI,+BAAA;E1EkrcV;E0EzrcM;IAOI,wBAAA;E1EqrcV;E0E5rcM;IAOI,yBAAA;E1EwrcV;E0E/rcM;IAOI,8BAAA;E1E2rcV;E0ElscM;IAOI,iCAAA;E1E8rcV;E0ErscM;IAOI,sCAAA;E1EiscV;E0ExscM;IAOI,yCAAA;E1EoscV;E0E3scM;IAOI,uBAAA;E1EuscV;E0E9scM;IAOI,uBAAA;E1E0scV;E0EjtcM;IAOI,yBAAA;E1E6scV;E0EptcM;IAOI,yBAAA;E1EgtcV;E0EvtcM;IAOI,0BAAA;E1EmtcV;E0E1tcM;IAOI,4BAAA;E1EstcV;E0E7tcM;IAOI,kCAAA;E1EytcV;E0EhucM;IAOI,sCAAA;E1E4tcV;E0EnucM;IAOI,oCAAA;E1E+tcV;E0EtucM;IAOI,kCAAA;E1EkucV;E0EzucM;IAOI,yCAAA;E1EqucV;E0E5ucM;IAOI,wCAAA;E1EwucV;E0E/ucM;IAOI,wCAAA;E1E2ucV;E0ElvcM;IAOI,kCAAA;E1E8ucV;E0ErvcM;IAOI,gCAAA;E1EivcV;E0ExvcM;IAOI,8BAAA;E1EovcV;E0E3vcM;IAOI,gCAAA;E1EuvcV;E0E9vcM;IAOI,+BAAA;E1E0vcV;E0EjwcM;IAOI,oCAAA;E1E6vcV;E0EpwcM;IAOI,kCAAA;E1EgwcV;E0EvwcM;IAOI,gCAAA;E1EmwcV;E0E1wcM;IAOI,uCAAA;E1EswcV;E0E7wcM;IAOI,sCAAA;E1EywcV;E0EhxcM;IAOI,iCAAA;E1E4wcV;E0EnxcM;IAOI,2BAAA;E1E+wcV;E0EtxcM;IAOI,iCAAA;E1EkxcV;E0EzxcM;IAOI,+BAAA;E1EqxcV;E0E5xcM;IAOI,6BAAA;E1EwxcV;E0E/xcM;IAOI,+BAAA;E1E2xcV;E0ElycM;IAOI,8BAAA;E1E8xcV;E0ErycM;IAOI,oBAAA;E1EiycV;E0ExycM;IAOI,mBAAA;E1EoycV;E0E3ycM;IAOI,mBAAA;E1EuycV;E0E9ycM;IAOI,mBAAA;E1E0ycV;E0EjzcM;IAOI,mBAAA;E1E6ycV;E0EpzcM;IAOI,mBAAA;E1EgzcV;E0EvzcM;IAOI,mBAAA;E1EmzcV;E0E1zcM;IAOI,mBAAA;E1EszcV;E0E7zcM;IAOI,oBAAA;E1EyzcV;E0Eh0cM;IAOI,0BAAA;E1E4zcV;E0En0cM;IAOI,yBAAA;E1E+zcV;E0Et0cM;IAOI,uBAAA;E1Ek0cV;E0Ez0cM;IAOI,yBAAA;E1Eq0cV;E0E50cM;IAOI,uBAAA;E1Ew0cV;E0E/0cM;IAOI,uBAAA;E1E20cV;E0El1cM;IAOI,0BAAA;IAAA,yBAAA;E1E+0cV;E0Et1cM;IAOI,gCAAA;IAAA,+BAAA;E1Em1cV;E0E11cM;IAOI,+BAAA;IAAA,8BAAA;E1Eu1cV;E0E91cM;IAOI,6BAAA;IAAA,4BAAA;E1E21cV;E0El2cM;IAOI,+BAAA;IAAA,8BAAA;E1E+1cV;E0Et2cM;IAOI,6BAAA;IAAA,4BAAA;E1Em2cV;E0E12cM;IAOI,6BAAA;IAAA,4BAAA;E1Eu2cV;E0E92cM;IAOI,wBAAA;IAAA,2BAAA;E1E22cV;E0El3cM;IAOI,8BAAA;IAAA,iCAAA;E1E+2cV;E0Et3cM;IAOI,6BAAA;IAAA,gCAAA;E1Em3cV;E0E13cM;IAOI,2BAAA;IAAA,8BAAA;E1Eu3cV;E0E93cM;IAOI,6BAAA;IAAA,gCAAA;E1E23cV;E0El4cM;IAOI,2BAAA;IAAA,8BAAA;E1E+3cV;E0Et4cM;IAOI,2BAAA;IAAA,8BAAA;E1Em4cV;E0E14cM;IAOI,wBAAA;E1Es4cV;E0E74cM;IAOI,8BAAA;E1Ey4cV;E0Eh5cM;IAOI,6BAAA;E1E44cV;E0En5cM;IAOI,2BAAA;E1E+4cV;E0Et5cM;IAOI,6BAAA;E1Ek5cV;E0Ez5cM;IAOI,2BAAA;E1Eq5cV;E0E55cM;IAOI,2BAAA;E1Ew5cV;E0E/5cM;IAOI,0BAAA;E1E25cV;E0El6cM;IAOI,gCAAA;E1E85cV;E0Er6cM;IAOI,+BAAA;E1Ei6cV;E0Ex6cM;IAOI,6BAAA;E1Eo6cV;E0E36cM;IAOI,+BAAA;E1Eu6cV;E0E96cM;IAOI,6BAAA;E1E06cV;E0Ej7cM;IAOI,6BAAA;E1E66cV;E0Ep7cM;IAOI,2BAAA;E1Eg7cV;E0Ev7cM;IAOI,iCAAA;E1Em7cV;E0E17cM;IAOI,gCAAA;E1Es7cV;E0E77cM;IAOI,8BAAA;E1Ey7cV;E0Eh8cM;IAOI,gCAAA;E1E47cV;E0En8cM;IAOI,8BAAA;E1E+7cV;E0Et8cM;IAOI,8BAAA;E1Ek8cV;E0Ez8cM;IAOI,yBAAA;E1Eq8cV;E0E58cM;IAOI,+BAAA;E1Ew8cV;E0E/8cM;IAOI,8BAAA;E1E28cV;E0El9cM;IAOI,4BAAA;E1E88cV;E0Er9cM;IAOI,8BAAA;E1Ei9cV;E0Ex9cM;IAOI,4BAAA;E1Eo9cV;E0E39cM;IAOI,4BAAA;E1Eu9cV;E0E99cM;IAOI,2BAAA;E1E09cV;E0Ej+cM;IAOI,0BAAA;E1E69cV;E0Ep+cM;IAOI,wBAAA;E1Eg+cV;E0Ev+cM;IAOI,0BAAA;E1Em+cV;E0E1+cM;IAOI,wBAAA;E1Es+cV;E0E7+cM;IAOI,iCAAA;IAAA,gCAAA;E1E0+cV;E0Ej/cM;IAOI,gCAAA;IAAA,+BAAA;E1E8+cV;E0Er/cM;IAOI,8BAAA;IAAA,6BAAA;E1Ek/cV;E0Ez/cM;IAOI,gCAAA;IAAA,+BAAA;E1Es/cV;E0E7/cM;IAOI,8BAAA;IAAA,6BAAA;E1E0/cV;E0EjgdM;IAOI,+BAAA;IAAA,kCAAA;E1E8/cV;E0ErgdM;IAOI,8BAAA;IAAA,iCAAA;E1EkgdV;E0EzgdM;IAOI,4BAAA;IAAA,+BAAA;E1EsgdV;E0E7gdM;IAOI,8BAAA;IAAA,iCAAA;E1E0gdV;E0EjhdM;IAOI,4BAAA;IAAA,+BAAA;E1E8gdV;E0ErhdM;IAOI,+BAAA;E1EihdV;E0ExhdM;IAOI,8BAAA;E1EohdV;E0E3hdM;IAOI,4BAAA;E1EuhdV;E0E9hdM;IAOI,8BAAA;E1E0hdV;E0EjidM;IAOI,4BAAA;E1E6hdV;E0EpidM;IAOI,iCAAA;E1EgidV;E0EvidM;IAOI,gCAAA;E1EmidV;E0E1idM;IAOI,8BAAA;E1EsidV;E0E7idM;IAOI,gCAAA;E1EyidV;E0EhjdM;IAOI,8BAAA;E1E4idV;E0EnjdM;IAOI,kCAAA;E1E+idV;E0EtjdM;IAOI,iCAAA;E1EkjdV;E0EzjdM;IAOI,+BAAA;E1EqjdV;E0E5jdM;IAOI,iCAAA;E1EwjdV;E0E/jdM;IAOI,+BAAA;E1E2jdV;E0ElkdM;IAOI,gCAAA;E1E8jdV;E0ErkdM;IAOI,+BAAA;E1EikdV;E0ExkdM;IAOI,6BAAA;E1EokdV;E0E3kdM;IAOI,+BAAA;E1EukdV;E0E9kdM;IAOI,6BAAA;E1E0kdV;E0EjldM;IAOI,qBAAA;E1E6kdV;E0EpldM;IAOI,2BAAA;E1EgldV;E0EvldM;IAOI,0BAAA;E1EmldV;E0E1ldM;IAOI,wBAAA;E1EsldV;E0E7ldM;IAOI,0BAAA;E1EyldV;E0EhmdM;IAOI,wBAAA;E1E4ldV;E0EnmdM;IAOI,2BAAA;IAAA,0BAAA;E1EgmdV;E0EvmdM;IAOI,iCAAA;IAAA,gCAAA;E1EomdV;E0E3mdM;IAOI,gCAAA;IAAA,+BAAA;E1EwmdV;E0E/mdM;IAOI,8BAAA;IAAA,6BAAA;E1E4mdV;E0EnndM;IAOI,gCAAA;IAAA,+BAAA;E1EgndV;E0EvndM;IAOI,8BAAA;IAAA,6BAAA;E1EondV;E0E3ndM;IAOI,yBAAA;IAAA,4BAAA;E1EwndV;E0E/ndM;IAOI,+BAAA;IAAA,kCAAA;E1E4ndV;E0EnodM;IAOI,8BAAA;IAAA,iCAAA;E1EgodV;E0EvodM;IAOI,4BAAA;IAAA,+BAAA;E1EoodV;E0E3odM;IAOI,8BAAA;IAAA,iCAAA;E1EwodV;E0E/odM;IAOI,4BAAA;IAAA,+BAAA;E1E4odV;E0EnpdM;IAOI,yBAAA;E1E+odV;E0EtpdM;IAOI,+BAAA;E1EkpdV;E0EzpdM;IAOI,8BAAA;E1EqpdV;E0E5pdM;IAOI,4BAAA;E1EwpdV;E0E/pdM;IAOI,8BAAA;E1E2pdV;E0ElqdM;IAOI,4BAAA;E1E8pdV;E0ErqdM;IAOI,2BAAA;E1EiqdV;E0ExqdM;IAOI,iCAAA;E1EoqdV;E0E3qdM;IAOI,gCAAA;E1EuqdV;E0E9qdM;IAOI,8BAAA;E1E0qdV;E0EjrdM;IAOI,gCAAA;E1E6qdV;E0EprdM;IAOI,8BAAA;E1EgrdV;E0EvrdM;IAOI,4BAAA;E1EmrdV;E0E1rdM;IAOI,kCAAA;E1EsrdV;E0E7rdM;IAOI,iCAAA;E1EyrdV;E0EhsdM;IAOI,+BAAA;E1E4rdV;E0EnsdM;IAOI,iCAAA;E1E+rdV;E0EtsdM;IAOI,+BAAA;E1EksdV;E0EzsdM;IAOI,0BAAA;E1EqsdV;E0E5sdM;IAOI,gCAAA;E1EwsdV;E0E/sdM;IAOI,+BAAA;E1E2sdV;E0EltdM;IAOI,6BAAA;E1E8sdV;E0ErtdM;IAOI,+BAAA;E1EitdV;E0ExtdM;IAOI,6BAAA;E1EotdV;E0E3tdM;IAOI,iBAAA;E1EutdV;E0E9tdM;IAOI,uBAAA;E1E0tdV;E0EjudM;IAOI,sBAAA;E1E6tdV;E0EpudM;IAOI,oBAAA;E1EgudV;E0EvudM;IAOI,sBAAA;E1EmudV;E0E1udM;IAOI,oBAAA;E1EsudV;E0E7udM;IAOI,qBAAA;E1EyudV;E0EhvdM;IAOI,2BAAA;E1E4udV;E0EnvdM;IAOI,0BAAA;E1E+udV;E0EtvdM;IAOI,wBAAA;E1EkvdV;E0EzvdM;IAOI,0BAAA;E1EqvdV;E0E5vdM;IAOI,wBAAA;E1EwvdV;E0E/vdM;IAOI,wBAAA;E1E2vdV;E0ElwdM;IAOI,8BAAA;E1E8vdV;E0ErwdM;IAOI,6BAAA;E1EiwdV;E0ExwdM;IAOI,2BAAA;E1EowdV;E0E3wdM;IAOI,6BAAA;E1EuwdV;E0E9wdM;IAOI,2BAAA;E1E0wdV;E0EjxdM;IAOI,2BAAA;E1E6wdV;E0EpxdM;IAOI,4BAAA;E1EgxdV;E0EvxdM;IAOI,6BAAA;E1EmxdV;AACF;AgB9xdI;E0DGI;IAOI,sBAAA;E1EwxdV;E0E/xdM;IAOI,uBAAA;E1E2xdV;E0ElydM;IAOI,sBAAA;E1E8xdV;E0ErydM;IAOI,8BAAA;E1EiydV;E0ExydM;IAOI,4BAAA;E1EoydV;E0E3ydM;IAOI,2BAAA;E1EuydV;E0E9ydM;IAOI,iCAAA;E1E0ydV;E0EjzdM;IAOI,2BAAA;E1E6ydV;E0EpzdM;IAOI,0BAAA;E1EgzdV;E0EvzdM;IAOI,gCAAA;E1EmzdV;E0E1zdM;IAOI,yBAAA;E1EszdV;E0E7zdM;IAOI,wBAAA;E1EyzdV;E0Eh0dM;IAOI,+BAAA;E1E4zdV;E0En0dM;IAOI,yBAAA;E1E+zdV;E0Et0dM;IAOI,6BAAA;E1Ek0dV;E0Ez0dM;IAOI,8BAAA;E1Eq0dV;E0E50dM;IAOI,wBAAA;E1Ew0dV;E0E/0dM;IAOI,+BAAA;E1E20dV;E0El1dM;IAOI,wBAAA;E1E80dV;E0Er1dM;IAOI,yBAAA;E1Ei1dV;E0Ex1dM;IAOI,8BAAA;E1Eo1dV;E0E31dM;IAOI,iCAAA;E1Eu1dV;E0E91dM;IAOI,sCAAA;E1E01dV;E0Ej2dM;IAOI,yCAAA;E1E61dV;E0Ep2dM;IAOI,uBAAA;E1Eg2dV;E0Ev2dM;IAOI,uBAAA;E1Em2dV;E0E12dM;IAOI,yBAAA;E1Es2dV;E0E72dM;IAOI,yBAAA;E1Ey2dV;E0Eh3dM;IAOI,0BAAA;E1E42dV;E0En3dM;IAOI,4BAAA;E1E+2dV;E0Et3dM;IAOI,kCAAA;E1Ek3dV;E0Ez3dM;IAOI,sCAAA;E1Eq3dV;E0E53dM;IAOI,oCAAA;E1Ew3dV;E0E/3dM;IAOI,kCAAA;E1E23dV;E0El4dM;IAOI,yCAAA;E1E83dV;E0Er4dM;IAOI,wCAAA;E1Ei4dV;E0Ex4dM;IAOI,wCAAA;E1Eo4dV;E0E34dM;IAOI,kCAAA;E1Eu4dV;E0E94dM;IAOI,gCAAA;E1E04dV;E0Ej5dM;IAOI,8BAAA;E1E64dV;E0Ep5dM;IAOI,gCAAA;E1Eg5dV;E0Ev5dM;IAOI,+BAAA;E1Em5dV;E0E15dM;IAOI,oCAAA;E1Es5dV;E0E75dM;IAOI,kCAAA;E1Ey5dV;E0Eh6dM;IAOI,gCAAA;E1E45dV;E0En6dM;IAOI,uCAAA;E1E+5dV;E0Et6dM;IAOI,sCAAA;E1Ek6dV;E0Ez6dM;IAOI,iCAAA;E1Eq6dV;E0E56dM;IAOI,2BAAA;E1Ew6dV;E0E/6dM;IAOI,iCAAA;E1E26dV;E0El7dM;IAOI,+BAAA;E1E86dV;E0Er7dM;IAOI,6BAAA;E1Ei7dV;E0Ex7dM;IAOI,+BAAA;E1Eo7dV;E0E37dM;IAOI,8BAAA;E1Eu7dV;E0E97dM;IAOI,oBAAA;E1E07dV;E0Ej8dM;IAOI,mBAAA;E1E67dV;E0Ep8dM;IAOI,mBAAA;E1Eg8dV;E0Ev8dM;IAOI,mBAAA;E1Em8dV;E0E18dM;IAOI,mBAAA;E1Es8dV;E0E78dM;IAOI,mBAAA;E1Ey8dV;E0Eh9dM;IAOI,mBAAA;E1E48dV;E0En9dM;IAOI,mBAAA;E1E+8dV;E0Et9dM;IAOI,oBAAA;E1Ek9dV;E0Ez9dM;IAOI,0BAAA;E1Eq9dV;E0E59dM;IAOI,yBAAA;E1Ew9dV;E0E/9dM;IAOI,uBAAA;E1E29dV;E0El+dM;IAOI,yBAAA;E1E89dV;E0Er+dM;IAOI,uBAAA;E1Ei+dV;E0Ex+dM;IAOI,uBAAA;E1Eo+dV;E0E3+dM;IAOI,0BAAA;IAAA,yBAAA;E1Ew+dV;E0E/+dM;IAOI,gCAAA;IAAA,+BAAA;E1E4+dV;E0En/dM;IAOI,+BAAA;IAAA,8BAAA;E1Eg/dV;E0Ev/dM;IAOI,6BAAA;IAAA,4BAAA;E1Eo/dV;E0E3/dM;IAOI,+BAAA;IAAA,8BAAA;E1Ew/dV;E0E//dM;IAOI,6BAAA;IAAA,4BAAA;E1E4/dV;E0EngeM;IAOI,6BAAA;IAAA,4BAAA;E1EggeV;E0EvgeM;IAOI,wBAAA;IAAA,2BAAA;E1EogeV;E0E3geM;IAOI,8BAAA;IAAA,iCAAA;E1EwgeV;E0E/geM;IAOI,6BAAA;IAAA,gCAAA;E1E4geV;E0EnheM;IAOI,2BAAA;IAAA,8BAAA;E1EgheV;E0EvheM;IAOI,6BAAA;IAAA,gCAAA;E1EoheV;E0E3heM;IAOI,2BAAA;IAAA,8BAAA;E1EwheV;E0E/heM;IAOI,2BAAA;IAAA,8BAAA;E1E4heV;E0EnieM;IAOI,wBAAA;E1E+heV;E0EtieM;IAOI,8BAAA;E1EkieV;E0EzieM;IAOI,6BAAA;E1EqieV;E0E5ieM;IAOI,2BAAA;E1EwieV;E0E/ieM;IAOI,6BAAA;E1E2ieV;E0EljeM;IAOI,2BAAA;E1E8ieV;E0ErjeM;IAOI,2BAAA;E1EijeV;E0ExjeM;IAOI,0BAAA;E1EojeV;E0E3jeM;IAOI,gCAAA;E1EujeV;E0E9jeM;IAOI,+BAAA;E1E0jeV;E0EjkeM;IAOI,6BAAA;E1E6jeV;E0EpkeM;IAOI,+BAAA;E1EgkeV;E0EvkeM;IAOI,6BAAA;E1EmkeV;E0E1keM;IAOI,6BAAA;E1EskeV;E0E7keM;IAOI,2BAAA;E1EykeV;E0EhleM;IAOI,iCAAA;E1E4keV;E0EnleM;IAOI,gCAAA;E1E+keV;E0EtleM;IAOI,8BAAA;E1EkleV;E0EzleM;IAOI,gCAAA;E1EqleV;E0E5leM;IAOI,8BAAA;E1EwleV;E0E/leM;IAOI,8BAAA;E1E2leV;E0ElmeM;IAOI,yBAAA;E1E8leV;E0ErmeM;IAOI,+BAAA;E1EimeV;E0ExmeM;IAOI,8BAAA;E1EomeV;E0E3meM;IAOI,4BAAA;E1EumeV;E0E9meM;IAOI,8BAAA;E1E0meV;E0EjneM;IAOI,4BAAA;E1E6meV;E0EpneM;IAOI,4BAAA;E1EgneV;E0EvneM;IAOI,2BAAA;E1EmneV;E0E1neM;IAOI,0BAAA;E1EsneV;E0E7neM;IAOI,wBAAA;E1EyneV;E0EhoeM;IAOI,0BAAA;E1E4neV;E0EnoeM;IAOI,wBAAA;E1E+neV;E0EtoeM;IAOI,iCAAA;IAAA,gCAAA;E1EmoeV;E0E1oeM;IAOI,gCAAA;IAAA,+BAAA;E1EuoeV;E0E9oeM;IAOI,8BAAA;IAAA,6BAAA;E1E2oeV;E0ElpeM;IAOI,gCAAA;IAAA,+BAAA;E1E+oeV;E0EtpeM;IAOI,8BAAA;IAAA,6BAAA;E1EmpeV;E0E1peM;IAOI,+BAAA;IAAA,kCAAA;E1EupeV;E0E9peM;IAOI,8BAAA;IAAA,iCAAA;E1E2peV;E0ElqeM;IAOI,4BAAA;IAAA,+BAAA;E1E+peV;E0EtqeM;IAOI,8BAAA;IAAA,iCAAA;E1EmqeV;E0E1qeM;IAOI,4BAAA;IAAA,+BAAA;E1EuqeV;E0E9qeM;IAOI,+BAAA;E1E0qeV;E0EjreM;IAOI,8BAAA;E1E6qeV;E0EpreM;IAOI,4BAAA;E1EgreV;E0EvreM;IAOI,8BAAA;E1EmreV;E0E1reM;IAOI,4BAAA;E1EsreV;E0E7reM;IAOI,iCAAA;E1EyreV;E0EhseM;IAOI,gCAAA;E1E4reV;E0EnseM;IAOI,8BAAA;E1E+reV;E0EtseM;IAOI,gCAAA;E1EkseV;E0EzseM;IAOI,8BAAA;E1EqseV;E0E5seM;IAOI,kCAAA;E1EwseV;E0E/seM;IAOI,iCAAA;E1E2seV;E0ElteM;IAOI,+BAAA;E1E8seV;E0ErteM;IAOI,iCAAA;E1EiteV;E0ExteM;IAOI,+BAAA;E1EoteV;E0E3teM;IAOI,gCAAA;E1EuteV;E0E9teM;IAOI,+BAAA;E1E0teV;E0EjueM;IAOI,6BAAA;E1E6teV;E0EpueM;IAOI,+BAAA;E1EgueV;E0EvueM;IAOI,6BAAA;E1EmueV;E0E1ueM;IAOI,qBAAA;E1EsueV;E0E7ueM;IAOI,2BAAA;E1EyueV;E0EhveM;IAOI,0BAAA;E1E4ueV;E0EnveM;IAOI,wBAAA;E1E+ueV;E0EtveM;IAOI,0BAAA;E1EkveV;E0EzveM;IAOI,wBAAA;E1EqveV;E0E5veM;IAOI,2BAAA;IAAA,0BAAA;E1EyveV;E0EhweM;IAOI,iCAAA;IAAA,gCAAA;E1E6veV;E0EpweM;IAOI,gCAAA;IAAA,+BAAA;E1EiweV;E0ExweM;IAOI,8BAAA;IAAA,6BAAA;E1EqweV;E0E5weM;IAOI,gCAAA;IAAA,+BAAA;E1EyweV;E0EhxeM;IAOI,8BAAA;IAAA,6BAAA;E1E6weV;E0EpxeM;IAOI,yBAAA;IAAA,4BAAA;E1EixeV;E0ExxeM;IAOI,+BAAA;IAAA,kCAAA;E1EqxeV;E0E5xeM;IAOI,8BAAA;IAAA,iCAAA;E1EyxeV;E0EhyeM;IAOI,4BAAA;IAAA,+BAAA;E1E6xeV;E0EpyeM;IAOI,8BAAA;IAAA,iCAAA;E1EiyeV;E0ExyeM;IAOI,4BAAA;IAAA,+BAAA;E1EqyeV;E0E5yeM;IAOI,yBAAA;E1EwyeV;E0E/yeM;IAOI,+BAAA;E1E2yeV;E0ElzeM;IAOI,8BAAA;E1E8yeV;E0ErzeM;IAOI,4BAAA;E1EizeV;E0ExzeM;IAOI,8BAAA;E1EozeV;E0E3zeM;IAOI,4BAAA;E1EuzeV;E0E9zeM;IAOI,2BAAA;E1E0zeV;E0Ej0eM;IAOI,iCAAA;E1E6zeV;E0Ep0eM;IAOI,gCAAA;E1Eg0eV;E0Ev0eM;IAOI,8BAAA;E1Em0eV;E0E10eM;IAOI,gCAAA;E1Es0eV;E0E70eM;IAOI,8BAAA;E1Ey0eV;E0Eh1eM;IAOI,4BAAA;E1E40eV;E0En1eM;IAOI,kCAAA;E1E+0eV;E0Et1eM;IAOI,iCAAA;E1Ek1eV;E0Ez1eM;IAOI,+BAAA;E1Eq1eV;E0E51eM;IAOI,iCAAA;E1Ew1eV;E0E/1eM;IAOI,+BAAA;E1E21eV;E0El2eM;IAOI,0BAAA;E1E81eV;E0Er2eM;IAOI,gCAAA;E1Ei2eV;E0Ex2eM;IAOI,+BAAA;E1Eo2eV;E0E32eM;IAOI,6BAAA;E1Eu2eV;E0E92eM;IAOI,+BAAA;E1E02eV;E0Ej3eM;IAOI,6BAAA;E1E62eV;E0Ep3eM;IAOI,iBAAA;E1Eg3eV;E0Ev3eM;IAOI,uBAAA;E1Em3eV;E0E13eM;IAOI,sBAAA;E1Es3eV;E0E73eM;IAOI,oBAAA;E1Ey3eV;E0Eh4eM;IAOI,sBAAA;E1E43eV;E0En4eM;IAOI,oBAAA;E1E+3eV;E0Et4eM;IAOI,qBAAA;E1Ek4eV;E0Ez4eM;IAOI,2BAAA;E1Eq4eV;E0E54eM;IAOI,0BAAA;E1Ew4eV;E0E/4eM;IAOI,wBAAA;E1E24eV;E0El5eM;IAOI,0BAAA;E1E84eV;E0Er5eM;IAOI,wBAAA;E1Ei5eV;E0Ex5eM;IAOI,wBAAA;E1Eo5eV;E0E35eM;IAOI,8BAAA;E1Eu5eV;E0E95eM;IAOI,6BAAA;E1E05eV;E0Ej6eM;IAOI,2BAAA;E1E65eV;E0Ep6eM;IAOI,6BAAA;E1Eg6eV;E0Ev6eM;IAOI,2BAAA;E1Em6eV;E0E16eM;IAOI,2BAAA;E1Es6eV;E0E76eM;IAOI,4BAAA;E1Ey6eV;E0Eh7eM;IAOI,6BAAA;E1E46eV;AACF;A2En+eA;ED+CQ;IAOI,+BAAA;E1Ei7eV;E0Ex7eM;IAOI,6BAAA;E1Eo7eV;E0E37eM;IAOI,gCAAA;E1Eu7eV;E0E97eM;IAOI,+BAAA;E1E07eV;AACF;A2E99eA;ED4BQ;IAOI,0BAAA;E1E+7eV;E0Et8eM;IAOI,gCAAA;E1Ek8eV;E0Ez8eM;IAOI,yBAAA;E1Eq8eV;E0E58eM;IAOI,wBAAA;E1Ew8eV;E0E/8eM;IAOI,+BAAA;E1E28eV;E0El9eM;IAOI,yBAAA;E1E88eV;E0Er9eM;IAOI,6BAAA;E1Ei9eV;E0Ex9eM;IAOI,8BAAA;E1Eo9eV;E0E39eM;IAOI,wBAAA;E1Eu9eV;E0E99eM;IAOI,+BAAA;E1E09eV;E0Ej+eM;IAOI,wBAAA;E1E69eV;AACF;A4EvifA;;EAEC,2GAAA;EACA,4DAAA;EACA,kCAAA;EACA,4DAAA;EACA,0BAAA;EACA,qCAAA;EACC,0BAAA;EACA,oCAAA;EACA,yCAAA;EACA,iCAAA;EACA,2BAAA;EACA,mEAAA;EACA,mCAAA;EACA,uCAAA;EACA,yCAAA;EACA,mCAAA;EACD,oEAAA;EACC,kEAAA;EACA,+CAAA;EACA,gDAAA;EACA,qDAAA;EACA,4BAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACA,yCAAA;EACA,kDAAA;EACA,8CAAA;A5EyifF;;AMvjfI;EsEmBF,8FAAA;EACA,4DAAA;EACA,kCAAA;EACA,4DAAA;EACA,0BAAA;EACA,qCAAA;EACA,0BAAA;EACA,iCAAA;EACA,+CAAA;EACA,uCAAA;EACA,0CAAA;EACA,mEAAA;EACA,mCAAA;EACA,6CAAA;EACC,0DAAA;EACA,mCAAA;EACD,oEAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACC,kDAAA;EACD,2CAAA;EACA,kEAAA;EACA,+CAAA;EACA,gDAAA;EACE,wDAAA;EACD,qDAAA;EACA,0CAAA;A5EwifH;;A6ErmfA;EACC,YAAA;EACA,mCAAA;EACA,4CAAA;A7EwmfD;A6EtmfC;EACG,WAAA;EACF,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;A7EwmfF;A6EtmfC;EACC,WAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,mCAAA;EACA,4CAAA;EACA,yCAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;EACA,kCAAA;EACA,sBAAA;A7EwmfF;;A6ErmfA;EACC,gBAAA;EACA,uCAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;A7EwmfD;A6ElmfC;EACC,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,8BAAA;EACA,6BAAA;EACA,yCAAA;EACA,6CAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;A7EomfF;A6ElmfC;EACC,2BAAA;EACA,0BAAA;A7EomfF;;A8EnqfA,kBAAA;AC8BE;EAcE,sBAAA;A/E4nfJ;;A+E1ofE;EAcE,sBAAA;A/EgofJ;;A+E9ofE;EAcE,sBAAA;A/EoofJ;;A+ElpfE;EAcE,sBAAA;A/EwofJ;;A+EtpfE;EAcE,sBAAA;A/E4ofJ;;A+E1pfE;EAcE,sBAAA;A/EgpfJ;;A+E9pfE;EAcE,sBAAA;A/EopfJ;;A+ElqfE;EAcE,sBAAA;A/EwpfJ;;A+EtqfE;EAcE,sBAAA;A/E4pfJ;;A+E1qfE;EAcE,uBAAA;A/EgqfJ;;A+E9qfE;EAcE,sBAAA;A/EoqfJ;;A+ElrfE;EAcE,uBAAA;A/EwqfJ;;A+EtrfE;EAcE,uBAAA;A/E4qfJ;;A+E1rfE;EAcE,uBAAA;A/EgrfJ;;A+E9rfE;EAcE,uBAAA;A/EorfJ;;A+ElsfE;EAcE,uBAAA;A/EwrfJ;;A+EtsfE;EAcE,uBAAA;A/E4rfJ;;A+E1sfE;EAcE,uBAAA;A/EgsfJ;;A+E9sfE;EAcE,uBAAA;A/EosfJ;;A+EltfE;EAcE,uBAAA;A/EwsfJ;;A+EttfE;EAcE,0BAAA;A/E4sfJ;;A+E1tfE;EAcE,0BAAA;A/EgtfJ;;A+E9tfE;EAcE,0BAAA;A/EotfJ;;A+ElufE;EAcE,0BAAA;A/EwtfJ;;A+EtufE;EAcE,0BAAA;A/E4tfJ;;A+E1ufE;EAcE,0BAAA;A/EgufJ;;A+E9ufE;EAcE,0BAAA;A/EoufJ;;A+ElvfE;EAcE,0BAAA;A/EwufJ;;A+EtvfE;EAcE,0BAAA;A/E4ufJ;;A+E1vfE;EAcE,2BAAA;A/EgvfJ;;A+E9vfE;EAcE,0BAAA;A/EovfJ;;A+ElwfE;EAcE,2BAAA;A/EwvfJ;;A+EtwfE;EAcE,2BAAA;A/E4vfJ;;A+E1wfE;EAcE,2BAAA;A/EgwfJ;;A+E9wfE;EAcE,2BAAA;A/EowfJ;;A+ElxfE;EAcE,2BAAA;A/EwwfJ;;A+EtxfE;EAcE,2BAAA;A/E4wfJ;;A+E1xfE;EAcE,2BAAA;A/EgxfJ;;A+E9xfE;EAcE,2BAAA;A/EoxfJ;;A+ElyfE;EAcE,2BAAA;A/EwxfJ;;A+EtyfE;EAcE,4BAAA;A/E4xfJ;;A+E1yfE;EAcE,4BAAA;A/EgyfJ;;A+E9yfE;EAcE,4BAAA;A/EoyfJ;;A+ElzfE;EAcE,4BAAA;A/EwyfJ;;A+EtzfE;EAcE,4BAAA;A/E4yfJ;;A+E1zfE;EAcE,4BAAA;A/EgzfJ;;A+E9zfE;EAcE,4BAAA;A/EozfJ;;A+El0fE;EAcE,4BAAA;A/EwzfJ;;A+Et0fE;EAcE,4BAAA;A/E4zfJ;;A+E10fE;EAcE,6BAAA;A/Eg0fJ;;A+E90fE;EAcE,4BAAA;A/Eo0fJ;;A+El1fE;EAcE,6BAAA;A/Ew0fJ;;A+Et1fE;EAcE,6BAAA;A/E40fJ;;A+E11fE;EAcE,6BAAA;A/Eg1fJ;;A+E91fE;EAcE,6BAAA;A/Eo1fJ;;A+El2fE;EAcE,6BAAA;A/Ew1fJ;;A+Et2fE;EAcE,6BAAA;A/E41fJ;;A+E12fE;EAcE,6BAAA;A/Eg2fJ;;A+E92fE;EAcE,6BAAA;A/Eo2fJ;;A+El3fE;EAcE,6BAAA;A/Ew2fJ;;A+Et3fE;EAcE,6BAAA;A/E42fJ;;A+E13fE;EAcE,6BAAA;A/Eg3fJ;;A+E93fE;EAcE,6BAAA;A/Eo3fJ;;A+El4fE;EAcE,6BAAA;A/Ew3fJ;;A+Et4fE;EAcE,6BAAA;A/E43fJ;;A+E14fE;EAcE,6BAAA;A/Eg4fJ;;A+E94fE;EAcE,6BAAA;A/Eo4fJ;;A+El5fE;EAcE,6BAAA;A/Ew4fJ;;A+Et5fE;EAcE,6BAAA;A/E44fJ;;A+E15fE;EAcE,8BAAA;A/Eg5fJ;;A+E95fE;EAcE,6BAAA;A/Eo5fJ;;A+El6fE;EAcE,8BAAA;A/Ew5fJ;;A+Et6fE;EAcE,8BAAA;A/E45fJ;;A+E16fE;EAcE,8BAAA;A/Eg6fJ;;A+E96fE;EAcE,8BAAA;A/Eo6fJ;;A+El7fE;EAcE,8BAAA;A/Ew6fJ;;A+Et7fE;EAcE,8BAAA;A/E46fJ;;A+E17fE;EAcE,8BAAA;A/Eg7fJ;;A+E97fE;EAcE,8BAAA;A/Eo7fJ;;A+El8fE;EAcE,8BAAA;A/Ew7fJ;;A+Et8fE;EAcE,2BAAA;A/E47fJ;;A+E18fE;EAcE,2BAAA;A/Eg8fJ;;A+E98fE;EAcE,2BAAA;A/Eo8fJ;;A+El9fE;EAcE,2BAAA;A/Ew8fJ;;A+Et9fE;EAcE,2BAAA;A/E48fJ;;A+E19fE;EAcE,2BAAA;A/Eg9fJ;;A+E99fE;EAcE,2BAAA;A/Eo9fJ;;A+El+fE;EAcE,2BAAA;A/Ew9fJ;;A+Et+fE;EAcE,2BAAA;A/E49fJ;;A+E1+fE;EAcE,4BAAA;A/Eg+fJ;;A+E9+fE;EAcE,2BAAA;A/Eo+fJ;;A+El/fE;EAcE,4BAAA;A/Ew+fJ;;A+Et/fE;EAcE,4BAAA;A/E4+fJ;;A+E1/fE;EAcE,4BAAA;A/Eg/fJ;;A+E9/fE;EAcE,4BAAA;A/Eo/fJ;;A+ElggBE;EAcE,4BAAA;A/Ew/fJ;;A+EtggBE;EAcE,4BAAA;A/E4/fJ;;A+E1ggBE;EAcE,4BAAA;A/EgggBJ;;A+E9ggBE;EAcE,4BAAA;A/EoggBJ;;A+ElhgBE;EAcE,4BAAA;A/EwggBJ;;A+EthgBE;EAEE,2BAAA;EACA,4BAAA;A/EwhgBJ;;A+E3hgBE;EAEE,2BAAA;EACA,4BAAA;A/E6hgBJ;;A+EhigBE;EAEE,2BAAA;EACA,4BAAA;A/EkigBJ;;A+ErigBE;EAEE,2BAAA;EACA,4BAAA;A/EuigBJ;;A+E1igBE;EAEE,2BAAA;EACA,4BAAA;A/E4igBJ;;A+E/igBE;EAEE,2BAAA;EACA,4BAAA;A/EijgBJ;;A+EpjgBE;EAEE,2BAAA;EACA,4BAAA;A/EsjgBJ;;A+EzjgBE;EAEE,2BAAA;EACA,4BAAA;A/E2jgBJ;;A+E9jgBE;EAEE,2BAAA;EACA,4BAAA;A/EgkgBJ;;A+EnkgBE;EAEE,4BAAA;EACA,6BAAA;A/EqkgBJ;;A+ExkgBE;EAEE,2BAAA;EACA,4BAAA;A/E0kgBJ;;A+E7kgBE;EAEE,4BAAA;EACA,6BAAA;A/E+kgBJ;;A+EllgBE;EAEE,4BAAA;EACA,6BAAA;A/EolgBJ;;A+EvlgBE;EAEE,4BAAA;EACA,6BAAA;A/EylgBJ;;A+E5lgBE;EAEE,4BAAA;EACA,6BAAA;A/E8lgBJ;;A+EjmgBE;EAEE,4BAAA;EACA,6BAAA;A/EmmgBJ;;A+EtmgBE;EAEE,4BAAA;EACA,6BAAA;A/EwmgBJ;;A+E3mgBE;EAEE,4BAAA;EACA,6BAAA;A/E6mgBJ;;A+EhngBE;EAEE,4BAAA;EACA,6BAAA;A/EkngBJ;;A+ErngBE;EAEE,4BAAA;EACA,6BAAA;A/EungBJ;;A+E1ngBE;EAKE,0BAAA;EACA,6BAAA;A/EyngBJ;;A+E/ngBE;EAKE,0BAAA;EACA,6BAAA;A/E8ngBJ;;A+EpogBE;EAKE,0BAAA;EACA,6BAAA;A/EmogBJ;;A+EzogBE;EAKE,0BAAA;EACA,6BAAA;A/EwogBJ;;A+E9ogBE;EAKE,0BAAA;EACA,6BAAA;A/E6ogBJ;;A+EnpgBE;EAKE,0BAAA;EACA,6BAAA;A/EkpgBJ;;A+ExpgBE;EAKE,0BAAA;EACA,6BAAA;A/EupgBJ;;A+E7pgBE;EAKE,0BAAA;EACA,6BAAA;A/E4pgBJ;;A+ElqgBE;EAKE,0BAAA;EACA,6BAAA;A/EiqgBJ;;A+EvqgBE;EAKE,2BAAA;EACA,8BAAA;A/EsqgBJ;;A+E5qgBE;EAKE,0BAAA;EACA,6BAAA;A/E2qgBJ;;A+EjrgBE;EAKE,2BAAA;EACA,8BAAA;A/EgrgBJ;;A+EtrgBE;EAKE,2BAAA;EACA,8BAAA;A/EqrgBJ;;A+E3rgBE;EAKE,2BAAA;EACA,8BAAA;A/E0rgBJ;;A+EhsgBE;EAKE,2BAAA;EACA,8BAAA;A/E+rgBJ;;A+ErsgBE;EAKE,2BAAA;EACA,8BAAA;A/EosgBJ;;A+E1sgBE;EAKE,2BAAA;EACA,8BAAA;A/EysgBJ;;A+E/sgBE;EAKE,2BAAA;EACA,8BAAA;A/E8sgBJ;;A+EptgBE;EAKE,2BAAA;EACA,8BAAA;A/EmtgBJ;;A+EztgBE;EAKE,2BAAA;EACA,8BAAA;A/EwtgBJ;;A8ElvgBA,mBAAA;ACoBE;EAcE,uBAAA;A/EqtgBJ;;A+EnugBE;EAcE,uBAAA;A/EytgBJ;;A+EvugBE;EAcE,uBAAA;A/E6tgBJ;;A+E3ugBE;EAcE,uBAAA;A/EiugBJ;;A+E/ugBE;EAcE,uBAAA;A/EqugBJ;;A+EnvgBE;EAcE,uBAAA;A/EyugBJ;;A+EvvgBE;EAcE,uBAAA;A/E6ugBJ;;A+E3vgBE;EAcE,uBAAA;A/EivgBJ;;A+E/vgBE;EAcE,uBAAA;A/EqvgBJ;;A+EnwgBE;EAcE,wBAAA;A/EyvgBJ;;A+EvwgBE;EAcE,uBAAA;A/E6vgBJ;;A+E3wgBE;EAcE,wBAAA;A/EiwgBJ;;A+E/wgBE;EAcE,wBAAA;A/EqwgBJ;;A+EnxgBE;EAcE,wBAAA;A/EywgBJ;;A+EvxgBE;EAcE,wBAAA;A/E6wgBJ;;A+E3xgBE;EAcE,wBAAA;A/EixgBJ;;A+E/xgBE;EAcE,wBAAA;A/EqxgBJ;;A+EnygBE;EAcE,wBAAA;A/EyxgBJ;;A+EvygBE;EAcE,wBAAA;A/E6xgBJ;;A+E3ygBE;EAcE,wBAAA;A/EiygBJ;;A+E/ygBE;EAcE,2BAAA;A/EqygBJ;;A+EnzgBE;EAcE,2BAAA;A/EyygBJ;;A+EvzgBE;EAcE,2BAAA;A/E6ygBJ;;A+E3zgBE;EAcE,2BAAA;A/EizgBJ;;A+E/zgBE;EAcE,2BAAA;A/EqzgBJ;;A+En0gBE;EAcE,2BAAA;A/EyzgBJ;;A+Ev0gBE;EAcE,2BAAA;A/E6zgBJ;;A+E30gBE;EAcE,2BAAA;A/Ei0gBJ;;A+E/0gBE;EAcE,2BAAA;A/Eq0gBJ;;A+En1gBE;EAcE,4BAAA;A/Ey0gBJ;;A+Ev1gBE;EAcE,2BAAA;A/E60gBJ;;A+E31gBE;EAcE,4BAAA;A/Ei1gBJ;;A+E/1gBE;EAcE,4BAAA;A/Eq1gBJ;;A+En2gBE;EAcE,4BAAA;A/Ey1gBJ;;A+Ev2gBE;EAcE,4BAAA;A/E61gBJ;;A+E32gBE;EAcE,4BAAA;A/Ei2gBJ;;A+E/2gBE;EAcE,4BAAA;A/Eq2gBJ;;A+En3gBE;EAcE,4BAAA;A/Ey2gBJ;;A+Ev3gBE;EAcE,4BAAA;A/E62gBJ;;A+E33gBE;EAcE,4BAAA;A/Ei3gBJ;;A+E/3gBE;EAcE,6BAAA;A/Eq3gBJ;;A+En4gBE;EAcE,6BAAA;A/Ey3gBJ;;A+Ev4gBE;EAcE,6BAAA;A/E63gBJ;;A+E34gBE;EAcE,6BAAA;A/Ei4gBJ;;A+E/4gBE;EAcE,6BAAA;A/Eq4gBJ;;A+En5gBE;EAcE,6BAAA;A/Ey4gBJ;;A+Ev5gBE;EAcE,6BAAA;A/E64gBJ;;A+E35gBE;EAcE,6BAAA;A/Ei5gBJ;;A+E/5gBE;EAcE,6BAAA;A/Eq5gBJ;;A+En6gBE;EAcE,8BAAA;A/Ey5gBJ;;A+Ev6gBE;EAcE,6BAAA;A/E65gBJ;;A+E36gBE;EAcE,8BAAA;A/Ei6gBJ;;A+E/6gBE;EAcE,8BAAA;A/Eq6gBJ;;A+En7gBE;EAcE,8BAAA;A/Ey6gBJ;;A+Ev7gBE;EAcE,8BAAA;A/E66gBJ;;A+E37gBE;EAcE,8BAAA;A/Ei7gBJ;;A+E/7gBE;EAcE,8BAAA;A/Eq7gBJ;;A+En8gBE;EAcE,8BAAA;A/Ey7gBJ;;A+Ev8gBE;EAcE,8BAAA;A/E67gBJ;;A+E38gBE;EAcE,8BAAA;A/Ei8gBJ;;A+E/8gBE;EAcE,8BAAA;A/Eq8gBJ;;A+En9gBE;EAcE,8BAAA;A/Ey8gBJ;;A+Ev9gBE;EAcE,8BAAA;A/E68gBJ;;A+E39gBE;EAcE,8BAAA;A/Ei9gBJ;;A+E/9gBE;EAcE,8BAAA;A/Eq9gBJ;;A+En+gBE;EAcE,8BAAA;A/Ey9gBJ;;A+Ev+gBE;EAcE,8BAAA;A/E69gBJ;;A+E3+gBE;EAcE,8BAAA;A/Ei+gBJ;;A+E/+gBE;EAcE,8BAAA;A/Eq+gBJ;;A+En/gBE;EAcE,+BAAA;A/Ey+gBJ;;A+Ev/gBE;EAcE,8BAAA;A/E6+gBJ;;A+E3/gBE;EAcE,+BAAA;A/Ei/gBJ;;A+E//gBE;EAcE,+BAAA;A/Eq/gBJ;;A+EnghBE;EAcE,+BAAA;A/Ey/gBJ;;A+EvghBE;EAcE,+BAAA;A/E6/gBJ;;A+E3ghBE;EAcE,+BAAA;A/EighBJ;;A+E/ghBE;EAcE,+BAAA;A/EqghBJ;;A+EnhhBE;EAcE,+BAAA;A/EyghBJ;;A+EvhhBE;EAcE,+BAAA;A/E6ghBJ;;A+E3hhBE;EAcE,+BAAA;A/EihhBJ;;A+E/hhBE;EAcE,4BAAA;A/EqhhBJ;;A+EnihBE;EAcE,4BAAA;A/EyhhBJ;;A+EvihBE;EAcE,4BAAA;A/E6hhBJ;;A+E3ihBE;EAcE,4BAAA;A/EiihBJ;;A+E/ihBE;EAcE,4BAAA;A/EqihBJ;;A+EnjhBE;EAcE,4BAAA;A/EyihBJ;;A+EvjhBE;EAcE,4BAAA;A/E6ihBJ;;A+E3jhBE;EAcE,4BAAA;A/EijhBJ;;A+E/jhBE;EAcE,4BAAA;A/EqjhBJ;;A+EnkhBE;EAcE,6BAAA;A/EyjhBJ;;A+EvkhBE;EAcE,4BAAA;A/E6jhBJ;;A+E3khBE;EAcE,6BAAA;A/EikhBJ;;A+E/khBE;EAcE,6BAAA;A/EqkhBJ;;A+EnlhBE;EAcE,6BAAA;A/EykhBJ;;A+EvlhBE;EAcE,6BAAA;A/E6khBJ;;A+E3lhBE;EAcE,6BAAA;A/EilhBJ;;A+E/lhBE;EAcE,6BAAA;A/EqlhBJ;;A+EnmhBE;EAcE,6BAAA;A/EylhBJ;;A+EvmhBE;EAcE,6BAAA;A/E6lhBJ;;A+E3mhBE;EAcE,6BAAA;A/EimhBJ;;A+E/mhBE;EAQE,4BAAA;EACA,6BAAA;A/E2mhBJ;;A+EpnhBE;EAQE,4BAAA;EACA,6BAAA;A/EgnhBJ;;A+EznhBE;EAQE,4BAAA;EACA,6BAAA;A/EqnhBJ;;A+E9nhBE;EAQE,4BAAA;EACA,6BAAA;A/E0nhBJ;;A+EnohBE;EAQE,4BAAA;EACA,6BAAA;A/E+nhBJ;;A+ExohBE;EAQE,4BAAA;EACA,6BAAA;A/EoohBJ;;A+E7ohBE;EAQE,4BAAA;EACA,6BAAA;A/EyohBJ;;A+ElphBE;EAQE,4BAAA;EACA,6BAAA;A/E8ohBJ;;A+EvphBE;EAQE,4BAAA;EACA,6BAAA;A/EmphBJ;;A+E5phBE;EAQE,6BAAA;EACA,8BAAA;A/EwphBJ;;A+EjqhBE;EAQE,4BAAA;EACA,6BAAA;A/E6phBJ;;A+EtqhBE;EAQE,6BAAA;EACA,8BAAA;A/EkqhBJ;;A+E3qhBE;EAQE,6BAAA;EACA,8BAAA;A/EuqhBJ;;A+EhrhBE;EAQE,6BAAA;EACA,8BAAA;A/E4qhBJ;;A+ErrhBE;EAQE,6BAAA;EACA,8BAAA;A/EirhBJ;;A+E1rhBE;EAQE,6BAAA;EACA,8BAAA;A/EsrhBJ;;A+E/rhBE;EAQE,6BAAA;EACA,8BAAA;A/E2rhBJ;;A+EpshBE;EAQE,6BAAA;EACA,8BAAA;A/EgshBJ;;A+EzshBE;EAQE,6BAAA;EACA,8BAAA;A/EqshBJ;;A+E9shBE;EAQE,6BAAA;EACA,8BAAA;A/E0shBJ;;A+EnthBE;EAWE,2BAAA;EACA,8BAAA;A/E4shBJ;;A+ExthBE;EAWE,2BAAA;EACA,8BAAA;A/EithBJ;;A+E7thBE;EAWE,2BAAA;EACA,8BAAA;A/EsthBJ;;A+EluhBE;EAWE,2BAAA;EACA,8BAAA;A/E2thBJ;;A+EvuhBE;EAWE,2BAAA;EACA,8BAAA;A/EguhBJ;;A+E5uhBE;EAWE,2BAAA;EACA,8BAAA;A/EquhBJ;;A+EjvhBE;EAWE,2BAAA;EACA,8BAAA;A/E0uhBJ;;A+EtvhBE;EAWE,2BAAA;EACA,8BAAA;A/E+uhBJ;;A+E3vhBE;EAWE,2BAAA;EACA,8BAAA;A/EovhBJ;;A+EhwhBE;EAWE,4BAAA;EACA,+BAAA;A/EyvhBJ;;A+ErwhBE;EAWE,2BAAA;EACA,8BAAA;A/E8vhBJ;;A+E1whBE;EAWE,4BAAA;EACA,+BAAA;A/EmwhBJ;;A+E/whBE;EAWE,4BAAA;EACA,+BAAA;A/EwwhBJ;;A+EpxhBE;EAWE,4BAAA;EACA,+BAAA;A/E6whBJ;;A+EzxhBE;EAWE,4BAAA;EACA,+BAAA;A/EkxhBJ;;A+E9xhBE;EAWE,4BAAA;EACA,+BAAA;A/EuxhBJ;;A+EnyhBE;EAWE,4BAAA;EACA,+BAAA;A/E4xhBJ;;A+ExyhBE;EAWE,4BAAA;EACA,+BAAA;A/EiyhBJ;;A+E7yhBE;EAWE,4BAAA;EACA,+BAAA;A/EsyhBJ;;A+ElzhBE;EAWE,4BAAA;EACA,+BAAA;A/E2yhBJ;;A8El0hBA,gBAAA;AEjBE;EACC,yBAAA;AhFu1hBH;;AgFx1hBE;EACC,yBAAA;AhF21hBH;;AgF51hBE;EACC,yBAAA;AhF+1hBH;;AgFh2hBE;EACC,yBAAA;AhFm2hBH;;AgFp2hBE;EACC,yBAAA;AhFu2hBH;;AgFx2hBE;EACC,yBAAA;AhF22hBH;;AgF52hBE;EACC,yBAAA;AhF+2hBH;;AgFh3hBE;EACC,yBAAA;AhFm3hBH;;AgFp3hBE;EACC,yBAAA;AhFu3hBH;;AgFx3hBE;EACC,yBAAA;AhF23hBH;;AgF53hBE;EACC,0BAAA;AhF+3hBH;;AgFh4hBE;EACC,0BAAA;AhFm4hBH;;AgFp4hBE;EACC,0BAAA;AhFu4hBH;;AgFx4hBE;EACC,0BAAA;AhF24hBH;;AgF54hBE;EACC,0BAAA;AhF+4hBH;;AgFh5hBE;EACC,0BAAA;AhFm5hBH;;AgFp5hBE;EACC,0BAAA;AhFu5hBH;;AgFx5hBE;EACC,0BAAA;AhF25hBH;;AgF55hBE;EACC,0BAAA;AhF+5hBH;;AgFh6hBE;EACC,0BAAA;AhFm6hBH;;AgFp6hBE;EACC,0BAAA;AhFu6hBH;;AgFx6hBE;EACC,0BAAA;AhF26hBH;;AgF56hBE;EACC,0BAAA;AhF+6hBH;;AgFh7hBE;EACC,0BAAA;AhFm7hBH;;AgFp7hBE;EACC,0BAAA;AhFu7hBH;;AgFx7hBE;EACC,0BAAA;AhF27hBH;;AgF57hBE;EACC,0BAAA;AhF+7hBH;;AgFh8hBE;EACC,0BAAA;AhFm8hBH;;AgFp8hBE;EACC,0BAAA;AhFu8hBH;;AgFx8hBE;EACC,0BAAA;AhF28hBH;;AgF58hBE;EACC,0BAAA;AhF+8hBH;;AgFh9hBE;EACC,0BAAA;AhFm9hBH;;AgFp9hBE;EACC,0BAAA;AhFu9hBH;;AgFx9hBE;EACC,0BAAA;AhF29hBH;;AgF59hBE;EACC,0BAAA;AhF+9hBH;;AgFh+hBE;EACC,0BAAA;AhFm+hBH;;AgFp+hBE;EACC,0BAAA;AhFu+hBH;;AgFx+hBE;EACC,0BAAA;AhF2+hBH;;AgF5+hBE;EACC,0BAAA;AhF++hBH;;AgFh/hBE;EACC,0BAAA;AhFm/hBH;;AgFp/hBE;EACC,0BAAA;AhFu/hBH;;AgFx/hBE;EACC,0BAAA;AhF2/hBH;;AgF5/hBE;EACC,0BAAA;AhF+/hBH;;AgFhgiBE;EACC,0BAAA;AhFmgiBH;;AgFpgiBE;EACC,0BAAA;AhFugiBH;;AgFxgiBE;EACC,0BAAA;AhF2giBH;;AgF5giBE;EACC,0BAAA;AhF+giBH;;AgFhhiBE;EACC,0BAAA;AhFmhiBH;;AgFphiBE;EACC,0BAAA;AhFuhiBH;;AgFxhiBE;EACC,0BAAA;AhF2hiBH;;AgF5hiBE;EACC,0BAAA;AhF+hiBH;;AgFhiiBE;EACC,0BAAA;AhFmiiBH;;AgFpiiBE;EACC,0BAAA;AhFuiiBH;;AgFxiiBE;EACC,0BAAA;AhF2iiBH;;AgF5iiBE;EACC,0BAAA;AhF+iiBH;;AgFhjiBE;EACC,0BAAA;AhFmjiBH;;AgFpjiBE;EACC,0BAAA;AhFujiBH;;AgFxjiBE;EACC,0BAAA;AhF2jiBH;;AgF5jiBE;EACC,0BAAA;AhF+jiBH;;AgFhkiBE;EACC,0BAAA;AhFmkiBH;;AgFpkiBE;EACC,0BAAA;AhFukiBH;;AgFxkiBE;EACC,0BAAA;AhF2kiBH;;AgF5kiBE;EACC,0BAAA;AhF+kiBH;;AgFhliBE;EACC,0BAAA;AhFmliBH;;AgFpliBE;EACC,0BAAA;AhFuliBH;;AgFxliBE;EACC,0BAAA;AhF2liBH;;AgF5liBE;EACC,0BAAA;AhF+liBH;;AgFhmiBE;EACC,0BAAA;AhFmmiBH;;AgFpmiBE;EACC,0BAAA;AhFumiBH;;AgFxmiBE;EACC,0BAAA;AhF2miBH;;AgF5miBE;EACC,0BAAA;AhF+miBH;;AgFhniBE;EACC,0BAAA;AhFmniBH;;AgFpniBE;EACC,0BAAA;AhFuniBH;;AgFxniBE;EACC,0BAAA;AhF2niBH;;AgF5niBE;EACC,0BAAA;AhF+niBH;;AgFhoiBE;EACC,0BAAA;AhFmoiBH;;AgFpoiBE;EACC,0BAAA;AhFuoiBH;;AgFxoiBE;EACC,0BAAA;AhF2oiBH;;AgF5oiBE;EACC,0BAAA;AhF+oiBH;;AgFhpiBE;EACC,0BAAA;AhFmpiBH;;AgFppiBE;EACC,0BAAA;AhFupiBH;;AiFtpiBE;EACC,2BAAA;AjFypiBH;;AiF1piBE;EACC,2BAAA;AjF6piBH;;AiF9piBE;EACC,2BAAA;AjFiqiBH;;AiFlqiBE;EACC,2BAAA;AjFqqiBH;;AiFtqiBE;EACC,2BAAA;AjFyqiBH;;AiF1qiBE;EACC,2BAAA;AjF6qiBH;;AiF9qiBE;EACC,2BAAA;AjFiriBH;;AiFlriBE;EACC,2BAAA;AjFqriBH;;A8EnqiBA,8BAAA;AACA;EAAS,iBAAA;A9EuqiBT;;A8EtqiBA;EAAY,oBAAA;A9E0qiBZ;;A8EzqiBA;EAAW,kBAAA;A9E6qiBX;;A8E5qiBA;EAAS,mBAAA;A9EgriBT;;A8E/qiBA;EAAY,oBAAA;A9EmriBZ;;A8ElriBA;EAAe,uBAAA;A9EsriBf;;A8ErriBA;EAAc,qBAAA;A9EyriBd;;A8ExriBA;EAAY,sBAAA;A9E4riBZ;;A8E1riBA,gBAAA;AACA;EAAkB,qCAAA;A9E8riBlB;;A8E7riBA;EAAiB,wCAAA;EAA0C,+CAAA;A9EksiB3D;;A8EjsiBA;EAAiB,yBAAA;A9EqsiBjB;;A8EnsiBA,gBAAA;AIlCE;EACC,qBAAA;AlFyuiBH;;AkFvuiBE;EACC,qBAAA;AlF0uiBH;;AkF9uiBE;EACC,sBAAA;AlFiviBH;;AkF/uiBE;EACC,qBAAA;AlFkviBH;;AkFtviBE;EACC,sBAAA;AlFyviBH;;AkFvviBE;EACC,qBAAA;AlF0viBH;;AkF9viBE;EACC,sBAAA;AlFiwiBH;;AkF/viBE;EACC,qBAAA;AlFkwiBH;;AkFtwiBE;EACC,sBAAA;AlFywiBH;;AkFvwiBE;EACC,qBAAA;AlF0wiBH;;AkF9wiBE;EACC,sBAAA;AlFixiBH;;AkF/wiBE;EACC,qBAAA;AlFkxiBH;;AkFtxiBE;EACC,sBAAA;AlFyxiBH;;AkFvxiBE;EACC,qBAAA;AlF0xiBH;;AkF9xiBE;EACC,sBAAA;AlFiyiBH;;AkF/xiBE;EACC,qBAAA;AlFkyiBH;;AkFtyiBE;EACC,sBAAA;AlFyyiBH;;AkFvyiBE;EACC,qBAAA;AlF0yiBH;;AkF9yiBE;EACC,sBAAA;AlFiziBH;;AkF/yiBE;EACC,sBAAA;AlFkziBH;;AkFtziBE;EACC,sBAAA;AlFyziBH;;AkFvziBE;EACC,sBAAA;AlF0ziBH;;AkF9ziBE;EACC,sBAAA;AlFi0iBH;;AkF/ziBE;EACC,sBAAA;AlFk0iBH;;AkFt0iBE;EACC,sBAAA;AlFy0iBH;;AkFv0iBE;EACC,sBAAA;AlF00iBH;;AkF90iBE;EACC,sBAAA;AlFi1iBH;;AkF/0iBE;EACC,sBAAA;AlFk1iBH;;AkFt1iBE;EACC,sBAAA;AlFy1iBH;;AkFv1iBE;EACC,sBAAA;AlF01iBH;;AkF91iBE;EACC,sBAAA;AlFi2iBH;;AkF/1iBE;EACC,sBAAA;AlFk2iBH;;AkFt2iBE;EACC,sBAAA;AlFy2iBH;;AkFv2iBE;EACC,sBAAA;AlF02iBH;;AkF92iBE;EACC,sBAAA;AlFi3iBH;;AkF/2iBE;EACC,sBAAA;AlFk3iBH;;AkFt3iBE;EACC,sBAAA;AlFy3iBH;;AkFv3iBE;EACC,sBAAA;AlF03iBH;;AkF93iBE;EACC,uBAAA;AlFi4iBH;;AkF/3iBE;EACC,sBAAA;AlFk4iBH;;AkFt4iBE;EACC,uBAAA;AlFy4iBH;;AkFv4iBE;EACC,sBAAA;AlF04iBH;;AkF94iBE;EACC,uBAAA;AlFi5iBH;;AkF/4iBE;EACC,sBAAA;AlFk5iBH;;AkFt5iBE;EACC,uBAAA;AlFy5iBH;;AkFv5iBE;EACC,sBAAA;AlF05iBH;;AkF95iBE;EACC,uBAAA;AlFi6iBH;;AkF/5iBE;EACC,sBAAA;AlFk6iBH;;AkFt6iBE;EACC,uBAAA;AlFy6iBH;;AkFv6iBE;EACC,sBAAA;AlF06iBH;;AkF96iBE;EACC,uBAAA;AlFi7iBH;;AkF/6iBE;EACC,sBAAA;AlFk7iBH;;AkFt7iBE;EACC,uBAAA;AlFy7iBH;;AkFv7iBE;EACC,sBAAA;AlF07iBH;;AkF97iBE;EACC,uBAAA;AlFi8iBH;;AkF/7iBE;EACC,sBAAA;AlFk8iBH;;AkFt8iBE;EACC,uBAAA;AlFy8iBH;;AkFv8iBE;EACC,sBAAA;AlF08iBH;;AkF98iBE;EACC,uBAAA;AlFi9iBH;;AkF/8iBE;EACC,sBAAA;AlFk9iBH;;AkFt9iBE;EACC,uBAAA;AlFy9iBH;;AkFv9iBE;EACC,sBAAA;AlF09iBH;;AkF99iBE;EACC,uBAAA;AlFi+iBH;;AkF/9iBE;EACC,sBAAA;AlFk+iBH;;AkFt+iBE;EACC,uBAAA;AlFy+iBH;;AkFv+iBE;EACC,sBAAA;AlF0+iBH;;AkF9+iBE;EACC,uBAAA;AlFi/iBH;;AkF/+iBE;EACC,sBAAA;AlFk/iBH;;AkFt/iBE;EACC,uBAAA;AlFy/iBH;;AkFv/iBE;EACC,sBAAA;AlF0/iBH;;AkF9/iBE;EACC,uBAAA;AlFigjBH;;AkF//iBE;EACC,sBAAA;AlFkgjBH;;AkFtgjBE;EACC,uBAAA;AlFygjBH;;AkFvgjBE;EACC,sBAAA;AlF0gjBH;;AkF9gjBE;EACC,uBAAA;AlFihjBH;;AkF/gjBE;EACC,sBAAA;AlFkhjBH;;AkFthjBE;EACC,uBAAA;AlFyhjBH;;AkFvhjBE;EACC,sBAAA;AlF0hjBH;;AkF9hjBE;EACC,uBAAA;AlFiijBH;;AkF/hjBE;EACC,sBAAA;AlFkijBH;;AkF5hjBE;EACC,uBAAA;AlF+hjBH;;AkFhijBE;EACC,uBAAA;AlFmijBH;;AkFpijBE;EACC,uBAAA;AlFuijBH;;AkFxijBE;EACC,uBAAA;AlF2ijBH;;AkF5ijBE;EACC,uBAAA;AlF+ijBH;;AkFhjjBE;EACC,uBAAA;AlFmjjBH;;AkFpjjBE;EACC,uBAAA;AlFujjBH;;AkFxjjBE;EACC,uBAAA;AlF2jjBH;;AkFtkjBE;EACC,sBAAA;AlFykjBH;;AkFvkjBE;EACC,sBAAA;AlF0kjBH;;AkF9kjBE;EACC,uBAAA;AlFiljBH;;AkF/kjBE;EACC,sBAAA;AlFkljBH;;AkFtljBE;EACC,uBAAA;AlFyljBH;;AkFvljBE;EACC,sBAAA;AlF0ljBH;;AkF9ljBE;EACC,uBAAA;AlFimjBH;;AkF/ljBE;EACC,sBAAA;AlFkmjBH;;AkFtmjBE;EACC,uBAAA;AlFymjBH;;AkFvmjBE;EACC,sBAAA;AlF0mjBH;;AkF9mjBE;EACC,uBAAA;AlFinjBH;;AkF/mjBE;EACC,sBAAA;AlFknjBH;;AkFtnjBE;EACC,uBAAA;AlFynjBH;;AkFvnjBE;EACC,sBAAA;AlF0njBH;;AkF9njBE;EACC,uBAAA;AlFiojBH;;AkF/njBE;EACC,sBAAA;AlFkojBH;;AkFtojBE;EACC,uBAAA;AlFyojBH;;AkFvojBE;EACC,sBAAA;AlF0ojBH;;AkF9ojBE;EACC,uBAAA;AlFipjBH;;AkF/ojBE;EACC,uBAAA;AlFkpjBH;;AkFtpjBE;EACC,uBAAA;AlFypjBH;;AkFvpjBE;EACC,uBAAA;AlF0pjBH;;AkF9pjBE;EACC,uBAAA;AlFiqjBH;;AkF/pjBE;EACC,uBAAA;AlFkqjBH;;AkFtqjBE;EACC,uBAAA;AlFyqjBH;;AkFvqjBE;EACC,uBAAA;AlF0qjBH;;AkF9qjBE;EACC,uBAAA;AlFirjBH;;AkF/qjBE;EACC,uBAAA;AlFkrjBH;;AkFtrjBE;EACC,uBAAA;AlFyrjBH;;AkFvrjBE;EACC,uBAAA;AlF0rjBH;;AkF9rjBE;EACC,uBAAA;AlFisjBH;;AkF/rjBE;EACC,uBAAA;AlFksjBH;;AkFtsjBE;EACC,uBAAA;AlFysjBH;;AkFvsjBE;EACC,uBAAA;AlF0sjBH;;AkF9sjBE;EACC,uBAAA;AlFitjBH;;AkF/sjBE;EACC,uBAAA;AlFktjBH;;AkFttjBE;EACC,uBAAA;AlFytjBH;;AkFvtjBE;EACC,uBAAA;AlF0tjBH;;AkF9tjBE;EACC,wBAAA;AlFiujBH;;AkF/tjBE;EACC,uBAAA;AlFkujBH;;AkFtujBE;EACC,wBAAA;AlFyujBH;;AkFvujBE;EACC,uBAAA;AlF0ujBH;;AkF9ujBE;EACC,wBAAA;AlFivjBH;;AkF/ujBE;EACC,uBAAA;AlFkvjBH;;AkFtvjBE;EACC,wBAAA;AlFyvjBH;;AkFvvjBE;EACC,uBAAA;AlF0vjBH;;AkF9vjBE;EACC,wBAAA;AlFiwjBH;;AkF/vjBE;EACC,uBAAA;AlFkwjBH;;AkFtwjBE;EACC,wBAAA;AlFywjBH;;AkFvwjBE;EACC,uBAAA;AlF0wjBH;;AkF9wjBE;EACC,wBAAA;AlFixjBH;;AkF/wjBE;EACC,uBAAA;AlFkxjBH;;AkFtxjBE;EACC,wBAAA;AlFyxjBH;;AkFvxjBE;EACC,uBAAA;AlF0xjBH;;AkF9xjBE;EACC,wBAAA;AlFiyjBH;;AkF/xjBE;EACC,uBAAA;AlFkyjBH;;AkFtyjBE;EACC,wBAAA;AlFyyjBH;;AkFvyjBE;EACC,uBAAA;AlF0yjBH;;AkF9yjBE;EACC,wBAAA;AlFizjBH;;AkF/yjBE;EACC,uBAAA;AlFkzjBH;;AkFtzjBE;EACC,wBAAA;AlFyzjBH;;AkFvzjBE;EACC,uBAAA;AlF0zjBH;;AkF9zjBE;EACC,wBAAA;AlFi0jBH;;AkF/zjBE;EACC,uBAAA;AlFk0jBH;;AkFt0jBE;EACC,wBAAA;AlFy0jBH;;AkFv0jBE;EACC,uBAAA;AlF00jBH;;AkF90jBE;EACC,wBAAA;AlFi1jBH;;AkF/0jBE;EACC,uBAAA;AlFk1jBH;;AkFt1jBE;EACC,wBAAA;AlFy1jBH;;AkFv1jBE;EACC,uBAAA;AlF01jBH;;AkF91jBE;EACC,wBAAA;AlFi2jBH;;AkF/1jBE;EACC,uBAAA;AlFk2jBH;;AkFt2jBE;EACC,wBAAA;AlFy2jBH;;AkFv2jBE;EACC,uBAAA;AlF02jBH;;AkF92jBE;EACC,wBAAA;AlFi3jBH;;AkF/2jBE;EACC,uBAAA;AlFk3jBH;;AkFt3jBE;EACC,wBAAA;AlFy3jBH;;AkFv3jBE;EACC,uBAAA;AlF03jBH;;AkF93jBE;EACC,wBAAA;AlFi4jBH;;AkF/3jBE;EACC,uBAAA;AlFk4jBH;;AkF53jBE;EACC,wBAAA;AlF+3jBH;;AkFh4jBE;EACC,wBAAA;AlFm4jBH;;AkFp4jBE;EACC,wBAAA;AlFu4jBH;;AkFx4jBE;EACC,wBAAA;AlF24jBH;;AkF54jBE;EACC,wBAAA;AlF+4jBH;;AkFh5jBE;EACC,wBAAA;AlFm5jBH;;AkFp5jBE;EACC,wBAAA;AlFu5jBH;;AkFx5jBE;EACC,wBAAA;AlF25jBH;;A8Eh4jBA,iBAAA;AKzCE;EACA,uDAAA;EAGA,8JAAA;EACA,sJAAA;AnF66jBF;;AmFt6jBE;EACA,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;AnFy6jBF;;AmFt6jBE;EACC,oBAAA;EACA,sEAAA;AnFy6jBH;;AmFv6jBE;EACC,kBAAA;EACA,+EAAA;AnF06jBH;;AmFx6jBE;EACC,oBAAA;EACA,qEAAA;AnF26jBH;;AmFz6jBE;EACC,kBAAA;EACA,8EAAA;AnF46jBH;;AmF17jBE;EACC,oBAAA;EACA,sEAAA;AnF67jBH;;AmF37jBE;EACC,kBAAA;EACA,+EAAA;AnF87jBH;;AmF57jBE;EACC,oBAAA;EACA,mEAAA;AnF+7jBH;;AmF77jBE;EACC,kBAAA;EACA,4EAAA;AnFg8jBH;;AmF98jBE;EACC,oBAAA;EACA,sEAAA;AnFi9jBH;;AmF/8jBE;EACC,kBAAA;EACA,+EAAA;AnFk9jBH;;AmFh9jBE;EACC,oBAAA;EACA,mEAAA;AnFm9jBH;;AmFj9jBE;EACC,kBAAA;EACA,4EAAA;AnFo9jBH;;AmFl+jBE;EACC,oBAAA;EACA,sEAAA;AnFq+jBH;;AmFn+jBE;EACC,kBAAA;EACA,+EAAA;AnFs+jBH;;AmFp+jBE;EACC,oBAAA;EACA,mEAAA;AnFu+jBH;;AmFr+jBE;EACC,kBAAA;EACA,4EAAA;AnFw+jBH;;AmFzgkBE;EACA,oCAAA;EAGA,+JAAA;EACA,sJAAA;AnF4gkBF;;AmF1gkBE;EAEC,wCAAA;AnF4gkBH;;AmFzgkBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF4gkBF;;AmFzgkBE;EACC,oBAAA;EACA,mEAAA;AnF4gkBH;;AmF1gkBE;EACC,kBAAA;EACA,4EAAA;AnF6gkBH;;AmF3gkBE;EACC,oBAAA;EACA,iEAAA;AnF8gkBH;;AmF5gkBE;EACC,kBAAA;EACA,0EAAA;AnF+gkBH;;AmF7hkBE;EACC,oBAAA;EACA,mEAAA;AnFgikBH;;AmF9hkBE;EACC,kBAAA;EACA,4EAAA;AnFiikBH;;AmF/hkBE;EACC,oBAAA;EACA,gEAAA;AnFkikBH;;AmFhikBE;EACC,kBAAA;EACA,yEAAA;AnFmikBH;;AmFjjkBE;EACC,oBAAA;EACA,mEAAA;AnFojkBH;;AmFljkBE;EACC,kBAAA;EACA,4EAAA;AnFqjkBH;;AmFnjkBE;EACC,oBAAA;EACA,gEAAA;AnFsjkBH;;AmFpjkBE;EACC,kBAAA;EACA,yEAAA;AnFujkBH;;AmFrkkBE;EACC,oBAAA;EACA,kEAAA;AnFwkkBH;;AmFtkkBE;EACC,kBAAA;EACA,2EAAA;AnFykkBH;;AmFvkkBE;EACC,oBAAA;EACA,+DAAA;AnF0kkBH;;AmFxkkBE;EACC,kBAAA;EACA,wEAAA;AnF2kkBH;;AmF5mkBE;EACA,oCAAA;EAGA,2FAAA;EACA,sJAAA;AnF+mkBF;;AmFxmkBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnF2mkBF;;AmFxmkBE;EACC,oBAAA;EACA,6DAAA;AnF2mkBH;;AmFzmkBE;EACC,kBAAA;EACA,sEAAA;AnF4mkBH;;AmF1mkBE;EACC,oBAAA;EACA,6DAAA;AnF6mkBH;;AmF3mkBE;EACC,kBAAA;EACA,sEAAA;AnF8mkBH;;AmF5nkBE;EACC,oBAAA;EACA,6DAAA;AnF+nkBH;;AmF7nkBE;EACC,kBAAA;EACA,sEAAA;AnFgokBH;;AmF9nkBE;EACC,oBAAA;EACA,6DAAA;AnFiokBH;;AmF/nkBE;EACC,kBAAA;EACA,sEAAA;AnFkokBH;;AmFhpkBE;EACC,oBAAA;EACA,6DAAA;AnFmpkBH;;AmFjpkBE;EACC,kBAAA;EACA,sEAAA;AnFopkBH;;AmFlpkBE;EACC,oBAAA;EACA,6DAAA;AnFqpkBH;;AmFnpkBE;EACC,kBAAA;EACA,sEAAA;AnFspkBH;;AmFpqkBE;EACC,oBAAA;EACA,6DAAA;AnFuqkBH;;AmFrqkBE;EACC,kBAAA;EACA,sEAAA;AnFwqkBH;;AmFtqkBE;EACC,oBAAA;EACA,0DAAA;AnFyqkBH;;AmFvqkBE;EACC,kBAAA;EACA,mEAAA;AnF0qkBH;;AmF3skBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnF8skBF;;AmFvskBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF0skBF;;AmFvskBE;EACC,oBAAA;EACA,iEAAA;AnF0skBH;;AmFxskBE;EACC,kBAAA;EACA,0EAAA;AnF2skBH;;AmFzskBE;EACC,oBAAA;EACA,8DAAA;AnF4skBH;;AmF1skBE;EACC,kBAAA;EACA,uEAAA;AnF6skBH;;AmF3tkBE;EACC,oBAAA;EACA,iEAAA;AnF8tkBH;;AmF5tkBE;EACC,kBAAA;EACA,0EAAA;AnF+tkBH;;AmF7tkBE;EACC,oBAAA;EACA,8DAAA;AnFgukBH;;AmF9tkBE;EACC,kBAAA;EACA,uEAAA;AnFiukBH;;AmF/ukBE;EACC,oBAAA;EACA,iEAAA;AnFkvkBH;;AmFhvkBE;EACC,kBAAA;EACA,0EAAA;AnFmvkBH;;AmFjvkBE;EACC,oBAAA;EACA,8DAAA;AnFovkBH;;AmFlvkBE;EACC,kBAAA;EACA,uEAAA;AnFqvkBH;;AmFnwkBE;EACC,oBAAA;EACA,gEAAA;AnFswkBH;;AmFpwkBE;EACC,kBAAA;EACA,yEAAA;AnFuwkBH;;AmFrwkBE;EACC,oBAAA;EACA,6DAAA;AnFwwkBH;;AmFtwkBE;EACC,kBAAA;EACA,sEAAA;AnFywkBH;;AmF1ykBE;EACA,uDAAA;EAGA,8JAAA;EACA,sJAAA;AnF6ykBF;;AmFtykBE;EACA,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;AnFyykBF;;AmFtykBE;EACC,oBAAA;EACA,sEAAA;AnFyykBH;;AmFvykBE;EACC,kBAAA;EACA,+EAAA;AnF0ykBH;;AmFxykBE;EACC,oBAAA;EACA,qEAAA;AnF2ykBH;;AmFzykBE;EACC,kBAAA;EACA,8EAAA;AnF4ykBH;;AmF1zkBE;EACC,oBAAA;EACA,sEAAA;AnF6zkBH;;AmF3zkBE;EACC,kBAAA;EACA,+EAAA;AnF8zkBH;;AmF5zkBE;EACC,oBAAA;EACA,mEAAA;AnF+zkBH;;AmF7zkBE;EACC,kBAAA;EACA,4EAAA;AnFg0kBH;;AmF90kBE;EACC,oBAAA;EACA,sEAAA;AnFi1kBH;;AmF/0kBE;EACC,kBAAA;EACA,+EAAA;AnFk1kBH;;AmFh1kBE;EACC,oBAAA;EACA,mEAAA;AnFm1kBH;;AmFj1kBE;EACC,kBAAA;EACA,4EAAA;AnFo1kBH;;AmFl2kBE;EACC,oBAAA;EACA,sEAAA;AnFq2kBH;;AmFn2kBE;EACC,kBAAA;EACA,+EAAA;AnFs2kBH;;AmFp2kBE;EACC,oBAAA;EACA,mEAAA;AnFu2kBH;;AmFr2kBE;EACC,kBAAA;EACA,4EAAA;AnFw2kBH;;AmFz4kBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnF44kBF;;AmFr4kBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnFw4kBF;;AmFr4kBE;EACC,oBAAA;EACA,iEAAA;AnFw4kBH;;AmFt4kBE;EACC,kBAAA;EACA,0EAAA;AnFy4kBH;;AmFv4kBE;EACC,oBAAA;EACA,+DAAA;AnF04kBH;;AmFx4kBE;EACC,kBAAA;EACA,wEAAA;AnF24kBH;;AmFz5kBE;EACC,oBAAA;EACA,iEAAA;AnF45kBH;;AmF15kBE;EACC,kBAAA;EACA,0EAAA;AnF65kBH;;AmF35kBE;EACC,oBAAA;EACA,8DAAA;AnF85kBH;;AmF55kBE;EACC,kBAAA;EACA,uEAAA;AnF+5kBH;;AmF76kBE;EACC,oBAAA;EACA,iEAAA;AnFg7kBH;;AmF96kBE;EACC,kBAAA;EACA,0EAAA;AnFi7kBH;;AmF/6kBE;EACC,oBAAA;EACA,8DAAA;AnFk7kBH;;AmFh7kBE;EACC,kBAAA;EACA,uEAAA;AnFm7kBH;;AmFj8kBE;EACC,oBAAA;EACA,gEAAA;AnFo8kBH;;AmFl8kBE;EACC,kBAAA;EACA,yEAAA;AnFq8kBH;;AmFn8kBE;EACC,oBAAA;EACA,6DAAA;AnFs8kBH;;AmFp8kBE;EACC,kBAAA;EACA,sEAAA;AnFu8kBH;;AmFx+kBE;EACA,oCAAA;EAGA,kFAAA;EACA,sJAAA;AnF2+kBF;;AmFp+kBE;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;AnFu+kBF;;AmFp+kBE;EACC,oBAAA;EACA,+DAAA;AnFu+kBH;;AmFr+kBE;EACC,kBAAA;EACA,wEAAA;AnFw+kBH;;AmFt+kBE;EACC,oBAAA;EACA,2DAAA;AnFy+kBH;;AmFv+kBE;EACC,kBAAA;EACA,oEAAA;AnF0+kBH;;AmFx/kBE;EACC,oBAAA;EACA,+DAAA;AnF2/kBH;;AmFz/kBE;EACC,kBAAA;EACA,wEAAA;AnF4/kBH;;AmF1/kBE;EACC,oBAAA;EACA,2DAAA;AnF6/kBH;;AmF3/kBE;EACC,kBAAA;EACA,oEAAA;AnF8/kBH;;AmF5glBE;EACC,oBAAA;EACA,+DAAA;AnF+glBH;;AmF7glBE;EACC,kBAAA;EACA,wEAAA;AnFghlBH;;AmF9glBE;EACC,oBAAA;EACA,0DAAA;AnFihlBH;;AmF/glBE;EACC,kBAAA;EACA,mEAAA;AnFkhlBH;;AmFhilBE;EACC,oBAAA;EACA,6DAAA;AnFmilBH;;AmFjilBE;EACC,kBAAA;EACA,sEAAA;AnFoilBH;;AmFlilBE;EACC,oBAAA;EACA,0DAAA;AnFqilBH;;AmFnilBE;EACC,kBAAA;EACA,mEAAA;AnFsilBH;;AmFvklBE;EACA,oCAAA;EAGA,+JAAA;EACA,sJAAA;AnF0klBF;;AmFnklBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFsklBF;;AmFnklBE;EACC,oBAAA;EACA,mEAAA;AnFsklBH;;AmFpklBE;EACC,kBAAA;EACA,4EAAA;AnFuklBH;;AmFrklBE;EACC,oBAAA;EACA,iEAAA;AnFwklBH;;AmFtklBE;EACC,kBAAA;EACA,0EAAA;AnFyklBH;;AmFvllBE;EACC,oBAAA;EACA,mEAAA;AnF0llBH;;AmFxllBE;EACC,kBAAA;EACA,4EAAA;AnF2llBH;;AmFzllBE;EACC,oBAAA;EACA,gEAAA;AnF4llBH;;AmF1llBE;EACC,kBAAA;EACA,yEAAA;AnF6llBH;;AmF3mlBE;EACC,oBAAA;EACA,mEAAA;AnF8mlBH;;AmF5mlBE;EACC,kBAAA;EACA,4EAAA;AnF+mlBH;;AmF7mlBE;EACC,oBAAA;EACA,gEAAA;AnFgnlBH;;AmF9mlBE;EACC,kBAAA;EACA,yEAAA;AnFinlBH;;AmF/nlBE;EACC,oBAAA;EACA,kEAAA;AnFkolBH;;AmFholBE;EACC,kBAAA;EACA,2EAAA;AnFmolBH;;AmFjolBE;EACC,oBAAA;EACA,+DAAA;AnFoolBH;;AmFlolBE;EACC,kBAAA;EACA,wEAAA;AnFqolBH;;AmFtqlBE;EACA,oCAAA;EAGA,qFAAA;EACA,sJAAA;AnFyqlBF;;AmFlqlBE;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;AnFqqlBF;;AmFlqlBE;EACC,oBAAA;EACA,6DAAA;AnFqqlBH;;AmFnqlBE;EACC,kBAAA;EACA,sEAAA;AnFsqlBH;;AmFpqlBE;EACC,oBAAA;EACA,uDAAA;AnFuqlBH;;AmFrqlBE;EACC,kBAAA;EACA,gEAAA;AnFwqlBH;;AmFtrlBE;EACC,oBAAA;EACA,6DAAA;AnFyrlBH;;AmFvrlBE;EACC,kBAAA;EACA,sEAAA;AnF0rlBH;;AmFxrlBE;EACC,oBAAA;EACA,uDAAA;AnF2rlBH;;AmFzrlBE;EACC,kBAAA;EACA,gEAAA;AnF4rlBH;;AmF1slBE;EACC,oBAAA;EACA,6DAAA;AnF6slBH;;AmF3slBE;EACC,kBAAA;EACA,sEAAA;AnF8slBH;;AmF5slBE;EACC,oBAAA;EACA,uDAAA;AnF+slBH;;AmF7slBE;EACC,kBAAA;EACA,gEAAA;AnFgtlBH;;AmF9tlBE;EACC,oBAAA;EACA,0DAAA;AnFiulBH;;AmF/tlBE;EACC,kBAAA;EACA,mEAAA;AnFkulBH;;AmFhulBE;EACC,oBAAA;EACA,uDAAA;AnFmulBH;;AmFjulBE;EACC,kBAAA;EACA,gEAAA;AnFoulBH;;AmFrwlBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnFwwlBF;;AmFjwlBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFowlBF;;AmFjwlBE;EACC,oBAAA;EACA,+DAAA;AnFowlBH;;AmFlwlBE;EACC,kBAAA;EACA,wEAAA;AnFqwlBH;;AmFnwlBE;EACC,oBAAA;EACA,6DAAA;AnFswlBH;;AmFpwlBE;EACC,kBAAA;EACA,sEAAA;AnFuwlBH;;AmFrxlBE;EACC,oBAAA;EACA,+DAAA;AnFwxlBH;;AmFtxlBE;EACC,kBAAA;EACA,wEAAA;AnFyxlBH;;AmFvxlBE;EACC,oBAAA;EACA,4DAAA;AnF0xlBH;;AmFxxlBE;EACC,kBAAA;EACA,qEAAA;AnF2xlBH;;AmFzylBE;EACC,oBAAA;EACA,+DAAA;AnF4ylBH;;AmF1ylBE;EACC,kBAAA;EACA,wEAAA;AnF6ylBH;;AmF3ylBE;EACC,oBAAA;EACA,2DAAA;AnF8ylBH;;AmF5ylBE;EACC,kBAAA;EACA,oEAAA;AnF+ylBH;;AmF7zlBE;EACC,oBAAA;EACA,8DAAA;AnFg0lBH;;AmF9zlBE;EACC,kBAAA;EACA,uEAAA;AnFi0lBH;;AmF/zlBE;EACC,oBAAA;EACA,2DAAA;AnFk0lBH;;AmFh0lBE;EACC,kBAAA;EACA,oEAAA;AnFm0lBH;;AmFp2lBE;EACA,mDAAA;EAGA,4JAAA;EACA,sJAAA;AnFu2lBF;;AmFh2lBE;EACA,6CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFm2lBF;;AmFh2lBE;EACC,oBAAA;EACA,sEAAA;AnFm2lBH;;AmFj2lBE;EACC,kBAAA;EACA,+EAAA;AnFo2lBH;;AmFl2lBE;EACC,oBAAA;EACA,mEAAA;AnFq2lBH;;AmFn2lBE;EACC,kBAAA;EACA,4EAAA;AnFs2lBH;;AmFp3lBE;EACC,oBAAA;EACA,sEAAA;AnFu3lBH;;AmFr3lBE;EACC,kBAAA;EACA,+EAAA;AnFw3lBH;;AmFt3lBE;EACC,oBAAA;EACA,mEAAA;AnFy3lBH;;AmFv3lBE;EACC,kBAAA;EACA,4EAAA;AnF03lBH;;AmFx4lBE;EACC,oBAAA;EACA,sEAAA;AnF24lBH;;AmFz4lBE;EACC,kBAAA;EACA,+EAAA;AnF44lBH;;AmF14lBE;EACC,oBAAA;EACA,mEAAA;AnF64lBH;;AmF34lBE;EACC,kBAAA;EACA,4EAAA;AnF84lBH;;AmF55lBE;EACC,oBAAA;EACA,qEAAA;AnF+5lBH;;AmF75lBE;EACC,kBAAA;EACA,8EAAA;AnFg6lBH;;AmF95lBE;EACC,oBAAA;EACA,mEAAA;AnFi6lBH;;AmF/5lBE;EACC,kBAAA;EACA,4EAAA;AnFk6lBH;;AmFn8lBE;EACA,oCAAA;EAGA,qFAAA;EACA,sJAAA;AnFs8lBF;;AmF/7lBE;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;AnFk8lBF;;AmF/7lBE;EACC,oBAAA;EACA,6DAAA;AnFk8lBH;;AmFh8lBE;EACC,kBAAA;EACA,sEAAA;AnFm8lBH;;AmFj8lBE;EACC,oBAAA;EACA,uDAAA;AnFo8lBH;;AmFl8lBE;EACC,kBAAA;EACA,gEAAA;AnFq8lBH;;AmFn9lBE;EACC,oBAAA;EACA,6DAAA;AnFs9lBH;;AmFp9lBE;EACC,kBAAA;EACA,sEAAA;AnFu9lBH;;AmFr9lBE;EACC,oBAAA;EACA,uDAAA;AnFw9lBH;;AmFt9lBE;EACC,kBAAA;EACA,gEAAA;AnFy9lBH;;AmFv+lBE;EACC,oBAAA;EACA,6DAAA;AnF0+lBH;;AmFx+lBE;EACC,kBAAA;EACA,sEAAA;AnF2+lBH;;AmFz+lBE;EACC,oBAAA;EACA,uDAAA;AnF4+lBH;;AmF1+lBE;EACC,kBAAA;EACA,gEAAA;AnF6+lBH;;AmF3/lBE;EACC,oBAAA;EACA,0DAAA;AnF8/lBH;;AmF5/lBE;EACC,kBAAA;EACA,mEAAA;AnF+/lBH;;AmF7/lBE;EACC,oBAAA;EACA,uDAAA;AnFggmBH;;AmF9/lBE;EACC,kBAAA;EACA,gEAAA;AnFigmBH;;AmFlimBE;EACA,oCAAA;EAGA,2FAAA;EACA,sJAAA;AnFqimBF;;AmF9hmBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFiimBF;;AmF9hmBE;EACC,oBAAA;EACA,6DAAA;AnFiimBH;;AmF/hmBE;EACC,kBAAA;EACA,sEAAA;AnFkimBH;;AmFhimBE;EACC,oBAAA;EACA,6DAAA;AnFmimBH;;AmFjimBE;EACC,kBAAA;EACA,sEAAA;AnFoimBH;;AmFljmBE;EACC,oBAAA;EACA,6DAAA;AnFqjmBH;;AmFnjmBE;EACC,kBAAA;EACA,sEAAA;AnFsjmBH;;AmFpjmBE;EACC,oBAAA;EACA,6DAAA;AnFujmBH;;AmFrjmBE;EACC,kBAAA;EACA,sEAAA;AnFwjmBH;;AmFtkmBE;EACC,oBAAA;EACA,6DAAA;AnFykmBH;;AmFvkmBE;EACC,kBAAA;EACA,sEAAA;AnF0kmBH;;AmFxkmBE;EACC,oBAAA;EACA,6DAAA;AnF2kmBH;;AmFzkmBE;EACC,kBAAA;EACA,sEAAA;AnF4kmBH;;AmF1lmBE;EACC,oBAAA;EACA,6DAAA;AnF6lmBH;;AmF3lmBE;EACC,kBAAA;EACA,sEAAA;AnF8lmBH;;AmF5lmBE;EACC,oBAAA;EACA,0DAAA;AnF+lmBH;;AmF7lmBE;EACC,kBAAA;EACA,mEAAA;AnFgmmBH;;AmFjomBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnFoomBF;;AmF7nmBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFgomBF;;AmF7nmBE;EACC,oBAAA;EACA,+DAAA;AnFgomBH;;AmF9nmBE;EACC,kBAAA;EACA,wEAAA;AnFiomBH;;AmF/nmBE;EACC,oBAAA;EACA,8DAAA;AnFkomBH;;AmFhomBE;EACC,kBAAA;EACA,uEAAA;AnFmomBH;;AmFjpmBE;EACC,oBAAA;EACA,+DAAA;AnFopmBH;;AmFlpmBE;EACC,kBAAA;EACA,wEAAA;AnFqpmBH;;AmFnpmBE;EACC,oBAAA;EACA,6DAAA;AnFspmBH;;AmFppmBE;EACC,kBAAA;EACA,sEAAA;AnFupmBH;;AmFrqmBE;EACC,oBAAA;EACA,+DAAA;AnFwqmBH;;AmFtqmBE;EACC,kBAAA;EACA,wEAAA;AnFyqmBH;;AmFvqmBE;EACC,oBAAA;EACA,4DAAA;AnF0qmBH;;AmFxqmBE;EACC,kBAAA;EACA,qEAAA;AnF2qmBH;;AmFzrmBE;EACC,oBAAA;EACA,8DAAA;AnF4rmBH;;AmF1rmBE;EACC,kBAAA;EACA,uEAAA;AnF6rmBH;;AmF3rmBE;EACC,oBAAA;EACA,2DAAA;AnF8rmBH;;AmF5rmBE;EACC,kBAAA;EACA,oEAAA;AnF+rmBH;;AmFhumBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnFmumBF;;AmF5tmBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF+tmBF;;AmF5tmBE;EACC,oBAAA;EACA,iEAAA;AnF+tmBH;;AmF7tmBE;EACC,kBAAA;EACA,0EAAA;AnFgumBH;;AmF9tmBE;EACC,oBAAA;EACA,+DAAA;AnFiumBH;;AmF/tmBE;EACC,kBAAA;EACA,wEAAA;AnFkumBH;;AmFhvmBE;EACC,oBAAA;EACA,iEAAA;AnFmvmBH;;AmFjvmBE;EACC,kBAAA;EACA,0EAAA;AnFovmBH;;AmFlvmBE;EACC,oBAAA;EACA,+DAAA;AnFqvmBH;;AmFnvmBE;EACC,kBAAA;EACA,wEAAA;AnFsvmBH;;AmFpwmBE;EACC,oBAAA;EACA,iEAAA;AnFuwmBH;;AmFrwmBE;EACC,kBAAA;EACA,0EAAA;AnFwwmBH;;AmFtwmBE;EACC,oBAAA;EACA,+DAAA;AnFywmBH;;AmFvwmBE;EACC,kBAAA;EACA,wEAAA;AnF0wmBH;;AmFxxmBE;EACC,oBAAA;EACA,gEAAA;AnF2xmBH;;AmFzxmBE;EACC,kBAAA;EACA,yEAAA;AnF4xmBH;;AmF1xmBE;EACC,oBAAA;EACA,6DAAA;AnF6xmBH;;AmF3xmBE;EACC,kBAAA;EACA,sEAAA;AnF8xmBH;;AmF/zmBE;EACA,oCAAA;EAGA,kFAAA;EACA,sJAAA;AnFk0mBF;;AmF3zmBE;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;AnF8zmBF;;AmF3zmBE;EACC,oBAAA;EACA,+DAAA;AnF8zmBH;;AmF5zmBE;EACC,kBAAA;EACA,wEAAA;AnF+zmBH;;AmF7zmBE;EACC,oBAAA;EACA,2DAAA;AnFg0mBH;;AmF9zmBE;EACC,kBAAA;EACA,oEAAA;AnFi0mBH;;AmF/0mBE;EACC,oBAAA;EACA,+DAAA;AnFk1mBH;;AmFh1mBE;EACC,kBAAA;EACA,wEAAA;AnFm1mBH;;AmFj1mBE;EACC,oBAAA;EACA,2DAAA;AnFo1mBH;;AmFl1mBE;EACC,kBAAA;EACA,oEAAA;AnFq1mBH;;AmFn2mBE;EACC,oBAAA;EACA,+DAAA;AnFs2mBH;;AmFp2mBE;EACC,kBAAA;EACA,wEAAA;AnFu2mBH;;AmFr2mBE;EACC,oBAAA;EACA,0DAAA;AnFw2mBH;;AmFt2mBE;EACC,kBAAA;EACA,mEAAA;AnFy2mBH;;AmFv3mBE;EACC,oBAAA;EACA,6DAAA;AnF03mBH;;AmFx3mBE;EACC,kBAAA;EACA,sEAAA;AnF23mBH;;AmFz3mBE;EACC,oBAAA;EACA,0DAAA;AnF43mBH;;AmF13mBE;EACC,kBAAA;EACA,mEAAA;AnF63mBH;;AmF95mBE;EACA,oCAAA;EAGA,+JAAA;EACA,sJAAA;AnFi6mBF;;AmF15mBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF65mBF;;AmF15mBE;EACC,oBAAA;EACA,iEAAA;AnF65mBH;;AmF35mBE;EACC,kBAAA;EACA,0EAAA;AnF85mBH;;AmF55mBE;EACC,oBAAA;EACA,+DAAA;AnF+5mBH;;AmF75mBE;EACC,kBAAA;EACA,wEAAA;AnFg6mBH;;AmF96mBE;EACC,oBAAA;EACA,iEAAA;AnFi7mBH;;AmF/6mBE;EACC,kBAAA;EACA,0EAAA;AnFk7mBH;;AmFh7mBE;EACC,oBAAA;EACA,8DAAA;AnFm7mBH;;AmFj7mBE;EACC,kBAAA;EACA,uEAAA;AnFo7mBH;;AmFl8mBE;EACC,oBAAA;EACA,iEAAA;AnFq8mBH;;AmFn8mBE;EACC,kBAAA;EACA,0EAAA;AnFs8mBH;;AmFp8mBE;EACC,oBAAA;EACA,6DAAA;AnFu8mBH;;AmFr8mBE;EACC,kBAAA;EACA,sEAAA;AnFw8mBH;;AmFt9mBE;EACC,oBAAA;EACA,gEAAA;AnFy9mBH;;AmFv9mBE;EACC,kBAAA;EACA,yEAAA;AnF09mBH;;AmFx9mBE;EACC,oBAAA;EACA,6DAAA;AnF29mBH;;AmFz9mBE;EACC,kBAAA;EACA,sEAAA;AnF49mBH;;AmF7/mBE;EACA,oCAAA;EAGA,6JAAA;EACA,sJAAA;AnFggnBF;;AmFz/mBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF4/mBF;;AmFz/mBE;EACC,oBAAA;EACA,iEAAA;AnF4/mBH;;AmF1/mBE;EACC,kBAAA;EACA,0EAAA;AnF6/mBH;;AmF3/mBE;EACC,oBAAA;EACA,+DAAA;AnF8/mBH;;AmF5/mBE;EACC,kBAAA;EACA,wEAAA;AnF+/mBH;;AmF7gnBE;EACC,oBAAA;EACA,iEAAA;AnFghnBH;;AmF9gnBE;EACC,kBAAA;EACA,0EAAA;AnFihnBH;;AmF/gnBE;EACC,oBAAA;EACA,8DAAA;AnFkhnBH;;AmFhhnBE;EACC,kBAAA;EACA,uEAAA;AnFmhnBH;;AmFjinBE;EACC,oBAAA;EACA,iEAAA;AnFoinBH;;AmFlinBE;EACC,kBAAA;EACA,0EAAA;AnFqinBH;;AmFninBE;EACC,oBAAA;EACA,6DAAA;AnFsinBH;;AmFpinBE;EACC,kBAAA;EACA,sEAAA;AnFuinBH;;AmFrjnBE;EACC,oBAAA;EACA,+DAAA;AnFwjnBH;;AmFtjnBE;EACC,kBAAA;EACA,wEAAA;AnFyjnBH;;AmFvjnBE;EACC,oBAAA;EACA,4DAAA;AnF0jnBH;;AmFxjnBE;EACC,kBAAA;EACA,qEAAA;AnF2jnBH;;AmF5lnBE;EACA,oCAAA;EAGA,8JAAA;EACA,sJAAA;AnF+lnBF;;AmFxlnBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnF2lnBF;;AmFxlnBE;EACC,oBAAA;EACA,mEAAA;AnF2lnBH;;AmFzlnBE;EACC,kBAAA;EACA,4EAAA;AnF4lnBH;;AmF1lnBE;EACC,oBAAA;EACA,kEAAA;AnF6lnBH;;AmF3lnBE;EACC,kBAAA;EACA,2EAAA;AnF8lnBH;;AmF5mnBE;EACC,oBAAA;EACA,mEAAA;AnF+mnBH;;AmF7mnBE;EACC,kBAAA;EACA,4EAAA;AnFgnnBH;;AmF9mnBE;EACC,oBAAA;EACA,iEAAA;AnFinnBH;;AmF/mnBE;EACC,kBAAA;EACA,0EAAA;AnFknnBH;;AmFhonBE;EACC,oBAAA;EACA,mEAAA;AnFmonBH;;AmFjonBE;EACC,kBAAA;EACA,4EAAA;AnFoonBH;;AmFlonBE;EACC,oBAAA;EACA,+DAAA;AnFqonBH;;AmFnonBE;EACC,kBAAA;EACA,wEAAA;AnFsonBH;;AmFppnBE;EACC,oBAAA;EACA,kEAAA;AnFupnBH;;AmFrpnBE;EACC,kBAAA;EACA,2EAAA;AnFwpnBH;;AmFtpnBE;EACC,oBAAA;EACA,+DAAA;AnFypnBH;;AmFvpnBE;EACC,kBAAA;EACA,wEAAA;AnF0pnBH;;AmF3rnBE;EACA,oCAAA;EAGA,+JAAA;EACA,sJAAA;AnF8rnBF;;AmFvrnBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF0rnBF;;AmFvrnBE;EACC,oBAAA;EACA,mEAAA;AnF0rnBH;;AmFxrnBE;EACC,kBAAA;EACA,4EAAA;AnF2rnBH;;AmFzrnBE;EACC,oBAAA;EACA,iEAAA;AnF4rnBH;;AmF1rnBE;EACC,kBAAA;EACA,0EAAA;AnF6rnBH;;AmF3snBE;EACC,oBAAA;EACA,mEAAA;AnF8snBH;;AmF5snBE;EACC,kBAAA;EACA,4EAAA;AnF+snBH;;AmF7snBE;EACC,oBAAA;EACA,gEAAA;AnFgtnBH;;AmF9snBE;EACC,kBAAA;EACA,yEAAA;AnFitnBH;;AmF/tnBE;EACC,oBAAA;EACA,mEAAA;AnFkunBH;;AmFhunBE;EACC,kBAAA;EACA,4EAAA;AnFmunBH;;AmFjunBE;EACC,oBAAA;EACA,gEAAA;AnFounBH;;AmFlunBE;EACC,kBAAA;EACA,yEAAA;AnFqunBH;;AmFnvnBE;EACC,oBAAA;EACA,kEAAA;AnFsvnBH;;AmFpvnBE;EACC,kBAAA;EACA,2EAAA;AnFuvnBH;;AmFrvnBE;EACC,oBAAA;EACA,+DAAA;AnFwvnBH;;AmFtvnBE;EACC,kBAAA;EACA,wEAAA;AnFyvnBH;;AmF1xnBE;EACA,oCAAA;EAGA,gKAAA;EACA,sJAAA;AnF6xnBF;;AmFtxnBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFyxnBF;;AmFtxnBE;EACC,oBAAA;EACA,mEAAA;AnFyxnBH;;AmFvxnBE;EACC,kBAAA;EACA,4EAAA;AnF0xnBH;;AmFxxnBE;EACC,oBAAA;EACA,iEAAA;AnF2xnBH;;AmFzxnBE;EACC,kBAAA;EACA,0EAAA;AnF4xnBH;;AmF1ynBE;EACC,oBAAA;EACA,mEAAA;AnF6ynBH;;AmF3ynBE;EACC,kBAAA;EACA,4EAAA;AnF8ynBH;;AmF5ynBE;EACC,oBAAA;EACA,gEAAA;AnF+ynBH;;AmF7ynBE;EACC,kBAAA;EACA,yEAAA;AnFgznBH;;AmF9znBE;EACC,oBAAA;EACA,mEAAA;AnFi0nBH;;AmF/znBE;EACC,kBAAA;EACA,4EAAA;AnFk0nBH;;AmFh0nBE;EACC,oBAAA;EACA,gEAAA;AnFm0nBH;;AmFj0nBE;EACC,kBAAA;EACA,yEAAA;AnFo0nBH;;AmFl1nBE;EACC,oBAAA;EACA,mEAAA;AnFq1nBH;;AmFn1nBE;EACC,kBAAA;EACA,4EAAA;AnFs1nBH;;AmFp1nBE;EACC,oBAAA;EACA,gEAAA;AnFu1nBH;;AmFr1nBE;EACC,kBAAA;EACA,yEAAA;AnFw1nBH;;AmFz3nBE;EACA,qDAAA;EAGA,gKAAA;EACA,sJAAA;AnF43nBF;;AmFr3nBE;EACA,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFw3nBF;;AmFr3nBE;EACC,oBAAA;EACA,sEAAA;AnFw3nBH;;AmFt3nBE;EACC,kBAAA;EACA,+EAAA;AnFy3nBH;;AmFv3nBE;EACC,oBAAA;EACA,sEAAA;AnF03nBH;;AmFx3nBE;EACC,kBAAA;EACA,+EAAA;AnF23nBH;;AmFz4nBE;EACC,oBAAA;EACA,sEAAA;AnF44nBH;;AmF14nBE;EACC,kBAAA;EACA,+EAAA;AnF64nBH;;AmF34nBE;EACC,oBAAA;EACA,sEAAA;AnF84nBH;;AmF54nBE;EACC,kBAAA;EACA,+EAAA;AnF+4nBH;;AmF75nBE;EACC,oBAAA;EACA,sEAAA;AnFg6nBH;;AmF95nBE;EACC,kBAAA;EACA,+EAAA;AnFi6nBH;;AmF/5nBE;EACC,oBAAA;EACA,mEAAA;AnFk6nBH;;AmFh6nBE;EACC,kBAAA;EACA,4EAAA;AnFm6nBH;;AmFj7nBE;EACC,oBAAA;EACA,sEAAA;AnFo7nBH;;AmFl7nBE;EACC,kBAAA;EACA,+EAAA;AnFq7nBH;;AmFn7nBE;EACC,oBAAA;EACA,mEAAA;AnFs7nBH;;AmFp7nBE;EACC,kBAAA;EACA,4EAAA;AnFu7nBH;;AmFx9nBE;EACA,oCAAA;EAGA,4JAAA;EACA,sJAAA;AnF29nBF;;AmFp9nBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;AnFu9nBF;;AmFp9nBE;EACC,oBAAA;EACA,+DAAA;AnFu9nBH;;AmFr9nBE;EACC,kBAAA;EACA,wEAAA;AnFw9nBH;;AmFt9nBE;EACC,oBAAA;EACA,4DAAA;AnFy9nBH;;AmFv9nBE;EACC,kBAAA;EACA,qEAAA;AnF09nBH;;AmFx+nBE;EACC,oBAAA;EACA,+DAAA;AnF2+nBH;;AmFz+nBE;EACC,kBAAA;EACA,wEAAA;AnF4+nBH;;AmF1+nBE;EACC,oBAAA;EACA,4DAAA;AnF6+nBH;;AmF3+nBE;EACC,kBAAA;EACA,qEAAA;AnF8+nBH;;AmF5/nBE;EACC,oBAAA;EACA,+DAAA;AnF+/nBH;;AmF7/nBE;EACC,kBAAA;EACA,wEAAA;AnFggoBH;;AmF9/nBE;EACC,oBAAA;EACA,2DAAA;AnFigoBH;;AmF//nBE;EACC,kBAAA;EACA,oEAAA;AnFkgoBH;;AmFhhoBE;EACC,oBAAA;EACA,8DAAA;AnFmhoBH;;AmFjhoBE;EACC,kBAAA;EACA,uEAAA;AnFohoBH;;AmFlhoBE;EACC,oBAAA;EACA,2DAAA;AnFqhoBH;;AmFnhoBE;EACC,kBAAA;EACA,oEAAA;AnFshoBH;;AmFvjoBE;EACA,qDAAA;EAGA,gKAAA;EACA,sJAAA;AnF0joBF;;AmFnjoBE;EACA,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFsjoBF;;AmFnjoBE;EACC,oBAAA;EACA,sEAAA;AnFsjoBH;;AmFpjoBE;EACC,kBAAA;EACA,+EAAA;AnFujoBH;;AmFrjoBE;EACC,oBAAA;EACA,sEAAA;AnFwjoBH;;AmFtjoBE;EACC,kBAAA;EACA,+EAAA;AnFyjoBH;;AmFvkoBE;EACC,oBAAA;EACA,sEAAA;AnF0koBH;;AmFxkoBE;EACC,kBAAA;EACA,+EAAA;AnF2koBH;;AmFzkoBE;EACC,oBAAA;EACA,sEAAA;AnF4koBH;;AmF1koBE;EACC,kBAAA;EACA,+EAAA;AnF6koBH;;AmF3loBE;EACC,oBAAA;EACA,sEAAA;AnF8loBH;;AmF5loBE;EACC,kBAAA;EACA,+EAAA;AnF+loBH;;AmF7loBE;EACC,oBAAA;EACA,mEAAA;AnFgmoBH;;AmF9loBE;EACC,kBAAA;EACA,4EAAA;AnFimoBH;;AmF/moBE;EACC,oBAAA;EACA,sEAAA;AnFknoBH;;AmFhnoBE;EACC,kBAAA;EACA,+EAAA;AnFmnoBH;;AmFjnoBE;EACC,oBAAA;EACA,mEAAA;AnFonoBH;;AmFlnoBE;EACC,kBAAA;EACA,4EAAA;AnFqnoBH;;AmFtpoBE;EACA,uDAAA;EAGA,gKAAA;EACA,sJAAA;AnFypoBF;;AmFlpoBE;EACA,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFqpoBF;;AmFlpoBE;EACC,oBAAA;EACA,sEAAA;AnFqpoBH;;AmFnpoBE;EACC,kBAAA;EACA,+EAAA;AnFspoBH;;AmFppoBE;EACC,oBAAA;EACA,sEAAA;AnFupoBH;;AmFrpoBE;EACC,kBAAA;EACA,+EAAA;AnFwpoBH;;AmFtqoBE;EACC,oBAAA;EACA,sEAAA;AnFyqoBH;;AmFvqoBE;EACC,kBAAA;EACA,+EAAA;AnF0qoBH;;AmFxqoBE;EACC,oBAAA;EACA,sEAAA;AnF2qoBH;;AmFzqoBE;EACC,kBAAA;EACA,+EAAA;AnF4qoBH;;AmF1roBE;EACC,oBAAA;EACA,sEAAA;AnF6roBH;;AmF3roBE;EACC,kBAAA;EACA,+EAAA;AnF8roBH;;AmF5roBE;EACC,oBAAA;EACA,mEAAA;AnF+roBH;;AmF7roBE;EACC,kBAAA;EACA,4EAAA;AnFgsoBH;;AmF9soBE;EACC,oBAAA;EACA,sEAAA;AnFitoBH;;AmF/soBE;EACC,kBAAA;EACA,+EAAA;AnFktoBH;;AmFhtoBE;EACC,oBAAA;EACA,mEAAA;AnFmtoBH;;AmFjtoBE;EACC,kBAAA;EACA,4EAAA;AnFotoBH;;AmFrvoBE;EACA,qDAAA;EAGA,gKAAA;EACA,sJAAA;AnFwvoBF;;AmFjvoBE;EACA,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFovoBF;;AmFjvoBE;EACC,oBAAA;EACA,sEAAA;AnFovoBH;;AmFlvoBE;EACC,kBAAA;EACA,+EAAA;AnFqvoBH;;AmFnvoBE;EACC,oBAAA;EACA,sEAAA;AnFsvoBH;;AmFpvoBE;EACC,kBAAA;EACA,+EAAA;AnFuvoBH;;AmFrwoBE;EACC,oBAAA;EACA,sEAAA;AnFwwoBH;;AmFtwoBE;EACC,kBAAA;EACA,+EAAA;AnFywoBH;;AmFvwoBE;EACC,oBAAA;EACA,oEAAA;AnF0woBH;;AmFxwoBE;EACC,kBAAA;EACA,6EAAA;AnF2woBH;;AmFzxoBE;EACC,oBAAA;EACA,sEAAA;AnF4xoBH;;AmF1xoBE;EACC,kBAAA;EACA,+EAAA;AnF6xoBH;;AmF3xoBE;EACC,oBAAA;EACA,mEAAA;AnF8xoBH;;AmF5xoBE;EACC,kBAAA;EACA,4EAAA;AnF+xoBH;;AmF7yoBE;EACC,oBAAA;EACA,sEAAA;AnFgzoBH;;AmF9yoBE;EACC,kBAAA;EACA,+EAAA;AnFizoBH;;AmF/yoBE;EACC,oBAAA;EACA,mEAAA;AnFkzoBH;;AmFhzoBE;EACC,kBAAA;EACA,4EAAA;AnFmzoBH;;AmFp1oBE;EACA,uDAAA;EAGA,8JAAA;EACA,sJAAA;AnFu1oBF;;AmFh1oBE;EACA,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;AnFm1oBF;;AmFh1oBE;EACC,oBAAA;EACA,sEAAA;AnFm1oBH;;AmFj1oBE;EACC,kBAAA;EACA,+EAAA;AnFo1oBH;;AmFl1oBE;EACC,oBAAA;EACA,qEAAA;AnFq1oBH;;AmFn1oBE;EACC,kBAAA;EACA,8EAAA;AnFs1oBH;;AmFp2oBE;EACC,oBAAA;EACA,sEAAA;AnFu2oBH;;AmFr2oBE;EACC,kBAAA;EACA,+EAAA;AnFw2oBH;;AmFt2oBE;EACC,oBAAA;EACA,mEAAA;AnFy2oBH;;AmFv2oBE;EACC,kBAAA;EACA,4EAAA;AnF02oBH;;AmFx3oBE;EACC,oBAAA;EACA,sEAAA;AnF23oBH;;AmFz3oBE;EACC,kBAAA;EACA,+EAAA;AnF43oBH;;AmF13oBE;EACC,oBAAA;EACA,mEAAA;AnF63oBH;;AmF33oBE;EACC,kBAAA;EACA,4EAAA;AnF83oBH;;AmF54oBE;EACC,oBAAA;EACA,sEAAA;AnF+4oBH;;AmF74oBE;EACC,kBAAA;EACA,+EAAA;AnFg5oBH;;AmF94oBE;EACC,oBAAA;EACA,mEAAA;AnFi5oBH;;AmF/4oBE;EACC,kBAAA;EACA,4EAAA;AnFk5oBH;;AmFn7oBE;EACA,oCAAA;EAGA,gKAAA;EACA,sJAAA;AnFs7oBF;;AmF/6oBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFk7oBF;;AmF/6oBE;EACC,oBAAA;EACA,mEAAA;AnFk7oBH;;AmFh7oBE;EACC,kBAAA;EACA,4EAAA;AnFm7oBH;;AmFj7oBE;EACC,oBAAA;EACA,iEAAA;AnFo7oBH;;AmFl7oBE;EACC,kBAAA;EACA,0EAAA;AnFq7oBH;;AmFn8oBE;EACC,oBAAA;EACA,mEAAA;AnFs8oBH;;AmFp8oBE;EACC,kBAAA;EACA,4EAAA;AnFu8oBH;;AmFr8oBE;EACC,oBAAA;EACA,gEAAA;AnFw8oBH;;AmFt8oBE;EACC,kBAAA;EACA,yEAAA;AnFy8oBH;;AmFv9oBE;EACC,oBAAA;EACA,mEAAA;AnF09oBH;;AmFx9oBE;EACC,kBAAA;EACA,4EAAA;AnF29oBH;;AmFz9oBE;EACC,oBAAA;EACA,gEAAA;AnF49oBH;;AmF19oBE;EACC,kBAAA;EACA,yEAAA;AnF69oBH;;AmF3+oBE;EACC,oBAAA;EACA,mEAAA;AnF8+oBH;;AmF5+oBE;EACC,kBAAA;EACA,4EAAA;AnF++oBH;;AmF7+oBE;EACC,oBAAA;EACA,gEAAA;AnFg/oBH;;AmF9+oBE;EACC,kBAAA;EACA,yEAAA;AnFi/oBH;;AmFlhpBE;EACA,qDAAA;EAGA,8JAAA;EACA,sJAAA;AnFqhpBF;;AmF9gpBE;EACA,+CAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFihpBF;;AmF9gpBE;EACC,oBAAA;EACA,sEAAA;AnFihpBH;;AmF/gpBE;EACC,kBAAA;EACA,+EAAA;AnFkhpBH;;AmFhhpBE;EACC,oBAAA;EACA,mEAAA;AnFmhpBH;;AmFjhpBE;EACC,kBAAA;EACA,4EAAA;AnFohpBH;;AmFlipBE;EACC,oBAAA;EACA,sEAAA;AnFqipBH;;AmFnipBE;EACC,kBAAA;EACA,+EAAA;AnFsipBH;;AmFpipBE;EACC,oBAAA;EACA,mEAAA;AnFuipBH;;AmFripBE;EACC,kBAAA;EACA,4EAAA;AnFwipBH;;AmFtjpBE;EACC,oBAAA;EACA,sEAAA;AnFyjpBH;;AmFvjpBE;EACC,kBAAA;EACA,+EAAA;AnF0jpBH;;AmFxjpBE;EACC,oBAAA;EACA,mEAAA;AnF2jpBH;;AmFzjpBE;EACC,kBAAA;EACA,4EAAA;AnF4jpBH;;AmF1kpBE;EACC,oBAAA;EACA,sEAAA;AnF6kpBH;;AmF3kpBE;EACC,kBAAA;EACA,+EAAA;AnF8kpBH;;AmF5kpBE;EACC,oBAAA;EACA,mEAAA;AnF+kpBH;;AmF7kpBE;EACC,kBAAA;EACA,4EAAA;AnFglpBH;;AmFjnpBE;EACA,kDAAA;EAGA,6JAAA;EACA,sJAAA;AnFonpBF;;AmF7mpBE;EACA,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFgnpBF;;AmF7mpBE;EACC,oBAAA;EACA,sEAAA;AnFgnpBH;;AmF9mpBE;EACC,kBAAA;EACA,+EAAA;AnFinpBH;;AmF/mpBE;EACC,oBAAA;EACA,mEAAA;AnFknpBH;;AmFhnpBE;EACC,kBAAA;EACA,4EAAA;AnFmnpBH;;AmFjopBE;EACC,oBAAA;EACA,sEAAA;AnFoopBH;;AmFlopBE;EACC,kBAAA;EACA,+EAAA;AnFqopBH;;AmFnopBE;EACC,oBAAA;EACA,mEAAA;AnFsopBH;;AmFpopBE;EACC,kBAAA;EACA,4EAAA;AnFuopBH;;AmFrppBE;EACC,oBAAA;EACA,sEAAA;AnFwppBH;;AmFtppBE;EACC,kBAAA;EACA,+EAAA;AnFyppBH;;AmFvppBE;EACC,oBAAA;EACA,mEAAA;AnF0ppBH;;AmFxppBE;EACC,kBAAA;EACA,4EAAA;AnF2ppBH;;AmFzqpBE;EACC,oBAAA;EACA,sEAAA;AnF4qpBH;;AmF1qpBE;EACC,kBAAA;EACA,+EAAA;AnF6qpBH;;AmF3qpBE;EACC,oBAAA;EACA,mEAAA;AnF8qpBH;;AmF5qpBE;EACC,kBAAA;EACA,4EAAA;AnF+qpBH;;AmFhtpBE;EACA,mDAAA;EAGA,4JAAA;EACA,sJAAA;AnFmtpBF;;AmF5spBE;EACA,6CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnF+spBF;;AmF5spBE;EACC,oBAAA;EACA,sEAAA;AnF+spBH;;AmF7spBE;EACC,kBAAA;EACA,+EAAA;AnFgtpBH;;AmF9spBE;EACC,oBAAA;EACA,mEAAA;AnFitpBH;;AmF/spBE;EACC,kBAAA;EACA,4EAAA;AnFktpBH;;AmFhupBE;EACC,oBAAA;EACA,sEAAA;AnFmupBH;;AmFjupBE;EACC,kBAAA;EACA,+EAAA;AnFoupBH;;AmFlupBE;EACC,oBAAA;EACA,mEAAA;AnFqupBH;;AmFnupBE;EACC,kBAAA;EACA,4EAAA;AnFsupBH;;AmFpvpBE;EACC,oBAAA;EACA,sEAAA;AnFuvpBH;;AmFrvpBE;EACC,kBAAA;EACA,+EAAA;AnFwvpBH;;AmFtvpBE;EACC,oBAAA;EACA,mEAAA;AnFyvpBH;;AmFvvpBE;EACC,kBAAA;EACA,4EAAA;AnF0vpBH;;AmFxwpBE;EACC,oBAAA;EACA,qEAAA;AnF2wpBH;;AmFzwpBE;EACC,kBAAA;EACA,8EAAA;AnF4wpBH;;AmF1wpBE;EACC,oBAAA;EACA,mEAAA;AnF6wpBH;;AmF3wpBE;EACC,kBAAA;EACA,4EAAA;AnF8wpBH;;AmF/ypBE;EACA,kDAAA;EAGA,2JAAA;EACA,sJAAA;AnFkzpBF;;AmF3ypBE;EACA,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnF8ypBF;;AmF3ypBE;EACC,oBAAA;EACA,sEAAA;AnF8ypBH;;AmF5ypBE;EACC,kBAAA;EACA,+EAAA;AnF+ypBH;;AmF7ypBE;EACC,oBAAA;EACA,mEAAA;AnFgzpBH;;AmF9ypBE;EACC,kBAAA;EACA,4EAAA;AnFizpBH;;AmF/zpBE;EACC,oBAAA;EACA,sEAAA;AnFk0pBH;;AmFh0pBE;EACC,kBAAA;EACA,+EAAA;AnFm0pBH;;AmFj0pBE;EACC,oBAAA;EACA,mEAAA;AnFo0pBH;;AmFl0pBE;EACC,kBAAA;EACA,4EAAA;AnFq0pBH;;AmFn1pBE;EACC,oBAAA;EACA,sEAAA;AnFs1pBH;;AmFp1pBE;EACC,kBAAA;EACA,+EAAA;AnFu1pBH;;AmFr1pBE;EACC,oBAAA;EACA,mEAAA;AnFw1pBH;;AmFt1pBE;EACC,kBAAA;EACA,4EAAA;AnFy1pBH;;AmFv2pBE;EACC,oBAAA;EACA,mEAAA;AnF02pBH;;AmFx2pBE;EACC,kBAAA;EACA,4EAAA;AnF22pBH;;AmFz2pBE;EACC,oBAAA;EACA,iEAAA;AnF42pBH;;AmF12pBE;EACC,kBAAA;EACA,0EAAA;AnF62pBH;;AmF94pBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnFi5pBF;;AmF14pBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF64pBF;;AmF14pBE;EACC,oBAAA;EACA,iEAAA;AnF64pBH;;AmF34pBE;EACC,kBAAA;EACA,0EAAA;AnF84pBH;;AmF54pBE;EACC,oBAAA;EACA,8DAAA;AnF+4pBH;;AmF74pBE;EACC,kBAAA;EACA,uEAAA;AnFg5pBH;;AmF95pBE;EACC,oBAAA;EACA,iEAAA;AnFi6pBH;;AmF/5pBE;EACC,kBAAA;EACA,0EAAA;AnFk6pBH;;AmFh6pBE;EACC,oBAAA;EACA,8DAAA;AnFm6pBH;;AmFj6pBE;EACC,kBAAA;EACA,uEAAA;AnFo6pBH;;AmFl7pBE;EACC,oBAAA;EACA,iEAAA;AnFq7pBH;;AmFn7pBE;EACC,kBAAA;EACA,0EAAA;AnFs7pBH;;AmFp7pBE;EACC,oBAAA;EACA,8DAAA;AnFu7pBH;;AmFr7pBE;EACC,kBAAA;EACA,uEAAA;AnFw7pBH;;AmFt8pBE;EACC,oBAAA;EACA,gEAAA;AnFy8pBH;;AmFv8pBE;EACC,kBAAA;EACA,yEAAA;AnF08pBH;;AmFx8pBE;EACC,oBAAA;EACA,6DAAA;AnF28pBH;;AmFz8pBE;EACC,kBAAA;EACA,sEAAA;AnF48pBH;;AmF7+pBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnFg/pBF;;AmFz+pBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnF4+pBF;;AmFz+pBE;EACC,oBAAA;EACA,iEAAA;AnF4+pBH;;AmF1+pBE;EACC,kBAAA;EACA,0EAAA;AnF6+pBH;;AmF3+pBE;EACC,oBAAA;EACA,+DAAA;AnF8+pBH;;AmF5+pBE;EACC,kBAAA;EACA,wEAAA;AnF++pBH;;AmF7/pBE;EACC,oBAAA;EACA,iEAAA;AnFggqBH;;AmF9/pBE;EACC,kBAAA;EACA,0EAAA;AnFigqBH;;AmF//pBE;EACC,oBAAA;EACA,+DAAA;AnFkgqBH;;AmFhgqBE;EACC,kBAAA;EACA,wEAAA;AnFmgqBH;;AmFjhqBE;EACC,oBAAA;EACA,iEAAA;AnFohqBH;;AmFlhqBE;EACC,kBAAA;EACA,0EAAA;AnFqhqBH;;AmFnhqBE;EACC,oBAAA;EACA,+DAAA;AnFshqBH;;AmFphqBE;EACC,kBAAA;EACA,wEAAA;AnFuhqBH;;AmFriqBE;EACC,oBAAA;EACA,gEAAA;AnFwiqBH;;AmFtiqBE;EACC,kBAAA;EACA,yEAAA;AnFyiqBH;;AmFviqBE;EACC,oBAAA;EACA,6DAAA;AnF0iqBH;;AmFxiqBE;EACC,kBAAA;EACA,sEAAA;AnF2iqBH;;AmF5kqBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnF+kqBF;;AmFxkqBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF2kqBF;;AmFxkqBE;EACC,oBAAA;EACA,+DAAA;AnF2kqBH;;AmFzkqBE;EACC,kBAAA;EACA,wEAAA;AnF4kqBH;;AmF1kqBE;EACC,oBAAA;EACA,8DAAA;AnF6kqBH;;AmF3kqBE;EACC,kBAAA;EACA,uEAAA;AnF8kqBH;;AmF5lqBE;EACC,oBAAA;EACA,+DAAA;AnF+lqBH;;AmF7lqBE;EACC,kBAAA;EACA,wEAAA;AnFgmqBH;;AmF9lqBE;EACC,oBAAA;EACA,6DAAA;AnFimqBH;;AmF/lqBE;EACC,kBAAA;EACA,sEAAA;AnFkmqBH;;AmFhnqBE;EACC,oBAAA;EACA,+DAAA;AnFmnqBH;;AmFjnqBE;EACC,kBAAA;EACA,wEAAA;AnFonqBH;;AmFlnqBE;EACC,oBAAA;EACA,4DAAA;AnFqnqBH;;AmFnnqBE;EACC,kBAAA;EACA,qEAAA;AnFsnqBH;;AmFpoqBE;EACC,oBAAA;EACA,8DAAA;AnFuoqBH;;AmFroqBE;EACC,kBAAA;EACA,uEAAA;AnFwoqBH;;AmFtoqBE;EACC,oBAAA;EACA,2DAAA;AnFyoqBH;;AmFvoqBE;EACC,kBAAA;EACA,oEAAA;AnF0oqBH;;AmF3qqBE;EACA,oCAAA;EAGA,+JAAA;EACA,sJAAA;AnF8qqBF;;AmFvqqBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnF0qqBF;;AmFvqqBE;EACC,oBAAA;EACA,iEAAA;AnF0qqBH;;AmFxqqBE;EACC,kBAAA;EACA,0EAAA;AnF2qqBH;;AmFzqqBE;EACC,oBAAA;EACA,+DAAA;AnF4qqBH;;AmF1qqBE;EACC,kBAAA;EACA,wEAAA;AnF6qqBH;;AmF3rqBE;EACC,oBAAA;EACA,iEAAA;AnF8rqBH;;AmF5rqBE;EACC,kBAAA;EACA,0EAAA;AnF+rqBH;;AmF7rqBE;EACC,oBAAA;EACA,8DAAA;AnFgsqBH;;AmF9rqBE;EACC,kBAAA;EACA,uEAAA;AnFisqBH;;AmF/sqBE;EACC,oBAAA;EACA,iEAAA;AnFktqBH;;AmFhtqBE;EACC,kBAAA;EACA,0EAAA;AnFmtqBH;;AmFjtqBE;EACC,oBAAA;EACA,6DAAA;AnFotqBH;;AmFltqBE;EACC,kBAAA;EACA,sEAAA;AnFqtqBH;;AmFnuqBE;EACC,oBAAA;EACA,gEAAA;AnFsuqBH;;AmFpuqBE;EACC,kBAAA;EACA,yEAAA;AnFuuqBH;;AmFruqBE;EACC,oBAAA;EACA,6DAAA;AnFwuqBH;;AmFtuqBE;EACC,kBAAA;EACA,sEAAA;AnFyuqBH;;AmF1wqBE;EACA,oCAAA;EAGA,kFAAA;EACA,sJAAA;AnF6wqBF;;AmFtwqBE;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;AnFywqBF;;AmFtwqBE;EACC,oBAAA;EACA,+DAAA;AnFywqBH;;AmFvwqBE;EACC,kBAAA;EACA,wEAAA;AnF0wqBH;;AmFxwqBE;EACC,oBAAA;EACA,2DAAA;AnF2wqBH;;AmFzwqBE;EACC,kBAAA;EACA,oEAAA;AnF4wqBH;;AmF1xqBE;EACC,oBAAA;EACA,+DAAA;AnF6xqBH;;AmF3xqBE;EACC,kBAAA;EACA,wEAAA;AnF8xqBH;;AmF5xqBE;EACC,oBAAA;EACA,2DAAA;AnF+xqBH;;AmF7xqBE;EACC,kBAAA;EACA,oEAAA;AnFgyqBH;;AmF9yqBE;EACC,oBAAA;EACA,+DAAA;AnFizqBH;;AmF/yqBE;EACC,kBAAA;EACA,wEAAA;AnFkzqBH;;AmFhzqBE;EACC,oBAAA;EACA,0DAAA;AnFmzqBH;;AmFjzqBE;EACC,kBAAA;EACA,mEAAA;AnFozqBH;;AmFl0qBE;EACC,oBAAA;EACA,6DAAA;AnFq0qBH;;AmFn0qBE;EACC,kBAAA;EACA,sEAAA;AnFs0qBH;;AmFp0qBE;EACC,oBAAA;EACA,0DAAA;AnFu0qBH;;AmFr0qBE;EACC,kBAAA;EACA,mEAAA;AnFw0qBH;;AmFz2qBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnF42qBF;;AmFr2qBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnFw2qBF;;AmFr2qBE;EACC,oBAAA;EACA,iEAAA;AnFw2qBH;;AmFt2qBE;EACC,kBAAA;EACA,0EAAA;AnFy2qBH;;AmFv2qBE;EACC,oBAAA;EACA,+DAAA;AnF02qBH;;AmFx2qBE;EACC,kBAAA;EACA,wEAAA;AnF22qBH;;AmFz3qBE;EACC,oBAAA;EACA,iEAAA;AnF43qBH;;AmF13qBE;EACC,kBAAA;EACA,0EAAA;AnF63qBH;;AmF33qBE;EACC,oBAAA;EACA,8DAAA;AnF83qBH;;AmF53qBE;EACC,kBAAA;EACA,uEAAA;AnF+3qBH;;AmF74qBE;EACC,oBAAA;EACA,iEAAA;AnFg5qBH;;AmF94qBE;EACC,kBAAA;EACA,0EAAA;AnFi5qBH;;AmF/4qBE;EACC,oBAAA;EACA,8DAAA;AnFk5qBH;;AmFh5qBE;EACC,kBAAA;EACA,uEAAA;AnFm5qBH;;AmFj6qBE;EACC,oBAAA;EACA,gEAAA;AnFo6qBH;;AmFl6qBE;EACC,kBAAA;EACA,yEAAA;AnFq6qBH;;AmFn6qBE;EACC,oBAAA;EACA,6DAAA;AnFs6qBH;;AmFp6qBE;EACC,kBAAA;EACA,sEAAA;AnFu6qBH;;AmFx8qBE;EACA,oCAAA;EAGA,8JAAA;EACA,sJAAA;AnF28qBF;;AmFp8qBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;AnFu8qBF;;AmFp8qBE;EACC,oBAAA;EACA,mEAAA;AnFu8qBH;;AmFr8qBE;EACC,kBAAA;EACA,4EAAA;AnFw8qBH;;AmFt8qBE;EACC,oBAAA;EACA,kEAAA;AnFy8qBH;;AmFv8qBE;EACC,kBAAA;EACA,2EAAA;AnF08qBH;;AmFx9qBE;EACC,oBAAA;EACA,mEAAA;AnF29qBH;;AmFz9qBE;EACC,kBAAA;EACA,4EAAA;AnF49qBH;;AmF19qBE;EACC,oBAAA;EACA,iEAAA;AnF69qBH;;AmF39qBE;EACC,kBAAA;EACA,0EAAA;AnF89qBH;;AmF5+qBE;EACC,oBAAA;EACA,mEAAA;AnF++qBH;;AmF7+qBE;EACC,kBAAA;EACA,4EAAA;AnFg/qBH;;AmF9+qBE;EACC,oBAAA;EACA,+DAAA;AnFi/qBH;;AmF/+qBE;EACC,kBAAA;EACA,wEAAA;AnFk/qBH;;AmFhgrBE;EACC,oBAAA;EACA,kEAAA;AnFmgrBH;;AmFjgrBE;EACC,kBAAA;EACA,2EAAA;AnFogrBH;;AmFlgrBE;EACC,oBAAA;EACA,+DAAA;AnFqgrBH;;AmFngrBE;EACC,kBAAA;EACA,wEAAA;AnFsgrBH;;AmFvirBE;EACA,oCAAA;EAGA,6JAAA;EACA,sJAAA;AnF0irBF;;AmFnirBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFsirBF;;AmFnirBE;EACC,oBAAA;EACA,iEAAA;AnFsirBH;;AmFpirBE;EACC,kBAAA;EACA,0EAAA;AnFuirBH;;AmFrirBE;EACC,oBAAA;EACA,+DAAA;AnFwirBH;;AmFtirBE;EACC,kBAAA;EACA,wEAAA;AnFyirBH;;AmFvjrBE;EACC,oBAAA;EACA,iEAAA;AnF0jrBH;;AmFxjrBE;EACC,kBAAA;EACA,0EAAA;AnF2jrBH;;AmFzjrBE;EACC,oBAAA;EACA,8DAAA;AnF4jrBH;;AmF1jrBE;EACC,kBAAA;EACA,uEAAA;AnF6jrBH;;AmF3krBE;EACC,oBAAA;EACA,iEAAA;AnF8krBH;;AmF5krBE;EACC,kBAAA;EACA,0EAAA;AnF+krBH;;AmF7krBE;EACC,oBAAA;EACA,6DAAA;AnFglrBH;;AmF9krBE;EACC,kBAAA;EACA,sEAAA;AnFilrBH;;AmF/lrBE;EACC,oBAAA;EACA,+DAAA;AnFkmrBH;;AmFhmrBE;EACC,kBAAA;EACA,wEAAA;AnFmmrBH;;AmFjmrBE;EACC,oBAAA;EACA,4DAAA;AnFomrBH;;AmFlmrBE;EACC,kBAAA;EACA,qEAAA;AnFqmrBH;;AmFtorBE;EACA,oCAAA;EAGA,+JAAA;EACA,sJAAA;AnFyorBF;;AmFlorBE;EACA,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFqorBF;;AmFlorBE;EACC,oBAAA;EACA,mEAAA;AnFqorBH;;AmFnorBE;EACC,kBAAA;EACA,4EAAA;AnFsorBH;;AmFporBE;EACC,oBAAA;EACA,iEAAA;AnFuorBH;;AmFrorBE;EACC,kBAAA;EACA,0EAAA;AnFworBH;;AmFtprBE;EACC,oBAAA;EACA,mEAAA;AnFyprBH;;AmFvprBE;EACC,kBAAA;EACA,4EAAA;AnF0prBH;;AmFxprBE;EACC,oBAAA;EACA,gEAAA;AnF2prBH;;AmFzprBE;EACC,kBAAA;EACA,yEAAA;AnF4prBH;;AmF1qrBE;EACC,oBAAA;EACA,mEAAA;AnF6qrBH;;AmF3qrBE;EACC,kBAAA;EACA,4EAAA;AnF8qrBH;;AmF5qrBE;EACC,oBAAA;EACA,gEAAA;AnF+qrBH;;AmF7qrBE;EACC,kBAAA;EACA,yEAAA;AnFgrrBH;;AmF9rrBE;EACC,oBAAA;EACA,kEAAA;AnFisrBH;;AmF/rrBE;EACC,kBAAA;EACA,2EAAA;AnFksrBH;;AmFhsrBE;EACC,oBAAA;EACA,+DAAA;AnFmsrBH;;AmFjsrBE;EACC,kBAAA;EACA,wEAAA;AnFosrBH;;AmFrurBE;EACA,oCAAA;EAGA,oHAAA;EACA,sJAAA;AnFwurBF;;AmFjurBE;EACA,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8CAAA;AnFourBF;;AmFjurBE;EACC,oBAAA;EACA,+DAAA;AnFourBH;;AmFlurBE;EACC,kBAAA;EACA,wEAAA;AnFqurBH;;AmFnurBE;EACC,oBAAA;EACA,6DAAA;AnFsurBH;;AmFpurBE;EACC,kBAAA;EACA,sEAAA;AnFuurBH;;AmFrvrBE;EACC,oBAAA;EACA,+DAAA;AnFwvrBH;;AmFtvrBE;EACC,kBAAA;EACA,wEAAA;AnFyvrBH;;AmFvvrBE;EACC,oBAAA;EACA,4DAAA;AnF0vrBH;;AmFxvrBE;EACC,kBAAA;EACA,qEAAA;AnF2vrBH;;AmFzwrBE;EACC,oBAAA;EACA,+DAAA;AnF4wrBH;;AmF1wrBE;EACC,kBAAA;EACA,wEAAA;AnF6wrBH;;AmF3wrBE;EACC,oBAAA;EACA,2DAAA;AnF8wrBH;;AmF5wrBE;EACC,kBAAA;EACA,oEAAA;AnF+wrBH;;AmF7xrBE;EACC,oBAAA;EACA,8DAAA;AnFgyrBH;;AmF9xrBE;EACC,kBAAA;EACA,uEAAA;AnFiyrBH;;AmF/xrBE;EACC,oBAAA;EACA,2DAAA;AnFkyrBH;;AmFhyrBE;EACC,kBAAA;EACA,oEAAA;AnFmyrBH;;AmFp0rBE;EACA,oCAAA;EAGA,qFAAA;EACA,sJAAA;AnFu0rBF;;AmFh0rBE;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;AnFm0rBF;;AmFh0rBE;EACC,oBAAA;EACA,6DAAA;AnFm0rBH;;AmFj0rBE;EACC,kBAAA;EACA,sEAAA;AnFo0rBH;;AmFl0rBE;EACC,oBAAA;EACA,uDAAA;AnFq0rBH;;AmFn0rBE;EACC,kBAAA;EACA,gEAAA;AnFs0rBH;;AmFp1rBE;EACC,oBAAA;EACA,6DAAA;AnFu1rBH;;AmFr1rBE;EACC,kBAAA;EACA,sEAAA;AnFw1rBH;;AmFt1rBE;EACC,oBAAA;EACA,uDAAA;AnFy1rBH;;AmFv1rBE;EACC,kBAAA;EACA,gEAAA;AnF01rBH;;AmFx2rBE;EACC,oBAAA;EACA,6DAAA;AnF22rBH;;AmFz2rBE;EACC,kBAAA;EACA,sEAAA;AnF42rBH;;AmF12rBE;EACC,oBAAA;EACA,uDAAA;AnF62rBH;;AmF32rBE;EACC,kBAAA;EACA,gEAAA;AnF82rBH;;AmF53rBE;EACC,oBAAA;EACA,0DAAA;AnF+3rBH;;AmF73rBE;EACC,kBAAA;EACA,mEAAA;AnFg4rBH;;AmF93rBE;EACC,oBAAA;EACA,uDAAA;AnFi4rBH;;AmF/3rBE;EACC,kBAAA;EACA,gEAAA;AnFk4rBH;;AmFn6rBE;EACA,oCAAA;EAGA,2FAAA;EACA,sJAAA;AnFs6rBF;;AmF/5rBE;EACA,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;AnFk6rBF;;AmF/5rBE;EACC,oBAAA;EACA,6DAAA;AnFk6rBH;;AmFh6rBE;EACC,kBAAA;EACA,sEAAA;AnFm6rBH;;AmFj6rBE;EACC,oBAAA;EACA,6DAAA;AnFo6rBH;;AmFl6rBE;EACC,kBAAA;EACA,sEAAA;AnFq6rBH;;AmFn7rBE;EACC,oBAAA;EACA,6DAAA;AnFs7rBH;;AmFp7rBE;EACC,kBAAA;EACA,sEAAA;AnFu7rBH;;AmFr7rBE;EACC,oBAAA;EACA,6DAAA;AnFw7rBH;;AmFt7rBE;EACC,kBAAA;EACA,sEAAA;AnFy7rBH;;AmFv8rBE;EACC,oBAAA;EACA,6DAAA;AnF08rBH;;AmFx8rBE;EACC,kBAAA;EACA,sEAAA;AnF28rBH;;AmFz8rBE;EACC,oBAAA;EACA,6DAAA;AnF48rBH;;AmF18rBE;EACC,kBAAA;EACA,sEAAA;AnF68rBH;;AmF39rBE;EACC,oBAAA;EACA,6DAAA;AnF89rBH;;AmF59rBE;EACC,kBAAA;EACA,sEAAA;AnF+9rBH;;AmF79rBE;EACC,oBAAA;EACA,0DAAA;AnFg+rBH;;AmF99rBE;EACC,kBAAA;EACA,mEAAA;AnFi+rBH;;AmFlgsBE;EACA,qDAAA;EAGA,8JAAA;EACA,sJAAA;AnFqgsBF;;AmF9/rBE;EACA,+CAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;AnFigsBF;;AmF9/rBE;EACC,oBAAA;EACA,sEAAA;AnFigsBH;;AmF//rBE;EACC,kBAAA;EACA,+EAAA;AnFkgsBH;;AmFhgsBE;EACC,oBAAA;EACA,mEAAA;AnFmgsBH;;AmFjgsBE;EACC,kBAAA;EACA,4EAAA;AnFogsBH;;AmFlhsBE;EACC,oBAAA;EACA,sEAAA;AnFqhsBH;;AmFnhsBE;EACC,kBAAA;EACA,+EAAA;AnFshsBH;;AmFphsBE;EACC,oBAAA;EACA,mEAAA;AnFuhsBH;;AmFrhsBE;EACC,kBAAA;EACA,4EAAA;AnFwhsBH;;AmFtisBE;EACC,oBAAA;EACA,sEAAA;AnFyisBH;;AmFvisBE;EACC,kBAAA;EACA,+EAAA;AnF0isBH;;AmFxisBE;EACC,oBAAA;EACA,mEAAA;AnF2isBH;;AmFzisBE;EACC,kBAAA;EACA,4EAAA;AnF4isBH;;AmF1jsBE;EACC,oBAAA;EACA,sEAAA;AnF6jsBH;;AmF3jsBE;EACC,kBAAA;EACA,+EAAA;AnF8jsBH;;AmF5jsBE;EACC,oBAAA;EACA,mEAAA;AnF+jsBH;;AmF7jsBE;EACC,kBAAA;EACA,4EAAA;AnFgksBH;;AmFjmsBE;EACA,mDAAA;EAGA,4JAAA;EACA,sJAAA;AnFomsBF;;AmF7lsBE;EACA,6CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;AnFgmsBF;;AmF7lsBE;EACC,oBAAA;EACA,sEAAA;AnFgmsBH;;AmF9lsBE;EACC,kBAAA;EACA,+EAAA;AnFimsBH;;AmF/lsBE;EACC,oBAAA;EACA,mEAAA;AnFkmsBH;;AmFhmsBE;EACC,kBAAA;EACA,4EAAA;AnFmmsBH;;AmFjnsBE;EACC,oBAAA;EACA,sEAAA;AnFonsBH;;AmFlnsBE;EACC,kBAAA;EACA,+EAAA;AnFqnsBH;;AmFnnsBE;EACC,oBAAA;EACA,mEAAA;AnFsnsBH;;AmFpnsBE;EACC,kBAAA;EACA,4EAAA;AnFunsBH;;AmFrosBE;EACC,oBAAA;EACA,sEAAA;AnFwosBH;;AmFtosBE;EACC,kBAAA;EACA,+EAAA;AnFyosBH;;AmFvosBE;EACC,oBAAA;EACA,mEAAA;AnF0osBH;;AmFxosBE;EACC,kBAAA;EACA,4EAAA;AnF2osBH;;AmFzpsBE;EACC,oBAAA;EACA,qEAAA;AnF4psBH;;AmF1psBE;EACC,kBAAA;EACA,8EAAA;AnF6psBH;;AmF3psBE;EACC,oBAAA;EACA,mEAAA;AnF8psBH;;AmF5psBE;EACC,kBAAA;EACA,4EAAA;AnF+psBH;;AMlrsBI;EwEsCD,wCAAA;EACA,+BAAA;EADA,mBAAA;EACA,4BAAA;EADA,qBAAA;EACA,8BAAA;EADA,0CAAA;EACA,iCAAA;EADA,qBAAA;EACA,8BAAA;EADA,oBAAA;EACA,4BAAA;EADA,qBAAA;EACA,8BAAA;EADA,qBAAA;EACA,+BAAA;EADA,kBAAA;EACA,2BAAA;EADA,iCAAA;EACA,yBAAA;EADA,mBAAA;EACA,uBAAA;EADA,mBAAA;EACA,6BAAA;EADA,oBAAA;EACA,8BAAA;EADA,oBAAA;EACA,8BAAA;EADA,iBAAA;EACA,yBAAA;EADA,kBAAA;EACA,2BAAA;EADA,mBAAA;EACA,2BAAA;EADA,oBAAA;EACA,6BAAA;EADA,kBAAA;EACA,2BAAA;EADA,mBAAA;EACA,4BAAA;EADA,oCAAA;EACA,6BAAA;EADA,kBAAA;EACA,2BAAA;EADA,uCAAA;EACA,gCAAA;EADA,yCAAA;EACA,gCAAA;EADA,uCAAA;EACA,gCAAA;EADA,yCAAA;EACA,gCAAA;EADA,sBAAA;EACA,+BAAA;EADA,uCAAA;EACA,+BAAA;EADA,oCAAA;EACA,6BAAA;EADA,qCAAA;EACA,6BAAA;EADA,oCAAA;EACA,6BAAA;A9E4ssBH;AoFjwsBC;EACC,uDAAA;EAGA,gKAAA;EACA,sJAAA;ApFmwsBF;AoF5vsBC;EACC,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF8vsBF;AoF3vsBE;EACC,oBAAA;EACA,sEAAA;ApF6vsBH;AoF3vsBE;EACC,kBAAA;EACA,+EAAA;ApF6vsBH;AoF3vsBE;EACC,oBAAA;EACA,sEAAA;ApF6vsBH;AoF3vsBE;EACC,kBAAA;EACA,+EAAA;ApF6vsBH;AoF3wsBE;EACC,oBAAA;EACA,sEAAA;ApF6wsBH;AoF3wsBE;EACC,kBAAA;EACA,+EAAA;ApF6wsBH;AoF3wsBE;EACC,oBAAA;EACA,sEAAA;ApF6wsBH;AoF3wsBE;EACC,kBAAA;EACA,+EAAA;ApF6wsBH;AoF3xsBE;EACC,oBAAA;EACA,sEAAA;ApF6xsBH;AoF3xsBE;EACC,kBAAA;EACA,+EAAA;ApF6xsBH;AoF3xsBE;EACC,oBAAA;EACA,mEAAA;ApF6xsBH;AoF3xsBE;EACC,kBAAA;EACA,4EAAA;ApF6xsBH;AoF3ysBE;EACC,oBAAA;EACA,sEAAA;ApF6ysBH;AoF3ysBE;EACC,kBAAA;EACA,+EAAA;ApF6ysBH;AoF3ysBE;EACC,oBAAA;EACA,mEAAA;ApF6ysBH;AoF3ysBE;EACC,kBAAA;EACA,4EAAA;ApF6ysBH;AoF90sBC;EACC,oCAAA;EAGA,6HAAA;EACA,sJAAA;ApFg1sBF;AoF90sBC;EAEE,wCAAA;ApF+0sBH;AoF50sBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF80sBF;AoF30sBE;EACC,oBAAA;EACA,6DAAA;ApF60sBH;AoF30sBE;EACC,kBAAA;EACA,sEAAA;ApF60sBH;AoF30sBE;EACC,oBAAA;EACA,4DAAA;ApF60sBH;AoF30sBE;EACC,kBAAA;EACA,qEAAA;ApF60sBH;AoF31sBE;EACC,oBAAA;EACA,6DAAA;ApF61sBH;AoF31sBE;EACC,kBAAA;EACA,sEAAA;ApF61sBH;AoF31sBE;EACC,oBAAA;EACA,2DAAA;ApF61sBH;AoF31sBE;EACC,kBAAA;EACA,oEAAA;ApF61sBH;AoF32sBE;EACC,oBAAA;EACA,6DAAA;ApF62sBH;AoF32sBE;EACC,kBAAA;EACA,sEAAA;ApF62sBH;AoF32sBE;EACC,oBAAA;EACA,0DAAA;ApF62sBH;AoF32sBE;EACC,kBAAA;EACA,mEAAA;ApF62sBH;AoF33sBE;EACC,oBAAA;EACA,4DAAA;ApF63sBH;AoF33sBE;EACC,kBAAA;EACA,qEAAA;ApF63sBH;AoF33sBE;EACC,oBAAA;EACA,0DAAA;ApF63sBH;AoF33sBE;EACC,kBAAA;EACA,mEAAA;ApF63sBH;AoF95sBC;EACC,oCAAA;EAGA,sHAAA;EACA,sJAAA;ApFg6sBF;AoFz5sBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF25sBF;AoFx5sBE;EACC,oBAAA;EACA,iEAAA;ApF05sBH;AoFx5sBE;EACC,kBAAA;EACA,0EAAA;ApF05sBH;AoFx5sBE;EACC,oBAAA;EACA,gEAAA;ApF05sBH;AoFx5sBE;EACC,kBAAA;EACA,yEAAA;ApF05sBH;AoFx6sBE;EACC,oBAAA;EACA,iEAAA;ApF06sBH;AoFx6sBE;EACC,kBAAA;EACA,0EAAA;ApF06sBH;AoFx6sBE;EACC,oBAAA;EACA,+DAAA;ApF06sBH;AoFx6sBE;EACC,kBAAA;EACA,wEAAA;ApF06sBH;AoFx7sBE;EACC,oBAAA;EACA,iEAAA;ApF07sBH;AoFx7sBE;EACC,kBAAA;EACA,0EAAA;ApF07sBH;AoFx7sBE;EACC,oBAAA;EACA,+DAAA;ApF07sBH;AoFx7sBE;EACC,kBAAA;EACA,wEAAA;ApF07sBH;AoFx8sBE;EACC,oBAAA;EACA,iEAAA;ApF08sBH;AoFx8sBE;EACC,kBAAA;EACA,0EAAA;ApF08sBH;AoFx8sBE;EACC,oBAAA;EACA,8DAAA;ApF08sBH;AoFx8sBE;EACC,kBAAA;EACA,uEAAA;ApF08sBH;AoF3+sBC;EACC,uDAAA;EAGA,8JAAA;EACA,sJAAA;ApF6+sBF;AoFt+sBC;EACC,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;ApFw+sBF;AoFr+sBE;EACC,oBAAA;EACA,sEAAA;ApFu+sBH;AoFr+sBE;EACC,kBAAA;EACA,+EAAA;ApFu+sBH;AoFr+sBE;EACC,oBAAA;EACA,qEAAA;ApFu+sBH;AoFr+sBE;EACC,kBAAA;EACA,8EAAA;ApFu+sBH;AoFr/sBE;EACC,oBAAA;EACA,sEAAA;ApFu/sBH;AoFr/sBE;EACC,kBAAA;EACA,+EAAA;ApFu/sBH;AoFr/sBE;EACC,oBAAA;EACA,mEAAA;ApFu/sBH;AoFr/sBE;EACC,kBAAA;EACA,4EAAA;ApFu/sBH;AoFrgtBE;EACC,oBAAA;EACA,sEAAA;ApFugtBH;AoFrgtBE;EACC,kBAAA;EACA,+EAAA;ApFugtBH;AoFrgtBE;EACC,oBAAA;EACA,mEAAA;ApFugtBH;AoFrgtBE;EACC,kBAAA;EACA,4EAAA;ApFugtBH;AoFrhtBE;EACC,oBAAA;EACA,sEAAA;ApFuhtBH;AoFrhtBE;EACC,kBAAA;EACA,+EAAA;ApFuhtBH;AoFrhtBE;EACC,oBAAA;EACA,mEAAA;ApFuhtBH;AoFrhtBE;EACC,kBAAA;EACA,4EAAA;ApFuhtBH;AoFxjtBC;EACC,oCAAA;EAGA,oHAAA;EACA,sJAAA;ApF0jtBF;AoFnjtBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFqjtBF;AoFljtBE;EACC,oBAAA;EACA,iEAAA;ApFojtBH;AoFljtBE;EACC,kBAAA;EACA,0EAAA;ApFojtBH;AoFljtBE;EACC,oBAAA;EACA,+DAAA;ApFojtBH;AoFljtBE;EACC,kBAAA;EACA,wEAAA;ApFojtBH;AoFlktBE;EACC,oBAAA;EACA,iEAAA;ApFoktBH;AoFlktBE;EACC,kBAAA;EACA,0EAAA;ApFoktBH;AoFlktBE;EACC,oBAAA;EACA,8DAAA;ApFoktBH;AoFlktBE;EACC,kBAAA;EACA,uEAAA;ApFoktBH;AoFlltBE;EACC,oBAAA;EACA,iEAAA;ApFoltBH;AoFlltBE;EACC,kBAAA;EACA,0EAAA;ApFoltBH;AoFlltBE;EACC,oBAAA;EACA,8DAAA;ApFoltBH;AoFlltBE;EACC,kBAAA;EACA,uEAAA;ApFoltBH;AoFlmtBE;EACC,oBAAA;EACA,gEAAA;ApFomtBH;AoFlmtBE;EACC,kBAAA;EACA,yEAAA;ApFomtBH;AoFlmtBE;EACC,oBAAA;EACA,6DAAA;ApFomtBH;AoFlmtBE;EACC,kBAAA;EACA,sEAAA;ApFomtBH;AoFrotBC;EACC,oCAAA;EAGA,sFAAA;EACA,sJAAA;ApFuotBF;AoFhotBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;ApFkotBF;AoF/ntBE;EACC,oBAAA;EACA,iEAAA;ApFiotBH;AoF/ntBE;EACC,kBAAA;EACA,0EAAA;ApFiotBH;AoF/ntBE;EACC,oBAAA;EACA,+DAAA;ApFiotBH;AoF/ntBE;EACC,kBAAA;EACA,wEAAA;ApFiotBH;AoF/otBE;EACC,oBAAA;EACA,iEAAA;ApFiptBH;AoF/otBE;EACC,kBAAA;EACA,0EAAA;ApFiptBH;AoF/otBE;EACC,oBAAA;EACA,+DAAA;ApFiptBH;AoF/otBE;EACC,kBAAA;EACA,wEAAA;ApFiptBH;AoF/ptBE;EACC,oBAAA;EACA,iEAAA;ApFiqtBH;AoF/ptBE;EACC,kBAAA;EACA,0EAAA;ApFiqtBH;AoF/ptBE;EACC,oBAAA;EACA,+DAAA;ApFiqtBH;AoF/ptBE;EACC,kBAAA;EACA,wEAAA;ApFiqtBH;AoF/qtBE;EACC,oBAAA;EACA,iEAAA;ApFirtBH;AoF/qtBE;EACC,kBAAA;EACA,0EAAA;ApFirtBH;AoF/qtBE;EACC,oBAAA;EACA,8DAAA;ApFirtBH;AoF/qtBE;EACC,kBAAA;EACA,uEAAA;ApFirtBH;AoFlttBC;EACC,oCAAA;EAGA,6HAAA;EACA,sJAAA;ApFottBF;AoF7stBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF+stBF;AoF5stBE;EACC,oBAAA;EACA,6DAAA;ApF8stBH;AoF5stBE;EACC,kBAAA;EACA,sEAAA;ApF8stBH;AoF5stBE;EACC,oBAAA;EACA,4DAAA;ApF8stBH;AoF5stBE;EACC,kBAAA;EACA,qEAAA;ApF8stBH;AoF5ttBE;EACC,oBAAA;EACA,6DAAA;ApF8ttBH;AoF5ttBE;EACC,kBAAA;EACA,sEAAA;ApF8ttBH;AoF5ttBE;EACC,oBAAA;EACA,2DAAA;ApF8ttBH;AoF5ttBE;EACC,kBAAA;EACA,oEAAA;ApF8ttBH;AoF5utBE;EACC,oBAAA;EACA,6DAAA;ApF8utBH;AoF5utBE;EACC,kBAAA;EACA,sEAAA;ApF8utBH;AoF5utBE;EACC,oBAAA;EACA,0DAAA;ApF8utBH;AoF5utBE;EACC,kBAAA;EACA,mEAAA;ApF8utBH;AoF5vtBE;EACC,oBAAA;EACA,4DAAA;ApF8vtBH;AoF5vtBE;EACC,kBAAA;EACA,qEAAA;ApF8vtBH;AoF5vtBE;EACC,oBAAA;EACA,0DAAA;ApF8vtBH;AoF5vtBE;EACC,kBAAA;EACA,mEAAA;ApF8vtBH;AoF/xtBC;EACC,oCAAA;EAGA,2FAAA;EACA,sJAAA;ApFiytBF;AoF1xtBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF4xtBF;AoFzxtBE;EACC,oBAAA;EACA,6DAAA;ApF2xtBH;AoFzxtBE;EACC,kBAAA;EACA,sEAAA;ApF2xtBH;AoFzxtBE;EACC,oBAAA;EACA,6DAAA;ApF2xtBH;AoFzxtBE;EACC,kBAAA;EACA,sEAAA;ApF2xtBH;AoFzytBE;EACC,oBAAA;EACA,6DAAA;ApF2ytBH;AoFzytBE;EACC,kBAAA;EACA,sEAAA;ApF2ytBH;AoFzytBE;EACC,oBAAA;EACA,6DAAA;ApF2ytBH;AoFzytBE;EACC,kBAAA;EACA,sEAAA;ApF2ytBH;AoFzztBE;EACC,oBAAA;EACA,6DAAA;ApF2ztBH;AoFzztBE;EACC,kBAAA;EACA,sEAAA;ApF2ztBH;AoFzztBE;EACC,oBAAA;EACA,6DAAA;ApF2ztBH;AoFzztBE;EACC,kBAAA;EACA,sEAAA;ApF2ztBH;AoFz0tBE;EACC,oBAAA;EACA,6DAAA;ApF20tBH;AoFz0tBE;EACC,kBAAA;EACA,sEAAA;ApF20tBH;AoFz0tBE;EACC,oBAAA;EACA,0DAAA;ApF20tBH;AoFz0tBE;EACC,kBAAA;EACA,mEAAA;ApF20tBH;AoF52tBC;EACC,oCAAA;EAGA,qHAAA;EACA,sJAAA;ApF82tBF;AoFv2tBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFy2tBF;AoFt2tBE;EACC,oBAAA;EACA,+DAAA;ApFw2tBH;AoFt2tBE;EACC,kBAAA;EACA,wEAAA;ApFw2tBH;AoFt2tBE;EACC,oBAAA;EACA,8DAAA;ApFw2tBH;AoFt2tBE;EACC,kBAAA;EACA,uEAAA;ApFw2tBH;AoFt3tBE;EACC,oBAAA;EACA,+DAAA;ApFw3tBH;AoFt3tBE;EACC,kBAAA;EACA,wEAAA;ApFw3tBH;AoFt3tBE;EACC,oBAAA;EACA,8DAAA;ApFw3tBH;AoFt3tBE;EACC,kBAAA;EACA,uEAAA;ApFw3tBH;AoFt4tBE;EACC,oBAAA;EACA,+DAAA;ApFw4tBH;AoFt4tBE;EACC,kBAAA;EACA,wEAAA;ApFw4tBH;AoFt4tBE;EACC,oBAAA;EACA,6DAAA;ApFw4tBH;AoFt4tBE;EACC,kBAAA;EACA,sEAAA;ApFw4tBH;AoFt5tBE;EACC,oBAAA;EACA,8DAAA;ApFw5tBH;AoFt5tBE;EACC,kBAAA;EACA,uEAAA;ApFw5tBH;AoFt5tBE;EACC,oBAAA;EACA,2DAAA;ApFw5tBH;AoFt5tBE;EACC,kBAAA;EACA,oEAAA;ApFw5tBH;AoFz7tBC;EACC,mDAAA;EAGA,4JAAA;EACA,sJAAA;ApF27tBF;AoFp7tBC;EACC,6CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApFs7tBF;AoFn7tBE;EACC,oBAAA;EACA,sEAAA;ApFq7tBH;AoFn7tBE;EACC,kBAAA;EACA,+EAAA;ApFq7tBH;AoFn7tBE;EACC,oBAAA;EACA,mEAAA;ApFq7tBH;AoFn7tBE;EACC,kBAAA;EACA,4EAAA;ApFq7tBH;AoFn8tBE;EACC,oBAAA;EACA,sEAAA;ApFq8tBH;AoFn8tBE;EACC,kBAAA;EACA,+EAAA;ApFq8tBH;AoFn8tBE;EACC,oBAAA;EACA,mEAAA;ApFq8tBH;AoFn8tBE;EACC,kBAAA;EACA,4EAAA;ApFq8tBH;AoFn9tBE;EACC,oBAAA;EACA,sEAAA;ApFq9tBH;AoFn9tBE;EACC,kBAAA;EACA,+EAAA;ApFq9tBH;AoFn9tBE;EACC,oBAAA;EACA,mEAAA;ApFq9tBH;AoFn9tBE;EACC,kBAAA;EACA,4EAAA;ApFq9tBH;AoFn+tBE;EACC,oBAAA;EACA,qEAAA;ApFq+tBH;AoFn+tBE;EACC,kBAAA;EACA,8EAAA;ApFq+tBH;AoFn+tBE;EACC,oBAAA;EACA,mEAAA;ApFq+tBH;AoFn+tBE;EACC,kBAAA;EACA,4EAAA;ApFq+tBH;AoFtguBC;EACC,oCAAA;EAGA,qFAAA;EACA,sJAAA;ApFwguBF;AoFjguBC;EACC,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,8CAAA;ApFmguBF;AoFhguBE;EACC,oBAAA;EACA,6DAAA;ApFkguBH;AoFhguBE;EACC,kBAAA;EACA,sEAAA;ApFkguBH;AoFhguBE;EACC,oBAAA;EACA,uDAAA;ApFkguBH;AoFhguBE;EACC,kBAAA;EACA,gEAAA;ApFkguBH;AoFhhuBE;EACC,oBAAA;EACA,6DAAA;ApFkhuBH;AoFhhuBE;EACC,kBAAA;EACA,sEAAA;ApFkhuBH;AoFhhuBE;EACC,oBAAA;EACA,uDAAA;ApFkhuBH;AoFhhuBE;EACC,kBAAA;EACA,gEAAA;ApFkhuBH;AoFhiuBE;EACC,oBAAA;EACA,6DAAA;ApFkiuBH;AoFhiuBE;EACC,kBAAA;EACA,sEAAA;ApFkiuBH;AoFhiuBE;EACC,oBAAA;EACA,uDAAA;ApFkiuBH;AoFhiuBE;EACC,kBAAA;EACA,gEAAA;ApFkiuBH;AoFhjuBE;EACC,oBAAA;EACA,0DAAA;ApFkjuBH;AoFhjuBE;EACC,kBAAA;EACA,mEAAA;ApFkjuBH;AoFhjuBE;EACC,oBAAA;EACA,uDAAA;ApFkjuBH;AoFhjuBE;EACC,kBAAA;EACA,gEAAA;ApFkjuBH;AoFnluBC;EACC,oCAAA;EAGA,2FAAA;EACA,sJAAA;ApFqluBF;AoF9kuBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFgluBF;AoF7kuBE;EACC,oBAAA;EACA,6DAAA;ApF+kuBH;AoF7kuBE;EACC,kBAAA;EACA,sEAAA;ApF+kuBH;AoF7kuBE;EACC,oBAAA;EACA,6DAAA;ApF+kuBH;AoF7kuBE;EACC,kBAAA;EACA,sEAAA;ApF+kuBH;AoF7luBE;EACC,oBAAA;EACA,6DAAA;ApF+luBH;AoF7luBE;EACC,kBAAA;EACA,sEAAA;ApF+luBH;AoF7luBE;EACC,oBAAA;EACA,6DAAA;ApF+luBH;AoF7luBE;EACC,kBAAA;EACA,sEAAA;ApF+luBH;AoF7muBE;EACC,oBAAA;EACA,6DAAA;ApF+muBH;AoF7muBE;EACC,kBAAA;EACA,sEAAA;ApF+muBH;AoF7muBE;EACC,oBAAA;EACA,6DAAA;ApF+muBH;AoF7muBE;EACC,kBAAA;EACA,sEAAA;ApF+muBH;AoF7nuBE;EACC,oBAAA;EACA,6DAAA;ApF+nuBH;AoF7nuBE;EACC,kBAAA;EACA,sEAAA;ApF+nuBH;AoF7nuBE;EACC,oBAAA;EACA,0DAAA;ApF+nuBH;AoF7nuBE;EACC,kBAAA;EACA,mEAAA;ApF+nuBH;AoFhquBC;EACC,oCAAA;EAGA,uHAAA;EACA,sJAAA;ApFkquBF;AoF3puBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF6puBF;AoF1puBE;EACC,oBAAA;EACA,+DAAA;ApF4puBH;AoF1puBE;EACC,kBAAA;EACA,wEAAA;ApF4puBH;AoF1puBE;EACC,oBAAA;EACA,+DAAA;ApF4puBH;AoF1puBE;EACC,kBAAA;EACA,wEAAA;ApF4puBH;AoF1quBE;EACC,oBAAA;EACA,+DAAA;ApF4quBH;AoF1quBE;EACC,kBAAA;EACA,wEAAA;ApF4quBH;AoF1quBE;EACC,oBAAA;EACA,8DAAA;ApF4quBH;AoF1quBE;EACC,kBAAA;EACA,uEAAA;ApF4quBH;AoF1ruBE;EACC,oBAAA;EACA,+DAAA;ApF4ruBH;AoF1ruBE;EACC,kBAAA;EACA,wEAAA;ApF4ruBH;AoF1ruBE;EACC,oBAAA;EACA,6DAAA;ApF4ruBH;AoF1ruBE;EACC,kBAAA;EACA,sEAAA;ApF4ruBH;AoF1suBE;EACC,oBAAA;EACA,+DAAA;ApF4suBH;AoF1suBE;EACC,kBAAA;EACA,wEAAA;ApF4suBH;AoF1suBE;EACC,oBAAA;EACA,4DAAA;ApF4suBH;AoF1suBE;EACC,kBAAA;EACA,qEAAA;ApF4suBH;AoF7uuBC;EACC,oCAAA;EAGA,uHAAA;EACA,sJAAA;ApF+uuBF;AoFxuuBC;EACC,8BAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF0uuBF;AoFvuuBE;EACC,oBAAA;EACA,iEAAA;ApFyuuBH;AoFvuuBE;EACC,kBAAA;EACA,0EAAA;ApFyuuBH;AoFvuuBE;EACC,oBAAA;EACA,iEAAA;ApFyuuBH;AoFvuuBE;EACC,kBAAA;EACA,0EAAA;ApFyuuBH;AoFvvuBE;EACC,oBAAA;EACA,iEAAA;ApFyvuBH;AoFvvuBE;EACC,kBAAA;EACA,0EAAA;ApFyvuBH;AoFvvuBE;EACC,oBAAA;EACA,gEAAA;ApFyvuBH;AoFvvuBE;EACC,kBAAA;EACA,yEAAA;ApFyvuBH;AoFvwuBE;EACC,oBAAA;EACA,iEAAA;ApFywuBH;AoFvwuBE;EACC,kBAAA;EACA,0EAAA;ApFywuBH;AoFvwuBE;EACC,oBAAA;EACA,+DAAA;ApFywuBH;AoFvwuBE;EACC,kBAAA;EACA,wEAAA;ApFywuBH;AoFvxuBE;EACC,oBAAA;EACA,iEAAA;ApFyxuBH;AoFvxuBE;EACC,kBAAA;EACA,0EAAA;ApFyxuBH;AoFvxuBE;EACC,oBAAA;EACA,8DAAA;ApFyxuBH;AoFvxuBE;EACC,kBAAA;EACA,uEAAA;ApFyxuBH;AoF1zuBC;EACC,oCAAA;EAGA,sFAAA;EACA,sJAAA;ApF4zuBF;AoFrzuBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;ApFuzuBF;AoFpzuBE;EACC,oBAAA;EACA,iEAAA;ApFszuBH;AoFpzuBE;EACC,kBAAA;EACA,0EAAA;ApFszuBH;AoFpzuBE;EACC,oBAAA;EACA,+DAAA;ApFszuBH;AoFpzuBE;EACC,kBAAA;EACA,wEAAA;ApFszuBH;AoFp0uBE;EACC,oBAAA;EACA,iEAAA;ApFs0uBH;AoFp0uBE;EACC,kBAAA;EACA,0EAAA;ApFs0uBH;AoFp0uBE;EACC,oBAAA;EACA,+DAAA;ApFs0uBH;AoFp0uBE;EACC,kBAAA;EACA,wEAAA;ApFs0uBH;AoFp1uBE;EACC,oBAAA;EACA,iEAAA;ApFs1uBH;AoFp1uBE;EACC,kBAAA;EACA,0EAAA;ApFs1uBH;AoFp1uBE;EACC,oBAAA;EACA,+DAAA;ApFs1uBH;AoFp1uBE;EACC,kBAAA;EACA,wEAAA;ApFs1uBH;AoFp2uBE;EACC,oBAAA;EACA,iEAAA;ApFs2uBH;AoFp2uBE;EACC,kBAAA;EACA,0EAAA;ApFs2uBH;AoFp2uBE;EACC,oBAAA;EACA,8DAAA;ApFs2uBH;AoFp2uBE;EACC,kBAAA;EACA,uEAAA;ApFs2uBH;AoFv4uBC;EACC,oCAAA;EAGA,gKAAA;EACA,sJAAA;ApFy4uBF;AoFl4uBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApFo4uBF;AoFj4uBE;EACC,oBAAA;EACA,iEAAA;ApFm4uBH;AoFj4uBE;EACC,kBAAA;EACA,0EAAA;ApFm4uBH;AoFj4uBE;EACC,oBAAA;EACA,gEAAA;ApFm4uBH;AoFj4uBE;EACC,kBAAA;EACA,yEAAA;ApFm4uBH;AoFj5uBE;EACC,oBAAA;EACA,iEAAA;ApFm5uBH;AoFj5uBE;EACC,kBAAA;EACA,0EAAA;ApFm5uBH;AoFj5uBE;EACC,oBAAA;EACA,+DAAA;ApFm5uBH;AoFj5uBE;EACC,kBAAA;EACA,wEAAA;ApFm5uBH;AoFj6uBE;EACC,oBAAA;EACA,iEAAA;ApFm6uBH;AoFj6uBE;EACC,kBAAA;EACA,0EAAA;ApFm6uBH;AoFj6uBE;EACC,oBAAA;EACA,8DAAA;ApFm6uBH;AoFj6uBE;EACC,kBAAA;EACA,uEAAA;ApFm6uBH;AoFj7uBE;EACC,oBAAA;EACA,iEAAA;ApFm7uBH;AoFj7uBE;EACC,kBAAA;EACA,0EAAA;ApFm7uBH;AoFj7uBE;EACC,oBAAA;EACA,8DAAA;ApFm7uBH;AoFj7uBE;EACC,kBAAA;EACA,uEAAA;ApFm7uBH;AoFp9uBC;EACC,oCAAA;EAGA,6JAAA;EACA,sJAAA;ApFs9uBF;AoF/8uBC;EACC,8BAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;ApFi9uBF;AoF98uBE;EACC,oBAAA;EACA,iEAAA;ApFg9uBH;AoF98uBE;EACC,kBAAA;EACA,0EAAA;ApFg9uBH;AoF98uBE;EACC,oBAAA;EACA,+DAAA;ApFg9uBH;AoF98uBE;EACC,kBAAA;EACA,wEAAA;ApFg9uBH;AoF99uBE;EACC,oBAAA;EACA,iEAAA;ApFg+uBH;AoF99uBE;EACC,kBAAA;EACA,0EAAA;ApFg+uBH;AoF99uBE;EACC,oBAAA;EACA,+DAAA;ApFg+uBH;AoF99uBE;EACC,kBAAA;EACA,wEAAA;ApFg+uBH;AoF9+uBE;EACC,oBAAA;EACA,iEAAA;ApFg/uBH;AoF9+uBE;EACC,kBAAA;EACA,0EAAA;ApFg/uBH;AoF9+uBE;EACC,oBAAA;EACA,8DAAA;ApFg/uBH;AoF9+uBE;EACC,kBAAA;EACA,uEAAA;ApFg/uBH;AoF9/uBE;EACC,oBAAA;EACA,+DAAA;ApFggvBH;AoF9/uBE;EACC,kBAAA;EACA,wEAAA;ApFggvBH;AoF9/uBE;EACC,oBAAA;EACA,6DAAA;ApFggvBH;AoF9/uBE;EACC,kBAAA;EACA,sEAAA;ApFggvBH;AoFjivBC;EACC,oCAAA;EAGA,8JAAA;EACA,sJAAA;ApFmivBF;AoF5hvBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF8hvBF;AoF3hvBE;EACC,oBAAA;EACA,mEAAA;ApF6hvBH;AoF3hvBE;EACC,kBAAA;EACA,4EAAA;ApF6hvBH;AoF3hvBE;EACC,oBAAA;EACA,kEAAA;ApF6hvBH;AoF3hvBE;EACC,kBAAA;EACA,2EAAA;ApF6hvBH;AoF3ivBE;EACC,oBAAA;EACA,mEAAA;ApF6ivBH;AoF3ivBE;EACC,kBAAA;EACA,4EAAA;ApF6ivBH;AoF3ivBE;EACC,oBAAA;EACA,iEAAA;ApF6ivBH;AoF3ivBE;EACC,kBAAA;EACA,0EAAA;ApF6ivBH;AoF3jvBE;EACC,oBAAA;EACA,mEAAA;ApF6jvBH;AoF3jvBE;EACC,kBAAA;EACA,4EAAA;ApF6jvBH;AoF3jvBE;EACC,oBAAA;EACA,+DAAA;ApF6jvBH;AoF3jvBE;EACC,kBAAA;EACA,wEAAA;ApF6jvBH;AoF3kvBE;EACC,oBAAA;EACA,kEAAA;ApF6kvBH;AoF3kvBE;EACC,kBAAA;EACA,2EAAA;ApF6kvBH;AoF3kvBE;EACC,oBAAA;EACA,+DAAA;ApF6kvBH;AoF3kvBE;EACC,kBAAA;EACA,wEAAA;ApF6kvBH;AoF9mvBC;EACC,oCAAA;EAGA,6HAAA;EACA,sJAAA;ApFgnvBF;AoFzmvBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApF2mvBF;AoFxmvBE;EACC,oBAAA;EACA,6DAAA;ApF0mvBH;AoFxmvBE;EACC,kBAAA;EACA,sEAAA;ApF0mvBH;AoFxmvBE;EACC,oBAAA;EACA,4DAAA;ApF0mvBH;AoFxmvBE;EACC,kBAAA;EACA,qEAAA;ApF0mvBH;AoFxnvBE;EACC,oBAAA;EACA,6DAAA;ApF0nvBH;AoFxnvBE;EACC,kBAAA;EACA,sEAAA;ApF0nvBH;AoFxnvBE;EACC,oBAAA;EACA,2DAAA;ApF0nvBH;AoFxnvBE;EACC,kBAAA;EACA,oEAAA;ApF0nvBH;AoFxovBE;EACC,oBAAA;EACA,6DAAA;ApF0ovBH;AoFxovBE;EACC,kBAAA;EACA,sEAAA;ApF0ovBH;AoFxovBE;EACC,oBAAA;EACA,0DAAA;ApF0ovBH;AoFxovBE;EACC,kBAAA;EACA,mEAAA;ApF0ovBH;AoFxpvBE;EACC,oBAAA;EACA,4DAAA;ApF0pvBH;AoFxpvBE;EACC,kBAAA;EACA,qEAAA;ApF0pvBH;AoFxpvBE;EACC,oBAAA;EACA,0DAAA;ApF0pvBH;AoFxpvBE;EACC,kBAAA;EACA,mEAAA;ApF0pvBH;AoF3rvBC;EACC,oCAAA;EAGA,gKAAA;EACA,sJAAA;ApF6rvBF;AoFtrvBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApFwrvBF;AoFrrvBE;EACC,oBAAA;EACA,mEAAA;ApFurvBH;AoFrrvBE;EACC,kBAAA;EACA,4EAAA;ApFurvBH;AoFrrvBE;EACC,oBAAA;EACA,iEAAA;ApFurvBH;AoFrrvBE;EACC,kBAAA;EACA,0EAAA;ApFurvBH;AoFrsvBE;EACC,oBAAA;EACA,mEAAA;ApFusvBH;AoFrsvBE;EACC,kBAAA;EACA,4EAAA;ApFusvBH;AoFrsvBE;EACC,oBAAA;EACA,gEAAA;ApFusvBH;AoFrsvBE;EACC,kBAAA;EACA,yEAAA;ApFusvBH;AoFrtvBE;EACC,oBAAA;EACA,mEAAA;ApFutvBH;AoFrtvBE;EACC,kBAAA;EACA,4EAAA;ApFutvBH;AoFrtvBE;EACC,oBAAA;EACA,gEAAA;ApFutvBH;AoFrtvBE;EACC,kBAAA;EACA,yEAAA;ApFutvBH;AoFruvBE;EACC,oBAAA;EACA,mEAAA;ApFuuvBH;AoFruvBE;EACC,kBAAA;EACA,4EAAA;ApFuuvBH;AoFruvBE;EACC,oBAAA;EACA,gEAAA;ApFuuvBH;AoFruvBE;EACC,kBAAA;EACA,yEAAA;ApFuuvBH;AoFxwvBC;EACC,qDAAA;EAGA,gKAAA;EACA,sJAAA;ApF0wvBF;AoFnwvBC;EACC,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFqwvBF;AoFlwvBE;EACC,oBAAA;EACA,sEAAA;ApFowvBH;AoFlwvBE;EACC,kBAAA;EACA,+EAAA;ApFowvBH;AoFlwvBE;EACC,oBAAA;EACA,sEAAA;ApFowvBH;AoFlwvBE;EACC,kBAAA;EACA,+EAAA;ApFowvBH;AoFlxvBE;EACC,oBAAA;EACA,sEAAA;ApFoxvBH;AoFlxvBE;EACC,kBAAA;EACA,+EAAA;ApFoxvBH;AoFlxvBE;EACC,oBAAA;EACA,sEAAA;ApFoxvBH;AoFlxvBE;EACC,kBAAA;EACA,+EAAA;ApFoxvBH;AoFlyvBE;EACC,oBAAA;EACA,sEAAA;ApFoyvBH;AoFlyvBE;EACC,kBAAA;EACA,+EAAA;ApFoyvBH;AoFlyvBE;EACC,oBAAA;EACA,mEAAA;ApFoyvBH;AoFlyvBE;EACC,kBAAA;EACA,4EAAA;ApFoyvBH;AoFlzvBE;EACC,oBAAA;EACA,sEAAA;ApFozvBH;AoFlzvBE;EACC,kBAAA;EACA,+EAAA;ApFozvBH;AoFlzvBE;EACC,oBAAA;EACA,mEAAA;ApFozvBH;AoFlzvBE;EACC,kBAAA;EACA,4EAAA;ApFozvBH;AoFr1vBC;EACC,oCAAA;EAGA,8JAAA;EACA,sJAAA;ApFu1vBF;AoFh1vBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;ApFk1vBF;AoF/0vBE;EACC,oBAAA;EACA,iEAAA;ApFi1vBH;AoF/0vBE;EACC,kBAAA;EACA,0EAAA;ApFi1vBH;AoF/0vBE;EACC,oBAAA;EACA,gEAAA;ApFi1vBH;AoF/0vBE;EACC,kBAAA;EACA,yEAAA;ApFi1vBH;AoF/1vBE;EACC,oBAAA;EACA,iEAAA;ApFi2vBH;AoF/1vBE;EACC,kBAAA;EACA,0EAAA;ApFi2vBH;AoF/1vBE;EACC,oBAAA;EACA,+DAAA;ApFi2vBH;AoF/1vBE;EACC,kBAAA;EACA,wEAAA;ApFi2vBH;AoF/2vBE;EACC,oBAAA;EACA,iEAAA;ApFi3vBH;AoF/2vBE;EACC,kBAAA;EACA,0EAAA;ApFi3vBH;AoF/2vBE;EACC,oBAAA;EACA,8DAAA;ApFi3vBH;AoF/2vBE;EACC,kBAAA;EACA,uEAAA;ApFi3vBH;AoF/3vBE;EACC,oBAAA;EACA,gEAAA;ApFi4vBH;AoF/3vBE;EACC,kBAAA;EACA,yEAAA;ApFi4vBH;AoF/3vBE;EACC,oBAAA;EACA,6DAAA;ApFi4vBH;AoF/3vBE;EACC,kBAAA;EACA,sEAAA;ApFi4vBH;AoFl6vBC;EACC,qDAAA;EAGA,gKAAA;EACA,sJAAA;ApFo6vBF;AoF75vBC;EACC,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF+5vBF;AoF55vBE;EACC,oBAAA;EACA,sEAAA;ApF85vBH;AoF55vBE;EACC,kBAAA;EACA,+EAAA;ApF85vBH;AoF55vBE;EACC,oBAAA;EACA,sEAAA;ApF85vBH;AoF55vBE;EACC,kBAAA;EACA,+EAAA;ApF85vBH;AoF56vBE;EACC,oBAAA;EACA,sEAAA;ApF86vBH;AoF56vBE;EACC,kBAAA;EACA,+EAAA;ApF86vBH;AoF56vBE;EACC,oBAAA;EACA,sEAAA;ApF86vBH;AoF56vBE;EACC,kBAAA;EACA,+EAAA;ApF86vBH;AoF57vBE;EACC,oBAAA;EACA,sEAAA;ApF87vBH;AoF57vBE;EACC,kBAAA;EACA,+EAAA;ApF87vBH;AoF57vBE;EACC,oBAAA;EACA,mEAAA;ApF87vBH;AoF57vBE;EACC,kBAAA;EACA,4EAAA;ApF87vBH;AoF58vBE;EACC,oBAAA;EACA,sEAAA;ApF88vBH;AoF58vBE;EACC,kBAAA;EACA,+EAAA;ApF88vBH;AoF58vBE;EACC,oBAAA;EACA,mEAAA;ApF88vBH;AoF58vBE;EACC,kBAAA;EACA,4EAAA;ApF88vBH;AoF/+vBC;EACC,uDAAA;EAGA,gKAAA;EACA,sJAAA;ApFi/vBF;AoF1+vBC;EACC,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApF4+vBF;AoFz+vBE;EACC,oBAAA;EACA,sEAAA;ApF2+vBH;AoFz+vBE;EACC,kBAAA;EACA,+EAAA;ApF2+vBH;AoFz+vBE;EACC,oBAAA;EACA,sEAAA;ApF2+vBH;AoFz+vBE;EACC,kBAAA;EACA,+EAAA;ApF2+vBH;AoFz/vBE;EACC,oBAAA;EACA,sEAAA;ApF2/vBH;AoFz/vBE;EACC,kBAAA;EACA,+EAAA;ApF2/vBH;AoFz/vBE;EACC,oBAAA;EACA,sEAAA;ApF2/vBH;AoFz/vBE;EACC,kBAAA;EACA,+EAAA;ApF2/vBH;AoFzgwBE;EACC,oBAAA;EACA,sEAAA;ApF2gwBH;AoFzgwBE;EACC,kBAAA;EACA,+EAAA;ApF2gwBH;AoFzgwBE;EACC,oBAAA;EACA,mEAAA;ApF2gwBH;AoFzgwBE;EACC,kBAAA;EACA,4EAAA;ApF2gwBH;AoFzhwBE;EACC,oBAAA;EACA,sEAAA;ApF2hwBH;AoFzhwBE;EACC,kBAAA;EACA,+EAAA;ApF2hwBH;AoFzhwBE;EACC,oBAAA;EACA,mEAAA;ApF2hwBH;AoFzhwBE;EACC,kBAAA;EACA,4EAAA;ApF2hwBH;AoF5jwBC;EACC,qDAAA;EAGA,gKAAA;EACA,sJAAA;ApF8jwBF;AoFvjwBC;EACC,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,wCAAA;ApFyjwBF;AoFtjwBE;EACC,oBAAA;EACA,sEAAA;ApFwjwBH;AoFtjwBE;EACC,kBAAA;EACA,+EAAA;ApFwjwBH;AoFtjwBE;EACC,oBAAA;EACA,sEAAA;ApFwjwBH;AoFtjwBE;EACC,kBAAA;EACA,+EAAA;ApFwjwBH;AoFtkwBE;EACC,oBAAA;EACA,sEAAA;ApFwkwBH;AoFtkwBE;EACC,kBAAA;EACA,+EAAA;ApFwkwBH;AoFtkwBE;EACC,oBAAA;EACA,oEAAA;ApFwkwBH;AoFtkwBE;EACC,kBAAA;EACA,6EAAA;ApFwkwBH;AoFtlwBE;EACC,oBAAA;EACA,sEAAA;ApFwlwBH;AoFtlwBE;EACC,kBAAA;EACA,+EAAA;ApFwlwBH;AoFtlwBE;EACC,oBAAA;EACA,mEAAA;ApFwlwBH;AoFtlwBE;EACC,kBAAA;EACA,4EAAA;ApFwlwBH;AoFtmwBE;EACC,oBAAA;EACA,sEAAA;ApFwmwBH;AoFtmwBE;EACC,kBAAA;EACA,+EAAA;ApFwmwBH;AoFtmwBE;EACC,oBAAA;EACA,mEAAA;ApFwmwBH;AoFtmwBE;EACC,kBAAA;EACA,4EAAA;ApFwmwBH;AoFzowBC;EACC,uDAAA;EAGA,8JAAA;EACA,sJAAA;ApF2owBF;AoFpowBC;EACC,iDAAA;EACA,wCAAA;EACA,oCAAA;EACA,8CAAA;ApFsowBF;AoFnowBE;EACC,oBAAA;EACA,sEAAA;ApFqowBH;AoFnowBE;EACC,kBAAA;EACA,+EAAA;ApFqowBH;AoFnowBE;EACC,oBAAA;EACA,qEAAA;ApFqowBH;AoFnowBE;EACC,kBAAA;EACA,8EAAA;ApFqowBH;AoFnpwBE;EACC,oBAAA;EACA,sEAAA;ApFqpwBH;AoFnpwBE;EACC,kBAAA;EACA,+EAAA;ApFqpwBH;AoFnpwBE;EACC,oBAAA;EACA,mEAAA;ApFqpwBH;AoFnpwBE;EACC,kBAAA;EACA,4EAAA;ApFqpwBH;AoFnqwBE;EACC,oBAAA;EACA,sEAAA;ApFqqwBH;AoFnqwBE;EACC,kBAAA;EACA,+EAAA;ApFqqwBH;AoFnqwBE;EACC,oBAAA;EACA,mEAAA;ApFqqwBH;AoFnqwBE;EACC,kBAAA;EACA,4EAAA;ApFqqwBH;AoFnrwBE;EACC,oBAAA;EACA,sEAAA;ApFqrwBH;AoFnrwBE;EACC,kBAAA;EACA,+EAAA;ApFqrwBH;AoFnrwBE;EACC,oBAAA;EACA,mEAAA;ApFqrwBH;AoFnrwBE;EACC,kBAAA;EACA,4EAAA;ApFqrwBH;AoFttwBC;EACC,oCAAA;EAGA,gKAAA;EACA,sJAAA;ApFwtwBF;AoFjtwBC;EACC,8BAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApFmtwBF;AoFhtwBE;EACC,oBAAA;EACA,mEAAA;ApFktwBH;AoFhtwBE;EACC,kBAAA;EACA,4EAAA;ApFktwBH;AoFhtwBE;EACC,oBAAA;EACA,iEAAA;ApFktwBH;AoFhtwBE;EACC,kBAAA;EACA,0EAAA;ApFktwBH;AoFhuwBE;EACC,oBAAA;EACA,mEAAA;ApFkuwBH;AoFhuwBE;EACC,kBAAA;EACA,4EAAA;ApFkuwBH;AoFhuwBE;EACC,oBAAA;EACA,gEAAA;ApFkuwBH;AoFhuwBE;EACC,kBAAA;EACA,yEAAA;ApFkuwBH;AoFhvwBE;EACC,oBAAA;EACA,mEAAA;ApFkvwBH;AoFhvwBE;EACC,kBAAA;EACA,4EAAA;ApFkvwBH;AoFhvwBE;EACC,oBAAA;EACA,gEAAA;ApFkvwBH;AoFhvwBE;EACC,kBAAA;EACA,yEAAA;ApFkvwBH;AoFhwwBE;EACC,oBAAA;EACA,mEAAA;ApFkwwBH;AoFhwwBE;EACC,kBAAA;EACA,4EAAA;ApFkwwBH;AoFhwwBE;EACC,oBAAA;EACA,gEAAA;ApFkwwBH;AoFhwwBE;EACC,kBAAA;EACA,yEAAA;ApFkwwBH;AoFnywBC;EACC,qDAAA;EAGA,8JAAA;EACA,sJAAA;ApFqywBF;AoF9xwBC;EACC,+CAAA;EACA,uCAAA;EACA,oCAAA;EACA,8CAAA;ApFgywBF;AoF7xwBE;EACC,oBAAA;EACA,sEAAA;ApF+xwBH;AoF7xwBE;EACC,kBAAA;EACA,+EAAA;ApF+xwBH;AoF7xwBE;EACC,oBAAA;EACA,mEAAA;ApF+xwBH;AoF7xwBE;EACC,kBAAA;EACA,4EAAA;ApF+xwBH;AoF7ywBE;EACC,oBAAA;EACA,sEAAA;ApF+ywBH;AoF7ywBE;EACC,kBAAA;EACA,+EAAA;ApF+ywBH;AoF7ywBE;EACC,oBAAA;EACA,mEAAA;ApF+ywBH;AoF7ywBE;EACC,kBAAA;EACA,4EAAA;ApF+ywBH;AoF7zwBE;EACC,oBAAA;EACA,sEAAA;ApF+zwBH;AoF7zwBE;EACC,kBAAA;EACA,+EAAA;ApF+zwBH;AoF7zwBE;EACC,oBAAA;EACA,mEAAA;ApF+zwBH;AoF7zwBE;EACC,kBAAA;EACA,4EAAA;ApF+zwBH;AoF70wBE;EACC,oBAAA;EACA,sEAAA;ApF+0wBH;AoF70wBE;EACC,kBAAA;EACA,+EAAA;ApF+0wBH;AoF70wBE;EACC,oBAAA;EACA,mEAAA;ApF+0wBH;AoF70wBE;EACC,kBAAA;EACA,4EAAA;ApF+0wBH;AoFh3wBC;EACC,kDAAA;EAGA,6JAAA;EACA,sJAAA;ApFk3wBF;AoF32wBC;EACC,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApF62wBF;AoF12wBE;EACC,oBAAA;EACA,sEAAA;ApF42wBH;AoF12wBE;EACC,kBAAA;EACA,+EAAA;ApF42wBH;AoF12wBE;EACC,oBAAA;EACA,mEAAA;ApF42wBH;AoF12wBE;EACC,kBAAA;EACA,4EAAA;ApF42wBH;AoF13wBE;EACC,oBAAA;EACA,sEAAA;ApF43wBH;AoF13wBE;EACC,kBAAA;EACA,+EAAA;ApF43wBH;AoF13wBE;EACC,oBAAA;EACA,mEAAA;ApF43wBH;AoF13wBE;EACC,kBAAA;EACA,4EAAA;ApF43wBH;AoF14wBE;EACC,oBAAA;EACA,sEAAA;ApF44wBH;AoF14wBE;EACC,kBAAA;EACA,+EAAA;ApF44wBH;AoF14wBE;EACC,oBAAA;EACA,mEAAA;ApF44wBH;AoF14wBE;EACC,kBAAA;EACA,4EAAA;ApF44wBH;AoF15wBE;EACC,oBAAA;EACA,sEAAA;ApF45wBH;AoF15wBE;EACC,kBAAA;EACA,+EAAA;ApF45wBH;AoF15wBE;EACC,oBAAA;EACA,mEAAA;ApF45wBH;AoF15wBE;EACC,kBAAA;EACA,4EAAA;ApF45wBH;AoF77wBC;EACC,mDAAA;EAGA,4JAAA;EACA,sJAAA;ApF+7wBF;AoFx7wBC;EACC,6CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApF07wBF;AoFv7wBE;EACC,oBAAA;EACA,sEAAA;ApFy7wBH;AoFv7wBE;EACC,kBAAA;EACA,+EAAA;ApFy7wBH;AoFv7wBE;EACC,oBAAA;EACA,mEAAA;ApFy7wBH;AoFv7wBE;EACC,kBAAA;EACA,4EAAA;ApFy7wBH;AoFv8wBE;EACC,oBAAA;EACA,sEAAA;ApFy8wBH;AoFv8wBE;EACC,kBAAA;EACA,+EAAA;ApFy8wBH;AoFv8wBE;EACC,oBAAA;EACA,mEAAA;ApFy8wBH;AoFv8wBE;EACC,kBAAA;EACA,4EAAA;ApFy8wBH;AoFv9wBE;EACC,oBAAA;EACA,sEAAA;ApFy9wBH;AoFv9wBE;EACC,kBAAA;EACA,+EAAA;ApFy9wBH;AoFv9wBE;EACC,oBAAA;EACA,mEAAA;ApFy9wBH;AoFv9wBE;EACC,kBAAA;EACA,4EAAA;ApFy9wBH;AoFv+wBE;EACC,oBAAA;EACA,qEAAA;ApFy+wBH;AoFv+wBE;EACC,kBAAA;EACA,8EAAA;ApFy+wBH;AoFv+wBE;EACC,oBAAA;EACA,mEAAA;ApFy+wBH;AoFv+wBE;EACC,kBAAA;EACA,4EAAA;ApFy+wBH;AoF1gxBC;EACC,kDAAA;EAGA,2JAAA;EACA,sJAAA;ApF4gxBF;AoFrgxBC;EACC,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;ApFugxBF;AoFpgxBE;EACC,oBAAA;EACA,sEAAA;ApFsgxBH;AoFpgxBE;EACC,kBAAA;EACA,+EAAA;ApFsgxBH;AoFpgxBE;EACC,oBAAA;EACA,mEAAA;ApFsgxBH;AoFpgxBE;EACC,kBAAA;EACA,4EAAA;ApFsgxBH;AoFphxBE;EACC,oBAAA;EACA,sEAAA;ApFshxBH;AoFphxBE;EACC,kBAAA;EACA,+EAAA;ApFshxBH;AoFphxBE;EACC,oBAAA;EACA,mEAAA;ApFshxBH;AoFphxBE;EACC,kBAAA;EACA,4EAAA;ApFshxBH;AoFpixBE;EACC,oBAAA;EACA,sEAAA;ApFsixBH;AoFpixBE;EACC,kBAAA;EACA,+EAAA;ApFsixBH;AoFpixBE;EACC,oBAAA;EACA,mEAAA;ApFsixBH;AoFpixBE;EACC,kBAAA;EACA,4EAAA;ApFsixBH;AoFpjxBE;EACC,oBAAA;EACA,mEAAA;ApFsjxBH;AoFpjxBE;EACC,kBAAA;EACA,4EAAA;ApFsjxBH;AoFpjxBE;EACC,oBAAA;EACA,iEAAA;ApFsjxBH;AoFpjxBE;EACC,kBAAA;EACA,0EAAA;ApFsjxBH;;A8E5hxBA;EAAW,2BAAA;A9EgixBX;;A8E/hxBA;EAAsB,sCAAA;A9EmixBtB;;A8ElixBA;EAAiB,iCAAA;A9EsixBjB;;A8ErixBA;EAAuB,uCAAA;A9EyixBvB;;AqFvmxBC;EACC,wCP8DqD;A9E4ixBvD;;AqFxmxBC;EAIK,qFAAA;EAQJ,wHAAA;ArFmmxBF;;AqFlnxBC;EACC,mBP+DqD;A9EsjxBvD;;AqFnnxBC;EAIK,qFAAA;EAQJ,wHAAA;ArF8mxBF;;AqF7nxBC;EACC,mBPgEmD;A9EgkxBrD;;AqF9nxBC;EAIK,2GAAA;EAQJ,wHAAA;ArFynxBF;;AqFxoxBC;EACC,8DPiEwD;A9E0kxB1D;;AqFzoxBC;EAIK,gIAAA;EAQJ,wHAAA;ArFooxBF;;AqFnpxBC;EACC,8DPkEqD;A9EolxBvD;;AqFppxBC;EAIK,2GAAA;EAQJ,wHAAA;ArF+oxBF;;AqF9pxBC;EACC,8DPmEuD;A9E8lxBzD;;AqF/pxBC;EAIK,qJAAA;EAQJ,wHAAA;ArF0pxBF;;AqFzqxBC;EACC,mBpF4Ea;ADgmxBf;;AqF1qxBC;EAIK,gEAAA;EAQJ,wHAAA;ArFqqxBF;;AqFprxBC;EACC,mBpF4Ea;AD2mxBf;;AqFrrxBC;EAIK,gEAAA;EAQJ,wHAAA;ArFgrxBF;;AqF/rxBC;EACC,mBpFoFa;AD8mxBf;;AqFhsxBC;EAIK,gEAAA;EAQJ,wHAAA;ArF2rxBF;;AqF1sxBC;EACC,mBpFoFa;ADynxBf;;AqF3sxBC;EAIK,gEAAA;EAQJ,wHAAA;ArFssxBF;;AqFrtxBC;EACC,mBpF6Ea;AD2oxBf;;AqFttxBC;EAIK,gEAAA;EAQJ,wHAAA;ArFitxBF;;AqFhuxBC;EACC,mDPyEwD;A9E0pxB1D;;AqFjuxBC;EAMK,qIAAA;EAMJ,wHAAA;ArF4txBF;;AqF3uxBC;EACC,8DP0EsD;A9EoqxBxD;;AqF5uxBC;EAMK,uJAAA;EAMJ,wHAAA;ArFuuxBF;;AqFtvxBC;EACC,qCP2EsD;A9E8qxBxD;;AqFvvxBC;EAMK,mFAAA;EAMJ,wHAAA;ArFkvxBF;;AqFjwxBC;EACC,+DP4EwD;A9EwrxB1D;;AqFlwxBC;EAMK,yJAAA;EAMJ,wHAAA;ArF6vxBF;;AqF5wxBC;EACC,mBpF4Ea;ADmsxBf;;AqF7wxBC;EAMK,sFAAA;EAMJ,wHAAA;ArFwwxBF;;A8ExsxBA;EACE,gFAAA;A9E2sxBF;;A8EvsxBG;EACC,iBAAA;A9E0sxBJ;;A8EpsxBA,mBAAA;AQ1FE;EACC,qBAAA;AtFkyxBH;;AsFhyxBE;EACC,qBAAA;AtFmyxBH;;AsFjyxBE;EACC,oBAAA;AtFoyxBH;;AsFlyxBE;EACC,uBAAA;AtFqyxBH;;AsFnyxBE;EACC,kBAAA;AtFsyxBH;;AsFpyxBE;EACC,qBAAA;AtFuyxBH;;AsFvzxBE;EACC,uBAAA;AtF0zxBH;;AsFxzxBE;EACC,wBAAA;AtF2zxBH;;AsFzzxBE;EACC,sBAAA;AtF4zxBH;;AsF1zxBE;EACC,uBAAA;AtF6zxBH;;AsF3zxBE;EACC,oBAAA;AtF8zxBH;;AsF5zxBE;EACC,qBAAA;AtF+zxBH;;AsF/0xBE;EACC,uBAAA;AtFk1xBH;;AsFh1xBE;EACC,uBAAA;AtFm1xBH;;AsFj1xBE;EACC,sBAAA;AtFo1xBH;;AsFl1xBE;EACC,uBAAA;AtFq1xBH;;AsFn1xBE;EACC,oBAAA;AtFs1xBH;;AsFp1xBE;EACC,qBAAA;AtFu1xBH;;AsFv2xBE;EACC,uBAAA;AtF02xBH;;AsFx2xBE;EACC,wBAAA;AtF22xBH;;AsFz2xBE;EACC,sBAAA;AtF42xBH;;AsF12xBE;EACC,uBAAA;AtF62xBH;;AsF32xBE;EACC,oBAAA;AtF82xBH;;AsF52xBE;EACC,qBAAA;AtF+2xBH;;AsF/3xBE;EACC,uBAAA;AtFk4xBH;;AsFh4xBE;EACC,uBAAA;AtFm4xBH;;AsFj4xBE;EACC,sBAAA;AtFo4xBH;;AsFl4xBE;EACC,uBAAA;AtFq4xBH;;AsFn4xBE;EACC,oBAAA;AtFs4xBH;;AsFp4xBE;EACC,qBAAA;AtFu4xBH;;AsFv5xBE;EACC,uBAAA;AtF05xBH;;AsFx5xBE;EACC,wBAAA;AtF25xBH;;AsFz5xBE;EACC,sBAAA;AtF45xBH;;AsF15xBE;EACC,uBAAA;AtF65xBH;;AsF35xBE;EACC,oBAAA;AtF85xBH;;AsF55xBE;EACC,qBAAA;AtF+5xBH;;AsF/6xBE;EACC,uBAAA;AtFk7xBH;;AsFh7xBE;EACC,uBAAA;AtFm7xBH;;AsFj7xBE;EACC,sBAAA;AtFo7xBH;;AsFl7xBE;EACC,uBAAA;AtFq7xBH;;AsFn7xBE;EACC,oBAAA;AtFs7xBH;;AsFp7xBE;EACC,qBAAA;AtFu7xBH;;AsFv8xBE;EACC,uBAAA;AtF08xBH;;AsFx8xBE;EACC,wBAAA;AtF28xBH;;AsFz8xBE;EACC,sBAAA;AtF48xBH;;AsF18xBE;EACC,uBAAA;AtF68xBH;;AsF38xBE;EACC,oBAAA;AtF88xBH;;AsF58xBE;EACC,qBAAA;AtF+8xBH;;AsF/9xBE;EACC,uBAAA;AtFk+xBH;;AsFh+xBE;EACC,uBAAA;AtFm+xBH;;AsFj+xBE;EACC,sBAAA;AtFo+xBH;;AsFl+xBE;EACC,uBAAA;AtFq+xBH;;AsFn+xBE;EACC,oBAAA;AtFs+xBH;;AsFp+xBE;EACC,qBAAA;AtFu+xBH;;AsFv/xBE;EACC,uBAAA;AtF0/xBH;;AsFx/xBE;EACC,wBAAA;AtF2/xBH;;AsFz/xBE;EACC,sBAAA;AtF4/xBH;;AsF1/xBE;EACC,uBAAA;AtF6/xBH;;AsF3/xBE;EACC,oBAAA;AtF8/xBH;;AsF5/xBE;EACC,qBAAA;AtF+/xBH;;AsF/gyBE;EACC,qBAAA;AtFkhyBH;;AsFhhyBE;EACC,uBAAA;AtFmhyBH;;AsFjhyBE;EACC,oBAAA;AtFohyBH;;AsFlhyBE;EACC,uBAAA;AtFqhyBH;;AsFnhyBE;EACC,kBAAA;AtFshyBH;;AsFphyBE;EACC,qBAAA;AtFuhyBH;;A8E18xBA,sBAAA;A9DhCI;E8DiCJ;IAEE,gBAAA;IACA,WAAA;E9E68xBA;AACF;;A8E18xBA,mBAAA;AACA;EAAgB,wBAAA;A9E88xBhB;;A8E18xBC;EACC,0DAAA;A9E68xBF;;A8E38xBC;EACC,mCAAA;A9E88xBF;;A8E18xBG;EACC,0DAAA;A9E68xBJ;;A8Et9xBC;EACC,0DAAA;A9Ey9xBF;;A8Ev9xBC;EACC,mCAAA;A9E09xBF;;A8Et9xBG;EACC,0DAAA;A9Ey9xBJ;;A8El+xBC;EACC,0DAAA;A9Eq+xBF;;A8En+xBC;EACC,mCAAA;A9Es+xBF;;A8El+xBG;EACC,0DAAA;A9Eq+xBJ;;A8E9+xBC;EACC,0DAAA;A9Ei/xBF;;A8E/+xBC;EACC,mCAAA;A9Ek/xBF;;A8E9+xBG;EACC,0DAAA;A9Ei/xBJ;;A8E1/xBC;EACC,0DAAA;A9E6/xBF;;A8E3/xBC;EACC,mCAAA;A9E8/xBF;;A8E1/xBG;EACC,0DAAA;A9E6/xBJ;;A8EtgyBC;EACC,0DAAA;A9EygyBF;;A8EvgyBC;EACC,mCAAA;A9E0gyBF;;A8EtgyBG;EACC,0DAAA;A9EygyBJ;;A8ElhyBC;EACC,0DAAA;A9EqhyBF;;A8EnhyBC;EACC,mCAAA;A9EshyBF;;A8ElhyBG;EACC,0DAAA;A9EqhyBJ;;A8E9hyBC;EACC,0DAAA;A9EiiyBF;;A8E/hyBC;EACC,mCAAA;A9EkiyBF;;A8E9hyBG;EACC,0DAAA;A9EiiyBJ;;A8E3hyBA,gBAAA;AACA;EACC,oBAAA;A9E8hyBD;;A8E3hyBA,iBAAA;AACA;;;;;EAKC,iCAAA;EACA,6BAAA;A9E8hyBD;;A8E5hyBA;EACC,iCAAA;EACA,6BAAA;EACA,kBAAA;A9E+hyBD;A8E7hyBC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEA,kB7EiR8C;EuBvZ1C,qIsDuIJ;A9E8hyBF;AwBjqyBM;EsD0HL;ItDzHO,gBAAA;ExBoqyBN;AACF;A8EjiyBC;EAEC,iCAAA;EACA,6BAAA;A9EkiyBF;A8EhiyBC;EAIC,iCAAA;EACA,6BAAA;A9E+hyBF;A8E7hyBE;EACC,oCAAA;A9E+hyBH;A8ErhyBA;EACC,sBAAA;EACA,6BAAA;A9EuhyBD;A8ErhyBC;EAEC,iCAAA;EACA,6BAAA;A9EshyBF;A8EphyBC;EAEC,sBAAA;A9EqhyBF;A8E5gyBA;EACC,sBAAA;A9E8gyBD;A8E5gyBC;EACC,qCAAA;A9E8gyBF;;AuFttyBA;EACC,kBAAA;EACA,SAAA;EAKC,sBtF8e8C;ADuuxBhD;AgBhpyBI;EuE5EJ;IAUE,kBAAA;IAKC,cAAA;EvFktyBD;AACF;AuF/syBC;EACC,kBAAA;AvFityBF;AgBzpyBI;EuEzDH;IAIE,kBAAA;EvFktyBD;AACF;AuFhtyBC;EACC,kBtFyf8C;EsFxf9C,mBtFwf8C;AD0txBhD;AgBlqyBI;EuElDH;IAKE,kBtFkS6C;IsFjS7C,mBtFiS6C;EDk7xB9C;AACF;AuFjtyBC;EACC,iBtF+e8C;EsF9e9C,oBtF8e8C;ADquxBhD;AgB5qyBI;EuEzCH;IAKE,iBtFyR6C;IsFxR7C,oBtFwR6C;ED47xB9C;AACF;;AwF9vyBA;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBvF+U+C;EuF9U/C,0CAAA;EAMC,sBAAA;EACA,kBvFsgB8C;ADsvxBhD;AgB9ryBI;EwE5EJ;IAiBE,eAAA;IACA,cAAA;ExF6vyBA;AACF;;AyFhxyBA;EACC,exFqe+C;EwFpe/C,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,axFke+C;EwFje/C,mCAAA;EACA,aAAA;EACA,iCAAA;AzFmxyBD;AyFjxyBC;EACC,YAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AzFmxyBF;AyFjxyBE;EACC,eAAA;EACA,cAAA;EACA,WAAA;EACA,0DAAA;EACA,2BAAA;AzFmxyBH;AyFjxyBG;EACC,mBAAA;AzFmxyBJ;AyF/wyBG;EACC,2DAAA;AzFixyBJ;AyF7wyBC;EACC,YAAA;EACA,aAAA;EAKC,kBAAA;AzF2wyBH;AgB5uyBI;EyEtCH;IAWE,aAAA;IACA,mBAAA;EzF2wyBD;AACF;AyFzwyBC;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EAKC,kBAAA;AzFuwyBH;AgBxvyBI;EyEvBH;IAYE,aAAA;EzFuwyBD;AACF;AyFpwyBC;EACC,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AzFswyBF;AgBpwyBI;EyEPH;IAQE,aAAA;EzFuwyBD;AACF;AyFrwyBE;EACC,qBAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AzFuwyBH;AgBjxyBI;EyEIF;IASE,aAAA;EzFwwyBF;AACF;AyFtwyBG;EACC,eAAA;EACA,gBAAA;EAKC,kBxF8N2C;ADsiyBhD;AyFjwyBG;EACC,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,kBxF6M2C;ADkjyBhD;AyF5vyBI;EACC,cAAA;EACA,uBAAA;EACA,gBxF2N2C;EwF1N3C,kBAAA;AzF8vyBL;AyFzvyBC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AzF2vyBF;AyFzvyBE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;AzF2vyBH;AyFzvyBG;EACC,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AzF2vyBJ;AyFzvyBI;EACC,WAAA;EACA,YAAA;EAKC,qBAAA;AzFuvyBN;AyFpvyBK;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AzFsvyBN;AyFnvyBI;EACC,kBAAA;AzFqvyBL;AyFnvyBI;EACC,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EAKC,WxFgJ0C;ADimyBhD;AyF3uyBC;EACC,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,exF0S8C;EwFzS9C,mCAAA;EACA,gCAAA;AzF6uyBF;AyF3uyBE;EACC,qBxFwS6C;EwFvS7C,cAAA;EACA,exFmS6C;EwFlS7C,aAAA;AzF6uyBH;AyF3uyBG;EACC,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AzF6uyBJ;AyF1uyBK;EACC,cAAA;AzF4uyBN;AyFzuyBI;EACC,qDAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AzF2uyBL;AyFzuyBK;EACC,sCAAA;AzF2uyBN;AyFvuyBG;EACC,SAAA;AzFyuyBJ;AyFvuyBI;EACC,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AzFyuyBL;AyFruyBE;EACC,MAAA;AzFuuyBH;AgBn4yBI;EyE+JH;IAEE,kBAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,mCAAA;IACA,eAAA;EzFsuyBD;AACF;;A0Fz9yBA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,azFwf+C;EyFvf/C,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,+BzFif+C;AD2+xBhD;;A2F1+yBA;EACC;IAAK,+BAAA;E3F8+yBJ;AACF;A2F5+yBA;EACC,gB1Fgf+C;E0F/e/C,SAAA;EACA,eAAA;EACA,Y1F8d+C;E0F7d/C,a1Fkf+C;E0F7e9C,OAAA;A3F0+yBF;AgB56yBI;E2ExEJ;IAcE,MAAA;IACA,a1Fye8C;I0Fxe9C,2CAAA;IAKC,gBAAA;E3Fs+yBD;AACF;A2Fn+yBC;EACC,sBAAA;A3Fq+yBF;A2Fn+yBE;EAEC,wBAAA;A3Fo+yBH;A2Fh+yBC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;A3Fk+yBF;A2Fh+yBE;EACC,kBAAA;A3Fk+yBH;A2Fh+yBG;EACC,yBAAA;EACA,qBAAA;EACA,gB1FoS4C;E0FnS5C,8CAAA;A3Fk+yBJ;A2F/9yBI;EACC,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;A3Fi+yBL;A2F/9yBK;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,qBAAA;A3F69yBP;A2F19yBK;EACC,oBAAA;A3F49yBN;A2F19yBK;EACC,SAAA;A3F49yBN;A2F19yBK;EAEC,kDAAA;A3F29yBN;A2Fx9yBI;EACC,gBAAA;EACA,aAAA;EACA,iBAAA;A3F09yBL;A2Fx9yBK;EACC,kBAAA;EAKC,sBAAA;A3Fs9yBP;A2Fj9yBK;EACE,mDAAA;A3Fm9yBP;A2Fh9yBM;EACC,sB1F2YyC;ADukyBhD;A2F98yBM;EACC,cAAA;A3Fg9yBP;A2F38yBK;EACC,cAAA;A3F68yBN;A2F38yBM;EACC,+EAAA;EAKC,mCAAA;A3Fy8yBR;A2F57yBK;EACC,qBALM;A3Fm8yBZ;A2F/7yBK;EACC,qBALM;A3Fs8yBZ;A2Fl8yBK;EACC,qBALM;A3Fy8yBZ;A2Fr8yBK;EACC,qBALM;A3F48yBZ;A2Fx8yBK;EACC,sBALM;A3F+8yBZ;A2F38yBK;EACC,sBALM;A3Fk9yBZ;A2F98yBK;EACC,sBALM;A3Fq9yBZ;A2Fj9yBK;EACC,sBALM;A3Fw9yBZ;A2Fp9yBK;EACC,sBALM;A3F29yBZ;A2Fv9yBK;EACC,sBALM;A3F89yBZ;A2F19yBK;EACC,sBALM;A3Fi+yBZ;A2F79yBK;EACC,sBALM;A3Fo+yBZ;A2Fh+yBK;EACC,sBALM;A3Fu+yBZ;A2Fn+yBK;EACC,sBALM;A3F0+yBZ;A2Ft+yBK;EACC,sBALM;A3F6+yBZ;A2Fz+yBK;EACC,sBALM;A3Fg/yBZ;A2F5+yBK;EACC,sBALM;A3Fm/yBZ;A2F/+yBK;EACC,sBALM;A3Fs/yBZ;A2Fl/yBK;EACC,sBALM;A3Fy/yBZ;A2Fr/yBK;EACC,sBALM;A3F4/yBZ;A2Fx/yBK;EACC,sBALM;A3F+/yBZ;A2F3/yBK;EACC,sBALM;A3FkgzBZ;A2F9/yBK;EACC,sBALM;A3FqgzBZ;A2FjgzBK;EACC,sBALM;A3FwgzBZ;A2FpgzBK;EACC,sBALM;A3F2gzBZ;A2FvgzBK;EACC,sBALM;A3F8gzBZ;A2F1gzBK;EACC,sBALM;A3FihzBZ;A2F7gzBK;EACC,sBALM;A3FohzBZ;A2FhhzBK;EACC,sBALM;A3FuhzBZ;A2FnhzBK;EACC,sBALM;A3F0hzBZ;A2FthzBK;EACC,sBALM;A3F6hzBZ;A2FzhzBK;EACC,sBALM;A3FgizBZ;A2F5hzBK;EACC,sBALM;A3FmizBZ;A2F/hzBK;EACC,sBALM;A3FsizBZ;A2FlizBK;EACC,sBALM;A3FyizBZ;A2FrizBK;EACC,sBALM;A3F4izBZ;A2FxizBK;EACC,sBALM;A3F+izBZ;A2F3izBK;EACC,sBALM;A3FkjzBZ;A2F9izBK;EACC,sBALM;A3FqjzBZ;A2FjjzBK;EACC,sBALM;A3FwjzBZ;A2FpjzBK;EACC,sBALM;A3F2jzBZ;A2FvjzBK;EACC,sBALM;A3F8jzBZ;A2F1jzBK;EACC,sBALM;A3FikzBZ;A2F7jzBK;EACC,sBALM;A3FokzBZ;A2FhkzBK;EACC,sBALM;A3FukzBZ;A2FnkzBK;EACC,sBALM;A3F0kzBZ;A2FtkzBK;EACC,sBALM;A3F6kzBZ;A2FzkzBK;EACC,sBALM;A3FglzBZ;A2F5kzBK;EACC,sBALM;A3FmlzBZ;A2FxkzBC;EACC,aAAA;A3F0kzBF;A2FxkzBC;EACC,yBAAA;A3F0kzBF;A2FrkzBK;EACC,qBAAA;A3FukzBN;;A4FruzBA;EACC,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EAMC,aAAA;EACA,kCAAA;A5FmuzBF;A4FhuzBC;EACC,YApBkB;EAqBlB,kBAAA;EAKC,QAAA;A5F8tzBH;A4F3tzBC;EACC,YA9BkB;EA+BlB,wCAAA;EACA,4D3FkZ8C;E2FjZ9C,eAAA;EACA,WAAA;A5F6tzBF;A4F3tzBE;EACC,gBAAA;EACA,aAAA;EACA,eAAA;A5F6tzBH;A4F3tzBG;EACC,gBAAA;EACA,UAAA;A5F6tzBJ;A4F3tzBI;EACC,YAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;A5F6tzBL;A4F3tzBK;EACC,YAAA;A5F6tzBN;A4FztzBK;EACC,UAAA;A5F2tzBN;A4FztzBM;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,c3FJQ;E2FKR,aAAA;EACA,mBAAA;EACA,uBAAA;ECtEN,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7FkyzBD;A4FvtzBE;EACC,c3FjBY;E2FkBZ,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;A5FytzBH;A4FvtzBG;EACC,kBAAA;A5FytzBJ;A4FvtzBI;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ECtGJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fg0zBD;A4FztzBG;EACC,qBAAA;EACA,gB3FsO4C;E2FrO5C,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;A5F2tzBJ;A4FztzBG;EACC,YAAA;A5F2tzBJ;A4FztzBG;EACC,UAAA;A5F2tzBJ;A4FxtzBK;EACC,c3FhES;AD0xzBf;A4FxtzBK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,8BAAA;A5F0tzBN;A4FltzBE;EACC,gBAAA;EACA,aAAA;EACA,eAAA;A5FotzBH;A4FltzBG;EACC,gBAAA;EACA,aAAA;A5FotzBJ;A4FltzBI;EACC,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;A5FotzBL;A4FltzBK;EACC,YAAA;A5FotzBN;A4FltzBK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mB3FpFS;E2FqFT,aAAA;A5FotzBN;A4FhtzBK;EACC,UAAA;A5FktzBN;A4FhtzBM;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,c3F7HQ;E2F8HR,aAAA;EACA,mBAAA;EACA,uBAAA;EC/LN,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fk5zBD;A4F9szBC;EACC,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,sCAAA;EACA,wCAAA;EACA,kBAAA;EAMC,OAAA;EACA,kBAAA;A5F2szBH;A4FxszBC;EAIE,QAAA;A5FuszBH;;A8Ft6zBA;EACC;IAAO,eAAA;E9F06zBN;E8Fz6zBD;IAAK,OAAA;E9F46zBJ;AACF;A8F36zBA;EACC;IAAO,gBAAA;E9F86zBN;E8F76zBD;IAAK,QAAA;E9Fg7zBJ;AACF;A8F/6zBA;EACC,oCAAA;EACA,OAAA;EACA,QAAA;EACA,a7Fuf+C;AD07yBhD;AgBh4zBI;E8ErDJ;IAOE,Y7Fqd8C;I6Fpd9C,eAAA;IACA,gB7Fmf8C;ED+7yB9C;AACF;AgB13zBI;E8ElEJ;IAYE,aAAA;E9Fo7zBA;AACF;AgB54zBI;E8EtCH;IAEE,aAAA;IACA,iBAAA;IACA,mBAAA;E9Fo7zBD;AACF;AgBt4zBI;E8EnDH;IAOE,cAAA;IACA,oBAAA;E9Fs7zBD;AACF;A8Fp7zBE;EACC,kBAAA;A9Fs7zBH;A8Fp7zBG;EACC,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;A9Fs7zBJ;AgB15zBI;E8ErCD;IAYE,mBAAA;IACA,sBAAA;E9Fu7zBH;AACF;A8Fr7zBI;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,qBAAA;A9Fm7zBN;A8Fh7zBI;EACC,oBAAA;EAKC,oBAAA;A9F86zBN;A8F36zBI;EACC,SAAA;A9F66zBL;A8F36zBI;EAEC,kDAAA;A9F46zBL;A8Fz6zBG;EACC,iDAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;A9F26zBJ;AgBx8zBI;E8EyBD;IAOE,kBAAA;IACA,kCAAA;IAKC,OAAA;E9Fw6zBJ;AACF;AgBl8zBI;E8EYD;IAiBE,cAAA;IACA,oB7FuN2C;I6FlN1C,sBAAA;E9Fq6zBJ;AACF;A8Fl6zBI;EACC,kBAAA;A9Fo6zBL;A8Fl6zBK;EACC,qBAAA;A9Fo6zBN;A8F/5zBI;EACC,mDAAA;A9Fi6zBL;A8F95zBK;EACC,sB7F2Y0C;ADqhzBhD;A8F55zBG;EACC,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;A9F85zBJ;AgB39zBI;E8EyDD;IAOE,wBAAA;E9F+5zBH;AACF;A8F75zBI;EACC,UAAA;EACA,kBAAA;EACA,e7FoX2C;E6FnX3C,gB7FmX2C;E6FlX3C,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;A9F+5zBL;A8F75zBK;EACC,WAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;A9F+5zBN;A8F75zBK;EAEC,kDAAA;A9F85zBN;A8F35zBI;EAIE,cAAA;A9F05zBN;A8Fv5zBK;EAIE,gDAAA;A9Fs5zBP;A8Fn5zBK;EAKE,OAAA;EACA,yCAAA;A9Fi5zBP;A8F74zBI;EAIE,eAAA;A9F44zBN;A8Fz4zBK;EAIE,iDAAA;A9Fw4zBP;A8Fr4zBK;EAKE,QAAA;EACA,0CAAA;A9Fm4zBP;AgBvh0BI;E8E6JC;IAEE,cAAA;E9F43zBL;AACF;;A+F3l0BA;EACC,oB9Fqe+C;ADynzBhD;;AgBhi0BI;EgF/DJ;IAEE,iBAAA;EhGkm0BA;EgGhm0BA;IAEC,gBAAA;IACA,iBAAA;IACA,kBAAA;EhGim0BD;EgG/l0BA;IACC,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EhGim0BD;EgG/l0BC;IACC,eAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;EhGim0BF;EgG9l0BA;IAIE,UAAA;EhG6l0BF;AACF;;AiGxn0BC;EACC,6BAAA;AjG2n0BF;AiGxn0BE;EACC,aAAA;AjG0n0BH;;AkG/n0BC;EACC,SAAA;AlGko0BF;AkGho0BC;EAIE,iBjG4gB6C;ADmnzBhD;AgB3j0BI;EkFxEH;IAWG,iBjGkT4C;ED00zB9C;AACF;;AmG5o0BA;EACC,iBAAA;EACA,aAAA;EACA,sBAAA;AnG+o0BD;;AoGlp0BA;EACC,iBAAA;ApGqp0BD;;AqGtp0BA;EAKE;IAAO,cAAA;IAAgB,UAAA;ErGup0BvB;EqGtp0BA;IAAK,uBAAA;IAAkC,UAAA;ErG0p0BvC;AACF;AqGxp0BA;EAKE;IAAO,sBpGueuC;EDgrzB9C;EqGtp0BA;IAAK,cAAA;ErGyp0BL;AACF;AqGvp0BA;EAKE;IAAO,sBpG8duC;EDwrzB9C;EqGrp0BA;IAAK,iBpG4fyC;ED4pzB9C;AACF;AgBln0BI;EqFhCF;IACC,UAAA;IASC,uBAAA;ErG6o0BF;EqGpp0BC;IACC,qEAAA;ErGsp0BF;EqG7o0BA;IACC,qEAAA;IAKC,cAAA;ErG2o0BF;EqGxo0BA;IACC,oEAAA;IAKC,iBpGyd4C;ED6qzB9C;AACF;;AsGls0BA;EAKE;IAAO,gBAAA;EtGks0BP;EsGjs0BA;IAAK,OAAA;EtGos0BL;AACF;AsGjs0BA;EACC;IAAO,uBAAA;EtGos0BN;EsGns0BD;IAAK,+BrGmf0C;EDmtzB9C;AACF;AgBvo0BI;EsF3DF;IACC,gDAAA;IAKC,OAAA;EtGis0BF;EsG9r0BA;IACC,cAAA;IACA,+BrGme6C;IqGle7C,6CAAA;EtGgs0BD;AACF;;AuG9t0BA;EAKE;IAAO,uBAAA;EvG8t0BP;EuG7t0BA;IAAK,cAAA;EvGgu0BL;AACF;AuG9t0BA;EAKE;IAAO,cAAA;EvG6t0BP;EuG5t0BA;IAAK,sBtGseyC;EDyvzB9C;AACF;AuG7t0BA;EAKE;IAAO,iBtG6fuC;ED+tzB9C;EuG3t0BA;IAAK,sBAAA;EvG8t0BL;AACF;AgBxr0BI;EuFjCF;IACC,mEAAA;IAKC,cAAA;EvGwt0BF;EuGrt0BA;IACC,mEAAA;IAKC,sBtGwc4C;ED2wzB9C;EuGht0BA;IACC,kEAAA;IAKC,sBAAA;EvG8s0BF;AACF;;AgBts0BI;EwF/DJ;IAEE,qBAAA;ExGww0BA;EwGtw0BA;IACC,aAAA;ExGww0BD;AACF;AgB/s0BI;EwFtDH;IAEE,qBvG2f6C;ED4wzB9C;EwGrw0BC;IACC,avGwf4C;ED+wzB9C;AACF;;AyGtx0BA;EACC,cAAA;AzGyx0BD;;A0Gzx0BC;EACC,SAAA;A1G4x0BF;;A2G9x0BA;EACC,iBAAA;A3Giy0BD;A2G9x0BE;EACC,qBAAA;A3Ggy0BH;A2G9x0BG;EACC,0BAAA;A3Ggy0BJ;A4Gxy0BA;EACC,eAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,yCAAA;EACA,c3G0Dc;E2GzDd,kBAAA;EACA,qBAAA;EACA,a3G+d+C;E2G9d/C,mBAAA;EACA,qI3G0oB+C;E2GzoB/C,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,eAAA;A5Gsy0BF;AgB7u0BI;E4F5EJ;IAsBE,eAAA;IACA,a3Gid8C;I2G5c7C,cAAA;E5Gmy0BD;AACF;A4Ghy0BC;EACC,2BAAA;EACA,4BAAA;EACA,qBAAA;A5Gky0BF;;A6Gp00BC;EACC,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;A7Gu00BF;;A6Gp00BA;EACC,+CAAA;EAEA,kBAAA;EACA,YAAA;A7Gs00BD;A6Gp00BC;EACC,0CAAA;A7Gs00BF;A6Gp00BC;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;A7Gs00BF;A6Gp00BE;EAEC,gBAAA;A7Gq00BH;A6Gn00BE;EACC,SAAA;EACA,gBAAA;A7Gq00BH;A6Gl00BE;EACC,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;A7Go00BH;A6Gl00BE;EACC,SAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A7Go00BH;A6Gl00BE;EACC,WAAA;A7Go00BH;A6G7z0BK;EACC,gCAAA;A7G+z0BN;A6Grz0BK;EACC,6BAAA;EACA,sCAAA;A7Guz0BN;A6Ghz0BC;EAEC,WAAA;EACA,kBAAA;A7Giz0BF;A6G/y0BC;EACC,UAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,2DAAA;EACA,8DAAA;A7Giz0BF;A6G/y0BC;EACC,SAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,4DAAA;EACA,6DAAA;A7Giz0BF;A6G9y0BC;EACC,kBAAA;EACA,WAAA;A7Ggz0BF;A6G9y0BC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;A7Ggz0BF;A6G9y0BC;EAIC,WAAA;EACA,YAAA;EACA,kBAAA;A7G6y0BF;A6G3y0BE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kDAAA;A7G6y0BH;A6G3y0BE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kDAAA;A7G6y0BH;A6G1y0BC;EAEC,MAAA;A7G2y0BF;A6Gzy0BE;EACC,QAAA;A7G2y0BH;A6Gzy0BE;EACC,MAAA;A7G2y0BH;A6Gxy0BC;EAEC,SAAA;A7Gyy0BF;A6Gvy0BE;EACC,WAAA;A7Gyy0BH;A6Gvy0BE;EACC,SAAA;A7Gyy0BH;A6Gty0BC;EAEC,OAAA;A7Guy0BF;A6Gry0BE;EAEC,OAAA;A7Gsy0BH;A6Gny0BC;EAEC,QAAA;A7Goy0BF;A6Gly0BE;EAEC,QAAA;A7Gmy0BH;;AgBl40BI;E8F5EJ;IAEI,eAAA;E9Gi90BF;AACF;AgBx40BI;E8F5EJ;IAKI,eAAA;E9Gm90BF;AACF;;A+Gx90BC;EACC,gBAAA;EACA,qBAAA;EACE,uCAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;A/G290BJ;;A+Gv90BC;EAEC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;A/Gy90BF;;AgH9+0BA;EACC,gBAAA;AhHi/0BD;;AiHl/0BA;EACC;IAAO,UAAA;EjHs/0BN;EiHr/0BD;IAAK,UAAA;EjHw/0BJ;AACF;AiHt/0BA;EACC,4DhH4a+C;AD4k0BhD;AiHt/0BC;EACC,kEAAA;AjHw/0BF;;AgBr70BI;EiG/DH;IAEE,iBAAA;EjHu/0BD;EiHr/0BC;IACC,wBAAA;IACA,yBAAA;IACA,sBAAA;EjHu/0BF;AACF;;AkH1g1BE;EACC,kEAAA;AlH6g1BH;;AmH9g1BE;EACC,kEAAA;AnHih1BH;;AoHnh1BC;EACC,cnHuFa;AD+70Bf;;AqHrh1BG;EACC,4DAAA;ArHwh1BJ;AqHth1BI;EACC,4DAAA;ArHwh1BL;AqHrh1BI;EAIE,6DAAA;ArHoh1BN;;AsHji1BC;EAIC,YAAA;EACA,WAAA;AtHii1BF;AsH/h1BC;EACC,oCAAA;AtHii1BF;AsH/h1BC;EACC,uCAAA;AtHii1BF;AsH/h1BC;EACC,0CAAA;AtHii1BF;;AuHhj1BA;EACC,sBAAA;AvHmj1BD;AuHjj1BC;EACC,sCAAA;AvHmj1BF;;AwHrj1BE;EACC,kBAAA;AxHwj1BH;AwHpj1BE;EACC,eAAA;EACA,WAAA;AxHsj1BH;AwHpj1BG;EACC,gBAAA;AxHsj1BJ;AwHjj1BE;EACC,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AxHmj1BH;AwHjj1BE;EAGC,gBAAA;EACA,YAAA;AxHij1BH;;AwH1i1BG;EACC,yBAAA;AxH6i1BJ;;AyH7k1BI;EACC,YAAA;EACA,oCAAA;EACA,eAAA;EACA,wBAAA;AzHgl1BL;AyH9k1BK;EAEC,wBxH2qC0C;EwH1qC1C,oCAAA;AzH+k1BN;AyH3k1BK;EACC,wBxHqqC0C;EwHpqC1C,oCAAA;AzH6k1BN;;AgBph1BI;E0G5EJ;IAEE,gBAAA;E1Hmm1BA;E0Hjm1BA;IAGC,kBAAA;E1Him1BD;AACF;;A0H3l1BE;EACC,UAAA;A1H8l1BH;A0H5l1BG;EACC,kBAAA;EACA,wCAAA;A1H8l1BJ;A0H5l1BI;EACC,aAAA;EACA,cAAA;EACA,cAAA;EACA,gBzH4T2C;EyH3T3C,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;A1H8l1BL;A0H5l1BI;EACC,kBAAA;EACA,qBAAA;EACA,gBzH8S2C;EyH7S3C,oBAAA;A1H8l1BL;A0H5l1BI;EAEC,sBAAA;A1H6l1BL;A0H3l1BK;EACC,6BAAA;EACA,sBAAA;A1H6l1BN;A0H3l1BK;EAEC,2BAAA;A1H4l1BN;A0Hxl1BK;EACC,oDAAA;A1H0l1BN;A0Hvl1BI;EACC,wCAAA;A1Hyl1BL;A0Hvl1BI;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,4CAAA;EACA,2BAAA;A1Hyl1BL;A0Hvl1BI;EACC,uBAAA;EACA,uBAAA;A1Hyl1BL;A0Hpl1BK;EACC,aAAA;A1Hsl1BN;A0Hhl1BK;EACC,aAAA;A1Hkl1BN;A0H3k1BE;EACC,eAAA;A1H6k1BH;A0H3k1BG;EACC,kBAAA;EACA,wCAAA;EACA,6CAAA;EACA,mBAAA;A1H6k1BJ;A0H3k1BI;EACC,kBAAA;EACA,gBzH6O2C;EyH5O3C,oBAAA;A1H6k1BL;A0H3k1BI;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;EACA,kDAAA;EACA,2BAAA;A1H6k1BL;A0H3k1BI;EACC,wCAAA;A1H6k1BL;A0H3k1BI;EAEC,2BAAA;EACA,4BAAA;A1H4k1BL;A0H1k1BK;EACC,2BAAA;A1H4k1BN;A0Hzk1BI;EACC,oDAAA;A1H2k1BL;A0Htk1BK;EACC,aAAA;A1Hwk1BN;A0Hjk1BE;EACC,UAAA;A1Hmk1BH;A0Hjk1BG;EACC,kBAAA;EACA,wCAAA;A1Hmk1BJ;A0Hjk1BI;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBzH0L2C;EyHzL3C,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;A1Hmk1BL;A0Hjk1BI;EACC,oBAAA;EACA,gBzH6K2C;EyH5K3C,kBAAA;A1Hmk1BL;A0Hjk1BI;EACC,kBAAA;EACA,oBAAA;A1Hmk1BL;A0Hjk1BI;EAEC,sBAAA;A1Hkk1BL;A0Hhk1BK;EACC,6BAAA;EACA,sBAAA;A1Hkk1BN;A0Hhk1BK;EACC,2BAAA;A1Hkk1BN;A0H9j1BK;EACC,oDAAA;A1Hgk1BN;A0H7j1BI;EACC,wCAAA;A1H+j1BL;A0H7j1BI;EACC,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,4CAAA;A1H+j1BL;A0H1j1BK;EACC,aAAA;A1H4j1BN;;A2H3w1BC;EACC,YAAA;EACA,gBAAA;EACA,UAAA;EAMC,6CAAA;EACA,iB1HsT6C;ADm90BhD;A2Htw1BE;EACC,WAAA;EACA,sBAAA;A3Hww1BH;A2Htw1BG;EACC,uCAAA;EACA,uBAAA;A3Hww1BJ;A2Htw1BI;EACC,qCAAA;A3Hww1BL;A2Htw1BI;EACC,sBAAA;EACA,gB1HyT2C;AD+80BhD;;A4Hny1BA;EACC,8BAAA;EACA,UAAA;EACA,YAAA;EACA,mB3H6T+C;E2H5T/C,gB3HgV+C;E2H/U/C,kBAAA;A5Hsy1BD;A4Hpy1BC;EACC,eAAA;EACA,uCAAA;EACA,gB3HwU8C;AD890BhD;;A6H/y1BE;EACC,sBAAA;A7Hkz1BH;A6Hhz1BE;EAIE,sBAAA;A7H+y1BJ;;A8Hxz1BA;EACC,cAAA;EACA,aAAA;EACA,mB7H6U+C;E6H5U/C,4B7HoEc;E6HnEd,qBAAA;EACA,qBAAA;EACA,yB7HyDc;E6HxDd,4CAAA;EACA,kB7H8Z+C;AD650BhD;;A+Hl01BE;EACC,wDAAA;A/Hq01BH;A+Hl01BC;EACC,uDAAA;A/Ho01BF;;AgIp01BK;EAIE,kB/HsTyC;AD8g1BhD;AgIj01BK;EAIE,mB/H+SyC;ADih1BhD;AgIzz1BC;EACC,kBAAA;AhI2z1BF;AgItz1BG;EACC,oBAAA;EACA,uBAAA;EACA,oBAAA;AhIwz1BJ;AgItz1BG;EACC,yBAAA;AhIwz1BJ;;AiI711BA;EACC,eAAA;EACA,YhIoe+C;EgIne/C,iBAAA;EACA,gBAAA;EAMC,QAAA;EACA,mBAAA;AjI211BF;AgB1x1BI;EiH5EJ;IAeE,eAAA;EjI211BA;AACF;AiIz11BC;EACC,WAAA;AjI211BF;;AkI721BC;EACC,oBAAA;EACA,4DjI+a8C;ADi80BhD;AkI921BE;EACC,+BAAA;AlIg31BH;AkI921BE;EAEC,YAAA;EACA,4CAAA;EACA,wBAAA;AlI+21BH;AkI721BG;EACC,6CAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;AlI+21BJ;AkI521BE;EACC,+BAAA;EACA,gBjI8T6C;EiI7T7C,wBAAA;EACA,SAAA;AlI821BH;AkI521BE;EACC,wBAAA;AlI821BH;AkI521BG;EACC,eAAA;EACA,gBAAA;EACA,qBAAA;AlI821BJ;AkI321BI;EACC,UAAA;AlI621BL;AkI121BG;EACC,cAAA;AlI421BJ;AkIv21BE;EACC,+BAAA;AlIy21BH;AkIv21BE;EAEC,cjIaY;EiIZZ,kCjIqBY;EiIpBZ,oCjIoBY;ADo11Bf;AkIr21BI;EACC,2CjIgBU;ADu11Bf;AkIr21BI;EACC,2CjIaU;AD011Bf;AkIn21BI;EACC,wCjIQU;AD611Bf;AkIn21BI;EACC,wCjIKU;ADg21Bf;AkI/11BE;EACC,+BAAA;AlIi21BH;AkI/11BE;EAEC,cjIfY;EiIgBZ,kCjIPY;EiIQZ,oCjIRY;ADw21Bf;AkI711BI;EACC,0CjIZU;AD221Bf;AkI711BI;EACC,0CjIfU;AD821Bf;AkI311BI;EACC,yCjIpBU;ADi31Bf;AkI311BI;EACC,yCjIvBU;ADo31Bf;AkIx11BC;EACC,0BAAA;EACA,2BAAA;EAKC,uBAAA;AlIs11BH;AkIn11BC;EACC,6CjI6gC8C;EiI5gC9C,YAAA;EACA,UAAA;EACA,gBjI4gC8C;EiI3gC9C,4DjI8T8C;ADuh1BhD;AkIn11BE;EACC,2BjI8gC6C;ADu0zBhD;AkIn11BG;EACC,gDjI6gC4C;EiI5gC5C,2BjI0gC4C;AD20zBhD;AkIz01BI;EACC,ajIxEU;ADm51Bf;;AmIl91BC;EACC,aAAA;EACA,gDlI2nC8C;EkI1nC9C,oBAAA;EACA,kBAAA;EACA,6ClIunC8C;EkItnC9C,gBAAA;EACA,4DlI0a8C;EkIza9C,WAAA;AnIq91BF;AmIn91BE;EAEC,aAAA;AnIo91BH;AmIl91BE;EACC,uBAAA;EACA,eAAA;EAMC,cAAA;AnI+81BJ;AmI381BG;EAKE,eAAA;EACA,UAAA;AnIy81BL;AmIr81BE;EAEC,oBAAA;AnIs81BH;AmIp81BE;EACC,kBAAA;EACA,gBAAA;AnIs81BH;AmIp81BG;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;AnIs81BJ;AmIj81BM;EACC,qBAAA;EACA,+BlIWQ;EkIVR,gBlI6RyC;ADsq1BhD;AmI971BO;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBlIiRwC;EkIhRxC,kBAAA;EACA,YAAA;AnIg81BR;AmI571BS;EACC,8CAAA;AnI871BV;AmI571BS;EAEC,gBAAA;EACA,sBAAA;AnI671BV;AmI371BU;EACC,6BAAA;AnI671BX;AmIx71BS;EAEC,oCAAA;EACA,uBAAA;EACA,kBlI2UsC;EkI1UtC,wBAAA;EACA,2BAAA;AnIy71BV;AmIv71BU;EACC,aAAA;EACA,8ClIonBqC;EkInnBrC,2DAAA;AnIy71BX;AmIn71BQ;EACC,qBAAA;EACA,sBAAA;AnIq71BT;AmI961BO;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBlI+NwC;EkI9NxC,wCAAA;EACA,gDlIogCwC;EkIngCxC,oBAAA;EACA,2BAAA;AnIg71BR;AmI761BS;EAEC,2BAAA;EACA,6BAAA;EACA,4BAAA;AnI861BV;AmI561BS;EACC,2CAAA;EACA,4CAAA;EACA,wBAAA;EACA,gBAAA;AnI861BV;AmI561BS;EACC,2BAAA;EACA,6BAAA;EACA,4BAAA;AnI861BV;AmI561BS;EACC,gBAAA;AnI861BV;AmI561BS;EACC,gBAAA;AnI861BV;AmI361BQ;EACC,gBAAA;EACA,wCAAA;AnI661BT;AmIt61BG;EACC,2BAAA;AnIw61BJ;AmIt61BI;EACC,qBAAA;AnIw61BL;AmIr61BG;EACC,2BAAA;EAKC,6CAAA;AnIm61BL;AgBpg2BI;EmH2FD;IAUE,4CAAA;IAKC,iBAAA;EnI+51BJ;AACF;AmI351BE;EACC,wBAAA;EACA,oCAAA;EACA,6CAAA;EACA,YAAA;AnI651BH;AmI151BI;EACC,gBAAA;EACA,4CAAA;EACA,0BAAA;ElGxJH,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCqj2BF;AmIt61BK;EAEC,kCAAA;AnIu61BN;AmIp61BI;EACC,gBAAA;EACA,4CAAA;EACA,0BAAA;ElGpKH,0CAAA;EACA,iDAAA;EACA,gDAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjC2k2BF;AmIh71BK;EAEC,clI9HS;EkI+HT,kCAAA;AnIi71BN;AmI561BE;EACC,aAAA;AnI861BH;AmI361BG;EACC,kBAAA;EACA,cAAA;AnI661BJ;AgBpk2BI;EmHqJD;IAKE,WAAA;IACA,SAAA;IACA,iBAAA;IACA,+CAAA;IACA,gBAAA;IACA,gBAAA;EnI861BH;AACF;AgB9k2BI;EmHkKA;IAEE,WAAA;IACA,mBAAA;IACA,aAAA;IACA,iBAAA;IAKC,uBAAA;EnI061BL;AACF;AmIv61BK;EACC,uCAAA;EACA,oBAAA;EACA,gBlIuF0C;ADk11BhD;AgB5l2BI;EmHgLC;IAME,kBlIqKyC;IkIhKxC,iCAAA;EnIs61BN;AACF;AmIn61BM;EAEC,6CAAA;EACA,wCAAA;AnIo61BP;AmIl61BM;EACC,2BAAA;EACA,4BAAA;EAKC,wBAAA;AnIg61BR;AmIz51BI;EAIE,mEAAA;AnIw51BN;AgB9m2BI;EmHkNA;IAWG,4BAAA;EnIq51BL;AACF;;AoIxr2BO;EACC,2BAAA;EACA,gBAAA;EACA,mDAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EClBP,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EDgBQ,WAAA;EACA,+BAAA;ApI+r2BT;AoI1r2BQ;EACC,wCAAA;ApI4r2BT;AoInr2BQ;EACC,gBAAA;EACA,2BAAA;EACA,4BAAA;ApIqr2BT;AoIvq2BO;EAEC,yCAAA;EACA,oBAAA;ApIwq2BR;AoItq2BO;EAIE,eAAA;ApIqq2BT;AoIlq2BQ;EACC,aAAA;ApIoq2BT;AoIlq2BQ;EACC,UAAA;EACA,0CAAA;EACA,MAAA;EACA,SAAA;EACA,mBnIiQuC;EmIhQvC,aAAA;EACA,mBAAA;EvChFR,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fqv2BD;AoIhq2BQ;EACC,gBAAA;ApIkq2BT;AoI7p2BS;EACC,gBAAA;EACA,sBAAA;ApI+p2BV;AoIzp2BS;EACC,gBAAA;EACA,sBAAA;ApI2p2BV;AoIhp2BK;EACC,0CAAA;ApIkp2BN;AoI5o2BG;EACC,iCAAA;EACA,kCAAA;EACA,kCAAA;EAEA,yBAAA;EACA,oBnI+M4C;AD871BhD;AoIxo2BI;EACC,kDAAA;EACA,qDAAA;ApI0o2BL;AoIpo2BM;EACC,mBAAA;ApIso2BP;AoIno2BQ;EACC,qDAAA;ApIqo2BT;AoI7n2BI;EACC,qDAAA;ApI+n2BL;AoI3n2BI;EACC,mDAAA;EACA,gBAAA;ApI6n2BL;AoIzn2BE;EACC,yBAAA;ApI2n2BH;AoIzn2BE;EACC,gBAAA;ApI2n2BH;;AsIpy2BE;EACC,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBrI8Z6C;ADy41BhD;AsIry2BG;EACC,4CAAA;AtIuy2BJ;AsIry2BG;EACC,gBAAA;EACA,uCAAA;EACA,cAAA;EACA,iBAAA;EzCjBH,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fyz2BD;AsIvy2BE;EACC,kBAAA;AtIyy2BH;;AsIpy2BC;EAEC,uBAAA;EACA,6CAAA;EACA,wCAAA;EACA,wBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBrIiY8C;EqIhY9C,4DrI2Y8C;AD251BhD;;AsIly2BC;EAEC,2BAAA;EACA,eAAA;EACA,mBAAA;AtIoy2BF;AsIly2BE;EAEC,+CAAA;EACA,arI6Q6C;EqI5Q7C,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AtImy2BH;AgB/w2BI;EsHlBD;IAEG,WAAA;EtImy2BJ;AACF;AsIjy2BG;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;ErGvBF,0CAAA;EACA,iDAAA;EACA,gDAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjC2z2BF;AgBzy2BI;EsHbD;IASE,mBAAA;EtIiz2BH;AACF;AsI/y2BI;EAEC,crIYU;EqIXV,kCAAA;AtIgz2BL;AsItx2BE;EAEC,SAAA;EACA,arIsN6C;ADik2BhD;AsIrx2BE;EAEC,arIkN6C;ADok2BhD;AsIpx2BG;EACC,mBAAA;EACA,sBAAA;EACA,gBAAA;ErGvEF,0CAAA;EACA,iDAAA;EACA,gDAAA;EACA,6CAAA;EACA,uDAAA;EACA,wCAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,4DAAA;EACA,mDAAA;EACA,iCAAA;EACA,0DAAA;EACA,mBAAA;AjC812BF;AsIhy2BI;EAEC,crIjCU;ADk02Bf;AsI3x2BE;EAEC,mDAAA;EACA,yBAAA;AtI4x2BH;AsI1x2BG;EACC,mDAAA;EACA,yBAAA;AtI4x2BJ;AsIvx2BG;EAGC,yBAAA;AtIux2BJ;AsIrx2BG;EAEC,oBAAA;AtIsx2BJ;AsI/w2BK;EACC,YAAA;AtIix2BN;AsI3w2BS;EACC,gBAAA;AtI6w2BV;AsIrw2BK;EACC,uBAAA;AtIuw2BN;AsIrw2BM;EAEC,uBAAA;AtIsw2BP;AsIhw2BE;EACC,qBAAA;AtIkw2BH;AsIhw2BE;EAIC,gBAAA;EACA,gBAAA;AtI+v2BH;AsI5v2BC;EAEC,iBAAA;EACA,oCrI+5B8C;AD810BhD;AsI3v2BC;EACC,uBAAA;AtI6v2BF;AsI3v2BC;EACC,6BAAA;EACA,4BAAA;AtI6v2BF;AsI3v2BC;EACC,cAAA;AtI6v2BF;;AuI182BA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AvI682BF;;AuI382BA;;EAEE,kBAAA;AvI882BF;;AuI582BA;;EAEC,yBAAA;AvI+82BD;;AuI782BA;;EAEE,uBAAA;AvIg92BF;;AuI982BA;EACC,qBAAA;AvIi92BD;;AuI/82BA;EACE,cAAA;AvIk92BF;AuIh92BC;EAEC,cAAA;EACA,0BAAA;AvIi92BF;;AuI982BA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;AvIi92BF;AuI/82BC;EACC,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AvIi92BF;;AwIz/2BC;EAGC,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,2BAAA;EACA,wCAAA;EACA,UvIqT8C;EuIpT9C,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EAMC,UvIyS6C;AD4s2BhD;AwIl/2BE;EACC,4BAAA;EACA,2BAAA;AxIo/2BH;AwIj/2BC;EACC,SvIgS8C;ADmt2BhD;AwIj/2BC;EACC,cAAA;AxIm/2BF;AwIh/2BE;EACC,MAAA;AxIk/2BH;AwIh/2BE;EACC,cAAA;AxIk/2BH;AwIh/2BE;EAME,OAAA;AxI6+2BJ;AwIz+2BC;EACC,6BAAA;EACA,2BAAA;EACA,4DvIwX8C;EuIvX9C,gBAAA;AxI2+2BF;AwIz+2BC;EACC,oBAAA;EACA,sBAAA;EACA,6CAAA;AxI2+2BF;AwIx+2BE;EACC,UAAA;EACA,qBAAA;AxI0+2BH;AwIx+2BG;EACC,eAAA;AxI0+2BJ;AwIx+2BG;EACC,aAAA;EACA,mBAAA;AxI0+2BJ;AwIx+2BG;EACC,WAAA;EACA,YAAA;AxI0+2BJ;AwIx+2BG;EACC,oBAAA;AxI0+2BJ;;AwIr+2BA;EACC,uDAAA;EACA,mCAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EACA,aAAA;EACA,6BAAA;AxIw+2BD;;AyIzk3BA;EACC,kBAAA;AzI4k3BD;AyI1k3BC;EAEC,WAAA;AzI2k3BF;AyIzk3BE;EAGC,gBAAA;AzIyk3BH;AyItk3BC;EACC,gBAAA;EACA,gBAAA;AzIwk3BF;AyItk3BE;EACC,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,QAAA;EACA,OAAA;AzIwk3BH;;AyIpk3BA;;EAEC,aAAA;AzIuk3BD;;A0Ipm3BC;EACC,WAAA;EACA,eAAA;EACA,6CzIynC8C;EyIxnC9C,oDAAA;EACA,gBzIynC8C;EyIxnC9C,sBAAA;A1Ium3BF;A0Ijm3BM;EAGC,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBzIkZyC;AD+s2BhD;A0I/l3BO;EAEC,gDzI8mCwC;ADk/0BhD;A0I9l3BQ;EACC,2BzIymCuC;ADu/0BhD;A0I5l3BM;EAEC,kBAAA;EACA,aAAA;EACA,kBAAA;A1I6l3BP;A0I3l3BO;EACC,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBzI6XwC;E4Fta/C,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7Fuo3BD;A0I9l3BQ;EACC,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Igm3BT;A0I9l3BQ;EACC,aAAA;A1Igm3BT;A0I3l3BO;EACC,gBAAA;A1I6l3BR;A0Izl3BO;EACC,gBAAA;A1I2l3BR;A0Ixl3BM;EACC,WAAA;A1I0l3BP;A0Ixl3BM;EACC,cAAA;A1I0l3BP;A0Irl3BG;EACC,YAAA;A1Iul3BJ;A0Inl3BM;EACC,YAAA;EACA,gBzI2PyC;EyI1PzC,0CAAA;EACA,iBAAA;EACA,kBzI0UyC;AD2w2BhD;A0Inl3BO;EAEC,gDzIsiCwC;EyIriCxC,iBAAA;A1Iol3BR;A0I7k3BE;EACC,gBAAA;A1I+k3BH;A0I7k3BG;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;A1I+k3BJ;A0I7k3BI;EACC,WAAA;A1I+k3BL;A0I7k3BI;EACC,aAAA;EACA,WAAA;A1I+k3BL;A0I7k3BK;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBzI2S0C;E4Fta/C,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F2s3BD;A0Ihl3BM;EACC,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Ikl3BP;A0Ihl3BM;EAEC,gDzIw/ByC;ADyl1BhD;A0I9k3BK;EACC,WAAA;EACA,gBzIiM0C;EyIhM1C,2CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1Igl3BN;A0I7k3BO;EACC,gBAAA;A1I+k3BR;A0Ixk3BE;EACC,kBAAA;A1I0k3BH;A0Ixk3BG;EACC,gBzI8K4C;EyI7K5C,2CAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBzI2P4C;AD+02BhD;A0Ixk3BI;EAKC,2DAAA;EACA,iBAAA;A1Isk3BL;A0Ipk3BI;EACC,sCAAA;EACA,uCAAA;A1Isk3BL;A0Ipk3BK;EACC,yCAAA;A1Isk3BN;A0Ink3BI;EACC,sCAAA;EACA,uCAAA;EACA,4BAAA;A1Iqk3BL;A0Ink3BI;EACC,2CAAA;A1Iqk3BL;A0Ink3BI;EACC,0CAAA;A1Iqk3BL;A0Ink3BI;EACC,2CAAA;A1Iqk3BL;A0Ink3BK;EAEC,2BAAA;A1Iok3BN;A0I/j3BE;EAEC,kBAAA;A1Igk3BH;A0I9j3BG;EAEC,gBzI4H4C;EyI3H5C,0CAAA;EACA,iBAAA;EACA,kBzI2M4C;ADo32BhD;A0I7j3BI;EAEC,gDzIu6B2C;ADup1BhD;A0I5j3BI;EACC,gDzIo6B2C;EyIn6B3C,2BAAA;A1I8j3BL;A0I5j3BI;EACC,8BAAA;EACA,2BAAA;A1I8j3BL;;A2Ity3BA;EACC,YAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;A3Iyy3BD;A2Ivy3BC;EACC,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kB1IyZ8C;ADg52BhD;A2Ivy3BE;EAEC,gD1IonC6C;E0InnC7C,aAAA;A3Iwy3BH;A2Ity3BG;EACC,2B1I8mC4C;AD0r1BhD;A2Iry3BE;EACC,0CAAA;EACA,kBAAA;EACA,mB1ImT6C;E0IlT7C,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;E9CnCF,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F203BD;A2Ixy3BE;EACC,aAAA;A3I0y3BH;A2Ivy3BG;EACC,gBAAA;A3Iyy3BJ;A2Iry3BG;EACC,gBAAA;A3Iuy3BJ;A2Iny3BC;EACC,WAAA;A3Iqy3BF;A2Iny3BE;EACC,gBAAA;EACA,YAAA;EACA,UAAA;A3Iqy3BH;A2Iny3BG;EACC,mB1IiR4C;E0IhR5C,2BAAA;EACA,gB1IoR4C;E0InR5C,gBAAA;EACA,qBAAA;A3Iqy3BJ;A2Iny3BG;EACC,aAAA;EACA,yBAAA;A3Iqy3BJ;A2Iny3BI;EACC,gB1I2Q2C;E0I1Q3C,2CAAA;EACA,mB1IoQ2C;E0InQ3C,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,SAAA;A3Iqy3BL;A2Ihy3BE;EACC,SAAA;A3Iky3BH;A2Ihy3BG;EACC,aAAA;A3Iky3BJ;A2Ihy3BI;EACC,uBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,gB1IuP2C;E0ItP3C,0CAAA;EACA,SAAA;EACA,kB1IoU2C;AD892BhD;A2Ihy3BK;EAIC,gD1I8hC0C;E0I7hC1C,2BAAA;EACA,aAAA;A3I+x3BN;A2I7x3BK;EACC,sCAAA;EACA,uCAAA;A3I+x3BN;;A2Ivx3BC;EACC,aAAA;A3I0x3BF;A2Ixx3BC;EACC,eAAA;EACA,6C1IigC8C;E0IhgC9C,WAAA;EACA,gB1IigC8C;E0IhgC9C,oDAAA;A3I0x3BF;A2Ixx3BC;EACC,cAAA;A3I0x3BF;;A4I353BC;EAEC,+CAAA;A5I653BF;A4I353BE;EACC,2BAAA;A5I653BH;A4I353BE;EAGC,uBAAA;A5I253BH;A4Iz53BG;EAEC,2DAAA;EACA,sCAAA;EACA,kB3IsZ4C;ADog3BhD;A4Ix53BI;EACC,qCAAA;A5I053BL;A4Iv53BG;EACC,sDAAA;EACA,kB3I8Y4C;E2I7Y5C,iCAAA;EACA,uBAAA;A5Iy53BJ;A4Iv53BI;EACC,kCAAA;A5Iy53BL;A4Iv53BI;EACC,gCAAA;A5Iy53BL;A4Ir53BE;EACC,2BAAA;EACA,+DAAA;EACA,6BAAA;EACA,gBAAA;EACA,0D3I0Y6C;E2IzY7C,UAAA;EACA,6C3IilC6C;ADs01BhD;A4Ir53BG;EACC,2BAAA;EACA,oBAAA;A5Iu53BJ;A4Ir53BI;EAEC,2DAAA;EACA,2BAAA;A5Is53BL;A4Ip53BI;EACC,sDAAA;EACA,iCAAA;A5Is53BL;A4Il53BE;EACC,4BAAA;EACA,uCAAA;A5Io53BH;A4Ij53BC;EACC,qCAAA;A5Im53BF;A4Ij53BC;EACC,qCAAA;A5Im53BF;;A4Ih53BA;EACC,2BAAA;EACA,4BAAA;EACA,6BAAA;A5Im53BD;;A4Ij53BA;EACC,uBAAA;A5Io53BD;;A6Il+3BC;EACC,wCAAA;EACA,gBAAA;EACA,kB5Ima8C;E4Ila9C,yBAAA;EACA,qBAAA;A7Iq+3BF;A6In+3BE;EACC,oCAAA;A7Iq+3BH;A6In+3BE;EACC,2D5ImmB6C;E4IlmB7C,8C5IysB6C;AD4x2BhD;A6In+3BE;EACC,UAAA;A7Iq+3BH;A6In+3BG;EACC,SAAA;EACA,0CAAA;A7Iq+3BJ;A6In+3BG;EACC,2BAAA;A7Iq+3BJ;A6In+3BG;EACC,SAAA;EACA,UAAA;A7Iq+3BJ;A6In+3BI;EACC,2BAAA;A7Iq+3BL;A6Il+3BG;EACC,yBAAA;A7Io+3BJ;A6Il+3BI;EAEC,sBAAA;A7Im+3BL;A6Ih+3BI;EACC,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kB5I0X2C;E4IzX3C,gB5IsS2C;AD4r3BhD;A6Ih+3BK;EACC,4BAAA;EACA,kBAAA;EACA,iBAAA;EAKC,sBAAA;A7I893BP;A6I393BK;EACC,gBAAA;EACA,cAAA;A7I693BN;A6I393BM;EACC,gBAAA;EACA,2CAAA;A7I693BP;A6It93BG;EACC,UAAA;EACA,0CAAA;A7Iw93BJ;A6It93BI;EACC,2BAAA;A7Iw93BL;A6Ir93BG;EACC,gBAAA;EACA,SAAA;A7Iu93BJ;A6In93BC;EACC,6C5IsiC8C;E4IriC9C,gB5IuiC8C;E4ItiC9C,oDAAA;EACA,gBAAA;A7Iq93BF;A6Ij93BI;EACC,gD5IwiC2C;AD261BhD;A6Ij93BI;EACC,2BAAA;EACA,4BAAA;A7Im93BL;A6Ij93BI;EACC,aAAA;A7Im93BL;;A8Ixj4BC;EAEC,2BAAA;A9I0j4BF;A8Ixj4BE;EACC,sBAAA;EACA,mDAAA;EACA,kB7I+Z6C;E6I9Z7C,wE7I0tB6C;E6IztB7C,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,sCAAA;A9I0j4BH;A8Ixj4BG;EACC,yDAAA;EACA,sEAAA;EACA,wBAAA;A9I0j4BJ;A8Ivj4BE;EACC,+CAAA;A9Iyj4BH;A8Ivj4BE;EACC,sCAAA;A9Iyj4BH;A8Irj4BE;EAEC,iDAAA;EACA,2BAAA;A9Isj4BH;A8Ipj4BG;EAEC,wDAAA;A9Iqj4BJ;;A+Izl4BA;EACC,uBAAA;EACA,wCAAA;EACA,kB9Ioa+C;E8Ina/C,wBAAA;EACA,cAAA;EACA,YAAA;A/I4l4BD;A+I1l4BC;EACC,8C9I6sB8C;E8I5sB9C,2D9IqmB8C;ADu/2BhD;A+I1l4BC;EACC,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;A/I4l4BF;A+I1l4BE;EACC,qBAAA;EACA,yBAAA;EACA,4BAAA;EAMC,wBAAA;EACA,sBAAA;A/Iul4BJ;A+Irl4BG;EACC,4BAAA;EACA,YAAA;A/Iul4BJ;A+Inl4BC;EACC,gBAAA;EACA,wBAAA;A/Iql4BF;A+Inl4BE;EACC,uCAAA;EACA,gB9IwS6C;AD6y3BhD;;AgJno4BA;EACC,iCAAA;EACA,aAAA;EAKC,6CAAA;AhJko4BF;AgB7j4BI;EgI5EJ;IAUE,YAAA;EhJmo4BA;AACF;AgJjo4BC;EACC,SAAA;EACA,6BAAA;AhJmo4BF;AgJjo4BE;EAIE,6CAAA;AhJgo4BJ;AgJ1n4BI;EACC,sBAAA;AhJ4n4BL;AgJzn4BG;EACC,uBAAA;AhJ2n4BJ;AgJvn4BK;EACC,eAAA;AhJyn4BN;AgJrn4BO;EAIE,+BAAA;AhJon4BT;AgJjn4BO;EAIE,gCAAA;AhJgn4BT;AgJ1m4BI;EACC,YAAA;AhJ4m4BL;AgJvm4BC;EACC,eAAA;EACA,a/I+P8C;AD023BhD;AgB5m4BI;EgICH;IAKE,6BAAA;EhJ0m4BD;AACF;AgBpm4BI;EgIZH;IAQE,aAAA;EhJ4m4BD;AACF;AgJ1m4BE;EAIE,6CAAA;AhJym4BJ;AgJtm4BE;EACC,gB/IkQ6C;E+IjQ7C,qBAAA;EACA,mB/I2P6C;E+I1P7C,aAAA;EACA,qBAAA;AhJwm4BH;;AiJ/r4BA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;AjJks4BD;AiJ/r4BE;EACC,eAAA;AjJis4BH;AiJ9r4BC;EACC,aAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AjJgs4BF;AiJ9r4BC;EACC,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,8FAAA;EACA,SAAA;AjJgs4BF;AiJ9r4BE;EACC,kBAAA;EACA,iBAAA;EACA,kBAAA;AjJgs4BH;AiJ7r4BC;EACC,gBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AjJ+r4BF;AkJlu4BC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AlJmu4BF;AiJhs4BE;EACC,cAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjJks4BH;AiJhs4BG;EACC,aAAA;EACA,ahJgR4C;EgJ/Q5C,6CAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;AjJks4BJ;AgB3q4BI;EiI7BD;IASE,WAAA;IACA,iBAAA;IACA,eAAA;EjJms4BH;AACF;AiJhs4BE;EACC,eAAA;EACA,gBhJqR6C;EgJpR7C,iBAAA;AjJks4BH;AgBvr4BI;EiIdF;IAME,kBAAA;EjJms4BF;AACF;AiJjs4BE;EACC,qBAAA;EACA,wCAAA;EACA,gBAAA;AjJms4BH;AgBjs4BI;EiILF;IAME,oBAAA;EjJos4BF;AACF;;AmJhx4BE;EACC,wBAAA;EACA,2BAAA;EACA,2BAAA;AnJmx4BH;AmJjx4BE;EACC,gBAAA;EACA,mBlJwT6C;EkJvT7C,kBAAA;AnJmx4BH;AmJjx4BG;EACC,aAAA;EACA,mBAAA;AnJmx4BJ;AmJjx4BG;EACC,kBlJsZ4C;EkJrZ5C,oBAAA;EACA,kBAAA;AnJmx4BJ;AgB1t4BI;EmI5DD;IAME,kBAAA;IACA,SAAA;IACA,WAAA;EnJox4BH;AACF;;AoJ7y4BA;EACC,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;ApJgz4BD;AoJ9y4BC;EACC,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;ApJgz4BF;AoJ9y4BE;EACC,wBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,gBnJoU6C;EmJnU7C,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wDAAA;ApJgz4BH;AgBzv4BI;EoIhEF;IAYE,mBAAA;EpJiz4BF;AACF;AoJ/y4BE;EACC,eAAA;EACA,+BnJuCY;AD0w4Bf;AoJ/y4BE;EACC,eAAA;EACA,gBnJoT6C;AD6/3BhD;AgBtw4BI;EoI7CF;IAKE,kBAAA;EpJkz4BF;AACF;AoJhz4BE;EACC,mBAAA;EACA,gBAAA;ApJkz4BH;AgB/w4BI;EoIrCF;IAKE,eAAA;EpJmz4BF;AACF;AoJjz4BE;EACC,cAAA;EACA,eAAA;EACA,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,kBnJgX6C;ADm83BhD;;AqJ124BA;EACC,kBAAA;ArJ624BD;AqJ324BC;EACC,kBAAA;EAKC,uBAAA;ArJy24BH;AqJt24BE;EACC,qBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBpJsZ6C;EoJrZ7C,aAAA;EACA,oBpJ8T6C;AD0i4BhD;AqJr24BI;EAEC,aAAA;ArJs24BL;AqJl24BG;EACC,aAAA;EACA,SAAA;ArJo24BJ;AqJl24BG;EACC,epJiT4C;EoJhT5C,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,qBAAA;ArJg24BL;AqJ714BG;EACC,SAAA;ArJ+14BJ;AqJ114BI;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;ExDzDJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EwD2DK,cAAA;ArJ414BN;AqJv14BI;EACC,cAAA;ArJy14BL;AqJt14BK;EACC,gBAAA;ArJw14BN;AqJl14BG;EACC,gBpJoQ4C;ADgl4BhD;AqJl14BI;EACC,UAAA;ArJo14BL;AqJ/04BC;EACC,aAAA;ArJi14BF;;AqJ704BA;EACC,0CAAA;EACA,mDAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;ArJ+04BD;AqJ704BC;EACC,4CAAA;EACA,gBAAA;EACA,+CAAA;EACA,aAAA;EACA,eAAA;ArJ+04BF;AgB/24BI;EqI2BH;IAQE,gBAAA;IACA,iBAAA;IACA,mBAAA;ErJg14BD;AACF;AqJ904BC;EACC,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;ArJg14BF;AqJ904BE;EACC,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,+CAAA;ArJg14BH;AgBl44BI;EqI8CF;IAOE,kBAAA;IACA,MAAA;IACA,SAAA;IACA,6CAAA;IACA,WAAA;IACA,gCpJsU4C;IoJ/T3C,kDAAA;IACA,sBAAA;IACA,0DAAA;ErJ204BH;AACF;AqJx04BG;EACC,kBAAA;EACA,SpJ4K4C;EoJ3K5C,WAAA;EAMC,UAAA;EACA,sBAAA;ArJq04BL;AqJn04BI;EACC,6CAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,4DpJ8Q2C;EoJ7Q3C,gCpJuS2C;EoJ/R1C,4BpJ0P0C;EoJzP1C,+BpJyP0C;EoJxP1C,oDAAA;EACA,iBAAA;ArJ8z4BN;AgB/64BI;EqIoFD;IAiCE,aAAA;ErJ8z4BH;AACF;AqJ3z4BG;EACC,SAAA;EACA,gBAAA;ArJ6z4BJ;AqJ3z4BG;EACC,oBAAA;EACA,4CAAA;ArJ6z4BJ;AqJ1z4BE;EACC,SAAA;ArJ4z4BH;AgB/74BI;EqIkIF;IAOG,6CAAA;ErJ0z4BH;AACF;AgBv74BI;EqIqHF;IAWE,gBAAA;IACA,iBAAA;ErJ2z4BF;AACF;AqJvz4BE;EAIE,OAAA;ArJsz4BJ;AgBh84BI;EqIsIF;IAOE,0DpJ2N4C;ED4l4B9C;AACF;AgBr84BI;EqIgJA;IAEE,gBAAA;ErJuz4BJ;AACF;;AsJth5BA;EACC,kBAAA;AtJyh5BD;AgB394BI;EsI/DJ;IAIE,iCAAA;IACA,8CAAA;EtJ0h5BA;AACF;;AsJxh5BA;EACC,arJwT+C;EqJvT/C,UAAA;AtJ2h5BD;AgBz94BI;EsIpEJ;IAKE,gBAAA;IACA,+CAAA;IACA,gBAAA;IACA,YrJsd8C;IqJrd9C,aAAA;IACA,iBAAA;EtJ4h5BA;AACF;AsJ3h5BC;EACC,0BAAA;EACA,gBrJ+T8C;EqJ9T9C,cAAA;AtJ6h5BF;AgBx+4BI;EsIxDH;IAME,aAAA;EtJ8h5BD;AACF;AsJ3h5BE;EACC,wBAAA;EACA,cAAA;EACA,uCAAA;EACA,qBAAA;AtJ6h5BH;AgBn/4BI;EsI9CF;IAOE,mBAAA;IACA,mCAAA;EtJ8h5BF;AACF;AsJ5h5BG;EACC,uCAAA;AtJ8h5BJ;AgB5/4BI;EsInCD;IAIE,cAAA;IACA,gCAAA;IACA,sBAAA;IACA,mBAAA;EtJ+h5BH;AACF;AsJ7h5BG;EACC,wCAAA;AtJ+h5BJ;AsJ7h5BG;EACC,sBAAA;EACA,gBrJ6R4C;ADkw4BhD;AsJ7h5BI;EACC,cAAA;AtJ+h5BL;;AsJxh5BA;EACC,WAAA;AtJ2h5BD;AgB/h5BI;EsIGJ;IAIE,iCAAA;EtJ4h5BA;AACF;;AsJ1h5BA;EACC,arJuP+C;ADsy4BhD;AsJ3h5BC;EACC,4CAAA;AtJ6h5BF;AsJ3h5BC;EACC,qBAAA;EACA,wBAAA;EACA,gBrJmQ8C;EqJlQ9C,mBrJ8O8C;AD+y4BhD;AsJ3h5BE;EACC,wBAAA;EACA,qBAAA;AtJ6h5BH;AsJ3h5BG;EACC,mBrJsP4C;EqJrP5C,uCAAA;EAKC,sBAAA;AtJyh5BL;AsJrh5BE;EACC,cAAA;EACA,uCAAA;EACA,oBAAA;AtJuh5BH;AsJph5BC;EACC,qBAAA;EACA,gBAAA;EACA,UAAA;AtJsh5BF;AkJlo5BC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AlJmo5BF;AsJvh5BE;EACC,kBAAA;EACA,kBAAA;EACA,eAAA;EAKC,WAAA;AtJqh5BJ;AgBlk5BI;EsIqCF;IAYE,UAAA;IACA,mBAAA;EtJqh5BF;AACF;AgBxk5BI;EsIqCF;IAgBE,aAAA;IACA,mBAAA;EtJuh5BF;AACF;AgB9k5BI;EsIqCF;IAoBE,UAAA;IACA,gBAAA;EtJyh5BF;AACF;AsJxh5BG;EACC,WAAA;AtJ0h5BJ;AsJxh5BG;EACC,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AtJ0h5BJ;AgBjn5BI;EsI0FC;IACC,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;EtJ0h5BJ;AACF;AsJvh5BG;EAEC,eAAA;AtJwh5BJ;AsJth5BG;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AtJwh5BJ;AgBrn5BI;EsI+FD;IAEE,YAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EtJwh5BH;AACF;;AuJzs5BA;EACC,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AvJ4s5BD;AgBpo5BI;EuI5EJ;IAOE,atJ0T8C;EDm54B9C;AACF;AuJ3s5BC;EACC,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AvJ6s5BF;;AwJ3t5BA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;AxJ8t5BD;AwJ5t5BC;EACC,gBAAA;EACA,aAAA;AxJ8t5BF;AgBzp5BI;EwIvEH;IAKE,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;ExJ+t5BD;AACF;AwJ9t5BE;EACC,uCAAA;EACA,eAAA;AxJgu5BH;AgBrq5BI;EwI7DF;IAKE,UAAA;ExJiu5BF;AACF;AwJ/t5BE;EACC,oBAAA;AxJiu5BH;AwJ/t5BE;EACC,eAAA;AxJiu5BH;AwJ/t5BE;EACC,wCAAA;EACA,qBAAA;EACA,kBvJuY6C;AD014BhD;AwJ/t5BG;EACC,6CAAA;AxJiu5BJ;AwJ/t5BG;EACC,2BAAA;EACA,cvJyBW;EuJxBX,gBvJ6S4C;ADo74BhD;AwJ7t5BC;EACC,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;AxJ+t5BF;AwJ7t5BE;EACC,kBAAA;EACA,YAAA;AxJ+t5BH;AgBvs5BI;EwI1BF;IAKE,eAAA;IACA,YAAA;ExJgu5BF;AACF;AwJ9t5BG;EAIE,6CAAA;AxJ6t5BL;AgBht5BI;EwIjBD;IAWG,iBAAA;ExJ0t5BJ;AACF;AwJtt5BE;EACC,YAAA;EACA,SAAA;AxJwt5BH;AwJrt5BC;EACC,gBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AxJut5BF;AwJpt5BG;EACC,mBAAA;AxJst5BJ;AwJnt5BE;EACC,WAAA;EACA,kBAAA;EACA,mBvJ+N6C;ADs/4BhD;AwJnt5BG;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AxJqt5BJ;AwJlt5BE;EACC,oBAAA;EACA,gBvJuO6C;EuJtO7C,uCAAA;AxJot5BH;AwJjt5BC;EACC,qBAAA;EACA,SAAA;EACA,UAAA;AxJmt5BF;AwJjt5BE;EACC,avJyM6C;EuJxM7C,aAAA;AxJmt5BH;AwJjt5BG;EACC,4CAAA;AxJmt5BJ;AwJjt5BG;EACC,kDAAA;AxJmt5BJ;AwJ/s5BK;EACC,gBvJiN0C;EuJhN1C,wBAAA;AxJit5BN;AwJ7s5BG;EACC,4CAAA;AxJ+s5BJ;AwJ5s5BI;EACC,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;E3DlJJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;E2DoJK,OAAA;AxJ8s5BN;AwJzs5BE;EACC,kBAAA;AxJ2s5BH;AwJzs5BG;EAIE,oBAAA;AxJws5BL;AwJps5BE;EACC,SAAA;AxJss5BH;AwJps5BG;EACC,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;AxJss5BJ;AwJps5BG;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;AxJss5BJ;AgB/y5BI;EwIsGD;IAME,cAAA;ExJus5BH;AACF;AwJrs5BI;EACC,gBvJyJ2C;EuJxJ3C,sBAAA;EACA,SAAA;EAKC,kBAAA;AxJms5BN;AwJhs5BI;EACC,kBAAA;EACA,uCAAA;EACA,gBvJ6I2C;EuJxI1C,oBAAA;AxJ8r5BN;AwJ1r5BG;EACC,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AxJ4r5BJ;AgBv05BI;EwIsID;IAQE,kBAAA;IACA,oBAAA;ExJ6r5BH;AACF;AwJ3r5BG;EACC,kBAAA;EACA,oBAAA;EACA,uCAAA;EACA,oBAAA;EACA,gBAAA;AxJ6r5BJ;AwJzr5BC;EACC,eAAA;AxJ2r5BF;AgBv15BI;EwI2JH;IAIE,avJsF6C;EDsm5B9C;AACF;AwJ1r5BE;EACC,+CAAA;EACA,mBAAA;AxJ4r5BH;AgBh25BI;EwIkKF;IAKE,oBvJ8E4C;ED+m5B9C;AACF;AwJ3r5BE;EACC,iBAAA;AxJ6r5BH;AgBx25BI;EwI0KF;IAIE,eAAA;ExJ8r5BF;AACF;AwJ5r5BE;EACC,mBvJkF6C;AD4m5BhD;AwJ5r5BE;EACC,aAAA;EACA,eAAA;AxJ8r5BH;AwJ5r5BG;EACC,6CAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBvJ8J4C;EuJzJ3C,oBAAA;AxJ0r5BL;AwJvr5BI;EACC,cAAA;EACA,qBAAA;AxJyr5BL;AwJvr5BI;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;AxJyr5BL;AwJvr5BK;EACC,cAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AxJyr5BN;AwJvr5BK;EACC,eAAA;AxJyr5BN;AwJtr5BI;EACC,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AxJwr5BL;AwJlr5BE;EACC,oBAAA;AxJor5BH;AgB755BI;EwIwOF;IAIE,qBAAA;ExJqr5BF;AACF;AwJnr5BG;EACC,4CAAA;AxJqr5BJ;AwJlr5BE;EACC,YAAA;EACA,gBAAA;AxJor5BH;AwJlr5BG;EACC,4CAAA;EACA,+CAAA;AxJor5BJ;AwJlr5BG;EACC,4CAAA;AxJor5BJ;;AyJ5/5BA;EACC,YAAA;EACA,aAAA;AzJ+/5BD;AyJ7/5BC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AzJ+/5BF;AgBv85BI;EyI3DH;IAME,kBAAA;IACA,8CAAA;EzJgg6BD;AACF;AyJ//5BE;EACC,+CAAA;EACA,axJkT6C;AD+s5BhD;AyJ//5BE;EACC,SAAA;EACA,gBAAA;AzJig6BH;AyJ//5BE;EACC,+CAAA;AzJig6BH;AyJ//5BG;EACC,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,wBAAA;AzJig6BJ;AyJ//5BI;EACC,mDAAA;AzJig6BL;AyJ//5BI;EAEC,kDAAA;AzJgg6BL;AyJ7/5BI;EACC,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzJ+/5BL;AyJ7/5BK;EACC,eAAA;AzJ+/5BN;AyJ5/5BK;EACC,qBAAA;AzJ8/5BN;AyJ3/5BI;EACC,SAAA;EACA,mBAAA;AzJ6/5BL;AyJ3/5BI;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AzJ6/5BL;AyJ3/5BI;EACC,sBAAA;EACA,uCAAA;EACA,sBAAA;AzJ6/5BL;AyJ3/5BI;EAEC,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,oBxJwQ2C;ADov5BhD;AyJ1/5BI;EACC,gBxJyQ2C;EwJxQ3C,wBAAA;AzJ4/5BL;AyJ1/5BI;EACC,2BAAA;EACA,4BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBxJ2P2C;EwJlP1C,iBAAA;AzJo/5BN;AyJ3/5BK;EACC,aAAA;AzJ6/5BN;AyJj/5BC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AzJm/5BF;AgBnh6BI;EyI6BH;IAME,aAAA;EzJo/5BD;AACF;AyJl/5BE;EACC,aAAA;EACA,+CAAA;EACA,qBAAA;EACA,mBAAA;AzJo/5BH;AyJl/5BG;EACC,aAAA;AzJo/5BJ;AgBji6BI;EyI4CD;IAIE,cAAA;EzJq/5BH;AACF;AyJn/5BI;EACC,uCAAA;EACA,mBAAA;AzJq/5BL;AyJj/5BI;EACC,aAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AzJm/5BL;AyJj/5BI;EAIE,iBxJgL0C;ADg05BhD;AyJ5+5BG;EACC,mBxJ0L4C;EwJzL5C,wBAAA;EACA,gBxJ6L4C;EwJ5L5C,oBAAA;EACA,SAAA;AzJ8+5BJ;AyJ5+5BI;EACC,cAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;AzJ8+5BL;AyJ3+5BG;EACC,aAAA;AzJ6+5BJ;AyJ3+5BI;EACC,eAAA;EACA,uCAAA;AzJ6+5BL;AyJ3+5BK;EAEC,wBAAA;AzJ4+5BN;AyJv+5BE;EACC,SAAA;EACA,gBAAA;AzJy+5BH;AyJv+5BG;EACC,axJ2I4C;AD815BhD;AyJt+5BE;EACC,4CAAA;EACA,axJsI6C;ADk25BhD;AgBvl6BI;EyIoHD;IACC,aAAA;EzJs+5BF;EyJp+5BC;IACC,aAAA;EzJs+5BF;AACF;;A0J3q6BA;EACC,6BAAA;EACA,YAAA;A1J8q6BD;A0J5q6BC;EACC,YAAA;EACA,UAAA;A1J8q6BF;AgBrn6BI;E0I3DH;IAKE,aAAA;E1J+q6BD;E0J7q6BC;IAIE,6CAAA;E1J4q6BH;AACF;A0Jxq6BC;EACC,aAAA;A1J0q6BF;AgBho6BI;E0I3CH;IAIE,YzJ+gB6C;IyJ9gB7C,sBAAA;E1J2q6BD;AACF;AgBzn6BI;E0IxDH;IAQE,gBAAA;IACA,mBAAA;IACA,+CAAA;E1J6q6BD;AACF;A0J3q6BE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,azJ4R6C;ADi55BhD;AgBto6BI;E0I3CF;IAOE,YzJ+f4C;IyJ9f5C,iBAAA;IACA,eAAA;E1J8q6BF;AACF;A0J7q6BG;EACC,cAAA;EACA,qBAAA;EACA,cAAA;A1J+q6BJ;A0J7q6BG;EACC,kBAAA;EACA,gBAAA;A1J+q6BJ;A0J7q6BG;EACC,mBzJ0R4C;EyJzR5C,gBzJ8R4C;EyJ7R5C,mBAAA;EACA,mBAAA;A1J+q6BJ;A0J7q6BG;EACC,eAAA;EACA,gBAAA;A1J+q6BJ;A0J5q6BE;EACC,SAAA;A1J8q6BH;AgBhr6BI;E0ICF;IAIE,gBAAA;IACA,UAAA;E1J+q6BF;AACF;A0J7q6BE;EACC,SAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;A1J+q6BH;AgB/q6BI;E0IJF;IAOE,aAAA;IACA,iBAAA;E1Jgr6BF;AACF;AgBrr6BI;E0IOD;IAEE,mBAAA;E1Jgr6BH;AACF;A0J/q6BI;EACC,kBAAA;EACA,azJwO2C;EyJvO3C,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBzJqP2C;EyJpP3C,gBAAA;A1Jir6BL;A0J/q6BK;EACC,yBAAA;A1Jir6BN;A0J/q6BM;EACC,sBAAA;EACA,cAAA;EACA,SAAA;A1Jir6BP;A0J/q6BM;EAGC,kBAAA;A1J+q6BP;A0J5q6BK;EACC,cAAA;EACA,6CAAA;EACA,kBAAA;A1J8q6BN;A0J5q6BK;EACC,mCAAA;A1J8q6BN;A0J5q6BK;EACC,wBAAA;A1J8q6BN;A0J3q6BO;EAGC,mBAAA;A1J2q6BR;A0Jnq6BC;EACC,SAAA;A1Jqq6BF;AgB/u6BI;E0IyEH;IAIE,gBAAA;E1Jsq6BD;AACF;AgBvu6BI;E0I4DH;IAOE,yBAAA;E1Jwq6BD;AACF;A0Jtq6BE;EACC,eAAA;A1Jwq6BH;A0Jrq6BC;EACC,YzJiZ8C;EyJhZ9C,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;A1Juq6BF;AgBtv6BI;E0I0EH;IAQE,eAAA;IACA,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,sCAAA;IACA,aAAA;E1Jwq6BD;AACF;A0Jtq6BE;EACC,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A1Jwq6BH;A0Jtq6BG;EACC,YAAA;EACA,aAAA;EAKC,kBzJ0I2C;AD0h6BhD;AgB/w6BI;E0IoGD;IAUE,cAAA;E1Jqq6BH;AACF;A0Jnq6BI;EACC,wBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;A1Jqq6BL;A0Jjq6BI;EACC,gBAAA;A1Jmq6BL;A0Jjq6BI;EAIE,sBAAA;A1Jgq6BN;A0J5p6BG;EACC,gBzJmI4C;EyJlI5C,SAAA;A1J8p6BJ;A0J5p6BG;EACC,cAAA;A1J8p6BJ;A0J1p6BG;EACC,iBAAA;A1J4p6BJ;A0Jzp6BK;EACC,mCAAA;A1J2p6BN;A0Jzp6BM;EACC,wBAAA;A1J2p6BP;A0Jxp6BK;EACC,mBAAA;A1J0p6BN;A0Jrp6BE;EACC,UAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;A1Jup6BH;A0Jrp6BE;EACC,4CAAA;EACA,oBAAA;A1Jup6BH;A0Jrp6BE;EACC,eAAA;EACA,kBAAA;EACA,aAAA;A1Jup6BH;A0Jrp6BG;EACC,aAAA;EACA,SAAA;A1Jup6BJ;A0Jrp6BI;EACC,aAAA;EACA,cAAA;EACA,2BAAA;EACA,sBAAA;A1Jup6BL;A0Jrp6BI;EAIE,iBzJyD0C;AD2l6BhD;A0Jhp6BG;EAIE,iBzJiD2C;AD8l6BhD;A0J3o6BG;EACC,kBAAA;EACA,MAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,qCAAA;EACA,azJqC4C;EyJpC5C,SAAA;A1J6o6BJ;A0J3o6BI;EACC,kBAAA;A1J6o6BL;A0J3o6BI;EACC,kBAAA;A1J6o6BL;A0Jzo6BG;EACC,4CAAA;A1J2o6BJ;A0Jvo6BC;EACC,wBAAA;EACA,ezJsP8C;EyJrP9C,aAAA;EACA,mBAAA;A1Jyo6BF;A0Jvo6BE;EAGC,aAAA;A1Juo6BH;AgBh36BI;E0IsOF;IAME,UAAA;E1Jwo6BF;AACF;A0Jto6BE;EACC,aAAA;A1Jwo6BH;A0Jto6BG;EAEC,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;A1Juo6BJ;A0Jpo6BK;EACC,YAAA;A1Jso6BN;A0Jno6BI;EACC,gBzJS2C;EyJR3C,eAAA;EACA,yBAAA;EAKC,iBzJlB0C;ADmp6BhD;A0J5n6BE;EACC,gBzJJ6C;EyJK7C,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1J8n6BH;AgB/46BI;E0I4QF;IAQE,aAAA;E1J+n6BF;AACF;A0J7n6BE;EACC,mBAAA;EACA,yBAAA;A1J+n6BH;A0J5n6BI;EACC,sBAAA;EACA,wBAAA;A1J8n6BL;AgB556BI;E0I4RA;IAKE,yBAAA;E1J+n6BJ;AACF;A0J9n6BK;EACC,eAAA;EACA,kBAAA;A1Jgo6BN;A0J9n6BK;EACC,mCAAA;A1Jgo6BN;A0J1n6BC;EACC,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;A1J4n6BF;A0J1n6BE;EACC,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;A1J4n6BH;A0J1n6BE;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,azJ9E6C;AD0s6BhD;A0J1n6BG;EACC,ezJhE4C;EyJiE5C,gBzJ9D4C;EyJ+D5C,iCAAA;EACA,oBAAA;A1J4n6BJ;A0J1n6BG;EACC,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;A1J4n6BJ;A0J1n6BG;EACC,SAAA;EACA,gBzJ1E4C;EyJ2E5C,iCAAA;EACA,ezJ/E4C;AD2s6BhD;A0Jzn6BE;EACC,mBAAA;A1J2n6BH;A0Jzn6BG;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACC,qCAAA;EACD,wBAAA;EACA,kBlJyM0B;EkJxM1B,aAAA;EACA,mBAAA;EACA,uBAAA;A1J2n6BJ;A0Jvn6BC;EACC,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;A1Jyn6BF;A0Jtn6BG;EACC,wCAAA;A1Jwn6BJ;A0Jpn6BE;EACC,UAAA;EACA,wCAAA;A1Jsn6BH;A0Jpn6BG;EACC,azJvI4C;EyJwI5C,+CAAA;EACA,mCAAA;EACA,gBzJtH4C;AD4u6BhD;A0Jpn6BI;EACC,iBAAA;EACA,wBAAA;A1Jsn6BL;A0Jln6BI;EACC,oBzJnI2C;EyJoI3C,sBAAA;EACA,aAAA;EACA,mBAAA;A1Jon6BL;A0Jln6BK;EACC,gBAAA;EACA,gBzJtI0C;EyJuI1C,qBAAA;EACA,mCAAA;A1Jon6BN;A0Jln6BK;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;A1Jon6BN;A0Jln6BK;EACC,mBAAA;EACA,czJtaS;EyJuaT,aAAA;EACA,mBAAA;EAKC,kBzJ7KyC;AD6x6BhD;A0J7m6BM;EACC,czJtaQ;ADqh7Bf;A0J7m6BM;EACC,czJnaQ;ADkh7Bf;A0J5m6BK;EACC,sBAAA;A1J8m6BN;A0J5m6BM;EACC,sCAAA;A1J8m6BP;A0J3m6BK;EACC,4CAAA;A1J6m6BN;A0Jvm6BC;EACC,+CAAA;A1Jym6BF;AgBjj7BI;E0IucH;IAIE,aAAA;E1J0m6BD;AACF;A0Jzm6BE;EACC,UAAA;EACA,eAAA;EAKC,iBAAA;A1Jum6BJ;AgB9i7BI;E0IgcF;IAUE,WAAA;IACA,kBAAA;IAKC,gBAAA;E1Jom6BH;AACF;A0Jjm6BE;EACC,eAAA;EACA,SAAA;EAKC,6CAAA;A1J+l6BJ;AgB1j7BI;E0IodF;IAUE,iBAAA;IACA,cAAA;E1Jgm6BF;AACF;A0J9l6BG;EACC,eAAA;EACA,oBAAA;A1Jgm6BJ;AgBpk7BI;E0IkeD;IAKE,4CAAA;IACA,qBAAA;IACA,qBAAA;E1Jim6BH;AACF;A0J/l6BG;EACC,aAAA;EACA,sBAAA;EACA,YAAA;A1Jim6BJ;A0J/l6BI;EACC,gBAAA;EACA,kBAAA;EACA,mBzJ/P2C;ADg26BhD;A0J/l6BK;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBzJnK0C;ADow6BhD;A0J/l6BK;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBzJ9K0C;EyJ+K1C,aAAA;EACA,mBAAA;EACA,uBAAA;A1Jim6BN;A0J9l6BI;EACC,aAAA;EACA,SAAA;EACA,mBzJ9R2C;AD836BhD;A0J7l6BK;EACC,cAAA;A1J+l6BN;A0J7l6BM;EACC,mBAAA;A1J+l6BP;A0J1l6BK;EACC,aAAA;A1J4l6BN;A0Jtl6BC;EACC,kBAAA;EACA,SAAA;EACA,YAAA;A1Jwl6BF;A0Jtl6BE;EACC,wBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;A1Jwl6BH;A0Jtl6BG;EACC,2BAAA;A1Jwl6BJ;A0Jtl6BG;EACC,azJpU4C;EyJqU5C,kBAAA;A1Jwl6BJ;A0Jtl6BI;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;A1Jwl6BL;A0Jpl6BI;EACC,4CAAA;EACA,SAAA;A1Jsl6BL;A0Jpl6BK;EACC,uBAAA;EACA,kBAAA;A1Jsl6BN;A0Jpl6BM;EAIE,6CAAA;A1Jml6BR;A0J5k6BE;EACC,kBAAA;EACA,WAAA;A1J8k6BH;A0J5k6BG;EACC,kBAAA;A1J8k6BJ;A0J5k6BI;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;A1J8k6BL;A0J5k6BI;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;E7D/rBJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F8w7BD;A0J1k6BI;EACC,iCAAA;A1J4k6BL;A0J1k6BI;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;A1J4k6BL;A0J1k6BI;EACC,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;E7DjuBJ,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;A7F8y7BD;A0J1k6BG;EACC,mBAAA;EACA,mCAAA;EACA,iCAAA;A1J4k6BJ;A0J1k6BI;EACC,czJ9pBU;AD0u7Bf;A0Jtk6BI;EACC,czJpqBU;AD4u7Bf;A0Jtk6BI;EACC,kBAAA;A1Jwk6BL;A0Jtk6BK;EACC,6BAAA;A1Jwk6BN;A0Jlk6BG;EACC,yCAAA;EACA,kBAAA;A1Jok6BJ;A0Jlk6BI;EACC,czJ3rBU;AD+v7Bf;A0J9j6BE;EACC,sBAAA;A1Jgk6BH;A0J7j6BI;EACC,yBAAA;A1J+j6BL;A0J5j6BG;EACC,SAAA;EACA,4CAAA;A1J8j6BJ;AgBzw7BI;E0I+sBH;IAEE,WAAA;E1J4j6BD;E0J1j6BC;IAEC,aAAA;E1J2j6BF;E0Jzj6BC;IACC,aAAA;E1J2j6BF;E0Jxj6BE;IACC,UAAA;E1J0j6BH;AACF;;A0Jlj6BC;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EAKC,gBAAA;A1Jij6BH;AgB3y7BI;E0I6vBH;IAEE,aAAA;E1Jgj6BD;E0J9i6BC;IAEC,UAAA;IACA,cAAA;IACA,aAAA;E1J+i6BF;AACF;A0J7i6BE;EACC,azJvgB6C;ADsj7BhD;A0J7i6BG;EACC,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;A1J+i6BJ;AgB/z7BI;E0I2wBD;IAQE,oBAAA;E1Jgj6BH;AACF;A0J7i6BE;EACC,eAAA;EACA,6CAAA;A1J+i6BH;A0J7i6BG;EACC,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;A1J+i6BJ;A0J7i6BI;EACC,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;A1J+i6BL;A0J7i6BK;EACC,aAAA;A1J+i6BN;A0J5i6BO;EACC,sBAAA;EACA,iCAAA;EACA,0CAAA;A1J8i6BR;A0J1i6BK;EACC,mDAAA;EACA,iBAAA;EACA,YAAA;EACA,kBzJ9c0C;EyJ+c1C,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;A1J4i6BN;A0J1i6BM;EACC,cAAA;EACA,gBlJ7OuB;EkJ8OvB,aAAA;EACA,oBzJ9iByC;EyJ+iBzC,kBAAA;A1J4i6BP;A0J1i6BM;EACC,gBzJ9iByC;EyJ+iBzC,mBAAA;EACA,gBlJrPuB;ARiy6B9B;;A0Jni6BA;EACC,eAAA;EACA,YAAA;EACA,WzJhlB+C;EyJilB/C,aAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,0DzJve+C;EyJwe/C,mBAAA;EACA,WAAA;A1Jsi6BD;A0Jpi6BC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;A1Jsi6BF;AgBj47BI;E0Ik0BJ;IA6BE,aAAA;E1Jsi6BA;AACF;A0Jpi6BC;EACC,+BzJx2Ba;AD847Bf;A0Jpi6BC;EACC,eAAA;EACA,cAAA;EACA,cAAA;A1Jsi6BF;A0Jpi6BC;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iCAAA;EACA,4BAAA;EACA,aAAA;EACA,cAAA;EACA,mBzJ9mB8C;EyJ+mB9C,gBzJ1mB8C;EyJ2mB9C,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;A1Jsi6BF;;A0Jhi6BE;;EAEC,kCAAA;A1Jmi6BH;;A2J9+7BC;EACC,eAAA;EACA,gBAAA;EACA,mB1J6T8C;E0J5T9C,WAAA;A3Ji/7BF;A2J/+7BE;EACC,eAAA;EACA,WAAA;A3Ji/7BH;A2J9+7BC;EACC,kBAAA;EACA,iBAAA;EACA,SAAA;A3Jg/7BF;AgBn77BI;E2IhEH;IAME,gBAAA;IACA,eAAA;IACA,aAAA;IACA,iBAAA;E3Ji/7BD;AACF;A2J9+7BG;EACC,kBAAA;A3Jg/7BJ;A2J9+7BI;EACC,oBAAA;EACA,gB1JuT2C;E0JtT3C,uBAAA;A3Jg/7BL;AgBn87BI;E2IhDA;IAME,qBAAA;E3Ji/7BJ;AACF;A2J9+7BG;EAIE,mBAAA;A3J6+7BL;A2Jx+7BC;EACC,aAAA;A3J0+7BF;AgB987BI;E2I7BH;IAIE,cAAA;E3J2+7BD;AACF;A2Jz+7BE;EACC,gBAAA;EACA,eAAA;EAKC,8CAAA;A3Ju+7BJ;AgBx97BI;E2ItBF;IAWE,aAAA;E3Ju+7BF;AACF;A2Jr+7BE;EACC,SAAA;A3Ju+7BH;A2Jr+7BG;EACC,eAAA;A3Ju+7BJ;AgBn+7BI;E2ILD;IAIE,a1JsP2C;EDkv7B9C;AACF;A2Jp+7BC;EACC,qBAAA;EACA,gBAAA;EACA,UAAA;A3Js+7BF;AkJxj8BC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AlJyj8BF;A2Jv+7BE;EACC,UAAA;EACA,gBAAA;EAKC,WAAA;A3Jq+7BJ;A2Jl+7BG;EACC,UAAA;A3Jo+7BJ;A2Jl+7BG;EACC,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;A3Jo+7BJ;A2Jl+7BI;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;A3Jm+7BL;A2Jj+7BK;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;A3Jm+7BN;A2J997BI;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,c1JvEU;E0JwEV,qBAAA;EACA,gB1J4M2C;E0J3M3C,qBAAA;EACA,wBAAA;EACA,kBAAA;A3Jg+7BL;;A4J5m8BA;EACC,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A5J+m8BD;AgBvi8BI;E4I5EJ;IAOE,a3J0T8C;EDsz7B9C;AACF;A4J9m8BC;EACC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;A5Jgn8BF;;A6J7n8BC;EACC,kBAAA;EACA,gBAAA;EACA,wBAAA;A7Jgo8BF;A6J9n8BC;EACC,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,6CAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAKC,cAAA;A7J4n8BH;A6Jzn8BE;EAEC,qBAAA;EACA,4CAAA;EACA,wBAAA;A7J0n8BH;A6Jvn8BC;EACC,qBAAA;EACA,eAAA;EACA,eAAA;EACA,+CAAA;EACA,mBAAA;EACA,aAAA;A7Jyn8BF;AgBvl8BI;E6IxCH;IASE,oBAAA;IACA,oBAAA;IACA,gBAAA;E7J0n8BD;AACF;A6Jvn8BG;EACC,cAAA;EACA,iBAAA;EACA,uCAAA;EACA,qBAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;A7Jyn8BJ;A6Jvn8BI;EAEC,6C5JMU;ADkn8Bf;A6Jtn8BI;EACC,gB5JoR2C;E4JnR3C,sBAAA;EACA,oCAAA;A7Jwn8BL;A6Jrn8BG;EAIE,iB5JuP2C;AD637BhD;A6J/m8BC;EACC,qBAAA;EACA,SAAA;EACA,UAAA;A7Jin8BF;A6J/m8BE;EACC,eAAA;EACA,aAAA;A7Jin8BH;AkJts8BC;EAEC,WAAA;EACA,cAAA;EACA,WAAA;AlJus8BF;A6Jln8BG;EACC,+CAAA;A7Jon8BJ;A6Jln8BG;EACC,4CAAA;A7Jon8BJ;A6Jln8BG;EACC,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A7Jon8BJ;AgB7o8BI;E6IoBD;IAQE,WAAA;IACA,eAAA;E7Jqn8BH;AACF;A6Jnn8BI;EACC,eAAA;EACA,gBAAA;A7Jqn8BL;A6Jnn8BI;EAIE,sBAAA;A7Jkn8BN;A6J9m8BG;EACC,SAAA;A7Jgn8BJ;A6J9m8BI;EACC,qBAAA;EACA,kBAAA;A7Jgn8BL;A6J9m8BK;EACC,wBAAA;EACA,qBAAA;A7Jgn8BN;A6J9m8BM;EACC,0BAAA;A7Jgn8BP;;A8Jpv8BA;EACC,SAAA;EACA,UAAA;A9Juv8BD;A8Jrv8BC;EACC,aAAA;EACA,qBAAA;A9Juv8BF;A8Jrv8BE;EACC,gB7JwT6C;AD+77BhD;A8Jrv8BE;EACC,qBAAA;A9Juv8BH;A8Jpv8BC;EACC,kBAAA;EACA,gB7JoU8C;E6JnU9C,uCAAA;EACA,gBAAA;EACA,kBAAA;A9Jsv8BF;A8Jpv8BC;EACC,SAAA;A9Jsv8BF;A8Jpv8BC;EAEC,oBAAA;EACA,gB7JyT8C;E6JxT9C,wCAAA;EACA,iBAAA;EACA,gBAAA;A9Jqv8BF;A8Jnv8BC;EACC,cAAA;A9Jqv8BF;A8Jnv8BE;EACC,eAAA;EACA,cAAA;ErJnBC,mBAAA;ATyw8BJ;A8Jlv8BC;EACC,mB7JqBa;E6JpBb,c7J6Ca;E6J5Cb,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kB7JwX8C;AD437BhD;A8Jlv8BE;EACC,kBAAA;A9Jov8BH;A8Jjv8BG;EACC,WAAA;EACA,mCAAA;EACA,4B7JOW;E6JNX,kBAAA;EACA,gBAAA;EAMC,cAAA;EACA,2B7JFU;ADgv8Bf;A8Jxu8BE;EACC,iBAAA;A9J0u8BH;A8Jxu8BE;EACC,2BAAA;EACA,4BAAA;A9J0u8BH;A8Jxu8BG;EACC,yBAAA;EACA,oCAAA;EAOC,kCAAA;EACA,UAAA;EACA,eAAA;A9Jou8BL;;A+J9z8BA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;A/Ji08BD;A+J/z8BC;EACC,kBAAA;EACA,UAAA;A/Ji08BF;A+J/z8BE;EACC,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A/Ji08BH;A+J/z8BG;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;A/Jg08BJ;A+J9z8BG;EACC,sBAAA;EACA,2BAAA;EACA,4BAAA;A/Jg08BJ;;AgK518BC;EACC,kBAAA;EACA,aAAA;AhK+18BF;AgK718BC;EAGC,4CAAA;AhK618BF;AgK318BC;EAEC,a/JqT8C;ADui8BhD;AgK118BC;EACC,SAAA;AhK418BF;AgK118BC;EACC,WAAA;EACA,oBAAA;EAKC,iBAAA;AhKw18BH;AgKr18BC;EACC,gBAAA;EACA,kCAAA;AhKu18BF;AgKr18BC;EAGC,4CAAA;AhKq18BF;;AiKv38BA;EACC,aAAA;EACA,mBAAA;AjK038BD;AiKv38BE;EACC,mCAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AjKy38BH;AiKv38BG;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AjKy38BJ;AiKr38BE;EAIE,qBAAA;AjKo38BJ","sourcesContent":["/*!\n * HUD REACT v3.1.0 (https://seantheme.com/hud-react/)\n * Copyright 2024 SeanTheme\n */\n\n@import '_functions.scss';\n@import '_variables.scss';\n@import '_variables-dark.scss';\n@import 'bootstrap/scss/bootstrap.scss';\n@import '_mixins.scss';\n\n@import '_root.scss';\n@import '_reboot.scss';\n@import '_helper.scss';\n\n@import '_app.scss';\n@import '_layout.scss';\n@import '_ui.scss';\n@import '_plugins.scss';\n@import '_pages.scss';\n@import '_widgets.scss';\n@import '_rtl.scss';\n\n","/*\n   01. Color system \n   02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)\n   03. Variable prefix setting\n   04. Body setting\n   05. Spacer setting\n   06. Font & headings settings\n   07. Grid settings\n   08. Container padding\n   09. Component border settings\n   10. Component border-radius settings\n   11. Component box-shadow settings \n   12. Component color settings \n   13. Component caret settings \n   14. Component transition settings \n   15. Component ratio settings \n   16. Container padding settings\n   17. App - Header settings\n   18. App - Sidebar settings\n   19. App - Content settings\n   20. App - Pos system settings\n   21. Link settings\n   22. Alerts settings\n   23. Breadcrumbs settings\n   24. Progress bars settings\n   25. Buttons + Forms settings\n   26. Buttons settings\n   27. Button close settings\n   28. Forms settings\n   29. Form placeholders settings\n   30. Form check settings\n   31. Form switch settings\n   32. Form input group settings\n   33. Form select settings\n   34. Form range settings\n   35. Form file settings\n   36. Form Floating settings\n   37. Form validation settings\n   38. Cards settings\n   39. Tooltips settings\n   40. Popovers\n   41. Modals settings\n   42. Offcanvas\n   43. Toasts settings\n   44. Accordion settings\n   45. Tables settings\n   46. Dropdown settings\n   47. List group settings\n   48. Nav settings\n   49. Navbar settings\n   50. Pagination settings\n   51. Z-index settings\n   52. Badges settings\n   53. Position settings\n   54. Image thumbnails settings\n   55. Figures settings\n   56. Carousel settings\n   57. Spinners settings\n   58. Code settings\n*/\n\n\n// 01. Color system \n\n$white:        #FFFFFF !default;\n$gray-500:     #617a86 !default;\n$gray-100:     mix(#fff, $gray-500, 60%) !default;\n$gray-200:     mix(#fff, $gray-500, 45%) !default;\n$gray-300:     mix(#fff, $gray-500, 30%) !default;\n$gray-400:     mix(#fff, $gray-500, 15%) !default;\n$gray-500:     #617a86 !default;\n$gray-600:     mix(#000, $gray-500, 15%) !default;\n$gray-700:     mix(#000, $gray-500, 30%) !default;\n$gray-800:     mix(#000, $gray-500, 45%) !default;\n$gray-900:     mix(#000, $gray-500, 60%) !default;\n$yellow:       #f9e80d !default;\n$orange:       #ff9f0c !default;\n$aqua:         #0cfff5 !default;\n$blue:         #0271ff !default;\n$indigo:       #5c25ff !default;\n$purple:       #b90dff !default;\n$red:          #e00000 !default;\n$teal:         #249d79 !default;\n$green:        #148922 !default;\n$lime:         #50b00a !default;\n$pink:         #e61079 !default;\n$cyan:         #009be3 !default;\n$default:      $gray-400 !default;\n$dark:         $gray-800 !default;\n$black:        #000000 !default;\n$light:        $gray-100 !default;\n$primary:      $blue !default;\n$warning:      $orange !default;\n$danger:       $red !default;\n$success:      $teal !default;\n$info:         $cyan !default;\n$secondary:    $gray-400 !default;\n$text-muted:   $gray-400 !default;\n$inverse:      $black !default;\n$theme:        $teal !default;\n$theme-color:  $white !default;\n$theme-colors: (\n\t\"default\":     $default,\n\t\"theme\":       $theme,\n\t\"theme-color\": $theme-color,\n\t\"primary\":     $primary,\n\t\"secondary\":   $secondary,\n\t\"warning\":     $warning,\n\t\"danger\":      $danger,\n\t\"success\":     $success,\n\t\"inverse\":     $inverse,\n\t\"info\":        $info,\n\t\"dark\":        $dark,\n\t\"black\":       $black,\n\t\"white\":       $white,\n\t\"purple\":      $purple,\n\t\"indigo\":      $indigo,\n\t\"red\":         $red,\n\t\"pink\":        $pink,\n\t\"green\":       $green,\n\t\"yellow\":      $yellow,\n\t\"teal\":        $teal,\n\t\"muted\":       $gray-500,\n  \"light\":       $light,\n  \"lime\":        $lime,\n\t\"gray-100\":    $gray-100,\n\t\"gray-200\":    $gray-200,\n\t\"gray-300\":    $gray-300,\n\t\"gray-400\":    $gray-400,\n\t\"gray-500\":    $gray-500,\n\t\"gray-600\":    $gray-600,\n\t\"gray-700\":    $gray-700,\n\t\"gray-800\":    $gray-800,\n\t\"gray-900\":    $gray-900\n);\n\n$min-contrast-ratio:                            3 !default;\n$color-contrast-dark:                           $black !default;\n$color-contrast-light:                          $white !default;\n\n$blue-100:                                      tint-color($blue, 80%) !default;\n$blue-200:                                      tint-color($blue, 60%) !default;\n$blue-300:                                      tint-color($blue, 40%) !default;\n$blue-400:                                      tint-color($blue, 20%) !default;\n$blue-500:                                      $blue !default;\n$blue-600:                                      shade-color($blue, 20%) !default;\n$blue-700:                                      shade-color($blue, 40%) !default;\n$blue-800:                                      shade-color($blue, 60%) !default;\n$blue-900:                                      shade-color($blue, 80%) !default;\n\n$indigo-100:                                    tint-color($indigo, 80%) !default;\n$indigo-200:                                    tint-color($indigo, 60%) !default;\n$indigo-300:                                    tint-color($indigo, 40%) !default;\n$indigo-400:                                    tint-color($indigo, 20%) !default;\n$indigo-500:                                    $indigo !default;\n$indigo-600:                                    shade-color($indigo, 20%) !default;\n$indigo-700:                                    shade-color($indigo, 40%) !default;\n$indigo-800:                                    shade-color($indigo, 60%) !default;\n$indigo-900:                                    shade-color($indigo, 80%) !default;\n\n$purple-100:                                    tint-color($purple, 80%) !default;\n$purple-200:                                    tint-color($purple, 60%) !default;\n$purple-300:                                    tint-color($purple, 40%) !default;\n$purple-400:                                    tint-color($purple, 20%) !default;\n$purple-500:                                    $purple !default;\n$purple-600:                                    shade-color($purple, 20%) !default;\n$purple-700:                                    shade-color($purple, 40%) !default;\n$purple-800:                                    shade-color($purple, 60%) !default;\n$purple-900:                                    shade-color($purple, 80%) !default;\n\n$pink-100:                                      tint-color($pink, 80%) !default;\n$pink-200:                                      tint-color($pink, 60%) !default;\n$pink-300:                                      tint-color($pink, 40%) !default;\n$pink-400:                                      tint-color($pink, 20%) !default;\n$pink-500:                                      $pink !default;\n$pink-600:                                      shade-color($pink, 20%) !default;\n$pink-700:                                      shade-color($pink, 40%) !default;\n$pink-800:                                      shade-color($pink, 60%) !default;\n$pink-900:                                      shade-color($pink, 80%) !default;\n\n$red-100:                                       tint-color($red, 80%) !default;\n$red-200:                                       tint-color($red, 60%) !default;\n$red-300:                                       tint-color($red, 40%) !default;\n$red-400:                                       tint-color($red, 20%) !default;\n$red-500:                                       $red !default;\n$red-600:                                       shade-color($red, 20%) !default;\n$red-700:                                       shade-color($red, 40%) !default;\n$red-800:                                       shade-color($red, 60%) !default;\n$red-900:                                       shade-color($red, 80%) !default;\n\n$orange-100:                                    tint-color($orange, 80%) !default;\n$orange-200:                                    tint-color($orange, 60%) !default;\n$orange-300:                                    tint-color($orange, 40%) !default;\n$orange-400:                                    tint-color($orange, 20%) !default;\n$orange-500:                                    $orange !default;\n$orange-600:                                    shade-color($orange, 20%) !default;\n$orange-700:                                    shade-color($orange, 40%) !default;\n$orange-800:                                    shade-color($orange, 60%) !default;\n$orange-900:                                    shade-color($orange, 80%) !default;\n\n$yellow-100:                                    tint-color($yellow, 80%) !default;\n$yellow-200:                                    tint-color($yellow, 60%) !default;\n$yellow-300:                                    tint-color($yellow, 40%) !default;\n$yellow-400:                                    tint-color($yellow, 20%) !default;\n$yellow-500:                                    $yellow !default;\n$yellow-600:                                    shade-color($yellow, 20%) !default;\n$yellow-700:                                    shade-color($yellow, 40%) !default;\n$yellow-800:                                    shade-color($yellow, 60%) !default;\n$yellow-900:                                    shade-color($yellow, 80%) !default;\n\n$green-100:                                     tint-color($green, 80%) !default;\n$green-200:                                     tint-color($green, 60%) !default;\n$green-300:                                     tint-color($green, 40%) !default;\n$green-400:                                     tint-color($green, 20%) !default;\n$green-500:                                     $green !default;\n$green-600:                                     shade-color($green, 20%) !default;\n$green-700:                                     shade-color($green, 40%) !default;\n$green-800:                                     shade-color($green, 60%) !default;\n$green-900:                                     shade-color($green, 80%) !default;\n\n$teal-100:                                      tint-color($teal, 80%) !default;\n$teal-200:                                      tint-color($teal, 60%) !default;\n$teal-300:                                      tint-color($teal, 40%) !default;\n$teal-400:                                      tint-color($teal, 20%) !default;\n$teal-500:                                      $teal !default;\n$teal-600:                                      shade-color($teal, 20%) !default;\n$teal-700:                                      shade-color($teal, 40%) !default;\n$teal-800:                                      shade-color($teal, 60%) !default;\n$teal-900:                                      shade-color($teal, 80%) !default;\n\n$cyan-100:                                      tint-color($cyan, 80%) !default;\n$cyan-200:                                      tint-color($cyan, 60%) !default;\n$cyan-300:                                      tint-color($cyan, 40%) !default;\n$cyan-400:                                      tint-color($cyan, 20%) !default;\n$cyan-500:                                      $cyan !default;\n$cyan-600:                                      shade-color($cyan, 20%) !default;\n$cyan-700:                                      shade-color($cyan, 40%) !default;\n$cyan-800:                                      shade-color($cyan, 60%) !default;\n$cyan-900:                                            shade-color($cyan, 80%) !default;\n\n$primary-text:                                  $blue-600 !default;\n$secondary-text:                                $gray-600 !default;\n$success-text:                                  $green-600 !default;\n$info-text:                                     $cyan-700 !default;\n$warning-text:                                  $yellow-700 !default;\n$danger-text:                                   $red-600 !default;\n$light-text:                                    $gray-600 !default;\n$dark-text:                                     $gray-700 !default;\n\n$primary-bg-subtle:                             $blue-100 !default;\n$secondary-bg-subtle:                           $gray-100 !default;\n$success-bg-subtle:                             $green-100 !default;\n$info-bg-subtle:                                $cyan-100 !default;\n$warning-bg-subtle:                             $yellow-100 !default;\n$danger-bg-subtle:                              $red-100 !default;\n$light-bg-subtle:                               mix($gray-100, $white) !default;\n$dark-bg-subtle:                                $gray-400 !default;\n\n$primary-border-subtle:                         $blue-200 !default;\n$secondary-border-subtle:                       $gray-200 !default;\n$success-border-subtle:                         $green-200 !default;\n$info-border-subtle:                            $cyan-200 !default;\n$warning-border-subtle:                         $yellow-200 !default;\n$danger-border-subtle:                          $red-200 !default;\n$light-border-subtle:                           $gray-200 !default;\n$dark-border-subtle:                            $gray-500 !default;\n\n\n\n// 02. Options toggle setting (rtl, shadow, caret, negative margin, color mode)\n\n$enable-rtl:                                    false !default;\n$enable-caret:                                  true !default;\n$enable-rounded:                                true !default;\n$enable-shadows:                                false !default;\n$enable-gradients:                              false !default;\n$enable-transitions:                            true !default;\n$enable-reduced-motion:                         true !default;\n$enable-smooth-scroll:                          true !default;\n$enable-grid-classes:                           true !default;\n$enable-container-classes:                      true !default;\n$enable-cssgrid:                                false !default;\n$enable-button-pointers:                        true !default;\n$enable-rfs:                                    true !default;\n$enable-validation-icons:                       true !default;\n$enable-negative-margins:                       true !default;\n$enable-deprecation-messages:                   true !default;\n$enable-important-utilities:                    true !default;\n$enable-dark-mode:                              true !default;\n$color-mode-type:                               data !default; // `data` or `media-query`\n$gradient:                                      linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n\n\n\n// 03. Variable prefix setting\n\n$prefix:                                        bs- !default;\n\n\n\n// 04. Body setting\n\n$body-bg:                                       $white !default;\n$body-bg-gradient:                              linear-gradient(180deg, rgba($white,.90) 0%, rgba($white,.99) 100%) !default;\n$body-bg-cover:                                 url('images/cover.jpg') !default;\n$body-bg-image:                                 url('images/pattern.png') !default;\n$body-bg-image-size:                            rem(75px) !default;\n$body-letter-spacing:                           rem(.75px) !default;\n$body-color:                                    rgba($black, .75) !default;\n$body-font-weight:                              400 !default;\n$body-emphasis-color:                           $black !default;\n$body-secondary-color:                          rgba($body-color, .75) !default;\n$body-secondary-bg:                             $gray-100 !default;\n$body-tertiary-color:                           rgba($body-color, .5) !default;\n$body-tertiary-bg:                              rgba($body-color, .1) !default;\n$emphasis-color:                                $black !default;\n\n\n\n// 05. Spacer setting\n\n$spacer:                                        rem-default(16px) !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n\n\n// 06. Font & headings settings\n\n$font-family-base:                              'Chakra Petch', sans-serif !default;\n$font-size-base:                                .875rem !default;\n$font-size-sm:                                  .8125rem !default;\n$font-size-lg:                                 \t1rem !default;\n$font-weight-light:                             300 !default;\n$font-weight-semibold:                          500 !default;\n$font-weight-bold:                              600 !default;\n$font-weight-base:                              400 !default;\n$font-weight-normal:                            400 !default;\n$headings-font-weight:                          $font-weight-bold !default;\n$headings-color:                                $black !default;\n$line-height-base:                              1.5 !default;\n$line-height-sm:                                1.25 !default;\n$line-height-lg:                                2 !default;\n$lead-font-size:                                $font-size-base * 1.25 !default;\n$lead-font-weight:                              300 !default;\n$small-font-size:                               .875em !default;\n$sub-sup-font-size:                             .75em !default;\n$text-muted:                                    var(--#{$prefix}secondary-color) !default;\n$initialism-font-size:                          $small-font-size !default;\n$blockquote-margin-y:                           $spacer !default;\n$blockquote-font-size:                          $font-size-base * 1.25 !default;\n$blockquote-footer-color:                       $gray-600 !default;\n$blockquote-footer-font-size:                   $small-font-size !default;\n$hr-margin-y:                                   $spacer !default;\n$hr-color:                                      inherit !default;\n$hr-border-color:                               null !default;\n$hr-border-width:                               var(--#{$prefix}border-width) !default;\n$hr-opacity:                                    .25 !default;\n$legend-margin-bottom:                          .5rem !default;\n$legend-font-size:                              1.5rem !default;\n$legend-font-weight:                            null !default;\n$dt-font-weight:                                $font-weight-bold !default;\n$list-inline-padding:                           .5rem !default;\n$mark-padding:                                  .1875em !default;\n$mark-bg:                                       $yellow-100 !default;\n$paragraph-margin-bottom:                       1rem !default;\n\n\n\n// 07. Grid settings\n\n$grid-gutter-width:                             20px !default;\n$grid-columns:                                  12 !default;\n$grid-row-columns:                              6 !default;\n$grid-breakpoints: (\n\txs: 0,\n\tsm: 576px,\n\tmd: 768px,\n\tlg: 992px,\n\txl: 1200px,\n\txxl: 1660px,\n  xxxl: 1900px\n) !default;\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n\n\n\n// 08. Container padding\n\n$container-padding-x:                           $grid-gutter-width !default;\n\n\n\n// 09. Component border settings\n\n$border-width:                                  1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                                  solid !default;\n$border-color:                                  rgba($black, .2) !default;\n$border-color-translucent:                      rgba($black, .1) !default;\n\n\n\n// 10. Component border-radius settings\n\n$border-radius:                                 4px !default;\n$border-radius-lg:                              8px !default;\n$border-radius-sm:                              2px !default;\n$border-radius-xl:                              1rem !default;\n$border-radius-2xl:                             2rem !default;\n$border-radius-pill:                            50rem !default;\n\n\n\n// 11. Component box-shadow settings \n\n$box-shadow:                                    0 .5rem 1rem rgba(var(--#{$prefix}inverse-rgb), .075) !default;\n$box-shadow-sm:                                 0 .125rem .25rem rgba(var(--#{$prefix}inverse-rgb), .035) !default;\n$box-shadow-lg:                                 0 1rem 3rem rgba(var(--#{$prefix}inverse-rgb), .175) !default;\n$box-shadow-inset:                              inset 0 1px 2px rgba(var(--#{$prefix}inverse-rgb), .075) !default;\n\n\n\n// 12. Component color settings \n\n$component-bg:                                  $white !default;\n$component-color:                               $body-color !default;\n$component-active-color:                        $theme-color !default;\n$component-active-bg:                           $theme !default;\n\n\n\n// 13. Component caret settings \n\n$caret-width:                                   .3em !default;\n$caret-vertical-align:                          $caret-width * .85 !default;\n$caret-spacing:                                 $caret-width * .85 !default;\n\n\n\n// 14. Component transition settings \n\n$transition-base:                               all .2s ease-in-out !default;\n$transition-fade:                               opacity .15s linear !default;\n$transition-collapse:                           height .35s ease !default;\n$transition-collapse-width:                     width .35s ease !default;\n\n\n\n// 15. Component ratio settings \n\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n\n\n\n// 16. Container padding settings\n\n$container-padding-x:                           $grid-gutter-width !default;\n\n\n\n// 17. App - Header settings\n\n$app-header-height:                             rem(52px) !default;\n$app-header-bg:                                 $white !default;\n$app-header-zindex:                             1020 !default;\n$app-header-search-max-width:                   rem(967px) !default;\n$app-header-padding-x:                          $spacer * .25 !default;\n$app-header-padding-y:                          $spacer * .25 !default;\n$app-header-brand-img:                          url('images/logo.png') !default;\n$app-header-link-color:                         $black !default;\n$app-header-link-hover-color:                   $black !default;\n$app-header-scroll-box-shadow:                  null !default;\n\n\n\n// 18. App - Sidebar settings\n      \n$app-sidebar-width:                             rem(270px) !default;\n$app-sidebar-menu-header-color:                 rgba(var(--#{$prefix}inverse-rgb), .3) !default;\n$app-sidebar-menu-link-color:                   rgba(var(--#{$prefix}inverse-rgb), .5) !default;\n$app-sidebar-menu-link-hover-color:             $black !default;\n$app-sidebar-menu-link-active-color:            $black !default;\n$app-sidebar-menu-link-icon-active-color:       var(--#{$prefix}theme) !default;\n$app-sidebar-zindex:                            $app-header-zindex - 10 !default;\n$app-sidebar-mobile-zindex:                     $app-header-zindex + 10 !default;\n$app-sidebar-mobile-bg:                         rgba(255, 255, 255, .98) !default;\n$app-sidebar-mobile-backdrop-zindex:            $app-sidebar-mobile-zindex - 10 !default;\n$app-sidebar-mobile-backdrop-bg:                rgba($black, .25) !default;\n\n\n\n// 19. App - Top Nav settings\n$app-top-nav-bg:                                $white !default;\n$app-top-nav-zindex:                            $app-header-zindex - 10 !default;\n$app-top-nav-height:                            rem(46px) !default;\n$app-top-nav-menu-link-padding-x:               rem(20px) !default;\n$app-top-nav-menu-link-padding-y:               rem(10px) !default;\n$app-top-nav-menu-link-color:                   rgba(var(--#{$prefix}inverse-rgb), .5) !default;\n$app-top-nav-menu-link-hover-color:             $black !default;\n$app-top-nav-menu-link-active-color:            $black !default;\n$app-top-nav-menu-link-icon-active-color:       var(--#{$prefix}theme) !default;\n$app-top-nav-menu-submenu-bg:                   $white !default;\n\n\n\n// 19. App - Content settings\n\n$app-content-padding-y:                         $spacer * 2;\n$app-content-padding-x:                         $spacer * 2;\n$app-content-sm-padding-y:                      $spacer;\n$app-content-sm-padding-x:                      $spacer;\n\n\n\n// 20. App - Theme panel settings\n\n$app-theme-panel-bg:                            rgba($white, .95) !default;\n$app-theme-panel-color:                       \t$black !default;\n\n\n\n// 20. App - Pos system settings\n\n$pos-booking-header-height:                     rem(52px) !default;\n$pos-counter-header-height:                     rem(52px) !default;\n$pos-kitchen-header-height:                     rem(52px) !default;\n$pos-stock-header-height:                       rem(52px) !default;\n$pos-sidebar-menu-width:                        140px !default;\n$pos-sidebar-desktop-width:                     360px !default;\n$pos-bg:                                        $gray-200 !default;\n$pos-bg-dark-mode:                              shade-color($gray-900, 30%) !default;\n\n\n\n// 21. Link settings\n\n$link-color:                                    $theme !default;\n$link-hover-color:                              rgba($theme, .5) !default;\n$link-decoration:                               underline !default;\n$link-shade-percentage:                         20% !default;\n$link-hover-decoration:                         null !default;\n$stretched-link-pseudo-element:                 after !default;\n$stretched-link-z-index:                        1 !default;\n\n\n\n// 22. Alerts settings\n\n$alert-padding-y:                               $spacer !default;\n$alert-padding-x:                               $spacer !default;\n$alert-margin-bottom:                           1rem !default;\n$alert-border-radius:                           $border-radius !default;\n$alert-link-font-weight:                        $font-weight-bold !default;\n$alert-border-width:                            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:                   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n\n\n\n// 23. Breadcrumbs settings\n\n$breadcrumb-font-size:                          85% !default;\n$breadcrumb-padding-y:                          0 !default;\n$breadcrumb-padding-x:                          0 !default;\n$breadcrumb-item-padding-x:                     .5rem !default;\n$breadcrumb-margin-bottom:                      1rem !default;\n$breadcrumb-bg:                                 null !default;\n$breadcrumb-divider-color:                      var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:                       var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                            quote(\"/\") !default;\n$breadcrumb-divider-flipped:                    $breadcrumb-divider !default;\n$breadcrumb-border-radius:                      null !default;\n\n\n\n// 24. Progress bars settings\n\n$progress-height:                               1rem !default;\n$progress-font-size:                            $font-size-base * .75 !default;\n$progress-bg:                                   rgba(var(--#{$prefix}inverse-rgb), .15) !default;\n$progress-border-radius:                        var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:                           var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                            $white !default;\n$progress-bar-bg:                               $primary !default;\n$progress-bar-animation-timing:                 1s linear infinite !default;\n$progress-bar-transition:                       width .6s ease !default;\n\n\n\n// 25. Buttons + Forms settings\n\n$input-btn-padding-y:                           .375rem !default;\n$input-btn-padding-x:                           .75rem !default;\n$input-btn-font-family:                         null !default;\n$input-btn-font-size:                           $font-size-base !default;\n$input-btn-line-height:                         $line-height-base !default;\n$input-btn-focus-width:                         .25rem !default;\n$input-btn-focus-color-opacity:                 .25 !default;\n$input-btn-focus-color:                         rgba(var(--#{$prefix}inverse-rgb), $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:                          0 !default;\n$input-btn-focus-box-shadow:                    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n$input-btn-padding-y-sm:                        .25rem !default;\n$input-btn-padding-x-sm:                        .5rem !default;\n$input-btn-font-size-sm:                        $font-size-sm !default;\n$input-btn-padding-y-lg:                        .5rem !default;\n$input-btn-padding-x-lg:                        1rem !default;\n$input-btn-font-size-lg:                        $font-size-lg !default;\n$input-btn-border-width:                        var(--#{$prefix}border-width) !default;\n\n\n\n// 26. Buttons settings\n\n$btn-padding-y:                                 $input-btn-padding-y !default;\n$btn-padding-x:                                 $input-btn-padding-x !default;\n$btn-font-family:                               $input-btn-font-family !default;\n$btn-font-size:                                 $input-btn-font-size !default;\n$btn-line-height:                               $input-btn-line-height !default;\n$btn-white-space:                               null !default; // Set to `nowrap` to prevent text wrapping\n$btn-padding-y-sm:                              $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:                              $input-btn-padding-x-sm !default;\n$btn-font-size-sm:                              $input-btn-font-size-sm !default;\n$btn-padding-y-lg:                              $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:                              $input-btn-padding-x-lg !default;\n$btn-font-size-lg:                              $input-btn-font-size-lg !default;\n$btn-border-width:                              $input-btn-border-width !default;\n$btn-font-weight:                               $font-weight-normal !default;\n$btn-box-shadow:                                inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:                               $input-btn-focus-width !default;\n$btn-focus-box-shadow:                          $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:                          .65 !default;\n$btn-active-box-shadow:                         inset 0 3px 5px rgba($black, .125) !default;\n$btn-link-color:                                var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:                          var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:                       $gray-600 !default;\n$btn-border-radius:                             $border-radius !default;\n$btn-border-radius-sm:                          $border-radius-sm !default;\n$btn-border-radius-lg:                          $border-radius-lg !default;\n$btn-transition:                                color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n$btn-hover-bg-shade-amount:                     15% !default;\n$btn-hover-bg-tint-amount:                      15% !default;\n$btn-hover-border-shade-amount:                 20% !default;\n$btn-hover-border-tint-amount:                  10% !default;\n$btn-active-bg-shade-amount:                    20% !default;\n$btn-active-bg-tint-amount:                     20% !default;\n$btn-active-border-shade-amount:                25% !default;\n$btn-active-border-tint-amount:                 10% !default;\n\n\n\n// 27. Button close settings\n\n$btn-close-width:                               1em !default;\n$btn-close-height:                              $btn-close-width !default;\n$btn-close-padding-x:                           .25em !default;\n$btn-close-padding-y:                           $btn-close-padding-x !default;\n$btn-close-color:                               $black !default;\n$btn-close-bg:                                  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:                        $input-btn-focus-box-shadow !default;\n$btn-close-opacity:                             .5 !default;\n$btn-close-hover-opacity:                       .75 !default;\n$btn-close-focus-opacity:                       1 !default;\n$btn-close-disabled-opacity:                    .25 !default;\n$btn-close-white-filter:                        invert(1) grayscale(100%) brightness(200%) !default;\n\n\n\n// 28. Forms settings\n\n$form-text-margin-top:                          .25rem !default;\n$form-text-font-size:                           $small-font-size !default;\n$form-text-font-style:                          null !default;\n$form-text-font-weight:                         null !default;\n$form-text-color:                               $text-muted !default;\n$form-label-margin-bottom:                      .5rem !default;\n$form-label-font-size:                          null !default;\n$form-label-font-style:                         null !default;\n$form-label-font-weight:                        null !default;\n$form-label-color:                              null !default;\n$input-padding-y:                               $input-btn-padding-y !default;\n$input-padding-x:                               $input-btn-padding-x !default;\n$input-font-family:                             $input-btn-font-family !default;\n$input-font-size:                               $input-btn-font-size !default;\n$input-font-weight:                             $font-weight-base !default;\n$input-line-height:                             $input-btn-line-height !default;\n$input-padding-y-sm:                            $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                            $input-btn-padding-x-sm !default;\n$input-font-size-sm:                            $input-btn-font-size-sm !default;\n$input-padding-y-lg:                            $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                            $input-btn-padding-x-lg !default;\n$input-font-size-lg:                            $input-btn-font-size-lg !default;\n$input-bg:                                      transparent !default;\n$input-disabled-color:                          null !default;\n$input-disabled-bg:                             var(--#{$prefix}form-control-disabled-bg) !default;\n$input-disabled-border-color:                   null !default;\n$input-color:                                   var(--#{$prefix}body-color) !default;\n$input-border-color:                            var(--#{$prefix}border-color) !default; //$gray-400\n$input-border-width:                            $input-btn-border-width !default;\n$input-box-shadow:                              $box-shadow-inset !default;\n$input-border-radius:                           $border-radius !default;\n$input-border-radius-sm:                        $border-radius-sm !default;\n$input-border-radius-lg:                        $border-radius-lg !default;\n$input-focus-bg:                                $input-bg !default;\n$input-focus-border-color:                      rgba(var(--#{$prefix}inverse-rgb), .5) !default;\n$input-focus-color:                             $input-color !default;\n$input-focus-width:                             $input-btn-focus-width !default;\n$input-focus-box-shadow:                        $input-btn-focus-box-shadow !default;\n$input-placeholder-color:                       rgba(var(--#{$prefix}body-color-rgb), .5) !default;\n$input-plaintext-color:                         var(--#{$prefix}body-color) !default;\n$input-height-border:                           calc($input-border-width * 2) !default; // stylelint-disable-line function-disallowed-list\n$input-height-inner:                            add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:                       add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:                    add($input-line-height * .25em, $input-padding-y * .5) !default;\n$input-height:                                  add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                               add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                               add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n$input-transition:                              border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n$form-color-width:                              3rem !default;\n\n\n\n// 29. Form placeholders settings\n\n$placeholder-opacity-max:                       .5 !default;\n$placeholder-opacity-min:                       .2 !default;\n\n\n\n// 30. Form check settings\n\n$form-check-input-width:                        1.3em !default;\n$form-check-min-height:                         1.3em !default;\n$form-check-padding-start:                      $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                      .125rem !default;\n$form-check-label-color:                        null !default;\n$form-check-label-cursor:                       null !default;\n$form-check-transition:                         null !default;\n$form-check-input-active-filter:                brightness(90%) !default;\n$form-check-input-bg:                           $input-bg !default;\n$form-check-input-border:                       var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:                .25em !default;\n$form-check-radio-border-radius:                50% !default;\n$form-check-input-focus-border:                 $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:             $input-btn-focus-box-shadow !default;\n$form-check-input-checked-color:                $component-active-color !default;\n$form-check-input-checked-bg-color:             $component-active-bg !default;\n$form-check-input-checked-border-color:         $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n$form-check-input-disabled-opacity:             .5 !default;\n$form-check-label-disabled-opacity:             $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:         $btn-disabled-opacity !default;\n$form-check-inline-margin-end:                  1rem !default;\n\n\n\n// 31. Form switch settings\n\n$form-switch-color:                             rgba($black, .25) !default;\n$form-switch-width:                             2.3em !default;\n$form-switch-padding-start:                     $form-switch-width + .5em !default;\n$form-switch-bg-image:                          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:                     $form-switch-width !default;\n$form-switch-transition:                        background-position .15s ease-in-out !default;\n$form-switch-focus-color:                       tint-color($black, 50%) !default;\n$form-switch-focus-bg-image:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n$form-switch-checked-color:                     $component-active-color !default;\n$form-switch-checked-bg-image:                  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position:               right center !default;\n\n\n\n// 32. Form input group settings\n\n$input-group-addon-padding-y:                   $input-padding-y !default;\n$input-group-addon-padding-x:                   $input-padding-x !default;\n$input-group-addon-font-weight:                 $input-font-weight !default;\n$input-group-addon-color:                       $input-color !default;\n$input-group-addon-bg:                          var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:                $input-border-color !default;\n\n\n\n// 33. Form select settings\n\n$form-select-padding-y:                         $input-padding-y !default;\n$form-select-padding-x:                         $input-padding-x !default;\n$form-select-font-family:                       $input-font-family !default;\n$form-select-font-size:                         $input-font-size !default;\n$form-select-indicator-padding:                 $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:                       $input-font-weight !default;\n$form-select-line-height:                       $input-line-height !default;\n$form-select-color:                             $input-color !default;\n$form-select-bg:                                $input-bg !default;\n$form-select-disabled-color:                    null !default;\n$form-select-disabled-bg:                       $input-disabled-bg !default;\n$form-select-disabled-border-color:             $input-disabled-border-color !default;\n$form-select-bg-position:                       right $form-select-padding-x center !default;\n$form-select-bg-size:                           16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:                   $gray-800 !default;\n$form-select-indicator:                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n$form-select-feedback-icon-padding-end:         $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:            center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:                $input-height-inner-half $input-height-inner-half !default;\n$form-select-border-width:                      $input-border-width !default;\n$form-select-border-color:                      $input-border-color !default;\n$form-select-border-radius:                     $input-border-radius !default;\n$form-select-box-shadow:                        $box-shadow-inset !default;\n$form-select-focus-border-color:                $input-focus-border-color !default;\n$form-select-focus-width:                       $input-focus-width !default;\n$form-select-focus-box-shadow:                  0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n$form-select-padding-y-sm:                      $input-padding-y-sm !default;\n$form-select-padding-x-sm:                      $input-padding-x-sm !default;\n$form-select-font-size-sm:                      $input-font-size-sm !default;\n$form-select-border-radius-sm:                  $input-border-radius-sm !default;\n$form-select-padding-y-lg:                      $input-padding-y-lg !default;\n$form-select-padding-x-lg:                      $input-padding-x-lg !default;\n$form-select-font-size-lg:                      $input-font-size-lg !default;\n$form-select-border-radius-lg:                  $input-border-radius-lg !default;\n$form-select-transition:                        $input-transition !default;\n\n\n\n// 34. Form range settings\n\n$form-range-track-width:                        100% !default;\n$form-range-track-height:                       .5rem !default;\n$form-range-track-cursor:                       pointer !default;\n$form-range-track-bg:                           rgba(var(--#{$prefix}inverse-rgb), .1) !default;\n$form-range-track-border-radius:                1rem !default;\n$form-range-track-box-shadow:                   $box-shadow-inset !default;\n$form-range-thumb-width:                        1rem !default;\n$form-range-thumb-height:                       $form-range-thumb-width !default;\n$form-range-thumb-bg:                           var(--#{$prefix}theme) !default;\n$form-range-thumb-border:                       0 !default;\n$form-range-thumb-border-radius:                1rem !default;\n$form-range-thumb-box-shadow:                   0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:             0 0 0 1px transparent, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:       $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:                    rgba(var(--#{$prefix}theme-rgb), .75) !default;\n$form-range-thumb-disabled-bg:                  var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:                   background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n\n// 35. Form file settings\n\n$form-file-button-color:                        $input-color !default;\n$form-file-button-bg:                           var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:                     var(--#{$prefix}border-color) !default;\n\n\n\n// 36. Form Floating settings\n\n$form-floating-height:                          add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:                     1.25 !default;\n$form-floating-padding-x:                       $input-padding-x !default;\n$form-floating-padding-y:                       1rem !default;\n$form-floating-input-padding-t:                 1.625rem !default;\n$form-floating-input-padding-b:                 .625rem !default;\n$form-floating-label-height:                    1.875em !default;\n$form-floating-label-opacity:                   .65 !default;\n$form-floating-label-transform:                 scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:            $gray-600 !default;\n$form-floating-transition:                      opacity .1s ease-in-out, transform .1s ease-in-out !default;\n\n\n\n// 37. Form validation settings\n\n$form-feedback-margin-top:                      $form-text-margin-top !default;\n$form-feedback-font-size:                       $form-text-font-size !default;\n$form-feedback-font-style:                      $form-text-font-style !default;\n$form-feedback-valid-color:                     $success !default;\n$form-feedback-invalid-color:                   $danger !default;\n$form-feedback-icon-valid-color:                $form-feedback-valid-color !default;\n$form-feedback-icon-valid:                      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:              $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n$form-validation-states: (\n  \"valid\": (\n    \"color\":            var(--#{$prefix}success-text),\n    \"icon\":             $form-feedback-icon-valid,\n    \"tooltip-color\":    #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\":     var(--#{$prefix}success),\n  ),\n  \"invalid\": (\n    \"color\":            var(--#{$prefix}danger-text),\n    \"icon\":             $form-feedback-icon-invalid,\n    \"tooltip-color\":    #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\":     var(--#{$prefix}danger),\n  )\n) !default;\n\n\n\n// 38. Cards settings\n\n$card-spacer-y:                                 $spacer !default;\n$card-spacer-x:                                 $spacer !default;\n$card-title-spacer-y:                           $spacer * .5 !default;\n$card-title-color:                              null !default;\n$card-subtitle-color:                           null !default;\n$card-border-width:                             var(--#{$prefix}border-width) !default;\n$card-border-color:                             var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                            var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                               null !default;\n$card-inner-border-radius:                      subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                            $card-spacer-y * .5 !default;\n$card-cap-padding-x:                            $card-spacer-x !default;\n$card-cap-bg:                                   rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                                null !default;\n$card-height:                                   null !default;\n$card-color:                                    null !default;\n$card-bg:                                       transparent !default;\n$card-img-overlay-padding:                      $spacer !default;\n$card-group-margin:                             $grid-gutter-width * .5 !default;\n\n\n\n// 39. Tooltips settings\n\n$tooltip-font-size:                             $font-size-sm !default;\n$tooltip-max-width:                             200px !default;\n$tooltip-color:                                 var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                                    var(--#{$prefix}inverse) !default;\n$tooltip-border-radius:                         var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                               .9 !default;\n$tooltip-padding-y:                             $spacer * .25 !default;\n$tooltip-padding-x:                             $spacer * .5 !default;\n$tooltip-arrow-width:                           .8rem !default;\n$tooltip-arrow-height:                          .4rem !default;\n$form-feedback-tooltip-padding-y:               $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:               $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:               $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:             null !default;\n$form-feedback-tooltip-opacity:                 $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius:           $tooltip-border-radius !default;\n\n\n\n// 40. Popovers\n\n$popover-font-size:                             $font-size-sm !default;\n$popover-bg:                                    var(--#{$prefix}body-bg) !default;\n$popover-max-width:                             276px !default;\n$popover-border-width:                          var(--#{$prefix}border-width) !default;\n$popover-border-color:                          var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:                         var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:                   calc($popover-border-radius - $popover-border-width) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                            $box-shadow !default;\n$popover-header-font-size:                      $font-size-base !default;\n$popover-header-bg:                             var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:                          $headings-color !default;\n$popover-header-padding-y:                      .5rem !default;\n$popover-header-padding-x:                      $spacer !default;\n$popover-body-color:                            var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:                        $spacer !default;\n$popover-body-padding-x:                        $spacer !default;\n$popover-arrow-width:                           1rem !default;\n$popover-arrow-height:                          .5rem !default;\n\n\n\n// 41. Modals settings\n\n$modal-inner-padding:                           $spacer !default;\n$modal-footer-margin-between:                   .5rem !default;\n$modal-dialog-margin:                           .5rem !default;\n$modal-dialog-margin-y-sm-up:                   1.75rem !default;\n$modal-title-line-height:                       $line-height-base !default;\n$modal-content-color:                           null !default;\n$modal-content-bg:                              var(--#{$prefix}app-header-bg) !default;\n$modal-content-border-color:                    var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:                    var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:                   0 !default;\n$modal-content-inner-border-radius:             0 !default;\n$modal-content-box-shadow-xs:                   $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:                $box-shadow !default;\n$modal-backdrop-bg:                             #e6e6e6 !default;\n$modal-backdrop-opacity:                        .95 !default;\n$modal-header-border-color:                     var(--#{$prefix}border-color) !default;\n$modal-header-border-width:                     $modal-content-border-width !default;\n$modal-header-padding-y:                        $modal-inner-padding !default;\n$modal-header-padding-x:                        $modal-inner-padding !default;\n$modal-header-padding:                          $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n$modal-footer-bg:                               null !default;\n$modal-footer-border-color:                     $modal-header-border-color !default;\n$modal-footer-border-width:                     $modal-header-border-width !default;\n$modal-sm:                                      300px !default;\n$modal-md:                                      500px !default;\n$modal-lg:                                      800px !default;\n$modal-xl:                                      1140px !default;\n$modal-fade-transform:                          translate(0, -50px) !default;\n$modal-show-transform:                          none !default;\n$modal-transition:                              transform .3s ease-out !default;\n$modal-scale-transform:                         scale(1.02) !default;\n\n\n\n// 42. Offcanvas\n\n$offcanvas-padding-y:                           $modal-inner-padding !default;\n$offcanvas-padding-x:                           $modal-inner-padding !default;\n$offcanvas-horizontal-width:                    400px !default;\n$offcanvas-vertical-height:                     30vh !default;\n$offcanvas-transition-duration:                 .3s !default;\n$offcanvas-border-color:                        $modal-content-border-color !default;\n$offcanvas-border-width:                        $modal-content-border-width !default;\n$offcanvas-title-line-height:                   $modal-title-line-height !default;\n$offcanvas-bg-color:                            var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                               var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:                          $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:                         $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:                    $modal-backdrop-opacity !default;\n\n\n\n// 43. Toasts settings\n\n$toast-max-width:                               350px !default;\n$toast-padding-x:                               .75rem !default;\n$toast-padding-y:                               .5rem !default;\n$toast-font-size:                               .875rem !default;\n$toast-color:                                   null !default;\n$toast-background-color:                        rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                            var(--#{$prefix}border-width) !default;\n$toast-border-color:                            var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:                           var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                              var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                                 $container-padding-x !default;\n$toast-header-color:                            var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:                 rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:                     $toast-border-color !default;\n\n\n\n// 44. Accordion settings\n\n$accordion-padding-y:                           1rem !default;\n$accordion-padding-x:                           1.25rem !default;\n$accordion-color:                               var(--#{$prefix}body-color) !default; // Sass variable because of $accordion-button-icon\n$accordion-bg:                                  var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                        var(--#{$prefix}border-width) !default;\n$accordion-border-color:                        var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                       var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:                 subtract($accordion-border-radius, $accordion-border-width) !default;\n$accordion-body-padding-y:                      $accordion-padding-y !default;\n$accordion-body-padding-x:                      $accordion-padding-x !default;\n$accordion-button-padding-y:                    $accordion-padding-y !default;\n$accordion-button-padding-x:                    $accordion-padding-x !default;\n$accordion-button-color:                        var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                           var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                          $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:                    rgba(var(--#{$prefix}theme-rgb), .15) !default;\n$accordion-button-active-color:                 var(--#{$prefix}inverse) !default;\n$accordion-button-focus-border-color:           $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:             $btn-focus-box-shadow !default;\n$accordion-icon-width:                          1.25rem !default;\n$accordion-icon-color:                          $body-color !default;\n$accordion-icon-active-color:                   $body-color !default;\n$accordion-icon-transition:                     transform .2s ease-in-out !default;\n$accordion-icon-transform:                      rotate(-180deg) !default;\n$accordion-button-icon:                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:                  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n\n\n// 45. Tables settings\n\n$table-cell-padding-y:                          .5rem !default;\n$table-cell-padding-x:                          .5rem !default;\n$table-cell-padding-y-sm:                       .25rem !default;\n$table-cell-padding-x-sm:                       .25rem !default;\n$table-cell-vertical-align:                     top !default;\n$table-color:                                   var(--#{$prefix}body-color) !default;\n$table-bg:                                      transparent !default;\n$table-accent-bg:                               transparent !default;\n$table-th-font-weight:                          null !default;\n$table-striped-color:                           $table-color !default;\n$table-striped-bg-factor:                       .1 !default;\n$table-striped-bg:                              rgba(var(--#{$prefix}inverse-rgb), $table-striped-bg-factor) !default;\n$table-active-color:                            $table-color !default;\n$table-active-bg-factor:                        .1 !default;\n$table-active-bg:                               rgba(var(--#{$prefix}inverse-rgb), $table-active-bg-factor) !default;\n$table-hover-color:                             $table-color !default;\n$table-hover-bg-factor:                         .075 !default;\n$table-hover-bg:                                rgba(var(--#{$prefix}inverse-rgb), $table-hover-bg-factor) !default;\n$table-border-factor:                           .1 !default;\n$table-border-width:                            var(--#{$prefix}border-width) !default;\n$table-border-color:                            var(--#{$prefix}border-color) !default;\n$table-striped-order:                           odd !default;\n$table-striped-columns-order:                   even !default;\n$table-group-separator-color:                   currentcolor !default;\n$table-caption-color:                           $text-muted !default;\n$table-bg-scale:                                -80% !default;\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n\n\n\n// 46. Dropdown settings\n\n$dropdown-min-width:                            10rem !default;\n$dropdown-padding-x:                            0 !default;\n$dropdown-padding-y:                            .5rem !default;\n$dropdown-spacer:                               .125rem !default;\n$dropdown-font-size:                            $font-size-base !default;\n$dropdown-color:                                var(--#{$prefix}body-color) !default;\n$dropdown-bg:                                   rgba(var(--#{$prefix}body-bg-rgb), .98) !default;\n$dropdown-border-color:                         var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:                        0 !default;\n$dropdown-border-width:                         var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:                  calc($dropdown-border-radius - $dropdown-border-width) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:                           $dropdown-border-color !default;\n$dropdown-divider-margin-y:                     $spacer * .5 !default;\n$dropdown-box-shadow:                           $box-shadow !default;\n$dropdown-link-color:                           var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:                     $dropdown-link-color !default;\n$dropdown-link-hover-bg:                        rgba(var(--#{$prefix}body-color-rgb), .15) !default;\n$dropdown-link-active-color:                    $component-active-color !default;\n$dropdown-link-active-bg:                       $component-active-bg !default;\n$dropdown-link-disabled-color:                  $gray-500 !default;\n$dropdown-item-padding-y:                       rem(6px) !default;\n$dropdown-item-padding-x:                       $spacer !default;\n$dropdown-header-color:                         rgba(var(--#{$prefix}body-color-rgb), .5) !default;\n$dropdown-header-padding-x:                     $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:                     $dropdown-padding-y !default;\n\n\n\n// 47. List group settings\n\n$list-group-color:                              var(--#{$prefix}body-color) !default;\n$list-group-bg:                                 transparent !default;\n$list-group-border-color:                       var(--#{$prefix}border-color) !default;\n$list-group-border-width:                       var(--#{$prefix}border-width) !default;\n$list-group-border-radius:                      var(--#{$prefix}border-radius) !default;\n$list-group-item-padding-y:                     $spacer * .5 !default;\n$list-group-item-padding-x:                     $spacer !default;\n$list-group-hover-bg:                           var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:                       $component-active-color !default;\n$list-group-active-bg:                          $component-active-bg !default;\n$list-group-active-border-color:                $list-group-active-bg !default;\n$list-group-disabled-color:                     var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:                        $list-group-bg !default;\n$list-group-action-color:                       var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:                 var(--#{$prefix}inverse) !default;\n$list-group-action-active-color:                var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:                   var(--#{$prefix}secondary-bg) !default;\n\n\n\n// 48. Nav settings\n\n$nav-link-padding-y:                            .5rem !default;\n$nav-link-padding-x:                            1rem !default;\n$nav-link-font-size:                            null !default;\n$nav-link-font-weight:                          null !default;\n$nav-link-color:                                var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:                          var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:                           color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:                       var(--#{$prefix}secondary-color) !default;\n$nav-tabs-border-color:                         var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:                         var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:                        var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:              var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:                    var(--#{$prefix}inverse) !default;\n$nav-tabs-link-active-bg:                       transparent !default;\n$nav-tabs-link-active-border-color:             var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n$nav-pills-border-radius:                       $border-radius !default;\n$nav-pills-link-active-color:                   $component-active-color !default;\n$nav-pills-link-active-bg:                      $component-active-bg !default;\n\n\n\n// 49. Navbar settings\n\n$navbar-padding-y:                              $spacer * .5 !default;\n$navbar-padding-x:                              null !default;\n$navbar-nav-link-padding-x:                     .5rem !default;\n$navbar-brand-font-size:                        $font-size-lg !default;\n$nav-link-height:                               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:                           $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:                        ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:                       1rem !default;\n$navbar-toggler-padding-y:                      .25rem !default;\n$navbar-toggler-padding-x:                      .75rem !default;\n$navbar-toggler-font-size:                      $font-size-lg !default;\n$navbar-toggler-border-radius:                  $btn-border-radius !default;\n$navbar-toggler-focus-width:                    $btn-focus-width !default;\n$navbar-toggler-transition:                     box-shadow .15s ease-in-out !default;\n$navbar-light-color:                            rgba(var(--#{$prefix}inverse-rgb), .65) !default;\n$navbar-light-hover-color:                      rgba(var(--#{$prefix}inverse-rgb), .8) !default;\n$navbar-light-active-color:                     rgba(var(--#{$prefix}inverse-rgb), 1) !default;\n$navbar-light-disabled-color:                   rgba(var(--#{$prefix}inverse-rgb), .3) !default;\n$navbar-light-toggler-icon-bg:                  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{rgba($body-color, .75)}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color:             rgba(var(--#{$prefix}inverse-rgb), .15) !default;\n$navbar-light-brand-color:                      $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:                $navbar-light-active-color !default;\n\n\n\n// 50. Pagination settings\n\n$pagination-padding-y:                          .375rem !default;\n$pagination-padding-x:                          .75rem !default;\n$pagination-padding-y-sm:                       .25rem !default;\n$pagination-padding-x-sm:                       .5rem !default;\n$pagination-padding-y-lg:                       .75rem !default;\n$pagination-padding-x-lg:                       1.5rem !default;\n$pagination-font-size:                          $font-size-base !default;\n$pagination-color:                              var(--#{$prefix}inverse) !default;\n$pagination-bg:                                 transparent !default;\n$pagination-border-radius:                      var(--#{$prefix}border-radius) !default;\n$pagination-border-width:                       var(--#{$prefix}border-width) !default;\n$pagination-margin-start:                       calc($pagination-border-width * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:                       var(--#{$prefix}border-color) !default;\n$pagination-focus-color:                        var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:                           var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:                   $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:                      0 !default;\n$pagination-hover-color:                        var(--#{$prefix}inverse) !default;\n$pagination-hover-bg:                           rgba(var(--#{$prefix}inverse-rgb), .1) !default;\n$pagination-hover-border-color:                 var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n$pagination-active-color:                       var(--#{$prefix}theme-color) !default;\n$pagination-active-bg:                          var(--#{$prefix}theme) !default;\n$pagination-active-border-color:                var(--#{$prefix}theme) !default;\n$pagination-disabled-color:                     rgba(var(--#{$prefix}inverse-rgb), .35) !default;\n$pagination-disabled-bg:                        rgba(var(--#{$prefix}inverse-rgb), .1) !default;\n$pagination-disabled-border-color:              var(--#{$prefix}border-color) !default;\n$pagination-transition:                         color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n$pagination-border-radius-sm:                   $border-radius-sm !default;\n$pagination-border-radius-lg:                   $border-radius-lg !default;\n\n\n\n// 51. Z-index settings\n\n$zindex-dropdown:                               1000 !default;\n$zindex-sticky:                                 1020 !default;\n$zindex-fixed:                                  1030 !default;\n$zindex-offcanvas-backdrop:                     1040 !default;\n$zindex-offcanvas:                              1045 !default;\n$zindex-modal-backdrop:                         1050 !default;\n$zindex-modal:                                  1055 !default;\n$zindex-popover:                                1070 !default;\n$zindex-tooltip:                                1130 !default;\n$zindex-toast:                                  1090 !default;\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n\n\n\n// 52. Badges settings\n\n$badge-font-size:                               .75em !default;\n$badge-font-weight:                             $font-weight-bold !default;\n$badge-color:                                   $white !default;\n$badge-padding-y:                               .35em !default;\n$badge-padding-x:                               .65em !default;\n$badge-border-radius:                           $border-radius !default;\n\n\n\n// 53. Position settings\n\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n\n\n\n// 54. Image thumbnails settings\n\n$thumbnail-padding:                             .25rem !default;\n$thumbnail-bg:                                  var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:                        var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:                        var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:                       var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:                          var(--#{$prefix}box-shadow-sm) !default;\n\n\n\n// 55. Figures settings\n\n$figure-caption-font-size:                      $small-font-size !default;\n$figure-caption-color:                          var(--#{$prefix}secondary-color) !default;\n\n\n\n// 56. Carousel settings\n\n$carousel-control-color:                        $white !default;\n$carousel-control-width:                        15% !default;\n$carousel-control-opacity:                      .5 !default;\n$carousel-control-hover-opacity:                .9 !default;\n$carousel-control-transition:                   opacity .15s ease !default;\n$carousel-indicator-width:                      30px !default;\n$carousel-indicator-height:                     3px !default;\n$carousel-indicator-hit-area-height:            10px !default;\n$carousel-indicator-spacer:                     3px !default;\n$carousel-indicator-opacity:                    .5 !default;\n$carousel-indicator-active-bg:                  $white !default;\n$carousel-indicator-active-opacity:             1 !default;\n$carousel-indicator-transition:                 opacity .6s ease !default;\n$carousel-caption-width:                        70% !default;\n$carousel-caption-color:                        $white !default;\n$carousel-caption-padding-y:                    1.25rem !default;\n$carousel-caption-spacer:                       1.25rem !default;\n$carousel-control-icon-width:                   2rem !default;\n$carousel-control-prev-icon-bg:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$carousel-transition-duration:                  .6s !default;\n$carousel-transition:                           transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n$carousel-dark-indicator-active-bg:             $black !default;\n$carousel-dark-caption-color:                   $black !default;\n$carousel-dark-control-icon-filter:             invert(1) grayscale(100) !default;\n\n\n\n// 57. Spinners settings\n\n$spinner-width:                                 2rem !default;\n$spinner-height:                                $spinner-width !default;\n$spinner-vertical-align:                        -.125em !default;\n$spinner-border-width:                          .25em !default;\n$spinner-animation-speed:                       .75s !default;\n$spinner-width-sm:                              1rem !default;\n$spinner-height-sm:                             $spinner-width-sm !default;\n$spinner-border-width-sm:                       .2em !default;\n\n\n\n// 58. Code settings\n\n$code-font-size:                               $small-font-size !default;\n$code-color:                                   $pink !default;\n$kbd-padding-y:                                .1875rem !default;\n$kbd-padding-x:                                .375rem !default;\n$kbd-font-size:                                $code-font-size !default;\n$kbd-color:                                    var(--#{$prefix}body-bg) !default;\n$kbd-bg:                                       var(--#{$prefix}body-color) !default;\n$pre-color:                                    null !default;","/*\n   Dark color mode variables\n\t\n   01. Color system \n   02. Body setting\n   03. Font & headings settings\n   04. Border settings\n   05. Component settings\n   06. App - Header settings\n   07. App - Sidebar settings\n   08. App - Theme panel settings\n   09. Form switch settings\n   10. Form select settings\n   11. Form check settings\n   12. Accordion settings\n   13. Modal settings\n*/\n\n\n// 01. Color system \n\n$white:        #FFFFFF !default;\n$gray-500:     #617a86 !default;\n$gray-100:     mix(#fff, $gray-500, 60%) !default;\n$gray-200:     mix(#fff, $gray-500, 45%) !default;\n$gray-300:     mix(#fff, $gray-500, 30%) !default;\n$gray-400:     mix(#fff, $gray-500, 15%) !default;\n$gray-500:     #617a86 !default;\n$gray-600:     mix(#000, $gray-500, 15%) !default;\n$gray-700:     mix(#000, $gray-500, 30%) !default;\n$gray-800:     mix(#000, $gray-500, 45%) !default;\n$gray-900:     mix(#000, $gray-500, 60%) !default;\n$yellow-dark:       #f9e80d !default;\n$orange-dark:       #ff9f0c !default;\n$aqua-dark:         #0cfff5 !default;\n$blue-dark:         #4e9cff !default;\n$indigo-dark:       #bba4ff !default;\n$purple-dark:       #de8cff !default;\n$red-dark:          #ff6060 !default;\n$teal-dark:         #3cd2a5 !default;\n$green-dark:        #1ecc33 !default;\n$lime-dark:         #81f32d !default;\n$pink-dark:         #f34fa0 !default;\n$cyan-dark:         #30beff !default;\n$default-dark:      $gray-200 !default;\n$dark-dark:         $gray-800 !default;\n$black-dark:        #000000 !default;\n$light-dark:        $gray-100 !default;\n$primary-dark:      $blue-dark !default;\n$warning-dark:      $orange-dark !default;\n$danger-dark:       $red-dark !default;\n$success-dark:      $teal-dark !default;\n$info-dark:         $cyan-dark !default;\n$secondary-dark:    $gray-400 !default;\n$text-muted-dark:   $gray-400 !default;\n$inverse-dark:      $white !default;\n$theme-dark:        $teal-dark !default;\n$theme-colors-dark: (\n\t\"default\":   $default-dark,\n\t\"theme\":     $theme-dark,\n\t\"primary\":   $primary-dark,\n\t\"secondary\": $secondary-dark,\n\t\"warning\":   $warning-dark,\n\t\"danger\":    $danger-dark,\n\t\"success\":   $success-dark,\n\t\"inverse\":   $inverse-dark,\n\t\"info\":      $info-dark,\n\t\"dark\":      $dark-dark,\n\t\"black\":     $black-dark,\n\t\"white\":     $white,\n\t\"purple\":    $purple-dark,\n\t\"indigo\":    $indigo-dark,\n\t\"red\":       $red-dark,\n\t\"pink\":      $pink-dark,\n\t\"green\":     $green-dark,\n\t\"yellow\":    $yellow-dark,\n\t\"teal\":      $teal-dark,\n\t\"muted\":     $gray-500,\n  \"light\":     $light-dark,\n  \"lime\":      $lime-dark,\n\t\"gray-100\":  $gray-100,\n\t\"gray-200\":  $gray-200,\n\t\"gray-300\":  $gray-300,\n\t\"gray-400\":  $gray-400,\n\t\"gray-500\":  $gray-500,\n\t\"gray-600\":  $gray-600,\n\t\"gray-700\":  $gray-700,\n\t\"gray-800\":  $gray-800,\n\t\"gray-900\":  $gray-900\n);\n\n$primary-text-dark:                             $blue-300 !default;\n$secondary-text-dark:                           $gray-300 !default;\n$success-text-dark:                             $green-300 !default;\n$info-text-dark:                                $cyan-300 !default;\n$warning-text-dark:                             $yellow-300 !default;\n$danger-text-dark:                              $red-300 !default;\n$light-text-dark:                               $gray-100 !default;\n$dark-text-dark:                                $gray-300 !default;\n\n$primary-bg-subtle-dark:                        $blue-900 !default;\n$secondary-bg-subtle-dark:                      $gray-900 !default;\n$success-bg-subtle-dark:                        $green-900 !default;\n$info-bg-subtle-dark:                           $cyan-900 !default;\n$warning-bg-subtle-dark:                        $yellow-900 !default;\n$danger-bg-subtle-dark:                         $red-900 !default;\n$light-bg-subtle-dark:                          $gray-800 !default;\n$dark-bg-subtle-dark:                           mix($gray-800, $black) !default;\n\n$primary-border-subtle-dark:                    $blue-700 !default;\n$secondary-border-subtle-dark:                  $gray-700 !default;\n$success-border-subtle-dark:                    $green-700 !default;\n$info-border-subtle-dark:                       $cyan-800 !default;\n$warning-border-subtle-dark:                    $yellow-800 !default;\n$danger-border-subtle-dark:                     $red-700 !default;\n$light-border-subtle-dark:                      $gray-700 !default;\n$dark-border-subtle-dark:                       $gray-800 !default;\n\n\n\n// 02. Body setting\n\n$body-font-weight-dark:                         300 !default;\n$body-letter-spacing-dark:                      rem(.75px) !default;\n$body-bg-dark:                                  #1d2835 !default;\n$body-bg-gradient-dark:                         linear-gradient(180deg, rgba(50,70,80,.9) 0%, rgba(13,16,27,1) 100%) !default;\n$body-bg-cover-dark:                            url('images/cover-dark.jpg') !default;\n$body-bg-image-dark:                            url('images/pattern-dark.png') !default;\n$body-bg-image-size-dark:                       rem(75px) !default;\n$body-color-dark:                               rgba($white, .75) !default;\n$body-emphasis-color-dark:                      $gray-100 !default;\n$body-secondary-color-dark:                     rgba($body-color-dark, .75) !default;\n$body-secondary-bg-dark:                        $gray-800 !default;\n$body-tertiary-color-dark:                      rgba($body-color-dark, .5) !default;\n$body-tertiary-bg-dark:                         rgba($body-color, .1) !default;\n$emphasis-color-dark:                           $white !default;\n\n\n\n// 03. Font & headings settings\n\n$headings-color-dark:                           #fff !default;\n$link-color-dark:                               $blue-300 !default;\n$link-hover-color-dark:                         $blue-200 !default;\n$code-color-dark:                               $pink-300 !default;\n\n\n\n// 04. Border settings\n\n$border-color-dark:                             rgba($white, .25) !default;\n$border-color-translucent-dark:                 rgba($white, .25) !default;\n\n\n\n// 05. Component settings\n\n$component-bg-dark:                             #28292b !default;\n$component-color-dark:                          $body-color-dark !default;\n\n\n\n// 06. App - Header settings\n\n$app-header-bg-dark:                            rgba(29, 40, 53, .95) !default;\n$app-header-brand-img-dark:                     url('images/logo-dark.png') !default;\n$app-header-link-color-dark:                    $white !default;\n$app-header-link-hover-color-dark:              rgba($white, .5) !default;\n$app-header-scroll-box-shadow-dark:             null !default;\n\n\n\n// 07. App - Sidebar settings\n\n$app-sidebar-menu-header-color-dark:            rgba(var(--#{$prefix}inverse-rgb), .3) !default;\n$app-sidebar-menu-link-color-dark:              rgba(var(--#{$prefix}inverse-rgb), .5) !default;\n$app-sidebar-menu-link-hover-color-dark:        $white !default;\n$app-sidebar-menu-link-active-color-dark:       $white !default;\n$app-sidebar-mobile-bg-dark:                    rgba(44, 56, 70, .98) !default;\n\n\n\n// 08. App - Top Nav settings\n\n$app-top-nav-bg-dark:                           rgba(29, 40, 53, .95) !default;\n$app-top-nav-menu-link-color-dark:              rgba(var(--#{$prefix}inverse-rgb), .5) !default;\n$app-top-nav-menu-link-hover-color-dark:        $white !default;\n$app-top-nav-menu-link-active-color-dark:       $white !default;\n$app-top-nav-menu-submenu-bg-dark:              rgba(29, 40, 53, .95) !default;\n\n\n// 08. App - Theme panel settings\n\n$app-theme-panel-bg-dark:                       rgba($gray-700, .95) !default;\n$app-theme-panel-color-dark:                   \t$white !default;\n\n\n\n// 09. Form switch settings\n\n$form-switch-color-dark:                        rgba($white, .25) !default;\n$form-switch-bg-image-dark:                     url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-dark}'/></svg>\") !default;\n$form-switch-focus-color-dark:                  rgba($white, .25) !default;\n$form-switch-focus-bg-image-dark:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color-dark}'/></svg>\") !default;\n$form-switch-checked-color-dark:                $black !default;\n$form-switch-checked-bg-image-dark:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color-dark}'/></svg>\") !default;\n\n\n\n// 10. Form select settings\n\n$form-select-indicator-color-dark:              $body-color-dark !default;\n$form-select-indicator-dark:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n\n\n// 11. Form check settings\n\n$form-check-input-checked-color-dark:           $black !default;\n$form-check-input-checked-bg-image-dark:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image-dark:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color-dark}'/></svg>\") !default;\n\n\n\n// 12. Accordion settings\n\n$accordion-button-icon-dark:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$body-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon-dark:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$body-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n\n\n// 13. Modal settings\n\n$modal-backdrop-bg-dark:                        #1d2835 !default;","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n",":root,\n[data-bs-theme=\"light\"] {\n\t--#{$prefix}body-bg-gradient: #{$body-bg-gradient};\n\t--#{$prefix}body-bg-image: #{$body-bg-image};\n\t--#{$prefix}body-bg-image-size: #{$body-bg-image-size};\n\t--#{$prefix}body-bg-cover: #{$body-bg-cover};\n\t--#{$prefix}body-font-weight: #{$body-font-weight};\n\t--#{$prefix}body-letter-spacing: #{$body-letter-spacing};\n  --#{$prefix}component-bg: #{$component-bg};\n  --#{$prefix}component-bg-rgb: #{to-rgb($component-bg)};\n  --#{$prefix}component-color: #{$component-color};\n  --#{$prefix}component-color-rgb: #{to-rgb($component-color)};\n  --#{$prefix}app-header-bg: #{$app-header-bg};\n  --#{$prefix}app-header-brand-img: #{$app-header-brand-img};\n  --#{$prefix}app-header-link-color: #{$app-header-link-color};\n  --#{$prefix}app-header-link-color-rgb: #{to-rgb($app-header-link-color)};\n  --#{$prefix}app-header-link-hover-color: #{$app-header-link-hover-color};\n  --#{$prefix}app-header-scroll-box-shadow: #{$app-header-scroll-box-shadow};\n\t--#{$prefix}app-sidebar-menu-header-color: #{$app-sidebar-menu-header-color};\n  --#{$prefix}app-sidebar-menu-link-color: #{$app-sidebar-menu-link-color};\n  --#{$prefix}app-sidebar-menu-link-hover-color: #{$app-sidebar-menu-link-hover-color};\n  --#{$prefix}app-sidebar-menu-link-active-color: #{$app-sidebar-menu-link-active-color};\n  --#{$prefix}app-sidebar-mobile-bg: #{$app-sidebar-mobile-bg};\n  --#{$prefix}app-top-nav-bg: #{$app-top-nav-bg};\n  --#{$prefix}app-top-nav-menu-link-color: #{$app-top-nav-menu-link-color};\n  --#{$prefix}app-top-nav-menu-link-hover-color: #{$app-top-nav-menu-link-hover-color};\n  --#{$prefix}app-top-nav-menu-link-active-color: #{$app-top-nav-menu-link-active-color};\n  --#{$prefix}app-top-nav-menu-submenu-bg: #{$app-top-nav-menu-submenu-bg};\n  --#{$prefix}app-theme-panel-bg: #{$app-theme-panel-bg};\n  --#{$prefix}theme-bg-subtle: #{tint-color($theme, 80%)};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t--#{$prefix}body-bg-gradient: #{$body-bg-gradient-dark};\n\t\t--#{$prefix}body-bg-image: #{$body-bg-image-dark};\n\t\t--#{$prefix}body-bg-image-size: #{$body-bg-image-size-dark};\n\t\t--#{$prefix}body-bg-cover: #{$body-bg-cover-dark};\n\t\t--#{$prefix}body-font-weight: #{$body-font-weight-dark};\n\t\t--#{$prefix}body-letter-spacing: #{$body-letter-spacing-dark};\n\t\t--#{$prefix}component-bg: #{$component-bg-dark};\n\t\t--#{$prefix}component-bg-rgb: #{to-rgb($component-bg-dark)};\n\t\t--#{$prefix}component-color: #{$component-color-dark};\n\t\t--#{$prefix}component-color-rgb: #{to-rgb($component-color-dark)};\n\t\t--#{$prefix}app-header-bg: #{$app-header-bg-dark};\n\t\t--#{$prefix}app-header-brand-img: #{$app-header-brand-img-dark};\n\t\t--#{$prefix}app-header-link-color: #{$app-header-link-color-dark};\n\t\t--#{$prefix}app-header-link-color-rgb: #{to-rgb($app-header-link-color-dark)};\n  \t--#{$prefix}app-header-link-hover-color: #{$app-header-link-hover-color-dark};\n  \t--#{$prefix}app-header-scroll-box-shadow: #{$app-header-scroll-box-shadow-dark};\n\t\t--#{$prefix}app-sidebar-menu-header-color: #{$app-sidebar-menu-header-color-dark};\n\t\t--#{$prefix}app-sidebar-menu-link-color: #{$app-sidebar-menu-link-color-dark};\n\t\t--#{$prefix}app-sidebar-menu-link-hover-color: #{$app-sidebar-menu-link-hover-color-dark};\n\t\t--#{$prefix}app-sidebar-menu-link-active-color: #{$app-sidebar-menu-link-active-color-dark};\n  \t--#{$prefix}app-sidebar-mobile-bg: #{$app-sidebar-mobile-bg-dark};\n\t\t--#{$prefix}app-top-nav-bg: #{$app-top-nav-bg-dark};\n\t\t--#{$prefix}app-top-nav-menu-link-color: #{$app-top-nav-menu-link-color-dark};\n\t\t--#{$prefix}app-top-nav-menu-link-hover-color: #{$app-top-nav-menu-link-hover-color-dark};\n\t\t--#{$prefix}app-top-nav-menu-link-active-color: #{$app-top-nav-menu-link-active-color-dark};\n    --#{$prefix}app-top-nav-menu-submenu-bg: #{$app-top-nav-menu-submenu-bg-dark};\n  \t--#{$prefix}app-theme-panel-bg: #{$app-theme-panel-bg-dark};\n  \t--#{$prefix}theme-bg-subtle: #{shade-color($theme, 80%)};\n  }\n}\n","html {\n\theight: 100%;\n\tbackground-color: var(--#{$prefix}body-bg);\n\tbackground-image: var(--#{$prefix}body-bg-gradient);\n\t\n\t&:before {\n    content: '';\n\t\tposition:fixed;\n\t\ttop:0;\n\t\tleft:0;\n\t\tright:0;\n\t\theight:100%;\n\t\tz-index:-5; \n\t\tbackground: var(--#{$prefix}body-bg-gradient);\n\t}\n\t&:after {\n\t\tcontent: '';\n\t\tposition:fixed;\n\t\ttop:0;\n\t\theight:100%;\n\t\tleft:0;\n\t\tright:0;\n\t\tz-index:-10; \n\t\tbackground-color: var(--#{$prefix}body-bg);\n\t\tbackground-image: var(--#{$prefix}body-bg-gradient);\n\t\tbackground-image: var(--#{$prefix}body-bg-cover);\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: center;\n\t\tbackground-attachment: initial;\n\t\theight: 100%;\n\t\ttransition: background .2s linear;\n\t\tbackground-size: cover;\n\t}\n}\nbody {\n\tbackground: none;\n\tfont-weight: var(--#{$prefix}body-font-weight);\n\tletter-spacing: var(--#{$prefix}body-letter-spacing);\n\tposition: relative;\n\tmin-height: 100vh;\n\tz-index: 9999;\n\t\n\t@if ($enable-rtl) {\n\t\tdirection: rtl;\n\t}\n\t\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\theight: 100%;\n\t\tbackground-attachment: initial;\n\t\tbackground-color: transparent;\n\t\tbackground-image: var(--#{$prefix}body-bg-image);\n\t\tbackground-size: var(--#{$prefix}body-bg-image-size);\n\t\tbackground-repeat: repeat;\n\t\tbackground-attachment: initial;\n\t\tz-index: -5;\n\t}\n\t&:not(.app-init) * {\n\t\ttransition: none !important;\n\t\tanimation: none !important;\n\t}\n}","/* Helper Margin */\n@include helper-spacing('', 'margin', 'm');\n@include helper-spacing('top', 'margin', 'mt');\n@include helper-spacing('right', 'margin', 'me');\n@include helper-spacing('bottom', 'margin', 'mb');\n@include helper-spacing('left', 'margin', 'ms');\n@include helper-spacing('mx', 'margin', 'mx');\n@include helper-spacing('my', 'margin', 'my');\n\n\n/* Helper Padding */\n@include helper-spacing('', 'padding', 'p');\n@include helper-spacing('top', 'padding', 'pt');\n@include helper-spacing('right', 'padding', 'pe');\n@include helper-spacing('bottom', 'padding', 'pb');\n@include helper-spacing('left', 'padding', 'ps');\n@include helper-spacing('px', 'padding', 'px');\n@include helper-spacing('py', 'padding', 'py');\n\n/* Helper Font */\n@include helper-font-size(0, 80);\n@include helper-font-weight(1, 8);\n\n/* Helper Position Direction */\n.top-0 { top: 0 !important; }\n.bottom-0 { bottom: 0 !important; }\n.start-0 { left: 0 !important; }\n.end-0 { right: 0 !important; }\n.top-auto { top: auto !important; }\n.bottom-auto { bottom: auto !important; }\n.start-auto { left: auto !important; }\n.end-auto { right: auto !important; }\n\n/* Helper Text */\n.text-underline { text-decoration: underline !important; }\n.text-gradient { -webkit-background-clip: text !important; -webkit-text-fill-color: transparent !important; }\n.line-height-1 { line-height: 1 !important; }\n\n/* Helper Size */\n@include helper-size('w', 'width');\n@include helper-size('h', 'height');\n\n/* Helper Color */\n@each $color, $value in $theme-colors {\n\t@include helper-color($color, $value);\n}\n@each $color, $value in $colors {\n\t@include helper-color($color, $value);\n}\n\n@if $enable-dark-mode {\n\t@include color-mode(dark, true) {\n\t\t@each $color, $value in $theme-colors-dark {\n\t\t\t--#{$prefix}#{$color}: #{$value};\n\t\t\t--#{$prefix}#{$color}-rgb: #{to-rgb($value)};\n\t\t\t\n\t\t\t@include helper-color-dark($color, $value);\n\t\t}\n\t}\n}\n.bg-none { background: none !important; }\n.bg-position-center { background-position: center !important; }\n.bg-size-cover { background-size: cover !important; }\n.bg-repeat-no-repeat { background-repeat: no-repeat !important; }\n@include background-gradient('bg-gradient-orange-red', lighten($orange, 10%), lighten($red, 10%));\n@include background-gradient('bg-gradient-red-orange', lighten($red, 10%), lighten($orange, 10%));\n@include background-gradient('bg-gradient-red-pink', lighten($red, 10%), lighten($pink, 10));\n@include background-gradient('bg-gradient-yellow-orange', lighten($yellow, 10%), lighten($orange, 10%));\n@include background-gradient('bg-gradient-yellow-red', lighten($yellow, 10%), lighten($red, 10%));\n@include background-gradient('bg-gradient-yellow-green', lighten($yellow, 10%), lighten($green, 10%));\n@include background-gradient('bg-gradient-blue-indigo', $blue, $indigo);\n@include background-gradient('bg-gradient-blue-cyan', $blue, $cyan);\n@include background-gradient('bg-gradient-cyan-blue', $cyan, $blue);\n@include background-gradient('bg-gradient-cyan-indigo', $cyan, $indigo);\n@include background-gradient('bg-gradient-indigo-blue', $indigo, $blue);\n@include background-gradient('bg-gradient-custom-orange', lighten(mix($pink, $orange, 50%), 6%), lighten(mix($pink, $orange, 50%), 13%), right);\n@include background-gradient('bg-gradient-custom-pink', lighten(mix($black, $pink, 20%), 14%), lighten(mix($black, $pink, 20%), 21%), right);\n@include background-gradient('bg-gradient-custom-teal', mix($black, $teal, 18%), $teal, right);\n@include background-gradient('bg-gradient-custom-indigo', lighten(mix($black, $indigo, 5%), 14%), lighten(mix($black, $indigo, 5%), 25%), right);\n@include background-gradient('bg-gradient-custom-blue', $blue, lighten($blue, 10%), right);\n.bg-gradient-indigo-teal {\n  background-image: linear-gradient(to left, $indigo, $blue, $teal) !important;\n}\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n  \t.invert-dark {\n  \t\tfilter: invert(1);\n  \t}\n  }\n}\n\n\n/* Helper Opacity */\n@include helper-opacity(0, 10);\n\n/* Helper Sticky Top */\n.desktop-sticky-top {\n\t@include media-breakpoint-up(xl) {\n\t\tposition: sticky;\n\t\ttop: $app-header-height + rem(20px);\n\t}\n}\n\n/* Helper Outline */\n.outline-none { outline: none !important }\n\n\n@for $i from 2 through 9 {\n\t.bg-cover-#{$i}:after {\n\t\tbackground-image: url('images/cover-#{$i}.jpg');\n\t}\n\t.bg-cover-none:after {\n\t\tbackground-color: var(--#{$prefix}body-bg);\n\t}\n\t@if $enable-dark-mode {\n\t\t@include color-mode(dark, true) {\n\t\t\t&.bg-cover-#{$i}:after {\n\t\t\t\tbackground-image: url('images/cover-#{$i}-dark.jpg');\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Helper Flex */\n.flex-1 {\n\tflex: 1 !important;\n}\n\n/* Helper Theme */\n.list-group-item.active,\n.page-item.active .page-link,\n.form-check-input:checked,\n.nav-pills .nav-link.active, \n.nav-pills .show>.nav-link {\n\tbackground-color: var(--#{$prefix}theme);\n\tborder-color: var(--#{$prefix}theme);\n}\n.btn-theme {\n\tbackground-color: var(--#{$prefix}theme);\n\tborder-color: var(--#{$prefix}theme);\n\tposition: relative;\n\t\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: -1px;\n\t\tleft: -1px;\n\t\tright: -1px;\n\t\tbottom: -1px;\n\t\t\n\t\tborder-radius: $border-radius;\n\t\t@include transition($btn-transition);\n\t}\n\t&.disabled,\n\t&:disabled {\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tborder-color: var(--#{$prefix}theme);\n\t}\n\t&:hover,\n\t&:focus,\n\t&:active,\n\t&.active {\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tborder-color: var(--#{$prefix}theme);\n\t\t\n\t\t&:before {\n\t\t\tbackground: rgba($white, .2);\n\t\t}\n\t}\n\t&:focus,\n\t&:active,\n\t&.active:focus, \n\t&:active:focus {\n\t\t@include box-shadow(0 0 0 0.25rem rgba(#{var(--#{$prefix}theme-rgb)}, .5));\n\t}\n}\n.btn-outline-theme {\n\tcolor: var(--#{$prefix}theme);\n\tborder-color: var(--#{$prefix}theme);\n\t\n\t&:hover,\n\t&.active {\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tborder-color: var(--#{$prefix}theme);\n\t}\n\t&.disabled,\n\t&:disabled {\n\t\tcolor: var(--#{$prefix}theme);\n\t}\n\t&:focus,\n\t&:active,\n\t&.active:focus, \n\t&:active:focus {\n\t\t@include box-shadow(0 0 0 0.25rem rgba(#{var(--#{$prefix}theme-rgb)}, .5));\n\t}\n}\n.nav-link {\n\tcolor: var(--#{$prefix}theme);\n\t\n\t&:hover {\n\t\tcolor: rgba(#{var(--#{$prefix}theme-rgb)}, .5);\n\t}\n}","@mixin helper-spacing($direction, $classProperty, $className) {\n\t@for $i from 1 through 20 {\n\t\t$classInt: $i;\n\t\t$cssValue: rem($i);\n\t\t$cssProperty: $classProperty;\n\t\t\n\t\t@if ($direction == 'top') {\n\t\t\t$cssProperty: $classProperty + '-top';\n\t\t} @else if ($direction == 'right') {\n\t\t\t@if $enable-rtl {\n\t\t\t\t$cssProperty: $classProperty + '-left';\n\t\t\t} @else {\n\t\t\t\t$cssProperty: $classProperty + '-right';\n\t\t\t}\n\t\t} @else if ($direction == 'bottom') {\n\t\t\t$cssProperty: $classProperty + '-bottom';\n\t\t} @else if ($direction == 'left') {\n\t\t\t@if $enable-rtl {\n\t\t\t\t$cssProperty: $classProperty + '-right';\n\t\t\t} @else {\n\t\t\t\t$cssProperty: $classProperty + '-left';\n\t\t\t}\n\t\t}\n\t\t@if ($i <= 10) {\n\t\t\t$classInt: ($i) + px;\n\t\t\t$cssValue: $i + px;\n\t\t} @else if ($i > 10) {\n\t\t\t$classInt: (($i - 10) * 5) + px;\n\t\t\t$cssValue: (($i - 10) * 5) + px;\n\t\t}\n\t\t.#{$className}-#{$classInt} {\n\t\t\t@if ($direction == 'mx') {\n\t\t\t\tmargin-left: $cssValue !important;\n\t\t\t\tmargin-right: $cssValue !important;\n\t\t\t} @else if ($direction == 'my') {\n\t\t\t\tmargin-top: $cssValue !important;\n\t\t\t\tmargin-bottom: $cssValue !important;\n\t\t\t} @else if ($direction == 'px') {\n\t\t\t\tpadding-left: $cssValue !important;\n\t\t\t\tpadding-right: $cssValue !important;\n\t\t\t} @else if ($direction == 'py') {\n\t\t\t\tpadding-top: $cssValue !important;\n\t\t\t\tpadding-bottom: $cssValue !important;\n\t\t\t} @else {\n\t\t\t\t#{$cssProperty}: $cssValue !important;\n\t\t\t}\n\t\t}\n\t}\n}","@mixin helper-font-size($from, $to) {\n\t@for $i from $from through $to {\n\t\t.fs-#{$i}px {\n\t\t\tfont-size: $i + px !important;\n\t\t}\n\t}\n}","@mixin helper-font-weight($from, $to) {\n\t@for $i from $from through $to {\n\t\t$classValue: $i * 100;\n\t\t\n\t\t.fw-#{$classValue} {\n\t\t\tfont-weight: $classValue !important;\n\t\t}\n\t}\n}","@mixin helper-size($className, $classProperty) {\n\t@for $i from 1 through 40 {\n\t\t$classInt: $i * 5;\n\t\t\n\t\t.#{$className}-#{$classInt}px {\n\t\t\t#{$classProperty}: $classInt + px !important;\n\t\t}\n\t\t.#{$className}-#{$i}px {\n\t\t\t#{$classProperty}: $i + px !important;\n\t\t}\n\t}\n\t@for $i from 5 through 12 {\n\t\t$classInt: $i * 50;\n\t\t\n\t\t.#{$className}-#{$classInt}px {\n\t\t\t#{$classProperty}: $classInt + px !important;\n\t\t}\n\t}\n}","@mixin helper-color($color, $value) {\n  .bg-gradient-#{$color} {\n\t\tbackground-color: $value !important;\n\t\tbackground-image: -moz-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: -webkit-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: linear-gradient(to bottom, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)',GradientType=0 ) !important;\n  }\n  .border-#{$color} {\n  \t@if ($color == 'theme') {\n\t\t\tborder-color: var(--#{$prefix}theme) !important;\n  \t}\n  }\n  :root .theme-#{$color} {\n\t\t--#{$prefix}theme: #{$value} !important;\n\t\t--#{$prefix}theme-rgb: #{to-rgb($value)} !important;\n\t\t--#{$prefix}theme-color: #{color-contrast($value)} !important;\n\t\t--#{$prefix}theme-color-rgb: #{to-rgb(color-contrast($value))} !important;\n\t}\n\t@for $i from 1 through 4 {\n\t\t.text-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}text-opacity)) !important;\n\t\t}\n\t\t.bg-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n\t\t.text-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}text-opacity))  !important;\n\t\t}\n\t\t.bg-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n  }\n}","@mixin helper-color-dark($color, $value) {\n\t& .bg-gradient-#{$color} {\n\t\tbackground-color: $value !important;\n\t\tbackground-image: -moz-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: -webkit-linear-gradient(top, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tbackground-image: linear-gradient(to bottom, lighten($value, 10%), darken($value, 5%)) !important;\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='lighten($value, 10%)', endColorstr='darken($value, 5%)',GradientType=0 ) !important;\n\t}\n\t& .border-#{$color} {\n\t\t@if ($color == 'theme') {\n\t\t\tborder-color: var(--#{$prefix}theme) !important;\n\t\t}\n\t}\n\t& .theme-#{$color} {\n\t\t--#{$prefix}theme: #{$value} !important;\n\t\t--#{$prefix}theme-rgb: #{to-rgb($value)} !important;\n\t\t--#{$prefix}theme-color: #{color-contrast($value)} !important;\n\t\t--#{$prefix}theme-color-rgb: #{to-rgb(color-contrast($value))} !important;\n\t}\n\t@for $i from 1 through 4 {\n\t\t& .text-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}text-opacity)) !important;\n\t\t}\n\t\t.bg-#{$color}-#{$i * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(tint-color($value, (100 - ($i * 20)) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n\t\t.text-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}text-opacity: 1;\n\t\t\tcolor: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}text-opacity))  !important;\n\t\t}\n\t\t.bg-#{$color}-#{($i + 5) * 100} {\n\t\t\t--#{$prefix}bg-opacity: 1;\n\t\t\tbackground-color: rgba(shade-color($value, ($i * 20) * 1%), var(--#{$prefix}bg-opacity)) !important;\n\t\t}\n\t}\n}","@mixin background-gradient($className, $from, $to, $direction: top) {\n\t.#{$className} {\n\t\tbackground: $from;\n\t}\n\t.#{$className} {\n\t\tbackground: -moz-linear-gradient($direction, $from, $to) !important;\n\t\tbackground: -webkit-linear-gradient($direction, $from, $to) !important;\n\t    @if $direction == top {\n\t\t    background: linear-gradient(to top, $from, $to) !important;\n\t    } @else if $direction == right {\n\t\t    background: linear-gradient(to left, $from, $to) !important;\n\t    } @else if $direction == left {\n\t\t    background: linear-gradient(to right, $from, $to) !important;\n\t    } @else if $direction == bottom {\n\t\t    background: linear-gradient(to bottom, $from, $to) !important;\n\t    }\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$from', endColorstr='$to',GradientType=0 ) !important;\n\t}\n}\n","@mixin helper-opacity($from, $to) {\n\t@for $i from $from through $to {\n\t\t.opacity-#{$i} {\n\t\t\topacity: #{$i * 0.1} !important;\n\t\t}\n\t\t.opacity-#{$i * 15} {\n\t\t\topacity: #{$i * 0.15} !important;\n\t\t}\n\t\t.text-opacity-#{$i * 10} {\n\t\t\t--#{$prefix}text-opacity: #{$i * 0.1};\n\t\t}\n\t\t.text-opacity-#{($i * 10) + 5} {\n\t\t\t--#{$prefix}text-opacity: #{($i * 0.1) + 0.05};\n\t\t}\n\t\t.bg-opacity-#{$i * 10} {\n\t\t\t--#{$prefix}bg-opacity: #{$i * 0.1};\n\t\t}\n\t\t.bg-opacity-#{($i * 10) + 5} {\n\t\t\t--#{$prefix}bg-opacity: #{($i * 0.1) + 0.05};\n\t\t}\n\t}\n}",".app-content {\n\tpadding: $app-content-padding-y $app-content-padding-x;\n\tflex: 1;\n\t\n\t@if $enable-rtl {\n\t\tmargin-right: $app-sidebar-width;\n\t} @else {\n\t\tmargin-left: $app-sidebar-width;\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tpadding: $app-content-sm-padding-y $app-content-sm-padding-x;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tmargin-right: 0;\n\t\t} @else {\n\t\t\tmargin-left: 0;\n\t\t}\n\t}\n\t\n\t& .app-content-inner-padding {\n\t\tpadding: $app-content-padding-y $app-content-padding-x;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tpadding: $app-content-sm-padding-y $app-content-sm-padding-x;\n\t\t}\n\t}\n\t& .app-content-inner-padding-x {\n\t\tpadding-left: $app-content-padding-x;\n\t\tpadding-right: $app-content-padding-x;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tpadding-left: $app-content-sm-padding-x;\n\t\t\tpadding-right: $app-content-sm-padding-x;\n\t\t}\n\t}\n\t& .app-content-inner-padding-y {\n\t\tpadding-top: $app-content-padding-y;\n\t\tpadding-bottom: $app-content-padding-y;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tpadding-top: $app-content-sm-padding-y;\n\t\t\tpadding-bottom: $app-content-sm-padding-y;\n\t\t}\n\t}\n}",".app-footer {\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tpadding: $spacer * 1.25 0;\n\tborder-top: 1px solid var(--#{$prefix}border-color);\n\tfont-weight: $font-weight-bold;\n\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\n\t@if $enable-rtl {\n\t\tmargin-right: $app-sidebar-width + $app-content-padding-x;\n\t\tmargin-left: $app-content-padding-x;\n\t} @else {\n\t\tmargin-left: $app-sidebar-width + $app-content-padding-x;\n\t\tmargin-right: $app-content-padding-x;\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tpadding: $spacer 0;\n\t\tmargin: 0 $app-content-sm-padding-x;\n\t}\n}",".app-header {\n\theight: $app-header-height;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: $app-header-zindex;\n\tbackground: var(--#{$prefix}app-header-bg);\n\tdisplay: flex;\n\ttransition: all .15s ease-in-out;\n\t\n\t& .menu-toggler {\n\t\tborder: none;\n\t\tbackground: none;\n\t\theight: 100%;\n\t\tpadding: $spacer * .5 $spacer;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\t\n\t\t& .bar {\n\t\t\twidth: rem(26px);\n\t\t\tdisplay: block;\n\t\t\theight: 1px;\n\t\t\tbackground: rgba(var(--#{$prefix}app-header-link-color-rgb), .4);\n\t\t\ttransition: all .2s linear;\n\t\t\t\n\t\t\t& + .bar {\n\t\t\t\tmargin-top: rem(4px);\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\t& .bar {\n\t\t\t\tbackground: rgba(var(--#{$prefix}app-header-link-color-rgb), .75);\n\t\t\t}\n\t\t}\n\t}\n\t& .mobile-toggler {\n\t\theight: 100%;\n\t\tdisplay: none;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tmargin-left: auto;\n\t\t} @else {\n\t\t\tmargin-right: auto;\n\t\t}\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\t& .desktop-toggler {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tmargin-left: auto;\n\t\t} @else {\n\t\t\tmargin-right: auto;\n\t\t}\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t\n\t& .brand {\n\t\theight: 100%;\n\t\twidth: $app-sidebar-width + $app-content-padding-y;\n\t\tpadding: 0 $spacer;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\t\t& .brand-logo {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--#{$prefix}app-header-link-color);\n\t\t\tfont-size: $font-size-base * 1.05;\n\t\t\tletter-spacing: 2px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t\n\t\t\t& img {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .brand-img {\n\t\t\t\twidth: rem(26px);\n\t\t\t\theight: rem(26px);\n\t\t\t\tbackground: var(--#{$prefix}app-header-brand-img);\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .brand-img-text {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tletter-spacing: initial;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .menu {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tflex: 1;\n\t\t\n\t\t& .menu-item {\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t\n\t\t\t& .menu-link {\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: var(--#{$prefix}app-header-link-color);\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: $spacer * .5 $spacer;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\t\n\t\t\t\t& .menu-img {\n\t\t\t\t\twidth: rem(32px);\n\t\t\t\t\theight: rem(32px);\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-left: $spacer * .75;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-right: $spacer * .75;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t& img {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\t\tborder-radius: 30px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-icon {\n\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t}\n\t\t\t\t& .menu-badge {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\twidth: 6px;\n\t\t\t\t\theight: 6px;\n\t\t\t\t\ttop: rem(8px);\n\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tleft: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tright: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .menu-search {\n\t\tposition: absolute;\n\t\ttop: $app-header-height * -1;\n\t\tleft: 0;\n\t\tright: 0;\n\t\theight: $app-header-height;\n\t\tbackground: var(--#{$prefix}app-header-bg);\n\t\ttransition: all .2s ease-in-out;\n\t\t\n\t\t& .menu-search-container {\n\t\t\tmax-width: $app-header-search-max-width;\n\t\t\tmargin: 0 auto;\n\t\t\theight: $app-header-height;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& .menu-search-icon {\n\t\t\t\tpadding: 0 $spacer;\n\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\n\t\t\t\t& .bi {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& a {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}app-header-link-color-rgb), .5);\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t\t\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-header-link-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .menu-search-input {\n\t\t\t\tflex: 1;\n\t\t\t\n\t\t\t\t& .form-control {\n\t\t\t\t\tborder: none;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbox-shadow: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.app-header-menu-search-toggled & {\n\t\t\ttop: 0;\n\t\t}\n\t}\n\t&.navbar .navbar-collapse {\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\ttop: 100%;\n\t\t\tbackground: var(--#{$prefix}app-header-bg);\n\t\t\tpadding: 0 $spacer;\n\t\t}\n\t}\n}",".app-sidebar-mobile-backdrop {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: $app-sidebar-mobile-backdrop-zindex;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0;\n\tborder: 0;\n\tmargin: 0;\n\toutline: none;\n\tdisplay: none;\n\tbackground: $app-sidebar-mobile-backdrop-bg;\n}","@keyframes appSidebarSubMenuSlideInRight {\n\tto { transform: translate3d(0, 0, 0); }\n}\n\n.app-sidebar {\n\twidth: $app-sidebar-width;\n\tbottom: 0;\n\tposition: fixed;\n\ttop: $app-header-height;\n\tz-index: $app-sidebar-zindex;\n\t\n\t@if $enable-rtl {\n\t\tright: 0;\n\t} @else {\n\t\tleft: 0;\n\t}\n\t\n\t@include media-breakpoint-down(md) {\n\t\ttop: 0;\n\t\tz-index: $app-sidebar-mobile-zindex;\n\t\tbackground: var(--#{$prefix}app-sidebar-mobile-bg);\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tright: -$app-sidebar-width;\n\t\t} @else {\n\t\t\tleft: -$app-sidebar-width;\n\t\t}\n\t}\n\t\n\t& .slimScrollDiv {\n\t\twidth: 100% !important;\n\t\t\n\t\t& .slimScrollBar,\n\t\t& .slimScrollRail {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n\t\n\t& .app-sidebar-content {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\t\n\t\t& .menu {\n\t\t\tposition: relative;\n\t\t\t\n\t\t\t& .menu-header {\n\t\t\t\tpadding: $spacer $spacer $spacer * 0.5;\n\t\t\t\tfont-size: $font-size-base * .75;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: var(--#{$prefix}app-sidebar-menu-header-color);\n\t\t\t}\n\t\t\t& .menu-item {\n\t\t\t\t& .menu-link {\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: $spacer * 0.3 $spacer;\n\t\t\t\t\tcolor: var(--#{$prefix}app-sidebar-menu-link-color);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t\ttransition: all .2s ease-in-out;\n\t\t\t\t\t\n\t\t\t\t\t& .menu-icon {\n\t\t\t\t\t\twidth: rem(30px);\n\t\t\t\t\t\theight: rem(30px);\n\t\t\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\t\t\tmargin: rem(-4px) 0;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tmargin-left: $spacer* .75;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tmargin-right: $spacer * .75;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .menu-caret {\n\t\t\t\t\t\tmargin: rem(-5px) 0;\n\t\t\t\t\t}\n\t\t\t\t\t& .menu-text {\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-sidebar-menu-link-hover-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-submenu {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tdisplay: none;\n\t\t\t\t\tpadding: 0 0 $spacer;\n\t\t\t\t\t\n\t\t\t\t\t& .menu-item {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: rem(42px);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: rem(42px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t&:not(.has-sub) > .menu-link {\n\t\t\t\t\t \tcolor: var(--#{$prefix}app-sidebar-menu-link-active-color);\n\t\t\t\t\t}\n\t\t\t\t\t& > .menu-link {\n\t\t\t\t\t\t& .menu-icon {\n\t\t\t\t\t\t\tcolor: $app-sidebar-menu-link-icon-active-color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.has-sub {\n\t\t\t\t\t\t& > .menu-submenu {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.expand {\n\t\t\t\t\t& > .menu-submenu {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& > .menu-item {\n\t\t\t\t\t\t\tanimation: appSidebarSubMenuSlideInRight 0.3s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\ttransform: translate3d(100%, 0, 0);\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\ttransform: translate3d(-100%, 0, 0);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@for $i from 2 through 50 {\n\t\t\t\t$time: 15 + (15 * $i);\n\t\t\t\t$delay: $time * 1ms;\n\t\t\t\n\t\t\t\t& .collapse.expand > .menu-item,\n\t\t\t\t& .menu-item > .menu-submenu > .menu-item {\n\t\t\t\t\t&:nth-child(#{$i}) {\n\t\t\t\t\t\tanimation-delay: $delay;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .app-sidebar-mobile-backdrop {\n\t\tdisplay: none;\n\t}\n\t&.uppercase-mode {\n\t\ttext-transform: uppercase;\n\t\t\n\t\t& .app-sidebar-content {\n\t\t\t& .menu {\n\t\t\t\t& .menu-item {\n\t\t\t\t\t& .menu-link {\n\t\t\t\t\t\tfont-size: $font-size-base * 0.95;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\t\t\n\t\t}\n\t}\n}","$theme-panel-width: $spacer * 12;\n\n.app-theme-panel {\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: $app-header-zindex + 10;\n\twidth: 0;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t@if $enable-rtl {\n\t\tleft: -$theme-panel-width;\n\t\ttransition: left .2s ease-in-out;\n\t} @else {\n\t\tright: -$theme-panel-width;\n\t\ttransition: right .2s ease-in-out;\n\t}\n\t\n\t& .app-theme-panel-container {\n\t\twidth: $theme-panel-width;\n\t\tposition: absolute;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tleft: 0;\n\t\t} @else {\n\t\t\tright: 0;\n\t\t}\n\t}\n\t& .app-theme-panel-content {\n\t\twidth: $theme-panel-width;\n\t\tbackground: var(--#{$prefix}app-theme-panel-bg);\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\tpadding: $spacer * .5;\n\t\tz-index: 10;\n\t\t\n\t\t& .app-theme-list {\n\t\t\tmargin: $spacer * -.25;\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\n\t\t\t& .app-theme-list-item {\n\t\t\t\tpadding: $spacer * .25;\n\t\t\t\twidth: 25%;\n\t\t\n\t\t\t\t& .app-theme-list-link {\n\t\t\t\t\theight: rem(32px);\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: .6;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .app-theme-list-link {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\tfont-size: rem(14px);\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .app-theme-mode-link {\n\t\t\tcolor: $white;\n\t\t\ttext-decoration: none;\n\t\t\ttext-align: center;\n\t\t\tposition: relative;\n\t\t\tdisplay: block;\n\t\t\ttransition: all .2s linear;\n\t\t\t\n\t\t\t& .img {\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tfont-size: rem(14px);\n\t\t\t\t\tcolor: transparent;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tz-index: 10;\n\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .text {\n\t\t\t\tfont-size: $font-size-base * .75;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tbackground: rgba($black, .85);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-end;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\topacity: .6;\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\topacity: 1;\n\t\t\t\t\n\t\t\t\t& .img {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground: rgba($black, .3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .text {\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .app-theme-cover {\n\t\t\tmargin: $spacer * -.25;\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\t\n\t\t\t& .app-theme-cover-item {\n\t\t\t\tpadding: $spacer * .25;\n\t\t\t\twidth: 33.33%;\n\t\t\t\t\n\t\t\t\t& .app-theme-cover-link {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding-top: 46%;\n\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: .6;\n\t\t\t\t\t}\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground: $black;\n\t\t\t\t\t\topacity: .25;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .app-theme-cover-link {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\tfont-size: rem(14px);\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .app-theme-toggle-btn {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tmargin-top: $spacer * -1;\n\t\twidth: $spacer * 2;\n\t\theight: $spacer * 2;\n\t\tline-height: $spacer * 2;\n\t\tfont-size: $font-size-base * 1.25;\n\t\tcolor: var(--#{$prefix}app-theme-panel-color);\n\t\tbackground: var(--#{$prefix}app-theme-panel-bg);\n\t\ttext-align: center;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tright: 0;\n\t\t\tmargin-right: $spacer * -2;\n\t\t} @else {\n\t\t\tleft: 0;\n\t\t\tmargin-left: $spacer * -2;\n\t\t}\n\t}\n\t&.active {\n\t\t@if $enable-rtl {\n\t\t\tleft: 0;\n\t\t} @else {\n\t\t\tright: 0;\n\t\t}\n\t}\n}","@mixin fontawesome() {\n\tfont-family: Font Awesome\\ 6 Free, Font Awesome\\ 6 Pro, FontAwesome !important;\n\tfont-weight: 900;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n}","@use 'sass:math';\n\n@keyframes topMenuControlSlideInLeft {\n\tfrom { left: rem(-50px); }\n\tto { left: 0; }\n}\n@keyframes topMenuControlSlideInRight {\n\tfrom { right: rem(-50px); }\n\tto { right: 0; }\n}\n.app-top-nav {\n\tbackground: var(--#{$prefix}app-top-nav-bg);\n\tleft: 0;\n\tright: 0;\n\tz-index: $app-top-nav-zindex;\n\t\n\t@include media-breakpoint-up(md) {\n\t\ttop: $app-header-height;\n\t\tposition: fixed;\n\t\theight: $app-top-nav-height;\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tdisplay: none;\n\t}\n\t\n\t& .menu {\n\t\t@include media-breakpoint-up(md) {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: nowrap;\n\t\t\talign-items: center;\n\t\t}\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: block;\n\t\t\tmargin: 0 !important;\n\t\t}\n\t\t\n\t\t& .menu-item {\n\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t& .menu-link {\n\t\t\t\ttext-decoration: none;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: ($app-top-nav-height - ($font-size-base * $line-height-base) - rem(1px)) * .5 $spacer;\n\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-color);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\ttransition: all .2s ease-in-out;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tpadding-top: $spacer * .5;\n\t\t\t\t\tpadding-bottom: $spacer * .5;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .menu-icon {\n\t\t\t\t\twidth: rem(30px);\n\t\t\t\t\theight: rem(30px);\n\t\t\t\t\tfont-size: $font-size-base * 1.2;\n\t\t\t\t\tmargin: rem(-4px) 0;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-left: $spacer* .75;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-right: $spacer * .75;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-caret {\n\t\t\t\t\tmargin: rem(-5px) 0;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-right: $spacer* .75;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer * .75;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .menu-text {\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-hover-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .menu-submenu {\n\t\t\t\tbackground: var(--#{$prefix}app-top-nav-menu-submenu-bg);\n\t\t\t\tdisplay: none;\n\t\t\t\tpadding: $spacer * .5 0;\n\t\t\t\tmin-width: rem(200px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-up(md) {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tmax-height: calc(100vh - #{$app-top-nav-height + $app-header-height});\n\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tpadding-top: 0;\n\t\t\t\t\tpadding-bottom: $spacer;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tpadding-right: rem(42px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: rem(42px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .menu-item {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t\n\t\t\t\t\t& .menu-link {\n\t\t\t\t\t\tpadding: $spacer * .25 $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\t& > .menu-link {\n\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-active-color);\n\t\t\t\t}\n\t\t\t\t& > .menu-link {\n\t\t\t\t\t& .menu-icon {\n\t\t\t\t\t\tcolor: $app-top-nav-menu-link-icon-active-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.menu-control {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tmargin: 0;\n\t\t\t\tz-index: 10;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tdisplay: none !important;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& > .menu-link {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\twidth: $app-top-nav-height;\n\t\t\t\t\theight: $app-top-nav-height;\n\t\t\t\t\tbackground: var(--#{$prefix}app-top-nav-bg);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-color);\n\t\t\t\t\t\n\t\t\t\t\t& i {\n\t\t\t\t\t\tfloat: none;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tfont-size: rem(18px);\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tline-height: rem(40px);\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tcolor: var(--#{$prefix}app-top-nav-menu-link-hover-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.menu-control-start {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tright: -$app-header-height;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: -$app-header-height;\n\t\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\t& > .menu-link {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tbox-shadow: -12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tbox-shadow: 12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.show {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInRight .2s;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInLeft .2s;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.menu-control-end {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tleft: -$app-header-height;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tright: -$app-header-height;\n\t\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\t& > .menu-link {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tbox-shadow: 12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tbox-shadow: -12px 0 10px -10px rgba($black,.5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.show {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInLeft .2s;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\tanimation: topMenuControlSlideInRight .2s;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& > .menu-item {\n\t\t\t&.has-sub {\n\t\t\t\t&:hover {\n\t\t\t\t\t& > .menu-submenu {\n\t\t\t\t\t\t@include media-breakpoint-up(md) {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".app {\n\tpadding-top: $app-header-height;\n}",".app-boxed-layout {\n\t@include media-breakpoint-up(lg) {\n\t\tmin-height: 100vh;\n\t\n\t\t&,\n\t\t& .app-header {\n\t\t\tmax-width: rem(1280px);\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t\t& .app-top-nav {\n\t\t\tmax-width: rem(1280px);\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t\toverflow: hidden;\n\t\t\t\n\t\t\t& .menu .menu-item .menu-submenu {\n\t\t\t\tposition: fixed;\n\t\t\t\tleft: auto;\n\t\t\t\tright: auto;\n\t\t\t\ttop: auto;\n\t\t\t}\n\t\t}\n\t\t& .app-sidebar {\n\t\t\t@if $enable-rtl {\n\t\t\t\tright: auto;\n\t\t\t} @else {\n\t\t\t\tleft: auto;\n\t\t\t}\n\t\t}\n\t}\n}",".app-content-full-height {\n\t& .app-content {\n\t\theight: calc(100vh - #{$app-header-height});\n\t}\n\t&.app-without-header {\n\t\t& .app-content {\n\t\t\theight: 100vh;\n\t\t}\n\t}\n}",".app-content-full-width {\n\t& .app-content {\n\t\tmargin: 0;\n\t}\n\t& .app-footer {\n\t\t@if ($enable-rtl) {\n\t\t\tmargin-right: $app-content-padding-x;\n\t\t} @else {\n\t\t\tmargin-left: $app-content-padding-x;\n\t\t}\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: $app-content-sm-padding-x;\n\t\t\t} @else {\n\t\t\t\tmargin-left: $app-content-sm-padding-x;\n\t\t\t}\n\t\t}\n\t}\n}",".app-footer-fixed {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n}\t",".app-full-height {\n\tmin-height: 100vh;\n}","@keyframes appSidebarCollapse {\n\t@if ($enable-rtl) {\n\t\tfrom { margin-right: 0; opacity: 1; }\n\t\tto { margin-right: -$app-sidebar-width; opacity: 0 }\n\t} @else {\n\t\tfrom { margin-left: 0; opacity: 1; }\n\t\tto { margin-left: -$app-sidebar-width; opacity: 0 }\n\t}\n}\n@keyframes appContentCollapse {\n\t@if ($enable-rtl) {\n\t\tfrom { margin-right: $app-sidebar-width; }\n\t\tto { margin-right: 0; }\n\t} @else {\n\t\tfrom { margin-left: $app-sidebar-width; }\n\t\tto { margin-left: 0; }\n\t}\n}\n@keyframes appFooterCollapse {\n\t@if ($enable-rtl) {\n\t\tfrom { margin-right: $app-sidebar-width; }\n\t\tto { margin-right: $app-content-padding-x; }\n\t} @else {\n\t\tfrom { margin-left: $app-sidebar-width; }\n\t\tto { margin-left: $app-content-padding-x; }\n\t}\n}\n\n\n.app-sidebar-collapsed {\n\t@include media-breakpoint-up(md) {\n\t\t& .app-sidebar {\n\t\t\topacity: 0;\n\t\t\t\n\t\t\t.app-init & {\n\t\t\t\tanimation: appSidebarCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t}\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: -$app-sidebar-width;\n\t\t\t} @else {\n\t\t\t\tmargin-left: -$app-sidebar-width;\n\t\t\t}\n\t\t}\n\t\t& .app-content {\n\t\t\tanimation: appContentCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: 0;\n\t\t\t} @else {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t& .app-footer {\n\t\t\tanimation: appFooterCollapse 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: $app-content-padding-x;\n\t\t\t} @else {\n\t\t\t\tmargin-left: $app-content-padding-x;\n\t\t\t}\n\t\t}\n\t}\n}","@keyframes appSidebarMobileSlideInLeft {\n\t@if ($enable-rtl) {\n\t\tfrom { right: -$app-sidebar-width; } \n\t\tto { right: 0; }\n\t} @else {\n\t\tfrom { left: -$app-sidebar-width; } \n\t\tto { left: 0; }\n\t}\n}\n\n@keyframes appSidebarMobileBackdrop { \n\tfrom { background: transparent; } \n\tto { background: $app-sidebar-mobile-backdrop-bg; } \n}\n\n.app-sidebar-mobile-toggled {\n\t@include media-breakpoint-down(md) {\n\t\t& .app-sidebar {\n\t\t\tanimation: appSidebarMobileSlideInLeft .1s ease;\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tright: 0;\n\t\t\t} @else {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t}\n\t\t& .app-sidebar-mobile-backdrop:not(.app-sidebar-end) {\n\t\t\tdisplay: block;\n\t\t\tbackground: $app-sidebar-mobile-backdrop-bg;\n\t\t\tanimation: appSidebarMobileBackdrop .1s ease;\n\t\t}\n\t}\n}","@keyframes appSidebarExpand {\n\t@if ($enable-rtl) {\n\t\tfrom { margin-right: -$app-sidebar-width; }\n\t\tto { margin-right: 0; }\n\t} @else {\n\t\tfrom { margin-left: -$app-sidebar-width; }\n\t\tto { margin-left: 0; }\n\t}\n}\n@keyframes appContentExpand {\n\t@if ($enable-rtl) {\n\t\tfrom { margin-right: 0; }\n\t\tto { margin-right: $app-sidebar-width; }\n\t} @else {\n\t\tfrom { margin-left: 0; }\n\t\tto { margin-left: $app-sidebar-width; }\n\t}\n}\n@keyframes appFooterExpand {\n\t@if ($enable-rtl) {\n\t\tfrom { margin-right: $app-content-padding-x; }\n\t\tto { margin-right: $app-sidebar-width + $app-content-padding-x; }\n\t} @else {\n\t\tfrom { margin-left: $app-content-padding-x; }\n\t\tto { margin-left: $app-sidebar-width + $app-content-padding-x; }\n\t}\n}\n\n.app-sidebar-toggled {\n\t@include media-breakpoint-up(md) {\n\t\t& .app-sidebar {\n\t\t\tanimation: appSidebarExpand 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: 0;\n\t\t\t} @else {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t& .app-content {\n\t\t\tanimation: appContentExpand 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: $app-sidebar-width;\n\t\t\t} @else {\n\t\t\t\tmargin-left: $app-sidebar-width;\n\t\t\t}\n\t\t}\n\t\t& .app-footer {\n\t\t\tanimation: appFooterExpand 0.15s both cubic-bezier(0.7, 0, 0.3, 1);\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tmargin-right: $app-sidebar-width + $app-content-padding-x;\n\t\t\t} @else {\n\t\t\t\tmargin-left: $app-sidebar-width + $app-content-padding-x;\n\t\t\t}\n\t\t}\n\t}\n}",".app-with-top-nav {\n\t@include media-breakpoint-up(md) {\n\t\tpadding-top: $app-top-nav-height + $app-header-height;\n\t\t\n\t\t& .app-sidebar {\n\t\t\ttop: $app-top-nav-height + $app-header-height;\n\t\t}\n\t}\n\t\n\t&.app-without-header {\n\t\t@include media-breakpoint-up(md) {\n\t\t\tpadding-top: $app-top-nav-height;\n\t\t\n\t\t\t& .app-sidebar {\n\t\t\t\ttop: $app-top-nav-height;\n\t\t\t}\n\t\t}\n\t}\n}",".app-without-header {\n\tpadding-top: 0;\n}",".app-without-sidebar {\n\t& .app-content {\n\t\tmargin: 0;\n\t}\n}",".breadcrumb {\n\tfont-weight: bold;\n\t\n\t& .breadcrumb-item {\n\t\t& a {\n\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t\t& + .breadcrumb-item {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tpadding-right: $spacer * .5;\n\t\t\t\t\n\t\t\t\t&:before {\n\t\t\t\t\tfloat: right;\n\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".btn-scroll-top {\n\tposition: fixed;\n\tbottom: rem(30px);\n\twidth: rem(40px);\n\theight: rem(40px);\n\tbackground: rgba($gray-800, .75);\n\tcolor: $white;\n\ttext-align: center;\n\ttext-decoration: none;\n\tz-index: $app-header-zindex;\n\tborder-radius: 36px;\n\ttransition: $btn-transition;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t\n\t@if $enable-rtl {\n\t\tleft: rem(30px);\n\t} @else {\n\t\tright: rem(30px);\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tbottom: rem(20px);\n\t\tz-index: $app-header-zindex;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tleft: rem(20px);\n\t\t} @else {\n\t\t\tright: rem(20px);\n\t\t}\n\t}\n\t\n\t&:hover {\n\t\tbackground: var(--#{$prefix}theme);\n\t\tcolor: var(--#{$prefix}theme-color);\n\t\ttext-decoration: none;\n\t}\n}",".card-expand {\n\t& .app-content {\n\t\tz-index: $app-header-zindex + 100;\n\t\tposition: relative;\n\t\theight: calc(100vh - #{$app-header-height});\n\t\toverflow: hidden;\n\t}\n}\n.card {\n\t--#{$prefix}border-color-rgb: var(--#{$prefix}body-color-rgb);\n\t\n\tposition: relative;\n\tborder: none;\n\t\n\t&.border-theme {\n\t\t--#{$prefix}border-color-rgb: var(--#{$prefix}theme-rgb);\n\t}\n\t&.card-expand {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: $app-header-zindex + 100;\n\t\tborder-radius: 0;\n\t\tmargin: 0 !important;\n\t\tpadding: rem(5px);\n\t\tbackground: var(--#{$prefix}app-header-bg);\n\t\t\n\t\t& .card-header,\n\t\t& .card-body {\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t& .card-body {\n\t\t\tflex: 1 0 0;\n\t\t\toverflow: scroll;\n\t\t}\n\t\t\n\t\t&:not(.border-0):before {\n\t\t\ttop: 5px;\n\t\t\tbottom: 5px;\n\t\t\tleft: 20px;\n\t\t\tright: 20px;\n\t\t}\n\t\t&:not(.border-0):after {\n\t\t\ttop: 20px;\n\t\t\tbottom: 20px;\n\t\t\tleft: 5px;\n\t\t\tright: 5px;\n\t\t}\n\t\t& .card-arrow {\n\t\t\tmargin: 5px;\n\t\t}\n\t}\n\t& .card-header {\n\t\t& .card-header-tabs {\n\t\t\t& .nav-item {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tborder-bottom-color: transparent;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .card-body {\n\t\t& .nav-tabs {\n\t\t\t& .nav-item {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tbackground: var(--#{$prefix}card-bg);\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}card-bg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t}\n\t&:not(.border-0):before {\n\t\tleft: 15px;\n\t\tright: 15px;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tborder-top: $border-width solid rgba(var(--#{$prefix}border-color-rgb), .3);\n\t\tborder-bottom: $border-width solid rgba(var(--#{$prefix}border-color-rgb), .3);\n\t}\n\t&:not(.border-0):after {\n\t\ttop: 15px;\n\t\tbottom: 15px;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tborder-left: $border-width solid rgba(var(--#{$prefix}border-color-rgb), .3);\n\t\tborder-right: $border-width solid rgba(var(--#{$prefix}border-color-rgb), .3);\n\t}\n\t\n\t& > *:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) {\n\t\tposition: relative;\n\t\tz-index: 10;\n\t}\n\t& .card-arrow {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t}\n\t& .card-arrow-top-left,\n\t& .card-arrow-top-right,\n\t& .card-arrow-bottom-left,\n\t& .card-arrow-bottom-right {\n\t\twidth: 10px;\n\t\theight: 10px;\n\t\tposition: absolute;\n\t\t\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\twidth: 2px;\n\t\t\theight: 8px;\n\t\t\tbackground: rgba(var(--#{$prefix}border-color-rgb), .75);\n\t\t}\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\twidth: 10px;\n\t\t\theight: 2px;\n\t\t\tbackground: rgba(var(--#{$prefix}border-color-rgb), .75);\n\t\t}\n\t}\n\t& .card-arrow-top-left,\n\t& .card-arrow-top-right {\n\t\ttop: 0;\n\t\t\n\t\t&:before {\n\t\t\ttop: 2px;\n\t\t}\n\t\t&:after {\n\t\t\ttop: 0;\n\t\t}\n\t}\n\t& .card-arrow-bottom-left,\n\t& .card-arrow-bottom-right {\n\t\tbottom: 0;\n\t\t\n\t\t&:before {\n\t\t\tbottom: 2px;\n\t\t}\n\t\t&:after {\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\t& .card-arrow-top-left,\n\t& .card-arrow-bottom-left {\n\t\tleft: 0;\n\t\t\n\t\t&:before,\n\t\t&:after {\n\t\t\tleft: 0;\n\t\t}\n\t}\n\t& .card-arrow-top-right,\n\t& .card-arrow-bottom-right {\n\t\tright: 0;\n\t\t\n\t\t&:before,\n\t\t&:after {\n\t\t\tright: 0;\n\t\t}\n\t}\n}",".card-columns {\n  @include media-breakpoint-down(lg) {\n    column-count: 2;\n  }\n  @include media-breakpoint-down(sm) {\n    column-count: 1;\n  }\n}",".caret {\n\t&:before {\n\t\tcontent: \"\\f22c\";\n\t\tdisplay: inline-block;\n    font-family: bootstrap-icons!important;\n    font-style: normal;\n    font-weight: 400!important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    vertical-align: -.125em;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\t}\n}\n.dropup {\n\t&.caret,\n\t& .caret {\n\t\tcontent: '';\n\t\tborder-top: 0;\n\t\tborder-bottom: 4px dashed;\n\t\tborder-bottom: 4px solid\\9;\n  }\n}",".carousel-indicators [data-bs-target] {\n\toverflow: hidden;\n}","@keyframes appDropdownShow {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n\n.dropdown-menu {\n\tbox-shadow: $dropdown-box-shadow;\n\t\n\t&.show {\n\t\tanimation: appDropdownShow 0.25s both cubic-bezier(0.7, 0, 0.3, 1);\n\t}\n}\n.dropdown {\n\t&.dropdown-mobile-full {\n\t\t@include media-breakpoint-down(sm) {\n\t\t\tposition: initial;\n\t\t\n\t\t\t& .dropdown-menu {\n\t\t\t\tleft: $spacer * .25 !important;\n\t\t\t\tright: $spacer * .25 !important;\n\t\t\t\twidth: auto !important;\n\t\t\t}\n\t\t}\n\t}\n}","@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t.form-check-input:checked[type=checkbox] {\n\t\t\t--#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image-dark)};\n\t\t}\n\t}\n}","@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t.form-check-input:checked[type=radio] {\n\t\t\t--#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image-dark)};\n\t\t}\n\t}\n}",".form-select:not([multiple]) {\n\t& option {\n\t\tcolor: $black;\n\t}\n}","@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n\t\t& .form-switch {\n\t\t\t& .form-check-input {\n\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n\n\t\t\t\t&:focus {\n\t\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image-dark)};\n\t\t\t\t}\n\n\t\t\t\t&:checked {\n\t\t\t\t\t@if $enable-gradients {\n\t\t\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image-dark)}, var(--#{$prefix}gradient);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\t--#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image-dark)};\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","hr {\n\t&.hr-bg,\n\t&.hr-transparent,\n\t&.hr-inverse,\n\t&.hr-inverse-transparent {\n\t\tborder: none;\n\t\theight: 1px;\n\t}\n\t&.hr-transparent {\n\t\tbackground-color: rgba($black, .3);\n\t}\n\t&.hr-inverse {\n\t\tbackground-color: lighten($black, 10%);\n\t}\n\t&.hr-inverse-transparent {\n\t\tbackground-color: rgba($white, .3);\n\t}\n}","a {\n\tcolor: var(--#{$prefix}theme);\n\t\n\t&:hover {\n\t\tcolor: rgba(#{var(--#{$prefix}theme-rgb)}, .75);\n\t}\n}",".modal {\n\t& .modal-content {\n\t\t& > * {\n\t\t\tposition: relative;\n\t\t}\n\t}\n\t& .modal-dialog{\n\t\t&.modal-full {\n\t\t\tmax-width: 100%;\n\t\t\twidth: 100%;\n\t\t\t\n\t\t\t& .modal-content {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\t&.modal-cover {\n\t\t& .modal-dialog {\n\t\t\tmin-height: 100%;\n\t\t\tmargin-top: 0;\n\t\t\tmargin-bottom: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t\t& .modal-content,\n\t\t& .modal-header,\n\t\t& .modal-footer {\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t}\n\t}\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n  \t.modal-backdrop {\n  \t\t--#{$prefix}backdrop-bg: #{$modal-backdrop-bg-dark};\n  \t}\n  }\n}\n\n",".nav {\n\t&.nav-tabs {\n\t\t&.nav-tabs-v2 {\n\t\t\t& > .nav-item {\n\t\t\t\t& > .nav-link {\n\t\t\t\t\tborder: none;\n\t\t\t\t\tborder-bottom: 3px solid transparent;\n\t\t\t\t\tpadding: $nav-link-padding-x 0;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: $nav-tabs-link-active-color;\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.show {\n\t\t\t\t\t& > .nav-link {\n\t\t\t\t\t\tcolor: $nav-tabs-link-active-color;\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".nav-wizards-container {\n\t@include media-breakpoint-down(md) {\n\t\toverflow: scroll;\n\t\t\n\t\t& .nav.nav-wizards-1,\n\t\t& .nav.nav-wizards-2,\n\t\t& .nav.nav-wizards-3 {\n\t\t\tmin-width: rem(600px);\n\t\t}\n\t}\n}\n\n.nav {\n\t&.nav-wizards-1 {\n\t\t& .nav-item {\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\n\t\t\t\t& .nav-no {\n\t\t\t\t\twidth: rem(40px);\n\t\t\t\t\theight: rem(40px);\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 2px solid var(--#{$prefix}border-color);\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\tborder-radius: 40px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t& .nav-text {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tmargin-top: rem(5px);\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t}\n\t\t\t\t&.active,\n\t\t\t\t&.completed {\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\n\t\t\t\t\t& .nav-no {\n\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t\t&:before,\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .nav-no {\n\t\t\t\t\t\tbox-shadow: 0 0 0 5px rgba(var(--#{$prefix}theme-rgb), .2);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: $nav-link-padding-x + rem(10px);\n\t\t\t\t\theight: rem(2px);\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tleft: calc(-50% + 20px);\n\t\t\t\t\tright: calc(50% + 20px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-wizards-2 {\n\t\t& .nav-item {\n\t\t\tpadding: 0 $nav-link-padding-x;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tborder-radius: 60px;\n\t\t\t\t\n\t\t\t\t& .nav-text {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: $nav-link-padding-x * -2;\n\t\t\t\t\tright: 100%;\n\t\t\t\t\theight: rem(2px);\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tmargin-top: rem(-1px);\n\t\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .35);\n\t\t\t\t}\n\t\t\t\t&.active,\n\t\t\t\t&.completed {\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tbox-shadow: 0 0 0 4px rgba(var(--#{$prefix}theme-rgb), .2);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.nav-wizards-3 {\n\t\t& .nav-item {\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tposition: relative;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\n\t\t\t\t& .nav-dot {\n\t\t\t\t\twidth: rem(16px);\n\t\t\t\t\theight: rem(16px);\n\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 3px solid var(--#{$prefix}border-color);\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t}\n\t\t\t\t& .nav-title {\n\t\t\t\t\tmargin-top: rem(10px);\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\t& .nav-text {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t}\n\t\t\t\t&.active,\n\t\t\t\t&.completed {\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\n\t\t\t\t\t& .nav-dot {\n\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\t& .nav-dot {\n\t\t\t\t\t\tbox-shadow: 0 0 0 5px rgba(var(--#{$prefix}theme-rgb), .2);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: calc(-50% + 8px);\n\t\t\t\t\ttop: $nav-link-padding-y + rem(6px);\n\t\t\t\t\tright: calc(50% + 8px);\n\t\t\t\t\theight: rem(3px);\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:first-child {\n\t\t\t\t& .nav-link {\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".navbar {\n\t&.navbar-sticky {\n\t\ttop: $app-header-height + $app-content-padding-y;\n\t\tposition: sticky;\n\t\tpadding: 0;\n\n\t\t@if $enable-rtl {\n\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\tmargin-right: $spacer;\n\t\t} @else {\n\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\tmargin-left: $spacer;\n\t\t}\n\t\t\n\t\t& .nav {\n\t\t\twidth: 100%;\n\t\t\tflex-direction: column;\n\t\t\t\n\t\t\t& .nav-link {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .6);\n\t\t\t\tpadding: $spacer * .25 $spacer * 1.5;\n\t\t\t\t\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), 1);\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".page-header {\n\tcolor: var(--#{$prefix}heading-color);\n\tpadding: 0;\n\tborder: none;\n\tmargin-bottom: $spacer;\n\tfont-weight: $font-weight-bold;\n\tfont-size: rem(28px);\n\t\n\t& small {\n\t\tfont-size: rem(16px);\n\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\tfont-weight: $font-weight-light;\n\t}\n}",".pagination {\n\t& .page-item {\n\t\t& .page-link {\n\t\t\tborder-radius: rem($border-radius);\n\t\t}\n\t\t& + .page-item {\n\t\t\t@if $enable-rtl {\n\t\t\t\tmargin-right: rem(5px);\n\t\t\t} @else {\n\t\t\t\tmargin-left: rem(5px);\n\t\t\t}\n\t\t}\n\t}\n}","pre {\n\tdisplay: block;\n\tpadding: rem(16px);\n\tfont-size: $font-size-base;\n\tcolor: $gray-700;\n\tword-break: break-all;\n\tword-wrap: break-word;\n\tbackground-color: $white;\n\tborder: 1px solid $gray-200;\n\tborder-radius: $border-radius;\n}",".row.row-grid {\n\t& > [class*=\"col-\"] {\n\t\t& + [class*=\"col-\"] {\n\t\t\tborder-left: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t}\n\t}\n\t& + .row-grid {\n\t\tborder-top: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15);\n\t}\n}",".table {\n\t&.table-card {\n\t\t& thead,\n\t\t& tbody {\n\t\t\t& > tr {\n\t\t\t\t& td,\n\t\t\t\t& th {\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: $card-spacer-x;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: $card-spacer-x;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-left: $card-spacer-x;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-right: $card-spacer-x;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.table-xs {\n\t\tfont-size: rem(12px);\n\t\t\n\t\t& thead,\n\t\t& tbody,\n\t\t& tfoot {\n\t\t\t& th {\n\t\t\t\tpadding-top: rem(4px);\n\t\t\t\tpadding-bottom: rem(4px);\n\t\t\t\tpadding-left: rem(8px);\n\t\t\t}\n\t\t\t& td {\n\t\t\t\tpadding: rem(5px) rem(8px);\n\t\t\t}\n\t\t}\n\t}\n}",".toasts-container {\n\tposition: fixed;\n\ttop: $app-header-height;\n\tpadding-top: $app-content-padding-y * 0.5;\n\twidth: rem(350px);\n\t\n\t@if $enable-rtl {\n\t\tleft: 0;\n\t\tpadding-left: $app-content-padding-y * 0.5;\n\t} @else {\n\t\tright: 0;\n\t\tpadding-right: $app-content-padding-y * 0.5;\n\t}\n\t\n\t@include media-breakpoint-down(md) {\n\t\twidth: rem(300px);\n\t}\n\t\n\t& .toast {\n\t\twidth: 100%;\n\t}\n}",".apexcharts-canvas {\n\t& .apexcharts-tooltip {\n\t\tfont-size: rem(13px);\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\t\n\t\t& * {\n\t\t\tfont-family: inherit !important;\n\t\t}\n\t\t&.apexcharts-theme-light,\n\t\t&.apexcharts-theme-dark {\n\t\t\tborder: none;\n\t\t\tbackground: rgba(var(--#{$prefix}body-bg-rgb), .9);\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\n\t\t\t& .apexcharts-tooltip-title {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tborder-color: transparent;\n\t\t\t\tcolor: var(--#{$prefix}inverse);;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\t\t}\n\t\t& .apexcharts-tooltip-title {\n\t\t\tfont-family: inherit !important;\n\t\t\tfont-weight: $headings-font-weight;\n\t\t\tpadding: $spacer * .35 $spacer * .75;\n\t\t\tmargin: 0;\n\t\t}\n\t\t& .apexcharts-tooltip-series-group {\n\t\t\tpadding: $spacer * .35 $spacer * .75;\n\t\t\t\n\t\t\t& .apexcharts-tooltip-marker {\n\t\t\t\twidth: rem(10px);\n\t\t\t\theight: rem(10px);\n\t\t\t\tmargin-right: $spacer * .25;\n\t\t\t}\n\t\t\t& .apexcharts-tooltip-text {\n\t\t\t\t& .apexcharts-tooltip-y-group {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& + .apexcharts-tooltip-series-group {\n\t\t\t\tpadding-top: 0;\n\t\t\t}\n\t\t}\n\t}\n\t& .apexcharts-xaxistooltip {\n\t\t& * {\n\t\t\tfont-family: inherit !important;\n\t\t}\n\t\t&.apexcharts-theme-light,\n\t\t&.apexcharts-theme-dark {\n\t\t\tcolor: $white;\n\t\t\tbackground: $gray-800;\n\t\t\tborder-color: $gray-800;\n\t\t\t\n\t\t\t&.apexcharts-xaxistooltip-bottom {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-bottom-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-bottom-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.apexcharts-xaxistooltip-top {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-top-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-top-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .apexcharts-yaxistooltip {\n\t\t& * {\n\t\t\tfont-family: inherit !important;\n\t\t}\n\t\t&.apexcharts-theme-light,\n\t\t&.apexcharts-theme-dark {\n\t\t\tcolor: $white;\n\t\t\tbackground: $gray-800;\n\t\t\tborder-color: $gray-800;\n\t\t\t\n\t\t\t&.apexcharts-yaxistooltip-right {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-right-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-right-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.apexcharts-yaxistooltip-left {\n\t\t\t\t&:before {\n\t\t\t\t\tborder-left-color: $gray-800;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-left-color: $gray-800;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .apexcharts-legend-marker {\n\t\twidth: rem(10px) !important;\n\t\theight: rem(10px) !important;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tmargin-left: rem(5px);\n\t\t} @else {\n\t\t\tmargin-right: rem(5px);\n\t\t}\n\t}\n\t& .apexcharts-menu {\n\t\tbackground: $dropdown-bg;\n\t\tborder: none;\n\t\tpadding: 0;\n\t\tborder-radius: $dropdown-border-radius;\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\t\n\t\t& .apexcharts-menu-item {\n\t\t\tcolor: $dropdown-link-color;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\tcolor: $dropdown-link-hover-color;\n\t\t\t}\n\t\t}\n\t}\n\t&.apexcharts-theme-light {\n\t\t& .apexcharts-selection-icon:not(.apexcharts-selected),\n\t\t& .apexcharts-zoom-icon:not(.apexcharts-selected),\n\t\t& .apexcharts-zoomin-icon,\n\t\t& .apexcharts-zoomout-icon,\n\t\t& .apexcharts-reset-icon,\n\t\t& .apexcharts-menu-icon {\n\t\t\t&:hover {\n\t\t\t\t& svg {\n\t\t\t\t\tfill: $white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".daterangepicker {\n\tbody & {\n\t\tz-index: $app-header-zindex + 10;\n\t\tborder-color: $dropdown-border-color;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\tbackground: $dropdown-bg;\n\t\tborder-radius: 0;\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\twidth: auto;\n\t\t\n\t\t&:before,\n\t\t&:after {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:after {\n\t\t\tborder-width: rem(7px);\n\t\t\ttop: rem(-7px);\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tright: rem(10px);\n\t\t\t\tleft: auto;\n\t\t\t} @else {\n\t\t\t\tleft: rem(10px);\n\t\t\t}\n\t\t}\n\t\t&.opensright {\n\t\t\t&:after {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tleft: rem(10px);\n\t\t\t\t\tright: auto;\n\t\t\t\t} @else {\n\t\t\t\t\tright: rem(10px);\n\t\t\t\t\tleft: auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& select.monthselect,\n\t\t& select.yearselect {\n\t\t\tfont-size: $font-size-base * .9;\n\t\t}\n\t\t& .drp-calendar {\n\t\t\tmax-width: inherit;\n\t\t\tpadding: rem(12px);\n\t\t\t\n\t\t\t& .calendar-table {\n\t\t\t\tbackground: none;\n\t\t\t\tborder: none;\n\t\t\t\tborder-radius: 0;\n\t\t\t\t\n\t\t\t\t& table {\n\t\t\t\t\t& thead,\n\t\t\t\t\t& tbody {\n\t\t\t\t\t\t& .week {\n\t\t\t\t\t\t\tfont-size: $font-size-base * .85;\n\t\t\t\t\t\t\tcolor: $gray-100;\n\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& thead {\n\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\t& th {\n\t\t\t\t\t\t\t\tmin-width: auto;\n\t\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t\tpadding: rem(6px) rem(12px);\n\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t\t\tfont-size: inherit;\n\t\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&.prev,\n\t\t\t\t\t\t\t\t&.next {\n\t\t\t\t\t\t\t\t\t& span {\n\t\t\t\t\t\t\t\t\t\tborder-color: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t& span {\n\t\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.month {\n\t\t\t\t\t\t\t\t\t& .yearselect,\n\t\t\t\t\t\t\t\t\t& .monthselect {\n\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\t\t\ttransition: all .2s linear;\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\t\t\t\t\t\tborder-color: $input-focus-border-color;\n\t\t\t\t\t\t\t\t\t\t\tbox-shadow: 0 0 0 0.125rem $input-focus-border-color;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t& th {\n\t\t\t\t\t\t\t\t\tfont-size: $font-size-base * .85;\n\t\t\t\t\t\t\t\t\tpadding-bottom: rem(8px);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& tbody {\n\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t\tmin-width: auto;\n\t\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\t\t\t\tpadding: rem(10px) rem(6px);\n\t\t\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\t\t\t\tborder-color: $dropdown-border-color;\n\t\t\t\t\t\t\t\tfont-size: $font-size-base * .9;\n\t\t\t\t\t\t\t\tborder-radius: 0 !important;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&.available {\n\t\t\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.in-range {\n\t\t\t\t\t\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .25);\n\t\t\t\t\t\t\t\t\t\tborder-color: rgba(var(--#{$prefix}theme-rgb), .5);\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.start-date {\n\t\t\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t&.end-date {\n\t\t\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.off {\n\t\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.left {\n\t\t\t\tpadding: rem(12px) !important;\n\t\t\t\t\n\t\t\t\t& .calendar-table {\n\t\t\t\t\tpadding: 0 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.right {\n\t\t\t\tpadding: rem(12px) !important;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .drp-buttons {\n\t\t\tpadding: rem(12px) rem(12px);\n\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .05);\n\t\t\tborder: none;\n\t\t\t\n\t\t\t& .btn {\n\t\t\t\t&.btn-primary {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 1px solid var(--#{$prefix}btn-border-color);\n\t\t\t\t\tcolor: var(--#{$prefix}btn-color);\n\t\t\t\t\t\n\t\t\t\t\t@include button-outline-variant($theme, $theme);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tbackground: var(--#{$prefix}btn-hover-bg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.btn-default {\n\t\t\t\t\tbackground: none;\n\t\t\t\t\tborder: 1px solid var(--#{$prefix}btn-border-color);\n\t\t\t\t\tcolor: var(--#{$prefix}btn-color);\n\t\t\t\t\t\n\t\t\t\t\t@include button-outline-variant($default, $default);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:active {\n\t\t\t\t\t\tcolor: $black;\n\t\t\t\t\t\tbackground: var(--#{$prefix}btn-hover-bg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .ranges {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&.show-ranges {\n\t\t\t& .ranges {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: block;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tfloat: none;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tpadding: rem(10px);\n\t\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\toverflow: scroll;\n\t\t\t\t\tmax-width: rem(560px);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& ul {\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-wrap: nowrap;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-left: rem(10px);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-right: rem(10px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t& li {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t\t\tfont-weight: $font-weight-base;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\tmargin-left: rem(10px) !important;\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\tmargin-right: rem(10px) !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\tmargin-left: rem(-1px);\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\tmargin-right: rem(-1px);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .drp-calendar {\n\t\t\t\t&.left { \n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tborder-right: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15) !important;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-left: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15) !important;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tborder-right: none !important;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tborder-left: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","body {\n\t& .dt-bootstrap5 {\n\t\t& .dataTable {\n\t\t\t&.dtr-inline {\n\t\t\t\t& tr {\n\t\t\t\t\t& td {\n\t\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\tcontent: '\\F64D' !important;\n\t\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\t\tborder: 1px solid var(--#{$prefix}border-color) !important;\n\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\t\tfont-size: $font-size-sm * .8;\n\t\t\t\t\t\t\t\twidth: rem(18px);\n\t\t\t\t\t\t\t\theight: rem(18px);\n\t\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t\t\t\tdisplay: inline-flex !important;\n\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t@include bootstrap-icons();\n\t\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\t\tfloat: right;\n\t\t\t\t\t\t\t\t\tmargin-left: $spacer * .5 !important;\n\t\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\t\tfloat: left;\n\t\t\t\t\t\t\t\t\tmargin-right: $spacer * .5 !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tborder-color: var(--#{$prefix}theme) !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.dt-hasChild {\n\t\t\t\t\t\t& > td,\n\t\t\t\t\t\t& > th {\n\t\t\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tcontent: '\\f068';\n\t\t\t\t\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& thead {\n\t\t\t\t& > tr {\n\t\t\t\t\t& > th,\n\t\t\t\t\t& > td {\n\t\t\t\t\t\t&.sorting,\n\t\t\t\t\t\t&.dt-orderable-asc,\n\t\t\t\t\t\t&.dt-orderable-desc {\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\toutline: 2px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t\toutline-offset: -2px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t& .dt-column-order {\n\t\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\t\tleft: rem(6px);\n\t\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\t\tright: rem(6px);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\tfont-size: $font-size-base;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\n\t\t\t\t\t\t&.dt-orderable-asc.dt-orderable-desc {\n\t\t\t\t\t\t\t& .dt-column-order {\n\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\tcontent: '\\f0dc';\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.dt-ordering-asc {\n\t\t\t\t\t\t\t\t& .dt-column-order {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tcontent: '\\f0dd';\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.dt-ordering-desc {\n\t\t\t\t\t\t\t\t& .dt-column-order {\n\t\t\t\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\t\t\t\tcontent: '\\f0de';\n\t\t\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.table-bordered {\n\t\t\t\t& th,\n\t\t\t\t& td {\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tborder-color: var(--#{$prefix}table-border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .dt-paging {\n\t\t\t& .pagination {\n\t\t\t\t--#{$prefix}pagination-padding-x: #{$pagination-padding-x-sm};\n\t\t\t\t--#{$prefix}pagination-padding-y: #{$pagination-padding-y-sm};\n\t\t\t\t--#{$prefix}pagination-border-radius: #{$pagination-border-radius-sm};\n\t\t\t\t\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\tfont-size: $font-size-sm;\n\t\t\t}\n\t\t}\n\t\t& .dt-scroll {\n\t\t\t& .dt-scroll-head {\n\t\t\t\t& .table-bordered {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}table-border-color);\n\t\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}table-border-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .dt-scroll-body {\n\t\t\t\t& .table-bordered {\n\t\t\t\t\t& tbody {\n\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t&:not(:last-child) {\n\t\t\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}table-border-color);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .dt-scroll-foot {\n\t\t\t\t& .table-bordered {\n\t\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}table-border-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .dtfc-scrolling-left {\n\t\t\t\t& tr > .dtfc-fixed-left::after {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}table-border-color);\n\t\t\t\t\tbox-shadow: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .dt-info {\n\t\t\tpadding-top: 0 !important;\n\t\t}\n\t\t& .btn.btn-secondary[class*=\"btn-outline-\"]:not(:hover):not(:focus) {\n\t\t\tbackground: none;\n\t\t}\n\t}\n}\n","@mixin bootstrap-icons() {\n\tdisplay: inline-block;\n\tfont-family: bootstrap-icons!important;\n\tfont-style: normal;\n\tfont-weight: 400!important;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\tvertical-align: -0.125em;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}",".fc-event-list {\n\t& .fc-event-item {\n\t\t& .fc-event-link {\n\t\t\tpadding: $spacer * .35 $spacer * .7;\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\tposition: relative;\n\t\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-radius: $border-radius;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tcontent: '\\f0b2';\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\tline-height: 1;\n\t\t\t\tmargin-left: auto;\n\t\t\t\t\n\t\t\t\t@include fontawesome();\n\t\t\t}\n\t\t}\n\t\t& + .fc-event-item {\n\t\t\tmargin-top: $spacer * .5;\n\t\t}\n\t}\n}\n.fc-event-link {\n\t&.fc-dragging,\n\t&.fc-event-dragging {\n\t\tpadding: $spacer * .35 $spacer * .7;\n\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tdisplay: block;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tborder-radius: $border-radius;\n\t\tbox-shadow: $dropdown-box-shadow;\n\t}\n}\n.fc {\n\t& .fc-toolbar,\n\t& .fc-header-toolbar {\n\t\tmargin-bottom: 0 !important;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\t\t\n\t\t& .fc-left,\n\t\t& .fc-toolbar-chunk:nth-child(1) {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer;\n\t\t\twidth: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t& .btn-group {\n\t\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t \t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .btn {\n\t\t\t\tmin-width: rem(100px);\n\t\t\t\tbackground: none;\n\t\t\t\tpadding-top: $spacer * .2;\n\t\t\t\tpadding-bottom: $spacer * .2;\n\t\t\t\tcolor: var(--#{$prefix}btn-color);\n\t\t\t\t\n\t\t\t\t@include button-outline-variant($default, $default);\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmin-width: rem(90px);\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:active {\n\t\t\t\t\tcolor: $black;\n\t\t\t\t\tbackground: var(--#{$prefix}btn-hover-bg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t@if $enable-rtl {\n\t\t\t& .fc-toolbar-chunk {\n\t\t\t\t& .btn-group {\n\t\t\t\t\t& > .btn {\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\n\t\t\t\t\t\t& + .btn {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\tmargin-left: -1px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tborder-top-left-radius: $border-radius;\n\t\t\t\t\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tborder-top-right-radius: $border-radius;\n\t\t\t\t\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .fc-center,\n\t\t& .fc-toolbar-chunk:nth-child(2) {\n\t\t\tflex: 1;\n\t\t\tpadding: $spacer;\n\t\t}\n\t\t& .fc-right,\n\t\t& .fc-toolbar-chunk:nth-child(3) {\n\t\t\tpadding: $spacer;\n\t\t\t\n\t\t\t& .btn {\n\t\t\t\tpadding-top: $spacer * .2;\n\t\t\t\tpadding-bottom: $spacer * .2;\n\t\t\t\tbackground: none;\n\t\t\t\t\n\t\t\t\t@include button-outline-variant($default, $default);\n\t\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:active {\n\t\t\t\t\tcolor: $black;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .fc-view {\n\t\t& .fc-event,\n\t\t& .fc-event-dot {\n\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\tborder-color: transparent;\n\t\t\t\n\t\t\t&.fc-daygrid-dot-event {\n\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n\t\t&.fc-dayGrid-view,\n\t\t&.fc-dayGridMonth-view {\n\t\t\t& .fc-week-number,\n\t\t\t& .fc-day-number,\n\t\t\t& .fc-daygrid-day-number {\n\t\t\t\tpadding: rem(2px) rem(4px);\n\t\t\t}\n\t\t\t& .fc-day-grid-event,\n\t\t\t& .fc-daygrid-day-events {\n\t\t\t\tmargin-top: rem(2px);\n\t\t\t}\n\t\t}\n\t\t&.fc-timeGrid-view {\n\t\t\t& .fc-time-grid {\n\t\t\t\t& .fc-slats,\n\t\t\t\t& .fc-bg {\n\t\t\t\t\t& table {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& tbody,\n\t\t\t\t\t\t& thead {\n\t\t\t\t\t\t\t& tr {\n\t\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t\t\t\tborder-top: none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .fc-content-skeleton {\n\t\t\t\t\t& table {\n\t\t\t\t\t\tborder: none !important;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& td,\n\t\t\t\t\t\t& th {\n\t\t\t\t\t\t\tborder: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& a {\n\t\t\ttext-decoration: none;\n\t\t}\n\t\t& .fc-daygrid-event,\n\t\t& .fc-timegrid-event-harness-inset .fc-timegrid-event, \n\t\t& .fc-timegrid-event.fc-event-mirror, \n\t\t& .fc-timegrid-more-link {\n\t\t\tbox-shadow: none;\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\t& td,\n\t& th {\n\t\tborder-width: 1px;\n\t\tborder-color: $table-border-color;\n\t}\n\t& .fc-view-harness {\n\t\theight: auto !important;\n\t}\n\t& .fc-scroller-liquid-absolute {\n\t\tposition: relative !important;\n\t\toverflow: initial !important;\n\t}\n\t& a:not([href]) {\n\t\tcolor: inherit;\n\t}\n}",".hljs {\n  display: block;\n  overflow-x: auto;\n  color: var(--#{$prefix}gray-500);\n  font-size: $font-size-base * .9;\n}\n.hljs-code,\n.hljs-emphasis {\n  font-style: italic;\n}\n.hljs-tag,\n.hljs-name {\n\tcolor: var(--#{$prefix}gray-300);\n}\n.hljs-string,\n.hljs-bullet {\n  color: var(--#{$prefix}indigo);\n}\n.hljs-attr {\n\tcolor: var(--#{$prefix}teal);\n}\n.hljs a {\n  color: inherit;\n  \n\t&:focus,\n\t&:hover {\n\t\tcolor: inherit;\n\t\ttext-decoration: underline;\n\t}\n}\n.hljs-container {\n  padding: $card-spacer-y $card-spacer-x;\n  border-top: 1px solid var(--#{$prefix}border-color);\n  position: relative;\n  z-index: 1;\n\t\n\t& pre {\n\t\tborder: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tbackground: none;\n\t\tborder-radius: 0;\n\t}\n}",".jvm-container {\n\t& .jvm-zoomin, \n\t& .jvm-zoomout, \n\t& .jvm-goback {\n\t\twidth: rem(18px);\n\t\theight: rem(18px);\n\t\tpadding: 0 0 rem(2px);\n\t\tbox-sizing: border-box;\n\t\tfont-size: rem(16px);\n\t\tbackground: var(--#{$prefix}body-bg);\n\t\tcolor: var(--#{$prefix}body-color);\n\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\tleft: $card-spacer-x;\n\t\tbox-shadow: none;\n\t\tborder-radius: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tz-index: 10;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tright: $card-spacer-x;\n\t\t\tleft: auto;\n\t\t} @else {\n\t\t\tleft: $card-spacer-x;\n\t\t}\n\t\t\n\t\t&:hover {\n\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\tbackground: var(--#{$prefix}theme);\n\t\t}\n\t}\n\t& .jvm-zoomin {\n\t\ttop: $card-spacer-x;\n\t}\n\t& .jvm-zoomout {\n\t\ttop: $card-spacer-x + rem(25px);\n\t}\n\t&.jvectormap-without-padding {\n\t\t& .jvm-zoomin {\n\t\t\ttop: 0;\n\t\t}\n\t\t& .jvm-zoomout {\n\t\t\ttop: rem(25px);\n\t\t}\n\t\t& .jvm-zoomin,\n\t\t& .jvm-zoomout {\n\t\t\t@if $enable-rtl {\n\t\t\t\tright: 0;\n\t\t\t\tleft: auto;\n\t\t\t} @else {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t}\n\t}\n\t& .jvm-legend {\n\t\tbackground: var(--#{$prefix}body-bg);\n\t\tcolor: var(--#{$prefix}body-color);\n\t\tbox-shadow: $dropdown-box-shadow;\n\t\tborder-radius: 0;\n\t}\n\t& .jvm-legend-title {\n\t\tfont-size: $font-size-base - rem(3px);\n\t\tpadding: $spacer * .3 $spacer * .5;\n\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t}\n\t& .jvm-legend-cnt-v {\n\t\t& .jvm-legend {\n\t\t\tpadding: 0;\n\t\t\tmargin: $card-spacer-x $card-spacer-x 0 0;\n\t\t\t\n\t\t\t& .jvm-legend-inner {\n\t\t\t\tpadding: $spacer * .5;\n\t\t\t}\n\t\t\t& .jvm-legend-tick {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t\t& .jvm-legend-tick-sample {\n\t\t\t\twidth: rem(16px);\n\t\t\t\theight: rem(16px);\n\t\t\t}\n\t\t\t& .jvm-legend-tick-text {\n\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t}\n\t\t}\n\t}\n}\n.jvm-tooltip {\n\tbackground: rgba(var(--#{$prefix}inverse-rgb), .9) !important;\n\tcolor: var(--#{$prefix}body-bg) !important;\n\tfont-weight: $font-weight-bold !important;\n\tpadding: rem(4px) rem(8px) !important;\n\tborder: none !important;\n\tfont-family: inherit !important;\n\tfont-size: $font-size-base * .9 !important;\n\tz-index: 1000;\n\tborder-radius: $border-radius !important;\n}",".ps {\n\tposition: relative;\n\t\n\t& .ps__rail-x,\n\t& .ps__rail-y {\n\t\tz-index: 10;\n\t\t\n\t\t&.ps--clicking,\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground: none;\n\t\t}\n\t}\n\t& .ps__thumb-y {\n\t\tborder-radius: 0;\n\t\tbackground: none;\n\t\t\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\tbackground: #aaa;\n\t\t\tposition: absolute;\n\t\t\ttop: rem(1px);\n\t\t\tbottom: rem(1px);\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t}\n\t}\n}\n.app-sidebar .ps__rail-x,\n.app-sidebar .ps__rail-y {\n\tdisplay: none;\n}",".rdt {\n\t& .rdtPicker {\n\t\twidth: auto;\n\t\tmin-width: auto;\n\t\tbackground: $dropdown-bg;\n\t\tborder: 1px solid $dropdown-border-color;\n\t\tborder-radius: $dropdown-border-radius;\n\t\tpadding: $spacer * .5 $spacer * .5;\n\t\t\n\t\t& table {\n\t\t\t& thead {\n\t\t\t\t& tr {\n\t\t\t\t\t& th {\n\t\t\t\t\t\t&.rdtPrev,\n\t\t\t\t\t\t&.rdtNext,\n\t\t\t\t\t\t&.rdtSwitch {\n\t\t\t\t\t\t\tline-height: rem(26px);\n\t\t\t\t\t\t\tpadding: $spacer * .25;\n\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\tmin-height: 30px;\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t& span:before {\n\t\t\t\t\t\t\t\t\tcolor: $dropdown-link-hover-color;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtPrev,\n\t\t\t\t\t\t&.rdtNext {\n\t\t\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\t\twidth: 14.28%;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t& span {\n\t\t\t\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t& i {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtPrev {\n\t\t\t\t\t\t\t& span:before {\n\t\t\t\t\t\t\t\tcontent: '\\f104';\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtNext {\n\t\t\t\t\t\t\t& span:before {\n\t\t\t\t\t\t\t\tcontent: '\\f105';\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.rdtSwitch {\n\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.dow {\n\t\t\t\t\t\t\tpadding: 5px 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& tfoot {\n\t\t\t\tborder: none;\n\t\t\t\t\n\t\t\t\t& tr {\n\t\t\t\t\t& td {\n\t\t\t\t\t\t&.rdtTimeToggle {\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t\t\t\ttext-shadow: none;\n\t\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\t\t\ttext-shadow: none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .rdtTime {\n\t\t\tmin-width: 180px;\n\t\t\t\n\t\t\t& .rdtCounters {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t\n\t\t\t\t& > div {\n\t\t\t\t\tfloat: none;\n\t\t\t\t}\n\t\t\t\t& .rdtCounter {\n\t\t\t\t\theight: 110px;\n\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\n\t\t\t\t\t& .rdtBtn {\n\t\t\t\t\t\theight: 35%;\n\t\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tcontent: '\\f106';\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t&:focus {\n\t\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .rdtCount {\n\t\t\t\t\t\theight: 30%;\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .75);\n\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& + .rdtBtn {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\tcontent: '\\f107';\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .rdtDays {\n\t\t\tmin-width: rem(280px);\n\t\t\t\n\t\t\t& .rdtDay {\n\t\t\t\tfont-weight: $font-weight-base;\n\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .75);\n\t\t\t\tpadding: $spacer * .25 $spacer * .25;\n\t\t\t\tline-height: rem(26px);\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus,\n\t\t\t\t&.rdtSelected,\n\t\t\t\t&.rdtHighlighted,\n\t\t\t\t&.rdtRange {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg !important;\n\t\t\t\t\ttext-shadow: none;\n\t\t\t\t}\n\t\t\t\t&.rdtToday {\n\t\t\t\t\tbackground: var(--#{$prefix}theme) !important;\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color) !important;\n\t\t\t\t\t\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tborder-bottom-color: var(--#{$prefix}body-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.rdtActive {\n\t\t\t\t\tbackground: var(--#{$prefix}theme) !important;\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color) !important;\n\t\t\t\t\ttext-shadow: none !important;\n\t\t\t\t}\n\t\t\t\t&.rdtOld {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .25);\n\t\t\t\t}\n\t\t\t\t&.rdtNew {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t}\n\t\t\t\t&.rdtDisabled {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .25);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbackground: none !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t\t& .rdtMonths,\n\t\t& .rdtYears {\n\t\t\tmin-width: rem(280px);\n\t\t\t\n\t\t\t& .rdtMonth,\n\t\t\t& .rdtYear {\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\ttext-shadow: none;\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t}\n\t\t\t\t&.rdtFocused {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\t}\n\t\t\t\t&.rdtActive {\n\t\t\t\t\tbackground: $dropdown-link-active-bg !important;\n\t\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".react-datepicker {\n\tborder: none;\n\tdisplay: block;\n\tfont-family: inherit;\n\tbackground: none;\n\t\n\t& .react-datepicker__navigation {\n\t\tcolor: transparent;\n\t\tpadding: rem(5px);\n\t\tline-height: rem(20px);\n\t\tborder: none;\n\t\twidth: rem(30px);\n\t\theight: rem(30px);\n\t\ttop: rem(5px);\n\t\ttext-indent: 0;\n\t\tborder-radius: $border-radius-lg;\n\t\t\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\toutline: none;\n\t\t\t\n\t\t\t&:after {\n\t\t\t\tcolor: $dropdown-link-hover-color;\n\t\t\t}\n\t\t}\n\t\t&:after {\n\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\tposition: absolute;\n\t\t\tfont-size: $font-size-base;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t@include fontawesome();\n\t\t}\n\t\t& .react-datepicker__navigation-icon {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&.react-datepicker__navigation--previous {\n\t\t\t&:after {\n\t\t\t\tcontent: '\\f104';\n\t\t\t}\n\t\t}\n\t\t&.react-datepicker__navigation--next {\n\t\t\t&:after {\n\t\t\t\tcontent: '\\f105';\n\t\t\t}\n\t\t}\n\t}\n\t& .react-datepicker__month-container {\n\t\tfloat: none;\n\t\t\n\t\t& .react-datepicker__header {\n\t\t\tbackground: none;\n\t\t\tborder: none;\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .react-datepicker__current-month {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tpadding: $spacer * .35;\n\t\t\t\tline-height: rem(26px);\n\t\t\t}\n\t\t\t& .react-datepicker__day-names {\n\t\t\t\tdisplay: flex;\n\t\t\t\tmargin-bottom: rem(-3px);\n\t\t\t\t\n\t\t\t\t& .react-datepicker__day-name {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .75);\n\t\t\t\t\tfont-size: $font-size-base;\n\t\t\t\t\tpadding: $spacer * .35;\n\t\t\t\t\tline-height: rem(26px);\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .react-datepicker__month {\n\t\t\tmargin: 0;\n\t\t\t\n\t\t\t& .react-datepicker__week {\n\t\t\t\tdisplay: flex;\n\t\t\t\t\n\t\t\t\t& .react-datepicker__day {\n\t\t\t\t\tpadding: $spacer * .35 $spacer * .5;\n\t\t\t\t\tmargin: $spacer * .15;\n\t\t\t\t\twidth: rem(30px);\n\t\t\t\t\tline-height: rem(20px);\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus,\n\t\t\t\t\t&.react-datepicker__day--today,\n\t\t\t\t\t&.react-datepicker__day--keyboard-selected {\n\t\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\t\t\toutline: none;\n\t\t\t\t\t}\n\t\t\t\t\t&.react-datepicker__day--selected {\n\t\t\t\t\t\tbackground: var(--#{$prefix}theme) !important;\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color) !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\nbody {\n\t& .react-datepicker__triangle {\n\t\tdisplay: none;\n\t}\n\t& .react-datepicker-popper {\n\t\tpadding: $spacer * .5;\n\t\tbackground: $dropdown-bg;\n\t\tz-index: 10;\n\t\tborder-radius: $dropdown-border-radius;\n\t\tborder: 1px solid $dropdown-border-color;\n\t}\n\t& .react-datepicker-wrapper {\n\t\tdisplay: block;\n\t}\n}","body {\n\t& .ql-toolbar,\n\t& .ql-container {\n\t\tborder-color: var(--#{$prefix}border-color) !important;\n\t\t\n\t\t& .ql-picker {\n\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t}\n\t\t& button,\n\t\t& .ql-picker-label,\n\t\t& .ql-picker-item {\n\t\t\tborder: none !important;\n\t\t\t\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tbackground: rgba(var(--#{$prefix}body-color-rgb), .25) !important;\n\t\t\t\tcolor: var(--#{$prefix}body-color) !important;\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t& .ql-fill {\n\t\t\t\t\tfill: var(--#{$prefix}body-color) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.ql-active {\n\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .25) !important;\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\tcolor: var(--#{$prefix}theme) !important;\n\t\t\t\tborder: none !important;\n\t\t\t\t\n\t\t\t\t& .ql-stroke {\n\t\t\t\t\tstroke: var(--#{$prefix}theme) !important;\n\t\t\t\t}\n\t\t\t\t& .ql-fill {\n\t\t\t\t\tfill: var(--#{$prefix}theme) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .ql-picker-options {\n\t\t\tborder-radius: $dropdown-border-radius !important;\n\t\t\tborder: 1px solid $dropdown-border-color !important;\n\t\t\tmargin-top: $spacer * .5 !important;\n\t\t\toverflow: hidden;\n\t\t\tbox-shadow: $box-shadow-lg;\n\t\t\tpadding: 0;\n\t\t\tbackground: $dropdown-bg;\n\t\t\t\n\t\t\t& .ql-picker-item {\n\t\t\t\tborder-radius: 0 !important;\n\t\t\t\tpadding: $spacer * .5 $spacer;\n\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg !important;\n\t\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\t}\n\t\t\t\t&.ql-selected {\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .25) !important;\n\t\t\t\t\tcolor: var(--#{$prefix}theme) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .ql-stroke {\n\t\t\tfill: transparent !important;\n\t\t\tstroke: var(--#{$prefix}body-color) !important;\n\t\t}\n\t}\n\t& .ql-toolbar {\n\t\tborder-radius: $border-radius $border-radius 0 0 !important;\n\t}\n\t& .ql-container {\n\t\tborder-radius: 0 0 $border-radius $border-radius !important;\n\t}\n}\n.border-0 .ql-toolbar {\n\tborder-top: none !important;\n\tborder-left: none !important;\n\tborder-right: none !important;\n}\n.border-0 .ql-container {\n\tborder: none !important;\n}","body {\n\t& .react-select__control {\n\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\tbackground: none;\n\t\tborder-radius: $border-radius;\n\t\tpadding: 0.375rem 0.75rem;\n\t\tmin-height: rem(35px);\n\t\t\n\t\t&:hover {\n\t\t\tborder-color: var(--#{$prefix}border-color);\n\t\t}\n\t\t&.react-select__control--is-focused {\n\t\t\tbox-shadow: $input-btn-focus-box-shadow;\n\t\t\tborder-color: $input-focus-border-color;\n\t\t}\n\t\t& .react-select__value-container {\n\t\t\tpadding: 0;\n\t\t\t\n\t\t\t& .react-select__placeholder {\n\t\t\t\tmargin: 0;\n\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t}\n\t\t\t& .react-select__single-value {\n\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t}\n\t\t\t& .react-select__input-container {\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\t\n\t\t\t\t& .react-select__input {\n\t\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.react-select__value-container--is-multi {\n\t\t\t\tmargin-bottom: rem(-5px);\n\t\t\t\t\n\t\t\t\t& .react-select__placeholder,\n\t\t\t\t& .react-select__input-container {\n\t\t\t\t\tmargin-top: rem(-5px);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .react-select__multi-value {\n\t\t\t\t\tmargin: 0 rem(4px) rem(4px) 0;\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t\t\n\t\t\t\t\t& .react-select__multi-value__label {\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\t\tfont-size: rem(12px);\n\t\t\t\t\t\tpadding: rem(2px);\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: rem(6px);\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: rem(6px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .react-select__multi-value__remove {\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tpadding: 0 3px;\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}theme-color-rgb), .5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .react-select__indicators {\n\t\t\t& .react-select__indicator {\n\t\t\t\tpadding: 0;\n\t\t\t\tcolor: rgba(var(--#{$prefix}body-color-rgb), .5);\n\t\t\t\t\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .react-select__indicator-separator {\n\t\t\t\tbackground: none;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n\t& .react-select__menu {\n\t\tbackground: $dropdown-bg;\n\t\tborder-radius: $dropdown-border-radius;\n\t\tborder: 1px solid $dropdown-border-color;\n\t\toverflow: hidden;\n\t\t\n\t\t& .react-select__menu-list {\n\t\t\t& .react-select__option {\n\t\t\t\t&.react-select__option--is-focused {\n\t\t\t\t\tbackground: $dropdown-link-hover-bg;\n\t\t\t\t}\n\t\t\t\t&.react-select__option--is-selected {\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t}\n\t\t\t\t&.react-select__option--is-disabled {\n\t\t\t\t\topacity: .25;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","body {\n\t& .sketch-picker,\n\t& .chrome-picker {\n\t\tbackground: none !important;\n\t\t\n\t\t& input {\n\t\t\twidth: 100% !important;\n\t\t\tborder: 1px solid $input-border-color !important;\n\t\t\tborder-radius: $input-border-radius;\n\t\t\ttransition: $input-transition;\n\t\t\tbox-shadow: none !important;\n\t\t\ttext-align: center;\n\t\t\tbackground: none !important;\n\t\t\tcolor: var(--#{$prefix}body-color) !important;\n\t\t\n\t\t\t&:focus {\n\t\t\t\tborder-color: $input-focus-border-color !important;\n\t\t\t\tbox-shadow: $input-btn-focus-box-shadow !important;\n\t\t\t\toutline: none !important;\n\t\t\t}\n\t\t}\n\t\t& .flexbox-fix:last-child {\n\t\t\tborder-color: var(--#{$prefix}border-color) !important;\n\t\t}\n\t\t& label {\n\t\t\tcolor: var(--#{$prefix}body-color) !important;\n\t\t}\n\t}\n\t& .dropdown-menu {\n\t\t& .sketch-picker,\n\t\t& .chrome-picker {\n\t\t\tborder: 1px solid var(--#{$prefix}dropdown-border-color);\n\t\t\tborder-radius: $dropdown-border-radius !important;\n\t\t\t\n\t\t\t& input:not(:focus),\n\t\t\t& .flexbox-fix:last-child {\n\t\t\t\tborder-color: var(--#{$prefix}dropdown-border-color) !important;\n\t\t\t}\n\t\t}\n\t}\n}","body .rti--container {\n\tbackground: transparent;\n\tborder: 1px solid $input-border-color;\n\tborder-radius: $border-radius;\n\tpadding: $input-padding-y - rem(2px) $input-padding-x;\n\tline-height: 1;\n\tgap: rem(4px);\n\t\n\t&:focus-within {\n\t\tborder-color: $input-focus-border-color;\n\t\tbox-shadow: $input-focus-box-shadow;\n\t}\n\t& .rti--tag {\n\t\tfont-size: rem(12px);\n\t\tcolor: var(--#{$prefix}theme-color);\n\t\tline-height: rem(15px);\n\t\tmin-height: rem(20px);\n\t\tfont-weight: 500;\n\t\tborder-radius: rem(20px);\n\t\tpadding: rem(5px) rem(12px);\n\t\tbackground: var(--#{$prefix}theme);\n\t\t\n\t\t& button {\n\t\t\tmargin-top: rem(1px);\n\t\t\tmargin-bottom: rem(-1px);\n\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tmargin-left: rem(-5px);\n\t\t\t\tmargin-right: rem(5px);\n\t\t\t} @else {\n\t\t\t\tmargin-right: rem(-5px);\n\t\t\t\tmargin-left: rem(5px);\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\topacity: .5;\n\t\t\t}\n\t\t}\n\t}\n\t& .rti--input {\n\t\tbackground: none;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\t\n\t\t&::placeholder {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tfont-weight: $input-font-weight;\n\t\t}\n\t}\n}",".calendar {\n\tmin-height: calc(100vh - #{$app-header-height});\n\tdisplay: flex;\n\t\n\t@if ($enable-rtl) {\n\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t} @else {\n\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t}\n\t@include media-breakpoint-down(md) {\n\t\tborder: none;\n\t}\n\t\n\t& .calendar-body {\n\t\tflex: 1;\n\t\theight: calc(100vh - #{$app-header-height});\n\t\t\n\t\t& + .calendar-sidebar {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .fc {\n\t\t\t& .fc-head-container  {\n\t\t\t\t& th {\n\t\t\t\t\tborder-bottom-width: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& table {\n\t\t\t\tborder: none !important;\n\t\t\t\n\t\t\t\t& thead,\n\t\t\t\t& tbody {\n\t\t\t\t\t& tr {\n\t\t\t\t\t\tborder-width: 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& th,\n\t\t\t\t\t\t& td {\n\t\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\t\t\t\tborder-right-width: 0 !important;\n\t\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\t\tborder-left-width: 0 !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\t\t\t\tborder-left-width: 0 !important;\n\t\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\t\tborder-right-width: 0 !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .fc-head-container  {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .calendar-sidebar {\n\t\twidth: rem(220px);\n\t\tpadding: $spacer;\n\t\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\theight: calc(100vh - #{$app-header-height});\n\t\t}\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\t\t& + .calendar-body {\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t\t& .calendar-sidebar-title {\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tmargin-bottom: $spacer * .5;\n\t\t\tfont-size: $font-size-base;\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-end;\n\t\t}\n\t}\n}",".coming-soon {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t& .coming-soon-img {\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n\t& .coming-soon-timer {\n\t\tpadding: $spacer * 2;\n\t\tmin-height: 50vh;\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tjustify-content: center;\n\t}\n\t& .coming-soon-content {\n\t\tmin-height: 50vh;\n\t\tposition: relative;\n\t\ttext-align: center;\n\t\tmargin: 0 auto;\n\t\tpadding: $spacer * 2;\n\t\tbackground: linear-gradient(to bottom, rgba(var(--#{$prefix}inverse-rgb), .15) 0%, transparent 100%);\n\t\tflex: 1;\n\t\t\n\t\t& > * {\n\t\t\tmax-width: rem(520px);\n\t\t\tmargin-left: auto;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n\t& .is-countdown {\n\t\tbackground: none;\n\t\tborder: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\t\n\t\t@include clearfix();\n\t\t\n\t\t& .countdown-row {\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t& .countdown-section {\n\t\t\t\twidth: rem(120px);\n\t\t\t\tpadding: $spacer;\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tmargin: $spacer * .75;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tborder-radius: $border-radius-lg * 1.5;\n\t\t\t\n\t\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\t\twidth: rem(80px);\n\t\t\t\t\tpadding: $spacer * .5 0;\n\t\t\t\t\tmargin: $spacer * .25;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .countdown-amount {\n\t\t\tfont-size: rem(48px);\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tline-height: 1.25;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(28px);\n\t\t\t}\n\t\t}\n\t\t& .countdown-period {\n\t\t\tfont-size: $font-size-base * 1.15;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\tline-height: 1.5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: $font-size-base * .9;\n\t\t\t}\n\t\t}\n\t}\n}","@mixin clearfix() {\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n}",".data-management {\n\t& .dataTables_wrapper {\n\t\t& .dataTable {\n\t\t\tmargin-top: 0 !important;\n\t\t\tmargin-bottom: 0 !important;\n\t\t\tcolor: var(--#{$prefix}body-color);\n\t\t}\n\t\t& .dataTables_filter {\n\t\t\ttext-align: left;\n\t\t\tmargin-bottom: $spacer;\n\t\t\tfont-size: rem(12px);\n\t\t\t\n\t\t\t& label {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t\t& input {\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\tfont-size: rem(13px);\n\t\t\t\tmin-width: rem(200px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmin-width: inherit;\n\t\t\t\t\tflex: 1;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".error-page {\n\tmin-height: 100vh;\n\tpadding: $spacer * 4 0;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t& .error-page-content {\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\tpadding: 0 $spacer;\n\t\ttext-align: center;\n\t\t\n\t\t& .error-code {\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tfont-size: rem(118px);\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\ttext-align: center;\n\t\t\tline-height: 1.25;\n\t\t\tletter-spacing: 5px;\n\t\t\ttext-shadow: 10px 10px rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(102px);\n\t\t\t}\n\t\t}\n\t\t& .error-page-icon i {\n\t\t\tfont-size: rem(128px);\n\t\t\tcolor: $gray-300;\n\t\t}\n\t\t& h1 {\n\t\t\tfont-size: rem(48px);\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(52px);\n\t\t\t}\n\t\t}\n\t\t& h3 {\n\t\t\tfont-size: rem(18px);\n\t\t\tfont-weight: 400;\n\t\t\t\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\tfont-size: rem(16px);\n\t\t\t}\n\t\t}\n\t\t& .link-divider {\n\t\t\twidth: rem(4px);\n\t\t\theight: rem(4px);\n\t\t\tdisplay: inline-block;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .3);\n\t\t\tposition: relative;\n\t\t\ttop: rem(-2px);\n\t\t\tmargin: 0 $spacer;\n\t\t\tborder-radius: $border-radius;\n\t\t}\n\t}\n}",".file-tree {\n\tposition: relative;\n\t\n\t& .file-node {\n\t\tposition: relative;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tpadding-right: rem-default(15px);\n\t\t} @else {\n\t\t\tpadding-left: rem-default(15px);\n\t\t}\n\t\t\n\t\t& .file-link {\n\t\t\ttext-decoration: none;\n\t\t\tpadding: $spacer * .25 $spacer * .25;\n\t\t\tcolor: var(--#{$prefix}body-text);\n\t\t\tposition: relative;\n\t\t\tborder-radius: $border-radius;\n\t\t\tdisplay: flex;\n\t\t\tfont-size: $font-size-sm;\n\t\t\t\n\t\t\t& > * {\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\topacity: .75;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t& .file-info {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t\t& .file-icon {\n\t\t\t\tfont-size: $font-size-lg;\n\t\t\t\twidth: rem(20px);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-left: $spacer * .35;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer * .35;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .file-text {\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t}\n\t\t&.has-sub {\n\t\t\t& > .file-link {\n\t\t\t\t& .file-arrow:before {\n\t\t\t\t\tcontent: '\\2b';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tmargin-top: $font-size-base * $line-height-base * -.5;\n\t\t\t\t\twidth: rem(12px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tright: rem(-12px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: rem(-12px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.expand {\n\t\t\t\t& > .file-tree {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t& > .file-link {\n\t\t\t\t\t& .file-arrow:before {\n\t\t\t\t\t\tcontent: '\\f068';\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.selected {\n\t\t\t& > .file-link {\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\n\t\t\t\t& > .file-info {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .file-tree {\n\t\tdisplay: none;\n\t}\n}\n\n.file-manager {\n\t--#{$prefix}file-manager-sidebar-width: #{rem(250px)};\n\t--#{$prefix}file-manager-mobile-sidebar-margin: #{rem(-250px)};\n\t\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: hidden;\n\tposition: relative;\n\t\n\t& .file-manager-toolbar {\n\t\tbackground: rgba(var(--#{$prefix}body-bg-rgb), .5);\n\t\tpadding: $spacer * .25;\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\tflex-wrap: nowrap;\n\t\t\twhite-space: nowrap;\n\t\t}\n\t}\n\t& .file-manager-container {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\toverflow: hidden;\n\t\tposition: relative;\n\t\t\n\t\t& .file-manager-sidebar {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\twidth: var(--#{$prefix}file-manager-sidebar-width);\n\t\t\tmin-width: var(--#{$prefix}file-manager-sidebar-width);\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tbackground: rgba(var(--#{$prefix}body-bg-rgb), .95);\n\t\t\t\tz-index: 10;\n\t\t\t\ttransition: $transition-base;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tright: var(--#{$prefix}file-manager-mobile-sidebar-margin);\n\t\t\t\t\tmargin-right: rem(1px);\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color-translucent);\n\t\t\t\t} @else {\n\t\t\t\t\tleft: var(--#{$prefix}file-manager-mobile-sidebar-margin);\n\t\t\t\t\tmargin-left: rem(1px);\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color-translucent);\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t& .file-manager-sidebar-mobile-toggler {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: $spacer;\n\t\t\t\twidth: $spacer * 2;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tright: 100%;\n\t\t\t\t\tmargin-right: rem(1px);\n\t\t\t\t} @else {\n\t\t\t\t\tleft: 100%;\n\t\t\t\t\tmargin-left: rem(1px);\n\t\t\t\t}\n\t\t\t\t& .btn {\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}body-bg-rgb), .95);\n\t\t\t\t\tcolor: var(--#{$prefix}component-color);\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\tpadding: $spacer * .5 $spacer * .65;\n\t\t\t\t\tbox-shadow: $box-shadow;\n\t\t\t\t\ttransition: $transition-base;\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tborder-top-left-radius: $border-radius;\n\t\t\t\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t\t\t\t\tborder: 1px solid var(--#{$prefix}border-color-translucent);\n\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-top-right-radius: $border-radius;\n\t\t\t\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t\t\t\t\tborder: 1px solid var(--#{$prefix}border-color-translucent);\n\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t& .file-manager-sidebar-content {\n\t\t\t\tflex: 1;\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\t\t\t& .file-manager-sidebar-footer {\n\t\t\t\tpadding: $spacer * .5 $spacer;\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t\t& .file-manager-content {\n\t\t\tflex: 1;\n\t\t\t\n\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\toverflow: scroll;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\t\t}\n\t}\n\t&.file-manager-sidebar-mobile-toggled {\n\t\t& .file-manager-sidebar {\n\t\t\t@if $enable-rtl {\n\t\t\t\tright: 0;\n\t\t\t} @else {\n\t\t\t\tleft: 0;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tbox-shadow: $box-shadow-lg;\n\t\t\t}\n\t\t\t& .file-manager-sidebar-mobile-toggler {\n\t\t\t\t& .btn {\n\t\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".gallery-menu-container {\n\tmin-width: rem(200px);\n\t\n\t@include media-breakpoint-up(md) {\n\t\tmin-height: calc(100vh - #{$app-header-height});\n\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t}\n}\n.gallery-menu {\n\tpadding: $spacer;\n\tpadding: 0;\n\t\n\t@include media-breakpoint-down(md) {\n\t\toverflow: scroll;\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\tposition: sticky;\n\t\ttop: $app-header-height;\n\t\tdisplay: flex;\n\t\tflex-wrap: nowrap;\n\t}\n\t& .gallery-menu-header {\n\t\tpadding: $spacer $spacer $spacer * .25;\n\t\tfont-weight: $font-weight-bold;\n\t\tfont-size: 90%;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t& .gallery-menu-item {\n\t\t& .gallery-menu-link {\n\t\t\tpadding: $spacer * .35 $spacer * 1.25;\n\t\t\tdisplay: block;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tpadding: rem(15px) rem(20px) rem(10px);\n\t\t\t}\n\t\t\t\n\t\t\t& .fa {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tmargin: 0 0 rem(3px) !important;\n\t\t\t\t\twidth: auto !important;\n\t\t\t\t\tfont-size: rem(18px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\n\t\t\t\t& .fa {\n\t\t\t\t\tcolor: inherit;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.gallery-content-container {\n\twidth: 100%;\n\t\n\t@include media-breakpoint-up(md) {\n\t\tmin-height: calc(100vh - #{$app-header-height});\n\t}\n}\n.gallery {\n\tpadding: $spacer;\n\t\n\t& + .gallery {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t}\n\t& .gallery-title {\n\t\tfont-size: $font-size-base * 1.25;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tfont-weight: $font-weight-bold;\n\t\tmargin-bottom: $spacer;\n\t\t\n\t\t& a {\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t& i {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-right: rem(5px);\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: rem(5px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& small {\n\t\t\tdisplay: block;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tfont-size: $font-size-base * .9;\n\t\t}\n\t}\n\t& .gallery-image-list {\n\t\tlist-style-type: none;\n\t\tmargin: $spacer * -.15;\n\t\tpadding: 0;\n\t\n\t\t@include clearfix();\n\t\n\t\t& > li {\n\t\t\tposition: relative;\n\t\t\tpadding-top: 12.5%;\n\t\t\twidth: 16.6667%;\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tfloat: right;\n\t\t\t} @else {\n\t\t\t\tfloat: left;\n\t\t\t}\n\t\t\n\t\t\t@include media-breakpoint-down(lg) { \n\t\t\t\twidth: 25%;\n\t\t\t\tpadding-top: 18.75%;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twidth: 33.33%;\n\t\t\t\tpadding-top: 33.33%;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(sm) {\n\t\t\t\twidth: 50%;\n\t\t\t\tpadding-top: 50%;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tz-index: 10;\n\t\t\t}\n\t\t\t& a {\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: $spacer * .15;\n\t\t\t\tright: $spacer * .15;\n\t\t\t\tbottom: $spacer * .15;\n\t\t\t\ttop: $spacer * .15;\n\t\t\t\toverflow: hidden;\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\ttransition: all .2s ease-in-out;\n\t\t\t\n\t\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tleft: -15%;\n\t\t\t\t\t\tright: -15%;\n\t\t\t\t\t\ttop: -15%;\n\t\t\t\t\t\tbottom: -15%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& img,\n\t\t\t& .img {\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t\t& .img-portrait {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: auto;\n\t\t\t\tmax-height: 100%;\n\t\t\t\tmax-width: inherit;\n\t\t\t}\n\t\t\t& .img-portrait-xs {\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\theight: 100%;\n\t\t\t\t\twidth: auto;\n\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\tmax-width: inherit;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".login {\n\tmin-height: 100vh;\n\tpadding: $spacer * 3 $spacer;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t@include media-breakpoint-down(md) {\n\t\tpadding: $spacer;\n\t}\n\t\n\t& .login-content {\n\t\tmax-width: rem(360px);\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\tflex: 1;\n\t}\n}",".mailbox {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t\n\t& .mailbox-toolbar {\n\t\tpadding: $spacer * .75;\n\t\tdisplay: flex;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\twhite-space: nowrap;\n\t\t\tpadding: $spacer * .5;\n\t\t\tflex-wrap: nowrap;\n\t\t}\n\t\t& .mailbox-toolbar-text {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tpadding: $spacer * .5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-toolbar-link {\n\t\t\tpadding: $spacer * .5 $spacer;\n\t\t}\n\t\t& .mailbox-toolbar-item {\n\t\t\tpadding: $spacer * .5;\n\t\t}\n\t\t& .mailbox-toolbar-link {\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\ttext-decoration: none;\n\t\t\tborder-radius: $border-radius;\n\t\t\t\n\t\t\t&:hover {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\tcolor: $component-active-color;\t\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t}\n\t\t}\n\t}\n\t& .mailbox-body {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\toverflow: hidden;\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\t\n\t\t& .mailbox-sidebar {\n\t\t\tmax-width: rem(360px);\n\t\t\theight: 100%;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tmax-width: 100%;\n\t\t\t\theight: auto;\n\t\t\t}\n\t\t\t\n\t\t\t& + .mailbox-content {\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .mailbox-content {\n\t\t\theight: 100%;\n\t\t\tflex: 1;\n\t\t}\n\t}\n\t& .mailbox-empty-message {\n\t\tmin-height: 100%;\n\t\twidth: 100%;\n\t\tpadding: $spacer * 2;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t\n\t\t& .mailbox-empty-message-icon {\n\t\t\t& i {\n\t\t\t\tfont-size: $font-size-base * 7;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-empty-message-img {\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: $spacer;\n\t\t\t\n\t\t\t& img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tmax-width: rem(480px);\n\t\t\t\tmax-height: rem(480px);\n\t\t\t\topacity: 0.5\n\t\t\t}\n\t\t}\n\t\t& .mailbox-empty-message-title {\n\t\t\tfont-size: $font-size-base * 1.5;\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t}\n\t}\n\t& .mailbox-list {\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\n\t\t& .mailbox-list-item {\n\t\t\tpadding: $spacer;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& + .mailbox-list-item {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t\t&.unread {\n\t\t\t\t& .mailbox-message {\n\t\t\t\t\t& .mailbox-title {\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t\t&.has-attachment {\n\t\t\t\t& .mailbox-checkbox:after {\n\t\t\t\t\tcontent: '\\f0c1';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: rem(25px);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\twidth: rem(18px);\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .mailbox-checkbox {\n\t\t\tposition: relative;\n\t\t\t\n\t\t\t& + .mailbox-message {\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tpadding-right: $spacer * .5;\n\t\t\t\t} @else {\n\t\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .mailbox-message {\n\t\t\tflex: 1;\n\t\t\n\t\t\t& .mailbox-list-item-link {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\ttext-decoration: none;\n\t\t\t\tposition: relative;\n\t\t\t}\n\t\t\t& .mailbox-sender {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .mailbox-sender-name {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\tflex: 1;\n\t\t\t\t\t\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .mailbox-time {\n\t\t\t\t\tfont-size: $font-size-base - rem(2px);\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-weight: $font-weight-base;\n\t\t\t\t\t\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tpadding-right: $spacer * .5;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: $spacer * .5;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .mailbox-title {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\t\t\twhite-space: nowrap;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\tmax-width: rem(290px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmax-width: initial;\n\t\t\t\t\twhite-space: initial;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .mailbox-desc {\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\tmax-height: rem(42px);\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\t\t}\n\t}\n\t& .mailbox-detail {\n\t\tpadding: $spacer * 1.5;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tpadding: $spacer;\n\t\t}\n\t\t\n\t\t& .mailbox-detail-header {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: 0 0 $spacer * 1.5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding-bottom: $spacer;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-detail-content {\n\t\t\tpadding: $spacer * 1.5 0;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding: $spacer 0;\n\t\t\t}\n\t\t}\n\t\t& .mailbox-detail-body {\n\t\t\tfont-size: $font-size-base;\n\t\t}\n\t\t& .mailbox-detail-attachment {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\t\n\t\t\t& .mailbox-attachment {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\twidth: rem(120px);\n\t\t\t\toverflow: hidden;\n\t\t\t\tmargin-bottom: $spacer * .5;\n\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tmargin-left: $spacer * .5;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer * .5;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& a {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t}\n\t\t\t\t& .document-file {\n\t\t\t\t\theight: rem(60px);\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t\t\t\n\t\t\t\t\t& i {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tline-height: rem(60px);\n\t\t\t\t\t\tfont-size: rem(32px);\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t\t& img {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .document-name {\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\tpadding: rem(2px) rem(10px);\n\t\t\t\t\tfont-size: $font-size-base - rem(1px);\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .mailbox-form {\n\t\t& .mailbox-form-header {\n\t\t\tpadding: $spacer $spacer * 1.5;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tpadding: $spacer * .75 $spacer;\n\t\t\t}\n\t\t\t\n\t\t\t& .form-control {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t}\n\t\t& .note-editor {\n\t\t\tborder: none;\n\t\t\tborder-radius: 0;\n\t\t\t\n\t\t\t& .note-toolbar {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t& .note-editing-area {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t}\n\t\t}\n\t}\n}",".messenger {\n\theight: 100%;\n\tdisplay: flex;\n\t\n\t& .messenger-sidebar {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\tmax-width: rem(360px);\n\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t}\n\t\t& .messenger-sidebar-header {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer;\n\t\t}\n\t\t& .messenger-sidebar-body {\n\t\t\tflex: 1;\n\t\t\toverflow: hidden;\n\t\t}\n\t\t& .messenger-item {\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t\n\t\t\t& .messenger-link {\n\t\t\t\tdisplay: flex;\n\t\t\t\tpadding: $spacer * .85 $spacer;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\t}\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tbackground-color: rgba(var(--#{$prefix}inverse-rgb), .1);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& .messenger-media {\n\t\t\t\t\twidth: rem(40px);\n\t\t\t\t\theight: rem(40px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t& img {\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t& + .messenger-info {\n\t\t\t\t\t\tpadding-left: $spacer * .85;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .messenger-info {\n\t\t\t\t\tflex: 1;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t}\n\t\t\t\t& .messenger-time-badge {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t}\n\t\t\t\t& .messenger-time {\n\t\t\t\t\tfont-size: $font-size-sm * .85;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tmargin-bottom: $spacer * .25;\n\t\t\t\t}\n\t\t\t\t& .messenger-text,\n\t\t\t\t& .messenger-name {\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\tmax-width: rem(220px);\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-size: $font-size-sm;\n\t\t\t\t}\n\t\t\t\t& .messenger-name {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t\t& .messenger-badge {\n\t\t\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tborder-radius: rem(30px);\n\t\t\t\t\tpadding: 0 rem(3px);\n\t\t\t\t\tmin-width: rem(18px);\n\t\t\t\t\tmin-height: rem(18px);\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tfont-size: $font-size-base * .65;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\n\t\t\t\t\t&.empty {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .messenger-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\t\t& .messenger-content-header {\n\t\t\tdisplay: flex;\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer * .75 $spacer;\n\t\t\talign-items: center;\n\t\t\t\n\t\t\t& .messenger-content-header-mobile-toggler {\n\t\t\t\tdisplay: none;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& a {\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-size: rem(18px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .messenger-content-header-media {\n\t\t\t\t& .media {\n\t\t\t\t\twidth: rem(40px);\n\t\t\t\t\theight: rem(40px);\n\t\t\t\t\tborder-radius: 40px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t\t& + .messenger-content-header-info {\n\t\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .messenger-content-header-info {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tfont-size: rem(15px);\n\t\t\t\tflex: 1;\n\t\t\t\t\n\t\t\t\t& small {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tfont-size: rem(11px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .messenger-content-header-btn {\n\t\t\t\tdisplay: flex;\n\t\t\t\t\n\t\t\t\t& .btn {\n\t\t\t\t\tfont-size: rem(16px);\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\t\t\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .messenger-content-body {\n\t\t\tflex: 1;\n\t\t\toverflow: hidden;\n\t\t\t\n\t\t\t& .widget-chat {\n\t\t\t\tpadding: $spacer;\n\t\t\t}\n\t\t}\n\t\t& .messenger-content-footer {\n\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer;\n\t\t}\n\t}\n\t&.messenger-content-toggled {\n\t\t@include media-breakpoint-down(lg) {\n\t\t\t& .messenger-sidebar {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t& .messenger-content {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\n\t}\n}",".pos {\n\tbackground: var(--app-pos-bg);\n\theight: 100%;\n\t\t\n\t& .pos-container {\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\tdisplay: flex;\n\t\t\n\t\t\t& > div + div {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-menu {\n\t\tdisplay: flex;\n\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\twidth: $pos-sidebar-menu-width;\n\t\t\tflex-direction: column;\n\t\t}\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\talign-items: center;\n\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t}\n\t\n\t\t& .logo {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: $spacer;\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\twidth: $pos-sidebar-menu-width;\n\t\t\t\theight: rem(95px);\n\t\t\t\tflex: 0 0 $pos-sidebar-menu-width;\n\t\t\t}\n\t\t\t& a {\n\t\t\t\tdisplay: block;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t\t& .logo-img {\n\t\t\t\ttext-align: center;\n\t\t\t\theight: rem(46px);\n\t\t\t}\n\t\t\t& .logo-text {\n\t\t\t\tfont-size: $font-size-base;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tletter-spacing: 1px;\n\t\t\t\tmargin-top: $spacer * .25;\n\t\t\t}\n\t\t\t& img {\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\t\t\t}\n\t\t}\n\t\t& .nav-container {\n\t\t\tflex: 1;\n\t\t\n\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\toverflow: hidden;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t\t& .nav.nav-tabs {\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tdisplay: block;\n\t\t\tborder: 0;\n\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t}\n\n\t\t\t& .nav-item {\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tmin-width: rem(90px);\n\t\t\t\t}\n\t\t\t\t& .nav-link {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: $spacer;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .25);\n\t\t\t\t\tborder: none;\n\t\t\t\t\tfont-size: $font-size-base * .75;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\n\t\t\t\t\t& .card {\n\t\t\t\t\t\tmargin: $spacer * -.75 $spacer * -.25;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& .card-body {\n\t\t\t\t\t\t\tpadding: $spacer * .5 $spacer * .7;\n\t\t\t\t\t\t\tmargin: $spacer * .5;\n\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before,\n\t\t\t\t\t\t&:after,\n\t\t\t\t\t\t& .card-arrow {\n\t\t\t\t\t\t\tvisibility: hidden;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .fa {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tmargin: $spacer * .225 auto $spacer * .35 auto !important;\n\t\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t}\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t\n\t\t\t\t\t\t& .card {\n\t\t\t\t\t\t\t&:before,\n\t\t\t\t\t\t\t&:after,\n\t\t\t\t\t\t\t& .card-arrow {\n\t\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-content {\n\t\tflex: 1;\n\t\n\t\t@include media-breakpoint-up(lg) {\n\t\t\toverflow: scroll;\n\t\t}\n\t\t@include media-breakpoint-down(lg) {\n\t\t\theight: calc(100% - 96px);\n\t\t}\n\t\t\n\t\t& .pos-content-container {\n\t\t\tpadding: 0 $spacer * 2;\n\t\t}\n\t}\n\t& .pos-sidebar {\n\t\twidth: $pos-sidebar-desktop-width;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 0 0 $pos-sidebar-desktop-width;\n\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\twidth: auto;\n\t\t\tz-index: $app-header-zindex + 1;\n\t\t\tbackground: var(--#{$prefix}body-bg);\n\t\t\tbackground: var(--#{$prefix}body-bg-gradient);\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& .pos-sidebar-header {\n\t\t\tpadding: $spacer $spacer * 1.5;\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\n\t\t\t& .back-btn {\n\t\t\t\tborder: none;\n\t\t\t\tdisplay: none;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t}\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\n\t\t\t\t& .btn {\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tfont-size: $font-size-base * 1.25;\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .icon {\n\t\t\t\t& img {\n\t\t\t\t\theight: rem(30px);\n\t\t\t\t}\n\t\t\t\t& + .title {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tpadding-right: rem(10px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: rem(10px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .title {\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t\t& .order {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t& .pos-sidebar-nav {\n\t\t\t& .nav.nav-tabs {\n\t\t\t\tpadding: 0 $spacer * 1.5;\n\t\t\t\t\n\t\t\t\t& .nav-item {\n\t\t\t\t\t& .nav-link {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t\t\n\t\t\t\t\t\t&.active {\n\t\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& + .nav-item {\n\t\t\t\t\t\tmargin-left: $spacer * .5;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .pos-sidebar-body {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\toverflow: scroll;\n\t\t\tflex: 1;\n\t\t}\n\t\t& .pos-sidebar-footer {\n\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\tpadding: $spacer $spacer * 1.5;\n\t\t}\n\t\t& .pos-order {\n\t\t\tpadding: $spacer * 1.5;\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& .pos-order-product {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex: 1;\n\t\t\t\t\n\t\t\t\t& .img {\n\t\t\t\t\twidth: rem(72px);\n\t\t\t\t\theight: rem(72px);\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\tbackground-size: cover;\n\t\t\t\t}\n\t\t\t\t& > * + * {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& > * + * {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\n\t\t\t& .pos-order-confirmation {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: rem(1px);\n\t\t\t\tright: rem(1px);\n\t\t\t\tbottom: 0;\n\t\t\t\tz-index: 10;\n\t\t\t\tbackground: rgba(235, 235, 235, .88);\n\t\t\t\tpadding: $spacer;\n\t\t\t\tmargin: 0;\n\t\t\t\n\t\t\t\t& > * {\n\t\t\t\t\tposition: relative;\n\t\t\t\t}\n\t\t\t\t& .btn {\n\t\t\t\t\tmin-width: rem(60px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t& + .pos-order {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-header {\n\t\tpadding: $spacer * 0.66 $spacer * 1.75;\n\t\theight: $pos-counter-header-height;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t\n\t\t& .logo,\n\t\t& .time,\n\t\t& .nav {\n\t\t\twidth: 33.33%;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t}\n\t\t& .logo {\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t& > div,\n\t\t\t& > a {\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\ttext-decoration: none;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\t\n\t\t\t\t& .logo-img {\n\t\t\t\t\t& img {\n\t\t\t\t\t\theight: rem(32px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .logo-text {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tfont-size: rem(16px);\n\t\t\t\t\tletter-spacing: rem(1px);\n\t\t\t\t\t\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .time {\n\t\t\tfont-weight: $font-weight-bold;\n\t\t\tfont-size: rem(20px);\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t& .nav {\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-end;\n\t\t\t\n\t\t\t& .nav-item {\n\t\t\t\t& .nav-link {\n\t\t\t\t\tpadding: $spacer * .333 $spacer;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\tpadding: $spacer * .333 $spacer * 0.66;\n\t\t\t\t\t}\n\t\t\t\t\t& .nav-icon {\n\t\t\t\t\t\theight: rem(20px);\n\t\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-product {\n\t\ttext-decoration: none;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tposition: relative;\n\t\ttransition: all .2s linear;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 100%;\n\n\t\t& .img {\n\t\t\tbackground-size: cover;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tmin-height: rem(180px);\n\t\t\ttransition: all .2s linear;\n\t\t}\n\t\t& .info {\n\t\t\tflex: 1;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse), .1);\n\t\t\tpadding: $spacer;\n\t\n\t\t\t& .title {\n\t\t\t\tfont-size: $font-size-lg;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\tmargin: 0 0 rem(2px);\n\t\t\t}\n\t\t\t& .desc {\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\tmargin: 0 0 $spacer;\n\t\t\t\tline-height: 1.4;\n\t\t\t\tflex: 1;\n\t\t\t}\n\t\t\t& .price {\n\t\t\t\tmargin: 0;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\tfont-size: $font-size-lg;\n\t\t\t}\n\t\t}\n\t\t&.not-available {\n\t\t\tcursor: not-allowed;\n\t\n\t\t\t& .not-available-text {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tmin-height: rem(180px);\n  \t\t\tbackground: rgba(235, 235, 235, .88);\n\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\tfont-size: $h2-font-size;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-table-booking {\n\t\tdisplay: block;\n\t\tmargin-bottom: $spacer * 1.25;\n\t\ttext-decoration: none;\n\t\tcolor: var(--#{$prefix}inverse);\n\t\n\t\t&:hover {\n\t\t\t& .pos-table-booking-container {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse), .2);\n\t\t\t}\n\t\t}\n\t\t\n\t\t& .pos-table-booking-container {\n\t\t\tpadding: 0;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse), .1);\n\t\t\t\n\t\t\t& .pos-table-booking-header {\n\t\t\t\tpadding: $spacer;\n\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\n\t\t\t\t& .no {\n\t\t\t\t\tfont-size: $font-size-lg * 2.5;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .pos-table-booking-body {\n\t\t\t\t& .booking {\n\t\t\t\t\tfont-size: $font-size-sm;\n\t\t\t\t\tpadding: $spacer * .333 $spacer;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t\n\t\t\t\t\t& .time {\n\t\t\t\t\t\twidth: rem(75px);\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\tfont-size: $font-size-base * .85;\n\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}inverse), .5);\n\t\t\t\t\t}\n\t\t\t\t\t& .info {\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t}\n\t\t\t\t\t& .status {\n\t\t\t\t\t\tfont-size: rem(6px);\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\tpadding-right: $spacer;\n\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\tpadding-left: $spacer;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t&.upcoming {\n\t\t\t\t\t\t\tcolor: $warning;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.in-progress {\n\t\t\t\t\t\t\tcolor: $success;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.highlight {\n\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\n\t\t\t\t\t\t& .time {\n\t\t\t\t\t\t\tcolor: rgba(var(--#{$prefix}theme-rgb), .75);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& + .booking {\n\t\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-task {\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\n\t\t@include media-breakpoint-up(md) {\n\t\t\tdisplay: flex;\n\t\t}\t\t\t\t\t\n\t\t& .pos-task-info {\n\t\t\twidth: 30%;\n\t\t\tpadding: $spacer * 1.5;\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\ttext-align: left;\n\t\t\t} @else {\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\twidth: auto;\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t} @else {\n\t\t\t\t\ttext-align: left;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .pos-task-body {\n\t\t\tpadding: $spacer * 1.5;\n\t\t\tflex: 1;\n\t\t\t\n\t\t\t@if $enable-rtl {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\tborder-left: none;\n\t\t\t\tpadding-top: 0;\n\t\t\t}\n\t\t\t\n\t\t\t& .pos-task-completed {\n\t\t\t\tfont-size: rem(16px);\n\t\t\t\tline-height: rem(36px);\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\tmargin-top: rem(-10px);\n\t\t\t\t\tpadding-top: rem(10px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .pos-task-product {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\theight: 100%;\n\t\t\t\t\n\t\t\t\t& .pos-task-product-img {\n\t\t\t\t\tpadding-top: 75%;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tmargin-bottom: $spacer;\n\t\t\t\t\n\t\t\t\t\t& .cover {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\t\tbackground-position: center;\n\t\t\t\t\t\tborder-radius: $border-radius-lg;\n\t\t\t\t\t}\n\t\t\t\t\t& .caption {\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tbackground: rgba($gray-800, .75);\n\t\t\t\t\t\tcolor: var(--#{$prefix}white);\n\t\t\t\t\t\tfont-size: rem(24px);\n\t\t\t\t\t\tborder-radius: $border-radius-lg;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t& .pos-task-product-info {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tmargin-bottom: $spacer;\n\t\t\t\t}\n\t\t\t\t& .pos-task-product-action {\n\t\t\t\t\t& .btn {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& + .btn {\n\t\t\t\t\t\t\tmargin-top: $spacer * .75;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.completed {\n\t\t\t\t\t& .pos-task-product-info {\n\t\t\t\t\t\topacity: .33;\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .pos-checkout-table {\n\t\tpadding: rem(1px);\n\t\tmargin: 0;\n\t\theight: 100%;\n\t\t\n\t\t& .pos-checkout-table-container {\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\theight: 100%;\n\t\t\ttext-decoration: none;\n\t\t\tposition: relative;\n\t\t\ttransition: all .1s linear;\n\t\t\tmargin: $spacer * .25;\n\t\t\t\n\t\t\t&:before {\n\t\t\t\ttransition: all .1s linear;\n\t\t\t}\n\t\t\t& .pos-checkout-table-header {\n\t\t\t\tpadding: $spacer;\n\t\t\t\ttext-align: center;\n\t\t\t\t\n\t\t\t\t& .status {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: $spacer * .5;\n\t\t\t\t\ttop: $spacer * .5;\n\t\t\t\t\tfont-size: rem(8px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .pos-checkout-table-info {\n\t\t\t\t& > .row {\n\t\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\n\t\t\t\t\t& > div {\n\t\t\t\t\t\tpadding: $spacer * .25 $spacer * .5;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& + div {\n\t\t\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t} @else {\n\t\t\t\t\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.in-use:hover:not(.disabled) {\n\t\t\tposition: relative;\n\t\t\tz-index: 10;\n\t\t\t\n\t\t\t& .table-container {\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tbackground: rgba(#2d333a, .75);\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\t\tfont-size: rem(32px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.selected:not(.disabled),\n\t\t&.selected:not(.disabled):hover {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\t& .table-info-row {\n\t\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\t}\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .5);\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: '\\f00c';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: 10;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\tfont-size: rem(32px);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\n\t\t\t\t\t@include fontawesome();\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.disabled {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\tcursor: not-allowed;\n\t\t\t\tbackground: var(--app-component-bg);\n\t\t\t\tcolor: var(--app-component-color);\n\t\t\t\n\t\t\t\t& .status {\n\t\t\t\t\tcolor: $danger;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.available {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\t& .status {\n\t\t\t\t\tcolor: $success;\n\t\t\t\t}\n\t\t\t\t& .pos-checkout-table-info {\n\t\t\t\t\tcolor: transparent;\n\t\t\t\t\t\n\t\t\t\t\t& i {\n\t\t\t\t\t\tcolor: transparent !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.in-use {\n\t\t\t& .pos-checkout-table-container {\n\t\t\t\tbackground: rgba(var(--#{$prefix}inverse), .15);\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t& .status {\n\t\t\t\t\tcolor: $warning;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.pos-vertical {\n\t\t& > .pos-container {\n\t\t\tflex-direction: column;\n\t\t\t\n\t\t\t& .pos-header {\n\t\t\t\t& + .pos-content {\n\t\t\t\t\theight: calc(100% - 52px);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& > div + div {\n\t\t\t\tborder: 0;\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t}\n\t}\n\t&.pos-mobile-sidebar-toggled {\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tz-index: 20;\n\t\t\t\n\t\t\t& .pos-content,\n\t\t\t& .pos-menu {\n\t\t\t\topacity: .25;\n\t\t\t}\n\t\t\t& .pos-sidebar {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t\t&.pos-vertical {\n\t\t\t\t& > .pos-container > .pos-content {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.modal.modal-pos {\n\t& .close {\n\t\tposition: absolute;\n\t\ttop: rem(25px);\n\t\tz-index: 10;\n\t\n\t\t@if $enable-rtl {\n\t\t\tleft: rem(25px);\n\t\t} @else {\n\t\t\tright: rem(25px);\n\t\t}\n\t}\n\t& .modal-pos-product {\n\t\t@include media-breakpoint-up(lg) {\n\t\t\tdisplay: flex;\n\t\n\t\t\t& .modal-pos-product-img,\n\t\t\t& .modal-pos-product-info {\n\t\t\t\twidth: 50%;\n\t\t\t\tmax-width: 50%;\n\t\t\t\tflex: 0 0 50%;\n\t\t\t}\n\t\t}\n\t\t& .modal-pos-product-img {\n\t\t\tpadding: $spacer;\n\t\t\t\n\t\t\t& .img {\n\t\t\t\theight: 100%;\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\tmin-height: rem(250px);\n\t\t\t\n\t\t\t\t@include media-breakpoint-up(lg) {\n\t\t\t\t\tmin-height: rem(300px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& .modal-pos-product-info {\n\t\t\tpadding: $spacer * 1.5;\n\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\n\t\t\t& .option-list {\n\t\t\t\tmargin: $spacer * -.333;\n\t\t\t\tpadding: $spacer * .333 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: wrap;\n\n\t\t\t\t& .option {\n\t\t\t\t\twidth: 33.33%;\n\t\t\t\t\tmax-width: 33.33%;\n\t\t\t\t\tpadding: $spacer * .333;\n\t\t\t\t\tflex: 0 0 33.33%;\n\t\n\t\t\t\t\t& .option-input {\n\t\t\t\t\t\tdisplay: none;\n\t\t\n\t\t\t\t\t\t&:checked {\n\t\t\t\t\t\t\t& + .option-label {\n\t\t\t\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\tborder: 1px solid var(--#{$prefix}theme);\n\t\t\t\t\t\t\t\tbackground: rgba(var(--#{$prefix}theme-rgb), .1);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& .option-label {\n\t\t\t\t\t\tborder: 1px solid rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\t\t\t\t\tpadding: rem(10px);\n\t\t\t\t\t\theight: 100%;\n\t\t\t\t\t\tborder-radius: $border-radius;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\n\t\t\t\t\t\t& .option-text {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tline-height: $headings-line-height;\n\t\t\t\t\t\t\topacity: .75;\n\t\t\t\t\t\t\tfont-size: $font-size-sm;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t& .option-price {\n\t\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t\t\tmargin-top: $spacer * .25;\n\t\t\t\t\t\t\tline-height: $headings-line-height;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.pos-mobile-sidebar-toggler {\n\tposition: fixed;\n\tbottom: $spacer * 3;\n\tright: $spacer;\n\tz-index: 1020;\n\tbackground: var(--#{$prefix}white);\n\tpadding: $spacer * .5;\n\twidth: rem(60px);\n\theight: rem(60px);\n\ttext-decoration: none;\n\tcolor: var(--#{$prefix}black);\n\tdisplay: none;\n\tborder-radius: 50px;\n\tbox-shadow: $box-shadow-lg;\n\talign-items: center;\n\tz-index: 10;\n\t\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: $spacer * -.25;\n\t\tleft: $spacer * -.25;\n\t\tright: $spacer * -.25;\n\t\tbottom: $spacer * -.25;\n\t\tborder: 2px solid var(--#{$prefix}white);\n\t\tborder-radius: 50px;\n\t}\n\t\n\t@include media-breakpoint-down(lg) {\n\t\tdisplay: flex;\n\t}\n\t\n\t&:hover {\n\t\tcolor: $gray-600;\n\t}\n\t& i {\n\t\tfont-size: rem(32px);\n\t\tdisplay: block;\n\t\tmargin: 0 auto;\n\t}\n\t& .badge {\n\t\tposition: absolute;\n\t\tright: $spacer * -.3;\n\t\ttop: $spacer * -.3;\n\t\tbackground-color: var(--#{$prefix}theme);\n\t\tcolor: var(--#{$prefix}theme-color);\n\t\twidth: rem(24px);\n\t\theight: rem(24px);\n\t\tfont-size: $font-size-base;\n\t\tfont-weight: $font-weight-bold;\n\t\tpadding: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 20px;\n\t}\n}\n\t\t\n@if $enable-dark-mode {\n\t@include color-mode(dark, true) {\n\t\t.pos .pos-product.not-available .not-available-text,\n\t\t.pos .pos-sidebar .pos-order .pos-order-confirmation {\n\t\t\tbackground: rgba(59, 70, 82, .88);\n\t\t}\n\t}\n}",".profile {\n\t& .profile-img {\n\t\theight: rem(200px);\n\t\toverflow: hidden;\n\t\tmargin-bottom: $spacer;\n\t\tz-index: 10;\n\t\t\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t& .profile-tab {\n\t\tposition: relative;\n\t\tpadding: 0 $spacer * 1.5;\n\t\tflex: 1;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\toverflow: scroll;\n\t\t\tpadding: 0 $spacer;\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: nowrap;\n\t\t}\n\n\t\t& .nav-item {\n\t\t\t& .nav-link {\n\t\t\t\ttext-align: center;\n\t\t\t\t\n\t\t\t\t& .nav-value {\n\t\t\t\t\tfont-size: $font-size-base * 1.5;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tmargin-bottom: $spacer * -.35;\n\t\t\t\t\t\n\t\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\t\tfont-size: $font-size-base * 1.15;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& + .nav-item {\n\t\t\t\t@if ($enable-rtl) {\n\t\t\t\t\tmargin-right: $spacer * 1.5;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: $spacer * 1.5;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .profile-container {\n\t\tdisplay: flex;\n\t\t\n\t\t@include media-breakpoint-down(lg) {\n\t\t\tdisplay: block;\n\t\t}\n\t\t\n\t\t& .profile-sidebar {\n\t\t\twidth: rem(250px);\n\t\t\tpadding: $spacer * 1.5;\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tborder-left: 1px solid var(--#{$prefix}border-color);\n\t\t\t} @else {\n\t\t\t\tborder-right: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t\n\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t& .profile-content {\n\t\t\tflex: 1;\n\t\t\t\n\t\t\t& .profile-content-container {\n\t\t\t\tpadding: $spacer * 1.5;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(lg) {\n\t\t\t\t\tpadding: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .profile-img-list {\n\t\tlist-style-type: none;\n\t\tmargin: $spacer * -.25;\n\t\tpadding: 0;\n\t\t\n\t\t@include clearfix();\n\t\t\n\t\t& .profile-img-list-item {\n\t\t\twidth: 25%;\n\t\t\tpadding: $spacer * .25;\n\t\t\t\n\t\t\t@if ($enable-rtl) {\n\t\t\t\tfloat: right;\n\t\t\t} @else {\n\t\t\t\tfloat: left;\n\t\t\t}\n\t\t\t\n\t\t\t&.main {\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t\t& .profile-img-list-link {\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding-top: 75%;\n\t\t\t\toverflow: hidden;\n\t\t\t\tposition: relative;\n\t\t\t\t\n\t\t\t\t& img,\n\t\t\t\t& .profile-img-content {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tbottom: 0;\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\tbackground-position: center;\n\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\t\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\tbottom: 0;\n\t\t\t\t\t\tborder: 1px solid rgba(var(--#{$prefix}inverse-rgb), .15);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.with-number {\n\t\t\t\t& .profile-img-number {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tright: 0;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tfont-size: $font-size-base * 1.75;\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tline-height: rem(26px);\n\t\t\t\t\tmargin-top: $font-size-base * -1.75 * .5;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".register {\n\tmin-height: 100vh;\n\tpadding: $spacer * 3 $spacer;\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t@include media-breakpoint-down(md) {\n\t\tpadding: $spacer;\n\t}\n\t\n\t& .register-content {\n\t\tflex: 1;\n\t\tmax-width: rem(360px);\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t}\n}",".search-result {\n\t& .search-input {\n\t\tposition: relative;\n\t\tmax-width: rem(720px);\n\t\tmargin-bottom: rem(15px);\n\t}\n\t& .search-close {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tmargin-top: rem(-12px);\n\t\twidth: rem(26px);\n\t\theight: rem(26px);\n\t\ttext-align: center;\n\t\tfont-size: rem(20px);\n\t\tpadding: 0 0 rem(2px);\n\t\tcolor: var(--#{$prefix}inverse);\n\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .25);\n\t\ttext-decoration: none;\n\t\tborder-radius: 30px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t\n\t\t@if $enable-rtl {\n\t\t\tleft: rem(12px);\n\t\t} @else {\n\t\t\tright: rem(12px);\n\t\t}\n\t\t\n\t\t&:hover,\n\t\t&:focus{ \n\t\t\ttext-decoration: none;\n\t\t\tbackground: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t}\t\n\t}\n\t& .search-tab {\n\t\tlist-style-type: none;\n\t\tmargin: 0 ($app-content-padding-x * -1);\n\t\tpadding: 0 $app-content-padding-x;\n\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\twhite-space: nowrap;\n\t\tdisplay: flex;\n\t\t\n\t\t@include media-breakpoint-down(md) {\n\t\t\tmargin: 0 rem(-15px);\n\t\t\tpadding: 0 rem(15px);\n\t\t\toverflow: scroll;\n\t\t}\n\t\t\n\t\t& .search-tab-item {\n\t\t\t& .search-tab-link {\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding: rem(10px);\n\t\t\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\t\t\ttext-decoration: none;\n\t\t\t\tborder-bottom: 3px solid transparent;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tmargin-bottom: -1px;\n\t\t\t\t\n\t\t\t\t&:hover,\n\t\t\t\t&:focus {\n\t\t\t\t\tborder-bottom-color: $gray-300;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\tcolor: var(--#{$prefix}theme);\n\t\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t}\n\t\t\t}\n\t\t\t& + .search-tab-item {\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tmargin-right: $spacer;\n\t\t\t\t} @else {\n\t\t\t\t\tmargin-left: $spacer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .search-result-list {\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\t\n\t\t& .search-result-item {\n\t\t\tpadding: $spacer * 2 0;\n\t\t\tdisplay: flex;\n\t\t\t\n\t\t\t@include clearfix();\n\t\t\t\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t& + .search-result-item {\n\t\t\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t\t\t}\n\t\t\t& .search-result-media {\n\t\t\t\twidth: rem(160px);\n\t\t\t\theight: rem(160px);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t\n\t\t\t\t@include media-breakpoint-down(md) {\n\t\t\t\t\twidth: rem(80px);\n\t\t\t\t\theight: rem(60px);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t& img {\n\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\tmax-height: 100%;\n\t\t\t\t}\n\t\t\t\t& + .search-result-content {\n\t\t\t\t\t@if $enable-rtl {\n\t\t\t\t\t\tpadding-right: rem(30px);\n\t\t\t\t\t} @else {\n\t\t\t\t\t\tpadding-left: rem(30px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t& .search-result-content {\n\t\t\t\tflex: 1;\n\t\t\t\t\n\t\t\t\t& h3 {\n\t\t\t\t\tmargin: 0 0 rem(5px);\n\t\t\t\t\tfont-size: rem(20px);\n\t\t\t\t\t\n\t\t\t\t\t& a {\n\t\t\t\t\t\tcolor: var(--#{$prefix}inverse);\n\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".widget-chat {\n\tmargin: 0;\n\tpadding: 0;\n\t\n\t& .widget-chat-item {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\t\n\t\t& + .widget-chat-item {\n\t\t\tmargin-top: $spacer;\n\t\t}\n\t\t& > div + div {\n\t\t\tpadding-left: $spacer * .75;\n\t\t}\n\t}\n\t& .widget-chat-date {\n\t\tfont-size: $font-size-base - rem(2px);\n\t\tfont-weight: $font-weight-bold;\n\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .5);\n\t\tpadding: $spacer * .75;\n\t\ttext-align: center;\n\t}\n\t& .widget-chat-content {\n\t\tflex: 1;\n\t}\n\t& .widget-chat-name,\n\t& .widget-chat-status {\n\t\tfont-size: $font-size-base - rem(3px);\n\t\tfont-weight: $font-weight-bold;\n\t\tcolor: rgba(var(--#{$prefix}inverse-rgb), .75);\n\t\tmargin: $spacer * .25 0;\n\t\tline-height: 1.5;\n\t}\n\t& .widget-chat-media {\n\t\twidth: rem(28px);\n\t\t\n\t\t& img {\n\t\t\tmax-width: 100%;\n\t\t\tdisplay: block;\n\t\t\t@include border-radius(28px);\n\t\t}\n\t}\n\t& .widget-chat-message {\n\t\tbackground: $white;\n\t\tcolor: $black;\n\t\tpadding: $spacer * .5 $spacer;\n\t\tdisplay: inline-block;\n\t\tposition: relative;\n\t\tborder-radius: $border-radius-lg;\n\t\t\n\t\t& + .widget-chat-message {\n\t\t\tmargin-top: $spacer * .3;\n\t\t}\n\t\t&.last {\n\t\t\t&:before {\n\t\t\t\tcontent: '';\n\t\t\t\tborder: rem(5px) solid transparent;\n\t\t\t\tborder-bottom-color: $white;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: rem(6px);\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tright: rem(-4px);\n\t\t\t\t\tborder-left-color: $white;\n\t\t\t\t} @else {\n\t\t\t\t\tleft: rem(-4px);\n\t\t\t\t\tborder-right-color: $white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t& .reply {\n\t\t& .widget-chat-content {\n\t\t\ttext-align: right;\n\t\t}\n\t\t& .widget-chat-message {\n\t\t\tbackground: var(--#{$prefix}theme);\n\t\t\tcolor: var(--#{$prefix}theme-color);\n\t\t\t\n\t\t\t&.last:before {\n\t\t\t\tborder-color: transparent;\n\t\t\t\tborder-bottom-color: var(--#{$prefix}theme);\n\t\t\t\t\n\t\t\t\t@if $enable-rtl {\n\t\t\t\t\tborder-right-color: var(--#{$prefix}theme);\n\t\t\t\t\tright: auto;\n\t\t\t\t\tleft: rem(-4px);\n\t\t\t\t} @else {\n\t\t\t\t\tborder-left-color: var(--#{$prefix}theme);\n\t\t\t\t\tleft: auto;\n\t\t\t\t\tright: rem(-4px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".widget-img-list {\n\tmargin: rem(-1px);\n\tpadding: 0;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\t\n\t& .widget-img-list-item {\n\t\tpadding: rem(1px);\n\t\twidth: 20%;\n\t\t\n\t\t& a {\n\t\t\tdisplay: block;\n\t\t\ttext-decoration: none;\n\t\t\tpadding-top: 100%;\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\t\t\t\n\t\t\t& img,\n\t\t\t& .img {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t\t& .img {\n\t\t\t\tbackground-size: cover;\n\t\t\t\tbackground-position: center;\n\t\t\t\tbackground-repeat: no-repeat;\t\n\t\t\t}\n\t\t}\n\t}\n}",".widget-reminder {\n\t& .widget-reminder-item {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t}\n\t& .widget-reminder-header + .widget-reminder-item,\n\t& .widget-reminder-item + .widget-reminder-header,\n\t& .widget-reminder-item + .widget-reminder-item {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t}\n\t& .widget-reminder-time,\n\t& .widget-reminder-content {\n\t\tpadding: $spacer;\n\t}\n\t& .widget-reminder-content {\n\t\tflex: 1;\n\t}\n\t& .widget-reminder-time {\n\t\twidth: rem(80px);\n\t\tfont-size: $font-size-base - rem(1px);\n\t\t\n\t\t@if $enable-rtl {\n\t\t\ttext-align: left;\n\t\t} @else {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\t& .widget-reminder-divider {\n\t\twidth: rem(3px);\n\t\tbackground: var(--#{$prefix}border-color);\n\t}\n\t& + .card-header,\n\t& + .card-footer,\n\t& + .card-body {\n\t\tborder-top: 1px solid var(--#{$prefix}border-color);\n\t}\n}",".widget-user-list {\n\tdisplay: flex;\n\talign-items: center;\n\t\n\t& .widget-user-list-item {\n\t\t& .widget-user-list-link {\n\t\t\tborder: 2px solid var(--#{$prefix}body-bg);\n\t\t\toverflow: hidden;\n\t\t\twidth: rem(40px);\n\t\t\theight: rem(40px);\n\t\t\ttext-align: center;\n\t\t\ttext-decoration: none;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: 40px;\n\t\t\t\n\t\t\t& img {\n\t\t\t\tdisplay: block;\n\t\t\t\tmax-width: 100%;\n\t\t\t\tmax-height: 100%;\n\t\t\t}\n\t\t}\n\t\t\n\t\t& + .widget-user-list-item {\n\t\t\t@if $enable-rtl {\n\t\t\t\tmargin-right: rem(-20px);\n\t\t\t} @else {\n\t\t\t\tmargin-left: rem(-20px);\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
